/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 107);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(152);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export validateFields */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getImgUrl; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return limitText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return compareDates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return shuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return geinstagramData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return asyncgetWeather; });
/* unused harmony export getWeather */
/* unused harmony export foundInString */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getBrowser; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isMobile; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_browser__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_detect_browser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_detect_browser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Validator_Validator__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_UI_UI_js_p1__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_UI_UI_js_p1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI_js_p1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__ = __webpack_require__(220);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _this=this;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var validateFields=function validateFields(fields){var errors=[];var v=new __WEBPACK_IMPORTED_MODULE_3__Validator_Validator__["a" /* default */]();for(var i in fields){var currentField=fields[i];var validationType=currentField.validationType;var res=null;if(validationType==="simple"){res=v.simpleValidation({val:currentField.val,err_1:currentField.err_1});}else if(validationType==="email"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/});}else if(validationType==="phone"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]{9,11}$/});}else if(validationType==="number"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]+$/});}else if(validationType==="licence"){res=v.regx_validation({val:currentField.val,err_1:currentField.err_1,err_2:currentField.err_2,expression:/^[0-9]+(-?[0-9]+)+$/});}if(res!==true){errors.push("err");currentField.cssClass=currentField.cssClass+" err-border ";}else{currentField.cssClass=currentField.cssClass+"succses-border";}}// check to  see if error acourd
if(errors.length===0){return true;}else{return false;}};var getUrl=function getUrl(){var host=window.location.host;var protocol=window.location.protocol;// const url = protocol + "//" + host   + '/';
var url=protocol+"//"+host;// .TwoCitiesOneBreak
// const url = protocol + "//" + host+'/';
// const url = 'https://view.activated.co.il/new-citiesbreak-en/fr-new/';
return url;};var getImgUrl=function getImgUrl(){var url='https://fr.goisrael.com/assets/img/';return url;};var limitText=function limitText(string){var length=arguments.length>1&&arguments[1]!==undefined?arguments[1]:40;var trimmedString=string.substring(0,length);var dots="";if(string.length>length){dots="";}return trimmedString+""+dots;};var compareDates=function compareDates(date1,date2){var patt=new RegExp(/[0-9]{1,2}-[0-9]{2}./);var res=patt.test(date2);var enDateFormat=[];if(res===true){var dateToArr=date2.split('.');// console.log(dateToArr);
var days=dateToArr[0];var daysToArr=days.split("-");var lastDay=daysToArr[1];dateToArr.shift();// remove first arr cell
dateToArr.unshift(lastDay);// add first arr cell
enDateFormat[0]=dateToArr[1];enDateFormat[1]=dateToArr[0];enDateFormat[2]=dateToArr[2];var newDate=enDateFormat.join('.');var date2=new Date(newDate);// console.log(' newDate ', newDate);
}else{var dateToArr=date2.split('.');enDateFormat[0]=dateToArr[1];enDateFormat[1]=dateToArr[0];enDateFormat[2]=dateToArr[2];var newDate=enDateFormat.join('.');// console.log(' newDate ', newDate);
var date2=new Date(newDate);}var d1=date1.getTime();var d1FullDate=date1.getDate()+"."+(date1.getMonth()+1)+"."+date1.getFullYear();var d2=date2.getTime();var d2FullDate=date2.getDate()+"."+(date2.getMonth()+1)+"."+date2.getFullYear();var isTodayBigger=d1>d2;if(d1FullDate===d2FullDate){isTodayBigger=false;}return isTodayBigger;};var shuffle=function shuffle(){var o=arguments.length>0&&arguments[0]!==undefined?arguments[0]:[];for(var j,x,i=o.length;i;j=parseInt(Math.random()*i),x=o[--i],o[i]=o[j],o[j]=x){}return o;};// Prod
var geinstagramData=function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(callback){var res;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://fr.goisrael.com/assets/insta-images.php");case 2:res=_context.sent;return _context.abrupt('return',res.data);case 4:case'end':return _context.stop();}}},_callee,_this);}));return function geinstagramData(_x3){return _ref.apply(this,arguments);};}();var asyncgetWeather=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(){var weatherData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.next=2;return __WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://goisrael.com/weather.php",{params:{method:"get_weather"}});case 2:weatherData=_context2.sent;// console.log('WEATHER:', typeof weatherData); // object
console.log('WEATHER:',_typeof(weatherData.data));// 
// return weatherData.data;
return _context2.abrupt('return',weatherData.data);case 5:case'end':return _context2.stop();}}},_callee2,_this);}));return function asyncgetWeather(){return _ref2.apply(this,arguments);};}();// Local 
// export const geinstagramData=  async callback => {
// 	const res 	= await  Http.get("https://view.activated.co.il/twocities/de/assets/insta-images.php");
// 	console.log('res' , res);
// 	return res.data;
// }
// export const asyncgetWeather = async  () => {
// 	const weatherData 	= await Http.get("https://view.activated.co.il/twocities/de/weather.php" , {params : {method: "get_weather"}});
// 	return weatherData.data;
// } 
// to do make  this async await 
var getWeather=function getWeather(callback){__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://fr.goisrael.com/weather.php",{params:{method:"get_weather",city:"deadsea"}}).then(function(res){var deadSeaWeather=res.data.temperature;__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://fr.goisrael.com/weather.php",{params:{method:"get_weather",city:"jerusalem"}}).then(function(res){var jerusalemWeather=res.data.temperature;var water_temp=res.data.water_temp;__WEBPACK_IMPORTED_MODULE_5__Axios_Axios__["a" /* default */].get("https://fr.goisrael.com/weather.php",{params:{method:"get_weather",city:"Tel Aviv"}}).then(function(res){var telAvivWeather=res.data.temperature;var o={jerusalemWeather:jerusalemWeather,water_temp:water_temp,telAvivWeather:telAvivWeather,deadSeaWeather:deadSeaWeather};callback(o);});});});};// export const geinstagramData= callback => {
// 	Http.get("https://en.citiesbreak.com/assets/insta-images.php")
//     .then(res => {
//     	callback(res);
//     	// return res;        
//     });
// }
var foundInString=function foundInString(text,match){return new RegExp(match).test(text);};var getBrowser=function getBrowser(){var browser=Object(__WEBPACK_IMPORTED_MODULE_2_detect_browser__["detect"])();// handle the case where we don't detect the browser
if(!browser){browser.name='centDetectBrowser';browser.version='0';}return browser;};var isMobile=function isMobile(){var isMobile=false;var windowW=window.innerWidth;if(windowW<1000){isMobile=true;}return isMobile;};

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Input */
/* unused harmony export Select */
/* unused harmony export TopPart */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return Img; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return Logo; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return HomeTitle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return WeatherIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return ResponsiveYouTubeIframe; });
/* unused harmony export VideoSliderItem2 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return VideoSliderItem; });
/* unused harmony export ConcertSliderItem */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return PostSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return InstagremSliderItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GallerSideBarItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ImgAndText; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return FaqItem; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CoverSection; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HomeDeals; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return HomeSlider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AnimateCallToAction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActivaImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return TravelAlert; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Deals_Deals__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_youtube__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility_GDPRWrapper__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UI_css__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UI_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__UI_css__);
var Input=function Input(props){var name=props.name;var labelProp=props.label;var cssWrapperClass='form-input-wrapper input-'+name+'-wrapper '+props.inputCssClass;var cssInputClass=' input-'+name+' ';var labelField='';var id="ac-input-"+new Date().getTime();if(labelProp!==undefined){cssWrapperClass+=' inputHasLabel ';labelField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},' ',props.label,' ');}var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssWrapperClass},labelField,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{id:id,'data-validation-type':props.validationType,onClick:props.click,onChange:props.change,type:props.type,name:name,className:cssInputClass,placeholder:props.placeholder,value:props.val}));if(props.type==="hidden"){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{type:props.type,name:name,className:cssInputClass,placeholder:props.placeholder,value:props.val});}return html;};var Select=function Select(props){var name=props.name;var cssWrapperClass='form-input-wrapper input-'+name+'-wrapper select-'+name+'-wrapper'+props.cssClass;var cssInputClass='select-'+name+' ';var labelProp=props.label;var labelField='';var id="ac-input-"+new Date().getTime();if(labelProp!==undefined){cssWrapperClass+=' inputHasLabel ';labelField=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('label',{htmlFor:id},' ',props.label,' ');}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssWrapperClass},labelField,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:props.change,name:props.name,className:cssInputClass},props.children,';'));};var TopPart=function TopPart(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('header',{className:'App-header alignCenter'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'App-title'},props.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.text)));};var Img=function Img(props){var windowW=window.innerWidth;var desktopImg=props.desktopImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.desktopImg:"";var mobileImg=props.mobileImg?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["e" /* getImgUrl */])()+""+props.mobileImg:"";var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:desktopImg,alt:''}));if(props.mobileImg!=undefined){if(windowW<1000){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'show-on-mobile',src:mobileImg,alt:''}));}}return html;};var Btn=function Btn(props){var cssClass=props.cssClass?'ac-btn '+props.cssClass:props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:cssClass,onClick:props.onClick},props.children);};var Logo=function Logo(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logoWrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"logo.png"}));};var HomeTitle=function HomeTitle(props){var cssClass='home-title-wrapper '+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,props.children),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-border'}));};var WeatherIcon=function WeatherIcon(props){var p=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.temp,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('sup',null,'o'),'C');var imgPath="WeatherIcon.png";var weatherClass='weather-icon-wrapper';if(props.temp==="4h 15m"){p=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,props.temp);imgPath="WeatherIcon2.png";weatherClass='weather-icon-wrapper flight-icon-wrapper';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:weatherClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:imgPath}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.label),p);};var ResponsiveYouTubeIframe=function ResponsiveYouTubeIframe(props){// const videoSrc = 'https://www.youtube.com/embed/'+props.vidId+'/?autoplay=1&mute=1&rel=0&loop=1&playlist=' + props.vidId;
var youTubeOptions={playerVars:{// https://developers.google.com/youtube/player_parameters
autoplay:1,muted:1,controls:1,loopPlaylists:true,loop:1,playlist:props.vidId,// sandbox: "allow-same-origin allow-popups",
origin:window.location.origin// host: "https://www.youtube.com",
}};// console.log('window.location.origin:', window.location.origin);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Utility_GDPRWrapper__["a" /* GDPRWrapper */],{group:'group_2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'responisve-iframe'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_youtube__["a" /* default */],{videoId:props.vidId,opts:youTubeOptions,onReady:function onReady(event){event.target.mute();event.target.playVideo();}})));};var VideoSliderItem2=function VideoSliderItem2(props){var youTubeOptions={playerVars:{// https://developers.google.com/youtube/player_parameters
autoplay:1,muted:1,// host: "https://www.youtube.com",
// sandbox: "allow-same-origin allow-popups",
origin:window.location.origin}};var desc=props.desc!=undefined?props.desc:"";var doBlank=props.doBlank!=undefined?props.doBlank:"";var title=props.title!=undefined?Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(props.title,30):"";var mobileId=props.mobileId!=''?props.mobileId:"";var cssClass='cites-slider video-slider-item '+props.cssClass;// console.log('props.mobileId' , props.mobileId);
// alert(mobileId);
var target='';if(doBlank){target='_blank';}var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'LIRE LA SUITE ','>>'))));if(Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["g" /* isMobile */])()){// console.log('mobileId' , mobileId);
var ht=null;if(mobileId!=""){ht=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-make-vid-responsive'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Utility_GDPRWrapper__["a" /* GDPRWrapper */],{group:'group_2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_youtube__["a" /* default */],{videoId:mobileId,opts:youTubeOptions,onReady:function onReady(event){event.target.mute();event.target.playVideo();}})));}else{ht=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"})));}// alert('s');
html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.clickMobile},ht),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'LIRE LA SUITE ','>>'))));}return html;};var VideoSliderItem=function VideoSliderItem(props){var desc=props.desc!=undefined?props.desc:"";var cssClass='cites-slider video-slider-item '+props.cssClass;var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},' ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(props.title,50)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:target},'LIRE LA SUITE ','>>'))));};var ConcertSliderItem=function ConcertSliderItem(props){var desc=props.desc;var cssClass='cites-slider concert-slider-item '+props.cssClass;if(props.isTodayBigger===true){cssClass+=' ac-disabled addOpacity ';}var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'concert-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(props.desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link},'LIRE LA SUITE ','>> ')));};var PostSliderItem=function PostSliderItem(props){var desc=props.desc!=undefined?props.desc:"";var cssClass='cites-slider concert-slider-item'+props.cssClass;var doBlank=props.doBlank!=undefined?props.doBlank:"";var target='';if(doBlank){target='_blank';}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:target,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'concert-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["h" /* limitText */])(desc))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrappr'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link},'LIRE LA SUITE ','>>')));};var InstagremSliderItem=function InstagremSliderItem(props){var desc=props.desc;var cssEClass=props.cssClass!==undefined?props.cssClass:'';var cssClass='cites-slider concert-slider-item '+cssEClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insta-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'insta-icon-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"insta-icon.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'@',props.title)));};var GallerSideBarItem=function GallerSideBarItem(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'cites-slider gallery-slider-item align-center'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gallery-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'title-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.title)));};var ImgAndText=function ImgAndText(props){var cssClass='box col col-50 '+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{target:'blank',to:props.link,className:'read-more-link'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.img,mobileImg:props.img_mob}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'link-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:props.link,target:'_blank'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.text)))));};var FaqItem=function FaqItem(props){var cssClass="faq-answer close";var cssClass2="icon-wrapper closeIcon";if(props.isOpen===true){cssClass="faq-answer open";cssClass2="icon-wrapper openIcon";}var ht=props.answer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-q-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'faq-q',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.q),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"collpase-icon.jpg"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:cssClass,dangerouslySetInnerHTML:{__html:ht}}));};var CoverSection=function CoverSection(props){var desktopImg=props.desktopImg;var mobileImg=props.mobileImg;var cssClass=props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:"ac-cover-section ac-cover-section-"+props.cssClass,id:'part-1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.desktopImg,mobileImg:props.mobileImg}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weather-wrapper show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"TEMPÉRATURE DE L'EAU",temp:props.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"TEL AVIV",temp:props.telAvivWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"JÉRUSALEM",temp:props.jerusalemWeather})));};var HomeDeals=function HomeDeals(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section caruasel-wrapper  home-section-padding',id:'deals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(HomeTitle,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/Pages/bestDeals',className:'ac-book-holiday'},'  R\xC9SERVEZ VOTRE',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{className:'show-on-mobile'}),' S\xC9JOUR MAINTENANT ')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Deals_Deals__["a" /* default */],null)));};var HomeSlider=function HomeSlider(props){var bannerSliderSettings={dots:false,infinite:true,fade:true,cssEase:'linear',autoplay:true,lazyLoad:"ondemand",slidesToShow:1,slidesToScroll:1};var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/Pages/bestDeals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"HomeSlider/3.jpg",mobileImg:"HomeSlider/M/3.jpg"}))));var isHomeSlider=props.isHomeSlider!==undefined?props.isHomeSlider:false;if(isHomeSlider===true){if(window.innerWidth<1000){//   html = <Img mobileImg={'/HomeSlider/M/douze.jpg'} />;
// }else {
// html = <div className="ac-responsive-video">
// <iframe className="ac-responsive-item" width="560" height="315" src="https://www.youtube.com/embed/5PAjhoH0NWU?mute=1&autoplay=1&playlist=5PAjhoH0NWU&rel=0&controls=0&loop=1" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
//  </div>
//   html = <Img desktopImg={"/1920-500.jpg"} />;
// }
html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{mobileImg:"HomeSlider/M/3.jpg"})));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"HomeSlider/1.jpg"})));}}else{if(window.innerWidth<1000){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{mobileImg:"HomeSlider/M/3.jpg"})));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:bannerSliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:'/Pages/bestDeals'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"HomeSlider/1a.jpg"}))));}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section caruasel-wrapper banners-caruasel-wrapper',id:'part-1'},html,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'weather-wrapper show-on-mobile'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"TEMP. DE L'EAU",temp:props.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"MÉTÉO DE TEL AVIV",temp:props.telAvivWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(WeatherIcon,{label:"MÉTÉO DE JÉRUSALEM",temp:props.jerusalemWeather})));};var AnimateCallToAction=function AnimateCallToAction(props){var cssClass="hide-on-mobile"+props.cssClass;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:props.link,target:'_blank',className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.src}));};var ActivaImg=function ActivaImg(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-img-wrapper',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:props.src}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'video-play-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Img,{desktopImg:"Videos/play.png",className:'video-play-ggg'})));};var TravelAlert=function TravelAlert(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'home-section home-section-padding',id:'travel-alert'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container ac-flex'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-message col-80'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:'/Pages/CoronaVirusPage'},'Alerte voyage - Recevez les derni\xE8res alertes de',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',{className:'show-on-mobile'}),' voyage concernant Isra\xEBl ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,'ici ')))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-close-wrapper col-20'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-travel-alert-close',onClick:props.click},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'+'))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'})));};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(161)();
}


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu_css__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Menu_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Menu_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var appCountrys=[{langCode:"de",subDomain:"de",countryName:"Deutsch"},// {langCode: "nl", subDomain: "nl", countryName: "Dutch"},
// {langCode: "at", subDomain: "at", countryName: "Österreich"},
// {langCode: "pl", subDomain: "pl", countryName: "Polski"},
// {langCode: "ro", subDomain: "ro", countryName: "Română"},
// {langCode: "se", subDomain: "se", countryName: "Svenska"},
// {langCode: "ch", subDomain: "ch", countryName: "Schwyzerdütsch"},
// {langCode: "cz", subDomain: "cz", countryName: "Cseh"},
// {langCode: "dk", subDomain: "dk", countryName: "Danish"},
// {langCode: "hu", subDomain: "hu", countryName: "Magyar"},
{langCode:"gb",subDomain:"uk",countryName:"English"},{langCode:"ru",subDomain:"ru",countryName:"Русский"},{langCode:"fr",subDomain:"fr",countryName:"Français"},{langCode:"es",subDomain:"es",countryName:"Español"},{langCode:"it",subDomain:"it",countryName:"Italiana"},{langCode:"eu",subDomain:"eu",countryName:"الإمارات العربية المتحدة"},{langCode:"eu-en",subDomain:"eu-en",countryName:"United Arab Emirates"},{langCode:"pt",subDomain:"pt",countryName:"Portuguese"}];var CurrentFlagIcon=function CurrentFlagIcon(props){var lang=props.lang?props.lang:"";var langName=props.langName?props.langName:"";var hideArrow=props.hideArrow===true?true:false;var arrow=null;if(hideArrow===false){arrow=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["i" /* Img */],{desktopImg:'/right-arrow-wb.png',cssClass:'bottom-arrow'});}if(Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["g" /* isMobile */])()){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"flat-icon-div"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'flat-icon-wrapper flat-icon-'+lang},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:props.setLangState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["i" /* Img */],{desktopImg:'/flags/4x3/'+lang+'.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,langName)),arrow)));}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'flat-icon-wrapper flat-icon-'+lang},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:props.setLangState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["i" /* Img */],{desktopImg:'/flags/4x3/'+lang+'.svg'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,langName)),arrow));}};var Menu=function(_Component){_inherits(Menu,_Component);function Menu(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Menu);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Menu.__proto__||Object.getPrototypeOf(Menu)).call.apply(_ref,[this].concat(args))),_this),_this.state={isOpen:false,isLangOpen:false},_this.setMenuState=function(){if(_this.state.isLangOpen){_this.setState({isLangOpen:!_this.state.isLangOpen,isOpen:!_this.state.isOpen});}else{_this.setState({isOpen:!_this.state.isOpen});}},_this.redirect=function(subDomain){if(subDomain==="ru"||subDomain==="at"||subDomain==="ch"||subDomain==="it"||subDomain==="en"||subDomain==="pl"||subDomain==="de"||subDomain==="fr"||subDomain==="es"||subDomain==="eu"||subDomain==="eu-en"){window.location.href='https://new.goisrael.com/'+subDomain;}else if(subDomain==="pt"){window.location.href='https://goisrael.com.br/';}else{window.location.href='https://goisrael.com/?lang='+subDomain;// window.location.href =  'http://localhost:3000/international/?lang=' + subDomain;
}},_this.setLangState=function(){if(Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["g" /* isMobile */])()){_this.setState({isLangOpen:!_this.state.isLangOpen,isOpen:!_this.state.isOpen});}else{_this.setState({isLangOpen:!_this.state.isLangOpen});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Menu,[{key:"render",value:function render(){var _this2=this;var isLangOpen=this.state.isLangOpen;var cssClass="inner";//  let parentCssClass ="";
if(this.state.isOpen===true){cssClass+=" open";}var countryContainer=null;var countryCssClass='country-close';if(isLangOpen){countryCssClass='country-open';countryContainer=appCountrys.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentFlagIcon,{lang:o.langCode,langName:o.countryName,setLangState:function setLangState(){_this2.redirect(o.subDomain);},hideArrow:true});});}var langName='fr';var langCode='fr';var CurrentLang='fr';if(CurrentLang!=null){langName=CurrentLang.toUpperCase();if(CurrentLang==="fr"){langCode='fr';}else{langCode=CurrentLang;}}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,this.state.isLangOpen&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"nav-trigger-overlay",onClick:this.setLangState}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-15 logo-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,className:"first",to:"/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI__["l" /* Logo */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-100 menu-inner-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,className:"first",to:"/"},"ACCUEIL"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/bestDeals"},"OFFRES SP\xC9CIALES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/whereToGo"},"O\xF9 aller"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/thingsToDo"},"\xC0 faire"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/Gallery/"},"galerie photos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/Videos"},"VID\xC9OS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */],{exact:true,to:"/Pages/TouristInfoPage"},"INFORMATIONS TOURISTIQUES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(CurrentFlagIcon,{lang:langCode,langName:langName,setLangState:this.setLangState,hideArrow:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:"open-mobile-menu navbar-toggle",onClick:this.setMenuState},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{className:"icon-bar"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:'container country-container '+countryCssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Choose your language:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"country-container-flags-wrapper"},countryContainer))));}}]);return Menu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Menu);

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer_css__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Footer_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__Footer_css__);
var Footer=function Footer(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"Footer-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-100 footer-menu-outer-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer-menu-inner-wrapper footer-menu-inner-wrapper-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"first"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/whereToGo"},"O\xD9 ALLER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/TelAvivPage"},"TEL AVIV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/JerusalemPage"},"J\xC9RUSALEM")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/DeadSeaPage"},"MER MORTE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/thingsToDo"},"\xC0 FAIRE...")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telaviv/Sensational_Beaches"},"PLAGES SENSATIONNELLES")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telaviv/Go_To_Guide"},"GO TO GUIDE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/telaviv/Day_IsTrippin"},"UNE JOURN\xC9E \xC0 TEL AVIV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{className:"first",to:"/Pages/Videos"},"VID\xC9OS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/telaviv/Outdoor_Adventures"},"AVENTURES EN PLEIN AIR")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/deadsea/Natural_Spa"},"MER MORTE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Posts/Videos/telaviv/Port_Pleasures"},"PLAISIRS PORTUAIRES")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"show-on-mobile"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",null,"|"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-social-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.instagram.com/visit_israel/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* Img */],{desktopImg:"social/i.png",mobileImg:"social/i.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.youtube.com/@goisraelofficial"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* Img */],{desktopImg:"social/y.png",mobileImg:"social/y.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-4"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.flickr.com/photos/israelphotogallery/sets/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* Img */],{desktopImg:"social/fl.png",mobileImg:"social/fl.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.facebook.com/voyage.en.israel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* Img */],{desktopImg:"social/f.png",mobileImg:"social/f.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-6"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.tiktok.com/@visit_israel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* Img */],{desktopImg:"social/tiktok.png",mobileImg:"social/tiktok.png"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-social-col ac-social-col-7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://www.linkedin.com/company/israel-ministry-of-tourism/"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["i" /* Img */],{desktopImg:"social/linkedin.png",mobileImg:"social/linkedin.png"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"cradit"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Photographers: Guy Yehieli, Adam Primer, Kfir Boltin, Linnea Andres, Kfir Sivan, Haim Yafim, Dana Fridlander, refael Ben Ari, Itamar Greenberg, Moshik Lindbaum"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Video Credits: Israeli food channel, Tel Aviv Jaffa municipality, UDINI prodactions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container container-links"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://brochures.goisrael.com/fr/",target:"_blank"},"BROCHURE OFFICIELLE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://goisrael.com/Pages/Contact/",target:"_blank"},"NOUS CONTACTER")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://israel.travel/terms-of-use/",target:"_blank"},"CONDITIONS D'UTILISATION")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://goisrael.com/Posts/telaviv/Privacy_Policy",target:"_blank"},"POLITIQUE DE CONFIDENTIALIT\xC9")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://fr.goisrael.com/Pages/Gallery/",target:"_blank"},"GALERIE PHOTOS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null," | ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://fr.goisrael.com/Posts/TouristInfo/Frequently_Asked_Questions",target:"_blank"},"FOIRE AUX QUESTIONS")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null));};/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export thingsToDoArr */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return newVideos; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return showsArr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return faqData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return newPosts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TouristInfoPosts; });
/* unused harmony export Reminders */
var thingsToDoArr=[];var newVideos=[{title:"Jérusalem",// "sml_desc": "Jérusalem - le coeur du monde",
sml_desc:"",// "desc": "",
desc:"",img:"Videos/heart-of-the-world.jpg",img_mob:"/Videos/video_mob/heart-of-the-world.jpg",side_img:"Videos/sidebar/heart-of-the-world.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Heart_Of_The_World",vidId:"nLKWDp5uA-U",ctg:"jerusalem",isVid:true,forVidPage:true,id:"Heart_Of_The_World"},{title:"LA MER MORTE",// "sml_desc": "Le plaisir de la vie à son plus haut niveau au point le plus bas sur Terre",
sml_desc:"",desc:"",img:"/PostCarousel/DeadSea/deadsea2.jpg",img_mob:"/PostCarousel/video_mob/100.jpg",side_img:"/PostCarousel/DeadSea/deadsea2.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Dead_Sea2",isVid:true,forVidPage:true,vidId:"c93EwT_1EU8",ctg:"deadsea",id:"Dead_Sea2"},{title:"TEL AVIV, EN BORD DE MER",// "sml_desc": "À Tel Aviv, c'est à la plage que bat le cœur de la ville",
sml_desc:"",// "desc": "Préparez-vous à vous éclater comme jamais au soleil",
desc:"",img:"Videos/a.jpg",img_mob:"/Videos/video_mob/a.jpg",side_img:"Videos/sidebar/a.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?postType=video&post=3",css_class:"unic_video-post-4",vidId:"jsTzRtTCvWg",ctg:"telaviv",isVid:true,forVidPage:true,id:"TelAviv_By_The_Sea"},{title:"Névé Tzedek",sml_desc:"",// "sml_desc" : "Chic et unique",
// "desc": "Déborde de cafés pittoresques, boutiques, galeries d'art, élégance et atmosphère rafraîchissante",
desc:"",img:"Videos/j.jpg",img_mob:"/Videos/video_mob/j.jpg",side_img:"Videos/sidebar/j.jpg",read_more:"LIRE LA SuITE",vidId:"SUJncZH91Bo",link:"/Posts/index.php?postType=video&post=7",css_class:"unic_video-post-13",ctg:"telaviv",isVid:true,forVidPage:true,id:"Neve_Tzedek"},{title:"Sarona Tel Aviv",desc:"",// "desc": "Un immense choix de lieux à découvrir dans une superbe colonie des Templiers rénovée",
// "sml_desc": "Une oasis urbaine spectaculaire",
sml_desc:"",img:"Videos/d.jpg",img_mob:"/Videos/video_mob/d.jpg",side_img:"Videos/sidebar/d.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?postType=video&post=Sarona_TelAviv",vidId:"hdquOPEilDo",ctg:"telaviv",isVid:true,forVidPage:true,id:"Sarona_TelAviv"},{title:"PLAISIRS PORTUAIRES",// "sml_desc": "Les ports de Tel Aviv et de Jaffa – différents et fabuleux",
sml_desc:"",// "desc": "Tel Aviv’s fascinating cultural scene",
desc:"",img:"/PostCarousel/3.jpg",img_mob:"/PostCarousel/video_mob/3.jpg",side_img:"/PostCarousel/3.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Port_Pleasures",isVid:true,forVidPage:true,vidId:"a6QMndU0wx0",ctg:"telaviv",id:"Port_Pleasures"},{title:"La mer Morte ",// "sml_desc": "La mer Morte naturel de toute beauté",
sml_desc:"",// "desc": "Le plaisir de la vie à son plus haut  niveau au point le plus bas sur Terre  ",
desc:"",img:"/PostCarousel/DeadSea/natures-glory.jpg",img_mob:"/PostCarousel/video_mob/natures-glory.jpg",side_img:"/PostCarousel/DeadSea/natures-glory.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Dead_Sea_Video",isVid:true,forVidPage:true,ctg:"deadsea",vidId:"ixFocykfYHo",id:"Dead_Sea_Video"},{title:"La vieille ville",sml_desc:"",// "sml_desc": "Sentez l'histoire prendre vie",
desc:"",// "desc": "Laissez-vous inspirer par les trésors de la vieille ville de Jérusalem, connus dans le monde entier",
img:"Videos/m.jpg",img_mob:"/Videos/video_mob/m.jpg",side_img:"Videos/sidebar/m.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Jerusalem_Old_City",isVid:true,forVidPage:true,vidId:"6eXJu1Yy4kg",ctg:"jerusalem",id:"Jerusalem_Old_City"},{title:"AVENTURES EN PLEIN AIR",// "sml_desc": "Tel Aviv sur roues",
sml_desc:"",// "desc": "Une ville pleine d’action idéale pour les personnes actives",
desc:"",img:"/Videos/12.jpg",img_mob:"/Videos/video_mob/12.jpg",side_img:"/Videos/12.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Outdoor_Adventures",isVid:true,forVidPage:true,ctg:"telaviv",vidId:"88OV6xU0vPI",id:"Outdoor_Adventures"},{title:"Moderne et vibrante",// "sml_desc": "Tant à voir dans le centre-ville animé de Jérusalem",
sml_desc:"",desc:"",img:"/PostCarousel/19.jpg",img_mob:"/PostCarousel/video_mob/19.jpg",side_img:"/PostCarousel/19.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Modern_And_Vibrant_Video",isVid:true,forVidPage:true,vidId:"cUBBkziv_4c",ctg:"jerusalem",id:"Modern_And_Vibrant_Video"},{title:"2 VILLES GRANDIOSES",// "sml_desc": "One magical unforgettable getaway to the sun",
sml_desc:"",desc:"",img:"/PostCarousel/Jerusalem/tw-awesome-cities.jpg",side_img:"/PostCarousel/Jerusalem/tw-awesome-cities.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=42",isVid:true,forVidPage:true,vidId:"b0QexDxEklA",ctg:"telavivAndJerusalem",id:"2_AWESOME_CITIES"},{title:"JERUSALEM",sml_desc:"",desc:"",img:"/PostCarousel/Jerusalem/jerusalem.jpg",side_img:"/PostCarousel/Jerusalem/jerusalem.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Jerusalem",isVid:true,forVidPage:true,vidId:"k4OwoEk5wMw",ctg:"jerusalem",id:"Jerusalem"},{title:"Tel Aviv",sml_desc:"",desc:"",img:"/PostCarousel/TelAviv/post-telaviv.jpg",side_img:"/PostCarousel/TelAviv/post-telaviv.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Tel_Aviv",isVid:true,forVidPage:true,vidId:"I9a4BFWO_6w",ctg:"telaviv",id:"Tel_Aviv"},{title:"LES JOIES DE LA MER MORTE",sml_desc:"",// "sml_desc": "THE DEAD SEA",
desc:"",img:"/PostCarousel/DeadSea/natural-spa.jpg",side_img:"/PostCarousel/DeadSea/natural-spa.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Natural_Spa",isVid:true,forVidPage:true,vidId:"8p4qfkneH1c",ctg:"deadsea",id:"Natural_Spa"},{title:"Ports de Jaffa",// "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
sml_desc:"",// "desc": "Tel Aviv’s fascinating cultural scene",
desc:"",img:"/PostCarousel/TelAviv/jaffa-port.jpg",side_img:"/PostCarousel/TelAviv/jaffa-port.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Port_Pleasures",isVid:true,forVidPage:true,vidId:"a6QMndU0wx0",ctg:"telaviv",id:"Port_Pleasures"},{title:"LES SURPRISES DE JÉRUSALEM",// "sml_desc": "A city beyond expectations",
sml_desc:"",desc:"",img:"/PostCarousel/38.jpg",side_img:"/PostCarousel/38.jpg",read_more:"LIRE LA SuITE",link:this.url+"/Posts/index.php?post=Cool Jerusalem",ctg:"jerusalem",vidId:"nLKWDp5uA-U",isVid:true,forVidPage:true,id:"Cool_Jerusalem"},{title:"LA MER MORTE",sml_desc:"",desc:"",img:"/PostCarousel/DeadSea/magical-deadsea.jpg",side_img:"/PostCarousel/DeadSea/magical-deadsea.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Magical_Deadsea",vidId:"8p4qfkneH1c",isVid:true,forVidPage:true,ctg:"deadsea",id:"Magical_Deadsea"},{title:"LES POINTS FORTS DE TEL AVIV",// "sml_desc": "Top 5 things to see and\n do in the city",
sml_desc:"",desc:"",img:"/PostCarousel/17.jpg",side_img:"/PostCarousel/17.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=17",ctg:"telaviv",vidId:"LLOUxE-K_9Y",isVid:true,forVidPage:true,id:"Top_5_Things"},{title:"AVENUE MAMILLA",sml_desc:"",desc:"",img:"/PostCarousel/Jerusalem/mamila-avenue.jpg",side_img:"/PostCarousel/Jerusalem/mamila-avenue.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Mamilla_Avenue",vidId:"V0Acsw3Hf_M",isVid:true,forVidPage:true,ctg:"jerusalem",id:"Mamilla_Avenue"},// No translation
/* Removed from request docsa Google Sheete */// {
//   title: "JOIES DU SHOPPING",
//   // "sml_desc": "From culture to souvenirs",
//   sml_desc: "",
//   desc: "",
//   img: "/PostCarousel/5.jpg",
//   side_img: "/PostCarousel/5.jpg",
//   read_more: "LIRE LA SuITE",
//   link: "/Posts/index.php?post=Shopping_Delights",
//   ctg: "jerusalem",
//   isVid: true,
//   forVidPage: true,
//   vidId: "MXtcTm_JXus",
//   id: "Shopping_Delights",
// },
/* ENd Removed from request docsa Google Sheete */{title:"PARADIS POUR LES GOURMETS",// "sml_desc" : "Tel Aviv street food",
sml_desc:"",// "desc" : "A true world-class foodie destination",
desc:"",img:"/PostCarousel/TelAviv/streetfood-telaviv.jpg",side_img:"/PostCarousel/TelAviv/streetfood-telaviv.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Tel_Aviv_Street_Food",isVid:true,forVidPage:true,vidId:"JQD9JpMaw9g",ctg:"telaviv",id:"Tel_Aviv_Street_Food"},{title:"Tel Aviv à vélo",// "desc": "Get on your bicycle -<br> explore the city in style",
sml_desc:"",desc:"",img:"PostCarousel/39.jpg",side_img:"PostCarousel/39.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=38",ctg:"telaviv",isVid:true,forVidPage:true,vidId:"1Yx2Uht4rms",id:39},{title:"Jerusalem ‘Musts’",// "sml_desc": "5 things to do in the stunning city",
sml_desc:"",desc:"",img:"/PostCarousel/18.jpg",side_img:"/PostCarousel/18.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Jerusalem_Musts",isVid:true,forVidPage:true,vidId:"k4OwoEk5wMw",ctg:"jerusalem",id:"Jerusalem_Musts"},{title:"Moderne et dynamique",// "sml_desc": "Il y a tant à voir dans le centre-ville animé de Jérusalem",
sml_desc:"",desc:"",img:"/PostCarousel/19.jpg",side_img:"/PostCarousel/19.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Modern_And_Vibrant_Post",isVid:true,forVidPage:true,vidId:"1Yx2Uht4rms",ctg:"jerusalem",id:"Modern_And_Vibrant_Post"},{title:"EFFERVESCENCE NON-STOP",// "sml_desc": "unforgettable Tel Aviv ",
sml_desc:"",desc:"",img:"/PostCarousel/TelAviv/nonstop-excitement2.jpg",side_img:"/PostCarousel/TelAviv/nonstop-excitement2.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Nonstop_Excitement",ctg:"telaviv",isVid:true,forVidPage:true,vidId:"88OV6xU0vPI",id:"Nonstop_Excitement"},// Eilat Posts
{title:"EILAT",sml_desc:"",desc:"",img:"/PostCarousel/eilat1.jpg",side_img:"/PostCarousel/eilat1.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=EILAT1",css_class:"unic-post-EILAT1",isVid:true,forVidPage:true,vidId:"ZdnNT-GDJv4",ctg:"eilat-negev",id:"EILAT1"},{title:" UN ÉTÉ SANS FIN",sml_desc:"",desc:"",img:"/PostCarousel/welcome-to-eilat.jpg",side_img:"/PostCarousel/welcome-to-eilat.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Welcome_To_Eilat",css_class:"unic-post-welcome-to-eilat",isVid:true,forVidPage:true,vidId:"ZdnNT-GDJv4",ctg:"eilat-negev",id:"Welcome_To_Eilat"},{title:"LE RÉCIF DES DAUPHINS À EILAT",sml_desc:"",desc:"",img:"/PostCarousel/eilat-doolphin-reef.jpg",side_img:"/PostCarousel/eilat-doolphin-reef.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Eilat_Doolphin_Reef",css_class:"unic-post-eilat-doolphin-reef",isVid:true,forVidPage:true,vidId:"3Cvz8GoxNzA",ctg:"eilat-negev",id:"Eilat_Doolphin_Reef"},{title:"FAITES LE GRAND PLONGEON",sml_desc:"",desc:"",img:"/PostCarousel/eilat-ultimate-beachside.jpg",side_img:"/PostCarousel/eilat-ultimate-beachside.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Eilat_Ultimate_Beachside",css_class:"unic-post-eilat-ultimate-beachside",isVid:true,forVidPage:true,vidId:"ZdnNT-GDJv4",ctg:"eilat-negev",id:"Eilat_Ultimate_Beachside"},{title:"LE MAJESTUEUX DÉSERT D'ISRAËL",sml_desc:"",desc:"",img:"/PostCarousel/majestic-desert.jpg",side_img:"/PostCarousel/majestic-desert.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Majestic_Desert",css_class:"unic-post-majestic-desert",isVid:true,forVidPage:true,vidId:"yXzhH92kREg",ctg:"eilat-negev",id:"Majestic_Desert"},{title:" LE DÉSERT ISRAÉLIEN",sml_desc:"",desc:"",img:"/PostCarousel/negev.jpg",side_img:"/PostCarousel/negev.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Negev1",css_class:"unic-post-negev",isVid:true,forVidPage:true,vidId:"yXzhH92kREg",ctg:"eilat-negev",id:"Negev1"},{title:"LE NÉGUEV - COMMENT S’Y RENDRE?",sml_desc:"",desc:"",img:"/PostCarousel/location-and-approach.jpg",side_img:"/PostCarousel/location-and-approach.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Location_And_Approach",css_class:"unic-post-location-and-approach",isVid:true,forVidPage:true,vidId:"5AAqIhkq_tQ",ctg:"eilat-negev",id:"Location_And_Approach"},{title:"ACTION FUN IN THE ISRAELI DESERT",sml_desc:"",desc:"",img:"/PostCarousel/action-fun-in-the-desert.jpg",side_img:"/PostCarousel/action-fun-in-the-desert.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Action_Fun_In_The_Desert",css_class:"unic-post-action-fun-in-the-desert",isVid:true,forVidPage:true,vidId:"yXzhH92kREg",ctg:"eilat-negev",id:"Action_Fun_In_The_Desert"},{title:"LA ROUTE DE L'ENCENS",sml_desc:"",desc:"",img:"/PostCarousel/the-incense-route.jpg",side_img:"/PostCarousel/the-incense-route.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=The_Incense_Route",css_class:"unic-post-the-incense-route",isVid:true,forVidPage:true,vidId:"5AAqIhkq_tQ",ctg:"eilat-negev",id:"The_Incense_Route"},{title:"MASSADA",sml_desc:"",desc:"",img:"/PostCarousel/epic-masada.jpg",side_img:"/PostCarousel/epic-masada.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Epic_Masada",css_class:"unic-post-epic-masada",isVid:true,forVidPage:true,vidId:"XxWa_MNm5x8",ctg:"eilat-negev",id:"Epic_Masada"},{title:"LE PARC DE TIMNA",sml_desc:"",desc:"",img:"/PostCarousel/timna-treasures.jpg",side_img:"/PostCarousel/timna-treasures.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Timna_Treasures",css_class:"unic-post-timna-treasures",isVid:true,forVidPage:true,vidId:"i_4QKtXIeto",ctg:"eilat-negev",id:"Timna_Treasures"},{title:"DÉCOUVREZ LES JOYAUX CACHÉS DE GALILÉE",sml_desc:"",desc:"",img:"/PostCarousel/galilee1.jpg",side_img:"/PostCarousel/galilee1.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Galilee_1",css_class:"unic-post-galilee1",isVid:true,forVidPage:true,vidId:"5Ep3GgxELag",ctg:"north",id:"Galilee_1"},{title:"CÉSARÉE",sml_desc:"",desc:"",img:"/PostCarousel/caesarea.jpg",side_img:"/PostCarousel/caesarea.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Caesarea_1",css_class:"unic-post-caesarea1",isVid:true,forVidPage:true,vidId:"eLZ433_S6HI",ctg:"north",id:"Caesarea_1"},{title:"LA VIEILLE VILLE D'ACRE",sml_desc:"",desc:"",img:"/PostCarousel/acre.jpg",side_img:"/PostCarousel/acre.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Acre",css_class:"unic-post-acre",isVid:true,forVidPage:true,vidId:"KlXXyToCmCM",ctg:"north",id:"Acre"},{title:"HAÏFA",sml_desc:"",desc:"",img:"/PostCarousel/haifa.jpg",side_img:"/PostCarousel/haifa.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Haifa",css_class:"unic-post-haifa",isVid:true,forVidPage:true,vidId:"3ahATaKkhBk",ctg:"north",id:"Haifa_1"},{title:"SAFED – OÙ LE MYSTIQUE CÔTOIE LE TERRESTRE",sml_desc:"",desc:"",img:"/PostCarousel/safed.jpg",side_img:"/PostCarousel/safed.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Safed",css_class:"unic-post-safed",isVid:true,forVidPage:true,vidId:"i3_ihL51bHo",ctg:"north",id:"Safed"},{title:"Rosh Pina",sml_desc:"",desc:"",img:"/PostCarousel/rosh-pina.jpg",side_img:"/PostCarousel/rosh-pina.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Rosh_Pina",css_class:"unic-post-rosh-pina",isVid:true,forVidPage:true,vidId:"_qKbHL5-qrQ",ctg:"north",id:"Rosh_Pina"},{title:"Nazareth",sml_desc:"",desc:"",img:"/PostCarousel/nazareth.jpg",side_img:"/PostCarousel/nazareth.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Nazareth",css_class:"unic-post-nazareth",isVid:true,forVidPage:true,vidId:"1M7N5BcmjFM",ctg:"north",id:"Nazareth"},{title:"CÉSARÉE VOYAGEZ À TRAVERS LE TEMPS",sml_desc:"",desc:"",img:"/PostCarousel/caesarea.jpg",side_img:"/PostCarousel/caesarea.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Caesarea_2",css_class:"unic-post-caesarea2",isVid:true,forVidPage:true,vidId:"eLZ433_S6HI",ctg:"north",id:"Caesarea_2"},{title:"BOUGEZ EN GALILÉE",sml_desc:"",desc:"",img:"/PostCarousel/galilee-action.jpg",side_img:"/PostCarousel/galilee-action.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Galilee_Action",css_class:"unic-post-galilee-action",isVid:true,forVidPage:true,vidId:"5Ep3GgxELag",ctg:"north",id:"Galilee_Action"},{title:"UN JOYAU AUX MULTIPLES FACETTES",sml_desc:"",desc:"",img:"/PostCarousel/nazareth1.jpg",side_img:"/PostCarousel/nazareth1.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Nazareth",css_class:"unic-post-nazareth1",isVid:true,forVidPage:true,vidId:"1M7N5BcmjFM",ctg:"north",id:"Nazareth_1"},{title:"LAC DE LA HOULA",sml_desc:"",desc:"",img:"/PostCarousel/birdtastic-hula-lake.jpg",side_img:"/PostCarousel/birdtastic-hula-lake.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Birdtastic_Hula_Lake",css_class:"unic-post-birdtastic-hula-lake",isVid:true,forVidPage:true,vidId:"ImobrsxsKl8",ctg:"north",id:"Birdtastic_Hula_Lake"},{title:"Moderne et vibrante",// "sml_desc": "Tant à voir dans le centre-ville animé de Jérusalem",
sml_desc:"",desc:"",img:"/PostCarousel/19.jpg",img_mob:"/PostCarousel/video_mob/19.jpg",side_img:"/PostCarousel/19.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Modern_And_Vibrant_Video",isVid:true,forVidPage:true,isDouble:true,vidId:"cUBBkziv_4c",ctg:"jerusalem",id:"Modern_And_Vibrant_Video"}];// start showsArr
// export const showsArr = [
//       {
//         title: "Semaine de la fierté 2020",
//         desc: "",
//         date: "12.06.2020",
//         code_date:"12.06.2020",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Week_2020",
//         css_class: "addopacity  unic-singer-Pride_Parade_2020",
//         id: "Pride_Week_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Nick Cave & Bad Seeds",
//         desc: "",
//         date: "17.06.2020",
//         code_date:"17.06.2020",
//         img: "Concerts/nickcave-badseeds.jpg",
//         side_img: "Concerts/nickcave-badseeds.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Nickcave-Badseeds",
//         id: "Nickcave_Badseeds",
//         css_class: "addopacity  unic-singer-nickcave-badseeds",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.2020",
//         code_date:"04.08.2020",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "addopacity  unic-singer-Celine_Dion",
//         id: "Celine_Dion",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "addopacity  unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Houtsot Hayotser Jérusalem",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "addopacity  unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Le Festival de la bière de Jérusalem",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Jerusalem_Beer_Festival_2020",
//         css_class: "addopacity  unic-singer-jbf_2020",
//         id: "Jerusalem_Beer_Festival_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Le Festival du vin de Jérusalem",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=Jerusalem Wine Festival_2020",
//         css_class: "addopacity  unic-singer-jwf-2020",
//         id: "Jerusalem_Wine_Festival_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Les Pixies",
//         desc: "",
//         date: "09.2020",
//         code_date:"30.09.2020",
//         img: "Concerts/1.jpg",
//         side_img: "Concerts/1.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=The_Pixies_2020",
//         css_class: "addopacity  unic-singer-pixies-2020",
//         id: "The_Pixies_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Le Festival Maisons Ouvertes",
//         desc: "",
//         date: "09.2020",
//         code_date:"30.09.2020",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "addopacity  unic-singer-openhf-2020",
//         id: "Open_Houses_Festival_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "La Marche de Jérusalem",
//         desc: "",
//         date: "03.09.2020",
//         code_date:"03.09.2020",
//         img: "Concerts/jerusalem-march.jpg",
//         side_img: "Concerts/jerusalem-march.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Open_Houses_Festival_2020",
//         css_class: "addopacity  unic-singer-jerusalem-march-2020",
//         id: "The_Jerusalem_March_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Celine Dion",
//         desc: "",
//         date: "04.08.2020",
//         code_date:"04.08.2020",
//         img: "Concerts/Celine_Dion.jpg",
//         side_img: "Concerts/Celine_Dion.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Celine_Dion",
//         css_class: "addopacity  unic-singer-Celine_Dion",
//         id: "Celine_Dion",
//         isDouble: true,
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=DGTL_Festival",
//         css_class: "addopacity  unic-singer-dgtl2020",
//         id: "DGTL_Festival_2020",
//         isDouble: true,
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Houtsot Hayotser Jérusalem",
//         desc: "",
//         date: "08.2020",
//         code_date:"30.08.2020",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Hutzot_Hayotzer_Jerusalem_2020",
//         css_class: "addopacity  unic-singer-hutzot_hayotzer",
//         id: "Hutzot_Hayotzer_Jerusalem_2020",
//         isDouble: true,
//         book_now : "LIRE LA SUITE"
//       },
//          //  /*----------------OLD SINGERS------------------*/
//       {
//        title: "Jerry Seinfeld",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "30.12.2017",
//        code_date:"30.12.2017",
//         img: "Concerts/jerry.jpg",
//        side_img  : "Concerts/Sidebar/jerry.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=36" ,
//        css_class: "addopacity  unic-singer-2",
//        id:36,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "Buena Vista",
//        desc : "Live in Tel Aviv for the first time ever!" ,
//        date : "21-26.12.2017",
//       code_date:"26.12.2017",
//         img: "Concerts/buena.jpg",
//        side_img  : "Concerts/Sidebar/buena.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=35" ,
//        id:35,
//        book_now : "Lire La suite"
//       },
//      {
//        title: "Justin Bieber",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.05.2017",
//       code_date:"03.05.2017",
//         img: "Concerts/justin.jpg",
//        side_img  : "Concerts/Sidebar/9.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=9" ,
//        a_star  : true,
//        id:9,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "AEROSMITH",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "28.06.2017",
//        code_date:"28.06.2017",
//         img: "Concerts/aerosmith3.jpg",
//        side_img  : "Concerts/Sidebar/10.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=10" ,
//        a_star  : true,
//        id:10,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "Britney Spears ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.07.2017",
//       code_date:"03.07.2017",
//         img: "Concerts/britney.jpg",
//        side_img  : "Concerts/Sidebar/2.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=2" ,
//        a_star  : true,
//        id: 2,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "Guns N' Roses",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "15.07.2017",
//       code_date:"15.07.2017",
//         img: "Concerts/Guns-N-roses.jpg",
//        side_img  : "Concerts/Sidebar/4.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=4" ,
//        a_star  : true,
//        id:4,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "Bryan Adams ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "04-06.12.2017",
//       code_date:"06.12.2017",
//         img: "Concerts/7.jpg",
//        side_img  : "Concerts/Sidebar/15.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=16" ,
//        a_star  : true,
//        id:16,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "NICK CAVE ",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.11.2017",
//       code_date:"19.11.2017",
//         img: "Concerts/4.jpg",
//        side_img  : "Concerts/Sidebar/8.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=8" ,
//        id:8,
//        book_now : "Lire La suite"
//       },
//       {
//         title: "RADIOHEAD ",
//         desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//         date : "19.07.2017",
//         code_date: "19.07.2017",
//         img  : "Concerts/360x539.jpg",
//         side_img  : "Concerts/Sidebar/5.jpg" ,
//         link :  "/Posts/index.php?postType=concerts&post=5" ,
//         a_star  : true,
//         id:5,
//         book_now : "Lire La suite"
//       },
//       {
//        title: "The Chainsmokers",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "03.08.2017",
//       code_date:"03.08.2017",
//         img: "Concerts/9.jpg",
//        side_img  : "Concerts/Sidebar/14.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=13" ,
//        id:13,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "Blue Man Group",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "07-23.08.2017",
//       code_date:"23.08.2017",
//         img: "Concerts/14.jpg",
//        side_img  : "Concerts/Sidebar/22.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=19" ,
//        id:19,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "Regina Spektor",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "19.08.2017",
//       code_date:"19.08.2017",
//         img: "Concerts/2.jpg",
//        side_img  : "Concerts/Sidebar/7.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=7" ,
//        id:7,
//        book_now : "Lire La suite"
//       },
//       {
//        title: "Sean Paul",
//        desc : "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH" ,
//        date : "22.08.2017",
//       code_date:"22.08.2017",
//         img: "Concerts/13.jpg",
//        side_img  : "Concerts/Sidebar/21.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=20" ,
//       id:20,
//        a_star  : true,
//        book_now : "Lire La suite"
//       },
//        {
//        title: "Led Zeppelin 2",
//        desc : "Don’t Miss the Zeps in Tel Aviv!" ,
//        date : "07-10.01.2018",
//       code_date:"10.01.2018",
//         img: "Concerts/20.jpg",
//        side_img  : "Concerts/Sidebar/29.jpg" ,
//        link :  "/Posts/index.php?postType=concerts&post=29" ,
//        css_class: "addopacity  unic-singer-3",
//        id:29,
//        book_now : "Lire La suite"
//       },
//       {
//         title: "Chris Rock",
//         desc: "PULL OUT THE SUNSCREEN! FREE TO BE YOURSELF ON THE BEACH",
//         date: "08-09.01.2018",
//         code_date:"09.01.2018",
//         img: "Concerts/6.jpg",
//         side_img: "Concerts/Sidebar/16.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=17",
//         css_class: "addopacity  unic-singer-4",
//         id:17,
//         book_now: "Lire La suite"
//       },
//       {
//         title: "Natalia Oreiro",
//         desc: "Natalia to Wow Tel Aviv in March",
//         date: "20.03.18",
//         code_date:"20.03.2018",
//         img: "Concerts/32.jpg",
//         side_img: "Concerts/Sidebar/46.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=44",
//         css_class: "addopacity  unic-singer-13",
//         id:44,
//         book_now: "Lire La suite"
//       },
//        {
//         title: "Backstreet Boys",
//         desc: "The Backstreet Boys are Back and Larger Than Life",
//         date: "22.04.18",
//         code_date:"22.04.2018",
//         img: "Concerts/51.jpg",
//         side_img: "Concerts/Sidebar/53.jpg",
//         link:  "/Posts/index.php?postType=concerts&post=51",
//         css_class: "addopacity  unic-singer-20",
//         id:51,
//         a_star: true,
//         book_now: "Lire La suite"
//       },
//       {
//         title: "Pride Parade 2019",
//         desc: "",
//         date: "14.06.2019",
//         code_date:"14.06.2019",
//         img:"Concerts/Pride_Parade_2019.jpg",
//         side_img:"Concerts/Pride_Parade_2019.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Pride_Parade_2019",
//         css_class: "addopacity  unic-singer-Pride_Parade_2019",
//         id: "Pride_Parade_2019",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Daddy Yankee",
//         desc: "",
//         date: "26.06.2019",
//         code_date:"26.06.2019",
//         img: "Concerts/daddyyanke.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-daddyyanke",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Tom Jones",
//         desc: "",
//         date: "03.07.2019",
//         code_date:"03.07.2019",
//         img: "Concerts/tomjones.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-tomjones",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Paul Anka",
//         desc: "",
//         date: "11.07.2019",
//         code_date:"11.07.2019",
//         img: "Concerts/paul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-paul",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Sean Paul",
//         desc: "",
//         date: "13.07.2019",
//         code_date:"13.07.2019",
//         img: "Concerts/seanpaul.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-seanpaul",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Ozuna",
//         desc: "",
//         date: "24.07.2019",
//         code_date:"24.07.2019",
//         img: "Concerts/ozuna.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-ozuna",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Jerusalem Film Festival",
//         desc: "36 Years of Cinema Magic!",
//         date: "04.08.19",
//         code_date:"04.08.2019",
//         img:"Concerts/filmFestive.jpg",
//         side_img:"Concerts/filmFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=68",
//         css_class: "addopacity  unic-singer-68",
//         id:68,
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Bon Jovi",
//         desc: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
//         date: "25.07.19",
//         code_date:"25.07.2019",
//         img: "Concerts/bon-j.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-76",
//         id: 76,
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "J Balvin",
//         desc: "",
//         date: "30.07.2019",
//         code_date:"30.07.2019",
//         img: "Concerts/balvin.jpg",
//         side_img: "Concerts/bon-j.jpg",
//         link: "/Posts/index.php?postType=concerts&post=76",
//         css_class: "addopacity  unic-singer-balvin",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Jerusalem Wine Festival",
//         desc: "Wine and dine in the holy city!",
//         date: "30.07.2019",
//               code_date:"30.07.2019",
//         img:"Concerts/wineFestive.jpg",
//         side_img:"Concerts/wineFestive.jpg",
//         link: "/Posts/index.php?postType=concerts&post=69",
//         css_class: "addopacity  unic-singer-69",
//         id:69,
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "J.Lo",
//         desc: "",
//         date: "01.08.2019",
//               code_date:"01.08.2019",
//         img:"Concerts/jlo.jpg",
//         side_img:"Concerts/jlo.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jlo",
//         css_class: "addopacity  unic-singer-jlo",
//         id: "J_Lo",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "The International Arts",
//         desc: "",
//         date: "12-24.08.2019",
//               code_date:"24.08.2019",
//         img: "Concerts/international-arts.jpg",
//         side_img: "Concerts/international-arts.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=94",
//         css_class: "addopacity  unic-singer-inter-arts",
//         id: "The_International_Arts",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Jerusalem Beer Festival",
//         desc: "",
//         date: "28-29.08.2019",
//               code_date:"29.08.2019",
//         img: "Concerts/jer-beer-ferstival.jpg",
//         side_img: "Concerts/jer-beer-ferstival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=91",
//         css_class: "addopacity  unic-singer-jbf",
//         id: "Jerusalem_Beer_Festival",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Lionel Richie",
//         desc: "",
//         date: "12.09.2019",
//               code_date:"12.09.2019",
//         img:"Concerts/lionel-richie.jpg",
//         side_img:"Concerts/lionel-richie.jpg",
//         link:"/Posts/index.php?postType=concerts&post=lionelrichie",
//         css_class: "addopacity  unic-singer-lionel-richie",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Open Houses Festival",
//         desc: "",
//         date: "19-21.09.2019",
//               code_date:"21.09.2019",
//         img: "Concerts/open-houses-festival.jpg",
//         side_img: "Concerts/open-houses-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=96",
//         css_class: "addopacity  unic-singer-openhf",
//         id: "Open_Houses_Festival",
//         book_now : "LIRE LA SuITE"
//       },
//       // {
//       //   title: "Open Restaurants TLV",
//       //   desc: " Feed Your Curiosity!",
//       //   date: .19",
//       //   img: "Concerts/71.jpg",
//       //   side_img: "Concerts/72.jpg",
//       //   link: this.url + "/Posts/index.php?postType=concerts&post=70",
//       //   css_class: "addopacity  unic-singer-70",
//       //   book_now : "LIRE LA SuITE"
//       // },
//        {
//         title: "DGTL FESTIVAL",
//         desc: "",
//         date: "14.10.2019",
//               code_date:"14.10.2019",
//         img: "Concerts/dgtl-festival.jpg",
//         side_img: "Concerts/dgtl-festival.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "addopacity  unic-singer-dgt.19",
//         id: "DGTL_Festival",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Cycle Tel Aviv",
//         desc: "",
//         date: "18.10.2019",
//               code_date:"18.10.2019",
//         img: "Concerts/cycle-tlv-2019.jpg",
//         side_img: "Concerts/cycle-tlv-2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=93",
//         css_class: "addopacity  unic-singer-cycle-tlv-2019",
//         id: "Cycle_Tel_Aviv",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Night Run Tel Aviv",
//         desc: "",
//         date: "30.10.2019",
//               code_date:"30.10.2019",
//         img: "Concerts/night-run-tlv.jpg",
//         side_img: "Concerts/night-run-tlv.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=98",
//         css_class: "addopacity  unic-singer-tlv-nightru.19",
//         id: "Night_Run_TelAviv",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Culinary Festival",
//         desc: "Special Edition: Female Chefs",
//         date: "09-23.11.2019",
//               code_date:"23.11.2019",
//         img: "Concerts/72.jpg",
//         side_img: "Concerts/73.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=71",
//         css_class: "addopacity  unic-singer-71",
//         book_now : "LIRE LA SuITE"
//       },
//      {
//         title: "Open Restaurants Jerusalem",
//         desc: "",
//         date: "19-23.11.19",
//               code_date:"23.11.2019",
//         img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         side_img:"Concerts/Open_Restaurants_Jerusalem.jpg",
//         link:"/Posts/index.php?postType=concerts&post=Open_Restaurants_Jerusalem",
//         css_class: "addopacity  unic-singer-Open_Restaurants_Jerusalem",
//         id: "Open_Restaurants_Jerusalem",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Louis CK",
//         desc: "",
//         date: "23.11.19",
//               code_date:"23.11.2019",
//         img: "Concerts/Louis_CK.jpg",
//         side_img: "Concerts/Louis_CK.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Louis_CK",
//         css_class: "addopacity  unic-singer-Louis_CK",
//         id: "Louis_CK",
//         book_now : "LIRE LA SuITE"
//       },
//       {
//         title: "Jim Jeffries",
//         desc: "",
//         date: "21.12.19",
//               code_date:"21.12.2019",
//         img:"Concerts/jim-jeffries.jpg",
//         side_img:"Concerts/jim-jeffries.jpg",
//         link:"/Posts/index.php?postType=concerts&post=jimjeffries",
//         css_class: "addopacity  unic-singer-jim-jeffries",
//         book_now : "LIRE LA SuITE"
//       },
//       // {
//       //   title: "Open Restaurants TLV",
//       //   desc: " Feed Your Curiosity!",
//       //   date: "2019",
//       //   img:"Concerts/openRestTlv.jpg",
//       //   side_img:"Concerts/openRestTlv.jpg",
//       //   link: "/Posts/index.php?postType=concerts&post=70",
//       //   css_class: "addopacity  unic-singer-70",
//       //   id:70,
//       //   book_now : "LIRE LA SuITE"
//       // },
//       {
//         title: "Le Marathon de Tel-Aviv",
//         desc: "",
//         date: "28.02.2020",
//         code_date:"28.02.2020",
//         img: "Concerts/tlv-marathon.jpg",
//         side_img: "Concerts/tlv-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=97",
//         css_class: "addopacity  unic-singer-tlv-marathon2020",
//         id: "TelAviv_Marathon",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Pourim 2020",
//         desc: "",
//         date: "09-10.03.2020",
//         code_date:"10.03.2020",
//         img: "Concerts/purim2019.jpg",
//         side_img: "Concerts/purim2019.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=Purim_2020",
//         css_class: "addopacity  unic-purim2020",
//         id: "Purim_2020",
//         book_now : "LIRE LA SUITE"
//       },
//         {
//         title: "La Fashion Week de Tel-Aviv",
//         desc: "",
//         date: "03.2020",
//         code_date:"30.03.2020",
//         img: "Concerts/fationWeek.jpg",
//         side_img: "Concerts/fationWeek.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=TelAviv_Fashion_Week_2020",
//         css_class: "addopacity  unic-fashion-week-2020",
//         id: "TelAviv_Fashion_Week_2020",
//         book_now : "LIRE LA SUITE"
//       },
//       {
//         title: "Jerusalem Marathon",
//         desc: "",
//         date: "20.03.2020",
//         code_date:"20.03.2020",
//         img: "Concerts/jer-marathon.jpg",
//         side_img: "Concerts/jer-marathon.jpg",
//         link: this.url + "/Posts/index.php?postType=concerts&post=95",
//         css_class: "addopacity  unic-singer-jer-marathon2020",
//         id: "Jerusalem_Marathon",
//         book_now : "LIRE LA SUITE"
//       },
//       // Hadar asked to hide these 3 event till next year - email date 19-05-2020
//       // {
//       //   title: "The Rubinstein International Competition ",
//       //   desc: "",
//       //   date: "05-21.05.2020",
//       //   img:"Concerts/piano-competition-2020.jpg",
//       //   side_img:"Concerts/piano-competition-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Piano_Competition_2020",
//       //   css_class: "addopacity  unic-singer-piano-competition-2020",
//       //   id: "Piano_Competition_2020",
//       //   book_now : "LIRE LA SuITE"
//       // },
//       // {
//       //   title: "Red Hot Chili Peppers",
//       //   desc: "",
//       //   date: "10.06.20",
//       //   img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   side_img:"Concerts/red-hot-chili-peppers-2020.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=Red_Hot_Chili_Peppers_2020",
//       //   css_class: "addopacity  unic-singer-red-hot-chili-peppers-2020",
//       //   id: "Red_Hot_Chili_Peppers_2020",
//       //   book_now : "LIRE LA SuITE"
//       // },
//       // {
//       //   title: "Nuit Blanche",
//       //   desc: "",
//       //   date: "06.2020",
//       //   code_date:"30.06.2020",
//       //   img:"Concerts/53.jpg",
//       //   side_img:"Concerts/53.jpg",
//       //   link:"/Posts/index.php?postType=concerts&post=White_Night_2020",
//       //   css_class: "addopacity  unic-singer-white-night-2020",
//       //   id: "White_Night_2020",
//       //   book_now : "LIRE LA SUITE"
//       // },
//        // End Hadar asked to hide these 3 event till next year - email date 19-05-2020
// ];
// End showsArr
var showsArr=[];var faqData=[{id:1,q:"FOIRE AUX QUESTIONS SUR LE COVID-19",answer:"\n      <ol start=\"1\">\n              <li>\n                <strong>Je suis un touriste en Isra\xEBl et je crains d'avoir le COVID-19, o\xF9 dois-je aller ?</strong><br/>\n                Si vous avez une fi\xE8vre d\u2019au moins 38\xB0C ou plus, de la toux, des difficult\xE9s respiratoires ou d'autres sympt\xF4mes respiratoires, vous devez imm\xE9diatement vous auto-isoler et appeler le 101 (MDA Emergency Services Hotline) pour un avis m\xE9dical. Ne vous rendez pas dans une clinique ni dans une salle d'urgence.        \n              </li>\n              <li>\n                <strong>Quand Isra\xEBl sera-t-il \xE0 nouveau ouvert aux visiteurs \xE9trangers ?</strong><br/>\n                \u2019Il est \xE0 ce jour possible de se rendre en Isra\xEBl selon les conditions requises et avec un passeport en r\xE8gle. Il est demand\xE9 \xE0 chaque passager de remplir le formulaire d\u2019entr\xE9e (voir sur : www.israelsafe.com) et de disposer d\u2019une attestation d\u2019assurance personnelle sp\xE9cial COVID-19.\n              </li>\n       \n      </ol>\n      ",isOpen:false},{id:2,q:"Israël c'est un peu loin, non ?",answer:"\n      <p>\n        Pas autant que vous le pensez : Isra\xEBl est \xE0 seulement 4h15 de vol de Paris et moins de 4h de Marseille. De plus, vous pouvez rejoindre Isra\xEBl via des douzaines de villes d'Europe.\n      </p>\n      ",isOpen:false},{id:3,q:"Déplacements",answer:"\n      \n      <h4>BUS:</h4> \n      <p>Isra\xEBl poss\xE8de l'un des r\xE9seaux de bus les plus performants et \xE9conomiques au monde puisqu'il relie la plupart des villes, villages et communes diverses.</p>\n\n      <h4>TRAIN:</h4> \n      <p>des trains \xE0 grande vitesse relient l'A\xE9roport Ben Gurion \xE0 Tel Aviv, J\xE9rusalem et Ha\xEFfa, et des trains rapides et bon march\xE9 sillonnent la majeure partie du pays.  Le train est un moyen de transport bon march\xE9 et extr\xEAmement simple \xE0 utiliser. Cliquez ici pour obtenir des informations compl\xE8tes.</p>\n       \n      <h4>AVION:</h4> \n      <p>Arkia, El Al et Israir proposent plusieurs liaisons quotidiennes pour Tel Aviv et Eilat, ainsi que des vols vers Ha\xEFfa et la Galil\xE9e.</p>\n       \n      <h4>TAXI:</h4> \n      <p>des taxis sont \xE0 votre disposition dans les villes et les chauffeurs vous transporteront avec plaisir d'une ville \xE0 l'autre. Consultez le tarif avant de convenir d'un trajet en taxi.</p>\n       \n      <h4>TAXI COLLECTIF:</h4> \n      <p>les taxis collectifs ou \"Sherut\" connaissent un vif succ\xE8s. Des stations \"Sherut\" sont propos\xE9es dans toute la ville. Pour conna\xEEtre la station la plus proche, adressez-vous \xE0 la r\xE9ception de votre h\xF4tel.</p>\n       \n      <h4>LOCATION DE VOITURE:</h4> \n      <p>La plupart des soci\xE9t\xE9s de location internationales poss\xE8dent des agences en Isra\xEBl. Il existe \xE9galement d'excellentes agences nationales. Votre permis de conduire europ\xE9en est valable en Isra\xEBl.</p>\n      ",isOpen:false},{id:4,q:"Et pour l'argent?",answer:"\n      <p>\n        La monnaie isra\xE9lienne est le shekel (officiellement le \"nouveau shekel\") ; 1 Euro est \xE9gal \xE0 environ 4 Shekels. Cliquez ici pour conna\xEEtre le taux de change actuel. Nous vous conseillons, \xE0 votre arriv\xE9e en Isra\xEBl, d'utiliser votre carte de cr\xE9dit pour retirer des devises \xE0 l'un des distributeurs automatiques disponibles dans les halls d'arriv\xE9e de l'a\xE9roport Ben Gurion, ou de changer de petites sommes ou ch\xE8ques de voyage \xE0 la banque de votre h\xF4tel. Vous trouverez des distributeurs de billets partout en Isra\xEBl et les cartes de cr\xE9dit sont largement accept\xE9es.\n      </p>\n      ",isOpen:false},{id:5,q:"Communications",answer:"\n        <p>\n        La plupart des h\xF4tels proposent g\xE9n\xE9ralement une connexion wi-fi gratuite dans le hall, et parfois dans les chambres. De nombreux h\xF4tels poss\xE8dent un Centre d'affaires permettant d'acc\xE9der gratuitement \xE0 Internet et \xE0 la messagerie \xE9lectronique. Les t\xE9l\xE9phones portables am\xE9ricains qui fonctionnent \xE0 l'\xE9tranger fonctionneront \xE9galement en Isra\xEBl. Le d\xE9calage horaire est de + 1 heure: quand il est midi \xE0 Paris, il est 13 heures \xE0 J\xE9rusalem ou Tel-Aviv.\n        </p>\n      ",isOpen:false},{id:6,q:"Températures",answer:"\n      <p>Les temp\xE9ratures peuvent \xEAtre tr\xE8s variables : par cons\xE9quent, emportez des v\xEAtements adapt\xE9s \xE0 la saison et tout ira bien.  La transition entre les saisons n'est bien entendu pas franche, mais les consignes g\xE9n\xE9rales sont les suivantes :</p>\n \n      <p>\xC9T\xC9 (jun/jul/aou/d\xE9but sep) :  temp\xE9ratures comprises entre 26 et 32\xBAC.  Tel Aviv et Tib\xE9riade ont un climat chaud et humide (similaire \xE0 celui de New York ou Miami).  J\xE9rusalem poss\xE8de un climat plus sec et plus frais, notamment la nuit.  Massada et Eilat enregistrent des temp\xE9ratures extr\xEAmement \xE9lev\xE9es (+ de 43\xBAC !)... mais l'air y est sec.  Vous n'aurez pas une goutte de pluie.</p>\n       \n      <p>PRINTEMPS/AUTOMNE (fin mar/avr/mai/fin sep/oct/nov) : temp\xE9ratures diurnes tr\xE8s plaisantes dans la plus grande partie du pays (autour de 24\xB0C) mais plus chaudes dans les r\xE9gions de la mer Rouge et de la mer Morte). \xC0 J\xE9rusalem, la temp\xE9rature sera d'environ 21\xB0C le jour et 10\xB0C la nuit.  Vous aurez de la pluie, mais peu abondante.</p>\n       \n      <p>HIVER (d\xE9c/jan/f\xE9v/d\xE9but mar) : la m\xE9t\xE9o peut \xEAtre variable.  Certains hivers sont doux et ensoleill\xE9s, d'autres rudes et nuageux. Les pluies fortes sont fr\xE9quentes, avec parfois de la neige en janvier et f\xE9vrier. La temp\xE9rature sera certainement comprise entre 10 et 15\xB0C dans la plupart des r\xE9gions, mais pourra descendre \xE0 4\xB0C \xE0 J\xE9rusalem et en Galil\xE9e, voire descendre encore la nuit.</p>\n      ",isOpen:false},{id:7,q:"De quels documents ai-je besoin pour venir en Israël ?",answer:"\n        \n        <p>\n        Les citoyens fran\xE7ais et belges doivent se munir d'un passeport valide au moins six mois apr\xE8s leur date d'arriv\xE9e en Isra\xEBl. Il est inutile de se procurer un visa pour les s\xE9jours de moins de trois mois. Les m\xEAmes conditions s'appliquent aux citoyens de la plupart des pays occidentaux. Pour vous en assurer, consultez le document: <a href=\"//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf\" target=\"_blank\">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a>\n        </p>\n      ",isOpen:false}];var newPosts=[// Videos posts of Section Plan Your trip
{title:"MAH’ANÉ YÉHOUDA",// "sml_desc": "Market Madness",
sml_desc:"",// "desc": "Night time celebration in <br>Jerusalem’s Mahane Yehuda",
desc:"",img:"Videos/market-madness.jpg",img_mob:"/Videos/video_mob/market-madness.jpg",side_img:"Videos/sidebar/market-madness.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Market_Madness",vidId:"2CSCe2WC7Ns",ctg:"culinary",isVid:true,forVidPage:true,id:"Market_Madness"},// this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
// {
//     "title": "À la recherche d'une vie nocturne de folie ?!",
//     // "sml_desc": " Book your trip to Tel Aviv!",
//     "sml_desc": "",
//     // "desc": "",
//     "desc": "",
//     "img": "Videos/crazy-night.jpg",
//     "img_mob":"/Videos/video_mob/crazy-night.jpg",
//     "side_img": "Videos/sidebar/crazy-night.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Amazing_Nightlife",
//     "vidId": "ogEN7aRT0SM",
//     "ctg": "telaviv",
//     "isVid": true,
//     "id": "Amazing_Nightlife"
// },
// END this Video post is going to the same post as "title": "Amazing Nightlife" Eyal Asked
{title:"Jérusalem",// "sml_desc": "Jérusalem - le coeur du monde",
sml_desc:"",// "desc": "",
desc:"",img:"Videos/heart-of-the-world.jpg",img_mob:"/Videos/video_mob/heart-of-the-world.jpg",side_img:"Videos/sidebar/heart-of-the-world.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Heart_Of_The_World",vidId:"nLKWDp5uA-U",ctg:"jerusalem",isVid:true,forVidPage:true,id:"Heart_Of_The_World"},{title:"LA MER MORTE",// "sml_desc": "Le plaisir de la vie à son plus haut niveau au point le plus bas sur Terre",
sml_desc:"",desc:"",img:"/PostCarousel/DeadSea/deadsea2.jpg",img_mob:"/PostCarousel/video_mob/100.jpg",side_img:"/PostCarousel/DeadSea/deadsea2.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Dead_Sea2",isVid:true,forVidPage:true,vidId:"c93EwT_1EU8",ctg:"deadsea",id:"Dead_Sea2"},// has ho translation hadar said to hide untill she'll send the translation
// {
//     "title": "JAFFA, VILLE MAGIQUE",
//     "sml_desc": "",
//     // "sml_desc" : "Explorez tous les trésors de la splendide ville antique de Jaffa",
//     "desc": "",
//      // "desc" : "Experience all the riches the beautiful ancient Jaffa has to offer",
//      "img_mob":"/Videos/video_mob/joys-of-jaffa.jpg",
//     "img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
//     "side_img": "/PostCarousel/TelAviv/joys-of-jaffa.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Joys_Of_Jaffa",
//     "isVid": true,
//     "vidId":"a6QMndU0wx0",
//     "ctg": "telaviv",
//     "id": "Joys_Of_Jaffa"
// },
{title:"TEL AVIV, EN BORD DE MER",// "sml_desc": "À Tel Aviv, c'est à la plage que bat le cœur de la ville",
sml_desc:"",// "desc": "Préparez-vous à vous éclater comme jamais au soleil",
desc:"",img:"Videos/a.jpg",img_mob:"/Videos/video_mob/a.jpg",side_img:"Videos/sidebar/a.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?postType=video&post=3",css_class:"unic_video-post-4",vidId:"jsTzRtTCvWg",ctg:"telaviv",isVid:true,forVidPage:true,id:"TelAviv_By_The_Sea"},{title:"Névé Tzedek",sml_desc:"",// "sml_desc" : "Chic et unique",
// "desc": "Déborde de cafés pittoresques, boutiques, galeries d'art, élégance et atmosphère rafraîchissante",
desc:"",img:"Videos/j.jpg",img_mob:"/Videos/video_mob/j.jpg",side_img:"Videos/sidebar/j.jpg",read_more:"LIRE LA SuITE",vidId:"5jl13Z-38eE",link:"/Posts/index.php?postType=video&post=7",css_class:"unic_video-post-13",ctg:"telaviv",isVid:true,forVidPage:true,id:"Neve_Tzedek"},{title:"Sarona Tel Aviv",desc:"",// "desc": "Un immense choix de lieux à découvrir dans une superbe colonie des Templiers rénovée",
// "sml_desc": "Une oasis urbaine spectaculaire",
sml_desc:"",img:"Videos/d.jpg",img_mob:"/Videos/video_mob/d.jpg",side_img:"Videos/sidebar/d.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?postType=video&post=Sarona_TelAviv",vidId:"hdquOPEilDo",ctg:"telaviv",isVid:true,forVidPage:true,id:"Sarona_TelAviv"},{title:"PLAISIRS PORTUAIRES",// "sml_desc": "Les ports de Tel Aviv et de Jaffa – différents et fabuleux",
sml_desc:"",// "desc": "Tel Aviv’s fascinating cultural scene",
desc:"",img:"/PostCarousel/3.jpg",img_mob:"/PostCarousel/video_mob/3.jpg",side_img:"/PostCarousel/3.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Port_Pleasures",isVid:true,forVidPage:true,vidId:"a6QMndU0wx0",ctg:"telaviv",id:"Port_Pleasures"},{title:"La mer Morte ",// "sml_desc": "La mer Morte naturel de toute beauté",
sml_desc:"",// "desc": "Le plaisir de la vie à son plus haut  niveau au point le plus bas sur Terre  ",
desc:"",img:"/PostCarousel/DeadSea/natures-glory.jpg",img_mob:"/PostCarousel/video_mob/natures-glory.jpg",side_img:"/PostCarousel/DeadSea/natures-glory.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Dead_Sea_Video",isVid:true,forVidPage:true,ctg:"deadsea",vidId:"ixFocykfYHo",id:"Dead_Sea_Video"},{title:"La vieille ville",sml_desc:"",// "sml_desc": "Sentez l'histoire prendre vie",
desc:"",// "desc": "Laissez-vous inspirer par les trésors de la vieille ville de Jérusalem, connus dans le monde entier",
img:"Videos/m.jpg",img_mob:"/Videos/video_mob/m.jpg",side_img:"Videos/sidebar/m.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Jerusalem_Old_City",isVid:true,forVidPage:true,vidId:"6eXJu1Yy4kg",ctg:"jerusalem",id:"Jerusalem_Old_City"},{title:"AVENTURES EN PLEIN AIR",// "sml_desc": "Tel Aviv sur roues",
sml_desc:"",// "desc": "Une ville pleine d’action idéale pour les personnes actives",
desc:"",img:"/Videos/12.jpg",img_mob:"/Videos/video_mob/12.jpg",side_img:"/Videos/12.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Outdoor_Adventures",isVid:true,forVidPage:true,ctg:"telaviv",vidId:"5nqL-oIC0GA",id:"Outdoor_Adventures"},{title:"Moderne et vibrante",// "sml_desc": "Tant à voir dans le centre-ville animé de Jérusalem",
sml_desc:"",desc:"",img:"/PostCarousel/19.jpg",img_mob:"/PostCarousel/video_mob/19.jpg",side_img:"/PostCarousel/19.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Modern_And_Vibrant_Video",isVid:true,forVidPage:true,vidId:"cUBBkziv_4c",ctg:"jerusalem",id:"Modern_And_Vibrant_Video"},{title:"2 VILLES GRANDIOSES",// "sml_desc": "One magical unforgettable getaway to the sun",
sml_desc:"",desc:"",img:"/PostCarousel/Jerusalem/tw-awesome-cities.jpg",side_img:"/PostCarousel/Jerusalem/tw-awesome-cities.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=42",isVid:false,forVidPage:true,ctg:"telavivAndJerusalem",id:"2_AWESOME_CITIES"},{title:"JERUSALEM",sml_desc:"",desc:"",img:"/PostCarousel/Jerusalem/jerusalem.jpg",side_img:"/PostCarousel/Jerusalem/jerusalem.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Jerusalem",isVid:false,forVidPage:true,ctg:"jerusalem",id:"Jerusalem"},// {
//     "title": "LE MER MUERTE",
//     // "sml_desc": "TAKE RELAXATION TO THE NEXT LEVEL",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/DeadSea/next-level.jpg",
//     "side_img": "/PostCarousel/DeadSea/next-level.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Next_Level_DS",
//     "isVid": false,
//     "ctg": "deadsea",
//     "id": "Next_Level_DS"
// },
{title:"Tel Aviv",sml_desc:"",desc:"",img:"/PostCarousel/TelAviv/post-telaviv.jpg",side_img:"/PostCarousel/TelAviv/post-telaviv.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Tel_Aviv",isVid:false,forVidPage:true,ctg:"telaviv",id:"Tel_Aviv"},// {
//    "title": "NATURE'S GLORY",
//     // "sml_desc": "THE DEAD SEA",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/DeadSea/natures-glory.jpg",
//     "side_img": "/PostCarousel/DeadSea/natures-glory.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Natures_Glory",
//     "isVid": false,
//     "ctg": "deadsea",
//     "id": "Natures_Glory"
// },
// {
//     "title": "Go To Guide",
//     // "sml_desc": "Travel from Tel Aviv and Jerusalem",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/34.jpg",
//     "side_img": "/PostCarousel/34.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=35",
//     "ctg": "telaviv",
//     "isVid": false,
//     // "id": 35
//     "id": "Go_To_Guide"
// },
// has ho translation' hadar said to hide untill she'll send the translation
// {
//     "title": "ALL SENSORY MARKETS",
//     "sml_desc": "",
//     "desc": "",
//     "img": "thingsToDo/8.jpg",
//     "side_img": "thingsToDo/sidebar/8.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     "id": "All_Sensory_Markets",
//     "showOnHome": false,
//     "ctg": "jerusalem"
// },
{title:"La cuisine de Jérusalem",// "sml_desc": "Appétissante, variée et tellement délicieuse",
sml_desc:"",// "desc": "La cuisine de Jérusalem",
desc:"",img:"PostCarousel/Jerusalem/jerusalem-kitchen.jpg",img_mob:"PostCarousel/video_mob/jerusalem-kitchen.jpg",side_img:"PostCarousel/Culinary/cuisine-jer.jpg",read_more:"LIRE LA SuITE",// "link": "/Posts/index.php?postType=video&post=3",
css_class:"unic_video-post-4",vidId:"jsTzRtTCvWg",ctg:"culinaryjerusalem",isVid:true,forVidPage:true,id:"Jerusalem_Cuisine"},{title:"Jerusalem ‘Musts’",// "sml_desc": "5 things to do in the stunning city",
sml_desc:"",desc:"",img:"/PostCarousel/18.jpg",side_img:"/PostCarousel/18.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Jerusalem_Musts",isVid:false,forVidPage:true,ctg:"jerusalem",id:"Jerusalem_Musts"},{title:"LES JOIES DE LA MER MORTE",sml_desc:"",// "sml_desc": "THE DEAD SEA",
desc:"",img:"/PostCarousel/DeadSea/natural-spa.jpg",side_img:"/PostCarousel/DeadSea/natural-spa.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Natural_Spa",isVid:false,forVidPage:true,ctg:"deadsea",id:"Natural_Spa"},{title:"Ports de Jaffa",// "sml_desc": "The different charms of<br> Tel Aviv and Jaffa Ports ",
sml_desc:"",// "desc": "Tel Aviv’s fascinating cultural scene",
desc:"",img:"/PostCarousel/TelAviv/jaffa-port.jpg",side_img:"/PostCarousel/TelAviv/jaffa-port.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Port_Pleasures",isVid:false,forVidPage:true,ctg:"telaviv",id:"Port_Pleasures"},// {
//     "title": "Upscale Jerusalem",
//     // "sml_desc": "Modern luxuries for the pampered traveler",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/Jerusalem/45.jpg",
//     "side_img": "/PostCarousel/Jerusalem/45.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=45",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": 45
// },
// {
//    "title": "NATURAL PHENOMENA",
//     // "sml_desc": "THE DEAD SEA",
//      "sml_desc": "",
//     "desc" : "",
//     "img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
//     "side_img": "/PostCarousel/DeadSea/natural-phenomena.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Natural_Phenomena",
//     "isVid": false,
//     "ctg": "deadsea",
//     "id": "Natural_Phenomena"
// },
{// "title": "A Foodie’s Paradise‘",
title:"Paradis pour les gourmets",// "sml_desc": "Explorez l’impressionnante scène culinaire de Tel Aviv",
sml_desc:"",desc:"",img:"/PostCarousel/99.jpg",img_mob:"/PostCarousel/video_mob/99.jpg",side_img:"/PostCarousel/99.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Simply_Delicious",ctg:"culinarytelaviv",vidId:"n4kCnPXEX7g",isVid:true,forVidPage:true,id:"Simply_Delicious"},{title:"LES SURPRISES DE JÉRUSALEM",// "sml_desc": "A city beyond expectations",
sml_desc:"",desc:"",img:"/PostCarousel/38.jpg",side_img:"/PostCarousel/38.jpg",read_more:"LIRE LA SuITE",link:this.url+"/Posts/index.php?post=Cool Jerusalem",ctg:"jerusalem",isVid:false,forVidPage:true,id:"Cool_Jerusalem"},{title:"LA MER MORTE",sml_desc:"",desc:"",img:"/PostCarousel/DeadSea/magical-deadsea.jpg",side_img:"/PostCarousel/DeadSea/magical-deadsea.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Magical_Deadsea",isVid:false,forVidPage:true,ctg:"deadsea",id:"Magical_Deadsea"},// has ho translation' hadar said to hide untill she'll send the translation
// {
//     "title": "A LA RECHERCHE D'UNE VIE NOCTURNE",
//     "sml_desc": "",
//     // "sml_desc": "Amazing Nightlife",
//     "desc": "",
//     // "desc": "It’s a never-ending party<br> in the nonstop city!",
//     "img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
//     "side_img": "/PostCarousel/TelAviv/amazing-nightlife.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Amazing_Nightlife",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Amazing_Nightlife"
// },
// {
//    "title": "MASADA",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/DeadSea/masada.jpg",
//     "side_img": "/PostCarousel/DeadSea/masada.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Masada",
//     "isVid": false,
//     "ctg": "deadsea",
//     "id": "Masada"
// },
{title:"LES POINTS FORTS DE TEL AVIV",// "sml_desc": "Top 5 things to see and\n do in the city",
sml_desc:"",desc:"",img:"/PostCarousel/17.jpg",side_img:"/PostCarousel/17.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=17",ctg:"telaviv",isVid:false,forVidPage:true,id:"Top_5_Things"},// {
//     "title": "First Time in Jerusalem",
//     // "sml_desc": "The must list for the first time visitor",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
//     "side_img": "/PostCarousel/Jerusalem/first-in-jerusalem.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=First_Time_In_Jerusalem",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "First_Time_In_Jerusalem"
// },
// {
//     "title": "Boutique Hospitality",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
//     "side_img": "/PostCarousel/TelAviv/boutique-hospitality.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Boutique_Hospitality",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Boutique_Hospitality"
// },
{title:"LES NUITS ANIMÉES DE TEL AVIV",sml_desc:"",desc:"",img:"/PostCarousel/TelAviv/ANIMATED_NIGHTS_TEL_AVIV.jpg",side_img:"/PostCarousel/TelAviv/ANIMATED_NIGHTS_TEL_AVIV.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=ANIMATED_NIGHTS_TEL_AVIV",isVid:false,ctg:"telaviv",id:"ANIMATED_NIGHTS_TEL_AVIV"},{title:"L’HEURE DE LA SHAKSHUKA",// "sml_desc": "Susshuka Zeit",
sml_desc:"",// "desc": "Lerne Sie, wie man das weltberühmte\n Shakshuka-Gericht zubereitet!",
desc:"",img:"/PostCarousel/22.jpg",img_mob:"/PostCarousel/video_mob/22.jpg",side_img:"/PostCarousel/22.jpg",read_more:"Weiterlesen",link:"/Posts/index.php?post=22",ctg:"culinary",vidId:"n4kCnPXEX7g",isVid:true,forVidPage:true,id:"Shakshuka"},{title:"Jerusalem",// "sml_desc": "Must eat dishes to try when visiting the magical city",
desc:"",sml_desc:"",img:"/PostCarousel/37.jpg",img_mob:"/PostCarousel/video_mob/37.jpg",side_img:"/PostCarousel/37.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=38",ctg:"culinaryjerusalem",vidId:"2CSCe2WC7Ns",isVid:true,forVidPage:true,id:"A_Taste_Of_Jerusalem"},{title:"PAUSE-CAFÉ À TEL AVIV",// "sml_desc": "Tel Aviv over a fresh coffee",
sml_desc:"",// "desc": "Coffee shop culture is fundamental",
desc:" ",img:"Videos/coffee.jpg",img_mob:"/Videos/video_mob/coffee.jpg",side_img:"Videos/sidebar/coffee.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?postType=video&post=16",vidId:"rVr0gqFC364",ctg:"culinarytelaviv",isVid:true,forVidPage:true,id:"Coffee_In_TelAviv"},// {
//    "title": "SECRETS OF JEWISH JERUSALEM",
//     "sml_desc" : "",
//      "desc" : "",
//     "img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
//     "side_img": "/PostCarousel/Jerusalem/secrets-jer.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Sectrets_Of_Jewish_Jerusalem",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Sectrets_Of_Jewish_Jerusalem"
// },
// {
//     "title": "Non Stop Markets",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
//     "side_img": "/PostCarousel/TelAviv/non-stop-markets.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Non_Stop_Markets",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Non_Stop_Markets"
// },
{title:"AVENUE MAMILLA",sml_desc:"",desc:"",img:"/PostCarousel/Jerusalem/mamila-avenue.jpg",side_img:"/PostCarousel/Jerusalem/mamila-avenue.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Mamilla_Avenue",isVid:false,forVidPage:true,ctg:"jerusalem",id:"Mamilla_Avenue"},// {
//     "title": "TOWER OF DAVID MUSEUM",
//     "sml_desc": "",
//     "img": "thingsToDo/7.jpg",
//     "side_img": "thingsToDo/sidebar/7.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     "id": "Tower_Of_David_Museum",
//     "showOnHome": false,
//     "ctg": "jerusalem"
// },
// {
//    "title": "JERUSALEM’S ART",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
//     "side_img": "/PostCarousel/Jerusalem/jerusalem-art.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Jerusalem_Arts",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Jerusalem_Arts"
// },
// {
//    "title": "MUST EAT IN JERUSALEM",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
//     "side_img": "/PostCarousel/Jerusalem/must-eat-in-jer.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Must_Eat_In_Jerusalem",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Must_Eat_In_Jerusalem"
// },
{title:"MANGER VEGAN A TEL-AVIV",// "sml_desc": "1ère destination mondiale pour les vegans",
// "desc": "Dégustez un large choix de délices vegans, même des glaces !",
sml_desc:"",desc:"",img:"Videos/h.jpg",img_mob:"/Videos/video_mob/h.jpg",side_img:"Videos/sidebar/h.jpg",vidId:"S2NGYP3QQT8",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=6",ctg:"culinarytelaviv",isVid:true,forVidPage:true,id:"Vegan_Friendly_TelAviv"},{title:"BONS PLANS SUR TEL AVIV",// "sml_desc": "Cool things to do in the hot city",
sml_desc:"",desc:"",img:"/PostCarousel/40.jpg",side_img:"/PostCarousel/40.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=TelAviv_Adventures",ctg:"telaviv",isVid:false,id:"TelAviv_Adventures"},// {
//     "title": "UNFORGETTABLE YAD VASHEM",
//     "sml_desc": "",
//     "img": "thingsToDo/10.jpg",
//     "side_img": "thingsToDo/sidebar/10.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 31,
//     "showOnHome": false,
//     "ctg": "jerusalem"
// },
// {
//    "title": "THE GATES OF JERUSALEM",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/gates.jpg",
//     "side_img": "/PostCarousel/Jerusalem/gates.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=The_Gates_Of_Jerusalem",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "The_Gates_Of_Jerusalem"
// },
{title:"Une journée à Tel Aviv",sml_desc:"",// "sml_desc" : "Day isTrippin’",
desc:"",// "desc" : "Fabulous and fascinating one day in Tel Aviv",
img:"/PostCarousel/TelAviv/day-is-trippin.jpg",side_img:"/PostCarousel/TelAviv/day-is-trippin.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Day_IsTrippin",isVid:false,ctg:"telaviv",id:"Day_IsTrippin"},// {
//     "title": "JERUSALEM MAIN SITES",
//     // "sml_desc": "Travel back thousands of years",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
//     "side_img": "/PostCarousel/Jerusalem/main-sites-jer.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=9",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": 99
// },
{title:"SCÈNE GOURMANDE SUR TEL-AVIV",// "sml_desc": "The perfect place\n to treat yourself",
sml_desc:"",// "desc": "Tel Aviv's huge variety of amazing",
desc:"",img:"Videos/e.jpg",img_mob:"/Videos/video_mob/e.jpg",side_img:"Videos/sidebar/e.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?postType=video&post=33",vidId:"jfyHxk8ZRrI",ctg:"culinarytelaviv",isVid:true,forVidPage:true,id:"Gourmet_TelAviv"},// {
//     "title": "WESTERN WALL WONDERS",
//     "sml_desc": "",
//     "img": "thingsToDo/4.jpg",
//     "side_img": "thingsToDo/sidebar/4.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Western_Wall_Wonders",
//     "css_class": "unic_video-post-Western_Wall_Wonders",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     "id": "Western_Wall_Wonders",
//     "ctg": "jerusalem",
//     "showOnHome": false,
// },
// has ho translation' hadar said to hide untill she'll send the translation
// {
//     "title": "TRAVELLING ON A BUDGET",
//     // "sml_desc": "Making it count in Tel Aviv and Jerusalem!",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/44.jpg",
//     "side_img": "/PostCarousel/44.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=44",
//     "isVid": false,
//     "ctg": "telavivAndJerusalem",
//     "id": 44
// },
{title:"DES ACHATS UNIQUES À ISRAËL",sml_desc:"",desc:"",img:"/PostCarousel/Jerusalem/unique.jpg",side_img:"/PostCarousel/Jerusalem/unique.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Purchases_In_Israel",isVid:false,ctg:"jerusalem",id:"Purchases_In_Israel"},{title:"PARADIS POUR LES GOURMETS",// "sml_desc" : "Tel Aviv street food",
sml_desc:"",// "desc" : "A true world-class foodie destination",
desc:"",img:"/PostCarousel/TelAviv/streetfood-telaviv.jpg",side_img:"/PostCarousel/TelAviv/streetfood-telaviv.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Tel_Aviv_Street_Food",isVid:false,forVidPage:true,ctg:"telaviv",id:"Tel_Aviv_Street_Food"},// {
//    "title": "JERUSALEM FUN",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
//     "side_img": "/PostCarousel/Jerusalem/jerusalem-fun.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Jerusalem_Fun",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Jerusalem_Fun"
// },
{title:"Tel Aviv à vélo",// "desc": "Get on your bicycle -<br> explore the city in style",
sml_desc:"",desc:"",img:"PostCarousel/39.jpg",side_img:"PostCarousel/39.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=38",ctg:"telaviv",isVid:false,forVidPage:true,id:39},// {
//     "title": "ULTIMATE BEACH FUN",
//     "sml_desc": "",
//     // "desc": "Join the ride in the city that doesn't stop \n Get your wheels on and go anywhere they take you in this fabulous city",
//     "desc": "",
//     "img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
//     "img_mob":"/PostCarousel/video_mob/ultimate-beaches.jpg",
//     "side_img": "/PostCarousel/TelAviv/ultimate-beaches.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=24",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": true,
//     "id":"Ultimate_Beach_Fun",
//     "ctg": "telaviv",
//     "showOnHome": false,
// },
{title:"Moderne et dynamique",// "sml_desc": "Il y a tant à voir dans le centre-ville animé de Jérusalem",
sml_desc:"",desc:"",img:"/PostCarousel/19.jpg",side_img:"/PostCarousel/19.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Modern_And_Vibrant_Post",isVid:false,forVidPage:true,ctg:"jerusalem",id:"Modern_And_Vibrant_Post"},// {
//     "title": "WHITE CITY SPLENDOR",
//     "sml_desc": "",
//     "desc": "",
//     "img": "thingsToDo/6.jpg",
//     "side_img": "thingsToDo/sidebar/6.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=20",
//     "css_class": "unic_video-post-1",
//     "vidId": "88OV6xU0vPI",
//     "isVid": false,
//     id: 28,
//     "showOnHome": false,
//     "ctg": "telaviv"
// },
// {
//    "title": "Jerusalem after dark fun",
//     "sml_desc" : "",
//     "desc" : "",
//     "img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
//     "side_img": "/PostCarousel/Jerusalem/after-dark-fun.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Jerusalem_After_Dark_Fun",
//     "isVid": false,
//     "ctg": "jerusalem",
//     "id": "Jerusalem_After_Dark_Fun"
// },
{title:"TEL AVIV",// "sml_desc": "Enjoy and Indulge",
sml_desc:"",// "desc": "Tel Aviv - The ultimate luxury destination",
desc:"",img:"/PostCarousel/36.jpg",side_img:"/PostCarousel/36.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=37",ctg:"telaviv",isVid:false,id:37},// has ho translation' hadar said to hide untill she'll send the translation
// {
//    "title" : "À L’HEURE DE LA CULTURE",
//     // "sml_desc": "Non Stop Culture",
//     "sml_desc" : "",
//     // "desc": "Tel Aviv’s fascinating cultural scene",
//      "desc" : "",
//     "img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
//     "side_img": "/PostCarousel/TelAviv/culture-telaviv.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=Non_Stop_Culture",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Non_Stop_Culture"
// },
// end has ho translation' hadar said to hide untill she'll send the translation
{title:"Jamie Oliver à Tel Aviv",// "sml_desc": "Jamie Oliver découvre les saveurs des petits-déjeuners de Tel Aviv ",
sml_desc:"",desc:"",img:"Videos/jamie-oliver.jpg",img_mob:"/Videos/video_mob/jamie-oliver.jpg",side_img:"Videos/sidebar/jamie-oliver.jpg",vidId:"gGe4W8WaIiQ",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Jamie_Oliver",ctg:"culinarytelaviv",isVid:true,forVidPage:true,id:"Jamie_Oliver"},// No translation
/* Removed from request docsa Google Sheete */// {
//   title: "JOIES DU SHOPPING",
//   // "sml_desc": "From culture to souvenirs",
//   sml_desc: "",
//   desc: "",
//   img: "/PostCarousel/5.jpg",
//   side_img: "/PostCarousel/5.jpg",
//   read_more: "LIRE LA SuITE",
//   link: "/Posts/index.php?post=Shopping_Delights",
//   ctg: "jerusalem",
//   isVid: false,
//   forVidPage: true,
//   id: "Shopping_Delights",
// },
/* End Removed from request docsa Google Sheete */// End No translation
// {
//     "title": "Party Capital",
//     // "sml_desc": "Epic Nights in the non stop city",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/42.jpg",
//     "side_img": "/PostCarousel/42.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=42",
//     "isVid": false,
//     "ctg": "telaviv",
//     "id": "Party_Capital"
// },
// has ho translation' hadar said to hide untill she'll send the translation
// {
//     "title": "PLAGES SENSATIONNELLES",
//     // "sml_desc": "Come chill by the sunny beaches",
//     "sml_desc": "",
//     "desc": "",
//     "img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
//     "side_img": "/PostCarousel/TelAviv/sensational-beaches2.jpg",
//     "read_more": "LIRE LA SuITE",
//     "link": "/Posts/index.php?post=14",
//     "isVid": false,
//     "ctg": "telaviv",
//     //"id": 14
//     "id":"Sensational_Beaches"
// },
{title:"EFFERVESCENCE NON-STOP",// "sml_desc": "unforgettable Tel Aviv ",
sml_desc:"",desc:"",img:"/PostCarousel/TelAviv/nonstop-excitement2.jpg",side_img:"/PostCarousel/TelAviv/nonstop-excitement2.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Nonstop_Excitement",ctg:"telaviv",isVid:false,forVidPage:true,id:"Nonstop_Excitement"},// Eilat Posts
{title:"Neot Semadar",sml_desc:"",desc:"",img:"PostCarousel/Neot_Semadar.jpg",side_img:"PostCarousel/Neot_Semadar.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Neot_Semadar",css_class:"unic-post-Neot-Semadar",isVid:false,// vidId: "ZdnNT-GDJv4",
// "isVid": false,
forVidPage:false,isDouble:false,ctg:"eilat-negev",id:"Neot_Semadar"},{title:"EILAT",sml_desc:"",desc:"",img:"/PostCarousel/eilat1.jpg",side_img:"/PostCarousel/eilat1.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=EILAT1",css_class:"unic-post-EILAT1",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"EILAT1"},{title:" UN ÉTÉ SANS FIN",sml_desc:"",desc:"",img:"/PostCarousel/welcome-to-eilat.jpg",side_img:"/PostCarousel/welcome-to-eilat.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Welcome_To_Eilat",css_class:"unic-post-welcome-to-eilat",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Welcome_To_Eilat"},{title:"la destination de vacances idéale",sml_desc:"",desc:"",img:"/PostCarousel/the-ultimate-holiday.jpg",side_img:"/PostCarousel/the-ultimate-holiday.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=The_Ultimate_Holiday",css_class:"unic-post-the-ultimate-holiday",isVid:false,ctg:"eilat-negev",id:"The_Ultimate_Holiday"},// {
//  "title":"EILAT’S CALLING",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/eilat-calling.jpg",
//  "side_img":"/PostCarousel/eilat-calling.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Eilat_Calling",
//  "css_class":"unic-post-eilat-calling",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Eilat_Calling'
// },
{title:"LE RÉCIF DES DAUPHINS À EILAT",sml_desc:"",desc:"",img:"/PostCarousel/eilat-doolphin-reef.jpg",side_img:"/PostCarousel/eilat-doolphin-reef.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Eilat_Doolphin_Reef",css_class:"unic-post-eilat-doolphin-reef",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Eilat_Doolphin_Reef"},// {
//  "title":"Action Packed Eilat",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/action-packed-eilat.jpg",
//  "side_img":"/PostCarousel/action-packed-eilat.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Action_Packed_Eilat",
//  "css_class":"unic-post-action-packed-eilat",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Action_Packed_Eilat'
// },
{title:"FAITES LE GRAND PLONGEON",sml_desc:"",desc:"",img:"/PostCarousel/eilat-ultimate-beachside.jpg",side_img:"/PostCarousel/eilat-ultimate-beachside.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Eilat_Ultimate_Beachside",css_class:"unic-post-eilat-ultimate-beachside",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Eilat_Ultimate_Beachside"},// {
//  "title":"One Day in Eilat",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/one-day-in-eilat.jpg",
//  "side_img":"/PostCarousel/one-day-in-eilat.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=One_Day_In_Eilat",
//  "css_class":"unic-post-one-day-in-eilat",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'One_Day_In_Eilat'
// },
{title:"LE MAJESTUEUX DÉSERT D'ISRAËL",sml_desc:"",desc:"",img:"/PostCarousel/majestic-desert.jpg",side_img:"/PostCarousel/majestic-desert.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Majestic_Desert",css_class:"unic-post-majestic-desert",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Majestic_Desert"},{title:"ARAVA",sml_desc:"",desc:"",img:"/PostCarousel/ha-arava.jpg",side_img:"/PostCarousel/ha-arava.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Ha_Arava",css_class:"unic-post-ha-arava",isVid:false,ctg:"eilat-negev",id:"Ha_Arava"},{title:" LE DÉSERT ISRAÉLIEN",sml_desc:"",desc:"",img:"/PostCarousel/negev.jpg",side_img:"/PostCarousel/negev.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Negev1",css_class:"unic-post-negev",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Negev1"},{title:"LE NÉGUEV - COMMENT S’Y RENDRE?",sml_desc:"",desc:"",img:"/PostCarousel/location-and-approach.jpg",side_img:"/PostCarousel/location-and-approach.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Location_And_Approach",css_class:"unic-post-location-and-approach",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Location_And_Approach"},{title:"UN SÉJOUR DANS LE NÉGUEV",sml_desc:"",desc:"",img:"/PostCarousel/stay-in-the-negev.jpg",side_img:"/PostCarousel/stay-in-the-negev.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Stay_In_The_Negev",css_class:"unic-post-stay-in-the-negev",isVid:false,ctg:"eilat-negev",id:"Stay_In_The_Negev"},{title:"TOUT SIMPLEMENT MAGIQUE!",sml_desc:"",desc:"",img:"/PostCarousel/pure-desert-magic.jpg",side_img:"/PostCarousel/pure-desert-magic.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Pure_Desert_Magic",css_class:"unic-post-pure-desert-magic",isVid:false,ctg:"eilat-negev",id:"Pure_Desert_Magic"},{title:"ACTION FUN IN THE ISRAELI DESERT",sml_desc:"",desc:"",img:"/PostCarousel/action-fun-in-the-desert.jpg",side_img:"/PostCarousel/action-fun-in-the-desert.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Action_Fun_In_The_Desert",css_class:"unic-post-action-fun-in-the-desert",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Action_Fun_In_The_Desert"},{title:"LA ROUTE DE L'ENCENS",sml_desc:"",desc:"",img:"/PostCarousel/the-incense-route.jpg",side_img:"/PostCarousel/the-incense-route.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=The_Incense_Route",css_class:"unic-post-the-incense-route",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"The_Incense_Route"},// {
//  "title":"Mount Karkom",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/mount-karkom.jpg",
//  "side_img":"/PostCarousel/mount-karkom.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Mount_Karkom",
//  "css_class":"unic-post-mount-karkom",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Mount_Karkom'
// },
// {
//  "title":"Machtesh Ramon",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/machtes-ramon.jpg",
//  "side_img":"/PostCarousel/machtes-ramon.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Machtesh_Ramon",
//  "css_class":"unic-post-machtes-ramon",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Machtesh_Ramon'
// },
{title:"MASSADA",sml_desc:"",desc:"",img:"/PostCarousel/epic-masada.jpg",side_img:"/PostCarousel/epic-masada.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Epic_Masada",css_class:"unic-post-epic-masada",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Epic_Masada"},// {
//  "title":"The Bedouin Experience",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/the-bedouin-experience.jpg",
//  "side_img":"/PostCarousel/the-bedouin-experience.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=The_Bedouin_Experience",
//  "css_class":"unic-post-the-bedouin-experience",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'The_Bedouin_Experience'
// },
// {
//  "title":"The Israel National Trail",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/the-israel-national-trail.jpg",
//  "side_img":"/PostCarousel/the-israel-national-trail.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=The_Israel_National_Trail",
//  "css_class":"unic-post-the-israel-national-trail",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'The_Israel_National_Trail'
// },
{title:"LE PARC DE TIMNA",sml_desc:"",desc:"",img:"/PostCarousel/timna-treasures.jpg",side_img:"/PostCarousel/timna-treasures.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Timna_Treasures",css_class:"unic-post-timna-treasures",isVid:false,forVidPage:true,ctg:"eilat-negev",id:"Timna_Treasures"},{title:"DÉSERT DU NÉGUEV – À NE PAS MANQUER",sml_desc:"",desc:"",img:"/PostCarousel/negev-desert-dont-miss.jpg",side_img:"/PostCarousel/negev-desert-dont-miss.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Negev_Desert_Dont_Miss",css_class:"unic-post-negev-desert-dont-miss",isVid:false,ctg:"eilat-negev",id:"Negev_Desert_Dont_Miss"},// {
//  "title":"NEGEV CHARMS",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/negev-charms.jpg",
//  "side_img":"/PostCarousel/negev-charms.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Negev_Charms",
//  "css_class":"unic-post-negev-charms",
//  "isVid" : false,
//  "ctg"   : 'eilat-negev',
//   "id"    : 'Negev_Charms'
// },
// End Eilat Posts
// North Posts
// {
//  "title":"Galilee",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/galilee.jpg",
//  "side_img":"/PostCarousel/galilee.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Galilee",
//  "css_class":"unic-post-galilee",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'Galilee'
// },
{title:"DÉCOUVREZ LES JOYAUX CACHÉS DE GALILÉE",sml_desc:"",desc:"",img:"/PostCarousel/galilee1.jpg",side_img:"/PostCarousel/galilee1.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Galilee_1",css_class:"unic-post-galilee1",isVid:false,forVidPage:true,ctg:"north",id:"Galilee_1"},// {
//  "title":"Caesarea",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/caesarea.jpg",
//  "side_img":"/PostCarousel/caesarea.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Caesarea",
//  "css_class":"unic-post-caesarea",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'Caesarea'
// },
{title:"CÉSARÉE",sml_desc:"",desc:"",img:"/PostCarousel/caesarea.jpg",side_img:"/PostCarousel/caesarea.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Caesarea_1",css_class:"unic-post-caesarea1",isVid:false,forVidPage:true,ctg:"north",id:"Caesarea_1"},{title:"LA VIEILLE VILLE D'ACRE",sml_desc:"",desc:"",img:"/PostCarousel/acre.jpg",side_img:"/PostCarousel/acre.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Acre",css_class:"unic-post-acre",isVid:false,forVidPage:true,ctg:"north",id:"Acre"},// {
//  "title":"Haifa",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/haifa.jpg",
//  "side_img":"/PostCarousel/haifa.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Haifa",
//  "css_class":"unic-post-haifa",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'Haifa'
// },
{title:"HAÏFA",sml_desc:"",desc:"",img:"/PostCarousel/haifa.jpg",side_img:"/PostCarousel/haifa.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Haifa",css_class:"unic-post-haifa",isVid:false,forVidPage:true,ctg:"north",id:"Haifa_1"},{title:"SAFED – OÙ LE MYSTIQUE CÔTOIE LE TERRESTRE",sml_desc:"",desc:"",img:"/PostCarousel/safed.jpg",side_img:"/PostCarousel/safed.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Safed",css_class:"unic-post-safed",isVid:false,forVidPage:true,ctg:"north",id:"Safed"},// {
//  "title":"THE STUNNING BAHA’I GARDENS",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/bahai-gardens.jpg",
//  "side_img":"/PostCarousel/bahai-gardens.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=The_Bahai_Gardens",
//  "css_class":"unic-post-bahai-gardens",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'The_Bahai_Gardens'
// },
// {
//  "title":"The Sea of Galilee (Kinneret )",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/sea-of-galilee.jpg",
//  "side_img":"/PostCarousel/sea-of-galilee.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=The_Sea_Of_Galilee",
//  "css_class":"unic-post-sea-of-galilee",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'The_Sea_Of_Galilee'
// },
{title:"Rosh Pina",sml_desc:"",desc:"",img:"/PostCarousel/rosh-pina.jpg",side_img:"/PostCarousel/rosh-pina.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Rosh_Pina",css_class:"unic-post-rosh-pina",isVid:false,forVidPage:true,ctg:"north",id:"Rosh_Pina"},// {
//  "title":"Cheers to Israel",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/cheers-to-israel.jpg",
//  "side_img":"/PostCarousel/cheers-to-israel.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Cheers_To_Israel",
//  "css_class":"unic-post-cheers-to-israel",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'Cheers_To_Israel'
// },
{title:"DES VACANCES GASTRONOMIQUES EN GALILÉE",sml_desc:"",desc:"",img:"/PostCarousel/galilean-treat.jpg",side_img:"/PostCarousel/galilean-treat.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=A_Galilean_Treat",css_class:"unic-post-galilean-treat",isVid:false,forVidPage:true,ctg:"culinarynorth",id:"A_Galilean_Treat"},{title:"Nazareth",sml_desc:"",desc:"",img:"/PostCarousel/nazareth.jpg",side_img:"/PostCarousel/nazareth.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Nazareth",css_class:"unic-post-nazareth",isVid:false,forVidPage:true,ctg:"north",id:"Nazareth"},{title:"CÉSARÉE VOYAGEZ À TRAVERS LE TEMPS",sml_desc:"",desc:"",img:"/PostCarousel/caesarea.jpg",side_img:"/PostCarousel/caesarea.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Caesarea_2",css_class:"unic-post-caesarea2",isVid:false,forVidPage:true,ctg:"north",id:"Caesarea_2"},{title:"BOUGEZ EN GALILÉE",sml_desc:"",desc:"",img:"/PostCarousel/galilee-action.jpg",side_img:"/PostCarousel/galilee-action.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Galilee_Action",css_class:"unic-post-galilee-action",isVid:false,forVidPage:true,ctg:"north",id:"Galilee_Action"},// {
//  "title":"Bet She’an",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/bet-shean.jpg",
//  "side_img":"/PostCarousel/bet-shean.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Bet_Shean",
//  "css_class":"unic-post-bet-shean",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'Bet_Shean'
// },
// {
//  "title":"Zichron Ya’akov",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/zichron-yaakov.jpg",
//  "side_img":"/PostCarousel/zichron-yaakov.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Zichron_Yaakov",
//  "css_class":"unic-post-zichron-yaakov",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'Zichron_Yaakov'
// },
{title:"LA BEAUTÉ SOURCE D'INSPIRATION",sml_desc:"",desc:"",img:"/PostCarousel/haifa-beauty.jpg",side_img:"/PostCarousel/haifa-beauty.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Haifa_Beauty",css_class:"unic-post-Haifa_Beauty",isVid:false,ctg:"north",id:"Haifa_Beauty"},// {
//  "title":"Discover the Wine Routes",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/discover-the-wine-routes.jpg",
//  "side_img":"/PostCarousel/discover-the-wine-routes.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Discover_The_Wine_Routes",
//  "css_class":"unic-post-discover-the-wine-routes",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'Discover_The_Wine_Routes'
// },
{title:"UN JOYAU AUX MULTIPLES FACETTES",sml_desc:"",desc:"",img:"/PostCarousel/nazareth1.jpg",side_img:"/PostCarousel/nazareth1.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Nazareth",css_class:"unic-post-nazareth1",isVid:false,forVidPage:true,ctg:"north",id:"Nazareth_1"},{title:"LAC DE LA HOULA",sml_desc:"",desc:"",img:"/PostCarousel/birdtastic-hula-lake.jpg",side_img:"/PostCarousel/birdtastic-hula-lake.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Birdtastic_Hula_Lake",css_class:"unic-post-birdtastic-hula-lake",isVid:false,forVidPage:true,ctg:"north",id:"Birdtastic_Hula_Lake"},// not translated
// {
//  "title":"L'EXPÉRIENCE INCOMPARABLE DU KIBBOUTZ",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/kibbutz-experience.jpg",
//  "side_img":"/PostCarousel/kibbutz-experience.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=The_Kibbutz_Experience",
//  "css_class":"unic-post-kibbutz-experience",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'The_Kibbutz_Experience'
// },
// {
//  "title":"NATIONAL PARKS",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/national-parks.jpg",
//  "side_img":"/PostCarousel/national-parks.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=National_Parks",
//  "css_class":"unic-post-national-parks",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'National_Parks'
// },
// {
//  "title":"Tiberias (Tverya)",
//  "sml_desc":"",
//  "desc":"",
//  "img":"/PostCarousel/tiberias.jpg",
//  "side_img":"/PostCarousel/tiberias.jpg",
//  "read_more":"READ MORE",
//  "link": "/Posts/index.php?post=Tiberias",
//  "css_class":"unic-post-tiberias",
//  "isVid" : false,
//  "ctg"   : 'north',
//   "id"    : 'Tiberias'
// },
// These 2 posts doubled for complite the Jerusalem Carousel
{title:"La vieille ville",sml_desc:"",// "sml_desc": "Sentez l'histoire prendre vie",
desc:"",// "desc": "Laissez-vous inspirer par les trésors de la vieille ville de Jérusalem, connus dans le monde entier",
img:"Videos/m.jpg",img_mob:"/Videos/video_mob/m.jpg",side_img:"Videos/sidebar/m.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Jerusalem_Old_City",isVid:true,isDouble:true,vidId:"6eXJu1Yy4kg",ctg:"jerusalem",id:"Jerusalem_Old_City"},{title:"AVENUE MAMILLA",sml_desc:"",desc:"",img:"/PostCarousel/Jerusalem/mamila-avenue.jpg",side_img:"/PostCarousel/Jerusalem/mamila-avenue.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Mamilla_Avenue",isVid:false,forVidPage:true,isDouble:true,ctg:"jerusalem",id:"Mamilla_Avenue"},// End These 2 posts doubled for complite the Jerusalem Carousel
// This post doubled for complite the TEL AVIV Carousel
{title:"Une journée à Tel Aviv",sml_desc:"",// "sml_desc" : "Day isTrippin’",
desc:"",// "desc" : "Fabulous and fascinating one day in Tel Aviv",
img:"/PostCarousel/TelAviv/day-is-trippin.jpg",side_img:"/PostCarousel/TelAviv/day-is-trippin.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Day_IsTrippin",isVid:false,isDouble:true,ctg:"telaviv",id:"Day_IsTrippin"},// End this post doubled for complite the TEL AVIV Carousel
// These 2 posts doubled for complite the CULINARY Carousel
{title:"L’HEURE DE LA SHAKSHUKA",// "sml_desc": "Susshuka Zeit",
sml_desc:"",// "desc": "Lerne Sie, wie man das weltberühmte\n Shakshuka-Gericht zubereitet!",
desc:"",img:"/PostCarousel/22.jpg",img_mob:"/PostCarousel/video_mob/22.jpg",side_img:"/PostCarousel/22.jpg",read_more:"Weiterlesen",link:"/Posts/index.php?post=22",ctg:"culinary",vidId:"n4kCnPXEX7g",isVid:true,forVidPage:true,isDouble:true,id:"Shakshuka"},{// "title": "A Foodie’s Paradise‘",
title:"Paradis pour les gourmets",// "sml_desc": "Explorez l’impressionnante scène culinaire de Tel Aviv",
sml_desc:"",desc:"",img:"/PostCarousel/99.jpg",img_mob:"/PostCarousel/video_mob/99.jpg",side_img:"/PostCarousel/99.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=Simply_Delicious",ctg:"culinarytelaviv",vidId:"n4kCnPXEX7g",isVid:true,forVidPage:true,isDouble:true,id:"Simply_Delicious"},// End These 2 posts doubled for complite the CULINARY Carousel
// These 3 posts doubled for complite the NORTH Carousel
{title:"HAÏFA",sml_desc:"",desc:"",img:"/PostCarousel/haifa.jpg",side_img:"/PostCarousel/haifa.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Haifa",css_class:"unic-post-haifa",isVid:false,forVidPage:true,isDouble:true,ctg:"north",id:"Haifa_1"},{title:"DÉCOUVREZ LES JOYAUX CACHÉS DE GALILÉE",sml_desc:"",desc:"",img:"/PostCarousel/galilee1.jpg",side_img:"/PostCarousel/galilee1.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Galilee_1",css_class:"unic-post-galilee1",isVid:false,forVidPage:true,isDouble:true,ctg:"north",id:"Galilee_1"},{title:"CÉSARÉE VOYAGEZ À TRAVERS LE TEMPS",sml_desc:"",desc:"",img:"/PostCarousel/caesarea.jpg",side_img:"/PostCarousel/caesarea.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=Caesarea_2",css_class:"unic-post-caesarea2",isVid:false,forVidPage:true,isDouble:true,ctg:"north",id:"Caesarea_2"}];var TouristInfoPosts=[{title:"CE QU'IL FAUT EMPORTER",sml_desc:"",desc:"",img:"/PostCarousel/what-to-pack.jpg",side_img:"/PostCarousel/what-to-pack.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=20",css_class:"unic-post-what-to-pack",isVid:false,ctg:"TouristInfo",id:"What_To_Pack"},{title:"APPAREILS ÉLECTRIQUES",sml_desc:"",desc:"",img:"/PostCarousel/electrical-appliances.jpg",side_img:"/PostCarousel/electrical-appliances.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=20",css_class:"unic-post-electrical-appliances",isVid:false,ctg:"TouristInfo",id:"Electrical_Appliances"},{title:"LE CLIMAT",sml_desc:"",desc:"",img:"/PostCarousel/weather.jpg",side_img:"/PostCarousel/weather.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=20",css_class:"unic-post-weather",isVid:false,ctg:"TouristInfo",id:"Weather"},{title:"TRANSPORTS",sml_desc:"",desc:"",img:"/PostCarousel/transportation.jpg",side_img:"/PostCarousel/transportation.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=20",css_class:"unic-post-transportation",isVid:false,ctg:"TouristInfo",id:"Transportation"},{title:"FAQ",sml_desc:"",desc:"",img:"/PostCarousel/faq.jpg",side_img:"/PostCarousel/faq.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=20",css_class:"unic-post-faq",isVid:false,ctg:"TouristInfo",id:"Frequently_Asked_Questions"},{title:"MONNAIE ISRAÉLIENNE",sml_desc:"",desc:"",img:"/PostCarousel/israeli-currency.jpg",side_img:"/PostCarousel/israeli-currency.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=20",css_class:"unic-post-israeli-currency",isVid:false,ctg:"TouristInfo",id:"Israeli_Currency"},{title:"Immigration et douane",sml_desc:"",desc:"",img:"/PostCarousel/immigration-customs.jpg",side_img:"/PostCarousel/immigration-customs.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=20",css_class:"unic-post-immigration-customs",isVid:false,ctg:"TouristInfo",id:"Immigration_Customs"},{title:"PASSEPORTS ET VISA",sml_desc:"",desc:"",img:"/PostCarousel/Passports-visa.jpg",side_img:"/PostCarousel/Passports-visa.jpg",read_more:"LIRE LA SuITE",link:"/Posts/index.php?post=20",css_class:"unic-post-Passports-visa",isVid:false,ctg:"TouristInfo",id:"Passports_Visa"},{title:"UNE DESTINATION POUR TOUS",sml_desc:"",desc:"",img:"/PostCarousel/PlanYourTrip/destination-for-all.jpg",side_img:"/PostCarousel/PlanYourTrip/destination-for-all.jpg",read_more:"READ MORE",link:"/Posts/index.php?post=20",css_class:"unic-post-Passports-visa",isVid:true,ctg:"TouristInfo",id:"Destination_For_All"}];var Reminders=[// Tel Aviv
{quote:"One of the world's 25 best cities for foodies",site:"Business Insider",img:"/References/1.jpg",ctg:"Tel Aviv"},// Jerusalem
{quote:"TripAdvisor Traveler's Choice Award 2015",site:"TripAdvisor",img:"/References/9.jpg",ctg:"Jerusalem"},{quote:"One of the world's leading party cities",site:"Telegraph",img:"/References/2.jpg",ctg:"Tel Aviv"},{quote:"One of the cities with most beautiful people",site:"Conde Nast",img:"/References/3.jpg",ctg:"Tel Aviv"},{quote:"One of the 20 must visit destinations in the world  TNS",site:"The National Student",img:"/References/10.jpg",ctg:"Jerusalem"},{quote:"One of the best beach party spots on the planet",site:"USA Today",img:"/References/4.jpg",ctg:"Tel Aviv"},{quote:"One of the world's top 10 beach cities",site:"National Geographic",img:"/References/5.jpg",ctg:"Tel Aviv"},{quote:"3rd Of 6 Top world’s holiest sites",site:"National Geographic",img:"/References/11.jpg",ctg:"Jerusalem"},{quote:"One of the world's top ten cities",site:"Lonely Planet",img:"/References/6.jpg",ctg:"Tel Aviv"},{quote:"One of the world's top ten hedonistic city breaks ",site:"Lonely Planet",img:"/References/7.jpg",ctg:"Tel Aviv"},{quote:"I just thought it was magical… It instantly turned into my favorite trip.",site:"TripAdvisor",img:"/References/12.jpg",ctg:"Jerusalem",job:"CEO, Stephen Kaufer about Jerusalem",cssClass:"make-it-smller"},{quote:"The World’s New Dining Hotspot",site:"Bloomberg.com",img:"/References/8.jpg",ctg:"Tel Aviv"}];

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line no-undef
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  check(typeof self == 'object' && self) ||
  check(typeof global == 'object' && global) ||
  // eslint-disable-next-line no-new-func
  Function('return this')();

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(97);
var isBuffer = __webpack_require__(195);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var shared = __webpack_require__(70);
var has = __webpack_require__(10);
var uid = __webpack_require__(41);
var NATIVE_SYMBOL = __webpack_require__(76);
var USE_SYMBOL_AS_UID = __webpack_require__(127);

var WellKnownSymbolsStore = shared('wks');
var Symbol = global.Symbol;
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!has(WellKnownSymbolsStore, name)) {
    if (NATIVE_SYMBOL && has(Symbol, name)) WellKnownSymbolsStore[name] = Symbol[name];
    else WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),
/* 10 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;

module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 11 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(160);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(168);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(87);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(169);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(171);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(173);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(175);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(88);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(50);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(177);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(179);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(181);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(182);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(183);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var IE8_DOM_DEFINE = __webpack_require__(66);
var anObject = __webpack_require__(19);
var toPrimitive = __webpack_require__(65);

var nativeDefineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.github.io/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? nativeDefineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return nativeDefineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

// Thank's IE8 for his funny defineProperty
module.exports = !fails(function () {
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var definePropertyModule = __webpack_require__(15);
var createPropertyDescriptor = __webpack_require__(36);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

module.exports = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(153);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(167);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var createNonEnumerableProperty = __webpack_require__(18);
var has = __webpack_require__(10);
var setGlobal = __webpack_require__(38);
var inspectSource = __webpack_require__(68);
var InternalStateModule = __webpack_require__(28);

var getInternalState = InternalStateModule.get;
var enforceInternalState = InternalStateModule.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) createNonEnumerableProperty(value, 'name', key);
    enforceInternalState(value).source = TEMPLATE.join(typeof key == 'string' ? key : '');
  }
  if (O === global) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});


/***/ }),
/* 25 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_slick_carousel_slick_slick_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_slick_carousel_slick_slick_theme_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__SimpleSlider_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// note 
// npm install react-slick
// npm install slick-carousel
// https://github.com/akiran/react-slick
/**
  use 

  import SimpleSlider from './components/SimpleSlider/SimpleSlider';
  
 <SimpleSlider settings={customSliderSettings}>
      <div><h3>Hey Man 1</h3></div>
      <div><h3>Hey Man 2</h3></div>
      <div><h3>Hey Man 3</h3></div>
      <div><h3>Hey Man 4 </h3></div>
      <div><h3>Hey Man 5 </h3></div>
      <div><h3>Hey Man  6 </h3></div>
       </SimpleSlider>
*/var SimpleSlider=function(_Component){_inherits(SimpleSlider,_Component);function SimpleSlider(props){_classCallCheck(this,SimpleSlider);var _this=_possibleConstructorReturn(this,(SimpleSlider.__proto__||Object.getPrototypeOf(SimpleSlider)).call(this,props));_this.settings=Object.assign({accessibility:false,autoplay:false,dots:true,infinite:true,speed:500,slidesToShow:1,slidesToScroll:1},_this.props.settings);return _this;}_createClass(SimpleSlider,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'Slider-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_slick___default.a,this.settings,this.props.children));}}]);return SimpleSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SimpleSlider);

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(117);
var requireObjectCoercible = __webpack_require__(37);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_WEAK_MAP = __webpack_require__(118);
var global = __webpack_require__(7);
var isObject = __webpack_require__(14);
var createNonEnumerableProperty = __webpack_require__(18);
var objectHas = __webpack_require__(10);
var sharedKey = __webpack_require__(39);
var hiddenKeys = __webpack_require__(29);

var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP) {
  var store = new WeakMap();
  var wmget = store.get;
  var wmhas = store.has;
  var wmset = store.set;
  set = function (it, metadata) {
    wmset.call(store, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store, it) || {};
  };
  has = function (it) {
    return wmhas.call(store, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return objectHas(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return objectHas(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 30 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(32);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(93);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(56);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var scrollOffset = _utils2.default.scrollOffset(containerElement, target) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        window.scrollTo(0, scrollOffset);
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var pushHash = function pushHash(hash) {
  hash = hash ? hash.indexOf("#") === 0 ? hash : "#" + hash : "";

  if (history.pushState) {
    var loc = window.location;
    history.pushState(null, null, hash ? loc.pathname + loc.search + hash : // remove hash
    loc.pathname + loc.search);
  } else {
    location.hash = hash;
  }
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var scrollOffset = function scrollOffset(c, t) {
  return c === document ? t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) : getComputedStyle(c).position !== "static" ? t.offsetTop : t.offsetTop - c.offsetTop;
};
exports.default = {
  pushHash: pushHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 36 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 37 */
/***/ (function(module, exports) {

// `RequireObjectCoercible` abstract operation
// https://tc39.github.io/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var createNonEnumerableProperty = __webpack_require__(18);

module.exports = function (key, value) {
  try {
    createNonEnumerableProperty(global, key, value);
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(70);
var uid = __webpack_require__(41);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var id = 0;
var postfix = Math.random();

module.exports = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var path = __webpack_require__(43);
var global = __webpack_require__(7);

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global[namespace])
    : path[namespace] && path[namespace][method] || global[namespace] && global[namespace][method];
};


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);

module.exports = global;


/***/ }),
/* 44 */
/***/ (function(module, exports) {

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.github.io/ecma262/#sec-tointeger
module.exports = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};


/***/ }),
/* 45 */
/***/ (function(module, exports) {

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(15).f;
var has = __webpack_require__(10);
var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG)) {
    defineProperty(it, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var defineProperties = __webpack_require__(134);
var enumBugKeys = __webpack_require__(45);
var hiddenKeys = __webpack_require__(29);
var html = __webpack_require__(136);
var documentCreateElement = __webpack_require__(67);
var sharedKey = __webpack_require__(39);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.github.io/ecma262/#sec-object.create
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : defineProperties(result, Properties);
};


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(62);
var createIteratorConstructor = __webpack_require__(138);
var getPrototypeOf = __webpack_require__(83);
var setPrototypeOf = __webpack_require__(80);
var setToStringTag = __webpack_require__(47);
var createNonEnumerableProperty = __webpack_require__(18);
var redefine = __webpack_require__(24);
var wellKnownSymbol = __webpack_require__(9);
var IS_PURE = __webpack_require__(40);
var Iterators = __webpack_require__(25);
var IteratorsCore = __webpack_require__(82);

var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (typeof CurrentIteratorPrototype[ITERATOR] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR, defaultIterator);
  }
  Iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(51);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(54);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(31);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(94);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  spy: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (y) {

      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var to = _this2.props.to;
      var element = null;
      var elemTopBound = 0;
      var elemBottomBound = 0;
      var containerTop = 0;

      if (scrollSpyContainer.getBoundingClientRect) {
        var containerCords = scrollSpyContainer.getBoundingClientRect();
        containerTop = containerCords.top;
      }

      if (!element || _this2.props.isDynamic) {
        element = scroller.get(to);
        if (!element) {
          return;
        }

        var cords = element.getBoundingClientRect();
        elemTopBound = cords.top - containerTop + y;
        elemBottomBound = elemTopBound + cords.height;
      }

      var offsetY = y - _this2.props.offset;
      var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
      var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          _scrollHash2.default.changeHash();
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(188);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(55);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps
var eventThrottler = function eventThrottler(eventHandler) {
  return (0, _lodash2.default)(eventHandler, 66);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      });
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(194);

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(8);
var normalizeHeaderName = __webpack_require__(197);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(98);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(98);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forceCheck = exports.lazyload = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _event = __webpack_require__(211);

var _scrollParent = __webpack_require__(212);

var _scrollParent2 = _interopRequireDefault(_scrollParent);

var _debounce = __webpack_require__(213);

var _debounce2 = _interopRequireDefault(_debounce);

var _throttle = __webpack_require__(214);

var _throttle2 = _interopRequireDefault(_throttle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * react-lazyload
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var defaultBoundingClientRect = { top: 0, right: 0, bottom: 0, left: 0, width: 0, height: 0 };
var LISTEN_FLAG = 'data-lazyload-listened';
var listeners = [];
var pending = [];

// try to handle passive events
var passiveEventSupported = false;
try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      passiveEventSupported = true;
    }
  });
  window.addEventListener('test', null, opts);
} catch (e) {}
// if they are supported, setup the optional params
// IMPORTANT: FALSE doubles as the default CAPTURE value!
var passiveEvent = passiveEventSupported ? { capture: false, passive: true } : false;

/**
 * Check if `component` is visible in overflow container `parent`
 * @param  {node} component React component
 * @param  {node} parent    component's scroll parent
 * @return {bool}
 */
var checkOverflowVisible = function checkOverflowVisible(component, parent) {
  var node = _reactDom2.default.findDOMNode(component);

  var parentTop = void 0;
  var parentLeft = void 0;
  var parentHeight = void 0;
  var parentWidth = void 0;

  try {
    var _parent$getBoundingCl = parent.getBoundingClientRect();

    parentTop = _parent$getBoundingCl.top;
    parentLeft = _parent$getBoundingCl.left;
    parentHeight = _parent$getBoundingCl.height;
    parentWidth = _parent$getBoundingCl.width;
  } catch (e) {
    parentTop = defaultBoundingClientRect.top;
    parentLeft = defaultBoundingClientRect.left;
    parentHeight = defaultBoundingClientRect.height;
    parentWidth = defaultBoundingClientRect.width;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;
  var windowInnerWidth = window.innerWidth || document.documentElement.clientWidth;

  // calculate top and height of the intersection of the element's scrollParent and viewport
  var intersectionTop = Math.max(parentTop, 0); // intersection's top relative to viewport
  var intersectionLeft = Math.max(parentLeft, 0); // intersection's left relative to viewport
  var intersectionHeight = Math.min(windowInnerHeight, parentTop + parentHeight) - intersectionTop; // height
  var intersectionWidth = Math.min(windowInnerWidth, parentLeft + parentWidth) - intersectionLeft; // width

  // check whether the element is visible in the intersection
  var top = void 0;
  var left = void 0;
  var height = void 0;
  var width = void 0;

  try {
    var _node$getBoundingClie = node.getBoundingClientRect();

    top = _node$getBoundingClie.top;
    left = _node$getBoundingClie.left;
    height = _node$getBoundingClie.height;
    width = _node$getBoundingClie.width;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    left = defaultBoundingClientRect.left;
    height = defaultBoundingClientRect.height;
    width = defaultBoundingClientRect.width;
  }

  var offsetTop = top - intersectionTop; // element's top relative to intersection
  var offsetLeft = left - intersectionLeft; // element's left relative to intersection

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return offsetTop - offsets[0] <= intersectionHeight && offsetTop + height + offsets[1] >= 0 && offsetLeft - offsets[0] <= intersectionWidth && offsetLeft + width + offsets[1] >= 0;
};

/**
 * Check if `component` is visible in document
 * @param  {node} component React component
 * @return {bool}
 */
var checkNormalVisible = function checkNormalVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);

  // If this element is hidden by css rules somehow, it's definitely invisible
  if (!(node.offsetWidth || node.offsetHeight || node.getClientRects().length)) return false;

  var top = void 0;
  var elementHeight = void 0;

  try {
    var _node$getBoundingClie2 = node.getBoundingClientRect();

    top = _node$getBoundingClie2.top;
    elementHeight = _node$getBoundingClie2.height;
  } catch (e) {
    top = defaultBoundingClientRect.top;
    elementHeight = defaultBoundingClientRect.height;
  }

  var windowInnerHeight = window.innerHeight || document.documentElement.clientHeight;

  var offsets = Array.isArray(component.props.offset) ? component.props.offset : [component.props.offset, component.props.offset]; // Be compatible with previous API

  return top - offsets[0] <= windowInnerHeight && top + elementHeight + offsets[1] >= 0;
};

/**
 * Detect if element is visible in viewport, if so, set `visible` state to true.
 * If `once` prop is provided true, remove component as listener after checkVisible
 *
 * @param  {React} component   React component that respond to scroll and resize
 */
var checkVisible = function checkVisible(component) {
  var node = _reactDom2.default.findDOMNode(component);
  if (!(node instanceof HTMLElement)) {
    return;
  }

  var parent = (0, _scrollParent2.default)(node);
  var isOverflow = component.props.overflow && parent !== node.ownerDocument && parent !== document && parent !== document.documentElement;
  var visible = isOverflow ? checkOverflowVisible(component, parent) : checkNormalVisible(component);
  if (visible) {
    // Avoid extra render if previously is visible
    if (!component.visible) {
      if (component.props.once) {
        pending.push(component);
      }

      component.visible = true;
      component.forceUpdate();
    }
  } else if (!(component.props.once && component.visible)) {
    component.visible = false;
    if (component.props.unmountIfInvisible) {
      component.forceUpdate();
    }
  }
};

var purgePending = function purgePending() {
  pending.forEach(function (component) {
    var index = listeners.indexOf(component);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
  });

  pending = [];
};

var lazyLoadHandler = function lazyLoadHandler() {
  for (var i = 0; i < listeners.length; ++i) {
    var listener = listeners[i];
    checkVisible(listener);
  }
  // Remove `once` component in listeners
  purgePending();
};

// Depending on component's props
var delayType = void 0;
var finalLazyLoadHandler = null;

var isString = function isString(string) {
  return typeof string === 'string';
};

var LazyLoad = function (_Component) {
  _inherits(LazyLoad, _Component);

  function LazyLoad(props) {
    _classCallCheck(this, LazyLoad);

    var _this = _possibleConstructorReturn(this, (LazyLoad.__proto__ || Object.getPrototypeOf(LazyLoad)).call(this, props));

    _this.visible = false;
    return _this;
  }

  _createClass(LazyLoad, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // It's unlikely to change delay type on the fly, this is mainly
      // designed for tests
      var scrollport = window;
      var scrollContainer = this.props.scrollContainer;

      if (scrollContainer) {
        if (isString(scrollContainer)) {
          scrollport = scrollport.document.querySelector(scrollContainer);
        }
      }
      var needResetFinalLazyLoadHandler = this.props.debounce !== undefined && delayType === 'throttle' || delayType === 'debounce' && this.props.debounce === undefined;

      if (needResetFinalLazyLoadHandler) {
        (0, _event.off)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        finalLazyLoadHandler = null;
      }

      if (!finalLazyLoadHandler) {
        if (this.props.debounce !== undefined) {
          finalLazyLoadHandler = (0, _debounce2.default)(lazyLoadHandler, typeof this.props.debounce === 'number' ? this.props.debounce : 300);
          delayType = 'debounce';
        } else if (this.props.throttle !== undefined) {
          finalLazyLoadHandler = (0, _throttle2.default)(lazyLoadHandler, typeof this.props.throttle === 'number' ? this.props.throttle : 300);
          delayType = 'throttle';
        } else {
          finalLazyLoadHandler = lazyLoadHandler;
        }
      }

      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = 1 + +parent.getAttribute(LISTEN_FLAG);
          if (listenerCount === 1) {
            parent.addEventListener('scroll', finalLazyLoadHandler, passiveEvent);
          }
          parent.setAttribute(LISTEN_FLAG, listenerCount);
        }
      } else if (listeners.length === 0 || needResetFinalLazyLoadHandler) {
        var _props = this.props,
            scroll = _props.scroll,
            resize = _props.resize;


        if (scroll) {
          (0, _event.on)(scrollport, 'scroll', finalLazyLoadHandler, passiveEvent);
        }

        if (resize) {
          (0, _event.on)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        }
      }

      listeners.push(this);
      checkVisible(this);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate() {
      return this.visible;
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this.props.overflow) {
        var parent = (0, _scrollParent2.default)(_reactDom2.default.findDOMNode(this));
        if (parent && typeof parent.getAttribute === 'function') {
          var listenerCount = +parent.getAttribute(LISTEN_FLAG) - 1;
          if (listenerCount === 0) {
            parent.removeEventListener('scroll', finalLazyLoadHandler, passiveEvent);
            parent.removeAttribute(LISTEN_FLAG);
          } else {
            parent.setAttribute(LISTEN_FLAG, listenerCount);
          }
        }
      }

      var index = listeners.indexOf(this);
      if (index !== -1) {
        listeners.splice(index, 1);
      }

      if (listeners.length === 0 && typeof window !== 'undefined') {
        (0, _event.off)(window, 'resize', finalLazyLoadHandler, passiveEvent);
        (0, _event.off)(window, 'scroll', finalLazyLoadHandler, passiveEvent);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.visible ? this.props.children : this.props.placeholder ? this.props.placeholder : _react2.default.createElement('div', { style: { height: this.props.height }, className: 'lazyload-placeholder' });
    }
  }]);

  return LazyLoad;
}(_react.Component);

LazyLoad.propTypes = {
  once: _propTypes2.default.bool,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  offset: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.arrayOf(_propTypes2.default.number)]),
  overflow: _propTypes2.default.bool,
  resize: _propTypes2.default.bool,
  scroll: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  throttle: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  debounce: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.bool]),
  placeholder: _propTypes2.default.node,
  scrollContainer: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]),
  unmountIfInvisible: _propTypes2.default.bool
};

LazyLoad.defaultProps = {
  once: false,
  offset: 0,
  overflow: false,
  resize: false,
  scroll: true,
  unmountIfInvisible: false
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

var decorator = function decorator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function lazyload(WrappedComponent) {
    return function (_Component2) {
      _inherits(LazyLoadDecorated, _Component2);

      function LazyLoadDecorated() {
        _classCallCheck(this, LazyLoadDecorated);

        var _this2 = _possibleConstructorReturn(this, (LazyLoadDecorated.__proto__ || Object.getPrototypeOf(LazyLoadDecorated)).call(this));

        _this2.displayName = 'LazyLoad' + getDisplayName(WrappedComponent);
        return _this2;
      }

      _createClass(LazyLoadDecorated, [{
        key: 'render',
        value: function render() {
          return _react2.default.createElement(
            LazyLoad,
            options,
            _react2.default.createElement(WrappedComponent, this.props)
          );
        }
      }]);

      return LazyLoadDecorated;
    }(_react.Component);
  };
};

exports.lazyload = decorator;
exports.default = LazyLoad;
exports.forceCheck = lazyLoadHandler;

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(110);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(62);
var global = __webpack_require__(7);
var isForced = __webpack_require__(73);
var redefine = __webpack_require__(24);
var InternalMetadataModule = __webpack_require__(74);
var iterate = __webpack_require__(75);
var anInstance = __webpack_require__(79);
var isObject = __webpack_require__(14);
var fails = __webpack_require__(13);
var checkCorrectnessOfIteration = __webpack_require__(131);
var setToStringTag = __webpack_require__(47);
var inheritIfRequired = __webpack_require__(132);

module.exports = function (CONSTRUCTOR_NAME, wrapper, common) {
  var IS_MAP = CONSTRUCTOR_NAME.indexOf('Map') !== -1;
  var IS_WEAK = CONSTRUCTOR_NAME.indexOf('Weak') !== -1;
  var ADDER = IS_MAP ? 'set' : 'add';
  var NativeConstructor = global[CONSTRUCTOR_NAME];
  var NativePrototype = NativeConstructor && NativeConstructor.prototype;
  var Constructor = NativeConstructor;
  var exported = {};

  var fixMethod = function (KEY) {
    var nativeMethod = NativePrototype[KEY];
    redefine(NativePrototype, KEY,
      KEY == 'add' ? function add(value) {
        nativeMethod.call(this, value === 0 ? 0 : value);
        return this;
      } : KEY == 'delete' ? function (key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'get' ? function get(key) {
        return IS_WEAK && !isObject(key) ? undefined : nativeMethod.call(this, key === 0 ? 0 : key);
      } : KEY == 'has' ? function has(key) {
        return IS_WEAK && !isObject(key) ? false : nativeMethod.call(this, key === 0 ? 0 : key);
      } : function set(key, value) {
        nativeMethod.call(this, key === 0 ? 0 : key, value);
        return this;
      }
    );
  };

  // eslint-disable-next-line max-len
  if (isForced(CONSTRUCTOR_NAME, typeof NativeConstructor != 'function' || !(IS_WEAK || NativePrototype.forEach && !fails(function () {
    new NativeConstructor().entries().next();
  })))) {
    // create collection constructor
    Constructor = common.getConstructor(wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER);
    InternalMetadataModule.REQUIRED = true;
  } else if (isForced(CONSTRUCTOR_NAME, true)) {
    var instance = new Constructor();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~ Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    // eslint-disable-next-line no-new
    var ACCEPT_ITERABLES = checkCorrectnessOfIteration(function (iterable) { new NativeConstructor(iterable); });
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new NativeConstructor();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });

    if (!ACCEPT_ITERABLES) {
      Constructor = wrapper(function (dummy, iterable) {
        anInstance(dummy, Constructor, CONSTRUCTOR_NAME);
        var that = inheritIfRequired(new NativeConstructor(), dummy, Constructor);
        if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
        return that;
      });
      Constructor.prototype = NativePrototype;
      NativePrototype.constructor = Constructor;
    }

    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }

    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);

    // weak collections should not contains .clear method
    if (IS_WEAK && NativePrototype.clear) delete NativePrototype.clear;
  }

  exported[CONSTRUCTOR_NAME] = Constructor;
  $({ global: true, forced: Constructor != NativeConstructor }, exported);

  setToStringTag(Constructor, CONSTRUCTOR_NAME);

  if (!IS_WEAK) common.setStrong(Constructor, CONSTRUCTOR_NAME, IS_MAP);

  return Constructor;
};


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var getOwnPropertyDescriptor = __webpack_require__(63).f;
var createNonEnumerableProperty = __webpack_require__(18);
var redefine = __webpack_require__(24);
var setGlobal = __webpack_require__(38);
var copyConstructorProperties = __webpack_require__(119);
var isForced = __webpack_require__(73);

/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var propertyIsEnumerableModule = __webpack_require__(116);
var createPropertyDescriptor = __webpack_require__(36);
var toIndexedObject = __webpack_require__(27);
var toPrimitive = __webpack_require__(65);
var has = __webpack_require__(10);
var IE8_DOM_DEFINE = __webpack_require__(66);

var nativeGetOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? nativeGetOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return nativeGetOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!propertyIsEnumerableModule.f.call(O, P), O[P]);
};


/***/ }),
/* 64 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

// `ToPrimitive` abstract operation
// https://tc39.github.io/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var fails = __webpack_require__(13);
var createElement = __webpack_require__(67);

// Thank's IE8 for his funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var isObject = __webpack_require__(14);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(69);

var functionToString = Function.toString;

// this helper broken in `3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof store.inspectSource != 'function') {
  store.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

module.exports = store.inspectSource;


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var setGlobal = __webpack_require__(38);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || setGlobal(SHARED, {});

module.exports = store;


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var IS_PURE = __webpack_require__(40);
var store = __webpack_require__(69);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.6.4',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(10);
var toIndexedObject = __webpack_require__(27);
var indexOf = __webpack_require__(122).indexOf;
var hiddenKeys = __webpack_require__(29);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(44);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.github.io/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var hiddenKeys = __webpack_require__(29);
var isObject = __webpack_require__(14);
var has = __webpack_require__(10);
var defineProperty = __webpack_require__(15).f;
var uid = __webpack_require__(41);
var FREEZING = __webpack_require__(125);

var METADATA = uid('meta');
var id = 0;

var isExtensible = Object.isExtensible || function () {
  return true;
};

var setMetadata = function (it) {
  defineProperty(it, METADATA, { value: {
    objectID: 'O' + ++id, // object ID
    weakData: {}          // weak collections IDs
  } });
};

var fastKey = function (it, create) {
  // return a primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMetadata(it);
  // return object ID
  } return it[METADATA].objectID;
};

var getWeakData = function (it, create) {
  if (!has(it, METADATA)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMetadata(it);
  // return the store of weak collections IDs
  } return it[METADATA].weakData;
};

// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZING && meta.REQUIRED && isExtensible(it) && !has(it, METADATA)) setMetadata(it);
  return it;
};

var meta = module.exports = {
  REQUIRED: false,
  fastKey: fastKey,
  getWeakData: getWeakData,
  onFreeze: onFreeze
};

hiddenKeys[METADATA] = true;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var isArrayIteratorMethod = __webpack_require__(126);
var toLength = __webpack_require__(72);
var bind = __webpack_require__(77);
var getIteratorMethod = __webpack_require__(129);
var callWithSafeIterationClosing = __webpack_require__(130);

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var iterate = module.exports = function (iterable, fn, that, AS_ENTRIES, IS_ITERATOR) {
  var boundFunction = bind(fn, that, AS_ENTRIES ? 2 : 1);
  var iterator, iterFn, index, length, result, next, step;

  if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (typeof iterFn != 'function') throw TypeError('Target is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = toLength(iterable.length); length > index; index++) {
        result = AS_ENTRIES
          ? boundFunction(anObject(step = iterable[index])[0], step[1])
          : boundFunction(iterable[index]);
        if (result && result instanceof Result) return result;
      } return new Result(false);
    }
    iterator = iterFn.call(iterable);
  }

  next = iterator.next;
  while (!(step = next.call(iterator)).done) {
    result = callWithSafeIterationClosing(iterator, boundFunction, step.value, AS_ENTRIES);
    if (typeof result == 'object' && result && result instanceof Result) return result;
  } return new Result(false);
};

iterate.stop = function (result) {
  return new Result(true, result);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  // Chrome 38 Symbol has incorrect toString conversion
  // eslint-disable-next-line no-undef
  return !String(Symbol());
});


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var aFunction = __webpack_require__(128);

// optional / simple context binding
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(46);
var classofRaw = __webpack_require__(64);
var wellKnownSymbol = __webpack_require__(9);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name) {
  if (!(it instanceof Constructor)) {
    throw TypeError('Incorrect ' + (name ? name + ' ' : '') + 'invocation');
  } return it;
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);
var aPossiblePrototype = __webpack_require__(133);

// `Object.setPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var defineProperty = __webpack_require__(15).f;
var create = __webpack_require__(48);
var redefineAll = __webpack_require__(137);
var bind = __webpack_require__(77);
var anInstance = __webpack_require__(79);
var iterate = __webpack_require__(75);
var defineIterator = __webpack_require__(49);
var setSpecies = __webpack_require__(141);
var DESCRIPTORS = __webpack_require__(17);
var fastKey = __webpack_require__(74).fastKey;
var InternalStateModule = __webpack_require__(28);

var setInternalState = InternalStateModule.set;
var internalStateGetterFor = InternalStateModule.getterFor;

module.exports = {
  getConstructor: function (wrapper, CONSTRUCTOR_NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, CONSTRUCTOR_NAME);
      setInternalState(that, {
        type: CONSTRUCTOR_NAME,
        index: create(null),
        first: undefined,
        last: undefined,
        size: 0
      });
      if (!DESCRIPTORS) that.size = 0;
      if (iterable != undefined) iterate(iterable, that[ADDER], that, IS_MAP);
    });

    var getInternalState = internalStateGetterFor(CONSTRUCTOR_NAME);

    var define = function (that, key, value) {
      var state = getInternalState(that);
      var entry = getEntry(that, key);
      var previous, index;
      // change existing entry
      if (entry) {
        entry.value = value;
      // create new entry
      } else {
        state.last = entry = {
          index: index = fastKey(key, true),
          key: key,
          value: value,
          previous: previous = state.last,
          next: undefined,
          removed: false
        };
        if (!state.first) state.first = entry;
        if (previous) previous.next = entry;
        if (DESCRIPTORS) state.size++;
        else that.size++;
        // add to index
        if (index !== 'F') state.index[index] = entry;
      } return that;
    };

    var getEntry = function (that, key) {
      var state = getInternalState(that);
      // fast case
      var index = fastKey(key);
      var entry;
      if (index !== 'F') return state.index[index];
      // frozen object case
      for (entry = state.first; entry; entry = entry.next) {
        if (entry.key == key) return entry;
      }
    };

    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        var that = this;
        var state = getInternalState(that);
        var data = state.index;
        var entry = state.first;
        while (entry) {
          entry.removed = true;
          if (entry.previous) entry.previous = entry.previous.next = undefined;
          delete data[entry.index];
          entry = entry.next;
        }
        state.first = state.last = undefined;
        if (DESCRIPTORS) state.size = 0;
        else that.size = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = this;
        var state = getInternalState(that);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.next;
          var prev = entry.previous;
          delete state.index[entry.index];
          entry.removed = true;
          if (prev) prev.next = next;
          if (next) next.previous = prev;
          if (state.first == entry) state.first = next;
          if (state.last == entry) state.last = prev;
          if (DESCRIPTORS) state.size--;
          else that.size--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        var state = getInternalState(this);
        var boundFunction = bind(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.next : state.first) {
          boundFunction(entry.value, entry.key, this);
          // revert to the last existing entry
          while (entry && entry.removed) entry = entry.previous;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(this, key);
      }
    });

    redefineAll(C.prototype, IS_MAP ? {
      // 23.1.3.6 Map.prototype.get(key)
      get: function get(key) {
        var entry = getEntry(this, key);
        return entry && entry.value;
      },
      // 23.1.3.9 Map.prototype.set(key, value)
      set: function set(key, value) {
        return define(this, key === 0 ? 0 : key, value);
      }
    } : {
      // 23.2.3.1 Set.prototype.add(value)
      add: function add(value) {
        return define(this, value = value === 0 ? 0 : value, value);
      }
    });
    if (DESCRIPTORS) defineProperty(C.prototype, 'size', {
      get: function () {
        return getInternalState(this).size;
      }
    });
    return C;
  },
  setStrong: function (C, CONSTRUCTOR_NAME, IS_MAP) {
    var ITERATOR_NAME = CONSTRUCTOR_NAME + ' Iterator';
    var getInternalCollectionState = internalStateGetterFor(CONSTRUCTOR_NAME);
    var getInternalIteratorState = internalStateGetterFor(ITERATOR_NAME);
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    defineIterator(C, CONSTRUCTOR_NAME, function (iterated, kind) {
      setInternalState(this, {
        type: ITERATOR_NAME,
        target: iterated,
        state: getInternalCollectionState(iterated),
        kind: kind,
        last: undefined
      });
    }, function () {
      var state = getInternalIteratorState(this);
      var kind = state.kind;
      var entry = state.last;
      // revert to the last existing entry
      while (entry && entry.removed) entry = entry.previous;
      // get next entry
      if (!state.target || !(state.last = entry = entry ? entry.next : state.state.first)) {
        // or finish the iteration
        state.target = undefined;
        return { value: undefined, done: true };
      }
      // return step by kind
      if (kind == 'keys') return { value: entry.key, done: false };
      if (kind == 'values') return { value: entry.value, done: false };
      return { value: [entry.key, entry.value], done: false };
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(CONSTRUCTOR_NAME);
  }
};


/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getPrototypeOf = __webpack_require__(83);
var createNonEnumerableProperty = __webpack_require__(18);
var has = __webpack_require__(10);
var wellKnownSymbol = __webpack_require__(9);
var IS_PURE = __webpack_require__(40);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.github.io/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

if (IteratorPrototype == undefined) IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
if (!IS_PURE && !has(IteratorPrototype, ITERATOR)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR, returnThis);
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(10);
var toObject = __webpack_require__(139);
var sharedKey = __webpack_require__(39);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(140);

var IE_PROTO = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.github.io/ecma262/#sec-object.getprototypeof
module.exports = CORRECT_PROTOTYPE_GETTER ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};


/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

var TO_STRING_TAG_SUPPORT = __webpack_require__(46);
var redefine = __webpack_require__(24);
var toString = __webpack_require__(142);

// `Object.prototype.toString` method
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  redefine(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var charAt = __webpack_require__(143).charAt;
var InternalStateModule = __webpack_require__(28);
var defineIterator = __webpack_require__(49);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt(string, index);
  state.index += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var DOMIterables = __webpack_require__(144);
var ArrayIteratorMethods = __webpack_require__(145);
var createNonEnumerableProperty = __webpack_require__(18);
var wellKnownSymbol = __webpack_require__(9);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

for (var COLLECTION_NAME in DOMIterables) {
  var Collection = global[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(89);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(52);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(172)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(187);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(191);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(192);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(31);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(56);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(54);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(93);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(53);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(95);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(193);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(32);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(189);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(190);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(56);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPositionY: 0,
    startPositionY: 0,
    targetPositionY: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    deltaTop: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.deltaTop = Math.round(data.targetPositionY - data.startPositionY);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPositionY = data.startPositionY + Math.ceil(data.deltaTop * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    data.containerElement.scrollTop = data.currentPositionY;
  } else {
    window.scrollTo(0, data.currentPositionY);
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(y, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  _cancelEvents2.default.subscribe(function () {
    options.data.cancel = true;
  });

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPositionY = currentPositionY(options);
  options.data.targetPositionY = options.absolute ? y : y + options.data.startPositionY;

  if (options.data.startPositionY === options.data.targetPositionY) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPositionY);
    }
    return;
  }

  options.data.deltaTop = Math.round(options.data.targetPositionY - options.data.startPositionY);

  options.data.duration = functionWrapper(options.duration)(options.data.deltaTop);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toY, options) {
  animateTopScroll(toY, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toY, options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(currentPositionY(options) + toY, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(55);

var _utils = __webpack_require__(32);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.pushHash(to);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(31);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/*!
 * reactjs-popup v1.5.0
 * (c) 2019-present Youssouf EL AZIZI <youssoufelazizi@gmail.com>
 * Released under the MIT License.
 */


function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/* Algo to calculate position
  1. center position for popup content : the center of the trigger will be the center of the content content
      so the popup content position will be like this :
      top => the y of the center for the trigger element : trigger.top + trigger.height/2
      left => the x of the center for the trigger element : trigger.left + trigger.width/2

  2. translate position according to the first  position attribute  passed  in the function argument
      for example :
        position = 'left top'
        we need to handle the first argument in the position: 'left' => that's mean we need to translate the popup content according to the X axis by - content.width/2

  3.translate position according to the first  position attribute  passed  in the function argument
    for example :
      position = 'left top'
      the second argument 'top' => translate popup content by + content.height*4/5

  4. check if calculated position is going out of bounds of wrapper box or not. If yes repeat 1-3 for next position enum. By default wrapper box is window element
*/
function getCoordinatesForPosition(triggerBounding, ContentBounding, position, arrow, _ref) {
  var offsetX = _ref.offsetX,
      offsetY = _ref.offsetY;
  var margin = arrow ? 8 : 0;
  var args = position.split(' '); // the step N 1 : center the popup content => ok

  var CenterTop = triggerBounding.top + triggerBounding.height / 2;
  var CenterLeft = triggerBounding.left + triggerBounding.width / 2;
  var height = ContentBounding.height,
      width = ContentBounding.width;
  var top = CenterTop - height / 2;
  var left = CenterLeft - width / 2;
  var transform = '';
  var arrowTop = '0%';
  var arrowLeft = '0%'; // the  step N 2 : => ok

  switch (args[0]) {
    case 'top':
      top -= height / 2 + triggerBounding.height / 2 + margin;
      transform = "rotate(45deg)";
      arrowTop = '100%';
      arrowLeft = '50%';
      break;

    case 'bottom':
      top += height / 2 + triggerBounding.height / 2 + margin;
      transform = "rotate(225deg)";
      arrowLeft = '50%';
      break;

    case 'left':
      left -= width / 2 + triggerBounding.width / 2 + margin;
      transform = " rotate(-45deg)";
      arrowLeft = '100%';
      arrowTop = '50%';
      break;

    case 'right':
      left += width / 2 + triggerBounding.width / 2 + margin;
      transform = "rotate(135deg)";
      arrowTop = '50%';
      break;

    default:
  }

  switch (args[1]) {
    case 'top':
      top = triggerBounding.top;
      arrowTop = "".concat(triggerBounding.height / 2, "px");
      break;

    case 'bottom':
      top = triggerBounding.top - height + triggerBounding.height;
      arrowTop = "".concat(height - triggerBounding.height / 2, "px");
      break;

    case 'left':
      left = triggerBounding.left;
      arrowLeft = "".concat(triggerBounding.width / 2, "px");
      break;

    case 'right':
      left = triggerBounding.left - width + triggerBounding.width;
      arrowLeft = "".concat(width - triggerBounding.width / 2, "px");
      break;

    default:
  }

  top = args[0] === 'top' ? top - offsetY : top + offsetY;
  left = args[0] === 'left' ? left - offsetX : left + offsetX;
  return {
    top: top,
    left: left,
    transform: transform,
    arrowLeft: arrowLeft,
    arrowTop: arrowTop
  };
}

function calculatePosition(triggerBounding, ContentBounding, positions, arrow, _ref2, wrapperBox) {
  var offsetX = _ref2.offsetX,
      offsetY = _ref2.offsetY;
  var bestCoords;
  var i = 0;

  while (i < positions.length) {
    bestCoords = getCoordinatesForPosition(triggerBounding, ContentBounding, positions[i], arrow, {
      offsetX: offsetX,
      offsetY: offsetY
    });
    var contentBox = {
      top: bestCoords.top,
      left: bestCoords.left,
      width: ContentBounding.width,
      height: ContentBounding.height
    };

    if (contentBox.top <= wrapperBox.top || contentBox.left <= wrapperBox.left || contentBox.top + contentBox.height >= wrapperBox.top + wrapperBox.height || contentBox.left + contentBox.width >= wrapperBox.left + wrapperBox.width) {
      i++;
    } else {
      break;
    }
  }

  return bestCoords;
}

var styles = {
  popupContent: {
    tooltip: {
      position: 'absolute',
      zIndex: '2',
      width: '200px',
      background: "rgb(255, 255, 255)",
      border: "1px solid rgb(187, 187, 187)",
      boxShadow: "rgba(0, 0, 0, 0.2) 0px 1px 3px",
      padding: '5px'
    },
    modal: {
      position: 'relative',
      background: "rgb(255, 255, 255)",
      width: '50%',
      margin: 'auto',
      border: "1px solid rgb(187, 187, 187)",
      padding: '5px'
    }
  },
  popupArrow: {
    height: '10px',
    width: '10px',
    position: 'absolute',
    background: 'rgb(255, 255, 255)',
    transform: 'rotate(45deg)',
    margin: '-5px',
    zIndex: '-1',
    boxShadow: 'rgba(0, 0, 0, 0.2) 1px 1px 1px'
  },
  overlay: {
    tooltip: {
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0'
    },
    modal: {
      position: 'fixed',
      top: '0',
      bottom: '0',
      left: '0',
      right: '0',
      background: "rgba(0, 0, 0,0.5)",
      display: 'flex',
      zIndex: '999'
    }
  }
};

var POSITION_TYPES = ['top left', 'top center', 'top right', 'right top', 'right center', 'right bottom', 'bottom left', 'bottom center', 'bottom right', 'left top', 'left center', 'left bottom', 'center center'];

var Popup =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Popup, _React$PureComponent);

  function Popup(props) {
    var _this;

    _classCallCheck(this, Popup);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Popup).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "repositionOnResize", function () {
      _this.setPosition();
    });

    _defineProperty(_assertThisInitialized(_this), "onEscape", function (e) {
      if (e.key === 'Escape') _this.closePopup();
    });

    _defineProperty(_assertThisInitialized(_this), "lockScroll", function () {
      var lockScroll = _this.props.lockScroll;
      var modal = _this.state.modal;
      if (modal && lockScroll)
        /* eslint-disable-next-line no-undef */
        document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    });

    _defineProperty(_assertThisInitialized(_this), "resetScroll", function () {
      var lockScroll = _this.props.lockScroll;
      var modal = _this.state.modal;
      if (modal && lockScroll)
        /* eslint-disable-next-line no-undef */
        document.getElementsByTagName('body')[0].style.overflow = 'auto';
    });

    _defineProperty(_assertThisInitialized(_this), "togglePopup", function (e) {
      // https://reactjs.org/docs/events.html#event-pooling
      e.persist();
      if (_this.state.isOpen) _this.closePopup(e);else _this.openPopup(e);
    });

    _defineProperty(_assertThisInitialized(_this), "openPopup", function (e) {
      var _this$props = _this.props,
          disabled = _this$props.disabled,
          onOpen = _this$props.onOpen;
      var isOpen = _this.state.isOpen;
      if (isOpen || disabled) return;
      onOpen(e);

      _this.setState({
        isOpen: true
      }, function () {
        _this.setPosition();

        _this.lockScroll();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "closePopup", function (e) {
      var onClose = _this.props.onClose;
      var isOpen = _this.state.isOpen;
      if (!isOpen) return;
      onClose(e);

      _this.setState({
        isOpen: false
      }, function () {
        _this.resetScroll();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function () {
      clearTimeout(_this.timeOut);
      var mouseEnterDelay = _this.props.mouseEnterDelay;
      _this.timeOut = setTimeout(function () {
        return _this.openPopup();
      }, mouseEnterDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function () {
      clearTimeout(_this.timeOut);
      var mouseLeaveDelay = _this.props.mouseLeaveDelay;
      _this.timeOut = setTimeout(function () {
        return _this.closePopup();
      }, mouseLeaveDelay);
    });

    _defineProperty(_assertThisInitialized(_this), "getTooltipBoundary", function () {
      var keepTooltipInside = _this.props.keepTooltipInside;
      var boundingBox = {
        top: 0,
        left: 0,

        /* eslint-disable-next-line no-undef */
        width: window.innerWidth,

        /* eslint-disable-next-line no-undef */
        height: window.innerHeight
      };

      if (typeof keepTooltipInside === 'string') {
        /* eslint-disable-next-line no-undef */
        var selector = document.querySelector(keepTooltipInside);

        if (false) {
          if (selector === null) throw new Error("".concat(keepTooltipInside, " selector is not exist : keepTooltipInside must be a valid html selector 'class' or 'Id'  or a boolean value"));
        }

        boundingBox = selector.getBoundingClientRect();
      }

      return boundingBox;
    });

    _defineProperty(_assertThisInitialized(_this), "setPosition", function () {
      var _this$state = _this.state,
          modal = _this$state.modal,
          isOpen = _this$state.isOpen;
      if (modal || !isOpen) return;
      var _this$props2 = _this.props,
          arrow = _this$props2.arrow,
          position = _this$props2.position,
          offsetX = _this$props2.offsetX,
          offsetY = _this$props2.offsetY,
          keepTooltipInside = _this$props2.keepTooltipInside,
          arrowStyle = _this$props2.arrowStyle,
          className = _this$props2.className;

      var helper = _this.HelperEl.getBoundingClientRect();

      var trigger = _this.TriggerEl.getBoundingClientRect();

      var content = _this.ContentEl.getBoundingClientRect();

      var boundingBox = _this.getTooltipBoundary();

      var positions = Array.isArray(position) ? position : [position]; // keepTooltipInside would be activated if the  keepTooltipInside exist or the position is Array

      if (keepTooltipInside || Array.isArray(position)) positions = [].concat(_toConsumableArray(positions), POSITION_TYPES);
      var cords = calculatePosition(trigger, content, positions, arrow, {
        offsetX: offsetX,
        offsetY: offsetY
      }, boundingBox);
      _this.ContentEl.style.top = "".concat(cords.top - helper.top, "px");
      _this.ContentEl.style.left = "".concat(cords.left - helper.left, "px");

      if (arrow) {
        _this.ArrowEl.style.transform = cords.transform;
        _this.ArrowEl.style['-ms-transform'] = cords.transform;
        _this.ArrowEl.style['-webkit-transform'] = cords.transform;
        _this.ArrowEl.style.top = arrowStyle.top || cords.arrowTop;
        _this.ArrowEl.style.left = arrowStyle.left || cords.arrowLeft;

        _this.ArrowEl.classList.add("popup-arrow");

        if (className !== '') {
          _this.ArrowEl.classList.add("".concat(className, "-arrow"));
        }
      }

      if (
      /* eslint-disable-next-line no-undef */
      window.getComputedStyle(_this.TriggerEl, null).getPropertyValue('position') === 'static' ||
      /* eslint-disable-next-line no-undef */
      window.getComputedStyle(_this.TriggerEl, null).getPropertyValue('position') === '') _this.TriggerEl.style.position = 'relative';
    });

    _defineProperty(_assertThisInitialized(_this), "addWarperAction", function () {
      var _this$props3 = _this.props,
          contentStyle = _this$props3.contentStyle,
          className = _this$props3.className,
          on = _this$props3.on;
      var modal = _this.state.modal;
      var popupContentStyle = modal ? styles.popupContent.modal : styles.popupContent.tooltip;
      var childrenElementProps = {
        className: "popup-content ".concat(className !== '' ? "".concat(className, "-content") : ''),
        style: Object.assign({}, popupContentStyle, contentStyle),
        ref: _this.setContentRef,
        onClick: function onClick(e) {
          e.stopPropagation();
        }
      };

      if (!modal && on.indexOf('hover') >= 0) {
        childrenElementProps.onMouseEnter = _this.onMouseEnter;
        childrenElementProps.onMouseLeave = _this.onMouseLeave;
      }

      return childrenElementProps;
    });

    _defineProperty(_assertThisInitialized(_this), "renderTrigger", function () {
      var triggerProps = {
        key: 'T',
        ref: _this.setTriggerRef
      };
      var _this$props4 = _this.props,
          on = _this$props4.on,
          trigger = _this$props4.trigger;
      var isOpen = _this.state.isOpen;
      var onAsArray = Array.isArray(on) ? on : [on];

      for (var i = 0, len = onAsArray.length; i < len; i++) {
        switch (onAsArray[i]) {
          case 'click':
            triggerProps.onClick = _this.togglePopup;
            break;

          case 'hover':
            triggerProps.onMouseEnter = _this.onMouseEnter;
            triggerProps.onMouseLeave = _this.onMouseLeave;
            break;

          case 'focus':
            triggerProps.onFocus = _this.onMouseEnter;
            break;

          default:
        }
      }

      if (typeof trigger === 'function') return !!trigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(trigger(isOpen), triggerProps);
      return !!trigger && __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(trigger, triggerProps);
    });

    _defineProperty(_assertThisInitialized(_this), "renderContent", function () {
      var _this$props5 = _this.props,
          arrow = _this$props5.arrow,
          arrowStyle = _this$props5.arrowStyle,
          children = _this$props5.children;
      var _this$state2 = _this.state,
          modal = _this$state2.modal,
          isOpen = _this$state2.isOpen;
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", _extends({}, _this.addWarperAction(), {
        key: "C"
      }), arrow && !modal && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        ref: _this.setArrowRef,
        style: Object.assign({}, styles.popupArrow, arrowStyle)
      }), typeof children === 'function' ? children(_this.closePopup, isOpen) : children);
    });

    _this.setTriggerRef = function (r) {
      return _this.TriggerEl = r;
    };

    _this.setContentRef = function (r) {
      return _this.ContentEl = r;
    };

    _this.setArrowRef = function (r) {
      return _this.ArrowEl = r;
    };

    _this.setHelperRef = function (r) {
      return _this.HelperEl = r;
    };

    _this.timeOut = 0;
    var open = props.open,
        _modal = props.modal,
        defaultOpen = props.defaultOpen,
        _trigger = props.trigger;
    _this.state = {
      isOpen: open || defaultOpen,
      modal: _modal ? true : !_trigger // we create this modal state because the popup can't be a tooltip if the trigger prop doesn't exist

    };
    return _this;
  }

  _createClass(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props6 = this.props,
          closeOnEscape = _this$props6.closeOnEscape,
          defaultOpen = _this$props6.defaultOpen,
          repositionOnResize = _this$props6.repositionOnResize;
      if (defaultOpen) this.setPosition();

      if (closeOnEscape) {
        /* eslint-disable-next-line no-undef */
        window.addEventListener('keyup', this.onEscape);
      }

      if (repositionOnResize) {
        /* eslint-disable-next-line no-undef */
        window.addEventListener('resize', this.repositionOnResize);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props7 = this.props,
          open = _this$props7.open,
          disabled = _this$props7.disabled;
      var isOpen = this.state.isOpen;

      if (prevProps.open !== open) {
        if (open) this.openPopup();else this.closePopup(undefined, true);
      }

      if (prevProps.disabled !== disabled && disabled && isOpen) {
        this.closePopup();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // kill any function to execute if the component is unmounted
      clearTimeout(this.timeOut);
      var _this$props8 = this.props,
          closeOnEscape = _this$props8.closeOnEscape,
          repositionOnResize = _this$props8.repositionOnResize; // remove events listeners

      if (closeOnEscape) {
        /* eslint-disable-next-line no-undef */
        window.removeEventListener('keyup', this.onEscape);
      }

      if (repositionOnResize) {
        /* eslint-disable-next-line no-undef */
        window.removeEventListener('resize', this.repositionOnResize);
      }

      this.resetScroll();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props9 = this.props,
          overlayStyle = _this$props9.overlayStyle,
          closeOnDocumentClick = _this$props9.closeOnDocumentClick,
          className = _this$props9.className,
          on = _this$props9.on,
          trigger = _this$props9.trigger;
      var _this$state3 = this.state,
          modal = _this$state3.modal,
          isOpen = _this$state3.isOpen;
      var overlay = isOpen && !(on.indexOf('hover') >= 0);
      var ovStyle = modal ? styles.overlay.modal : styles.overlay.tooltip;
      return [this.renderTrigger(), isOpen && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: "H",
        style: {
          position: 'absolute',
          top: '0px',
          left: '0px'
        },
        ref: this.setHelperRef
      }), overlay && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
        key: "O",
        className: "popup-overlay ".concat(className !== '' ? "".concat(className, "-overlay") : ''),
        style: Object.assign({}, ovStyle, overlayStyle),
        onClick: closeOnDocumentClick ? this.closePopup : undefined
      }, modal && this.renderContent()), isOpen && !modal && this.renderContent()];
    }
  }]);

  return Popup;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

_defineProperty(Popup, "defaultProps", {
  trigger: null,
  onOpen: function onOpen() {},
  onClose: function onClose() {},
  defaultOpen: false,
  open: false,
  disabled: false,
  closeOnDocumentClick: true,
  repositionOnResize: true,
  closeOnEscape: true,
  on: ['click'],
  contentStyle: {},
  arrowStyle: {},
  overlayStyle: {},
  className: '',
  position: 'bottom center',
  modal: false,
  lockScroll: false,
  arrow: true,
  offsetX: 0,
  offsetY: 0,
  mouseEnterDelay: 100,
  mouseLeaveDelay: 100,
  keepTooltipInside: false
});

if (false) {
  var PropTypes = require('prop-types');

  var TRIGGER_TYPES = ['hover', 'click', 'focus'];
  Popup.propTypes = {
    arrowStyle: PropTypes.object,
    contentStyle: PropTypes.object,
    overlayStyle: PropTypes.object,
    className: PropTypes.string,
    modal: PropTypes.bool,
    arrow: PropTypes.bool,
    closeOnDocumentClick: PropTypes.bool,
    repositionOnResize: PropTypes.bool,
    disabled: PropTypes.bool,
    closeOnEscape: PropTypes.bool,
    lockScroll: PropTypes.bool,
    offsetX: PropTypes.number,
    offsetY: PropTypes.number,
    mouseEnterDelay: PropTypes.number,
    mouseLeaveDelay: PropTypes.number,
    onOpen: PropTypes.func,
    onClose: PropTypes.func,
    open: PropTypes.bool,
    defaultOpen: PropTypes.bool,
    trigger: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
    // for uncontrolled component we don't need the trigger Element
    on: PropTypes.oneOfType([PropTypes.oneOf(TRIGGER_TYPES), PropTypes.arrayOf(PropTypes.oneOf(TRIGGER_TYPES))]),
    children: PropTypes.oneOfType([PropTypes.func, PropTypes.element, PropTypes.string]).isRequired,
    position: PropTypes.oneOfType([PropTypes.oneOf(POSITION_TYPES), PropTypes.arrayOf(PropTypes.oneOf(POSITION_TYPES))]),
    keepTooltipInside: PropTypes.oneOfType([PropTypes.bool, PropTypes.string])
  };
}

/* harmony default export */ __webpack_exports__["a"] = (Popup);


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var settle = __webpack_require__(198);
var buildURL = __webpack_require__(200);
var parseHeaders = __webpack_require__(201);
var isURLSameOrigin = __webpack_require__(202);
var createError = __webpack_require__(99);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(203);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(199);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/UI.5b30eafc.js-p1";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ShowsPostsData */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return newPostdata; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Utility_Utility__ = __webpack_require__(1);
var _ref,_ref2;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}// start live shows
// export const ShowsPostsData = [
// 	{
// 		id:1,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tom Jones \n Tel Aviv ",
//         smltitle: "The one and only Tom Jones returns to Tel Aviv for one live performance",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tomjones.com/">
// 												www.tomjones.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/1/1.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 							At the request of the audience and after the success of his sold-out show in 2013, the legendary performer Tom Jones returns to Israel for one live performance, to be held in Tel Aviv on Wednesday, June 28, 2017.
// 						</p>
// 						<p>
// 							Tom Jones, a world-famous living legend, is known for not allowing the diverse audience that fills his halls to sit quietly for a moment. He is a performer who captures the hearts of men and women of all ages, crosses generations and genres with his infinite inherent talent and his powerful and unique voice.
// 						</p>
// 						<p>
// 							Tom Jones has had an amazing stage career and sold over 100 million records. He has been awarded many titles including the Brit Awards for his immense musical contribution and Lifetime Achievement Award for his many achievements in the world of music and live performances at the Silver Clef (annual British Music Awards). For his contribution to the music industry, he won a star on the Hollywood Walk of Fame. In 1999, Tom Jones was awarded the Order of the British Empire (OBE) and in 2006 His Royal Highness Queen Elizabeth gave him the title of nobility and he became Sir Tom Jones.
// 						</p>
// 						<p>
// 							Jones, recognized across the world as a "hit machine", will be hitting the 24/7 city this June for the second time. As he did in his last sold out show in Tel Aviv to the delight of his audience, will be performing his all-time greatest hits.
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:2,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Britney Spears \n  Live in Concert",
//         smltitle: "Britney Spears- performing all her greatest hits in the fabulous city of Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.britneyspears.com">
// 												www.britneyspears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/2/1.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 							Pop Icon Britney Spears is coming to Tel Aviv for the first time ever, for one show only, as part of her international tour of Asia. The show will take place in stunning Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Pop Icon Britney Spears will be coming to Israel for the first time ever for one show only as part of her international tour of Asia. The show will take place in Ha’Yarkon Park in central Tel Aviv and will include the Pop Princesses’ greatest hits.
// 						</p>
// 						<p>
// 							Multi-platinum, Grammy Award-winning pop icon Britney Spears was born in Mississippi and raised in Louisiana, Spears became a household name as a teenager when she released her first single “…Baby One More Time,” a Billboard Hot 100 No. 1 smash and international hit that broke sales records with more than 20 million copies sold worldwide and is currently 14x Platinum in the U.S.
// 						</p>
// 						<p>
// 							Spears is one of the most successful and celebrated entertainers in pop history with nearly 150 million records worldwide. In the U.S. alone, she has sold more than 70 million albums, singles and songs, according to Nielsen Music.
// 						</p>
// 						<p>
// 							Britney’s live concerts are renowned for their amazing production and nonstop energy. Her first ever show in Tel Aviv is likely to feature some of her most recent songs from her Glory Album, including massive 2016 hit ‘Slumber Party’, and also some of her massive all-time hits such as ‘Baby One More Time’ and ‘Oops I Did It Again’!
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:3,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Tears for Fears",
//         smltitle: "Tear for Fears in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.tearsforfears.com">
// 												www.tearsforfears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<p>
// 							This summer, the trendy city of Tel Aviv is embracing it’s 80s vibe for one performance only by the incomparable Tears for Fears. The legendary British pop/rock band that is responsible for many unforgettable hits is coming to the rocking city of Tel Aviv for a single awesome performance!
// 						</p>
// 						<p>
// 							Originally from Bath, Avon, Tears for Fears was founded in 1981 and was associated at first with the new wave synthesizer bands but later on became a part of mainstream rock and pop and hit international success. During the 80's the band released 3 albums that were a combination of pop, new wave and rock. Their first album from 1983, "The Hurting", reached number one in the UK albums chart and was a platinum-selling album. It included major hits such as "Pale Shelter", "Change", and "Mad World". Their second album, "Songs from the Big Chair", followed the same path and reached number one on the US Billboard 200, getting multi-platinum status in the UK and the US. It contained unforgettable hits such as "Shout", "Head Over Heels" and "Everybody Wants to Rule the World" which won the Brit Award for best British single in 1986. Their third successful album "The Seeds of Love" that came out in 1989 included the epic songs "The Seeds of Love", "Sowing Woman in Chains" and many more.
// 						</p>
// 						<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans
// 						</p>
// 						<p>
// 						Tears for Fears’ albums and singles were sold in tens of millions of copies and their songs were covered by other artists countless times. Last year the band announced they are working on a new album to be released during 2017. This July they will be gracing the nonstop city of Tel Aviv for the first time with a single performance, guaranteed to be a night to remember.
// 						</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:4,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: " Guns N' Roses  \"Not in this Lifetime\"",
//         smltitle: "Legendary Guns N' Roses is Coming Back to Rock Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.gunsnroses.com">
// 											www.gunsnroses.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								After their celebrated reunion tour last summer, which became the most profitable musical rock concert in 2016, Guns N' Roses, one of the world's most important and beloved rock bands, is coming to Tel Aviv as part of its successful tour with has already added more than 30 shows in the US and Europe.
// 							</p>
// 							<p>
// 								The concert in Tel Aviv will take place on Saturday, July 15 and, 17 at the Yarkon Park, and will close the European tour.
// 							</p>
// 							<p>
// 								Twenty-three years after standing together on the stage in Tel Aviv for the first time, the three original members of the ensemble will come back again: vocalist Axel Rose, guitarist Slash and bassist Duff McGinn, along with an impressive ensemble of musicians including drummer Frank Ferrer, keyboardist Dizzy Red (who was an integral part of the band in the 1990s) Guitarist Richard Fortus and keyboardist Melissa Reyes.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/4/2.jpg"} class="img-responsive" />
// 							</div>
// 							<h3>
// 							"Not in this Lifetime"
// 							</h3>
// 							<p>
// 							Since their first reunion concert at Cochlea Festival last April, the band's tour has become one of the most sought-after shows in America with more than 2 million tickets sold.
// 							</p>
// 							<p>
// 								The success and numbers of the current tour show more than anything else that the audience's love of the band's music and rock music is more relevant and bigger than ever. The historic tour last summer visited 21 cities (25 performances) in North America.
// 							</p>
// 							<p>
// 								The band has recently completed a successful tour in South America, Brazil, Argentina and Mexico. All of band's new tour dates are completely sold out, generating massive interest among audiences. In January, the band will continue to Japan and from there to Australia, Thailand, Singapore, Dubai and will arrive in the “nonstop city” of Tel Aviv in July.
// 							</p>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:5,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: " RADIOHEAD  \n Tel Aviv",
//         smltitle: "The trailblazing RADIOHEAD bringing their iconic repertoire to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.radiohead.com">
// 											www.radiohead.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/5/1.jpeg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Preforming in Tel Aviv for the second time ever, Radiohead has managed to remain innovative, relevant and especially moving since first visiting here 17 years ago . It is a band blessed with superhuman ability to meld together distant musical influences to create a new identity for themselves and their listeners; A band whose compulsive tendency to experiment with groundbreaking sound echoed the impact of entire generations of artists and shattered it to the walls of superfluous genres; A band that changed the way we listen to music, make music, see music, think music and even buy music. Now, 17 years after they last visited here, Radiohead is coming to a concert in Tel Aviv.
// 							</p>
// 							<p>
// 								Watching Radiohead's show, it becomes clear that first and foremost, they are the authors and performers of a huge amount of unforgettable songs. Their repertoire manages to be on the one hand familiar, classical - most of us know it by heart - and on the other hand revolutionary, developing and surprising. The tight performance of the ensemble, along with the unique energy of the soloist, Tom York, transforms each performance into a one-time live experience that attracts huge audiences, to participate in the celebration of artistic evolution, to see how they grew, evolved and reinvented themselves time and time again.
// 							</p>
// 							<p>
// 								Today's Radiohead is a band with a more contemporary presence than ever before, with a glorious past and a variety that transcends all cataloging: a band that began with the Immortal Grange anthem of Creep; Slapped critics over the head with the alternative masterpiece The Bends and then committed commercial suicide - and reached heaven - twice! - with two of the best albums of all time, OK Computer and Kid A.
// 							</p>
// 							<p>
// 								The new generations who discover Radiohead through their new works - In Rainbows a favorite in Israel or the new and acclaimed album A Moon Shaped Pool - discover a band whose influences have permeated every musical genre today: rock, electronic, world, hip hop. Today's Radiohead is more than just another band, it is a world - with a unique visual language, exceptional imagery, an unreplaceable atmosphere and inner humor. Especially in Israel - a country that has always enjoyed an intimate and warm relationship with the band - Radiohead's performance is a cultural experience of the rarest kind.
// 							</p>
// 							<p>
// 							This concert will not have assigned seats, Golden Ring, VIP, unfair prices or any other division of class. Anyone who wants to sit is welcome to bring a blanket, and anyone who wants to stand close to the stage is welcome to arrive early, the ticket price is equal to all, and as many people as possible will be able to enjoy this momentous musical event.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:6,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25-26.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								The Israeli summer is always hot, but the Pixies are returning to Tel Aviv after 3 years to make it even hotter!
// 							</p>
// 							<p>
// 								The famous rock band was founded in 1986 in Boston and released its first EP "Come on Pilgrim" in 1987. A year later, when their first album "Surfer Rose" came out, they became a unique voice in the American Rock. 2 years later, they released their second album "Doolittle" that is considered one of the best rock albums of all times. Their third album "Bossanova" came out in 1990 and included unforgettable songs such as "Hang Wire", "Stormy Weather", and "All Over the World".
// 							</p>
// 							<p>
// 							A year later they released their fourth album "Trompe le Monde" that featured songs such as "Planet of Sound", "Distance Equals Rate Times Time" and many more. They fell apart in 1993 but went back to performing together in 2004. After a decade of touring the world, they released their fifth album "Indie Cindy" which included songs like "Another Toe in The Ocean", "Blue Eyed Hexe", and "Jaime Bravo". To this date they released six albums, the last one, "Head Carrier" came out last year. Their biggest hits include "Hey", "Where Is My Mind", "Monkey Gone to Heaven" and "Here Comes Your Man".
// 							</p>
// 							<p>
// 								The band that is known to influence artists such as PJ Harvey and Kurt Kobain will perform this summer in Tel Aviv, giving only 7000 lucky fans the opportunity to see them live and after the rave reviews of their 2014 performance, it’s shaping up to be an unmissable night!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:7,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Regina Spektor – Back in Israel",
//         smltitle: "Regina Spektor – Back in Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reginaspektor.com">
// 											www.reginaspektor.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								Beloved pianist, songwriter and singer Regina Spektor is coming back to Tel Aviv for the third time, closing the worldwide tour of her recent 2016 album “Remember Us to Life” that has gotten excellent reviews.
// 							</p>
// 							<p>
// 								Regina Spektor, whose past concerts in Israel were sold out in 2007 and 2013, will perform again for one time only in Ra’anana Amphitheater on Saturday, August 19.
// 							</p>
// 							<p>
// 								Grammy and VMA nominee Regina Spektor was born in Russia, where she started her classical music training at the age of six and immigrated shortly after to the New York, where she began writing her own original songs. Her first Album came out in 2001 and a year later she already released her second album, “songs”, but her real success started after her third album, Soviet Kitsch, was out in 2004 and the fans started pouring in.
// 							</p>
// 							<p>
// 								Her international breakthrough came in 2006 with her album “Begin to Hope” that reached gold status and sold more than 500,000 copies (!!!). The album includes the single “Fidelity” that is very popular in Israel and in the rest of the world to this day and was used as part of the soundtrack of TV shows such as “Grey’s Anatomy”. Her success only became stronger when her fifth album “Far” and her sixth album “What We Saw From The Cheap Seats” got to the third place in Billboard's album chart.
// 							</p>
// 							<p>
// 								In 2013 Spektor created the theme song of the successful Netflix series “Orange Is the New Black”, called “You’ve Got Time” that also became a radio hit and got her her first Grammy Award nomination. The following year, she sang “Love Me or Leave Me” for the HBO historical crime series “Boardwalk Empire”.
// 							</p>
// 							<p>
// 								Regina Spektor is coming to the non-stop city of Tel Aviv after her sold-out tour in the United States and her old and new fans can’t wait for her show, guaranteed to light up the beautiful summer night of Tel Aviv with it’s amazing infectious energy.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:8,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Nick Cave & The Bad Seeds",
//         smltitle: "Rock legend Nick Cave & The Bad Seeds returning to Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19-20.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.nick-cave.com">
// 											www.nick-cave.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<p>
// 								19 years after his last performance in Tel Aviv, the prince of darkness returns once again with his band The Bad Seeds for two shows only to the joy of his fans in what are set to be intimate and unique performances.
// 							</p>
// 							<p>
// 								Australian musician, singer-songwriter, author, screenwriter, composer and film actor Nick Cave is well known as rock musics' "Prince of Darkness" because of his dark, intense tunes. His music is known to be emotionally intense and is characterized by a variety of influences such as death, religion, love and violence. He was called by NME "the grand lord of gothic lushness".
// 							</p>
// 							<p>
// 							In the early 90's, Curt Smith left the band and Roland Orzabal kept releasing more albums under the name of the band. In 2004 the two went back to working together under the name "Tears for Fears" and released the album "Everybody Loves Happy Ending". Since then, the band has been touring around the world to the delight of their fans.
// 							</p>
// 							<p>
// 								Cave started his musical path in the 1970's when he formed "the Boys Next Door" which became a huge success in Melbourne's post-punk scene. Their name was changed to "the Birthday Party" and the band's sound and shows took a rather violent direction and they became known as one of the darkest groups of the 1980's, they fell apart in 1983
// 							</p>
// 							<p>
// 								The end of the Birthday Party was the beginning of Nick Cave and the Bad Seeds in 1983 and they released their debut album the following year. In 1996 the band released its album "Murder Ballads" which featured "Where the Wild Roses Grow", a duet with Kylie Minogue that is also Cave's biggest commercial success to date.
// 							</p>
// 							<p>
// 								Many artists have covered Cave's songs over the years, including Metallica, Johnny Cash, and even the Arctic Monkeys.
// 							</p>
// 							<p>
// 								Nick Cave & The Bad Seeds will perform at the Menora Arena in Tel Aviv on November 19 and an additional date has been added on November 20 due to high demand. For the mere 7,000 fans who will get the chance to look the legendary Nick Cave in the eyes, this is guaranteed to be an unforgettable show!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:9,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Justin Bieber",
//         smltitle: "Justin Bieber, is landing in Tel Aviv for a single breathtaking concert",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.05.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.justinbiebermusic.com">
// 											www.justinbiebermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/9/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The artist with the most followers on Twitter 90,149,014
// 								The artist with the most watched official music channel online 13,518,849,954
// 								The artist with the most mentions on Youtube music channel
// 							</p>
// 							<p>
// 							Justin Bieber, the biggest international star of our day, arrives in Israel for just one concert as part of the PURPOSE WORLD TOUR, a tour bearing the name of his last album, which has sold 640,000 copies in just a week and became his bestselling album.
// 							</p>
// 							<p>
// 								Bieber, born in Ontario, Canada, learned to play piano, guitar and drums as a child. At the age of 13, with the help of his mother, he began posting videos on YouTube where he sang covers to artists such as Asher, Stevie Wonder, Chris Brown and others.
// 							</p>
// 							<p>
// 								Scooter Browne, a former marketing director at “So So Def”, was the first to spot Bieber’s talent and invited him and his mother to recordings in Atlanta.
// 							</p>
// 							<p>
// 								In 2008, Bieber was signed by Universal Records, and in 2009, "My World", the first mini-album by Bieber, including "One Time Lonely", "Love Me" and "Favorite Girl" topped the Canadian Billboard charts and the top 40 Billboard Hot 100 hits
// 							</p>
// 							<p>
// 								In 2010, he released his second album, "My World 2.0" with the single "Baby", which became a huge hit and was accompanied by the most watched YouTube video by November 24, 2012.
// 							</p>
// 							<p>
// 								In October 2015, Bieber released the second single from the album "Sorry". The dance clip for the song accumulated over 10 million views in the first 24 hours since its release.
// 							</p>
// 							<p>
// 								In November 2015 he released his fourth album "Purpose", which sold 640,000 copies in the first week and became Bieber’s best-selling album with hits such as "Love Yourself." That same month Bieber made history by placing 17 songs on the American charts and breaking the record held by the Beatles since 1964.
// 							</p>
// 							<p>
// 								In December 2015, Bieber and Skrillex won the Grammy Award for "Where are You Now".
// 							</p>
// 							<p>
// 								Justin Bieber will be performing in Israel on May 3 at Hayarkon Park, with his latest hits "love yourself" and "Sorry" and with the hits "Baby" and "As long as you love me".
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:10,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "AEROSMITH \n \"AERO-VEDERCI BABY\" ",
//         smltitle: " Aerosmith launching its tour in the rocking city of Tel Aviv  ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.aerosmith.com">
// 											www.aerosmith.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/1.png"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Aerosmith’s farewell concerts began several months ago in South America and will continue in 2017 in the United States and Europe. the European leg of the tour will begin in Tel Aviv and the band will go on to perform in Georgia, Russia, Germany, Poland, Denmark, Ireland, Italy, Portugal and Spain, including appearances in some of the world's leading rock festivals.
// 							</p>
// 							<p>
// 								For over 45 years, Aerosmith has been the quintessential Rock & Roll band, becoming one of the most influential and loved groups in the world. An endless list of amazing songs, many of them becoming massive worldwide hits, and their groundbreaking live shows have gained the band mass appeal for nearly half a century. Rock & Roll Hall of Fame inductees, Aerosmith, have sold over 100 million albums and won countless awards (including four Grammy Awards, eight American Music Awards, six Billboard Awards, and 12 MTV Awards).
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/10/2.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								<strong>Steven Tyler</strong> – "Aerosmith just got done ripping through South America like true ambassadors of rock...The band is unstoppable right now and in Europe, we're going to keep doing what we do best... Let The Music Do The Talking...Living On The Edge, and living to rock another day."
// 							</p>
// 							<p>
// 								<strong>Joe Perry </strong> – “It’s been 3 years since we have been on tour in Europe and I can speak for my brothers that we can’t wait to get over there and take it up a few notches. Last tour in South America we were running on all cylinders and I can see no reason to let up now." ;
// 							</p>
// 							<p>
// 							This May, the city of Tel Aviv will be hosting Steven Tyler, Joe Perry, Joey Kramer, Tom Hamilton and Brad Whitford in the beautiful Ganei Yehoshua Park for what promises to be an unforgettable experience and the concert of a lifetime.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:11,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Frankie Valli & The Four Seasons  ",
//         smltitle: " An American Legend in the heart of Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											4.007.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.frankievallifourseasons.com/">
// 											www.frankievallifourseasons.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/11/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The American legend comes to the rocking city of Tel Aviv for the first time ever for an unforgettable 4th of July celebration with the best timeless classics!
// 							</p>
// 							<p>
// 								The original Jersey boy, musical legend Frankie Valli, comes Tel Aviv for the first time for one single performance. Back in the 50’s, Valli started singing in harmonies with different bands in New Jersey, but the success only struck him when he grabbed the microphone in the early 60’s as the lead singer for The Four Seasons that rocked the music world in the next decades with major hits such as “Big Girls Don’t Cry”, “Sherry”, “Walk Like a Man” and more. Valli scored 29 Top 40 hits with The Four Seasons and nine Top 40 hits as a solo artist. The band sold more than 175 million albums and Valli, Tommy DeVito, Nick Massi and Bob Gaudio – the original members of The Four Seasons – were inducted into the Rock and Roll Hall of Fame in 1990 and the Vocal Group Hall of Fame in 1999.
// 							</p>
// 							<p>
// 								At the same time, Valli also has a successful solo career with songs such as the theme song for Grease, and “Can’t Take My Eyes Off You” that was covered by hundreds of artists, from The Pet Shop Boys to Muse. Younger generations got to know Valli from the remarkable musical “Jersey Boys” that tell the story of the band that is responsible for songs that became a part of our life’s soundtrack for over four decades and was turned into a movie which was directed by Clint Eastwood.
// 							</p>
// 							<p>
// 								Ever since he began, Frankie has been performing all over the world, and soon the magic will come to Tel Aviv for one unforgettable show.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:12,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Unite With Tomorrowland",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											29.07.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tomorrowland.com/en/unite-israel/en/welcome">
// 											www.tomorrowland.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/12/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous Tomorrowland festival might take place in Belgium, but Tel Aviv is also up for the party! Unite with Tomorrowland brings the party to the hottest city in the Middle East with live connection from the Tomorrowland Mainstage, live local and international DJ’s on the UNITE stage and of course – the magical Tomorrowland atmosphere.
// 							</p>
// 							<p>
// 								The live connection with the Mainstage in Belgium will give the People of Tomorrow the chance to connect with the crowd in Israel and vice versa. 3 mainstage headliners will be broadcasted live on a unique UNITE with Tomorrowland stage and special effects will be synchronized with the show in Belgium, creating a special global connection.
// 							</p>
// 							<p>
// 								The main headliners in Belgium will be Armin Van Buuren who has won best trance DJ at the DJ Awards 9 years in a row, was ranked among the world’s top 4 DJ’s at DJ Magazine 13 years in a row, the known electro-house duo Dimitri Vegas & Like Mike and the house sensation KSHMR. On the UNITE stage in Israel the DJs will be Steve Angello who won the DJ award for best house in 2010, the Israeli trance artist Alien Project, DJ Tomer Maizner, Dor Dekel, Teamworx, and TRIPL.
// 							</p>
// 							<p>
// 								EUnite with Tomorrowland isn’t just a livestream, it’s a one of a kind show that allows you to escape reality and join the magical world of tomorrow.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:13,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Chainsmokers",
//         smltitle: "The world’s number one leading EDM festival is coming to Tel Aviv! ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											NEAR Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											3.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thechainsmokers.com/">
// 											www.thechainsmokers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/13/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Tel Aviv is known for its great dance scene, so it makes perfect sense that the hottest DJ/production duo that everyone is talking about to come to get the city on its feet! The duo is responsible for many current hits such as “Don’t let me go”, “Roses”, and their recent collaboration with Coldplay “Something Just Like This”, and they will perform in Israel as part of their international tour “Memories Do Not Open”.
// 							</p>
// 							<p>
// 								The Chainsmokers consists of Andrew Taggart and Alex Pall. The duo performed live for the first time as the opening for Timeflies in 2014, and their single "#Selfie" was re-released at the same year, leading to breakthrough success as "#Selfie" became a worldwide hit and peaked on the Dance/Electronic chart. In 2015 they released their first EP “Bouquet”, featuring “New York City”, “Until You Were Gone, “Good Intentions” and “Roses”, all of which climbed the international charts and became major hits.
// 							</p>
// 							<p>
// 								A year later, the duo released their singles “Don’t Let Me Down” featuring Daya, “Inside Out”, featuring Charlee, and “Closer” featuring Halsey. The latter peaked at number one in the United Kingdom and the United States. Their success didn’t stop there and after releasing “All We Know” featuring Phoebe Ryan, they were ranked 18th in DJ Magazine’s annual list of “Top 100 DJ’s” in 2016. The same year the duo won favorite electronic/dance music artist at the American Music Awards and top dance/electronic artist at the Billboard Music Awards. A year later “Closer” also won top hot 100 songs, top collaboration and top electronic/dance song at the same Awards ceremony.  “Don’t Let Me Down” also won best dance recording in 2017 at the Grammy awards.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:14,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Dire Straits Experience",
//         smltitle: "Get a shiver in the dark in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.09.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.direstraitsexperience.com/">
// 											www.direstraitsexperience.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/14/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								25 years have passed since Dire Straits disbanded and we last heard that unmistakable sound of Mark Knopfler’s guitar…
// 							</p>
// 							<p>
// 								Close your eyes and get transported back to an original Dire Straits gig. Beautiful inspiring tracks, quality sound, amazing atmosphere, spine tingling riffs, vocals, instrumentals and an outstanding performance.
// 							</p>
// 							<p>
// 								After selling over 25,000 tickets in Israel within the past three years, and in light of the high demand for yet another show, The Dire Straits Experience are coming to Tel Aviv for only one night.  A single performance on the 14th of September at the Menora Mivtachim Arena.
// 							</p>
// 							<p>
// 							   The Dire Straits Experience was founded by saxophonist Chris White after their successful debut playing for a charity event at the Royal Albert Hall where members of the legendary band got back together on stage. News travelled fast, and an increasing global demand to hear the most dramatic songs in rock history played live eventually led to a worldwide tour.
// 							</p>
// 							<p>
// 							    Chris White, who recorded and performed with the rock legends for over a decade, joined Dire Straits for their record breaking “Brothers in Arms” world tour in 1985. This included their famous performance at Live Aid and later the renowned Nelson Mandela 70th birthday concert. White has played with some of the greatest rock stars the world has known, such as Paul Mccartney, Joe Cocker, Mick Jagger, Robbie Williams and many others. Joining Chris White is a stellar band consisting of some of the finest professional musicians the UK has to offer.
// 							</p>
// 							<p>
// 							   “When I was first approached to put together a band to play Dire Straits songs, I didn’t believe it would be possible to find someone who would be able to stand in Mark’s shoes without sounding like an imposter. I was wrong. In Terence Reis, I think we may have found the only person on the planet that is able to play and sing like Mark but maintain his own integrity and identity.”
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:15,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alan Parsons",
//         smltitle: "The man that said no to Pink Floyd, live in TA",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											11.11.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.alanparsonsmusic.com/">
// 											 www.alanparsonsmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/15/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The musical legend Alan Parsons and his band are coming to Israel for two shows, the first at the Congress Centre in Haifa and the second at the Menorah Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 								Parsons has a large following in Israel. In fact, this will be his third visit to the country in order to play on stage. This time they’ll be performing their new “I Robot” tour, commemorating 40 years for the release of the similarly titled mythological album in 1977. You can expect to hear all of their greatest hits of course.
// 							</p>
// 							<p>
// 								Alan Parsons is a renowned musician and one of the most influential musical producers in history. He started out as a sound technician working in the notorious Abbey Road recording studio. Alan became famous after helping to produce Pink Floyd’s masterpiece album “Dark Side of the Moon”. He has worked as a sound technician with others such as The Beatles, Wings, Al Stewart and many more.
// 							</p>
// 							<p>
// 							   In 1975, Pink Floyd invited him to work on their next album “Wish You Were Here”. Alan declined the offer in order to form his progressive rock band “The Alan Parsons Project”. The band succeeded immediately, receiving international acclaim for their huge hits “Eye in the Sky”, “Time” and “Old and Wise” to name a few.
// 							</p>
// 							<p>
// 							   An accomplished vocalist, keyboardist, bassist, guitarist and flautist receiving gold and platinum awards from many nations, Parsons also has ten Grammy Award nominations for engineering and production. Up until today The Alan Parsons Project is one of the most popular events in Europe, with tickets being sold out within hours.
// 							</p>
// 							<p>
// 							   Come indulge your ears and listen firsthand to some of the classics of our time. You can catch the concerts either in Haifa on the 9th of November or in Tel Aviv on the 11th of November.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:16,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Bryan Adams",
//         smltitle: "Bryan Adams to warm our winter with 3 shows",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv & Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											4+5+6.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bryanadams.co.il/">
// 											 www.bryanadams.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/16/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								With the summer days way behind us and the days getting shorter, a little winter comfort is necessary. What better way to warm up from the inside than with some romantic ballads and timeless rock anthems. Treat yourself (and someone you love) to a throwback of nostalgia from our younger days, reminding us those sweet moments of slow dancing, first crushes and innocent youth.
// 							</p>
// 							<p>
// 								The Canadian pop rock icon with hits spanning over four decades is coming to Israel for three consecutive shows! Two will performances in Tel Aviv on the 4th and 5th of December at the Menora Mivtachim Arena and one more concert in Jerusalem on the 6th of December at the Pais Arena.
// 							</p>
// 							<p>
// 								Born in 1959 in Kingston, Ontario, Bryan Adams’ music career took off in the early 80’s with the release of his third album “Cuts Like A Knife” which included the hit “Straight From The Heart”. It was his following album “Reckless” that skyrocketed his career and brought his rise to stardom with the hits “Run To You”, “Heaven” and “Summer of ‘69”. Following these hits Adams later brought us the U.S. Billboard Hot 100 number-one singles "Heaven", "All for Love" and "Have You Ever Really Loved a Woman?".
// 							</p>
// 							<p>
// 							  Besides topping the charts in North America and Europe, his songs were nominated for several Grammy, Golden Globe and Academy Awards. His records have collectively sold over 100 million copies worldwide, making him one of the best-selling music artists of all time.
// 							</p>
// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>
// 							<p>
// 							   He’ll be performing songs from the “Get Up” tour being held for his similarly titled thirteenth (and most recent) album from 2015. No reason to worry though, we’re sure he’ll serenade us with his biggest hits and favorite crowd pleasers.
// 							</p>
// 							<p>
// 							   Make sure you don’t miss this time-defying legend.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:17,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Chris Rock",
//         smltitle: "Coming to Tel Aviv to rock your world ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											8+9.01.18
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.chrisrock.com/">
// 											 www.chrisrock.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/17/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Chris Rock, one of the greatest standup comedians of all time and the funniest people in the world is going on a rare, highly awaited tour for the first time in 9 years. One of his few stops will be in Tel Aviv.
// 							</p>
// 							<p>
// 								The hilarious comedian has put on a new live act, after nearly a decade of focusing on television and film. Chris Rock will make his first ever live on stage appearance in Israel as part of his 2017 “Total Blackout” tour.
// 							</p>
// 							<p>
// 								Born in 1965, he made his breakthrough on SNL (Saturday Night Live) starring next to Adam Sandler, David Spade and Chris Farley. Eddie Murphy helped accelerate his stardom by giving him a role in Beverly Hills Cop 2. Since then it’s been a long line of success, from Lethal Weapon 4, Madagascar, Scary Movie, Nurse Betty and the list goes on. He’s hosted the Academy Awards twice and has also written, directed and produced several movies and TV shows. Despite all this, Chris Rock has and always will shine brightest where he truly belongs, on stage with a microphone.
// 							</p>
// 							<p>
// 							  His previous standup acts: Bigger and Blacker, Born Suspect, Bring the Pain and Kill the Messenger all broke records and are considered to be classics, with bits that are still quoted today.
//                               Rock is often compared to the greatest comedians in the field, alongside Jerry Seinfeld, Louis CK and Dave Chappelle (all of which he’s also collaborated with).
// 							</p>
// 							<p>
// 							   He made it to the top 5 in Rolling Stone magazine’s 50 greatest comedians of all time.
// 							</p>
// 							<p>
// 							   When he gets on stage it’s like seeing a boxer, a preacher and a poet all bundled together into one man. Chris delivers powerful, fast paced, side-splitting punches. His views on relationships, race and politics challenge his listeners and make them rethink everything they know. Rock dares to cross boundaries with his material and is not afraid to shock and surprise.
// 							</p>
// 							<p>
// 							   In an interview he recently gave to Rolling Stone magazine, he talked about his divorce after 18 years of marriage and how he decided to devote himself to standup again. According to him, these events gave rise to the world tour in which he will be performing in Tel Aviv.
// 							</p>
// 							<p>
// 							   Catch Chris live on January 8th at the Menorah Mivtachim Arena.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:18,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Patricia Kaas",
//         smltitle: "The great French singer returns to the white city once again",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.patriciakaas.net/">
// 											  www.patriciakaas.net
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/18/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The famous French singer and actress Patricia Kaas is coming back to Tel Aviv for the third time after her previous performance three years ago became a huge success and recieved incredible reviews. Kaas is considered one of the all-time most successful French singers and her music is a mix of pop, cabaret, jazz, and chanson. She started her career in the late 80’s and very quickly she climbed the charts in France.
// 							</p>
// 							<p>
// 								Kaas’s first single “Mademoiselle chante le blues” that came out in 1987 became a huge hit and got to the top 10 in the French chart. A year later she released her second single “D’Allemagne”, followed by her first album “Mademoiselle chante…” that was ranked number two at the French chart. The album sold over 100,000 copies within less than two months and became a gold album. It didn’t take long and within less than three months more than 350,000 copies were sold and it became a platinum album. Kaas received a platinum album status in Belgium, Switzerland and Canada as well, and at the same year she won the most important French music award – Victories de la Musique.
// 							</p>
// 							<p>
// 								Since then the French phenomenon sold more than 17 million albums worldwide. Her third album “Je te dis vous” brought her major success in Germany, Belgium, Switzerland, Canada, Russia, Finland, Ukraine and Korea. In 2002 she acted in a movie for the first time, it was “And now… Ladies and Gentlemen” in which she performed with the British actor Jeremy Irons. In 2009 she represented France at the Eurovision contest and got to the 8th place.
// 							</p>
// 							<p>
//                                    Patricia Kaas is responsible for many hits and her songs became a part of our lives. The talented musician is coming back to Tel Aviv to sing her famous repertoire and bring back the nostalgia to the nonstop city.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:19,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blue Man Group",
//         smltitle: "The phenomenal musical group is returning to Tel Aviv once again for a show like no other!  ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											 7-23.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.blueman.com/">
// 											  www.blueman.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/19/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Blue Man Group is coming to Tel Aviv as a part of their 25 years of living in full-color tour! This is a show unlike anything you have ever seen before that combines music, theater, art and technology.
// 							</p>
// 							<p>
// 								Originally Formed in New York in 1988 by three close friends, Chris Wink, Matt Goldman and Phil Stanton, Blue Man Group originated as a celebration of the end of the 1980s. The three men wore blue masks and led a procession that included the burning of a Rambo doll and a piece of the Berlin Wall. They caught the eye of an MTV reporter and gained attention. They started with small acts on the streets of New York, growing into shows at downtown clubs, eventually becoming a full performance at the Astor Place Theatre in 1991.
// 							</p>
// 							<p>
// 								In 1999 the band released its first gold album “Audio” and it was nominated for the Grammy Award for Best Pop Instrumental Performance. Their second album, “The Complex” (2003), features collaborations with various musicians like Gavin Rossdale, Dave Matthews and many others. It charted four songs on the Billboard charts. In 2006 they released “Live at The Venetian – Las Vegas” which was an iTunes exclusive, and their most recent album, “THREE”, came out in 2016 and was also nominated for the Grammy Award.
// 							</p>
// 							<p>
//                                  Currently, the Blue Man Group is performing on a regular basis in five theaters around the world- in Vegas, New York, Boston, Orlando and Berlin. They recently launched their new book “Blue Man World” that tells the story of the blue man from their perspective.  Three blue people that will take you on a crazy adventure full of music, laughter and surprises. More than 35 million people worldwide have already seen them, not it’s your turn!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:20,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Sean Paul",
//         smltitle: "The international mega star is coming to make our summer sizzle!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv Outskirts
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.08.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.allseanpaul.com/">
// 											  www.allseanpaul.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/20/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Grammy winner dancehall artist, Sean Paul will return to Tel Aviv for a single hot hot hot hot performance.
// 							</p>
// 							<p>
// 								Sean Paul will arrive in Tel Aviv for the third time as part of his new international tour. The artist is currently storming the international charts with a string of hits that including collaborations with some of the most popular names in music including Sia, Anne-Marie and more.
// 							</p>
// 							<p>
// 							    His extraordinary voice, rhythms, catchy songs and super-polished productions all combine the winning recipe of the Grammy winner and international star - Sean Paul. Originally known as Sean Paul Ryan Francis Henriques, Sean Paul was born in Jamaica in 1973. His musical career soared in 2002 with the tremendous success of his second studio album, "Dutty Rock," mainly for the songs "Gimmie The Light" and "Get Busy" Hot 100 chart toppers). Sean Paul has managed to maintain his relevance in the music industry since breaking into fame in the year 2000 until now with a string hits such as Cheap Thrills, Rockabye, No Lie, and Body.
// 							</p>
// 							<p>
// 							   Sean Paul studied at the University of Technology in Jamaica with aspirations for a career in the hotel industry, but his passion for music took over. The single ‘Baby Girl’ was the first to mark his successful career as a recording artist and led to his debut album ‘Stage One’ at VP Records. To date, he has released six studio albums; the last five were all nominated for the Grammy Award.
// 							</p>
// 							<p>
// 							   The album "Dutty Rock," 2002, earned him the Grammy Best Reggae Album. "The Trinity," 2005, reached platinum status in Europe and the Recording Industry Association in the United States. His albums, "Imperial Blaze" in 2009 "Tomahawk Technique" in 2012, and the last one was released in 2014 - "Recent Full Frequency" – were all warmly received and highly acclaimed.
// 							</p>
// 							<p>
//                                   His hard work, perseverance, and dedication over the years have earned him several nominations for the Grammy and Billboard awards. His most notable accomplishments include An American Music Award, Mobo Awards, Soul Train Awards, MTV Music Awards, ASCAP Rhythm and Soul Music Awards, a Source Award and a BET Award.
// 							</p>
// 							<p>
//                                 Sean Paul maintains a multinational presence thanks to his collaborations with artists in a wide variety of genres such as EDM, Soca, Pop, Afro-Beat and Latin music. His icon status allows him to maintain an immense fan base in Latin America, Japan, Europe and the US and his relationship with the Spanish audience received a serious boost, following his collaboration with the singer Farruko in the single Passion Whine and of course the legendary collaboration with Enrico Iglesias ‘Bailando’ which became no.1 in 33 (!) countries and gained millions of views on YouTube.
// 							</p>
// 							<p>
//                                Sean's collaborations throughout his career include numerous international collaborations with hip-hop stars such as Busta Rhymes, Beyoncé, Rihanna, Keyshia Cole, Kelly Rowland, Juicy J, 2Chainz and Nicki Minaj.
// 							</p>
// 							<p>
//                                Sean Paul performs regularly on the biggest most respectable venues in the world and enjoys a huge following from a worldwide audience of all ages.
// 							</p>
// 							<p>
//                                His last performance in Tel Aviv received fantastic revues from critics and fans alike, and he is back on popular demand, promising to make the hot summer scorch even more with a what is guaranteed to be a party like no other!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:21,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "The Pretenders",
//         smltitle: "The legendary rock band and Chrissie Hynde are coming to rock out Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23.09.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thepretenders.com/">
// 											  www.thepretenders.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/21/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								For the past three decades Chrissie Hynde and The Pretenders stayed at the top of the British rock and won the hearts of millions of fans. Hynde took a long break from writing and recording new materials but after the raving reviews the band’s most recent album, “Alone” got, she and The Pretenders are back on a world tour and are now coming for one unforgettable show in Tel Aviv!
// 							</p>
// 							<p>
// 								The band started its way in the music world in England in 1978 and experienced numerous subsequent personnel changes, with Chrissie Hynde being the only consistent member. The original band was active until 1982 and released its first album (Pretenders) that was a success in the United Kingdom and the United States both critically and commercially. The band got to No. 1 in the UK with its single "Brass in Pocket", which was also successful in the US, reaching No. 14 on the Billboard Hot 100.
// 							</p>
// 							<p>
// 								Later on the band released nine more albums - Pretenders II (1981), Learning to Crawl (1984), Get Close (1986), Packed! (1990), Last of the Independents (1994) which was rated gold in the US, Viva el Amor (1999), Loose Screw (2002), Break Up the Concrete (2008) which was among the Top 40 album in the US, and The Pretenders’ most recent album - Alone (2016). During March 2005, the Pretenders were inducted into the Rock and Roll Hall of Fame. Among their most famous song one can remember “Brass in pocket”, “Hymn to her”, “Don’t get me wrong”, “I’ll stand by you”, and many others.
// 							</p>
// 							<p>
//                                   The Pretenders worked carefully on their new show and started their new tour at the Royal Albert Hall in London, which was full with fans that showed how much they missed the incredible band. Hynde and The Pretenders performed in music festivals all over the world, and they’ll start the second part of their tour right here in the rocking city of Tel Aviv, make sure not to miss it!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:22,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Cliff Richard",
//         smltitle: "The incomparable Cliff Richard coming back to Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.cliffrichard.org/">
// 											  www.cliffrichard.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/22/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Cliff Richard, the beloved British artist who previously performed in the fabulous city of Tel Aviv more than 20 years back, is coming back to the delight of his local fans.
// 							</p>
// 							<p>
// 								Over his long and illustrious career, the 72-year-old Cliff Richard has sold more than 260 million records worldwide and is best known for his tunes "Fallen angel Woman," "We Don't Talk Anymore," "The Young Ones," "Summer Holiday," and "Congrats" .
// 							</p>
// 							<p>
// 								Richard has a long list of hits and is responsible for many worldwide beloved songs. He has sold over 21 million singles in the UK and has become an intrinsic part of the nation’s soundtrack.
// 							</p>
// 							<p>
//                                  Richard has had eight US Top 40 singles, including the million-offering "Demon Woman" and "We Don't Talk Anymore". In Canada, Richard made a real splash during the mid-1960s, and again in the late 1970s and mid-1980s with a few singles and collections achieving gold and platinum status. He has remained a prominent music, film, and TV character in Australia, New Zealand, South Africa, Northern Europe and Asia, and has a strong following.
// 							</p>
// 							<p>
// 							   Throughout his career, spanning over 50 years, Richard has amassed numerous gold and platinum records and awards, including three Brit Awards—winning Best British Male Singer twice and the Brit Award for Outstanding Contribution to Music, as well as two Ivor Novello Awards. He has had more than 130 singles, collections and EPs make the UK Top 20, more than any other artist.
// 							</p>
// 							<p>
// 							   Richard has had 67 UK top ten singles, including one written for the great Elvis Presley.  He has had 14 UK No. 1 singles and is the leading vocalist to have had a No. 1 single in the UK in five back to back decades: the 1950s through to the 1990s.
// 							</p>
// 							<p>
// 							   This October, after much anticipation, Cliff Richard is coming to Tel Aviv to sing his mind-blowing songs live, in his unmatchable performing style. Come watch the living legend himself on-stage in the exciting city of Tel-Aviv!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:23,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "DGTL Festival",
//         smltitle: "An awesome digital celebration in the one of the world’s Digital Capitals",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/?skip_portal=1">
// 											  www.tlv-digital.nl
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/23/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The first ever of its kind in the country, the DGTL festival is a dream come true for the music and nightlife scene of this buzzing metropolis. The DGTL festival is set to be by far the biggest electronic music event held in Tel Aviv, which is considered one of the nightlife capitals of the world.
// 							</p>
// 							<p>
// 								DGTL Festival, making its Tel Aviv debut this October originates in Holland and takes place each year in the most trendy capitals including Amsterdam, Sau Paulo, and Barcelona.
// 							</p>
// 							<p>
// 								The festival is an innovative technology centered event showcasing some of the world’s greatest biggest names in the digital scene alongside new hot up and comers from the industry. Tickets are often sold out in advance, and dozens of DJs and leading artists show off their talents in this a multi-sensory experience of art, music, lighting and uncompromising production standards throughout the:
// 							</p>
// 							<p>
//                                The festival has a unique and electrifying atmosphere, and audiences will also get to enjoy a variety of food stalls, art, and meticulous sound.
// 							</p>
// 							<p>
// 							   The festival will include three stages featuring excellent music at any given moment.
// 							</p>
// 							<p>
// 							   The fantastic international line up is set to include:
// 							</p>
// 							<p>
// 							  Maslow Flux, Marcel Dettman, John Talabot, Red Access, Jennifer Cardini, Avalon Emerson, Young Marko, Yotam Avni, Otarki, Joba Jobsa and many others.
// 							</p>
// 							<p>
// 							  This huge production will be launched for the first time in October 2017. In addition to being an innovative music festival, DGTL is held under the theme of environmental preservation and sustainability and is considered the greenest festival in Europe. Also, DGTL festival promotes vegetarian food only and develops a unique program for recycling materials. Alongside the local audience, the festival will be marketed in 50 countries, and thousands of music fans from all over the world are expected to arrive in Tel Aviv to take part in the party.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:24,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Richard Clayderman",
//         smltitle: "The famous pianist returns to perform in Israel with all his unforgettable hits!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.clayderman.co.uk/">
// 											  www.clayderman.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/24/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Romance lovers, prepare yourselves – after his last show in Israel three years ago, the famous French pianist Richard Clayderman returns to the holy land as a part of his new tour that marks 40 years of an outstanding career!
// 							</p>
// 							<p>
// 								Clayderman recently turned 63 and he is one of the world’s most successful pianists with a rich and diverse career that started four decades ago. He recorded over 1200 songs and his biggest hit ever is “Ballade Pour Adeline” that was sold in 22 million copies in 38 different countries. Clayderman is considered one of the world’s most successful instrumental artists along with others like Kenny G and more.
// 							</p>
// 							<p>
// 								During his career, Richard Clayderman sold more than 85 million albums and had more than 340 gold and platinum albums. He created a new romantic style through a repertoire that combines his original melodies with classics and pop standards. The phenomenal artist devoted much of his time to performing, going as far as playing 200 shows in 250 days. The Guinness Book of World Records noted him as “the most successful pianist in the world”.
// 							</p>
// 							<p>
//                                His previous visits in Israel were extremely successful with multiple sold out concerts. In his upcoming shows in Israel, Clayderman will play a selection of his best pieces, including the 12 minutes of the “Titanic Symphony”, “Don’t Cry for Me Argentina”, “Love Story”, “Ballade Pour Adeline”, and song from other famous movies such as “West Side Story”, “Harry Potter Melody” and “The Schindler List”. Come listen to the outstanding pianist who has touched the heart of millions around the world!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:25,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Smokie",
//         smltitle: "Smokie, coming to light up the stage this fall in Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv + Jerusalim
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28+31.10.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//smokie.co.uk/Band">
// 											  www.smokie.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/25/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Smokie, the iconic British rock band is coming back to Tel Aviv to rock it out in the city this fall.
// 							</p>
// 							<p>
// 								Smokie initially rose to fame in the 1970's and is most know for its chart topping hits 'Living Next Door to Alice', 'Lay Back in the Arms of Someone', and "If You Think You Know How to Love Me.'
// 							</p>
// 							<p>
// 								The band has had 13 top twenty hits during the 1970s and has sold more than 30 million albums.
// 							</p>
// 							<p>
//                               Initially formed in Yorkshire, England, in 1966, Smokie hit the British pop charts a few times amid the late '70s with a fresh pop style.  The quartet recorded many singles amid the late '60s and mid '70s, and in 1975 hit number three in the U.K. with "If You Think You Know How to Love Me."
// 							</p>
// 							<p>
// 							   After another Top Ten hit, "Don't Play Your Rock’n’ Roll to Me,” the band made it big with three Top 20 hits, including "Living Next Door to Alice." Smokie hit number five both in 1977 ("It's Your Life") and 1978 ("Oh Carol(".
// 							</p>
// 							<p>
// 							   The band has performed in Tel Aviv several times and are returning shortly after their last visit to the non stop city with an extremely successful run two years ago. The Tel Aviv concert will be a part of the band’s new tour which includes England and many countries around Europe and which also includes musicians Martin Bullard, Mick McConnell, Mike Craft, Steve Pinnell and Terry Uttley.
// 							</p>
// 							<p>
// 							    Smokie’s songs have gained iconic status over the years and have been covered multiple times due to their catchy style. The band enjoys a strong fan base in the country and regularly fills every seat in the house in each of their performances. The band will be playing its greatest hits to the joy of their fans which will flock to see the rock legends in action in Tel Aviv.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:26,
//         bgImage :"/posts/bank/15/1.jpg",
//         mobBgImage :"/posts/bank/15/M.jpg",
//         title: "Foreigner",
//         smltitle: "The 80's are back to rock Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											  www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/26/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The 80's are coming back! The British-American hard rock group is returning once again to the amazing city of Tel Aviv. The band is returning to Israel again after 3 sold out concerts in the past – one in 2014 and two in 2016, which got incredible reviews.
// 							</p>
// 							<p>
// 								Foreigner was founded in New York in 1976 by veteran English musician Mick Jones, ex-King Crimson member Ian McDonald and American vocalist Lou Gramm. The band focused more on commercial rock and is remembered mostly for its soft ballads that topped the charts worldwide.
// 							</p>
// 							<p>
// 								The rock group released its debut album in 1977 which provided one of its most popular hits "Cold As Ice", but the band's real breakthrough happened in the early 1980's when they released the album "4". Their success continued as they released their next album "Agent Provocateur" in 1984, as well as in their last one- "Can't Slow Down", in 2009.
// 							</p>
// 							<p>
//                               The band has sold over 80 million records worldwide in the past 3 decades, out of them 37.5 were sold in the United States alone, making it one of the bestselling bands in the history. Their most memorable hits include "Waiting for a Girl Like You", "I Want to Know What Love Is", "Urgent", "Juke Box Hero", and "That Was Yesterday".
// 							</p>
// 							<p>
// 							  Come rock with the American-British legend and bring the 80's back to life in a one of a kind concert!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:27,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Carcass",
//         smltitle: "The British metal legends are coming <br>to rock the city that never sleeps!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/OfficialCarcass/">
// 											  facebook.com/OfficialCarcass
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/27/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The British extreme metal band was formed in 1985. They started as a school band by Bill Steer and Ken Owen, and the latter left the band soon after. Steer then joined the D-beat band Disattack and played with drummer Middie, bassist Paul and the lead singer Andrew Pek. The band later changed its name to Carcass as the members changed their musical direction. The band recorder only one album with Pek, who changed his name to Sanjiv, and shortly after "Flesh Ripping Sonic Torment" was released he left the group.
// 							</p>
// 							<p>
// 								The vocal duties were shared between Walker, Steer and Owen, and together they recorded a debut album in only four days.  The band wasn't pleased with the poor production of their album "Reek of Putrefaction" but it became a favorite of Radio 1 DJ John Peel. His interest in them made them participate in his first "Peel Session", in which they released materials for their second album.
// 							</p>
// 							<p>
// 								Carcass are considered to be the pioneers of the grindcore genre, although their early work is considered to be more splatter death metal, hardgore and goregrind. The band also became one of the pioneers of melodic death metal with their album "Heartwork" which was released in 1993. Their lyrics usually focus on animal rights issues, as both Jeff Walker and Bill Steer are vegetarians.
// 							</p>
// 							<p>
//                               In 2013 the band signed with Nuclear Blast, and in Japan they signed with Trooper Entertainment for the release of their new album. They released "Surgical Steel", which received extremely positive reviews and earned Top 50 position on the US Billboard 200 charts. Soon afterward they headlined Damnation Festival in Leeds and then performed at 70000 Tons of Metal in 2014 and headlined the Agglutination Festival the same year.
// 							</p>
// 							<p>
// 							   The band is coming to give only one show in the nonstop city of Tel Aviv, which is guaranteed to be an extraordinary experience for all the metal fans out there, make sure to get your ticket now!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:28,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Kygo",
//         smltitle: "The Norwegian house phenomena for the first time ever in Tal Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.kygomusic.com/">
// 											  www.kygomusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/28/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Kygo, originally a Norwegian pianist, became a tropical house music producer in no time. "Spotify" announced him as the biggest discovery of 2015 after his songs "Firestone" and "Stole the Show" were played over a billion times. Both of these songs also received gold and platinum status in 16 countries.
// 							</p>
// 							<p>
// 								His first album, "Cloud Nine", reached the top of the dance albums chart on "Itunes" and also on the electronic albums chart of Nielsen Soundscan. The house sensation preformed in the most popular TV shows in the United States such as "The Late Late Show" with James Corden, "The Tonight Show", "Good Morning America" with Jimmy Fallon and on Ellen Degeneres. Moreover, he was on the cover of the biggest magazines – "The Billboard", "Haute Living Magazine", "LA Times", "USA Today", "The Wall Street Journal", "The Rolling Stones", "Forbes" and more.
// 							</p>
// 							<p>
// 								Kygo started his musical journey at the age of 6 when he started learning how to play the piano. It took almost a decade for the classical music to step aside and for the new love in his life to take over – Electronic music. He only decided that he wants a career in the music industry a moment before he was about to graduate from his economics and business degree.
// 							</p>
// 							<p>
//                               His first significant breakthrough was with the hit "Firestone" that shortly grabbed the attention of tens of millions of listeners. Aviici played it in his sets and in festivals. Afterwards Coldplay's lead singer, Chris Martin, gave him permission to create a remix of their song "Midnight". Kygo's unique sound led him to incredible achievements, such as the hit "ID" that was featured in Ultra Festival's official trailer and in the playlist of FIFA 2016.
// 							</p>
// 							<p>
// 							  The extraordinary house sensation is coming to rock Tel Aviv for the first time ever, for one show only. His shows in New York and Hollywood were sold out, and the reviews were incredible. This is guaranteed to be a night to remember, you definitely want to be there!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:29,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Led Zeppelin 2",
//         smltitle: "Don’t Miss the Zeps in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv, Haifa and Be'er Sheva
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											07-10.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//zep2.com/">
// 											  www.zep2.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/29/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The tribute band from Chicago Led Zeppelin 2, which was named after the mythological band's second album, is coming to Israel for 4 shows only. Come feel the old Led Zeppelin vibes and kick it with the ultimate Led Zeppelin experience here in rocking Tel Aviv
// 							</p>
// 							<p>
// 								Led Zeppelin 2 have been performing  for over a decade and are considered to be the ultimate Led Zeppelin experience. The band consists of 4 musicians from the indie-rock, jazz and metal scene in Chicago. The lead singer, Bruce Lamont, who took the place of the legendary Robert Plant, is also a part of the avant-garde metal group "Yakuza", and he has collaborated with bands like "Dyslexic Apaches", and "Circle of Animals". His solo album "Feral Songs for The Epic Decline" was recently rated among SPIN magazine's top 20 metal albums.
// 							</p>
// 							<p>
// 								Greg Fundis, the group's drummer, is playing with leading musicians among which one can find the singer and jazz guitarist George Benson, the musician Joey De Francesco, the saxophonist Joe Lovano and more. The bassist Matthew Longbons participates in more than 200 shows a year next to leading international artists such as Alice Cooper and Matt Walker from the "Smashing Pumpkins". Paul Kamp, the group's guitarist, is known mostly from his collaboration with "Busker Soundcheck", a well-known alternative rock band.
// 							</p>
// 							<p>
//                              Led Zeppelin is considered until today to be one of the most revolutionary, influencing and successful bands in the history. They sold more than 300 million albums worldwide, with 'Led Zeppelin IV' alone selling over 37 million copies and being ranked as the third all-time best-selling album in the U.S. All 9 of the band's albums were rated in the top 10 in the U.S. chart, and 6 of them even top over the top 5. Their second album that was recorded during their first tour was a huge success both in the U.S. and in the UK, and it featured the hit 'Whole Lotta Love' that sold over a million copies.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:30,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Oh Wonder",
//         smltitle: "Live in Tel Aviv for the first time ever!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ohwondermusic.com/">
// 											  www.ohwondermusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/30/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Oh Wonder consist of Josephine Vander Gucht and Anthony West. In 2014 they started releasing singles every month and then they combined all of them and released a debut album that's named after them and sold over 500 million copies. This year they released their second album, "Ultralife", which had even a bigger success and reached the Top 10 in the UK charts.
// 							</p>
// 							<p>
// 								In 2015 the duo was announced by Billboard as one of the 5 biggest breakthroughs. They come to Israel this year after a long tour and performing in the biggest festivals around the world as part of the promotion of their new album, which includes hits such as "Without You" and "Drive".
// 							</p>
// 							<p>
// 								Gutcht and West played sold out shows in New York, Los Angeles, Paris and London, and now they're coming for one show only to give the people of Tel Aviv a taste of their alt-pop hits. The successful duo is guaranteed to get you dancing and give the ultimate pop experience, this will be one night in Tel Aviv you are sure to remember.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:31,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Ott & The All Seeing I",
//         smltitle: "Electro explosion in the city that never sleeps",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//ottsonic.com/">
// 											  www.ottsonic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/31/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Ott and the All Seeing I are coming to take Tel Aviv by a storm this December.
// 							</p>
// 							<p>
// 								Ott is considered to be one of the pioneers of calm, groovy electronic music and likes to record the sounds of nature in his mobile studio, with which he tours England. The British record producer and musician has worked with Sinead O'Connor, The Orb, Brian Eno and Embrace, and has achieved recognition since 2002. He's known for psychedelic dub tracks and his collaborations with other artists. He has released two albums on Twisted Records – "Blumenkraft" in 2003 and "Skylon" in 2008, and two other albums on Ottsonic – "Mir" in 2011 and "Fairchildren" in 2015.
// 							</p>
// 							<p>
// 								The electro genius performed at the Glastonbury Festival in 2007, and then in 2011 he performed at Glade Festival, a show that was described as "the perfect opening act" in an article at Virtual Festivals. The same publication also called Ott a "Psy-dub maestro" and ranked his performance 10/10. The Israeli crowd was first exposed to Ott in the early 2000's with the album "Hallucinogen in Dub", the remix album he produced for Simon Posford. All the albums he released later only enhanced the effect he has with his powerful and addictive music.
// 							</p>
// 							<p>
// 							   The All Seeing I are an English electronic music group from Sheffield, consisting of Dean Honer, Jason Buckle and DJ Parrot. Their first single "I Walk" came out in 1997, but it was only in the following year that they gained mainstream commercial success with the song "Beat Goes On". The trio worked with artists such as Tony Christie, Jarvis Cocker, Babybird, Phillip Oakey and many others.
// 							</p>
// 							 <p>
// 							    Ott has performed Tel Aviv twice in the past and his shows received incredible reviews. This is guaranteed to be a one of a kind night that you definitely don't want to miss!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:32,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Take That",
//         smltitle: "Take That – Taking Tel Aviv By Storm!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//takethat.com/">
// 											  www.takethat.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/32/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The legendary British pop band is this coming November to rock Tel Aviv for one show only!
// 							</p>
// 							<p>
// 								Take That started in Manchester in 1990 and currently includes Mark Owen, Gary Barlow, and Howard Donald. The original band also featured Robbie Williams and Jason Orange. Barlow is the band's lead singer and songwriter, while Owen and Donald act as backing vocals.
// 							</p>
// 							<p>
// 								Their most memorable songs include "Pray" which won The Guardian Music Award for Best Number 1 Single, "Back For Good" which won BRIT Award for Best British Single, "Everything Changes" and "Could It Be Magic." The band released 28 top 40 singles and 17 top 5 singles in the United Kingdom, out of which 12 reached number one, and they have 7 number one albums. Internationally, the band released 56 number one singles and 37 number one albums. They won 8 Brit Awards, including awards for Best British Live Act and Best British Group.
// 							</p>
// 							<p>
// 							   The British pop sensation set the record in 2011 for the fastest-selling tour of all time in the United Kingdom with "Progress Live", beating their own personal record from 2009 with their "Circus Live Tour". They were named as Amazon's top-selling music artist of all time, and in 2012 Forbes announced them as the fifth highest-earning music stars in the world. During the same year, the Official Charts Company announced the biggest-selling singles artists in the British music chart history with Take That being placed at 15th overall and having four of the best-selling albums of the millennium, which makes them the most successful boy band in the UK chart history.
// 							</p>
// 							 <p>
// 							   The band will come to Israel as a part of its international tour in order to promote its last album "Wonderland". Their previous tours have gotten raving reviews, with "Progress" winning Audio Pro International Awards for Best Live Sound Event and Audio Pro International Awards Grand Prix Award. Their performance in Tel Aviv will for sure be a one to remember, don't miss out!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:33,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Kooks",
//         smltitle: "Getting it on with the Kooks in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											 Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-28.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.thekooks.com/">
// 											  www.thekooks.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/33/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The Kooks – one of the ultimate British rock/pop bands of the century are coming this January to rock Tel Aviv as a part of "The Best of The Kooks" tour that marks a decade to their existence.
// 							</p>
// 							<p>
// 								The band was formed in Brighton, UK, in 2004 by lead singer Luke Pritchard and consists of Hugh Harris the lead guitarist, drummer Alexis Nunez and bassist Peter Denton. The band released its debut album, "Inside In/Inside Out" in 2006, which included hits such as "Ooh La" and "She Moves in Her Own Way" and achieved quadruple platinum status in the UK within a year and also abroad in the form of a platinum certification in Australia and two times platinum in Ireland.
// 							</p>
// 							<p>
// 								The group released its second album "Konk" in 2008 which debuted at number one on the UK Albums Chart and recorded first week sales of 65000, achieving gold status in both the UK and Ireland, which continued to establish their reputation as one of the world's most beloved brit-pop and post-punk bands. In 2011 their third album "Junk of the Heart" came out, followed by "Listen" in 2014 which debuted at No. 16 on the UK Albums Chart. Besides the fact that they quickly signed with "Virgin Records" only 3 months after forming, they also won several awards, such as MTV's best band of 2006 award, Best UK & Ireland Act at the MTV Europe Music Awards 2006 and even a nomination for the famous Brits award.
// 							</p>
// 							<p>
// 							  The band's music is primarily influenced by the 1960s British Invasion movement and post-punk revival of the new millennium. The Kooks have experimented in genres such as pop, reggae, ska, Britpop, rock, funk and hip-hop, and released songs that were describes as "catchy as hell".
// 							</p>
// 							 <p>
// 							  The Kooks are known for their amazing sold out shows and this one is due to be no different, so make sure to get your ticket now!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:34,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Willy William and Farruko",
//         smltitle: "The reggaetón superstars coming to get you movin’ in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											  Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.11.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.reggaetontelaviv.co.il/indexEN.php">
// 											  www.reggaetontelaviv.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/34/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								The reggaetón superstars coming to get you movin’ in Tel Aviv!
// 							</p>
// 							<p>
// 								Willy William and Farruko, the reggaeton megastars are coming this fall to perform as a part of the "Reggaeton Tel Aviv" festival and get the people of Tel Aviv on their feet in one extraordinary show only!
// 							</p>
// 							<p>
// 								Farruko , the 26-year-old world famous reggaton singer comes from Puerto Rico. He started his professional career in 2009 through Myspace. Since then, he released six albums and collaborated with Sean Paul, Daddy Yankee, Maluma, Don Omar, Shaggy, Nicky Jam, Ky-Many Marley, Chino&Nacho, J Balvin, Ozuna and many other successful reggaeton legends, and he was nominated for the Latin Grammy awards in 2012. His hits got millions of views on Youtube, and among them, one can find the famous "6 AM", "Passion Wine", "Me Voy Enamorando", "Krippy Kush", "Sunset" and "Chillax".
// 							</p>
// 							<p>
// 							  The 36-year-old singer, producer and DJ, Willy William is coming to Tel Aviv all the way from France. He's known for his remixes and collaborations with dance artists. His big breakthrough was in 2003 when he collaborated with DJ Flex and released his hit "B Boyz Shake da Body" and right afterwards his next song "Tragedie" and the name "Lord William". His most famous hits are "EGO" and "Mi Gente" which topped the charts in many radio stations worldwide, including Israel.
// 							</p>
// 							 <p>
// 							  Come get the addictive reggaetón vibes in you and dance the night away in the city that just won't quit!
// 							 </p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:35,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Buena Vista",
//         smltitle: "The ultimate Cuban experience in Tel Aviv & Jerusalem!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											21-26.12.17
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pasion-de-buena-vista.com/">
// 											  www.pasion-de-buena-vista.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/35/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   The ultimate Cuban experience in Tel Aviv & Jerusalem!
// 							</p>
// 							<p>
// 								After 600 shows worldwide -  the extraordinary Buena Vista Cuban sensation is coming for first time to give Tel Aviv and Jerusalem a taste of Cuba!
// 							</p>
// 							<p>
// 								The show is a one-of-a-kind experience that expresses love to the Cuban culture with all the known Cuban hits such as La Vida es un Carnaval. The Buena Vista Band includes 11 talented musicians, working together with a group of unbelievable dancers to provide an experience you never had before.
// 							</p>
// 							<p>
// 								The show will be held in two separate dates in Tel Aviv and Jerusalem, both awesome choices offering a huge host of activities and experiences in a unique unrivaled atmosphere. Jerusalem is known for its rich history, interesting architecture and incredible cultural diversity, while Tel Aviv is known for its fast tempo, warm exotic weather, amazing beaches and non-stop nightlife! Whatever city you'll choose- you visit is bound to be exciting and packed with unforgettable experiences!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:36,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Jerry Seinfeld",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.12.2017
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jerryseinfeld.com/">
// 											  www.jerryseinfeld.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/36/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Comedy King Closing 2017 in Tel Aviv!
// 							</p>
// 							<p>
// 								Jerry Seinfeld, the undisputed king of American comedy is returning to Tel Aviv for two performances which will be held on the same night in Tel Aviv.
// 							</p>
// 							<p>
// 								Home to incredible comedy venues a sought-after location for many international comedians such as Eddie Izzard, Jim Jeffries, Chris Rock and many others, Tel Aviv has a hedonistic vibe, incredible vibrancy and energy and a liberal loose spirit making in a comedy heaven.
// 							</p>
// 							<p>
// 								Seinfeld, hailed as one of the top comedians of his generation has without a doubt shaped the way we watch television and sitcoms, with his iconic show “Seinfeld” which ran from 1990-1998 and reigned over primetime TV for nearly a decade.
// 							</p>
// 							<p>
// 							   However, Seinfeld is a man loyal to his roots and has often declared that performing live is one of his favorites and he’s coming to Tel Aviv to do Just that.
// 							</p>
// 							<p>
// 							  This December, Seinfeld will strut his stuff onstage live in his hilarious laugh- a – second style, performing two consecutive shows in the nonstop city of Tel Aviv, and what better city is there to close the 2017 with a smile?
// 							</p>
// 							<p>
// 							   For visitors coming to check out Seinfeld’s show, the city of Tel Aviv, with its winter sunshine and world-famous nightlife is without a doubt THE place to spend a fantastic and absolutely unforgettable Tel Aviv Style New Year’s Eve.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:37,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Alt-J",
//         smltitle: "Comedy King Closing 2017 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											29.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.altjband.com/">
// 											  www.altjband.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/37/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  The British indie band is returning to Tel Aviv once again after their last successful sold-out show in Israel two years ago. The band was formed in 2007 in England, and their debut album “An Awesome Wave” was released in 2012 and won the Mercury award the same year. The band is a combination of electro-pop, psychedelic folk, African beats, post-dubstep and rock n’ roll. The band members met through their mutual love for Radiohead while they were in college, and their sound was affected by the fact that they weren’t allowed to use a bass guitar and drums when they were students.
// 							</p>
// 							<p>
// 								The band comes to rock Tel Aviv this spring and invites fans from all over the world to come and enjoy the wonderful alternative music scene that the city that never sleeps can offer. From extraordinary art galleries to unique theatre shows to live music concerts – the cultural scene in Tel Aviv is one of a kind. It’s a home for many musicians and artists, and now it welcomes every culture lover.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:38,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ozzy Osbourne",
//         smltitle: "Ozzy O -  coming to say goodbye to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ozzy.com/">
// 											  www.ozzy.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/38/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Ozzy O -  coming to say goodbye to Tel Aviv!
// 							</p>
// 							<p>
// 								Ozzy Osbourne, the world-famous metal legend returns to Tel Aviv for the last time as part of his farewell tour. While known to younger audiences mainly from the reality show “The Osbournes”, Ozzy was already a musical icon and a huge star since way before – from his role as the lead singer for Black Sabbath, to being the headliner in the international metal festival that was named after him, the “Ozzfest”.
// 							</p>
// 							<p>
// 							   After 2500 shows all around the world, the star comes to say goodbye to his fans in Tel Aviv, a city known around the world for its rich rock and metal scene. Being the most liberal city in Israel, Tel Aviv is always full of action and attracts both younger and older visitors who craving a taste of the underground culture. The rocking city is full of bars with rock themes, alternative clubs, live music venues and is known to attract music lovers from every country.
// 							</p>
// 							<p>
// 							   Don’t miss your chance to see the metal star for the very last time, make sure to get your ticket now and come rock it with ozzy in rockin’ Tel Aviv!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:39,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jim Jefferies",
//         smltitle: "Jim Jefferies Kicks Off 2018 in Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.01.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//jimjefferies.com/">
// 											  www.jimjefferies.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/39/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Jim Jefferies Kicks Off 2018 in Tel Aviv!
// 							</p>
// 							<p>
// 								One of the most popular comedians worldwide, Jim Jefferies, is returning to Tel Aviv after only a year. He will be kicking off 2018 and unleashing his famous humor with new material in a new show, “The Unusual Punishment Tour”.
// 							</p>
// 							<p>
// 							  The show will take place on a special 360-degree platform at the Menorah Mivtachim Hall in Tel Aviv, the perfect location for a comedian of his stature. Catching the show with the hilarious Australian performer is just the right excuse to come visit Tel Aviv, renowned for its exciting atmosphere and diverse nightlife scene.
// 							</p>
// 							<p>
// 							  Take the opportunity to visit one of the exciting bars or clubs which attract top International DJs, or visit one of the smaller neighborhood bars or cafes with its atmospheres to suit all tastes. Whether it’s food, drink or dancing you are after, Tel Aviv has it all.
// 							</p>
// 							<p>
// 							    After creating, writing, producing and starring in the critically acclaimed FX series, Legit, Jefferies and his material have gained a cult following. His voice has become well-known in late-night entertainment, making his show a must-see in Tel Aviv. Those coming to the Tel Aviv for Jefferies’ show will enjoy some good laughs, set on a background of stunning warm winters and an exciting night vibe.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:40,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Gerard Depardieu & Isabelle Adjani",
//         smltitle: "“Love Letters” Coming to Tel Aviv from France!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/40/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 “Love Letters” Coming to Tel Aviv from France!
// 							</p>
// 							<p>
// 								From France with love! French actors, Gerard Depardieu and Isabelle Adjani, will be performing “Love Letters” in March in Tel Aviv. Written by the late A.R. Gurney, the show has been performed on and off-Broadway by actors and actresses around the world.
// 							</p>
// 							<p>
// 							 The Pulitzer Prize-nominated show is now coming to Israel and will be performed by Gerard Depardieu and Isabelle Adjani in French, with Hebrew and Russian subtitles. With the performance taking place in Tel Aviv, visitors to the city will have the chance to enjoy some of the exotic and exciting nightlife that makes Tel Aviv so popular.
// 							</p>
// 							<p>
// 							  With restaurants to suit all palettes, dinner is just the thing for before the show, and with a nightlife that just starts to come alive around midnight, those who are looking for some adventure after the show will have plenty of options open to them. Anyone visiting the city especially for the show is sure to come away dazzled, both by the liveliness of the atmosphere and from the two well-known French stars.
// 							</p>
// 							<p>
// 							   While this is Adjani’s first trip to Israel, Depardieu has been here a number of times, and this occasion is sure to be memorable.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:41,
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "A-HA",
//         smltitle: "An Electric Summer with A-HA!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											21.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://a-ha.com/">
// 											  www.a-ha.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/41/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 An Electric Summer with A-HA!
// 							</p>
// 							<p>
// 								Israel will be treated to an exciting performance from Norwegian band, A-HA, in June, 2018. Coming to Israel as part of their Electric Summer Tour 2018, the band will perform in Tel Aviv at the Exhibition Grounds in a show that promises to be a hit.
// 							</p>
// 							<p>
// 							 Formed in Oslo in 1982, A-HA has been talked about for more than three decades, and since their hit “Take On Me” in 1985, they have grown to be one of the most popular Scandinavian bands in the world. While they originally split up in 2010, they have come back together again for a number of tours and Tel Aviv is honored to be among their stops this time around.
// 							</p>
// 							<p>
// 							 Fans of the band will be treated to an exciting performance by the well-known group, while having the chance to enjoy some of the best entertainment venues in the country. From museums to theatres, restaurants to clubs, there is something to suit everyone in the bustling city of Tel Aviv.
// 							</p>
// 							<p>
// 							  Take the opportunity to enjoy a walk along the brilliant beachfront as the city’s locals get ready for the summer sun, and enjoy the vibe as diverse cultures come together for the band’s latest show.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:42,
//         bgImage :"/posts/bank/13/1.jpg",
//         mobBgImage :"/posts/bank/13/M.jpg",
//         title: "Ringo Starr",
//         smltitle: "Ringo’s All Starr Band Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23-24.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.ringostarr.com/">
// 											 www.ringostarr.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/42/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Ringo’s All Starr Band Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								It’s been a year of stars in Tel Aviv and the latest concert to come to the dynamic city, has everyone talking! Ringo Starr will be coming to Israel as part of his European Tour and will be performing two concerts with his All Starrs Band at the Menorah Mivtachim Arena in June 2018.
// 							</p>
// 							<p>
// 							Starr, an English songwriter, singer and actor, first became famous as the drummer for the Beatles; however, since 1989, he has toured with his All Starr Band. The 77-year old released his 19th studio album in September, known as “Give More Love.”
// 							</p>
// 							<p>
// 							Tel Aviv is the ideal location for a concert with such a big name. Known as the New York City of Israel, Tel Aviv is the center of excitement, fun and initiatives in the country. As the city that attracts over a million tourists each year, whether for business or pleasure, Tel Aviv offers a beautiful beach, unique restaurants, theatres, museums and pulsing bars.
// 							</p>
// 							<p>
// 							  If you are joining the many fans who are coming to Tel Aviv to hear Ringo and his All Starrs Band perform, make sure not to miss out on the rest of what Tel Aviv has to offer and come away with an experience to remember.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:43,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "The Scorpions",
//         smltitle: "Tel Aviv to Go Crazy in July with The Scorpions!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.the-scorpions.com/">
// 											 www.the-scorpions.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/43/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Go Crazy in July with The Scorpions!
// 							</p>
// 							<p>
// 								One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>
// 							<p>
// 							One of the most well-known heavy metal bands in history, The Scorpions, will be coming to the Menorah Mivtachim Arena in Tel Aviv in July 2018, as part of their Crazy World Tour.
// 							</p>
// 							<p>
// 							Those looking to make a day of it in Tel Aviv, will have their pick of food and entertainment venues. The spirited city has become a melting pot of cultures and this is reflected in the museums, restaurants and street stalls that can be found all around the city. Enjoy cuisine to suit every palate, stroll around the interesting streets or pop into one of the many unique exhibitions that can be found around the city.
// 							</p>
// 							<p>
// 							  With the show scheduled for the beginning of the summer, it will be daylight until late and the locals will be out enjoying the sunshine. Soak up the vibe before you go on to rock the night away with The Scorpions!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:44,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Natalia Oreiro",
//         smltitle: "Natalia to Wow Tel Aviv in March",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											20.03.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.nataliaoreiro.com/">
// 											 www.nataliaoreiro.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/44/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							Natalia to Wow Tel Aviv in March
// 							</p>
// 							<p>
// 								South American singer and actress, Natalia Oreiro, is headed to Israel in March, where she will be performing a live concert at Menora Mivtachim Arena in Tel Aviv. Coming back to Tel Aviv, straight from Argentina, fans are looking forward to seeing the Latin star once again.
// 							</p>
// 							<p>
// 							Having performed in numerous daily series, including telenovelas and movies, and after producing 3 CDs, she will bring some of her biggest hits to the show, such as Cambio dolor, Corazon Valiente, Me Muero de Amor and Rio de la Plata y más, as she opens her new World Tour.
// 							</p>
// 							<p>
// 							Tel Aviv, which attracts celebrity singers, actors and performers from around the world, is the perfect location for the Grammy-nominated singer from Uruguay. The pumping city offers entertainment beyond the walls of the Menora Mivtachim Arena, with its trendy restaurants, upscale bars, and clubs.
// 							</p>
// 							<p>
// 							 Natalia, who has performed in Israel many times in the last 20 years, already has a following here. The show is sure to attract a large audience. Join the excitement before the performance by satisfying your taste buds in one of the many highly-acclaimed restaurants in the area or continue the celebration after the curtains have closed with a drink at a pub. Whatever your tastes, Tel Aviv is a great complement to Natalia Oreiro.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:45,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "André Rieu",
//         smltitle: "Tel Aviv to Be Treated to Rieu in 2018",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											04-05.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.andrerieu.com/">
// 											 www.andrerieu.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/45/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Tel Aviv to Be Treated to Rieu in 2018
// 							</p>
// 							<p>
// 								World-class Dutch composer and violinist, André Rieu, is coming to Tel Aviv with his Johann Strauss Orchestra for a performance that promises to be unforgettable. The two events, which are Rieu’s first in Israel, will be held at the Menora Mivtachim Arena in Tel Aviv.
// 							</p>
// 							<p>
// 							Rieu will be conducting his 60-piece orchestra while playing his famous Stradivarius violin, treating the audience to their repertoire of renowned ballads and waltzes. The event will be particularly captivating as Rieu will be presenting his new album, “Amore,” which includes a unique interpretation of Naomi Shemer’s “Jerusalem of Gold.”
// 							</p>
// 							<p>
// 							Tel Aviv, with its many facets, is just the right location for the range of musical pieces that Rieu and the Johann Strauss Orchestra will be performing. From the beach to the theater, classy restaurants to lively pubs, Tel Aviv has it all. Sit down to a posh dinner, visit a charming cafe, or enjoy a drink at a chic bar, before you end off your evening with a concert that promises no shortage of exquisite music.
// 							</p>
// 							<p>
// 							  André Rieu has become one of the most popular live acts around the world and Tel Aviv is about to find out why! Make sure you don’t miss out on the experience!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:46,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Foreigner",
//         smltitle: "Foreigner Returning to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.foreigneronline.com/">
// 											 www.foreigneronline.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/46/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 Foreigner Returning to Israel in May!
// 							</p>
// 							<p>
// 								Popular British hard rock band, Foreigner, is returning to Tel Aviv in May 2018. After recently playing 2 concerts in Caesarea, the band will now be performing in the entertainment capital of the country, Tel Aviv.
// 							</p>
// 							<p>
// 							Since being founded in 1976 by Mick Jones, Foreigner has sold nearly 80 million albums across the globe. It reached the height of its popularity in the 1980s, with some of its most well-known hits including “I Want to Know What Love Is,” “I Don’t Want to Live Without You,” “That Was Yesterday” and “Waiting for a Girl Like You.”
// 							</p>
// 							<p>
// 							With the band performing at the Menora Mivtachim Arena in Tel Aviv, fans and visitors will be able to make the most of the concert and enjoy the vibe and energy of the city. Soak up the rays on the beach as the summer sun starts to make an appearance or spend the day in one of the many museums or exhibitions of the city.
// 							</p>
// 							<p>
// 							 You will be transported back to the 80’s with this popular band, while enjoying the best that Tel Aviv has to offer. Don’t miss out on the great nightlife of the clubs and pubs after the show, as you complete your evening with style!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:47,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Don Mclean",
//         smltitle: "Enjoy a Piece of “American Pie” in June!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											16.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://don-mclean.com/">
// 											 www.don-mclean.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/47/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Enjoy a Piece of “American Pie” in June!
// 							</p>
// 							<p>
// 								Famous American songwriter, Don McLean, will perform in the outskirts of Tel Aviv in June, 2018. After almost 60 years of career, McLean remains most famous for his hit song, American Pie, which came out in 1972 and is still covered by big names in the industry, such as Madonna.
// 							</p>
// 							<p>
// 							   McLean has released 40 gold and platinum records, but it is his attachment to Israel that makes him so popular here. This is particularly clear with his song, Jerusalem, which he wrote in support of the country. This time, he will be performing closer to the entertainment capital of Israel, Tel Aviv.
// 							</p>
// 							<p>
// 							    With the show taking place only 10 minutes from the hustle and bustle of the lively city, there are plenty of options for fans to make a full day of the concert. Visit one of a number of world-class museums or take in one of the many temporary exhibitions that come to the city. If you’re looking for food, there is certainly no shortage in Tel Aviv with a range of styles and tastes to suit all visitors. Soak up the sun as summer begins to arrive or enjoy the sounds and scenes of the nightlife that Tel Aviv is famous for.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:48,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Enrique Iglesias",
//         smltitle: "Tel Aviv to Host Spanish Pop Legend!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://enriqueiglesias.com/">
// 											 www.enriqueiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/48/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Tel Aviv to Host Spanish Pop Legend!
// 							</p>
// 							<p>
// 								Spanish pop legend, Enrique Iglesias, will be returning to Israel for his fourth visit, this time to perform at the Yarkon Park in Tel Aviv. While this won’t be his first time in the entertainment capital of the country, it is expected to be his largest performance to date.
// 							</p>
// 							<p>
// 							  This visit comes close on the heels of the Hebrew remix of his popular piece, “Subleme La Radio,” together with Israeli singer, Rotem Cohen. Concert-goers can look forward to hearing some of Iglesias’ hit songs which may include “Bailamos,” “Hero,” “Be With You” and “I Like It.” He is expected to perform together with his long-time guitarist, Israeli Sean Hurwitz.
// 							</p>
// 							<p>
// 							   Iglesias is predicted to be one of the most popular concerts of the year judging by the fact that it will be held in the Yarkon Park venue which can accommodate up to 100,000 people. Those looking to make a whole evening of the event will find plenty to keep them entertained in Tel Aviv before the concert starts.
// 							</p>
// 							<p>
// 							    With a wide range of eateries and pubs, there is something to suit all tastes. Enjoy the limitless choices when it comes to restaurants and pick up the vibe of the city before heading off to the main event.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:49,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Blood Sweat and Tears",
//         smltitle: "Blood, Sweat & Tears Headed to Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//bloodsweatandtears.com/">
// 											 www.bloodsweatandtears.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/49/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Blood, Sweat & Tears Headed to Tel Aviv!
// 							</p>
// 							<p>
// 								Legendary rock band, Blood, Sweat & Tears, is heading to Israel for one concert to be held in Hangar 11 in Tel Aviv. The band was last in Israel 10 years ago when they played in Tel Aviv and Caesarea.
// 							</p>
// 							<p>
// 							  Established in 1967 in New York City, their best-known hits include “I Love You More than You’ll Ever Know,” “I Cannot Quit Her,” “When I Die” and “You’ve Made Me So Very Happy.” There are no original members of the band left, but seven current members will take to the stage when they perform in March. These include lead vocalist and popular runner-up to American Idol in 2005, Bo Bice.
// 							</p>
// 							<p>
// 							   Tel Aviv promises a full day of excitement for concert-goers with the opportunity to enjoy the beautiful beaches, parklands and entertainment options that the city offers before the concert even begins. Make sure to eat in one of the many restaurants scattered around the city and immerse yourself in the character of Tel Aviv by visiting one of the popular pubs or clubs that make up its charming nightlife.
// 							</p>
//                             <p>
//                                 Create the perfect night out as you combine the atmosphere of Tel Aviv with jazz and rock in a unique concert from Blood, Sweat & Tears.
//                             </p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:50,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jamiroquai",
//         smltitle: "Jamiroquai Heads to Israel in May!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											02.05.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jamiroquai.com/">
// 											 www.jamiroquai.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/50/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jamiroquai Heads to Israel in May!
// 							</p>
// 							<p>
// 								British band, Jamiroquai, is heading to Israel in May 2018, where they will perform in the outskirts of the bustling city of Tel Aviv. With only one performance in Israel, the popular band from the 90s is expected to attract a large crowd.
// 							</p>
// 							<p>
// 							  The band has published 8 studio albums, with “Automaton” being their latest from 2017. The hip city of Tel Aviv is the ideal location for a concert that promises an exciting performance by the group that introduced “future funk” and took the world by storm. Founded in 1992 by Jay Kay, Jamiroquai holds the Guinness Book of World Records listing for “Best Selling Funk Album” of all time.
// 							</p>
// 							<p>
// 							   Anyone looking for a lively night out will do well to head to this concert. Being held a short drive from the center of Tel Aviv, concert-goers will be able to begin the party early at one of the city’s top-notch restaurants, clubs or pubs. Start your evening with a quality dinner at any one of dozens of stylish restaurants and then move onto one of Tel Aviv’s famous clubs before making your way to the concert for an unforgettable night out.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:51,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Backstreet Boys",
//         smltitle: "The Backstreet Boys are Back and Larger Than Life",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.backstreetboys.com/">
// 												www.backstreetboys.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/51/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    The Backstreet Boys are Back and Larger Than Life
// 							</p>
// 							<p>
// 									The Backstreet Boys will be back in Israel this year for a concert. To be held in the outskirts of Tel Aviv in April, concert-goers will be able to enjoy the incredible vibe of the city together with some of the greatest hits in history.
// 							</p>
// 							<p>
// 									Tel Aviv is one of the most sought-after locations for big names in the entertainment industry, with its energy, vitality and spirit. There is no shortage of eateries, pubs and coffee shops for those looking for a culinary experience. Or, if you prefer to make a full day of it, you can visit some of the world-class museums, theaters or galleries around the city.
// 							</p>
// 							<p>
// 									Formed almost 20 years ago, the Backstreet Boys have produced 7 multi-platinum albums and sold more than 130 million records worldwide, with some of their most popular hits such as “I Want It That Way,” “As Long as You Love Me” and “Larger Than Life”.
// 							</p>
// 							<p>
// 									Visitors heading to the concert will be able to enjoy Tel Aviv at its best with beautiful Spring weather enticing locals and guests to the beach, before making their way to hear the best-selling boy band of all times!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:52,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alice in Chains",
//         smltitle: "Alice in Chains Announces Debut Show in Tel Aviv",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.aliceinchains.com/">
// 												www.aliceinchains.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/52/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Alice in Chains Announces Debut Show in Tel Aviv
// 							</p>
// 							<p>
// 									Making their debut appearance in Israel, rock band and grunge pioneer, Alice in Chains, will perform in July, north of Tel Aviv, in what promises to be an electrifying concert.
// 							</p>
// 							<p>
// 									Having come together in the late 80’s, Alice in Chains is one of four major groups that led the grunge revolution, and they became one of the most influential bands of all time. With music that combines rock, alternative rock and metal, the band was nominated for 9 Grammy awards and sold more than 20 million albums.
// 							</p>
// 							<p>
// 									Taking place in the middle of summer, Tel Aviv is the perfect location to start the day’s activities. If you’re looking for some indoor entertainment, visit one of the city’s world-class museums or galleries, or head over to one of the many restaurants around the city. For something a bit different, soak up the rays walking along the promenade of a beautiful beach or pop into a club or pub in the area before heading north for the concert.
// 							</p>
// 							<p>
// 									This show is part of the first European tour the band has been on in four years, and being its first appearance ever in Israel, it promises to be a night full of excitement.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:53,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Hardwell",
//         smltitle: "Hardwell Headed to Israel in April",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.djhardwell.com/">
// 												www.djhardwell.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/53/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Hardwell Headed to Israel in April
// 							</p>
// 							<p>
// 									Number 1 ranking DJ, Hardwell, is coming to Israel in April where he will thrill crowds just outside Tel Aviv. This will be his third concert in the country, after performing to sell-out audiences in 2013 and 2017.
// 							</p>
// 							<p>
// 									Robbert van de Corput, better known as DJ Hardwell, first made a name for himself at the young age of 14, but it was at age 25 when he truly became famous, named World’s #1 DJ by the 2013 DJ Mag. Hardwell has become an International name, hosting his own radio show which is broadcast around the world, and producing a consistently top 10 iTunes podcast. He is also well known for his remix of The Wanted’s “Chasing the Sun”.
// 							</p>
// 							<p>
// 									Tel Aviv is the ideal location for a concert of this type with the natural vibe and energy of the city adding to the excitement that will be in the air. Tel Aviv in Spring is full of blue skies and warm weather, attracting crowds to the beach and the outdoor cafes and restaurants that can be found throughout the city. Enjoy a full day out or join the gathering of people at one of the city’s world-class restaurants before heading to the concert.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:54,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Jethro Tull",
//         smltitle: "Jethro Tull’s 50th Anniversary Tour Heads to Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-28.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jethrotull.com/">
// 												jethrotull.com/
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/54/1.gif"} class="img-responsive" />
// 							</div>
// 							<p>
// 							    Jethro Tull’s 50th Anniversary Tour Heads to Israel
// 							</p>
// 							<p>
// 									Ian Anderson, vocalist, flutist, and guitarist of the popular British rock band, Jethro Tull, is coming to Israel for the band’s 50th anniversary tour. Performances will take place at Heichal Hatarbut in Tel Aviv on October 27, followed by the International Convention Center in Jerusalem on October 28.
// 							</p>
// 							<p>
// 									Formed in 1967, the band initially played blues rock, but later evolved and developed elements of hard rock. Their greatest success came in the 1970s with hit songs such as “Bungle In The Jungle,” “Living In The Past,” and “The Witch’s Promise.” The band has performed in Israel numerous times in the past, and Anderson who is the only remaining member of the band who is coming on tour, is expected to receive a warm welcome.
// 							</p>
// 							<p>
// 									Performing in both Tel Aviv and Jerusalem will appeal to a wide audience. Join the energy and vibe of the lively city of Tel Aviv with its nightlife, culinary experiences and beautiful beaches, or enjoy the concert in the cultural and historic center of the country, which is Jerusalem. No matter which flavor of the region you prefer, there are plenty of restaurants, cafes, museums or galleries to visit in each of the cities before the venues open their doors.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//       id:55,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Israel Calling",
//         smltitle: "Good Evening Europe, This is Tel Aviv!",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08-10.04.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 						<!--	<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->
// 							<h2>
// 							   Good Evening Europe,<br class="show-on-mobile"> This is Tel Aviv!
// 							</h2>
// 							<p>
// 								Eurovision fever is sweeping over Tel Aviv as it confirms hosting the star and glitter studded event - “Israel Calling”, for the 3rd consecutive year!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/55/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								About 30 delegates from Eurovision participating countries worldwide will be gathering at the beginning of April in the nonstop city of Tel Aviv, for the largest Eurovision promo-event to ever take place in front of a crowd of thousands from Israel and around Europe.
// 							</p>
// 							<p>
// 								This unique and exciting event, held only in Tel Aviv, will give Eurovision fans from far and wide an amazing and completely free of charge opportunity to take part in the glamour of the Eurovision right here in the beautiful city of Tel Aviv.
// 						</p>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/2.jpg"} class="img-responsive" />
// 						</div>
// 						<p>
// 						The event will be held for three days starting on the 8th of April. The main stage will be set in Rabin Square, Tel Aviv’s main square and one of the city’s favorite outdoor venues, located at the heart of the buzzing city.
// 						</p>
// 						<p>
// 						The main event will take place on Tuesday and will include a mini Eurovision show in front of a live audience, featuring performances by the various Eurovision contenders performing the songs they will be competing with on the main event in May.
// 						</p>
// 						<p>
// 						This much anticipated pre-Eurovision event is set to take place just a few minutes’ walk from the stunning Tel Aviv beach. Fans and music lovers coming to see the show will get to take in all the city has to offer, including the excellent bars, restaurants and the awesome nightlife in this world-famous ultimate vacation destination called Tel Aviv.
// 						</p>
// 						<div class="img-wrapper">
// 							<img src=${getImgUrl() +  "/Concerts/55/3.jpg"} class="img-responsive" />
// 						</div>
// 						`
// 			}
// 		}
//     },
//     {
//       id:56,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Clean Bandit",
//         smltitle: "Clean Bandit Announces First Visit to Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											26.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//cleanbandit.co.uk/">
// 												cleanbandit.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/56/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Clean Bandit Announces First Visit to Israel
// 							</p>
// 							<p>
// 									British electro-pop group, Clean Bandit, which has become one of the leading dance acts around the world, has announced their debut performance in Israel. Visiting as part of their European tour, the band will play on the outskirts of Tel Aviv on June 26.
// 							</p>
// 							<p>
// 									Formed in 2008, they became well-known for merging classical instruments and pop with a unique and masterful outcome and they became a sensation with their smash hits “Rather Be,” “Real Love,” “Rockabye,” and “Symphony.” Since its release in 2016, “Rockabye” has been viewed almost 2 billion times on YouTube, while they won a Grammy for “Rather Be” in 2015.
// 							</p>
// 							<p>
// 									The band has been together for ten years and has seen incredible success in the that time. Join the throngs of people heading to Tel Aviv for the group’s first visit.
// 						    </p>
// 						    <p>
// 									Tel Aviv is just the venue for the unforgettable night that this concert offers. With cafes, bars, clubs, and pubs throughout the city, there is no shortage of activities in Tel Aviv. Known as “the city that doesn’t stop”, you can take advantage of the buzz of the nightlife and enjoy the vibe of the bustling beachfront at any hour before or after the concert.
// 						    </p>
// 						`
// 			}
// 		}
//     },
//     {
//        id:57,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Alanis Morissette",
//         smltitle: "Alanis Morissette to Turn Up The Heat with Summer Performance in Israel",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//alanis.com/">
// 												alanis.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/57/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Alanis Morissette to Turn Up The Heat with Summer Performance in Israel
// 							</p>
// 							<p>
// 									Canadian singer and songwriter, Alanis Morissette, will return to Israel in the summer for one show which will take place on the outskirts of the lively city of Tel Aviv. Morissette has performed in Israel a number of times, including in 2000 and 2012, since she released her first album, “Jagged Little Pill” in 1995.
// 							</p>
// 							<p>
// 									The popular alternative rock singer is expected to rock Tel Aviv with some of her top hits, including “All I Really Want,” “Hand in My Pocket,” “Head Over Feet,” “Ironic,” “You Learn,” and “You Ought to Know.” Having taken home seven Grammy Awards and with eight albums having sold more than 60 million copies across the globe, her upcoming visit is already causing much excitement.
// 							</p>
// 							<p>
// 									The Tel Aviv area is the perfect location for a concert of this calibre, with visitors to the city given an exceptional choice of wining, dining and entertainment options. Begin your night at one of the many world-class restaurants or head out to one of the quaint coffee shops or bustling bars to end off your evening. The music scene will be hotter than ever with Alanis Morissette this July!
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//        id:58,
//         bgImage :"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title: "Marc Almond",
//         smltitle: "Marc Almond’s Amazing Summer Concert",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.marcalmond.co.uk/news/index.html">
// 												marcalmond.co.uk
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() +  "/Concerts/58/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							   Marc Almond’s Amazing Summer Concert
// 							</p>
// 							<p>
// 									English musician, Marc Almond, will be heading to Israel in the summer for a much-awaited concert. The singer, who is most famous for his part in the new wave duo Soft Cell, will be playing north of Just north of the nonstop city of Tel Aviv in August.
// 							</p>
// 							<p>
// 									Soft Cell became famous for its 80’s hits “Tainted Love,” “Torch,” “Say Hello, Wave Goodbye,” and others, while Almond’s solo career took off when the duo split in the mid-80’s with hits including “Jacky” and “Something’s Gotten Hold of My Heart.” In another tribute to the decade, the Israeli rock group, Tattoo, which broke up in 1989, will open the concert in a historic reunion.
// 							</p>
// 							<p>
// 									Fans have been waiting for this performance since 2011, when his planned concert was canceled due to technical reasons. The 2018 concert promises to be an experience to remember.
// 							</p>
// 						    <p>
// 									From music to art, culture to fun, Tel Aviv has something for everyone. Spend the day wandering the vibrant streets of the city or pop into one of the many museums, theatres or galleries downtown. Make sure to stop off for a bite to eat at any of the city’s many world-class restaurants so you’ll be energized for what is sure to be an awesome concert.
// 							</p>
// 						`
// 			}
// 		}
//     },
//     {
//         id:59,
//         bgImage:"/posts/bank/16/1.jpg",
//         mobBgImage :"/posts/bank/16/M.jpg",
//         title : "Shakira",
//         smlTitle : "Shakira to heat up the summer in sizzling Tel Aviv ",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09.07.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.shakira.com/">
// 												shakira.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/59/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							  Shakira to heat up the summer in sizzling Tel Aviv
// 							</p>
// 							<p>
// 									The worldwide sensation Shakira is set to perform for the first time on the big stage in Tel Aviv this coming July and the city’s a buzz. The 41-year-old Colombian superstar who has sold close to 200 million albums and has won over 250 awards including three Grammys is just the perfect fit for a summertime concert in Tel Aviv.
// 							</p>
// 							<p>
// 									With a long and illustrious list of hit songs, including “Waka-Waka”, “Chantage” and “Whenever, whenever” Shakira is one of the most celebrated artists in the world today and nearly every song she records tops the international charts and receives hundreds of millions of Youtube views.
// 							</p>
// 							<p>
// 									Shakira’s concert is due to be held on July 9th in Yarkon Park, Tel Aviv’s massive park also dubbed the city’s “Green Lung”, which boasts, in addition to beautiful greenery, a stunning lake and excellent bike trails, a huge outdoor live music venue.
// 							</p>
// 							<p>
// 							        The party atmosphere of the nonstop city in July, the beautiful beaches and amazing nightlife and cool street vibe, all set the scene for perfectly Shakira’s show-stopping style and what is guaranteed to be an explosive musical celebration in the heart of cool city of Tel Aviv.
// 							</p>
// 	                    `
// 			}
// 		}
//       },
//   //     {
//   //     id: 60,
//   //     bgImage:"/posts/bank/16/1.jpg",
//   //     mobBgImage:"/posts/bank/16/M.jpg",
//   //     title: "White Night TLV",
//   //     smlTitle: "A “White Night” Rager In the Non-Stop City!",
//   //     html: function(){
// 		// 	return {
// 		// 		__html: `
// 		// 					<h2 class="align-center">
// 		// 					   16.05.2019
// 		// 					</h2>
// 		// 					<h1 class="align-center">
// 		// 					   A “White Night” Rager In the<br class="show-on-mobile"/> Non-Stop City!
// 		// 					</h1>
// 		// 					<div class="responisve-iframe">
// 		// 						<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 		// 					</div>
// 		// 					<p>
// 		// 						When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat. “White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open and everything is happening across the city at the same time…
// 		// 					</p>
// 		// 					<p>
// 		// 						From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Adam Primer
// 		// 					</small>
// 		// 					<p>
// 		// 						The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City", Tel Aviv’s largest architectural collection of Bauhaus style buildings a world cultural heritage site, giving it a unique status in the architectural heritage of the modern era.
// 		// 					</p>
// 		// 					<p>
// 		// 						This historic declaration has been celebrated yearly ever since by Tel Aviv-Jaffa in a series of white night events, named after the "White City" and Tel Aviv’s other well-known characteristic: being “The City That Doesn’t Stop”.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo By: Kfir Sivan
// 		// 					</small>
// 		// 					<p>
// 		// 						The White Night is a celebration of numerous events held throughout the city, which seems to expand with every passing year. In recent years, the celebrations  included (to name just a few): a unique midnight public picnic, an epic headphones party in the city’s main square, countless live music concerts, amazing indoor as well as street theatre performances, fascinating nighttime tours, night sports classes , Yoga at sunrise, and of course countless epic parties, all taking place all night across the city at the same time.
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by Moshik Lindenbaum
// 		// 					</small>
// 		// 					<p>
// 		// 						So you better get your rest on- you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 		// 					</p>
// 		// 					<div class="img-wrapper">
// 		// 						<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 		// 					</div>
// 		// 					<small>
// 		// 						Photo by: Guy Yechiely‎.
// 		// 					</small>
// 		// 			               `
// 		// 	}
// 		// }
//   //   },
//       {
//       id: 60,
//       bgImage:"/posts/bank/16/1.jpg",
//       mobBgImage:"/posts/bank/16/M.jpg",
//       title: "White Night TLV",
//       smlTitle: "All Night Citywide party in Tel Aviv on Eurovision Semifinal!",
//       html: function(){
// 			return {
// 				__html: `
// 							<h2 class="align-center">
// 							   16.05.2019
// 							</h2>
// 							<h1 class="align-center">
// 							   All Night Citywide party in Tel Aviv on Eurovision Semifinal!
// 							</h1>
// 							<div class="responisve-iframe">
// 								<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 							</div>
// 							<p>
// 								When a city renowned across the world as the “City that never sleeps” holds an event like “White Night” – you know you’re in for a treat, and this year the treat is going to be especially epic!
// 							</p>
// 							<p>
// 								As part of the warm and exciting welcome awaiting visitors during Eurovision week, the powers that be have decided to combine Tel Aviv’s annual “White Night” extravaganza with the Eurovision Semifinal set to be held on 16.05.2019.
// 							</p>
// 							<p>
// 								“White Night”, one of Tel Aviv’s biggest events of the year, is a traditional annual citywide celebration which keeps the city up all night – everything is open, and everything is happening throughout the city simultaneously.
// 							</p>
// 							<p>
// 								The origin of this now world-famous event dates back to 2003 when UNESCO declared the "White City as a world cultural heritage site, setting off annual citywide celebration in a series of white night events in the city that (truly) doesn’t sleeps.
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Adam Primer
// 							</small>
// 							<p>
// 								From the early evening and until dawn, the city becomes packed with tourists and locals, high on life and enjoying everything on offer, from shops and eateries to cinemas and culture venues – free of charge or at reduced rates, all night long!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo By: Kfir Sivan
// 							</small>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by Moshik Lindenbaum
// 							</small>
// 							<p>
// 								So you better get some rest - you’re gonna need all your energy to keep up with “White Night” in the awesome city of Tel Aviv!
// 							</p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							</div>
// 							<small>
// 								Photo by: Guy Yechiely‎.
// 							</small>
// 					               `
// 			}
// 		}
//     },
//     {
//         id:61,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Brian Wilson",
// 	    smlTitle: "The legendary Brian Wilson returning to rock Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											07.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.brianwilson.com/">
// 												brianwilson.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/61/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 							 The legendary Brian Wilson returning to rock Tel Aviv!
// 							</p>
// 							<p>
// 									He returns to the white city with Al Jardine and Blondie Chaplin as a part of his world tour that celebrates his biggest hits from the last 54 years. The Beach Boys is one of the world’s most successful bands, the band has won many Grammy awards, got their own star in Hollywood and entered the Rock N’ Roll hall of fame.
// 							</p>
// 							<p>
// 									The band sold over 100 million records over the years and produced more hits than any other American band. They’re known especially for their hits “God Only Knows”, “Get Around”, “California Girls” and “Good Vibrations”. Wilson’s solo career is also successful, he recorded 11 albums and won 2 Grammy awards.
// 							</p>
// 							<p>
// 									Wilson’s concert will take place in Tel Aviv on August’s 7th. The summertime provides long daylight hours that give visitors the perfect opportunity to see what Tel Aviv has to offer; from an incredible art scene to fantastic theatres, to phenomenal live music shows and world-class restaurants – there are so many options in the spectacular city of Tel Aviv for  everyone will to find their brand of fun and excitement in the nonstop city.
//                             </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 62,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Jason Derulo and Rita Ora",
// 	    smlTitle: "Jason Derulo and Rita Ora to raise it up in Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											The outskirts of Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.jasonderulo.com/">
// 												jasonderulo.com
// 											</a><br>
// 											<a target="_blank" href="//ritaora.com/">
// 												ritaora.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/62/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						         	Jason Derulo and Rita Ora to raise it up in Tel Aviv!
// 							</p>
// 							<p>
// 									The two mega pop stars will perform at the “Lollipop” festival that will take place at the outskirts of Tel Aviv on the first of August. Derulo, that made his big breakthrough in 2009 with the hit “Whatcha Say”, became over the last decade one of the biggest stars in the international music industry with his huge hits such as “Wiggle”, “Want to Want Me”, “Swalla”, “Tip Toe” and “Talk Dirty”. The popular British Pop star, Rita Ora, is known especially for her famous hits “I Will Never Let You Down”, “Anywhere”, “R.I.P” and “Hot Right Now”.
// 							</p>
// 							<p>
// 									The festival provides a great opportunity to explore the city that never sleeps and enjoy its famous nightlife scene – from world-class bars, to secret underground clubs, to live music shows and various culinary options and even alternative art galleries, Tel Aviv for sure has something for everyone to enjoy. Whether you’re following a map or letting yourself get lost in the streets, you’re sure to fall in love with Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 63,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Julio Iglesias",
// 	    smlTitle: "The Latin legend returning to wow Tel Aviv!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.10.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.julioiglesias.com/">
// 												julioiglesias.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/63/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						             The Latin legend returning to wow Tel Aviv!
// 							</p>
// 							<p>
// 									Tel Aviv can’t wait for the return of the beloved Spanish star! With a great cultural scene, incredible culinary options, amazing beaches, phenomenal museums and galleries and plenty of unique spots to explore – those who come to enjoy Iglesias’s concert have plenty of different ways to spend their time in the cultural capital.
// 							</p>
// 							<p>
// 									The hot climate and long daylight hours just reminiscent of the phenomenal singer’s origin country, Tel Aviv offers a variety of options that suit all ages and therefore attracts a big amount of visitors all around the year.
// 							</p>
// 							<p>
// 							        Iglesias has an ongoing love affair with the nonstop city and his past shows were sold out. He’s one of the most successful singers in the history and during his career became a phenomenal success story all around the world. He has 77 different albums that sold over 300 million copies!
// 							</p>
// 							<p>
// 							         Many of the Spanish phenomenon’s hits have reached the top of the charts and he won numerous awards, such as the Grammy. His fans are incredibly excited about his return and tickets are selling like hot falafels. This is guaranteed to be a show to remember!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 64,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Maluma",
// 	    smlTitle: "The Reggaeton sensation returns to the white city!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											28.06.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fame.malumaofficial.com/">
// 												fame.malumaofficial.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/64/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The Reggaeton sensation returns to the white city!
// 							</p>
// 							<p>
// 									After winning over the crowd’s hearts during his last visit, the Colombian reggaetón singer and songwriter Juan Luis Londoño Arias, better known by his stage name Maluma returns to the city that never stops for one show only!
// 							</p>
// 							<p>
// 									Maluma has several singles that have charted within the top 10 on Billboard Hot Latin Songs, including "Felices los 4", "Borro Cassette", "El Perdedor" and "Corazón". During his career he won several awards, among which there is MTV Europe’s award for best world tour. The phenomenal performer is known among his fans as “the Latin lover” despite being only 24 years old.
// 							</p>
// 							<p>
// 							       His show will be held on June’s 28th in HaYarkon Park, located in the heart of Tel Aviv. Fans from all over the world who come to the show can enjoy the lovely beaches the city has to offer, the variety of restaurants and cafes, the remarkable art scene, the world-class bars and clubs, the various shopping venues spread all across the city – Tel Aviv has something for everyone.
// 						    </p>
// 							<p>
// 							         The Latin superstar is known to be quite a charmer and win everyone over in his shows – don’t miss this fantastic mix of Maluma and Tel Aviv -  come see the legend live in the hot hot city!
// 						    </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 65,
// 	    bgImage:"/posts/bank/16/1.jpg",
// 	    mobBgImage:"/posts/bank/16/M.jpg",
// 	    title: "Martin Garrix",
// 	    smlTitle: "The 1# DJ comes to the nonstop city!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.09.2018
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.martingarrix.com/">
// 												martingarrix.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/65/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 						           The 1# DJ comes to the nonstop city!
// 							</p>
// 							<p>
// 									Martin Garrix , hailed as “the world’s best DJ” by DJMag is coming to get the party going in the nightlife capital of the middle east! With tons of world known clubs, bars, pubs and a one of a kind atmosphere, Tel Aviv is known for its vibrant vibe and incredible night scene.
// 							</p>
// 							<p>
// 									At 20 years old, the Dutch wonderkid is coming at the height of his career for one unforgettable show in Tel Aviv! The international hits machine became famous when he was only 17 and since then has released many loved tracks and climbed the charts all over the world.
// 							</p>
// 							<p>
// 							       Garrix is considered by many is the undeniable king of the industry. With remarkable hits such as “Animals”, “Tremor”, “In the Name of Love” and “Scared to Be Lonely”, the phenomenal DJ is one of the most popular performers in the world and is a must-have headliner for every well-known festival.
// 							</p>
// 							<p>
// 							        The show will be held in HaYarkon Park, in the heart of the awesome city, on September 10th. The international vibe, gorgeous location and great nightlife scene attract an extraordinary crowd that comes from different corners of the world and is guaranteed to make this show a once in a lifetime experience!
// 						    </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 66,
// 	    bgImage:"/posts/bank/59/1.jpg",
// 	    mobBgImage:"/posts/bank/59/M.jpg",
// 	    title: "Eurovision Tel Aviv",
// 	    smlTitle: "Epic song contest in the Non-Stop City",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14-18.05.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<!--<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>-->
// 							<h3>A once in a lifetime opportunity to visit Tel Aviv as it hosts the Eurovision song contest.</h3>
// 							<p>
// 						     Epic song contest in the Non-Stop City
// 							</p>
// 							<p>Semi-final 1: 14 May 2019</p>
//                             <p>Semi-final 2: 16 May 2019</p>
//                             <p>Grand Final: 18 May 2019</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/67/1.svg"} class="img-responsive" />
// 							</div>
//                             <p>It’s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city. </p>
//                             <p>Tel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak.  Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest. </p>
//                             <div class="img-wrapper">
// 							    <img src=${getImgUrl() + "/Concerts/67/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Major productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega “Euro Village” which will be situated merely a minutes’ walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest’s semifinal and final. The contest itself will take place in the Expo Tel Aviv. </p>
//                             <p>The Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all! </p>
// 					               `
// 			}
// 		}
//     },
//    {
//         id: 68,
// 	    bgImage:"/posts/bank/68/1.jpg",
// 	    mobBgImage:"/posts/bank/68/M.jpg",
// 	    title: "",
// 	    smlTitle: "36 Years of Cinema Magic!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25.07-04.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.jff.org.il/en">
// 												www.jff.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Film Festival (JFF)</h2>
// 							<p>Time to start preparing your Summer 2019 checklist: Buy suntan lotion, pick wildflowers, host a barbeque, make plans to attend the 36th Annual Jerusalem Film Festival! It’s 11 days, over 200 films, prizes awarded to the very best, and you’ll be a part of it all! From star-studded international features to independent productions and the best of Israeli cinema, this unique film fest showcases excellence from various genres. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/68/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>Take advantage of the opportunity to meet festival guests, including world-renown stars, writers, directors, cinematographers and other movie-making professionals. Film enthusiasts will enjoy Jerusalem’s many cinema spaces and be delighted by JFF on the Go, which presents films under the stars throughout the festival, and Cinema Park, which includes a 300 square meter pool with rubber boats, a giant LED screen, and a concert stage featuring live musical performances nightly. </p>
//                             <p>As you travel across the city to attend screenings, workshops, master classes, parties, musical shows and other festival events, you’ll experience how ancient cultures give modern spice to the contemporary vibe and personality of this global city. Fill your spare time strolling through neighborhood streets, exploring local shops, and taking your pick of Jerusalem’s wide variety of restaurants and cafes. You may have attended other film fests, but you won’t find one quite like this and, certainly, none other can boast the grandeur of the eternal City of Peace! </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 69,
// 	    bgImage:"/posts/bank/69/1.jpg",
// 	    mobBgImage:"/posts/bank/69/M.jpg",
// 	    title: "",
// 	    smlTitle: "Jerusalem Wine Festival (JWF)",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01-31.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Jerusalem Wine Festival (JWF)</h2>
// 							<p>
// 								Relaxing summer evenings were made for an exquisite glass of fine wine! And for four days in August, you can enjoy world class selections and award-winning food at the 16th Annual JWF. Hosted in the beauty of the Japanese Art Garden of the Israel Museum, this is considered by many to be Jerusalem’s premiere social event. It’s a wine festival unlike any other, whose ambiance and stunning views of this historic city combine to make the JWF a not-to-be-missed experience.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Hundreds of wines will be served by dozens of well-known and boutique wineries. There’ll be free wine tasting opportunities, along with a culinary oasis of stalls offering cheeses, chocolates, olive oils, exceptional sauces, and tasty jams. And speaking of tasty jams, the festival will get your party started every night with two different live music concerts.
// 							</p>
//                            <p>
// 								Every year, the JWF welcomes a diverse and refined crowd of over 20,000 wine and culture lovers to Jerusalem. Many attend over multiple evenings simply to soak in the atmosphere. You could even build your stay in the city around the festival! Certainly, your days will be filled with sightseeing, shopping, and loads of walking about. The perfect way to unwind after your busy days might well be several fun-filled nights at the Jerusalem Wine Festival!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 70,
// 	    bgImage:"/posts/bank/70/1.jpg",
// 	    mobBgImage:"/posts/bank/70/M.jpg",
// 	    title: "OPEN RESTAURANTS TLV",
// 	    smlTitle: "Feed Your Curiosity!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019 y.
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Feed Your Curiosity!</h2>
// 							<p>
// 								Ever wanted to get more than a taste of what gets created in a truly fine restaurant? Have you ever fantasized about what it would be like to be a top chef? Well, now’s your chance!
// 							</p>
// 							<p>
// 								OpenRestaurants is more than a culinary event, it’s a cultural happening that showcases Tel Aviv’s wide array of restaurants, chefs, and local culinary personalities. Guests get to meet with chefs from around the city, wander through open markets, and try their hands at cooking up flagship dishes under the supervision of first-class professionals. It’s your opportunity to experience a day in the life of the sophisticated chefs, line cooks, restaurateurs, food vendors, and others who make gastronomy in Tel Aviv as palate pleasing as it is.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/70/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Beyond peeking behind many kitchen curtains, OpenRestaurants hosts a range of events that include curated dinners, history presentations, and exhibitions of culinary-themed art, design, music, and technology!
// 							</p>
//                            <p>
// 								Many events are available at no charge, including the Culinary Innovation Summit, the Food & Hospitality Hackathon, and various food talks. There are also family-oriented events that focus on cooking activities for children and several market tours.
// 							</p>
//                            <p>
// 								Everyone’s gotta eat and there’s no one who doesn’t enjoy good food that’s well prepared. So, whether you like to understand the process behind the preparation, you like to do the preparing, or you just have a hearty appetite, there’ll be plenty to delight your senses at OpenRestaurants: Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 71,
// 	    bgImage:"/posts/bank/71/1.jpg",
// 	    mobBgImage:"/posts/bank/71/M.jpg",
// 	    title: "CULINARY FESTIVAL",
// 	    smlTitle: "Round Tables Culinary Festival",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											09-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Round Tables Culinary Festival</h2>
// 							<p>
// 								The 4th edition of this celebrated culinary experience that brings renowned chefs from around the globe and invites them to take over the kitchens of several of Tel Aviv’s most notable restaurants.
// 							</p>
// 							<p>
// 								This year offers a new twist: The eight visiting chefs are all women – hailing from Mexico, South Korea, Italy, Switzerland, Colombia, Slovenia, Spain, and the United States. They’ll work with their local counterparts in the creation of culture crossover chowdowns featuring signature dishes from the guest chefs alongside flavors offered by the local chefs from the host restaurants.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/71/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								Everyone involved agrees that creative cooking is always intensely steeped cultural context and a deeply felt sense of place. All of them are passionate about using local ingredients. Of course, each of these chefs has received accolades and awards from international critics and guides.
// 							</p>
//                            <p>
// 								There’s no better way to showcase Tel Aviv’s growing prominence on the global stage of gastronomy than the annual Round Table event. Seats get reserved quickly and must be made in advance. So, don’t miss your chance for a place at these prestigious tables – your taste buds will never forgive you!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 72,
// 	    bgImage:"/posts/bank/72/1.jpg",
// 	    mobBgImage:"/posts/bank/72/M.jpg",
// 	    title: "TEL AVIV FASHION WEEK",
// 	    smlTitle: "Tel Aviv Fashion Week (TAFW)",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2>Tel Aviv Fashion Week (TAFW)</h2>
// 							<p>
// 								Fashion events are always occasions for the celebration of elegance, imagination, creativity, and style. But the TAFW has been making its mark in the international fashion industry with its recent attention to changing ideals of beauty, featuring models, both male and female, of different ages, sizes, heights, colors, and religions. The 4-day event showcases uncommon displays from around the world and those close to home in and around Tel Aviv’s vibrant design scene.
// 							</p>
//                            <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>
// 								TAFW also embraces leading edge fashion concepts by exhibiting innovative uses of technology and textiles. And it’s especially proud of the support it provides to young designers. As in past editions, this 7th annual event will feature an Upcoming Designers show in which new talent will have an opportunity to share their wares with you!
// 							</p>
//                            <p>
// 								In 2019, Tel Aviv Fashion Week will once again take place in the historic Tachana complex. Formerly the final stop of the old Jaffa-to-Jerusalem railway, the station has been transformed into one of Tel Aviv’s coolest and most lively public spaces. Located in a trendy neighborhood of pastel-colored homes, unique boutiques, and numerous cafes, you’ll want to explore the entire area while you’re getting your vogue on at the TAFW!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 73,
// 	    bgImage:"/posts/bank/73/1.jpg",
// 	    mobBgImage:"/posts/bank/73/M.jpg",
// 	    title: "DGTL FESTIVAL",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
// 												tlv.dgtl.nl/en
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>
//                             <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now Tel Aviv and bringing together the worlds of music, technology and art, as well as the latest discoveries in production and sound. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/73/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include three stages which will operate simultaneously at any given moment.</p>
//                             <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for saving electricity, vegetarian food only, a recycling plan and more. </p>
//                             <p>The Festival will be held in the fabulous Yarkon Park in the heart of the buzzing city of Tel Aviv, a hub of innovation, trendiness and exciting nightlife scene, making it the host for DGTL. </p>
//                             <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 74,
// 	    bgImage:"/posts/bank/74/1.jpg",
// 	    mobBgImage:"/posts/bank/74/M.jpg",
// 	    title: "Tel Aviv Marathon",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											22.02.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=5418">
// 												www.tlvmarathon.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Run and fun in the city that doesn’t stop</h2><br/>
//                             <p>Tel Aviv Marathon is the country’s biggest international sports event and a unique and exciting celebration for runners worldwide. The Marathon is held in the heart of the fabulous city of Tel Aviv, giving participants the opportunity to take in its awesome sites and views and feel their heart beat become one with the pulse of this adrenaline charged metropolis. </p>
//                             <p>The Tel Aviv Marathon is city wide celebration stretching along the stunning beachfront, the amazing sites of the white city - a UNESCO World Heritage Site, and the city’s many buzzing stylish streets, packed with over 150,000 people taking part in the many side events, cheering the runners along the race’s flat and friendly course.   </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/74/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Around 40,000 runners come from far and wide to take part in this multi-course annual even. Allowing runners in all levels and styles, from professional long-distance runners to beginners, to take part.</p>
//                             <p>Much more than just a run, the marathon is in fact a huge festival featuring a host of dedicated lively events before and after the race, full of live music, dancing and many other attractions to the delight of runners and supporters alike.  </p>
//                             <p>Dubbed ‘The Mediterranean Capital of Cool’ By the New York Times and among Lonely Planet’s ‘Top 10 Action-Packed Cities’. Tel Aviv offers a host of fascinating attractions from all walks of life including dazzling stretches of golden beaches, colorful markets, cutting edge culture and entertainment, outstanding nightlife & an exciting culinary scene. </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 75,
// 	    bgImage:"/posts/bank/75/1.jpg",
// 	    mobBgImage:"/posts/bank/75/M.jpg",
// 	    title: "Jerusalem Marathon",
// 	    smlTitle: "The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											15.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://jerusalem-marathon.com/Register.aspx">
// 												jerusalem-marathon.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>The Ultimate Race against time in this spectacular Marathon held in the 3,000-Year-old magnificent city of Jerusalem</h2>
//                             <p>The International Jerusalem Winner Marathon is one of Israel's largest marathons, with 30,000 participants including hundreds of elite runners from Israel and around the world.</p>
//                             <p>The marathon offers a variety of tracks, from professional to family friendly, which pass by fascinating historical sites that illuminate 3,000 years of the history of Jerusalem, Israel's capital guaranteeing a challenging, thrilling and unforgettable experience for all runners. </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/75/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>With a series of cultural happenings planned around the central event, the Jerusalem International Marathon provides international runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event. </p>
//                             <p>The Jerusalem marathon allows runners the chance to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners.</p>
//                             <p>The course takes the runner on a unique path through Jerusalem’s 3,000-year historical narrative, on the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of Israel’s capital. The course includes the city’s best known sites including, among others, the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 76,
// 	    bgImage:"/posts/bank/76/1.jpg",
// 	    mobBgImage:"/posts/bank/76/M.jpg",
// 	    title: "Bon Jovi",
// 	    smlTitle: "Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, TLV
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											25.07.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												bonjovi.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2>Bon Jovi are Back to take over the hot hot hot Tel Aviv Summer!</h2>
//                             <p>Bon Jovi, all-time favorites in Tel Aviv, are making their way back to the city, famed for its lively music scene once more to appear in the famous Yarkon Park, the beautiful green lung of the city.
//                             <p>Currently touring America to sold out venues, Bon Jovi will arrive here as part of a new European tour in the summer of 2019, entitled "This House is not for Sale". The tour is set will begin on May 31, 2019 in Moscow and will probably end on July 25, 2019 with their show in Tel Aviv.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/76/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>The band, considered e one of the most successful American bands of all times has sold more than 100 million copies, performed in over 2700 concerts in 50 different countries to more than 34 million viewers worldwide.
//                             <p>This is not Bon Jovi's first stint in the city. The band gave a truly memorable performance about three years ago at the Hayarkon Park in Tel Aviv to 50,000 adoring fans, singing along to every lyric .
//                             <p>Those coming to see the band play in Tel Aviv are in for a special treat as they will get to experience Tel Aviv in July, the city’s summer finest,  sunbathe on the fabulous beaches, enjoy the awesome culinary options, take in  the epic hot night life and best of all see Bon Jovi raise it live on stage in the city that doesn’t stop!
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 77,
// 	    bgImage:"/posts/bank/77/1.jpg",
// 	    mobBgImage:"/posts/bank/77/M.jpg",
// 	    title: "TAG 2019",
// 	    smlTitle: "Tel Aviv Games are Back!",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											TAG 2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											27-30.3.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.bonjovi.com/">
// 												www.telavivgames.org
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <h2>
//                             	Tel Aviv Games are Back!
//                           	 </h2>
//                             <p>
// 								Tel Aviv, declared one of the best gay travel destinations in the world, is joining a list of renowned capitals such as Paris, New York, Berlin and Rome, organizing its own LGBT multinational sports event – Tel Aviv Games – TAG2019. TAG 2019 offering the LGBT+ traveler a unique and exciting sports experience.
//                             </p>
//                             <p>
// 								With over 250 athletes from all over the world already signed up, and an estimated 500 more expected, Tel Aviv Games 2019 is anticipated to become the biggest LGBT+ Sports event in the middle east and one of the biggest in Europe.
//                             </p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/77/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>
// 								LGBT+ athletes from more than 17 countries (including France, Germany, UK, US, Australia, Canada, Belgium, Czech Rep., Greece, Netherlands, Norway, Spain, Russia, Surnami and more) will come together for a 3-day multi-national celebration of participation, inclusion and personal best.
//                             </p>
//                             <p>
// 								The tournament will include individual and team events in 7 sporting categories: Swimming, Tennis, Basketball, Soccer, Volleyball, Same Sex Dance, and 5K and 10K Competitive Running.
//                             </p>
//                             <p>
// 								This year Tel Aviv Games will also introduce the city’s first ever “Pride Run - Running for the youth”, supporting Healthy LGBT+ Youth lifestyle in a 5K race along Tel Aviv’s beautiful shore.
// 							 </p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: 78,
// 	    bgImage:"/posts/bank/100/1.jpg",
// 	    mobBgImage:"/posts/bank/100/M.jpg",
// 	    title: "Purim 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv and Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											20-22.03.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tel-aviv.gov.il/en/Pages/MainItemPage.aspx?WebID=9336473c-1537-4ab6-8a69-d299b5db8bcc&ListID=0ac6b290-896c-4fcb-bb36-0c5252101eff&ItemId=123">
// 												Tel Aviv Purim 2019
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                            <p>Every year in March, the people of Tel Aviv & Jerusalem dress up in costumes, the cities are a party and it’s all because of Purim – the most colorful and fun holiday of them all!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>As expected, the party capital doesn’t disappoint, as there are tons of events to choose from – the annual street party is Tel Aviv’s biggest event. Thousands of dressed up people will gather together in “Kikar Hamedina” (State’s Square)  to enjoy performances from top musicians and dance together! The best part? It’s free of charge! If you won’t be too exhausted, you can also participate in Tel Aviv’s Zombie Walk. The name is self-explanatory, as the walk features hundreds of zombies walking through the streets of the city that never sleeps. Other events include Tel Aviv Street Party in Rothschild boulevard and many more.
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/2.jpg"} class="img-responsive" />
// 							</div>
//                             <p>If your prefer to spend the holiday in the city of gold, have no fear as there are plenty of events taking place across Jerusalem – from carnivals to parties there is something for everyone: The official Jerusalem Purim events is at Safra Square, featuring activities and performances for kids. Another option is the event at the Israel Museum that’s meant for the whole family. There’s also a Purim Rave Party at The Tower of David, the traditional parade at Nachlaot street, a party at Downtown Jerusalem building, a Purim party at the Shuka and more events to be confirmed!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/3.jpg"} class="img-responsive" />
// 							</div>
//                             <p>So choose your costume and come celebrate with us!
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/78/4.jpg"} class="img-responsive" />
// 							</div>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "J_Lo",
// 	    bgImage:"/posts/bank/J_Lo/1.jpg",
// 	    mobBgImage:"/posts/bank/J_Lo/M.jpg",
// 	    title: "J.LO",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Hayarkon Park
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											01.08.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								J.LO HEADING TO TEL AVIV TO SET THE SUMMER ON FIRE!
// 							</h3>
// 							<p>
// 								Yes, it's true! after weeks of rumors flying around it is officially confirmed the J.Lo, AKA Jeniffer Lopes, AKA Jenny from the block, the hottest name worldwide as queen of pop for the past 2 decades, is coming to light up your summer in Tel Aviv!
// 							</p>
//                          <p>
// 								Performing for the first time in this country, J.Lo will be getting loud on the floor on August 1st at the Yarkon Park. The show, part of the maga star’s “It’s My Party” worldwide tour is expected to be one of the summer’s biggest concerts, along with Bon Jovi’s highly anticipated performance on the very same Tel Aviv stage on the 25th July.
// 							</p>
// 							<p>
// 								Hayarkon park is Tel Aviv’s green lung. This is the perfect place to get some respite after spending a wild night in Tel Aviv. Here you can spend the day cycling, walking or relaxing in the beautiful outdoor scenery and even enjoy flying high on a hot air balloon before heading to take your place in the stunning amphitheater. Whatever you choose, make sure to come packed with energy for J.Lo’s once in a lifetime performance in sunny awesome Tel Aviv!
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "Pride_Parade_2019",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Pride Parade 2019",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.6.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								The  most fabulous event of the Year
// 							</h3>
// 							<p>
// 								<strong>
// 									Tel Aviv 2019 Pride Celebrations – guaranteed to blow your mind!
// 								</strong>
// 							</p>
// 							<p>
// 								Tel Aviv, one of the most celebrated gay capitals in the world, is famous for its round the clock energy and extravagant nonstop parties. One of the biggest and hottest events, by far in the city is the ‘Gay Pride Week’ parties ending with the awesome Friday Pride Parade.
// 							</p>
//                          <p>
// 								The parade, a tradition which began as early as 1998, draws a huge crowd of the coolest people and thousands of participants from around the world. All them come together to celebrate and support freedom and embrace all lifestyles and genres in an open minded, off the charts, celebration.
// 							</p>
// 							<p>
// 								The parade is the highlight of a week of gay pride events which take place around the city of Tel Aviv and include pride-themed parties, exhibitions, movie festivals, music concerts and so much more.
// 							</p>
// 							<p>
// 								The parade itself takes place along the buzzing main streets of marvelous Tel Aviv, and features, in the tradition of pride parades from across the world, fantastic extravagant floats, live music, dance performances and revelers dressed in a colorful festival dress.
// 							</p>
// 							<p>
// 								The parade stops and rests at the stunning Tel Aviv promenade by the shores of the beautiful coastline, where it turns into an epic adrenaline-charged beach party featuring leading DJs and live performances, lasting well into the small hours of the night.
// 							</p>
// 							<p>
// 								The 2019 parade will take place on June 14th 2019 and participation, as always, will be completely free of charge.
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "Open_Restaurants_Jerusalem",
// 	    bgImage:"/posts/bank/Open_Restaurants_Jerusalem/1.jpg",
// 	    mobBgImage:"/posts/bank/Open_Restaurants_Jerusalem/M.jpg",
// 	    title: "Open Restaurants Jerusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jerusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											19-23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://open-restaurants.co.il/?lang=en">
// 												www.open-restaurants.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h3>
// 								Open Restaurants Jerusalem
// 							</h3>
// 							<p>
// 								Taking place in the iconic city of Jerusalem at varying hours, \‘Open Restaurants\’ is a unique culinary festival giving visitors a glimpse into the fascinating cultural and culinary diversity of Jerusalem.
// 							</p>
// 							<p>
// 								The festival includes about 100 different events held all over the city of Jerusalem, even in places which are less culinary oriented, as well as in culinary adequate venues and combine food with art, culture, innovation and technology.
// 							</p>
//                          <p>
// 								Festival-goers will also have a chance to participate in a series of meetings, workshops and lectures by prominent local personalities, and visits to the city\'s famous restaurant kitchens.
// 							</p>
// 							<p>
// 								As part of the festival program, day and night tours will be held at various culinary centers throughout Jerusalem including flavors tours in the Old City,Ein Kerem and more. You are encouraged to take at least one of them!
// 							</p>
// 							<p>
// 								In addition, FoodTalks meetings will be held with leading culinary experts (we can’t reveal who they are, so keep guessing…), photographers and chefs. The top hotels in Jerusalem will also collaborate with their private chefs at special prices.
// 							</p>
// 							<p>
// 								Whether you’re a foodie or just a curious visitor, you are sure to enjoy this unique taste of magical Jerusalem’s culinary side happening between the 19th -23rd , November,2019.
// 							</p>
// 					               `
// 			}
// 		}
//     },
//     {
//                   id: "Jerusalem_Beer_Festival",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Jerusalem Beer Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													28 - 29.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 	                                <p>The city of Jerusalem is proud to host, for the 15th(!) year in a row – the fabulous and hugely popular ‘Beer Festival’.</p>
// 	                                <p>The Jerusalem Beer Festival is an internationally recognized celebration of good music, good food and of course, you guessed it, great beer. </p>
// 	                                <p>Held in the magical 3000-year-old city of Jerusalem, the festival boasts an incomparable atmosphere, guaranteeing an unforgettable experience. </p>
// 	                                <p>The iconic festival has become over the years, a symbol of Jerusalem's entertainment culture and creates a unique opportunity for visitors from around the globe, to enjoy a delicious variety of cold beers, food and people in open air of Jerusalem.</p>
// 	                                <p>During the festival you will have the opportunity to taste any (or all) of the variety special flavors of beers from around the country and the world (and we have over 120 of them), served in pop up bars, built specifically for the festival. </p>
// 	                                <p>The Jerusalem Beer Festival is the only festival of its kind in Israel, hosting a huge variety of large and international beer brands every year alongside a distinguished presence of local breweries. </p>
// 	                                <p>So make your way and join more than 15,000 visitors coming to enjoy the unique atmosphere, the fantastic live shows, the great food and the awesome people, and to celebrate the global love of Beer.</p>
//                                     <a href="https://www.jerusalembeer.com/en" target="_blank" class="jerusalem-link">www.jerusalembeer.com</a>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "DGTL_Festival",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Hayarkon Park Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													14.10.19
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <p>After its stellar debut in Tel Aviv, DGTL Festival is back, bringing yet another excellent musical program to the Yarkon Park, accompanied by the latest sustainable and technological innovations and fresh art projects.</p>
//                                    <p>The DGTL festival is a global event at the forefront of the music and festivals scene, showcasing in an exclusive list of cities around the world: Amsterdam, Sao Paulo, Barcelona, Santiago and now, Tel Aviv. DGTL brings together the worlds of music, technology and art, as well as the latest discoveries in production and sound.</p>
//                                    <p>The DGTL festival will be held in an expanded edition with a huge lineup and will include four stages which, will operate simultaneously at any given moment.</p>
//                                    <p>In addition to being an innovative music festival, DGTL champions environmental protection and sustainability and has won prizes for being the greenest festival in Europe. The festival has a revolutionary program for reducing electricity consumption, vegetarian food only, a recycling plan and more. </p>
//                                    <p>The Festival will be held in the fabulous Yarkon Park,  situated in the heart of the buzzing city of Tel Aviv. As a hub of innovation, trendiness and exciting nightlife scene, it is the perfect host for DGTL festival. </p>
//                                    <p>Come and get your groove on in the most cutting-edge festival on the planet, held in heart of the most exciting city in the world! </p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "The_International_Arts",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "The International Arts",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Jérusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													12 - 24.08.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
//                                     <h2>The International Arts and Crafts Festival 2019<br>
//                                     <small>Hutzot Hayotzer Jerusalem<small></h2>
//                                     <p>Jerusalem is packed with fantastic events throughout the summer. One of the most celebrated events is the colorful “Hutzot Hayotzer -International Art and Crafts Festival”. </p>
//                                     <p>This large-scale annual festival takes place in the Hutzot Hayotzer lane and the Sultan’s Pool, opposite the Tower of David and at the foot of the walls of the Old City. </p>
//                                     <p>The iconic Hutzot Hayotzer festival has been held for over 35 consecutive years. It has long since became a hugely popular tourist and artistic attraction for visitors from around the world. Visitors will enjoy more than 150 local artists who showcase their art including paintings, prints, ceramics, jewelry and more, as well as an international exhibition, showcasing the work of overseas artists.  They will be able to engage in fascinating art conversations and enjoy unique workshops, live performances, an Irish pub, huge sculptures, live Jazz music, all wrapped up in an authentic European carnival atmosphere. </p>
//                                     <p>The festival is open every evening (except Fridays) between 18:00 and 23:00 and on Saturday night from 21:00 until midnight, at the Hutzot Hayotzer, Mitchell Park and the Merrill Haasenfeld Amphitheater at the Sultan’s Pool.</p>
//                                     <p>Last but definitely not least, don’t miss the “Food around the world” - an Israeli and international food fair, which will include food stalls of various tastes from different world kitchens: Thai, Israeli, Chinese, Korean, and more.</p>
//                                     <a href="https://artfair-jer.com/english/" target="_blank" class="artfair-link">www.artfair-jer.com</a>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Jerusalem_Marathon",
// 	              bgImage:"/posts/bank/jer-marathon2019/1.jpg",
// 	              mobBgImage:"/posts/bank/jer-marathon2019/M.jpg",
// 	              title: "Jerusalem Marathon",
// 	              smlTitle: "",
// 	              html: function(){
// 			                 return {
// 				                 __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Jérusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													20.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://jerusalem-marathon.com/default.aspx">
// 														jerusalem-marathon.com
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 									<div class="responisve-iframe">
// 									<iframe width="560" height="315" src="https://www.youtube.com/embed/7wMT5mKOwYk?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=7wMT5mKOwYk&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
// 									</div>
// 									<br/>
//                                     <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">A Spectacular run through the 3,000-Year-old city</h2>
//                                     <p>With 30,000 participants including hundreds of elite runners from around the world, The International Jerusalem marathon, is a fantastic celebration of body and mind in the heart of one of the most enchanted cities in the world. </p>
//                                     <p>The Jerusalem International Marathon provides the runners with the perfect opportunity to visit the ancient city while participating in a truly modern and excitement-filled competitive sporting event, with a series of cultural happenings planned around the central event.</p>
//                                     <p>The marathon offers a variety of tracks, from professional to family friendly.</p>
//                                     <p>The course takes you by the fascinating historical sites that reveal the 3,000 years of Jerusalem’s history, the cobblestones of the ancient and holy walled city of Jerusalem and through the modern city center of the capital. </p>
//                                     <p>The course includes the city’s best-known sites, among others the Knesset, the Old City, Sultan's Pool, Mount Zion, the German Colony, the Jerusalem Promenade and the Mount of Olives.</p>
//                                     <p>Runners are provided with the opportunity to compete in a setting of unparalleled natural and cultural beauty unlike any other international marathon course. The topography of the city lends itself to a challenging route that will test even the most experienced of runners. Ultimately guaranteeing an illuminating, challenging, thrilling and unforgettable experience for all runners. </p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Open_Houses_Festival",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Open Houses Festival",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv, City -Wide
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													19 - 21.09.2019
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">
// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2>An amazing experience for design lovers everywhere</h2>
//                                     <p>This September, the nonstop city of Tel Aviv will be hosting for the 14th year, the fantastic ‘Open Houses’ Architecture and Design Festival. </p>
//                                     <p>The ‘Open Houses’ opens a one-time door to allow a glimpse into the forms of design, style of living, history, culture, technology, ecology and houses of added value that makes them intriguing and attractive</p>
//                                     <p>The event will include an exciting program of fascinating visits and tours to some of the most intriguing buildings in the city including private homes, apartments, historical as well as urban buildings. The Festival will also include special guided tours and attractions in unusual places -  from tours of residential apartments to tours of  new buildings. </p>
//                                     <p>Among the many buildings and structures open to the public, some of which have never been opened before are:  Tel-Aviv Velodrome, opened for the first time, a ship from within, a synagogue from 1840 in Old Jaffa and some fan favorites including the helipad on the Azrieli roof and a glimpse of the atomic shelter at Dizengoff Center. </p>
//                                      <p>"Open Houses” is part of the Open House World Wide's international organization, operating in New York, London, Chicago, Rome, Barcelona, Melbourne, Dublin, Helsinki, and more. </p>
//                                     <p>Be sure to check out what is guaranteed to be a unique and unforgettable urban celebration in the awesome city of Tel Aviv!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "TelAviv_Marathon",
// 	              bgImage:"/posts/bank/tlv-marathon2020/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-marathon2020/M.jpg",
// 	              title: "Le Marathon de Tel-Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			              return {
// 				              __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Tel Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													28.02.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://www.tlvmarathon.co.il/MenuDefault.aspx?id=6607">
// 														www.tlvmarathon.co.il
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 									<div class="responisve-iframe">
// 									<iframe width="560" height="315" src="https://www.youtube.com/embed/7wMT5mKOwYk?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=7wMT5mKOwYk&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
// 									</div>
// 									<br/>
//                                     <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Courez et amusez-vous dans la ville qui ne s’arrête jamais</h2>
//                                    <p>Le Marathon de Tel-Aviv est le plus grand événement sportif international du pays. Une célébration unique et palpitante pour les coureurs du monde entier. La rencontre se déroule au cœur de la fabuleuse Tel-Aviv. L’opportunité, pour les participants, de profiter des sites et vues remarquables, et de sentir le pouls de cette métropole chargée d’adrénaline.</p>
//                                    <p>Ils seront quelque 40 000 coureurs venus des quatre coins du monde, pour participer aux différentes courses de cet événement annuel, qui permet aux sportifs ou amateurs de tous niveaux et de tous styles, professionnels sur longue distance ou débutants, de prendre le départ.</p>
//                                    <p>Le Marathon de Tel Aviv s'étend le long du magnifique front de mer, traversant les étonnants sites de la Ville blanche – classée au patrimoine mondial de l'UNESCO - et ses diverses artères élégantes et animées, rassemblant sur son passage plus de 150 000 personnes venues prendre part aux nombreux événements parallèles ou encourager les coureurs le long du circuit plat et convivial.</p>
//                                    <p>La rencontre sportive est en fait un festival géant, dotée de tout un éventail d’événements animés, avant et après la course. Au programme : danse et musique live à gogo et de nombreuses autres attractions, pour le plus grand plaisir des coureurs et des supporters.</p>
//                                    <p>Surnommé « la capitale méditerranéenne la plus cool » par le New York Times et l’une des « 10 villes les plus actives » selon Lonely Planet, Tel-Aviv offre une multitude d'attractions fascinantes tous domaines confondus : des plages dorées éblouissantes, des marchés colorés, une richesse culturelle et des divertissements d'avant-garde, une vie nocturne exceptionnelle, ainsi qu’une étonnante scène culinaire.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Night_Run_TelAviv",
// 	              bgImage:"/posts/bank/tlv-nightrun2019/1.jpg",
// 	              mobBgImage:"/posts/bank/tlv-nightrun2019/M.jpg",
// 	              title: "Night Run Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.tlvnightrun.co.il/MenuDefault.aspx?id=6571">
// 												www.tlvnightrun.co.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2>The most exhilarating 10km you will ever experience</h2>
//                                     <p>A lot has been said about the world-renowned city of Tel Aviv. Named among Lonely Planet’s 'Top 10 Action-Packed Cities’, this city is a truly trendy buzzing metropolis that doesn’t rest. While its official slogan is the Non Stop City, it truly gives NYC a run for its money for the title the City that doesn’t sleep. </p>
//                                     <p>This is especially the case when it comes to the amazing Night Run Tel Aviv annual race. </p>
//                                     <p>With around 25,000 runners and tens of thousands of cheering spectators, this upbeat adrenaline-charged race is more of a full-blown night time party for the scores of participants and spectators who come from all around the world to take part.</p>
//                                     <p>Taking place during the autumn, the 10KM night run begins well after sundown and follows a fantastic urban route along the streets of Tel Aviv, starting at  Rabin Square in the center of town, and south along Rothschild Boulevard, before continuing along Dizengoff Street, Nordau Boulevard, and into Park Hayarkon, reaching the finish line alongside the river. </p>
//                                     <p>You will be passing all the trendy,, fascinating attractions and renowned Bauhaus architecture the "White City" of Tel Aviv has been declared a UNESCO World Heritage Site for. </p>
//                                     <p>Best of all, The TLV Night Run ends with a celebratory finish line festival at Hayarkon park in the heart of the city where thousands more come to join the runners and spectators in an all-night rager of music, dancing and nonstop fun.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Celine_Dion",
// 	              bgImage:"/posts/bank/Celine_Dion/1.jpg",
// 	              mobBgImage:"/posts/bank/Celine_Dion/M.jpg",
// 	              title: "Celine Dion",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											04.08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.celinedion.com">
// 												www.celinedion.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Our Heart Goes On – for Celine Dion in Tel Aviv!</h2>
// 										<p>The Diva is coming! Now it’s official: Celine Dion will perform in Tel Aviv on August 4th of next summer and it’s going to be a hot one! This will be Dion’s first ever concert here, and boy are we excited.</p>
//                                         <p>The 6 Grammy award-winner will visit Tel Aviv, the city that never sleeps, to keep the party going all Night. Dion’s countless hits, “Because you Loved Me”, “Just Walk Away” and of course her all-time greatest hit – “My Heart Will Go On” – will hopefully make their debut live in Tel Aviv.</p>
//                                         <p>Tel Aviv has also hosted some of the largest art exhibitions, live shows and festivals, making it one of the liveliest cities in the world. With a combination of sun, rich nightlife scene, spectacular sights in every corner and the Dion’s first appearance – Tel Aviv is the place to be next summer.</p>
//                                         <p>Ticket sales have yet to open, but it’s never too early to start planning your next visit to Tel Aviv!
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Nickcave_Badseeds",
// 	              bgImage:"/Concerts/bank/nickcave_badseeds/1.jpg",
// 	              mobBgImage:"/Concerts/bank/nickcave_badseeds/M.jpg",
// 	              title: "NICK CAVE & BAD SEEDS",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Bloomfield Stadium, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											17.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="">
// 												Update Soon
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">NICK CAVE AND THE BAD SEEDS LIVE IN TEL AVIV!</h2>
//                                     <p>Nick Cave is coming to Tel Aviv to blow the roof off! Returning to the city that never sleeps in June 2020, the Australian pop-punk musician is coming to rock you.</p>
//                                     <p>Having recorded no less than 17 studio albums with his band, the talented musician is excited about his visit – which will be hotter than ever.</p>
//                                     <p>Coming back just a little more than two years after his previous performance here, this time, lighting up the newly renovated Bloomfield Stadium (which has hosted a long line of international artists). Judging by the last performance, this one should be truly sensational.</p>
//                                     <p>Tel Aviv has been known to attract and feature some of the biggest names in the world, making it one of the hottest cities when it comes to live concerts and the nightlife scene. This performance shouldn’t be any different and is a great opportunity to catch Nick Cave live, as part of his summer tour.</p>
//                                     <p>Warm summer nights, soft sand beaches and the mesmerizing music of a world-renowned artist – what more could you ask for? Tel Aviv has it all!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Louis_CK",
// 	              bgImage:"/posts/bank/Louis_CK/1.jpg",
// 	              mobBgImage:"/posts/bank/Louis_CK/M.jpg",
// 	              title: "He’s coming back! Louis CK in Tel Aviv",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Hangar 11, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											23.11.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.facebook.com/events/%D7%A4%D7%99%D7%A1-%D7%90%D7%A8%D7%A0%D7%94-%D7%9E%D7%9C%D7%97%D7%94-%D7%99%D7%A8%D7%95%D7%A9%D7%9C%D7%99%D7%9D/%D7%9C%D7%95%D7%90%D7%99%D7%A1-%D7%A1%D7%99-%D7%A7%D7%99%D7%99-%D7%91%D7%94%D7%95%D7%A4%D7%A2%D7%94-%D7%91%D7%99%D7%A9%D7%A8%D7%90%D7%9C-louis-ck-live-in-israel/554683431359536/">
// 												Louis CK
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>Back for the second time, Louis CK will preform at the Hangar 11 in Tel Aviv, this upcoming November.</p>
//                                     <p>After his tremendous success in Jerusalem in 2016, Louis CK is about to return for another exclusive show; this time, right here in Tel Aviv, one of the hottest cities for live shows.</p>
//                                     <p>The talented, hilarious comedian is back in action after a two-year break making this show, bigger, better and funnier than ever. Having a wide following audience in Tel Aviv alone, the sharp comedian is sure to light up the stage.</p>
//                                     <p>Tel Aviv has hosted dozens of comedians from all over the world, including Jerry Seinfeld and Chris Rock, Jim Jefferies and many others, is the ultimate city for having a good time. The city is known for its art and culture as well as its exciting club scene and trendy bars and restaurants.</p>
//                                     <p>So book your trip now and get ready for an unforgettable time in the city that doesn’t stop!</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Cycle_Tel_Aviv",
// 	              bgImage:"/Concerts/bank/cycle-tlv-2019/1.jpg",
// 	              mobBgImage:"/Concerts/bank/cycle-tlv-2019/M.jpg",
// 	              title: "Cycle Tel Aviv",
// 				  vidId: "5nqL-oIC0GA",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                              <div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											All Around Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											18.10.2019
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                                     <p>The mild to warm October weather, combined with the energetic vibe of Tel Aviv, provide the perfect setting for the biggest cycling event in the country.</p>
//                                     <p>Thousands of cycling enthusiasts flock to Tel Aviv to ride through the vibrant city, on a scenic course showing you everything Tel Aviv has to offer:</p>
//                                     <p>From the beautiful Yarkon Park, along the coast, past the city’s many dazzling beaches and back up to the park through the city center, you’ll get a glimpse of every characteristic place, the “Mediterranean capital” has to offer.</p>
//                                     <p>Everyone can experience the thrill and excitement of the event, from the 60 km course for professional riders to the 8 km course for families and beginners, there is even a rollerblades course for those who prefer to make their way through the city on foot.</p>
//                                     <p>With the locals coming out in droves to cheer on the event, you’ll see a colorful and diverse crowd, adding to the fun and excitement in the air.</p>
//                                     <p>Whether you’re looking for a personal challenge to compete against some of the top riders in the country, or you’re hoping to enjoy a family day out with the crowds, you’re sure to experience the beauty and energy that makes up the unique atmosphere of Tel Aviv.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "DGTL_Festival_2020",
// 	              bgImage:"/posts/bank/dgtl-festival2019/1.jpg",
// 	              mobBgImage:"/posts/bank/dgtl-festival2019/M.jpg",
// 	              title: "DGTL FESTIVAL",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Parc Hayarkon Tel-Aviv
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="https://tlv.dgtl.nl/en/dgtl-tel-aviv-returns-to-israel/">
// 														www.tlv.dgtl.nl
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							        <p>Le Festival DGTL est de retour au parc Hayarkon ! Avec, cette année encore, un excellent programme musical soutenu par les dernières innovations technologiques et durables, et des projets artistiques originaux.</p>
// 									<p>Le Festival DGTL est un événement mondial à la pointe de la scène musicale et festivalière, qui se produit dans un cercle sélect de villes internationales : Amsterdam, Sao Paulo, Barcelone, Santiago et désormais, Tel-Aviv. DGTL combine les mondes de la musique, de la technologie et de l'art, ainsi que les dernières découvertes en matière de production et de son.</p>
// 									<p>Le festival voit grand avec une programmation édifiante et quatre scènes qui officieront simultanément pendant tout le festival.</p>
// 									<p>DGTL est non seulement un festival de musique innovant, mais aussi un champion de la protection de l'environnement et du développement durable, ce qui lui a valu de remporter des prix en tant que festival le plus vert d'Europe. A son actif : un programme révolutionnaire pour réduire la consommation d'électricité, de la nourriture végétarienne uniquement, un plan de recyclage, et plus encore.</p>
// 									<p>Le festival se tiendra dans le fabuleux parc Hayarkon, situé au cœur de la vibrante Tel-Aviv. Cette ville animée, plaque tournante de l'innovation, des tendances et de la vie nocturne palpitante, est l'hôte idéal pour accueillir le DGTL.</p>
// 									<p>Venez vibrer au rythme du festival le plus avant-gardiste de la planète, au cœur de la ville la plus envoûtante au monde !</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "Pride_Week_2020",
// 	    bgImage:"/posts/bank/Pride_Parade_2019/1.jpg",
// 	    mobBgImage:"/posts/bank/Pride_Parade_2019/M.jpg",
// 	    title: "Semaine de la fierté 2020",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											12.6.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<div class="responisve-iframe">
// 					             <iframe width="560" height="315" src="https://www.youtube.com/embed/U8KwXVP3Xng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				             </div>
// 				             <div class="ac-cradit" style="margin-top: -15px;margin-bottom: 40px;">
// 							<span class="ac-cradit-text">Credits:</span>
// 								<span class="ac-cradit-text-1"><a href="https://www.youtube.com/channel/UCWN-mUP4IzdHLH7gaXHEKVw" target="_blank">Basti Hansen</a><br/>
// 							</div>
// 							<p></p>
// 							</div>
//                             <h2  class="ac-align-center">L'événement absolument fabuleux de l’année</h2>
//                             <p class="ac-align-center ac-margin-bottom-20"><strong>Célébrations de la fierté 2020 à Tel-Aviv – Vous allez être bluffé !</strong></p>
//                             <p>Tel-Aviv, l'une des capitales gays les plus célèbres au monde, est bien connue pour son énergie 24h/24 et ses soirées extravagantes sans interruption. Parmi ses événements les plus importants et les plus intenses, figure en bonne place la semaine de la Gay Pride, avec, en point d’orgue, l’impressionnante parade de la fierté du vendredi.</p>
//                             <p>Ce défilé, tradition qui remonte à 1998, attire une foule particulièrement dense et décontractée, venue du monde entier pour célébrer et soutenir avec une ouverture d’esprit, la liberté et l'acceptation de tous les genres et modes de vie.</p>
//                             <p>Il constitue le point culminant d'une semaine d'événements dans la ville, avec au programme : fêtes non-stop sur le thème de la fierté, expositions, festivals de cinéma, concerts de musique et bien plus encore.</p>
//                             <p>Cette tourbillonnante parade se déroule tout au long des principales artères animées de l'incroyable Tel-Aviv et présente, dans la tradition des défilés de fierté du monde entier, des chars fantastiques, de la musique live, des spectacles de danse et des fêtards vêtus de festifs costumes colorés.</p>
//                             <p>Elle s’achève sur la promenade de Tel-Aviv qui longe la magnifique côte méditerranéenne, pour se transformer sur la plage en fête épique, chargée d'adrénaline, avec des DJ de pointe et des spectacles live, jusqu'aux petites heures de la nuit.</p>
//                             <p>Cette année, le défilé aura lieu le 12 juin 2020. Et, comme d’habitude, la participation est entièrement gratuite.</p>
// 					               `
// 			}
// 		}
//     },
//     {
// 	              id: "Hutzot_Hayotzer_Jerusalem_2020",
// 	              bgImage:"/posts/bank/international-arts/1.jpg",
// 	              mobBgImage:"/posts/bank/international-arts/M.jpg",
// 	              title: "Houtsot Hayotser Jérusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			return {
// 				__html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Piscine du sultan, Jérusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 							        <div class="clear"></div>
//                                    <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">Le Festival international des arts et de l'artisanat</h2>
//                                     <p>Tout l’été, Jérusalem regorge d’événements extraordinaires. Parmi les plus célèbres, le très coloré « Houtsot Hayotser – Le Festival international des arts et de l'artisanat ».</p>
// 									<p>Ce festival annuel de grande envergure s’installe chaque année dans les ruelles de Houtsot Hayotser et la piscine du Sultan, face à la tour de David et au pied des murailles de la Vieille ville.</p>
// 									<p>Fort de ses 35 ans d’existence, ce festival emblématique constitue une attraction touristique et artistique incontournable pour les visiteurs du monde entier. A son actif, plus de 150 artistes locaux qui viennent présenter leurs créations : peintures, estampes, céramiques, bijoux, et plus encore. Il comprend également une exposition internationale mettant en valeur le travail de créateurs étrangers. </p>
// 									<p>Les visiteurs pourront ainsi s’engager dans un fascinant dialogue avec l’art, ou profiter d'ateliers uniques, de spectacles live, d'un pub irlandais, d’imposantes sculptures, de concerts de jazz, le tout dans une authentique atmosphère de carnaval européen.</p>
// 									<p>Le festival est ouvert tous les soirs (sauf le vendredi) de 18h00 à 23h00 et le samedi soir de 21h00 à minuit, à Houtsot Hayotser, au Parc Mitchell et à l’amphithéâtre Merrill Haasenfeld de la piscine du Sultan.</p>
// 									<p>Dernier point, mais non des moindres, ne manquez pas « Nourriture du monde » - une foire alimentaire israélienne et internationale, avec ses stands de plats originaux et ses différentes saveurs de cuisines du monde : thaïlandaise, israélienne, chinoise, coréenne, etc.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//                   id: "Jerusalem_Beer_Festival_2020",
// 	              bgImage:"/posts/bank/jerusalem-beer-festival/1.jpg",
// 	              mobBgImage:"/posts/bank/jerusalem-beer-festival/M.jpg",
// 	              title: "Le Festival de la bière de Jérusalem",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Time</h2>
// 											<div class="text">
// 												<p>
// 													18:00 – 00:00
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													08.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="clear"></div>
// 							         <p>La ville de Jérusalem est fière d’accueillir, pour la 16e année (!) consécutive, son fabuleux "Festival de la bière", un rendez-vous incontournable.</p>
// 									<p>Le Festival de la bière à Jérusalem est une célébration de renommée internationale sur fond de bonne musique, de bons plats et bien sûr, vous l'aurez deviné, d’excellentes bières.</p>
// 									<p>Organisé dans la magique cité hiérosolomytaine de 3000 ans, l’évènement se caractérise par une atmosphère incomparable, qui promet une expérience inoubliable.</p>
// 									<p>Ce rendez-vous emblématique est devenu au fil des ans un symbole de la culture de divertissement de Jérusalem et offre aux visiteurs du monde entier une occasion unique de déguster une excellente palette de bières fraîches, de plats et de nouvelles rencontres, en plein air.</p>
// 									<p>Le temps du festival, vous pourrez savourer un ou plusieurs parfums des 120 bières typiques ou insolites, locales ou internationales, servies dans des bars éphémères, construits spécialement pour l’occasion.</p>
// 									<p>Le Festival de la bière de Jérusalem est un évènement unique en son genre en Israël, qui accueille chaque année une grande variété de bières internationales aux côtés d’une présence notable de brasseries locales.</p>
// 									<p>Alors, n’hésitez pas à rejoindre ces plus de 15 000 visiteurs venus profiter de cette atmosphère unique, de cette délicieuse cuisine, de ces fantastiques spectacles live, et de ce public formidable, pour célébrer vous aussi l'amour de la bière.</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "Jerusalem_Wine_Festival_2020",
// 	    bgImage:"/Concerts/bank/jer-wine-festival-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jer-wine-festival-2020/M.jpg",
// 	    title: "Le Festival du vin de Jérusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jérusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											08.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://www.imj.org.il/en/events/wine-festival-1">
// 												www.imj.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">   Vins fins et collations de rêve dans<br/> la Ville sainte !</h2>
// 				            <p>Qui dit soirées d'été relaxantes, dit verre de bon vin ! Quatre jours durant, en août, vous pourrez profiter de sélections de crus de classe mondiale et de plats primés, à l’occasion de la 16e édition annuelle du Festival du vin de Jérusalem. Hébergé dans les superbes jardins d'art japonais du musée d'Israël, il est considéré par beaucoup comme le premier événement social de la cité hiérosolomytaine. Et de fait, ce n'est pas un festival comme les autres : l'ambiance et la vue imprenable sur la ville historique se combinent pour en faire une expérience à ne pas manquer.</p>
//                             <div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/69/1.jpg"} class="img-responsive" />
// 							</div>
//                             <p>Des centaines de vins seront proposés par des dizaines de vignobles boutique bien connus. Aux dégustations gratuites de vin, s’ajoutent également une oasis culinaire d’étals de fromages, chocolats, huiles d'olive, sauces exceptionnelles et autres confitures savoureuses. Le tout sur un fond sonore des plus agréables puisque le festival proposera tous les soirs deux concerts de musique live.</p>
//                             <p>Chaque année, l’événement accueille à Jérusalem une foule diversifiée et raffinée de plus de 20 000 amateurs de vin et de culture. Beaucoup ne se contentent pas d’une seule soirée, ne serait-ce que pour s’enivrer de cette atmosphère si particulière. Et pourquoi ne pas construire votre séjour dans la capitale autour du festival ! Certes, vos journées seront déjà remplies de visites, shopping et autres découvertes de la ville. Mais le moyen idéal pour finir la soirée en beauté pourrait bien être de profiter chaque soir du Festival du vin de Jérusalem !</p>
// 					     `
// 			}
// 		}
//     },
//     {
// 	              id: "Open_Houses_Festival_2020",
// 	              bgImage:"/posts/bank/openhf/1.jpg",
// 	              mobBgImage:"/posts/bank/openhf/M.jpg",
// 	              title: "Le Festival Maisons Ouvertes",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-30">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 														Tel-Aviv, dans toute la ville
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													09.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-30">
// 										<div class="top-box yellow">
// 											<h2>Plus D'infos sur:</h2>
// 											<div class="text info">
// 												<p>
// 													<a target="_blank" href="//www.batim-il.org/DefaultEng.aspx?batim=">
// 														www.batim-il.org
// 													</a>
// 												</p>
// 											</div>
// 										</div>
// 									</div><div class="clear"></div>
//                                     <h2  class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">  Une expérience enthousiasmante pour les amateurs de design du monde entier	</h2>
// 									<p>Ce mois de septembre, Tel-Aviv, la ville qui ne s’arrête jamais, accueillera pour la 14e année consécutive son emblématique festival d’architecture et de design "Maisons Ouvertes".</p>
// 									<p>Un événement hors-du-commun au programme alléchant : visites et découvertes fascinantes de certains des édifices les plus énigmatiques de la ville - maisons particulières, appartements, bâtiments historiques et immeubles urbains. Le festival proposera également des visites guidées originales et diverses attractions dans des lieux insolites.</p>
// 									<p>Le temps d’un week-end, ces "Maisons Ouvertes" ouvrent une fenêtre sur un monde méconnu et donnent un avant-goût des différentes facettes du design, de la vie, l’histoire, la culture, la technologie, l’écologie, qui rendent si fascinantes et attrayantes ces maisons à valeur ajoutée.</p>
// 									<p>Parmi les nombreux bâtiments et édifices ouverts au public, certains d'entre eux s’exposent pour la première fois : le vélodrome de Tel-Aviv, l’intérieur d’un navire, une synagogue de 1840 du vieux Jaffa et quelques lieux cultes, comme l’héliport du toit Azrieli ou un aperçu de l’abri antiatomique du centre Dizengoff.</p>
// 									<p>"Maisons Ouvertes" fait partie de l'organisation internationale Open House World Wide (Maisons Ouvertes dans le monde entier), qui s’illustre, entre autres, à New York, Londres, Chicago, Rome, Barcelone, Melbourne, Dublin, Helsinki, ou ailleurs…</p>
// 									<p>On vous promet une célébration urbaine unique et inoubliable dans l’impressionante ville de Tel-Aviv ! Prenez note !</p>
// 	                            `
// 			}
// 		}
//     },
//     {
// 	              id: "Purim_2020",
// 	              bgImage:"/Concerts/bank/purim2020/1.jpg",
// 	              mobBgImage:"/Concerts/bank/purim2020/M.jpg",
// 	              title: "Pourim 2020",
// 	              smlTitle: "",
// 	              html: function(){
// 			             return {
// 				             __html: `
//                                     <div class="col col-50">
// 										<div class="top-box yellow">
// 											 <h2>lieu</h2>
// 											<div class="text">
// 												<p>
// 													Tel-Aviv et Jérusalem
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									<div class="col col-50">
// 										<div class="top-box yellow">
// 											<h2>Date</h2>
// 											<div class="text">
// 												<p>
// 													09-10.03.2020
// 												</p>
// 											</div>
// 										</div>
// 									</div>
// 									</div><div class="clear"></div>
//                                     <p>Chaque année en mars, Tel-Aviv et Jérusalem sont en liesse ; partout dans les rues, leurs habitants sont déguisés. La raison ? Pourim – la fête la plus gaie et la plus colorée du calendrier !</p>
// 									<div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/1.jpg"} class="img-responsive" />
// 									</div>
// 									<p>Comme à son habitude, la capitale du loisir ne déçoit pas. Tel-Aviv offrira un vaste panel d’événements à célébrer – avec, en point d’orgue, sa parade annuelle. Des milliers de personnes déguisées se réuniront à Kikar Hamedina pour profiter des prestations des meilleurs musiciens et danser ensemble ! Et vous savez quoi ? C'est gratuit ! Si vous n’êtes pas trop épuisé, vous pourrez aussi participer à la Zombie Walk de Tel-Aviv. Son nom est explicite : il s’agit d’une marche où des centaines de participants grimés en morts-vivants déambulent dans les rues de la ville qui ne dort jamais. Parmi les événements majeurs, on peut également citer la fête de rue du boulevard Rothschild et bien d'autres encore…</p>
// 									 <div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/2.jpg"} class="img-responsive" />
// 									</div>
// 									<p>Si vous optez pour la ville d'or, vous ne serez pas déçus, de nombreuses attractions sont également prévues à Jérusalem - carnavals ou festivités, il y en aura pour tous les goûts. Les événements officiels de Pourim se dérouleront sur l’esplanade de la municipalité, place Safra. Au programme : activités et spectacles pour enfants. Autre option, le Musée d'Israël qui organise des événements pour toute la famille. A noter également : une Rave Party de Pourim à la Tour de David, le défilé traditionnel de la rue Nahlaot, une fête au centre-ville de Jérusalem, des animations de Pourim au Shouk et tant d'autres rendez-vous à confirmer !</p>
// 									<div class="img-wrapper">
// 										<img src=${getImgUrl() + "/Concerts/purim2020/4.jpg"} class="img-responsive" />
// 									</div>
// 									<p>Il ne vous reste qu’à choisir votre costume et rejoignez-nous pour faire la fête !</p>
// 	                            `
// 			}
// 		}
//     },
//     {
//         id: "TelAviv_Fashion_Week_2020",
// 	    bgImage:"/Concerts/bank/fashion-week-2020/1.jpg",
// 	    mobBgImage:"/Concerts/bank/fashion-week-2020/M.jpg",
// 	    title: "La Fashion Week de Tel-Aviv",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											03.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//fashionweektelaviv.com/">
// 												fashionweektelaviv.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">C'est chic, magnifique!</h2>
// 							<p>Chaque défilé de mode est une célébration de l'élégance, de l'imagination, de la créativité et du style. La Fashion Week de Tel-Aviv n’échappe pas à la règle : elle a su mettre sa griffe sur l’industrie de la mode internationale, avec ses idéaux de beauté en pleine évolution et ses modèles hommes et femmes, de tous âges, tailles, hauteurs, couleurs et religions. L'événement de 4 jours présente des collections inhabituelles de la scène internationale et locale, avec des créateurs issus du dynamique monde du design de la ville et de ses environs.</p>
//                              <!--<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/72/1.jpg"} class="img-responsive" />
// 							</div>-->
// 							<p>La Fashion Week de Tel-Aviv est également à la pointe de la mode pour présenter des concepts d’utilisation innovants de la technologie et des textiles. Quant au soutien qu’elle apporte aux jeunes designers, elle n’en est pas peu fière. Comme lors des éditions précédentes, ce 7e événement annuel proposera un défilé des designers de demain, l’opportunité pour les nouveaux talents de partager leurs créations avec les participants.</p>
//                             <p>En 2020, la Fashion Week de Tel-Aviv aura lieu, une fois encore, dans le complexe historique de la Tahana. Dernière station de la liaison ferroviaire qui reliait autrefois Jaffa à Jérusalem, cette ancienne gare a été reconvertie en centre commercial à ciel ouvert, un des lieux publics les plus vivants et les plus animés de Tel-Aviv, situé dans un quartier branché ponctué de maisons pastel, de boutiques stylées et de cafés tendance. La Fashion Week sera pour vous l’occasion d’approcher l’univers de la mode et d'explorer toute la région !</p>
// 					               `
// 			}
// 		}
//     },
//     {
//         id: "The_Jerusalem_March_2020",
// 	    bgImage:"/Concerts/bank/jerusalem-march/1.jpg",
// 	    mobBgImage:"/Concerts/bank/jerusalem-march/M.jpg",
// 	    title: "La Marche de Jérusalem",
// 	    smlTitle: "",
// 	    html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Jérusalem
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											30.09.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>La Marche de Jérusalem est l'un des événements les plus colorés et les plus excitants du pays. Organisée au mois d’octobre, elle rassemble des dizaines de milliers de marcheurs du monde entier.
//                             <p> Elle comprend trois événements - un parcours matinal sur des chemins de randonnée, un happening dans le parc Sacher et un défilé festif dans les rues du centre-ville de Jérusalem.
//                             <p>Pour permettre au plus grand nombre de prendre part à l’aventure, plusieurs itinéraires de longueurs variables et de différents niveaux de difficulté sont proposés.
//                             <p><strong>Pistes du matin</strong><br/>
//                                 Piste A - Pour les bons marcheurs, environ 12 km (7h00 à 9h00)</p>
//                             <p><strong>De la Colline des munitions au parc Sacher.</strong><br/>
//                                 Piste B - Niveau de difficulté moyen, environ 9 km (7h30 à 9h30)</p>
//                             <p><strong>Da Mount Scopus a Sacher Park.</strong><br/>
//                                 Piste C - Niveau de difficulté facile / familial, environ 4 km (8h00 à 10h00)</p>
//                             <p>De la place Safra au parc Sacher.<br/>
//                                 Festival au parc Sacher</p>
//                             <p>Entre 10h00 et 16h00, un événement festif aura lieu au parc Sacher, avec des représentations, de la musique live et des spectacles pour enfants, ainsi qu'un espace dédié aux plus jeunes.</p>
//                             <p>Le défilé festif prendra le départ à 15h00 pour longer les rues de Bezalel, Hillel et King David, avant de se terminer à proximité du parc de la Cloche. La parade se composera de véhicules de collection, délégations d'Israël et du monde entier, orchestres, groupes de danse, soldats de Tsahal, artistes de rue, équipes sportives et plus encore.</p>
//                             <p>Ne manquez pas votre chance de participer à cette célébration de Jérusalem, parmi les plus belles et les plus animées !</p>
// 				`
// 			}
// 		}
//     },
//     {
//         id:"The_Pixies_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Les Pixies",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											14.07.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="//www.pixiesmusic.com">
// 											www.pixiesmusic.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
//                             <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">The Pixies sont de retour pour du rock en live à Tel-Aviv !</h2>
// 										<p>L'été israélien est toujours chaud, mais le retour des Pixies à Tel-Aviv après 3 ans d’absence, va faire encore monter la température d’un cran !</p>
//                                         <p>Le célèbre groupe américain, bien connu pour son style de punk rock et de pop agressif, est à l’origine de certaines des chansons les plus emblématiques de l’histoire de la musique. En particulier avec son tube intemporel ‘Where is my mind’. Les pixies reviennent à Tel-Aviv pour la troisième fois, dans le cadre de la tournée promotionnelle de leur nouvel album, ‘Beneath the Eyrie’.</p>
//                                         <p>Ils donneront une représentation unique dans la ville qui ne s’arrête jamais, de quoi faire vibrer vos vacances de sable, soleil et loisirs. Le concert est prévu en juillet, moment idéal pour profiter du célèbre été telavivien, de ses fêtes, sa cuisine gourmande et ses plages enivrantes.</p>
//                                         <p>Les billets se vendent rapidement. Alors n’hésitez pas et réservez votre voyage dès aujourd'hui !</p>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:"White_Night_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Nuit Blanche",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-50">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							                <h2 class="ac-align-center ac-margin-bottom-20 ac-margin-top-20">
// 											   "Nuit Blanche" détonante dans la ville non-stop !
// 											</h2>
// 				        					<div class="responisve-iframe">
// 												<iframe width="560" height="315" src="https://www.youtube.com/embed/T0ugqxG5UaM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 											</div>
//                                             <p>Lorsqu'une cité connue aux quatre coins de la planète comme la "ville qui ne dort jamais" organise une "Nuit Blanche" - aucun doute que vous voudrez, vous aussi, être de la partie. "Nuit Blanche" est l'un des plus grands événements de Tel-Aviv. Une célébration annuelle traditionnelle qui tient la ville éveillée toute la nuit : tout y est ouvert et tout s’y passe en même temps…</p>
//                                             <p>Du début de soirée jusqu'à l'aube, la cité regorge de touristes et de locaux, débordant d’énergie et prêts à profiter de tout ce qui s’offre à eux – magasins, restaurants, cinémas et autres lieux de culture – le tout, gratuitement ou à tarifs réduits, toute la nuit !</p>
// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/1.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Photo : Adam Primer
// 											</small>
// 											<p>L'origine de cet événement désormais mondialement connu remonte à 2003, lorsque l'Unesco inscrit au patrimoine mondial la "ville Blanche", pour sa plus grande collection architecturale de bâtiments de style Bauhaus. Une reconnaissance qui lui confère alors un statut unique dans le patrimoine architectural de l'ère moderne.</p>
//                                             <p>Depuis, la municipalité de Tel-Aviv-Jaffa célèbre chaque année cette déclaration historique par une série d'événements qui s’inscrivent dans une fantastique "Nuit Blanche", faisant écho aux deux surnoms de Tel-Aviv-Jaffa, la "ville Blanche" et "la ville qui ne s'arrête jamais".</p>
// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/2.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Photo : Kfir Sivan
// 											</small>
//                                             <p>La Nuit Blanche consiste en un festival de festivités, chaque année de plus en plus nombreuses, organisées dans toute la ville. Au programme de ces dernières éditions, pour n'en citer que quelques-uns : pique-nique de minuit hors-du-commun, épique Silent Party (soirée à casque) sur la place principale de la ville, innombrables concerts de musique live, superbes représentations théâtrale ou spectacles de rue, fascinantes visites de nuit, cours de sport nocturnes, yoga au lever du soleil, et tant d’autres moments fantastiques, qui se déroulent simultanément, le temps d’une nuit, à travers toute la ville</p>
//                                             <div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/3.jpg"} class="img-responsive" />
// 							                </div>
// 											<small>
// 												Photo : Moshik Lindenbaum
// 											</small>
// 											<p>Ti consigliamo di riposarti a dovere, perché avrai bisogno di tutta la tua energia per stare al passo con la “Notte Bianca” nella meravigliosa città di Tel Aviv! </p>
// 											<div class="img-wrapper">
// 								                <img src=${getImgUrl() + "/Concerts/60/4.jpg"} class="img-responsive" />
// 							                </div>
// 											<p>En résumé, commencez par vous reposer, vous aurez besoin de toute votre énergie pour suivre le rythme endiablé de la "Nuit Blanche" de Tel-Aviv !</p>
// 											<small>
// 												Photo : Guy Yechiely
// 											</small>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:"Piano_Competition_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "The Rubinstein International Piano Competition 2020",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											05-21.05.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://arims.org.il/">
// 											www.arims.org.il
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<p>There is no shortage of fantastic arts and culture events in Tel Aviv, but the Rubinstein International Competition is the pride of the city. </p>
// 							<p>39 extremely talented pianists have been nominated to participate in the 16th Arthur Rubinstein International Piano Master Competition. 15 competitors are coming from Asia, 10 from Eastern Europe, 7 from Europe, 3 local talents, 2 from Georgia, and 2 from the USA. Tel Aviv, the cultural hub, is happy to welcome all of them. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/piano-competition-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>The first two stages of this prestigious competition will be held at the Tel Aviv Museum of Art, one of the country’s leading artistic and cultural institutions. The lively Sarona Market is only a 10-minute stroll from there. </p>
// 							<p>The final stages will be hosted at the Charles Bronfman Auditorium, also known as the Culture Palace (Heichal HaTarbut), located in Habima Square, next to the national theater. Some of the best cafés and restaurants of Tel Aviv are located nearby, as well as the beautiful Rothschild Boulevard. </p>
// 							<p>Early tickets sale for friends of the society and newcomers has already started. The regular sale will commence on 16 February 2020. </p>
// 						`
// 			}
// 		}
// 	},
// 	{
//         id:"Red_Hot_Chili_Peppers_2020",
//         bgImage :"/posts/bank/14/1.jpg",
//         mobBgImage :"/posts/bank/14/M.jpg",
//         title: "Red Hot Chili Peppers",
//         smltitle: "",
//         html: function(){
// 			return {
// 				__html: `
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									 <h2>lieu</h2>
// 									<div class="text">
// 										<p>
// 											HaYarkon Park, Tel Aviv
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Date</h2>
// 									<div class="text">
// 										<p>
// 											10.06.2020
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="col col-30">
// 								<div class="top-box yellow">
// 									<h2>Plus D'infos sur:</h2>
// 									<div class="text info">
// 										<p>
// 											<a target="_blank" href="https://redhotchilipeppers.com/">
// 											www.redhotchilipeppers.com
// 											</a>
// 										</p>
// 									</div>
// 								</div>
// 							</div>
// 							<div class="clear"></div>
// 							<h2  class="ac-align-center ac-margin-top-20">Red Hot Chili Peppers are coming to Funkyard Tel Aviv!</h2>
// 							<p  class="ac-align-center ac-margin-bottom-20 "><b>They’re hot, they’re sexy, they’re Red Hot Chili Peppers,<br class="hide-on-mobile"> and they’re coming back to Tel Aviv for the first time since 2012!</b></p>
// 							<p>With 11 albums, 16 Grammy nominations and six awards, this mega-successful band will make your heart, body, and soul dance at the new Funkyard Festival to be held at the green heart of Tel Aviv - Hayarkon Park. </p>
// 							<div class="img-wrapper">
// 								<img src=${getImgUrl() + "/Concerts/red-hot-chili-peppers-2020/1.jpg"} class="img-responsive" />
// 							</div>
// 							<p>last December, the band announced the return of the legendary guitarist John Frusciante to the band for the second time, and we’re sure the LA funk-rock icons will rock the park once again.</p>
// 							<p>Red Hot Chili Peppers will give a single concert in the city that doesn’t stop, where you can start the day tanning at the beach with ice-cold beers and end up at one of the lively bars open till morning. The Peppers’ will perform at the beginning of summer when the temperatures are not too hot, but the parties across the city are sizzling. </p>
// 							<p>Tickets are on sale now and the concert is expected to be sold out, so book your trip before it’s gone!</p>
// 						`
// 			}
// 		}
// 	},
// ];
// End live shows
var ShowsPostsData=[];var newPostdata=[{id:"eurovision",bgImage:"/posts/bank/eurovision/1.jpg",mobBgImage:"/posts/bank/eurovision/M/1.jpg",title:"EUROVISION TEL AVIV",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n                   \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/eurovision/logo.png")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tA ONCE IN A LIFETIME OPPORTUNITY TO VISIT TEL AVIV AS IT HOSTS THE EUROVISION SONG CONTEST\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\t\t\t\t\t\n\t\t\t\t\t\tEpic song contest in the Non-Stop City\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSemi-final 1: 14 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSemi-final 2: 16 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tGrand Final: 18 May 2019\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIt\u2019s getting hot hot hot in Fabulous Tel Aviv! The nonstop city is teaming with excitement as it is getting ready to host the 2019 Eurovision Song Contest in what promises to be one of the most epic events ever held in the famous party city.\n\t\t\t\t\t</p>\t\t\t\t\t\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTel Aviv, known for its amazing energy, stunning beaches, great year round weather and gorgeous people, is the perfect destination for an unforgettable citybreak. Tel Aviv is known world over for its open mindedness and liberal spirit, making it the ideal host for the Eurovision song contest, offering visitors from far and wide the perfect opportunity to enjoy this vibrant and energetic city at its finest.\n\t\t\t\t\t</p>            \n                   \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/eurovision/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tMajor productions centered around the Eurovision contest month are already well on their way. Some of the exciting events planned include an amazing opening ceremony, a prestigious red-carpet event, and even a mega \u201CEuro Village\u201D which will be situated merely a minutes\u2019 walk from the awesome Tel Aviv baordwalk and beach. The Euro Village will be open for 10 days and will include live performances from past and present mega stars as well as live screenings of the Eurovision contest\u2019s semifinal and final. The contest itself will take place in the Expo Tel Aviv.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe Eurovision Song contest in Tel Aviv is guaranteed to be an event of a lifetime, so make sure to book your trip now to the most amazing Eurovision contest yet, in the most amazing city of all!\n\t\t\t\t\t</p>\n\n            \t"};}},{id:"Get_ready_to_party",bgImage:"/posts/bank/Get_ready_to_party/1.jpg",mobBgImage:"/posts/bank/Get_ready_to_party/M/1.jpg",title:"The best Eurovision parties to be at",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n               <h3>\n               \tYour Total Guide to Tel Aviv Eurovision parties\n               </h3>\n               <p>\n\t\t\t\t\tFrom the Eurovision Village to the EXPO Centre, these are all the key places you need to know about for Eurovision 2019 in Tel Aviv\u2026\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tCHARLES CLORE PARTY VENUE\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tCharles Clore Park: home to the largest Eurovision Village to have ever been made.\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tCharles Clore Park is located on the sea-front in the south-west of Tel Aviv. It\u2019s a beautiful green space overlooking Old Jaffa, one of the most ancient places in Tel Aviv. \n\t\t\t\t\tDuring Eurovision week it will be home to the Eurovision Village, where free concerts from the biggest Eurovision stars will take place. Highlights include Dana International and Conchita Wurst, plus parties and screenings of the live Eurovision TV shows will take place outside, right in-front of the beautiful Mediterranean sea! \n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tAlso, some of Israel\u2019s best chefs will be opening food stalls for the public to get first-hand experience of-mouth-watering Israeli and Middle-Eastern cuisine.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tCharles Clore is easy to get to: It\u2019s a five minute walk from the Carmelit bus terminal, so any bus terminating there is a good choice. Then you can just walk towards the sea and you\u2019ll see the village. If coming by foot, walk along the beach promenade. Or you can cycle or scoot along the sea front to get there. \n\t\t\t\t\tIt\u2019s a big park and will be having a Eurovision makeover, so you won\u2019t be able to miss it! In fact, this is the largest village to ever have been made for the Eurovision!\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tTEL AVIV PORT VENUE (\u201CThe Namal\u201D)\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tHome to 2019\u2019s official Eurovision Euro Club\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tWith its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tWith its huge venues, gorgeous decking and sea-side views, Tel Aviv Port is the perfect place to party the night away on Eurovision week!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe club will feature theme parties, live performances, screenings of the Eurovision live shows and many more surprises to be revealed. Former Eurovision acts and winners, both Israeli and international, are set to perform there during the Eurovision week, so the venue will offer much more than just a traditional night-club. Entry to the Euroclub is free for accredited fans, journalists, delegations and artists. Members of the general public can get in to the Euroclub by purchasing a special weekly bracelet, here:\n\t\t\t\t\t<a href=\"https://www.eventer.co.il/euroclub?fbclid=IwAR37-d_19OE7bsq0rQ_gPHAW-sRfn1QAMi-cxp_ID2pFtDODBYzbf5NB6S0\" target=\"_blank\">https://www.eventer.co.il</a>\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tEUROVISION VENUE\n\t\t\t\t</h3>\n\t\t\t\t<h3>\n\t\t\t\t\tExpo Tel Aviv: home to the Eurovision Song Contest itself\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tThe 2019 Eurovision Song Contest will be held at the Tel Aviv Expo center on the14th, 16th and 18th May. If you\u2019ve got tickets, this is the place you\u2019ll need to get to.\n\t\t\t\t\tIt\u2019s located on Rokach Boulevard in the north of the city, past HaYarkon Park and near to Tel Aviv University. To get there, use a journey planning app to find a bus route that will drop you right outside. Or, if travelling by train, get off at Tel Aviv University Train Station which is just a few minutes\u2019 away from the convention centre.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tDon\u2019t forget about the White Night, all the details are in the next article.\n\t\t\t\t</p>\n\n         \t"};}},{id:"Dead_Sea2",bgImage:"/posts/bank/deadsea2/1.jpg",mobBgImage:"/posts/bank/deadsea2/M.jpg",title:"LA MER MORTE",smltitle:"",isVid:true,vidId:"c93EwT_1EU8",ctg:"deadsea",html:function html(){return{__html:"\n                     \n                     <br/>\n\t\t\t\t\t <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">\n                             Le plaisir de la vie \xE0 son plus haut niveau au point le plus bas sur Terre\n                      </h2>\n              \t\t<p>\n\t\t\tUne merveille g\xE9ologique dans un cadre particuli\xE8rement serein, la mer Morte est une attraction touristique extr\xEAmement populaire. Exp\xE9rimentez le calme et la tranquillit\xE9 de l\u2019eau avec ses propri\xE9t\xE9s m\xE9dicinales apparentes tout en profitant de la beaut\xE9 in\xE9gal\xE9e du paysage environnant. <strong>La mer Morte, \xE9galement connue comme \xE9tant le plus vieux spa naturel du monde, jouit d\u2019une concentration extr\xEAmement forte en sel, soit 31,5%, permettant aux touristes venus de toutes parts de vivre l\u2019exp\xE9rience extraordinaire de flotter sans efforts dans les eaux de l\u2019endroit le plus bas sur terre. </strong> Sur place, vous pouvez vous baigner dans la boue noire et saine de la r\xE9gion ou explorer les paysages fascinants et riches en histoire des alentours.\n              \t\t</p>\n\n              \t\t<p>\n\t\t\t            Les h\xF4tels de luxe, la cuisine vari\xE9e des restaurants gourmets \xE0 la restauration rapide, les grands magasins de souvenirs, l\u2019histoire extraordinaire de Masada, \xE0 proximit\xE9, et les nombreuses activit\xE9s culturelles pendant toute l\u2019ann\xE9e, font de la mer Morte une destination populaire aussi bien pour les touristes locaux que les visiteurs du monde entier.\n\t\t\t       </p>\n              \t\t\n\t\t\t\t\n\t\t\t\t<!--<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/next-level/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/next-level/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>-->\n\t\t\t\t      \n\n\n           "};}},{id:"Tourist_info",bgImage:"/posts/bank/Tourist_info/1.jpg",mobBgImage:"/posts/bank/Tourist_info/M/1.jpg",title:"Tourist info",ctg:"telaviv",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t<h3>\n\t\t\t\t\tHow to get to Tel Aviv from the airport:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tThe cheapest way to get into central Tel Aviv from Ben Gurion airport is by train. Follow the signs to the train station that\u2019s attached to the airport (it\u2019s clearly sign-posted) and look for a train that\u2019s going to Tel Aviv-HaHagana (for south Tel Aviv), Tel Aviv-HaShalom (for Central Tel Aviv), Tel Aviv-Savidor Center (for the Old North area of Tel Aviv), or Tel Aviv-University (for the Eurovision Song Contest venue itself). Please note that Tel Aviv HaShalom is closed on Fridays until September 2019. \n\t\t\t\t\tA one-way single ride ticket will cost 13 shekels 50, and the journey takes around 25 minutes. When you get off the train, you might want to take a taxi to your accommodation. Whenever you get in a taxi, ask the driver to use the meter (\u201Cmonet\u201D) and have cash ready to pay. Or see below for details of taxi apps. For more information and to plan your journey, visit <a href=\"https://www.rail.co.il/en\" target=\"_blank\">https://www.rail.co.il/en</a>: - it\u2019s in English!\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tIf you\u2019d prefer to take a taxi all the way to Tel Aviv from the airport, then join the registered taxi queue outside the arrivals hall. A member of staff will ask you where you\u2019re going and how many passengers and cases you have, then will give you a ticket to hand to your driver. You can either use a meter or accept a fixed price. Journeys usually cost around 150-170 shekels for one person. \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tHow to get from Tel Aviv to Jerusalem:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<h3>\n\t\t\t\t\tBy Bus\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tHead to the Tel Aviv Savidor train central station take bus no.480. The journey time is around 45 minutes. The bus route finishes at the Jerusalem Central Bus Station on Jaffa Road. From there you can take the tram or any other means of  available to you, to get to your final destination. \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tBy Train\n\t\t\t\t\t</h3>            \n\t\t\t\t\t<p>\n\t\t\t\t\tYou can also take the brand new train! If you want to go to Jerusalem directly from Ben Gurion Airport, take the train to Navon Station in Jerusalem. The journey from the airport takes around 25 minutes. If you\u2019re connecting from other Tel Aviv stations, just take a train to Ben Gurion Airport station and change there for a connection to Navon.  \n\t\t\t\t\t</p>            \n\t\t\t\t\t<h3>\n\t\t\t\t\tHow to get around Tel Aviv\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tThe municipality of Tel Aviv will offer free public transport throughout the city over the weekend of the Eurovision Song Contest. \n\t\t\t\t\tFree buses will run on Friday and Saturday May 17-18.\n\t\t\t\t\tHowever Usually on Saturday there is no public transport in Tel Aviv (aside from taxies).\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tFor the other days of Eurovision week, you\u2019ll need a Rav Kav card: Similar to the \u201COyster Card\u201D in London, a Rav Kav is a smart card that can be loaded with credit to allow you to ride on buses without needing to worry about cash. In fact, bus drivers no longer let you pay in cash, so it\u2019s super important to get a Rav Kav as soon as you arrive in Tel Aviv.\n\t\t\t\t\tTo get a card, just jump on a bus at any bus stop, and ask the driver for a Rav-Kav card - it costs 5 shekels (You will need exact change). Then, when you get off the bus, take the card anywhere with you. Some local 7/11s (Kiosk) provide top up serives, ask to add some credit. 50 shekels is probably enough for a one-week visit, as it will cover the cost of around 10 local journeys (each journey is 5 shekels 90). \n\t\t\t\t\tYou can also buy a Rav Kav at the official Rav Kav office at 35 Iban Gabirol Street, which is open Sunday to Thursday 8:00 - 20:00 and Friday and holiday eves 8:00 - 13:00 ,or in the Tel Aviv Savidor train station and Carmelit central. You can also add credit at any train station. \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tCycling\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tTel Aviv is a cycling hot-spot and there are bike lanes all around the city, including one that runs all the way along the beach promenade from Jaffa in the south  the north of Tel Aviv and beyond, which are gorgeous locations to take a bike ride while soaking up the atmosphere and architecture of Tel Aviv. If you have a bicycle helmet, bring it with you. \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tElectric Scooters\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tScooters have become super popular in Tel Aviv! They offer a convenient and fun way to get round the city. There are a few brands around \u2013 all you have to do is download the relevant app, follow instructions and off you go. Swap your handbag for a rucksack as this will help with balance and remember to keep an eye on the traffic and not to listen to music while scooting. If you have a helmet, it\u2019s a good idea to wear it while you scoot\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tWalking\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tWalking is also a great option too - your step-count will soar after a few days in the non-stop city! Equip yourself with a map, a sun-hat and a bottle fo water, and hit the pavements!\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t Apps \n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tThere are various  apps you can download before arrival to help you plan your way around. Search for one from each category: there are taxi apps, bicycle rental apps, scooter rental apps and journey planning apps. You can also ask your hotel concierge or apartment host for advice on how to get around Tel Aviv - they will be happy to help! \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tWIFI\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tTel Aviv has a free Wifi network throughout the city. Look for the \u2018Free TLV\u2019 network in your smartphone - it works in 80 locations around the city. Most cafes and bars have free public Wifi networks you can use too; just ask for the password when you make your order. Hotels also have free Wifi so just ask for the password information when you check-in.\n\t\t\t\t\t</p>\n\n         \t"};}},{id:"White_night",bgImage:"/posts/bank/White_night/1.jpg",mobBgImage:"/posts/bank/White_night/M/1.jpg",title:"White night",ctg:"eurovision",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t\t<h1 class=\"align-center\">\n\t\t\t\t\t\t\t  White Night Lights Up Tel Aviv on 16th May \n\t\t\t\t\t\t\t</h1>\n        \t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t\t<iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/T0ugqxG5UaM\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<p>What do you get when you cross a Eurovision Semi-Final with an all-night party in a city that is famous for its 24/7 party energy? The answer is White Night, which will hit Tel Aviv this year on Thursday 16th May, just two days before the 2019 Eurovision Song Contest grand final.</p>\n                            <p>Featuring pop-up art installations, live music, dance parties, cultural events, food and drink, all fused together with Tel Aviv\u2019s eclectic atmosphere, White Night is one of the biggest cultural events of the year. </p>\n                            <p>And for 2019, it\u2019s taking place a month earlier than usual, so that visitors coming for the Eurovision Song Contest can also experience this magical experience in the White City of Tel Aviv.</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto By: Adam Primer\n\t\t\t\t\t\t\t</small>\n\n\t\t\t\t\t\t\t<p>From sunset until sunrise, the city will be wide-awake with cultural activities. Locals and visitors alike are invited to explore the city and soak up all the activities on offer. Many bars, restaurants and shops will be offering experiences free of charge or at reduced rates, so it\u2019s definitely worth stocking up on sleep so you\u2019re ready to party all night long!</p>\n                            <p>And at the Eurovision Village in Charles Clore Park, there\u2019ll be an extra sparkle of Eurovision magic, as several icons of the competition take to the stage to entertain visitors during the night. </p>\n                            <p>Last year\u2019s runner-up, Eleni Foureira, who narrowly missed out to Tel Aviv\u2019s own Neta Barzilai with her smash-hit song \u201CFuego\u201D, will be performing, as will 2014 winner, Conchita Wurst from Austria, who will most likely perform his iconic winning song, \u201CRise Like a Phoenix\u201D while showcasing his new-look for 2019!</p>\n                            <p>They\u2019ll be joined by three more Queens of Eurovision, in the form of 1970s pop icon Anne-Marie David, who won for Luxembourg in 1973, Swedish pop star Carola H\xE4ggkvist, who won the contest in 1991, and Loreen, who also won for Sweden in 2012 with her song Euphoria. The performances will take place on the coast, overlooking the Mediterranean; the live semi-final will also be shown on big-screens in the Eurovision Village, off-set by jaw-dropping light compositions, created by the competition\u2019s official lighting partner OSRAM.</p>\n                            <p>All in all, White Night is a night not to be missed. So make the 15th May your duvet day and get-set to party all night long on Thursday 16th May 2019. Tel Aviv is ready and waiting to celebrate with you!</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto By: Kfir Sivan\n\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto by Moshik Lindenbaum\n\t\t\t\t\t\t\t</small>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/White_night/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<small>\n\t\t\t\t\t\t\t\tPhoto by: Guy Yechiely\u200E.\n\t\t\t\t\t\t\t</small>\n\n         \t"};}},{id:"Tel_Aviv_Street_Food",bgImage:"/posts/bank/street-food/1.jpg",mobBgImage:"/posts/bank/street-food/M/1.jpg",title:"PARADIS POUR LES GOURMETS",ctg:"telaviv",isVid:true,vidId:"JQD9JpMaw9g",smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<p>Explorez l\u2019impressionnante sc\xE8ne culinaire de Tel Aviv. Si vous \xEAtes gourmands (et soyons honn\xEAtes, la plupart d\u2019entre nous le sommes), alors vous devriez venir go\xFBter \xE0 Tel Aviv. Ses chefs isra\xE9liens sont devenus c\xE9l\xE8bres \xE0 travers le monde pour leurs plats innovants, et la sc\xE8ne culinaire de Tel Aviv est en train de compl\xE8tement exploser.</p>\n\n\t\t\t\t<p>Dot\xE9e d\u2019environ 4 500 lieux de restauration, Tel Aviv est une v\xE9ritable Mecque de la gastronomie. Beaucoup de restaurants appartiennent \xE0 de brillants chefs de renomm\xE9e internationale, qui ont \xE9t\xE9 form\xE9s et ont travaill\xE9 dans certains des meilleurs \xE9tablissements du monde, avant de revenir en Isra\xEBl pour marquer la sc\xE8ne culinaire locale de leurs empreintes uniques.</p>\n\t\t\t\t\n\t\t\t\t<p>\xC0 Tel Aviv, la cuisine poss\xE8de de quoi faire le bonheur de chaque palais. D\xE9sign\xE9e \u2018Top destination vegan\u2019 par le site web culinaire am\xE9ricain The Daily Meal, Tel Aviv r\xE9pertorie quelques 400 restaurants adapt\xE9s aux v\xE9g\xE9taliens et v\xE9g\xE9taliennes. Vous aurez envie d\u2019essayer les excellentes sp\xE9cialit\xE9s de rue comme le Falafel et le Houmous, ainsi que la gamme vari\xE9e des d\xE9lices en vente sur les march\xE9s locaux. Pour vivre une fantastique exp\xE9rience culinaire, ne manquez pas les restaurants \xE0 la mode du port de Tel Aviv, de l\u2019avenue Rothschild, du quartier Neve Tzedek et ceux situ\xE9s dans le complexe superbement r\xE9nov\xE9 de \u2018Tachana\u2019.</p>\n\t\t\t\t\n\t\t\t\t<p>Une partie de la cuisine la plus avant-gardiste de la ville se trouve essentiellement au march\xE9 de Sarona, qui fut \xE0 l\u2019origine une colonie allemande de Templiers ; ce march\xE9 d\u2019une superficie de 8 700 m2 a \xE9t\xE9 m\xE9ticuleusement restaur\xE9 et abrite d\xE9sormais 91 boutiques de tous types, des stands et des restaurants, o\xF9 vous pouvez tester de nouveaux plats qui mettent non seulement l\u2019eau \xE0 la bouche, mais sont aussi particuli\xE8rement originaux.</p>\n\n         \t"};}},{id:"Dead_Sea_Video",bgImage:"/posts/bank/natures-glory/1.jpg",mobBgImage:"/posts/bank/natures-glory/M.jpg",title:"LA MER MORTE",ctg:"deadsea",isVid:true,vidId:"ixFocykfYHo",smlTitle:"",html:function html(){return{__html:"\n                      <p>Le plaisir de la vie \xE0 son plus haut niveau au point le plus bas sur Terre</p>\n                   \n         \t"};}},{id:"Jerusalem_Old_City",bgImage:"/posts/bank/jerusalem1/1.jpg",mobBgImage:"/posts/bank/jerusalem1/M.jpg",title:"La vieille ville",ctg:"jerusalem",isVid:true,vidId:"6eXJu1Yy4kg",smlTitle:"",html:function html(){return{__html:"\n\t\t \n\t\t\t\t\t<p>J\xE9rusalem est une v\xE9ritable invitation au voyage. Gravissez les montagnes, p\xE9n\xE9trez dans la ville et ressentez ce m\xE9lange de pass\xE9 et de pr\xE9sent, d'ordinaire et d'extraordinaire. L'une des cit\xE9s les plus anciennes au monde et consid\xE9r\xE9e comme sacr\xE9e par les juifs, les chr\xE9tiens et les musulmans, J\xE9rusalem offre une exp\xE9rience sensorielle et spirituelle sans \xE9quivalent.</p>\n\n\t\t\t\t\t<p>P\xE9n\xE9trez dans la ville. Pour le juda\xEFsme, le c\u0153ur de la ville sainte est la vieille ville. Empruntez l'entr\xE9e historique, La Porte de Jaffa, ou la Porte de Sion qui conduit directement au Quartier juif, l'un des quatre quartiers de la ville fortifi\xE9e o\xF9 habitent des juifs presque sans interruption depuis le 8\xE8me si\xE8cle avant J.C. Fl\xE2nez dans les ruelles, observez les habitants, visitez le Cardo, l'ancienne voie principale de J\xE9rusalem et impr\xE9gnez-vous de son atmosph\xE8re. Vous marchez dans les traces des rois et proph\xE8tes, c'est extraordinaire.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>Regardez l'histoire prendre vie et ressentez la profonde \xE9nergie spirituelle que contiennent ces murs</h3>\n\t\t\t\t\t\n\t\t\t\t\t<p>Ce qui est devant vous. Le Mur occidental, derni\xE8re portion encore pr\xE9sente des murailles antiques qui entouraient le Second temple, symbolise l'aspiration des juifs \xE0 retrouver leur patrie ancestrale et spirituelle. Chaque juif hors de J\xE9rusalem prie face au lieu o\xF9 vous vous trouvez maintenant, celui o\xF9, selon le juda\xEFsme, r\xE9side Dieu. Quelle que soit notre confession, ce lieu force l'humilit\xE9. Honorez l'esprit du site et placez un message contenant une pri\xE8re ou un souhait entre les pierres du mur.</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jerusalem-old-city/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>Ce qui est sous vous. J\xE9rusalem est litt\xE9ralement constitu\xE9e de plusieurs niveaux d'histoire, et toucher du doigt cette histoire prend ici une toute nouvelle signification.</p>\n\t\t\t\t\t\n\t\t\t\t\t<p>Visitez les myst\xE9rieux tunnels du Mur occidental et d\xE9couvrez ses recoins secrets. L'histoire prendra vie devant vous lorsque vous parcourrez les passages souterrains, d\xE9couvrirez la vie \xE0 l'\xE9poque du Second temple, vous familiariserez avec l'art, l'architecture et les pratiques de construction.</p>\n\t\t\t\t\t\n\t\t\t\t\t<p>Visitez le site arch\xE9ologique de la Ville de David, situ\xE9 \xE0 proximit\xE9, et apprenez \xE0 conna\xEEtre l'histoire de la ville, d\xE9sign\xE9e il y a 3000 ans comme la capitale unifi\xE9e des 12 tribus d'Isra\xEBl par le Roi David. Au d\xE9tour des murs et forteresses anciennes, d\xE9couvrez les sources cach\xE9es o\xF9 des rois ont \xE9t\xE9 couronn\xE9s, puis suivez les pas des habitants de J\xE9rusalem lorsqu'ils ont fui la ville conquise par les Romains.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>\xC9merveillez-vous devant l'extraordinaire panorama et sentez-vous sur le toit du monde</h3>\n\t\t\t\t\t\n\t\t\t\t\t<p>Ce qui est au-dessus. \xC0 l'origine, les murs qui entourent J\xE9rusalem avaient \xE9t\xE9 b\xE2tis pour prot\xE9ger la ville de l'envahisseur. Aujourd'hui, les Murs de J\xE9rusalem offrent l'opportunit\xE9 d'explorer la ville sous une perspective in\xE9dite. \xC9coutez les histoires, admirez la ville qui s'\xE9tale \xE0 vos pieds et embrassez sa beaut\xE9.</p>\n\t\t\t\t\t\n\t\t\t\t\t<p>Vous n'\xEAtes pas au bout de vos surprises.</p>\n\n\t\t\t\t\t<h2>LES PORTES DE J\xC9RUSALEM<br/>\n\t\t\t\t\t\tFranchissez les portes et d\xE9couvrez un nouvel aspect de la vieille ville de J\xE9rusalem\n\t\t\t        </h2>\n\n\t\t\t        <p>Les remparts de la vieille ville de J\xE9rusalem, construits au 16<sup>\xE8me</sup> si\xE8cle par le sultan turc Soliman le Magnifique, comportent huit portes. Toutes ces portes, \xE0 l'exception de la Porte de la mis\xE9ricorde, permettent toujours aux Hi\xE9rosolymitains et aux visiteurs de se rendre sur ses march\xE9s et sur ses sites historiques et sacr\xE9s.</p>\n\t\t\t\t\t<p>Vous trouverez ci-apr\xE8s un aper\xE7u de ces portes, dans le sens contraire des aiguilles d'une montre, du sud \xE0 l'ouest:</p>\n\t\t\t\t\t<p><strong>La Porte de Sion:</strong></p>\n\t\t\t\t\t<p>Elle porte le nom biblique le plus ancien de J\xE9rusalem, que ce soit en h\xE9breu ou en fran\xE7ais. Son nom arabe est \"Porte du Proph\xE8te David\", car la tombe du roi David, sur le mont Sion adjacent, ne se trouve qu'\xE0 quelques pas. La Porte de Sion d\xE9bouche directement sur les quartiers arm\xE9niens et juifs.</p>\n\t\t\t\t\t<p><strong>La Porte des immondices</strong>: cette porte doit son nom peu courant aux d\xE9charges malodorantes qui se trouvaient \xE0 cet endroit durant l'antiquit\xE9, et dont les odeurs \xE9taient port\xE9es par les vents dominants. N\xE9h\xE9mie 2:13 mentionne une porte des immondices qui se trouvait probablement \xE0 proximit\xE9 de celle-ci. Cette porte d\xE9bouche directement sur le Mur occidental et le Parc arch\xE9ologique du Mur m\xE9ridional.</p>\n\t\t\t\t\t<p><strong>La Porte de la mis\xE9ricorde</strong>: cette porte, qui se trouve dans le mur oriental du Mont du Temple, est peut-\xEAtre la plus connue. \xC9galement appel\xE9e Porte dor\xE9e ou Porte orientale, elle est mur\xE9e depuis des si\xE8cles. Il est dit qu'elle attend une ouverture miraculeuse lorsque le Messie viendra sur terre et que les morts ressusciteront.</p>\n\t\t\t\t\t<p><strong>La Porte des Lions:</strong></p>\n\t\t\t\t\t<p>Cette porte doit son nom aux deux couples de f\xE9lins en bas-relief qui l'encadrent. Il s'agit en r\xE9alit\xE9 de l\xE9opards, symbole h\xE9raldique du sultan Beybars au 13<sup>\xE8me</sup> si\xE8cle. Elle est \xE9galement appel\xE9e Porte Saint-\xC9tienne, du nom du premier martyr chr\xE9tien, dont la tradition fixe la lapidation \xE0 cet endroit. La Porte des Lions, qui d\xE9bouche sur la piscine de Bethesda, la Via Dolorosa et les march\xE9s, est devenue c\xE9l\xE8bre durant la Guerre des Six Jours.</p>\n\t\t\t\t\t<p><strong>La Porte d'H\xE9rode:</strong></p>\n\t\t\t\t\t<p>Malgr\xE9 son nom, le c\xE9l\xE8bre roi de Jud\xE9e n'a aucun rapport avec cette porte. En arabe et en h\xE9breu, cette porte qui fait face au nord et d\xE9bouche sur les march\xE9s de la vieille ville est appel\xE9e Porte des Fleurs. Certains pr\xE9tendent que son nom provient de la rosette sculpt\xE9e qui la surplombe. Cependant, un mot similaire en arabe signifie \xAB&nbsp;r\xE9veill\xE9&nbsp;\xBB, ce qui peut faire r\xE9f\xE9rence \xE0 un cimeti\xE8re proche et \xE0 l'espoir d'une r\xE9surrection.</p>\n\t\t\t\t\t<p><strong>La Porte de Damas:</strong></p>\n\t\t\t\t\t<p>Il s'agit de la porte la plus imposante de J\xE9rusalem. Faisant \xE9galement face au nord, son nom provient de la grande ville dont vinrent autrefois les souverains de J\xE9rusalem. Ce passage est toujours tr\xE8s actif, gr\xE2ce aux march\xE9s anim\xE9s qui s'y tiennent. Sous la porte du 16<sup>\xE8me</sup> si\xE8cle, les arch\xE9ologues ont d\xE9couvert une partie de l'entr\xE9e b\xE2tie par l'empereur Hadrien au deuxi\xE8me si\xE8cle de notre \xE8re.</p>\n\t\t\t\t\t<p><strong>La Nouvelle Porte:</strong></p>\n\t\t\t\t\t<p>C'est le seul point d'acc\xE8s \xE0 la vieille ville qui ne faisait pas partie de la structure originale des remparts du 16<sup>\xE8me</sup> si\xE8cle. Elle fut perc\xE9e dans les derniers jours de l'Empire ottoman, afin de permettre aux p\xE8lerins chr\xE9tiens d'acc\xE9der plus rapidement \xE0 leurs lieux saints \xE0 l'int\xE9rieur des remparts.</p>\n\t\t\t\t\t<p><strong>La Porte de Jaffa:</strong> elle \xE9tait la destination des p\xE8lerins juifs et chr\xE9tiens d\xE9barquant dans le port de Jaffa, d'o\xF9 son nom. Elle conduisait (et conduit toujours) directement aux quartiers juif et chr\xE9tien, ainsi qu'aux parties les plus populaires du march\xE9 et au Mus\xE9e de la Tour de David, qui fut autrefois la citadelle de J\xE9rusalem et pr\xE9sente aujourd'hui son histoire.</p>\n\n\n         \t"};}},{id:13,bgImage:"/posts/bank/25/1.jpg",mobBgImage:"/posts/bank/25/M.jpg",vidId:"k4OwoEk5wMw",ctg:"jerusalem",isVid:true,title:"Jerusalem’s Calling",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h2>The most magical and radiant city on Earth </h2>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWhat else can you say about the world\u2019s most unique city? Simply put: Welcome to Jerusalem \u2013 where a glorious history is intertwined with modern and dynamic life.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tJerusalem is home to innumerable fascinating historic sites, magical walkways, breathtaking views at sunset, a wide variety of entertainment options, restaurants that offer culinary excitement, spirited nightlife and a tremendous offering of centers for the arts and culture.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   The Old City\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tNo other place offers as many attractions and emotionally inspiring sites in a single square kilometer. The Old City of Jerusalem brims with opportunities for you to connect with the city\u2019s resplendent past, history, culture and spirituality. In the Old City, you\u2019ll find archaeological treasures that are thousands of years old, contemporary art and bustling markets where you can purchase delectable delights.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  The Western Wall:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tBelieved to be the only remaining segment of the Second Temple, the Western Wall has become truly synonymous with Jerusalem. Thousands of years old, it is the most important Jewish prayer site in the world, where thirteen-year-old boys come to celebrate their bar mitzvahs, and where millions of visitors and tourists from around the world place notes with requests and prayers into its cracks.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Western Wall Tunnels:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tVisiting the tunnels is like entering a time machine. Located beneath the Western Wall and the Muslim Quarter, provides visitors with a glimpse of the various periods in the history of Jerusalem.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   City of David:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tLocated next to the Dung Gate, this site presents the story of Jerusalem during the reigns of King David, King Solomon and King Hezekiah. Many archeological treasures were unearthed in the excavation, including a two-thousand year-old gold earring.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t   A visit to the site will enable you to take a flashlight and wade through the flowing water of the Siloam Tunnel, which was built during the reign of King Hezekiah.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t Via Dolorosa\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tChristian faithful follow in the footsteps of Jesus down the Via Dolorosa and the 14 Stations of the Cross, reenacting the fateful path that had an unprecedented impact on the course of history.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Church of the Holy Sepulchre:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAccording to Christian tradition, the Church is the site where Jesus was crucified, buried and where he resurrected from the dead. It has long been and continues to be a major pilgrimage center for Christians world over.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t The market in the Old City:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThis must-see attraction is made up of a series of alleyways, with numerous stalls offering a staggering variety of souvenirs, clothing, foods (baked goods, spices, sweets, tehini and more); stands hawking juices of all kinds, Armenian ceramics, drums and other musical instruments, earthenware jugs and much more. The colorful market delivers an authentic and extremely enjoyable experience that simply cannot be missed.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/4/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tAttractions\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tSegway tours:\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThis adrenaline-packed method of seeing the city will allow you to take in the beauty of Jerusalem from an entirely different perspective. The Segway tours leave from various central spots, including the Armon HaNatziv Promenade (East Talpiot), Yemin Moshe, and the Old City, as well as near the Knesset and the museum area.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n                        First Station (Hatachana):\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   If you like amusement park rides, you love having your senses scintillated by the Time Elevator. It\u2019s an interactive experience that takes visitors on fabulous voyages to fascinating places, with motion-based seating in a unique hall that is filled with special effects.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n                        Time Elevator:\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   The First Station is right in the heart of Jerusalem, between the Old City and the city center, and between the historical neighborhoods of the German Colony and Yemin Moshe. It is the site of the first train station in Jerusalem, which was built in 1892. After undergoing renovation and preservation, the First Station was reopened as a lively entertainment spot.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Machane Yehuda Market:\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   To experience the city as authentically as possible, your itinerary must include a stop at Machane Yehuda Market. It represents Jerusalem of the present and the future. Machane Yehuda uniquely brings together old and new, with its fruit and vegetable market, along with an excellent food and a vibrant entertainment area.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Museums\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   In a city filled with a large number of museums, you have every opportunity to experience and learn about the events of the past and to visit modern and contemporary exhibits.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Israel Museum\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   The Israel Museum is the largest cultural institution in the country. It has many wings and very large collections of art, archeology and Judaica. One of the highlights of any visit to the museum is the Shrine of the Book, with its unique design that has come to be closely associated with the city itself.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Tower of David Museum:\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Thousands of years ago, Jerusalem was a small city, where kings and prophets walked or rode their horses down the alleys. Since that time, one of the best-known symbols of the city is David\u2019s Tower, with its turret standing proudly above the ancient fortress that has also become one of the city\u2019s important museums.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/4/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Restaurants\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Jerusalem boasts many restaurants, where you can dine on a wide array of delicacies \u2013local and international, standard and exotic. And if you are looking for the gourmet experience, you can reserve a spot at exclusive chef restaurants. The following are five of Jerusalem\u2019s finest and most popular spots, which attract crowds all day long:\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Caf\xE9 Kadosh\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t Highly popular, the caf\xE9 serves kosher dairy cuisine \u2013 all made in house, and all delicious!\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Tmol Shilshom\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  A dairy bookstore caf\xE9 in the city center, favored for its warmth, delicious food and friendly service. Don\u2019t miss the shakshuka or salmon fillet in fig sauce!\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   The Eucalyptus\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  The kosher restaurant, located in the Artist\u2019s Quarter, serves Chef Moshe Basson\u2019s interpretation of biblical cuisine. Every dish has its origins in biblical scenes and all the spices and herbs used grow, as in ancient times, in the surrounding hills of Jerusalem and Judea. An unforgettable experience.\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Darna\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  An authentic, glatt kosher, Moroccan restaurant, located in the heart of the city. Experience the warm welcome and the true meaning of Moroccan hospitality, while enjoying the culinary excellence of the Maghreb.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Ima Restaurant\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  Right down the street from Machane Yehuda market, Ima offers excellent kosher Middle Eastern food, served in a relaxed family atmosphere\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   And no visit to Jerusalem is complete without scooping up some hummus with a pita right out of the oven. The following are a few centrally located hummus spots:\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<strong>Azura,</strong><small> in the Iraqi section of the Mahane Yehuda Market </small><br>\n\t\t\t\t\t\t\t<strong>Lina,</strong><small> in the Christian Quarter of the Old City</small><br>\n\t\t\t\t\t\t\t<strong>Hummus Acramawi,</strong><small>  in the Muslim Quarter of the Old City </small><br>\n\t\t\t\t\t\t\t<strong>Hummus</strong><small> Ben Sira, in the city center next to the Mamilla Hotel</small><br>\n\t\t\t\t\t\t\t<strong>Abu Shukri,</strong><small> in the Muslim Quarter in the Old City of Jerusalem </small><br>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t    </div>\n\n\t\t\t\t    <h3>\n\t\t\t\t        Nightlife\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t         Jerusalem is filled with scores of restaurants and entertainment spots that are also open on Friday nights (the Jewish Sabbath). All of Jerusalem\u2019s entertainment areas have excellent options for weekend fun on Friday nights as well as Saturdays, and you can most definitely enjoy a delightful evening over a cold beer or dance to great music.\n                         Below is a small selection of bars and clubs that are hopping on Friday nights and will leave you wanting more\u2026\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n\t\t\t\t       Mantra\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       An intimate restaurant and wine bar, where a friendly atmosphere meets superb cuisine.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n\t\t\t\t       Gatsby Cocktail Room\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       The cocktail lounge and bar evokes the magic of the Roaring 20\u2019s and the days of cabarets.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n\t\t\t\t        HaTaklit\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       With a name means \u201Cthe record\u201D in Hebrew, the trendy bar is decorated with record sleeves. Enjoy full bar, live music, DJs and even independent performers.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n\t\t\t\t       Toy Bar (HaTza\u2019atzua)\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t      Centrally located, Toy Bar offers great drinks, great music by some of the best local DJs and great dance bar experience.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n                        Sira\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n                       One of the city\u2019s most eclectic underground clubs, with an arcade room and dance floor. The pub also hosts events and performances.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n                        Even / Juke\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       A music club that showcases the most creative bands in Israel, with an emphasis on jazz, blues and funk.\n\t\t\t\t    </p>\n\n\t\t\t\t    <h3>\n                       Video Pub\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\t\t\t\t       Jerusalem\u2019s only \u201Cofficial\u201D gay bar is home to some of the wildest parties in the city.\n\t\t\t\t    </p>\n\n\t\t\t\t    <p>\n\t\t\t\t       Jerusalem is the ultimate vacation destination! With so much to see and do, so much to stimulate your senses and pique your curiosity, your trip to Jerusalem promises us an unforgettable experience. Book your vacation now!\n\t\t\t\t    </p>\n\n\t\t\t\t    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/4/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>Box:</h3>\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Annual events\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Jerusalem plays host to a variety of unique annual events. Check the Internet for dates and further information.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   Festival of Light\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   Held in the Old City \u2013 May 25, 2016 to June 2, 2016. Come and be part of the enchanting games of light and color, with dozens of displays by Israeli and international artists. Follow the paths set up throughout the Old City, guiding visitors from one mesmerizing work to another.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   International Arts and Crafts Fair (Khutsot Hayotser):\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t  August 15, 2016 \u2013 August 29, 2016. Held against the backdrop of the Old City walls, visitors enjoy a very special nighttime atmosphere and happening with musical performances. Walk through the gardens and stop at the various stands, where artists from Israel and the world exhibit paintings, prints, ceramics, metalwork and jewelry, weaving and textiles, Judaica, toys, crafts in various techniques, woodwork and more.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   The Israel Festival\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   May 24, 2016 \u2013 June 11, 2016. The festival is Israel\u2019s premiere multi-disciplinary international festival. It takes place annually in the spring, presenting outstanding theater performances, contemporary dance, classical music and performances from around the world, along with ground breaking Israeli works. Numerous festival events are held at unique Jerusalem locations that have historic significance of hundreds, if not thousands, of years. There are also many street performances that are open to the public.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t  Jerusalem Film Festival\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t   July 7, 2016 \u2013 July 17, 2016. The festival sprinkles star dust across the city, with quality cinema, actors and writers that are guests. Many famous stars have come to the festival of the years. Over 200 Israeli and foreign films will be screened during the festival, highlighting various genres and competing for prizes. The festival offers opportunities for meetings with artists, workshops, parties and musical events.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/4/5.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\n         "};}},{id:"Outdoor_Adventures",bgImage:"/posts/bank/40/1.jpg",mobBgImage:"/posts/bank/40/M.jpg",title:"Aventures en plein air",ctg:"telaviv",vidId:"88OV6xU0vPI",isVid:true,smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<br/>\n                <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Une ville pleine d\u2019action id\xE9ale pour les personnes actives</h2>\n\t\t\t     <p>\n\t\t\t\t\t\tLes gens \xE0 Tel Aviv profitent pleinement de la vie ; et ils le font \xE0 l\u2019ext\xE9rieur. Cette ville regorge d\u2019activit\xE9s de plein air, et vous pouvez choisir vos pr\xE9f\xE9r\xE9es en toute libert\xE9. C\u2019est une ville riche en action, ce qui la rend id\xE9ale pour les personnes actives.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tLe parc Hayarkon\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSurnomm\xE9 le \xAB Central Park \xBB de Tel Aviv, le parc Hayarkon est visit\xE9 par approximativement seize millions de personnes chaque ann\xE9e. Les attractions vont des pique-niques sur les immenses pelouses et du p\xE9dalo sur le magnifique lac artificiel aux pistes cyclables et visites de nombreux jardins \xE9tonnants, d\xE9peignant la nature au coeur de la ville.\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tLa sc\xE8ne cycliste\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tL'une des meilleures fa\xE7ons de d\xE9couvrir Tel Aviv est de parcourir ses 100 km de pistes cyclables. Vous pouvez profiter du syst\xE8me de location de v\xE9los publics Tel-O-Fun qui permet aux r\xE9sidents et aux visiteurs de prendre ou de d\xE9poser des v\xE9los verts dans 150 stations \xE0 travers la ville. Et si vous aimez passer du temps sur des roulettes, vous devriez aussi vous rendre aux nombreux planchodromes pour y admirer les casse-cou locaux faire leurs num\xE9ros ou alors vous procurer un skateboard ou des rollers, et prendre part \xE0 l\u2019action.\n\t\t\t\t\t</p>\n\n         "};}},{id:"Port_Pleasures",bgImage:"/posts/bank/23/1.jpg",mobBgImage:"/posts/bank/23/M.jpg",vidId_post:"a6QMndU0wx0",ctg:"telaviv",isVid:true,//  vidId : "LLOUxE-K_9Y",
vidId:"tgF0zMUYY2g",title:"PLAISIRS PORTUAIRES",smltitle:"",html:function html(){return{__html:"\n\n\n\t\t\t\t<br/>\n\t\t\t\t<h3>Une histoire color\xE9e et un irr\xE9sistible charme du levant</h3>\n\n\t\t\t\t<p>Les odeurs de la mer se m\xEAlant aux parfums de caf\xE9 noir et d'\xE9pices qui \xE9manent des march\xE9s, le mariage des cultures du levant et europ\xE9ennes, de l'ancien et du moderne \u2013 vous \xEAtes \xE0 Jaffa. Jaffa est l'une des plus anciennes villes portuaires au monde et son histoire remonte \xE0 l'\xE9poque du D\xE9luge. C'est aujourd'hui une ville dynamique qui ne cesse jamais de surprendre et d'innover. Des ruelles pittoresques, des galeries d'art, des boutiques uniques, des b\xE2timents anciens, des monuments magnifiques et une pl\xE9thore d'authentiques restaurants moyens-orientaux \u2013 visiter la vieille ville de Jaffa, c'est vivre une exp\xE9rience multisensorielle que toute personne visitant Isra\xEBl ne doit manquer sous aucun pr\xE9texte. Vous tomberez amoureux de cette ville.</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n\t\t\t\t\n\t\t\t\t<h3>D\xE9couvrez la magie d'une ville portuaire pleine de vie </h3>\n\t\t\t\t\n\t\t\t\t<p>Situ\xE9e dans la partie sud de Tel Aviv, sur une colline dominant la mer M\xE9diterran\xE9e, Jaffa est depuis des mill\xE9naires le centre d'\xE9v\xE9nements historiques. Toujours actif, le Port de Jaffa est un endroit extraordinaire \xE0 explorer. D\xE9couvrez ses galeries d'art, ses boutiques et ses march\xE9s gastronomiques. Fl\xE2nez le long des anciens quais, assistez aux spectacles musicaux, buvez, mangez, impr\xE9gnez-vous de son atmosph\xE8re si particuli\xE8re.</p>\n\t\t\t\t\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>Pour avoir une meilleure vue de la ville, montez sur la colline jusqu'au Jardin de la Cr\xEAte (Ha'Pisga) surplombant la baie et contemplez la magnifique cit\xE9 qui s'\xE9tend \xE0 vos pieds. En redescendant, faites un souhait sur le pont des V\u0153ux. Qui sait, peut-\xEAtre se r\xE9alisera-t-il.</p>\n\t\t\t\t\n\t\t\t\t<h3>Plongez-vous dans une aventure urbaine et romantique</h3>\n\t\t\t\t\n\t\t\t\t<p>Les rues de Jaffa sont pleines de surprises. Fl\xE2nez dans les \xE9troites rues pav\xE9es du vieux Jaffa, d\xE9nichez ses cours int\xE9rieures cach\xE9es et pr\xEAtez attention aux petits d\xE9tails \u2013 carreaux de c\xE9ramique peints, petites sculptures et terrasses en hauteur ouvertes. Faites la connaissance des habitants, visitez les galeries d'art, les studios d'artiste et les boutiques originales.</p>\n\t\t\t\t\n\t\t\t\t<p>Poursuivez votre exploration. Depuis la place de la tour de l'horloge au c\u0153ur de la ville, poursuivez votre chemin vers le fameux march\xE9 aux puces de Jaffa et faufilez-vous parmi les objets du quotidien et les tr\xE9sors cach\xE9s. C'est le moment de tester vos aptitudes \xE0 marchander. Profitez des petits caf\xE9s pittoresques, des authentiques restaurants moyen-orientaux, des bars et go\xFBtez leurs houmous, parmi les meilleurs que vous n'aurez jamais go\xFBt\xE9s. Garanti !</p> \n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\n         "};}},{id:14,bgImage:"/posts/videos/deadsea/1/1.jpg",mobBgImage:"/posts/videos/deadsea/1/M.jpg",title:"The Dead Sea",vidId:"ixFocykfYHo",ctg:"deadsea",isVid:true,smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h2>Time to bask in nature\u2019s glory</h2>\n\t\t\t<p>\n\t\t\t\t\tA geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.\n\t\t\t</p>\n           <p>\n\t\t\t\t\tLuxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.\n           </p>\n\t\t\t"};}},{id:3,bgImage:"/posts/bank/23/1.jpg",mobBgImage:"/posts/bank/23/M.jpg",vidId:"LLOUxE-K_9Y",player_id_post:"3",title:"Port Pleasures",isVid:true,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h2>The different charms of Tel Aviv and Jaffa Ports</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tJaffa Port offers an ancient history, stone buildings and cobbled lanes while Tel Aviv Port is a contemporary cultural, recreational and commercial hub.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Jaffa Port\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe modern city of Tel Aviv had its humble beginnings in the port of Jaffa where immigrants, armies and traders docked their ships. The port is famed as one of the oldest in the world and today it is still used by local fishermen while the historic surrounding area has become a popular tourist destination.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t    </div>\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe waterside hangers have been converted into galleries and cultural spaces like the Nalaga\u2019at Center operated by the deaf and blind community and the Dvir Gallery. From the waterfront the ancient cobbled alleyways wend their way up through stone buildings reminiscent of old Jerusalem. In among the historic buildings are galleries, specialty stores and excellent restaurants. As you reach the upper levels of the Old Port area you can see St. Peter\u2019s Church, the Wishing Bridge, the Old Jaffa Museum and the Ilana Goor Museum.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tTel Aviv Port\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIn contrast to Jaffa Port Tel Aviv has a more commercial and contemporary feel. The port operated from 1938 to 1965 and has undergone renewal and restoration to convert it into a shopping and entertainment district. The port area consists of converted hangers and a long wide waterfront promenade. It is popular with families visiting the Dyada Center for children\u2019s activities and others visiting the yoga center, center for women, conference venue and the Cavim Institute of Design and Architecture. The promenade is always alive with street performers, musical events and outdoor markets. The port is a contemporary and dynamic area for creative and cultural expression. When the sun goes down the Tel Aviv Port becomes a popular nightlife destination with bars and clubs.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/3/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t<div class=\"cradit\">\n\t\t\t\t\t\t\t\t<small>Dana Friedlander</small>\n\t\t\t\t\t    </div>\n\t\t\t\t\t</div>\n\n\n         "};}},{id:"TelAviv_By_The_Sea",bgImage:"posts/bank/17/1.jpg",mobBgImage:"posts/bank/17/M.jpg",title:"TEL AVIV, EN BORD DE MER",vidId:"jsTzRtTCvWg",isVid:true,ctg:"telaviv",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<br/>\n\t\t\t<h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">\n\t\t\t\t\t\t\tPour le magazine National Geographic : \xAB Une des 10 meilleures villes baln\xE9aires du monde \xBB\n\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tAvec leurs eaux cristallines et leurs caract\xE8res anim\xE9s, les 16 plages de Tel Aviv poss\xE8dent toutes leurs propres styles et attirent des profils diff\xE9rents allant des hippies d\xE9contract\xE9s aux personnes chics de la Riviera. De jour comme de nuit, l\u2019un des meilleurs moyens de passer son temps \xE0 Tel Aviv est de fl\xE2ner sur la plage.\n\t\t\t\t\t\t</p>\n\n\t\t\t"};}},{id:"Sarona_TelAviv",bgImage:"posts/bank/36/1.jpg",mobBgImage:"posts/bank/36/M.jpg",title:"Sarona Tel Aviv",isVid:true,ctg:"telaviv",// vidId: "hdquOPEilDo",
vidId:"MJ-gsGs1tqA",smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t            <p>Un immense choix de lieux \xE0 d\xE9couvrir dans une superbe colonie des Templiers r\xE9nov\xE9e</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<h3>Sur le march\xE9 de Sarona \xE0 Tel Aviv, le choix culinaire est illimit\xE9</h3>\n\n\t\t\t\t\t\t<p>B\xE2ti au c\u0153ur de Tel Aviv, \xE0 l'emplacement de structures templi\xE8res vieilles de 150 ans, le march\xE9 de Sarona est le v\xE9ritable melting pot gastronomique d'Isra\xEBl. Refl\xE9tant l'atmosph\xE8re culinaire exemplaire de Tel Aviv et apportant une touche contemporaine aux march\xE9s plus traditionnels de la ville, Sarona est le lieu \xE0 visiter pour satisfaire votre gourmandise - et avoir un aper\xE7u des diverses inspirations ethniques qui animent cette tr\xE9pidante cit\xE9 maritime.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<h3>Visitez le plus grand march\xE9 gastronomique couvert d'Isra\xEBl</h3>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>Cr\xE9ations gastronomiques sophistiqu\xE9es ou sp\xE9cialit\xE9s locales traditionnelles : le march\xE9 de Sarona a tout pour satisfaire les palais les plus exigeants. Plus de 90 restaurants, stands d'alimentation, pubs et boutiques gastronomiques y sont ouverts sept jours sur sept. Sur place, vous n'aurez que l'embarras du choix entre un bol de succulents r\u0101men, un plat d'empanadas \xE9pic\xE9es, un succulent sandwich ou une p\xE2tisserie... Vous n'arrivez pas \xE0 vous d\xE9cider ? Les \xE9tablissements de restauration \xE9tant tous proches les uns des autres, vous pourrez facilement d\xE9guster une entr\xE9e de fruits de mer suivie d'un pad tha\xEF \xE9pic\xE9 ou d'un savoureux hamburger.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>Besoin de faire une pause entre les plats ? Le march\xE9 de Sarona accueille \xE9galement des boutiques d'accessoires, des mus\xE9es, un centre d\xE9di\xE9 aux visiteurs et d'autres attractions \xE0 ne pas manquer.</p> \n\t\t\t\t\t\t\n\t\t\t\t\t\t<h3>Mettez-vous au vert</h3>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>Le vendredi, c'est la f\xEAte ! Au march\xE9 de Sarona, le vendredi est un jour \xE0 part. C'est le jour o\xF9 des produits sont livr\xE9s directement de la ferme, ce qui rendra votre exp\xE9rience gastronomique encore plus interactive et attrayante. Une fois que vous aurez s\xE9lectionn\xE9 votre produit, vous poursuivrez votre exploration de ce march\xE9 urbain, et ajouterez \xE0 votre cabas de savoureux fromages import\xE9s, un vinaigre balsamique italien de premi\xE8re qualit\xE9, des bi\xE8res artisanales et des friandises sucr\xE9es. Tous ces ingr\xE9dients go\xFBteux vous permettront de concocter un repas inoubliable au cours du week-end.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>Sur le march\xE9 de Sarona, d\xE9couvrez toute la force de la cuisine isra\xE9lienne moderne. Avec ses innombrables options culinaires, qui refl\xE8tent l'atmosph\xE8re gastronomique unique de Tel Aviv, le march\xE9 de Sarona donnera satisfaction aux gourmets les plus exigeants. Un endroit \xE0 ne manquer sous aucun pr\xE9texte.</p> \n\n\t\t\n\t\t           "};}},{id:"Neve_Tzedek",bgImage:"posts/bank/4/1.jpg",mobBgImage:"posts/bank/4/M.jpg",title:"Névé Tzedek",// vidId: "SUJncZH91Bo",
vidId:"5jl13Z-38eE",smlTitle:"",isVid:true,ctg:"telaviv",html:function html(){return{__html:"\n\n                      \t<br/>\n                      \t<h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\"> D\xE9borde de caf\xE9s pittoresques, boutiques, galeries d'art, \xE9l\xE9gance et atmosph\xE8re rafra\xEEchissante</h2>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<h3>D\xE9couvrez l'ambiance magique des cours ombrag\xE9es des restaurants et caf\xE9s de N\xE9v\xE9 Tzedek</h3>\n\n\t\t\t\t\t\t<p>Nich\xE9 dans l'un des plus anciens quartiers de Tel Aviv, se trouve un joyau architectural \xE0 l'esprit jeune et dynamique. Cr\xE9\xE9 en 1887, N\xE9v\xE9 Tzedek, le premier quartier juif en dehors de la vieille cit\xE9 portuaire de Jaffa, est r\xE9cemment devenu le terrain de pr\xE9dilection d'artistes de toutes tendances, qui s'int\xE8grent parfaitement \xE0 l'architecture orientale pittoresque du quartier restaur\xE9.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t\t<h3>Une v\xE9ritable oasis dans l'agitation de Tel Aviv</h3>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>Vous cherchez un plat en c\xE9ramique artisanal, un article vestimentaire original ou un bijou r\xE9alis\xE9 avec les techniques de joaillerie traditionnelles ? Les innombrables boutiques, galeries, ateliers de design et  magasins de mode qu'abritent les immeubles de style oriental bordant les passages \xE9troits jusqu'\xE0 la rue Shabazi vous laisseront le souvenir d'une s\xE9ance de shopping \xE0 nulle autre pareille. Pendant que vous fl\xE2nerez dans le quartier, la brise de mer vous rafra\xEEchira et vous vous sentirez plein de vie et joyeux, en harmonie avec l'esprit fantasque des lieux.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>Appr\xE9ciez l'ambiance magique des cours ombrag\xE9es des restaurants et caf\xE9s de N\xE9v\xE9 Tzedek en vous attablant devant un repas l\xE9ger mais satisfaisant. Les nombreux restaurants, install\xE9s dans les b\xE2timents historiques pittoresques jalonnant les ruelles \xE9troites du quartier, servent de v\xE9ritables sp\xE9cialit\xE9s culinaires. Se mariant \xE0 l'ambiance sereine des rues du quartier, ces plats d\xE9licieux vous transporteront dans une atmosph\xE8re boh\xE8me sans \xE9quivalent.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<h3>Ici, la cr\xE9ativit\xE9 n'a pas de limites...</h3>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>La visite de N\xE9v\xE9 Tzedek ne serait pas compl\xE8te sans une visite au mus\xE9e Nachum Gutman, qui rend hommage \xE0 ce grand artiste de Tel Aviv. Des expositions permanentes et des activit\xE9s interactives renforcent le sentiment artistique v\xE9hicul\xE9 par ce quartier tranquille, et vous invitent \xE0 visiter les autres galeries et ateliers de c\xE9ramique qui s'y trouvent.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>Visitez le Centre Suzanne Dellal d\xE9di\xE9 \xE0 la danse et au th\xE9\xE2tre, o\xF9 assistez \xE0 l'un des nombreux spectacles et festivals organis\xE9s par ce centre culturel, dont les spectacles de musique et de danse ethniques, \xE9tablit un v\xE9ritable lien entre les arts isra\xE9liens de la sc\xE8ne et la sc\xE8ne internationale.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p>En remontant la rue Shabazi, vous constaterez que l'esprit cr\xE9atif du quartier reste sensible, jusqu'\xE0 impr\xE9gner Hatachana, l'ancienne gare ferroviaire de Jaffa. R\xE9cemment transform\xE9 en centre commercial \xE0 la mode, cet ensemble historique surprenant abrite des boutiques et des caf\xE9s.</p>\n\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tOffrez-vous une pause avec le rythme tr\xE9pidant de Tel Aviv ; cette perle, dissimul\xE9e dans un quartier, poss\xE8de un magnifique style architectural oriental et de charmantes rues \xE9troites qui font de Neve Tzedek, qui signifie lit\xE9ralement une Oasis de Justice, une veritable oasis au coeur de la ville effervescente.\n\t\t\t\t\t\t</p><p><a href=\"https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1\" rel=\"nofollow\" target=\"_blank\">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href=\"https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19\" rel=\"nofollow\" target=\"_blank\">View accommodations in </a><a href=\"https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1\" rel=\"nofollow\" target=\"_blank\">Tel Aviv &amp; Center</a><a href=\"https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19\" rel=\"nofollow\" target=\"_blank\"> at Tourist Information site</a></p>\n\n              \n\t\t\t"};}},{id:9,bgImage:"posts/bank/5/1.jpg",mobBgImage:"posts/bank/5/M.jpg",title:"Jerusalem Old and new ",isVid:true,ctg:"jerusalem",vidId:"MXtcTm_JXus",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h2>Ancient treasures and modern luxuries.</h2>\n\n\t\t\t<p>\n\t\t\t\tDowntown Jerusalem is the heart of the modern metropolis, bursting with nightlife, dining and cultural options to rival any major city in the world.\n\t\t\t</p>\n\t\t\t<p>\n\t\t\t\tThe area is made up of several neighborhoods and appealing locations such as charming Nachlat Shiva, the bustling Yafo Street and Ben Yehuda Street, with its own unique personality and atmosphere not to be missed.\n\t\t\t</p>\n\t\t\t<p>\n\t\t\t\tThe center of Jerusalem includes some of the city\u2019s most charming neighborhoods and fascinating attractions. For an unbeatable cultural experience, check out Jerusalem\u2019s variety of fascinating museums, including the world class Israel Museum, the Bible Lands Museum and Jerusalem\u2019s Science Museum.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tMachane Yehuda Market\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tDiscover this market's unrivaled atmosphere and variety which draw thousands of tourists every day. Once the shopping is done and the food vendors close up, join the young trendy crowds, foreign and locals alike, who descend on the market to drink and party until the small hours, in the bars, restaurants and alleyways.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tNahalat Shiv\u2019a\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tThis charming cobblestone neighborhood at the heart of the city offers an excellent selection of shops, restaurants, bars and outdoor caf\xE9s. Nahalat Shiva is home to Kikar Hamusica (Music Square) \u2013 a lively and trendy outdoor space that offers live music every day throughout the week.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tYemin Moshe\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tThis lovely neighborhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. Home to artists, writers and academics, Yemin Moshe is known for its beautiful windmill and oriental style houses, green parks, lively music center and stunning views.\n\t\t\t</p>\n\t\t\t<h3>\n\t\t\t\tEin Kerem\n\t\t\t</h3>\n\t\t\t<p>\n\t\t\t\tNestled in a peaceful valley between the mountains and the terraced hills southwest of Jerusalem, Ein Kerem is one of Jerusalem\u2019s most picturesque neighborhoods. With its winding paved lanes, their charming stone houses adorned with arches, churches whose bells chime in the clear air, Ein Kerem radiates charm and beauty like an island in a sea of green forest\n\t\t\t</p>  \n\n\t\t\t"};}},{id:"Market_Madness",bgImage:"posts/bank/10/1.jpg",mobBgImage:"posts/bank/10/M.jpg",title:"MAH’ANÉ YÉHOUDA",vidId:"fJ7bLOOstgA",isVid:true,ctg:"culinary",smlTitle:"",html:function html(){return{__html:"\n                    <br/>\n                    <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Go\xFBtez \xE0 la culture isra\xE9lienne</h2>\n\t\t\t\t\t<p><strong>Le march\xE9 ext\xE9rieur de J\xE9rusalem - un r\xE9gal pour les yeux et pour les papilles</strong></p>\n\t\t\t\t\t<p>Consid\xE9r\xE9 comme le march\xE9 en plein air<b>&nbsp;</b>le plus \xE0 la mode et le plus anim\xE9 d'Isra\xEBl, Mah\u2019an\xE9 Y\xE9houda est une source de divertissement unique, avec ses innombrables produits frais, ses agr\xE9ables commerces et ses restaurants pittoresques.</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/7/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>Ce march\xE9 ne cesse de se r\xE9inventer : les traditions ancestrales s'y m\xEAlent et s'y opposent aux derniers ph\xE9nom\xE8nes de mode, et les parfums et fumets qui \xE9manent des mets propos\xE9s sont absolument irr\xE9sistibles.</p>\n\n\t\t\t\t\t<p><strong>La Culture et la cuisine \xE0 leur summum </strong></p>\n\t\t\t\t\t<p>Fl\xE2nez dans les longues all\xE9es \xE9troites du march\xE9 et explorez les restaurants, caf\xE9s, pubs, \xE9tablissements v\xE9g\xE9taliens et boutiques qui se dissimulent l\xE0 o\xF9 vous ne les attendez pas. En franchissant leur seuil, vous appr\xE9cierez le calme relatif qu'ils offrent apr\xE8s l'agitation des marchands locaux vantant aux consommateurs avides les m\xE9rites de leurs pains frais, fruits et l\xE9gumes tout juste cueillis, salades, desserts, \xE9pices fra\xEEchement moulus et viandes. Les odeurs suffisent \xE0 faire gargouiller votre estomac tandis qu'elles vous transportent aux quatre coins du monde. Chaque coupe de fruits, fallafel ou halva parfum\xE9e est un r\xE9gal pour les sens.</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/7/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p><strong>Une visite pour satisfaire votre curiosit\xE9 et votre app\xE9tit</strong></p>\n\t\t\t\t\t<p>Participez \xE0 un des nombreux ateliers ou itin\xE9raire de visite et d\xE9gustation pour d\xE9couvrir le march\xE9 Mah\u2019an\xE9 Y\xE9houda de mani\xE8re interactive, en go\xFBtant aux plats frais pr\xE9par\xE9s par certains exposants. \xC9coutez les anecdotes qui font l'histoire du march\xE9 et apprenez \xE0 conna\xEEtre les boutiques et stands qui ont contribu\xE9 faire de ce march\xE9 en plein air&nbsp;le plus connu d'Isra\xEBl. Lorsque la nuit tombe, le march\xE9 se transforme en un lieu branch\xE9 et extr\xEAmement anim\xE9, pris\xE9 des jeunes de la ville et des touristes.</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/7/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t\n\n              \n\t\t\t"};}},{id:13,bgImage:"posts/bank/24/1.jpg",mobBgImage:"posts/bank/24/M.jpg",title:"The old city ",vidId:"k4OwoEk5wMw",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h2>Feel the story come alive</h2>\n\t\t\t<p>\n\t\t\t   Become inspired by the world renowned treasures of the ancient city of Jerusalem.\n\t\t\t</p>\n              \n\t\t\t"};}},{id:14,bgImage:"posts/bank/32/1.jpg",mobBgImage:"posts/bank/32/M.jpg",title:"The Dead Sea ",vidId:"DzEJxjnC_UQ",isVid:true,ctg:"deadsea",smlTitle:"",html:function html(){return{__html:"\n\t\t\t<h2>Time to bask in nature\u2019s glory</h2>\n\t\t\t<p>\n\t\t\t   Get high on life in the lowest place on earth.\n\t\t\t</p>\n              \n\t\t\t"};}},{id:3,bgImage:"posts/bank/58/1.jpg",mobBgImage:"posts/bank/58/M.jpg",title:"The Dead Sea ",vidId:"DzEJxjnC_UQ",isVid:true,ctg:"deadsea",smlTitle:"",html:function html(){return{__html:"\n\t\t\t  <h2>Time to bask in nature\u2019s glory</h2>\n              <p>\n\t\t\t\t\t\tThe Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth\u2019s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water\u2019s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.\n              </p>\n              <p>\n              \t\tThis is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.\n              </p>\n              <p>\n              \t\tThe Dead Sea is lined with spas, bathing beaches and spa hotels.\n              </p>\n\t\t\t"};}},{id:"Go_To_Guide",bgImage:"/posts/bank/gotoguide/1.jpg",mobBgImage:"/posts/bank/gotoguide/M/1.jpg",title:"Go To Guide",ctg:"telaviv",isVid:false,smltitle:"",html:function html(){return{__html:"\n                    <h2>\n                    Travel from Tel Aviv and Jerusalem\n                    </h2>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tOne of the best things in visiting Tel Aviv and Jerusalem is how incredibly different yet amazingly close are these two fabulous destinations. In fact, the two cities are less than one hour\u2019s drive(!) from one another, which means that should you wish, you could spend the day exploring the awesome and world-famous sites of Jerusalem and be back in time to watch the sunset from one of Tel Aviv stunning beaches before heading on to an all-night rager in one of the city\u2019s hottest clubs. Talk about a full day\u2019s fun\u2026\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/gotoguide/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tGetting to and from Tel Aviv and Jerusalem is easy and there are several ways depending on your preference and budget:\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>By Car:</strong> \n\t\t\t\t\t\tShould you choose to hire a car you will find route 1 connects the two cities directly, and road signs to be pretty clear and come in three languages. However, you may want to use one of the local navigation apps to show you the way and help you avoid heavy traffic. \n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/gotoguide/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>By Bus:</strong> \n\t\t\t\t\t\tthere are several public buses which travel to and from Tel Aviv and Jerusalem. This is by far one of the most convenient and budget-friendly means of travel. \n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>By Train:</strong> \n\t\t\t\t\t\tA convenient train service operates in several main stations to and from Tel Aviv and Jerusalem. Works are currently underway and soon a fast new direct route will begin operating between the two cities. \n\t\t\t            \t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>By Taxi:</strong> \n\t\t\t\t\t\tTaxis for interurban travel can be flagged on the street or booked via phone or designated apps such as Gett (GetTaxi).\n\t\t\t            \t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>Sherut Taxis:</strong> \n\t\t\t\t\t\t\u201CSherut\u201D (service) taxis are 10 - 12 seater vans which generally follow major bus routes, in and between major cities. Pricewise, sherut taxi fares have a fixed price, similar to public bus fares. Sherut taxis also offer a replacement to service to buses on Fridays.  \n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t            \t\tFor information regarding train stations, routes and schedules, visit <a href=\"https://www.rail.co.il\" target=\"_blank\">www.rail.co.il</a>\n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t            \t\tFor information regarding bus routes and schedules visit  <a href=\"https://www.bus.co.il\" target=\"_blank\">www.bus.co.il</a>\n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t            \t\tPublic transport helpline   <a href=\"tel:*8787\">*8787</a>\n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t            \t\tLocal public transport app - \u2018Moovit\u2019\n\t\t\t            \t</p>\n\t\t\t            \t<p>\n\t\t\t\t\t\tSo come check out Epic Tel Aviv and unforgettable Jerusalem, less than one hour away from each other!\n\t\t\t            \t</p>\n\n            \t"};}},{id:"Day_IsTrippin",bgImage:"/posts/bank/48/1.jpg",mobBgImage:"/posts/bank/48/M/1.jpg",title:"UNE JOURNÉE À TEL AVIV",isVid:false,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<p>\n\t\t\t\tD\xE9marrez votre journ\xE9e au Midron parc de Jaffa (parc en pente), avec un magnifique panorama sur presque la totalit\xE9 du littoral isra\xE9lien et sur le point de d\xE9part historique de la m\xE9tropole, il y a 4,000 ans. D\xE9gustez une tasse de caf\xE9 sur l'ancien port r\xE9nov\xE9 et continuez vers le nord pour une belle balade le long de la promenade, un agr\xE9able petit plaisir baln\xE9aire.\n\t\t\t\t</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/37/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\tTraversez la rue pour vous diriger vers la \"Tachana compound\" (le complexe de la gare), un fabuleux centre commercial en plein air enti\xE8rement r\xE9nov\xE9 situ\xE9 dans une ancienne gare ferroviaire historique construite dans les ann\xE9es 1890 pour servir de gare centrale de Tel Aviv et de Jaffa.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\tAvancez jusqu'au pittoresque quartier de Neve Tsedek et d\xE9couvrez ses magnifiques ruelles. Faites-vous plaisir dans les petites boutiques jusqu'\xE0 ce que vous atteigniez l'agitation bariol\xE9e du march\xE9 Ha carmel. Faites une pause le temps d'avaler une excellente sp\xE9cialit\xE9 de rue et si c'est un mardi ou un vendredi \u2013 consid\xE9rez-vous chanceux et faites un peu de shopping \xE0 la foire traditionnelle de Nahalat Benyamin o\xF9 les artisans locaux pr\xE9sentent leurs ouvrages.\n\t\t\t\t</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/37/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\tRemontez le splendide boulevard Rothschild, le c\u0153ur de l'architecture Bauhaus et un site du patrimoine international de l'UNESCO. C'est le moment de louer une bicyclette et de se joindre \xE0 la foule locale jusqu'\xE0 la place Habima, foyer du th\xE9\xE2tre national et de l'orchestre philarmonique isra\xE9lien. Dirigez-vous vers la rue Dizengoff, tr\xE8s tendance et anim\xE9e, ou avalez un morceau dans l'un des coffee shops encerclant la place puis poursuivez votre marche ou roulez sur le boulevard Hen jusqu'\xE0 la place Rabin.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\tD\xE9couvrez la rue Ibn Gabirol, une plaque tournante de cette ville incroyable, foyer d'un large \xE9ventail de restaurants prim\xE9s et d'excellents pubs et bars o\xF9 vous pouvez avaler un repas ou siroter un verre et vous m\xEAler \xE0 la population locale.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\tGrimpez dans un bus de la ligne 5, v\xE9ritable ic\xF4ne urbaine et descendez au port de Tel Aviv. Profitez du coucher du soleil et posez votre regard vers le sud sur l'horizon de Jaffa o\xF9 votre journ\xE9e a d\xE9marr\xE9. Passez la soir\xE9e dans le coin et observez sa transformation en l'une des sc\xE8nes les plus chaudes de la vie nocturne de la ville, d\xE9bordante de bars formidables et de discoth\xE8ques sur mesure pour des soir\xE9es \xE9piques.\n\t\t\t\t</p>\n\n            \t"};}},// has ho translation' hadar said to hide untill she'll send the translation
// {
// 	id:"Non_Stop_Culture",
//               bgImage: "/posts/bank/non-stop-culture/1.jpg",
//               mobBgImage: "/posts/bank/non-stop-culture/M/1.jpg",
//               title :"Non Stop Culture",
// 				isVid:true,
// 				vidId:"MXtcTm_JXus",
// 				ctg:"telaviv",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
//                     <h2>Tel Aviv’s fascinating cultural scene</h2>
// 				    <p>Tel Aviv is famous around the world for its culture and entertainment scene. Home to fantastic museums and art galleries, theaters, concert halls, and dance centers, your cultural desires are sure to be met.
//                     <h3>Theatres</h3>
//                     <p>The Tel Aviv theatre scene is flourishing and visitors to the city will enjoy the many world class plays of the city’s main theatres – Habima, Hakameri and Gesher, located is beautiful surroundings and often hosting shows in English or offer subtitles for non-Hebrew speakers.
//                     <h3>Tel Aviv Museum of Art</h3>
//                     <p> The city’s beautifully designed, leading museum for Israeli and international art containing one of the world’s largest contemporary art collections featuring permanent displays alongside rotating exhibitions.
//                     <div class="img-wrapper">
// 					    <img src=${getImgUrl() + "/posts/non-stop-culture/1.jpg"} class="img-responsive" />
// 				    </div>
//                     <h3>Beit Ha’ir (The old Town Hall)</h3>
//                     <p>The recently renovated Beit Ha’ir, was the old city hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city’s history, featuring a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years.
//                     <h3>Eretz Israel Museum</h3>
//                     <p>A multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts.
//                     <h3>Private Galleries</h3>
//                     <p>All around Tel Aviv, but mainly in Neve Tzedek, Ben Yehuda and Gordon streets you can freely wonder into any of the privately-owned beautiful art galleries featuring original works of local contemporary artists.
//             	`   }
//   }
// },
// end has ho translation' hadar said to hide untill she'll send the translation
{id:"A_Taste_Of_Jerusalem",bgImage:"/posts/bank/taste-of-jerusalem/1.jpg",mobBgImage:"/posts/bank/taste-of-jerusalem/M/1.jpg",title:"JERUSALEM",ctg:"culinaryjerusalem",isVid:true,vidId:"2CSCe2WC7Ns",smlTitle:"",html:function html(){return{__html:"\n                <h2>A manger \xE0 J\xE9rusalem</h2>\n\t\t\t\t<p>\n\t\t\t\tJ\xE9rusalem est une ville fascinante et magique. De nombreuses personnes qui visitent J\xE9rusalem sont emball\xE9es par l'atmosph\xE8re extraordinaire, les sites inoubliables, les vues \xE0 couper le souffle et plus encore. Cependant, pour vraiment comprendre ce que repr\xE9sente J\xE9rusalem, il y a certaines choses que vous devez d\xE9couvrir gr\xE2ce \xE0 vos papilles. Voici un petit aper\xE7u de ce qu\u2019il vous faut vraiment tester en visitant J\xE9rusalem.\n\t\t\t\t</p>\n\t                    \t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/39/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\t<strong>Malabi:</strong> une combinaison unique entre une boisson et un dessert, pr\xE9par\xE9e avec un m\xE9lange d'eau de rose, de lait, de f\xE9cule de ma\xEFs et de sucre. Le Malabi est un met tr\xE8s populaire \xE0 J\xE9rusalem, propos\xE9 dans beaucoup de restaurants orientaux et de kiosques \xE0 travers la ville. Ce qui est certain c'est que cela ne ressemble \xE0 rien de tout ce que vous avez d\xE9j\xE0 pu go\xFBter.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t<strong>Knafe:</strong> un plat tr\xE8s int\xE9ressant et surprenant lorsqu'il est servi et mang\xE9 frais. Le Knafe est plut\xF4t un dessert arabe pr\xE9par\xE9 avec du fromage de ch\xE8vre fondu et recouvert de cheveux d'anges de couleur orange fortement imbib\xE9s d'un sirop \xE0 l'eau de rose sucr\xE9. Trouver le parfait Knafe est une v\xE9ritable mission, mais une fois que vous l'avez trouv\xE9, le d\xE9guster devient une addiction.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t<strong>Pretzel de J\xE9rusalem:</strong> le must absolu, lorsque vous visitez les sites fascinants de la vieille ville, est de s'arr\xEAter \xE0 l'un de ces petits chariots verts et d'acheter un authentique pretzel de J\xE9rusalem. Pour l'accompagner, vous recevrez une herbe aromatique locale de couleur verte appel\xE9 Zaatar et qui se marie tr\xE8s bien avec ce d\xE9licieux pain chaud.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t<strong>Meorav Yerushalmi:</strong> Traduit mot \xE0 mot par \"M\xE9lange de J\xE9rusalem\", ce d\xE9licieux assortiment de diff\xE9rentes sortes de viandes marin\xE9es dans un m\xE9lange d'herbes locales est un paradis absolu pour le palais des carnivores.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t<strong>\"Ashtanur\":</strong> une abr\xE9vation en h\xE9breu pour \"le feu au four\", Ashtanur est un pain pita local authentique que vous pouvez trouver en ville ou au march\xE9 \xE0 l'heure du d\xE9jeuner. Si vous avez tr\xE8s faim, testez-le farci d'une portion de shawarma ou de falafel.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t<strong>Sabich:</strong> une v\xE9ritable originalit\xE9, le sabich est vraiment un plat local unique compos\xE9 d'un pain pita farci d'aubergines frites, d'\u0153ufs durs et de cornichons, g\xE9n\xE9ralement recouvert d'une sauce Amba \xE0 base d'un savoureux condiment local. D\xE8s que vous l'aurez go\xFBt\xE9, vous en serez accro !\n\t\t\t\t</p>\n\n            \t"};}},{id:"Sectrets_Of_Jewish_Jerusalem",bgImage:"/posts/bank/sectrets-of-jewish-jerusalem/1.jpg",mobBgImage:"/posts/bank/sectrets-of-jewish-jerusalem/M/1.jpg",title:"A taste of Jerusalem",ctg:"jerusalem",isVid:false,smlTitle:"",html:function html(){return{__html:"\n                                <p>Jerusalem is an open invitation for a journey. Climb the mountains, enter the city and feel the unique mix between past and present, ordinary and extraordinary. One of the most ancient cities in the world, sacred for Jews, Christians and Muslims, Jerusalem offers an unparalleled sensory and spiritual experience.</p>\n\n                                <p>Enter. The heart of the holiest city in Judaism is the Old City. Enter through the historic entrance, The Jaffa Gate, or use The Zion Gate that leads straight to the Jewish Quarter, one of the four quarters of the walled city and home to Jews almost consecutively since 8 BCE. Wonder through the alleyways, see the people, visit the Cardo, Jerusalem's ancient main street and absorb the unique atmosphere. You're walking in the footsteps of kings and prophets \u2013 It's no ordinary thing.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t                <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/sectrets-of-jewish-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t                </div>\n\t\t\t\t\t\t\t    <small style=\"color:#000; display:block;\">\n                      \t\t        Credit: Noam Chen\n                      \t        </small>\n\t\t\t\t\t\t\t\t<p>Witness History Comes alive and Feel the Deep Spiritual Energy within the Walls </h3>\n\n                                <p>What Lays Ahead.  The last remaining segment from the ancient walls that surrounded The Second Temple, The Western Wall, is a symbol of Jewish yearnings for their ancestral and spiritual homeland. Every Jew outside Jerusalem pray facing the place you stand in now, the place where according to Judaism, God resides. No matter what your beliefs are, it's a humbling experience. Honor the spirit of the site and place a note in the wall with a prayer or a wish.</p>\n\n                                <p>What Lays Beneath. Jerusalem is literally covered with layers of history and touching history gets a whole new meaning here.</p>\n\n                                <p>Take the fascinating tour at the Western Wall Tunnels and reveal the hidden sections of the Western Wall. History will come to life as you move through underground passages, discover life in Jerusalem during The Second Temple era and learn about the art, architecture and building practices.</p>\n\n                                <p>Visit the nearby archeological site City of David and learn more about the history of the city King David declared as the unified capital of Israel's 12 tribes 3000 years ago. Go on a journey between ancient walls and fortresses, hidden springs where kings were coroneted and follow the path of fleeing Jerusalem residents after the city was conquered by the Romans.</p>\n\n                                <h3>Marvel at the Breathtaking Extraordinary Vista and Feel on Top of the World</h3>\n\n                                <p>What Lays Above. Originally built to protect the city against intruders, Jerusalem is surrounded by walls.  Today The Walls of Jerusalem offer an opportunity to explore the city from a different angle. Hear the stories, see the city below you and take in all this beauty.</p>\n\n                                <p>You are just beginning to stretch the surface.</p>\n\n            \t"};}},{id:"Jamie_Oliver",bgImage:"/posts/bank/jamie_oliver/1.jpg",mobBgImage:"/posts/bank/jamie_oliver/M/1.jpg",title:"Jamie Oliver découvre les saveurs des petits-déjeuners de Tel Aviv",ctg:"culinarytelaviv",isVid:true,vidId:"gGe4W8WaIiQ",smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t<small style=\"color:#000; display:block;position: relative;top: 5px;\">\n\t\t\t\t\t\tCredit:  Israeli food channel\n\t\t\t\t\t\t</small>\n\n\n            \t"};}},{id:37,bgImage:"/posts/bank/enjoy-and-indulge/1.jpg",mobBgImage:"/posts/bank/enjoy-and-indulge/M/1.jpg",title:"TEL AVIV",isVid:false,ctg:"telaviv",smltitle:"",html:function html(){return{__html:"\n                    <h2>L'ultime destination de luxe</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\tOubliez les Cara\xEFbes, Cannes ou les Maldives, si vous recherchez des vacances de luxe \u2013 Tel Aviv est l'endroit o\xF9 il faut \xEAtre !\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p> \n\t\t\t\t\tTout d'abord, la ville, surnomm\xE9e \"la capitale du cool\" par le New York Time, n'est qu'\xE0 quelques heures, ce qui signifie que vous ne perdrez m\xEAme pas une minute de vos vacances \xE0 vous remettre du d\xE9calage horaire.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tUne fois sur place, votre premier d\xE9lice est le temps ensoleill\xE9 tout au long de l'ann\xE9e \u2013 du sur mesure pour le plaisir.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p> \n\t\t\t\t\tEnsuite, allez vous installer et vous relaxer dans l'un des nombreux h\xE9bergements luxueux propos\xE9s \u2013 des h\xF4tels 5 \xE9toiles de rang mondial surplombant la plage aux diff\xE9rents h\xF4tels boutiques surprenants situ\xE9s dans des endroits \xE0 couper le souffle \xE0 travers la ville.\n\t\t\t\t\t</p>\n                   \t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/38/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\tPour compl\xE9ter cette aventure, attrapez une serviette et dirigez-vous vers l'une des admirables plages, am\xE9nag\xE9es avec toutes les installations n\xE9cessaires pour passer une journ\xE9e fabuleuse, sans oublier les splendides eaux fra\xEEches.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p> \n\t\t\t\t\tUne petite faim ? Profitez d'un large choix de repas gastronomiques, du local \xE0 la fusion, Tel Aviv est mondialement r\xE9put\xE9e pour la qualit\xE9 de sa cuisine propos\xE9e dans des restaurants de chefs prim\xE9s au d\xE9cor exquis.\n\t\t\t\t\t</p>\n\t\t \t\t\t<p>\n\t\t\t\t\t Il est temps de faire un peu de shopping \u2013 prenez votre portefeuille et venez d\xE9couvrir les articles dans les boutiques de cr\xE9ateurs locaux, les magasins chics des grandes marques et les luxueux centre commerciaux o\xF9 vous pouvez tout trouver, des articles de Haute Couture comme les derni\xE8res tendances internationales.\n\t\t\t\t\t </p>\n\t\t\t\t\t<p>\n\t\t\t\t\tPour terminer votre journ\xE9e, avalez une bi\xE8re artisanale ou un cocktail glamour dans l'une des discoth\xE8ques sensationnelles ou l'un des bars chics de la ville et dansez toute la nuit avant de retourner \xE0 votre h\xF4tel pour un sommeil 5 \xE9toiles bien m\xE9rit\xE9.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tDu luxe ? Du style ? Du glamour ? Nous avons tout ! Alors d\xE9p\xEAchez-vous et r\xE9servez votre s\xE9jour \xE0 Tel Aviv d\xE8s Aujourd\u2019hui !\n\t\t\t\t\t</p>\n\n            \t"};}},{id:"Cool_Jerusalem",bgImage:"/posts/bank/cool-jerusalem/1.jpg",mobBgImage:"/posts/bank/cool-jerusalem/M/1.jpg",title:"",ctg:"jerusalem",isVid:true,vidId:"nLKWDp5uA-U",smltitle:"LES SURPRISES DE JÉRUSALEM",html:function html(){return{__html:"\n\t\t\t\t<br/>\n                    <h2  class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Une ville au-del\xE0 de toutes attentes</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\tJ\xE9rusalem est une ville mondialement c\xE9l\xE8bre et l'une des destinations de vacances les plus populaires au monde. Beaucoup de gens visitent J\xE9rusalem chaque ann\xE9e en raison de sa signification historique, ses lieux saints, son architecture magnifique et unique et son atmosph\xE8re hors du commun. Cependant, J\xE9rusalem est une ville de surprises et il y a de nombreuses choses \xE0 proposer dans cette cit\xE9 extraordinaire que la plupart des gens ne pourraient pas imaginer au premier abord. Voici juste un aper\xE7u des choses que vous ne vous attendrez pas n\xE9cessairement \xE0 trouver \xE0 J\xE9rusalem.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/40/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>LES F\xCATES DE L'\xC9T\xC9</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tTous les ans pendant la saison d'\xE9t\xE9, le centre de J\xE9rusalem est inond\xE9 des f\xEAtes du vendredi midi, emplies de musique, de danses, de personnes formidables du monde entier et d'une ambiance enivrante pour d\xE9marrer les choses en beaut\xE9 et vous mettre en forme pour le reste du week-end.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>LA FOLIE DU MARCH\xC9</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tUne aventure incroyable qui op\xE8re le jeudi soir, lorsque le march\xE9 tr\xE8s anim\xE9 de Mahan\xE9 Yehuda se transforme en une sc\xE8ne de fin de soir\xE9e bourdonnante et bouillonnante de bars et de pubs d\xE9lirants et de la musique en live toute la soir\xE9e.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>LES FESTIVALS</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tJ\xE9rusalem est une ville d\xE9bordante de festivals \u2013 du c\xE9l\xE8bre festival du film au festival du vin, en passant par un festival international de marionnettes et m\xEAme une f\xEAte de la bi\xE8re, quoique vous appr\xE9ciez, vous pouvez \xEAtre certain de trouver un festival qui vous correspond et qui, \xE0 un moment donn\xE9, se tiendra dans la ville.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>LE MARATHON DE J\xC9RUSALEM</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tUn marathon g\xE9nial et extr\xEAmement populaire qui propose une vari\xE9t\xE9 de parcours, pour les professionnels ou les familles d'amateurs, traversant des sites historiques fascinants qui illuminent 3,000 ans de l'histoire de J\xE9rusalem, garants d'une exp\xE9rience stimulante, passionnante et inoubliable pour l'ensemble des coureurs et des spectateurs.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>LES MUS\xC9ES ET LES EXPOSITIONS</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tLa diversit\xE9 de la ville de J\xE9rusalem se prolonge dans ses mus\xE9es et ses \xE9v\xE8nements culturels pr\xE9sent\xE9s dans toute la ville. Du mondialement c\xE9l\xE8bre mus\xE9e d'Isra\xEBl \xE0 Yad Vashem, au m\xE9morable spectacle \u2018\u2019sons et lumi\xE8res\u2019\u2019 de la vieille ville et la promenade sur les remparts, et beaucoup plus encore ; la ville est tout simplement baign\xE9e d'exp\xE9riences culturelles admirables.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>LE MARCH\xC9 CHAMP\xCATRE</h3>\n\t\t\t\t\t<p>Tous les vendredis, dans le quartier de la colonie allemande au c\u0153ur de la ville, vous trouverez le march\xE9 champ\xEAtre local. Proposant une multitude de bons produits et une large vari\xE9t\xE9 de d\xE9licatesses locales et d'excellentes affaires.</p>\n\n\t\t\t\t\t<h3>UN AQUARIUM DE CLASSE MONDIALE</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tL'un des plus grands aquariums du Moyen-Orient, cette fabuleuse attraction pour les enfants comme pour les adultes a ouvert, pour la premi\xE8re fois cette ann\xE9e, ses portes au public. Cet aquarium s'\xE9tend sur 7,000 m2 et renferme 40 esp\xE8ces marines dans 33 r\xE9servoirs d'eau, dont le plus grand contient 1.6 millions de litres d'eau.\n\t\t\t\t\t</p>\n\n\n            \t"};}},{id:39,bgImage:"/posts/bank/cycle-in-telaviv/1.jpg",mobBgImage:"/posts/bank/cycle-in-telaviv/M/1.jpg",vidId:"88OV6xU0vPI",isVid:true,ctg:"telaviv",title:"TEL-AVIV SUR ROUES",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t\t\t<p>Le meilleur moyen d'apprendre \xE0 conna\xEEtre une nouvelle ville est d'explorer ses recoins - et quel meilleur moyen de le faire qu'\xE0 v\xE9lo&nbsp;? Ces derni\xE8res ann\xE9es, Tel Aviv a adopt\xE9 la mode du deux roues, encourag\xE9e par son nouveau r\xE9seau de pistes cyclables et ses zones de stationnement. C'est une bonne nouvelle pour les touristes - le moment n'a jamais \xE9t\xE9 meilleur pour se d\xE9placer en ville \xE0 bicyclette.</p>\n\t\t\t\t\t<h3>Circuler en deux roues \xE0 Tel Aviv</h3>\n\t\t\t\t\t<p>Quasiment sans d\xE9nivel\xE9, la ville est id\xE9ale pour les v\xE9los, et la circulation en voiture y est l\xE9gendaire. La bicyclette constitue un excellent moyen de transport pour les habitants et les touristes qui souhaitent se d\xE9placer en ville \xE0 leur rythme. Sept minutes suffisent pour passer de la verdure du parc Hayarkon \xE0 celle du square Rabin situ\xE9 en centre-ville, soit quasiment le temps n\xE9cessaire pour parcourir le m\xEAme trajet en voiture&nbsp;!</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/41/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>La partie centrale bord\xE9e d'arbres du Boulevard Rothschild est \xE9quip\xE9e d'une piste cyclable qui vous permet d'admirer les b\xE2timents de style Bauhaus en roulant. La promenade r\xE9nov\xE9e du port de la ville et celle qui longe le front de mer \xE0 Tel Aviv et Jaffa sont elles aussi tr\xE8s agr\xE9ables \xE0 parcourir \xE0 v\xE9lo. Emprunter les pistes qui longent les eaux de la M\xE9diterran\xE9e est une des activit\xE9s touristiques les plus romantiques de la ville, en particulier lorsque le soleil se couche et que souffle une l\xE9g\xE8re brise.</p>\n\t\t\t\t\t<h3>Visiter Tel Aviv sur deux roues</h3>\n\t\t\t\t\t<p>\xC0 Tel Aviv, l'ann\xE9e 2011 a \xE9t\xE9 marqu\xE9e par le lancement du programme de location de v\xE9los Tel-O-Fun. Son fonctionnement est le m\xEAme que celui de syst\xE8mes \xE9quivalents propos\xE9s \xE0 New York, Londres et Paris. Touristes et visiteurs peuvent acheter des cartes d'acc\xE8s quotidiennes ou hebdomadaires, en ligne ou dans l\u2019une des 206 bornes de vente disponibles dans toute la ville. Passez votre carte dans l'appareil pour obtenir un v\xE9lo et la ville est \xE0 vous&nbsp;!</p>\n\t\t\t\t\t<p>Le Segway est un autre moyen amusant de d\xE9couvrir la ville sur deux roues. Des visites guid\xE9es en Segway de la zone portuaire, des sentiers du parc Hayarkon, du vieux Jaffa et des charmants quartiers de style Bauhaus sont propos\xE9es aux touristes qui souhaitent s'aventurer dans les rues auxquelles les bus touristiques ne peuvent acc\xE9der.</p>\n\n            \t"};}},{id:"TelAviv_Adventures",bgImage:"/posts/bank/telaviv-adventures/1.jpg",mobBgImage:"/posts/bank/telaviv-adventures/M/1.jpg",title:"",smltitle:"Bons plans sur Tel Aviv",isVid:false,ctg:"telaviv",html:function html(){return{__html:"\n\t\t\t\t\t<p>\n\t\t\t\t\tTel Aviv est mondialement reconnue comme la ville qui ne dort jamais, r\xE9put\xE9e pour son incroyable vie nocturne, ses plages fabuleuses, son art et sa culture fantastiques et plus encore. Mais voici quelques endroits moins connus dont vous pouvez profiter durant l'\xE9t\xE9 \xE0 Tel Aviv.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/42/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>ESSAYEZ LES BARS BRACELET</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tLes bars Bracelet sont un excellent moyen de profiter d'une sortie nocturne en d\xE9gustant des verres sans ruiner son budget. Frayez-vous simplement un chemin dans l'un des nombreux bars de Tel Aviv qui vous proposent de payer un prix fixe \xE0 l'avance et de boire autant que vous le souhaitez ou autant que vous le pouvez\u2026\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>LES CERCLES DE PERCUSSIONS DES VENDREDIS APR\xC8S-MIDI<h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tDirigez-vous vers la fameuse plage Banana beach les vendredis apr\xE8s-midi et faites-vous doublement plaisir \u2013 profitez d'un impressionnant morceau de percussions sur la plage et admirez le splendide coucher du soleil \u2013 le tout enti\xE8rement gratuit!\n\t\t\t\t\t<p>\n\t\t\t\t\t<h3>LE PLAISIR SUR LES TOITS<h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tC'est peut-\xEAtre le climat; c'est peut-\xEAtre la vue \u2013 une chose est s\xFBre, les Tel Aviviens adorent \xEAtre dehors, surtout un verre \xE0 la main. En \xE9t\xE9, la plupart des bars et des pubs atteignent le sommet (litt\xE9ralement!) et se transforment en lieux ext\xE9rieurs, car beaucoup de bars s'installent sur les toits des immeubles commerciaux et de bureaux. Pour trouver ces formidables endroits, vous n'avez qu'\xE0 suivre les sons de la musique et de la f\xEAte.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>LA GYM EN PLEIN AIR<h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tRien n'est plus important que votre sant\xE9 et l'une des meilleures chose que vous pouvez offrir \xE0 votre corps c'est un peu d'exercice. Tel Aviv vous permet de le faire de diff\xE9rentes mani\xE8res \u2013 en nageant dans la mer, en courant le long de la promenade, en v\xE9lo \xE0 travers les magnifiques rues de la ville et m\xEAme en faisant de la gymnastique dans l'une des stations de sport en plein air (gratuites) situ\xE9es un peu partout en ville.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>LES FABULEUX \xC9V\xC9NEMENTS DE L'\xC9T\xC9<h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tDes artistes internationaux de renomm\xE9e mondiale \xE0 la technologie surprenante, des festivals d'art et de la bi\xE8re, des inaugurations de galeries, des expositions, des musiques de rue, aux cin\xE9mas en plein air et aux f\xEAtes sur la plage qui durent toute la nuit, Tel Aviv l'\xE9t\xE9 est une source intarrissable d'amusement et de divertissement qu'il ne faut pas manquer!\n\t\t\t\t\t</p>\n\n            \t"};}},{id:"ANIMATED_NIGHTS_TEL_AVIV",bgImage:"/posts/bank/ANIMATED_NIGHTS_TEL_AVIV/1.jpg",mobBgImage:"/posts/bank/ANIMATED_NIGHTS_TEL_AVIV/M/1.jpg",title:"LES NUITS ANIMÉES DE TEL AVIV NUITS BLANCHES DANS LA VILLE BLANCHE",smltitle:"",isVid:false,ctg:"telaviv",html:function html(){return{__html:"\n\n\t\t\t\t<p>Tel Aviv est \xE0 juste titre connue comme une des villes au monde o\xF9 l'on peut s'amuser jusqu'au bout de la nuit, son chaud climat m\xE9diterran\xE9en en fait le lieu id\xE9al pour faire la f\xEAte en ext\xE9rieur  presque toute l'ann\xE9e. Au coucher du soleil, la ville s'anime pour offrir de multiples exp\xE9riences aux noctambules.</p>\n\n\t\t\t\t<h3>Tel Aviv de nuit</h3>\n\t\t\t\t<p>Peu importe l'heure, il se passe toujours quelque chose \xE0 Tel Aviv. Regardez le soleil se coucher depuis un bar en bord de mer, les pieds dans le sable chaud, une boisson fra\xEEche \xE0 la main, avant de poursuivre votre soir\xE9e dans un pub en vogue pour d\xE9guster une bi\xE8re artisanale, siroter un cocktail exotique dans un bar tranquille ou prendre un d\xE9licieux en-cas avant d'aller fouler la piste d'une discoth\xE8que de Tel Aviv jusqu\u2019\xE0 l'aube.</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/animated-nights-tlv/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t<p>Les gourmands appr\xE9cieront les fantastiques cocktails r\xE9alis\xE9s par les habiles barmen de Tel Aviv, les bi\xE8res et plats de fabrication artisanale servis dans les pubs, ainsi que les lieux de restauration tr\xE8s vari\xE9s allant des \xE9tablissements raffin\xE9s aux marchands de rue proposant tous les styles et types de cuisine. Mangez tout ce qui vous fait envie !</p>\n\t\t\t\t\n\t\t\t\t<h3>Profiter \xE0 fond de la vie nocturne \xE0 Tel Aviv</h3>\n\t\t\t\t<p>Vous pouvez passer une soir\xE9e tranquille dans un \xE9l\xE9gant bar \xE0 vin d'un quartier branch\xE9 tel que N\xE9v\xE9 Tzedek, o\xF9 vous aurez la possibilit\xE9 de go\xFBter quelques-uns des vins renomm\xE9s d'Isra\xEBl. Allez-vous d\xE9tendre dans un des nombreux bars o\xF9 se produisent des orchestres en live ou cultivez-vous en d\xE9gustant un cocktail dans une des nouvelles galeries-bars de la ville exposant les \u0153uvres d'artistes prometteurs.</p>\n\t\t\t\t\n\t\t\t\t<p>Si vous voulez faire la f\xEAte en ville toute la nuit, Tel Aviv est l'endroit qu'il vous faut. Ses discoth\xE8ques sont connues dans le monde entier et re\xE7oivent m\xEAme des DJ internationaux. En \xE9t\xE9, certaines plages se transforment en bo\xEEte de nuit pour proposer jusqu'au petit matin des rave-parties o\xF9 vous retrouverez les rythmes lancinants, lasers et musiques ent\xEAtantes qui les caract\xE9risent. Dans la plupart des discoth\xE8ques de la ville qui re\xE7oivent des DJ renomm\xE9s, la f\xEAte ne bat totalement son plein que vers 2 heures du matin. Vous trouverez tous les types de clubs possibles, que vous recherchiez une atmosph\xE8re intime ou une m\xE9ga discoth\xE8que, et m\xEAme si vous aimez les danses r\xE9tro ou les musiques \xE9lectriques ind\xE9s les plus r\xE9centes.</p>\n\t\t\t\t\n\t\t\t\t<p>\xC0 Tel Aviv, le milieu LGBTQ n'est pas en reste, puisque certains des meilleurs concerts et f\xEAtes sont donn\xE9s dans des clubs et bars gay. Quoi que recherchiez, une atmosph\xE8re paisible, une f\xEAte endiabl\xE9e, une soir\xE9e culturelle ou un lieu intime pour passer un moment \xE0 deux, un nombre impressionnant de lieux n'attendent que vous, quelle que soit l'heure du jour ou de la nuit.</p>\n\n            \t"};}},{id:"2_AWESOME_CITIES",bgImage:"/posts/bank/27/1.jpg",mobBgImage:"/posts/bank/27/M.jpg",title:"2 VILLES GRANDIOSES",smltitle:"",isVid:true,vidId:"b0QexDxEklA",ctg:"telavivAndJerusalem",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t<h2>Une escapade magique et inoubliable au soleil</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\tTel Aviv, cette m\xE9tropole ultra moderne vous offre ses plages de sable fin, son atmosph\xE8re tr\xE9pidante et les infinies possibilit\xE9s de se faire plaisir fa\xE7on m\xE9diterran\xE9enne, sans parler de l\u2019excellence de sa cuisine et de son caf\xE9. A moins de 40 minutes de l\xE0, le rythme est tout \xE0 fait diff\xE9rent. J\xE9rusalem, cette ville d\u2019une beaut\xE9 sans pareil. Pas \xE9tonnant qu\u2019elle ait inspir\xE9 autant de gens depuis des mill\xE9naires.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\tBien que Tel Aviv et J\xE9rusalem soient toutes deux des cit\xE9s industrieuses, vitales et intrigantes qui offrent une multitude d\u2019attractions \xE0 voir absolument, elles sont aussi diff\xE9rentes que possible. Malgr\xE9 leur proximit\xE9 g\xE9ographique, elles ont des paysages, odeurs et saveurs compl\xE8tement diff\xE9rents. A quel autre endroit pouvez-vous combiner plages de r\xEAve et lieux les plus anciens et sacr\xE9s de l\u2019histoire ? Alors voil\xE0 un \xE9chantillon de ce que vous pourriez faire pendant vos vacances dans ces deux villes.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>TEL AVIV- LA VILLE QUI NE DORT JAMAIS</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tVous voil\xE0 donc \xE0 Tel-Aviv. Faites l\u2019exp\xE9rience de l\u2019excitation que la premi\xE8re ville h\xE9bra\xEFque moderne vous r\xE9serve. D\xE9couvrez l\u2019azur de la M\xE9diterran\xE9e, les endroits typiques de la ville blanche, ses march\xE9s, restaurants, saveurs sp\xE9ciales et sa vie nocturne tr\xE9pidante. Attrapez quelques vagues vous comprendrez pourquoi donc Tel Aviv est connue comme la ville qui ne dort hamais, qui respire et exhale la vitalit\xE9 24 heures sur 24. Allons-y.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tNEV\xC9 TZ\xC9DEK :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tD\xE9couvrez la magie de ce quartier spectaculaire, joliment r\xE9nov\xE9 de l\u2019extr\xEAme sud de la promenade de Tel Aviv, \xE0 c\xF4t\xE9 de Jaffa. Commencez la matin\xE9e par une exp\xE9rience culinaire en prenant un petit-d\xE9jeuner isra\xE9lien typique, de d\xE9licieuses viennoiseries, des \u0153ufs, fromages et autres laitages, salade verte ou mixte, jus d\u2019oranges bien s\xFBr et bien entendu un excellent caf\xE9. La visite de Nev\xE9 Tz\xE9dek que nous vous recommandons vous conduira dans des lieux historiques\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\tHATA\u2019HANA :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tApr\xE8s vous \xEAtre sustent\xE9s, allez visiter HaTa\u2019hana, tout \xE0 c\xF4t\xE9. L\xE0 vous pouvez admirer des b\xE2timents r\xE9nov\xE9s datant de l\u2019\xE9poque des templiers, ainsi que l\u2018ancienne gare ferroviaire de Jaffa, refaite \xE0 neuf. Le site raconte l\u2019histoire de la gare et sa ligne Jaffa-J\xE9rusalem, op\xE9rationnelle entre 1892 et 1948.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tJaffa\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tDe l\xE0 marchez le long du magnifique littoral jusqu\u2019\xE0 Jaffa. Nous recommandons de visiter le port de Jaffa, consid\xE9r\xE9 comme l\u2019un des plus anciens au monde. Installez-vous dans l\u2019un des caf\xE9s du front de mer et observez les p\xEAcheurs au travail. Puis continuez vers le march\xE9 aux puces haut en couleurs o\xF9 vous pourrez vous offrir un objet de collection, c\xE9ramique arm\xE9nienne, main de Fatma ou tout autre objet parmi une multitude de souvenirs. La nuit ce quartier devient un lieu de divertissement avec ses bars et restaurants.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/7.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\tP\xC9DALEZ LE LONG DE LA PLAGE :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tTel Aviv est connue pour \xEAtre la capitale isra\xE9lienne du v\xE9lo. Par une belle journ\xE9e, les plus sportifs d\u2019entre vous pourront en louer un \xE0 l\u2019une des stations Tel-o-Fun ou \xE0 tout autre endroit de la ville. P\xE9daler de N\xE9v\xE9 Tz\xE9dek \xE0 la plage de Tel Baruch au nord de la ville est un vrai plaisir.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\tMUS\xC9E D\u2019ERETZ ISRA\xCBL :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tSi vous vous trouvez dans la partie nord de la ville, nous vous sugg\xE9rons de visiter le Mus\xE9e d\u2019Eretz Isra\xEBl, mus\xE9e multidisciplinaire qui se concentre sur l\u2019histoire et la culture d\u2019Isra\xEBl gr\xE2ce \xE0 des expositions permanentes et temporaires consacr\xE9es \xE0 l\u2019arch\xE9ologie, \xE0 l\u2019ethnographie, la poste et la philat\xE9lie, au folklore, \xE0 l\u2019art juif, aux arts traditionnels, \xE0 l\u2019art populaire, \xE0 l\u2019histoire culturelle et \xE0 l\u2019identit\xE9 locale ;\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tBOULEVARD ROTHSCHILD :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tVous cherchez un endroit o\xF9 faire un excellent repas ? Essayez l\u2019un des restaurants du Boulevard Rothschild ou de ses alentours, au c\u0153ur de la ville. C\u2019est l\u2019une des trois zones qui composent la ville blanche, reconnue par l\u2019UNESCO comme appartenant au patrimoine mondial de l\u2019Humanit\xE9. Cette art\xE8re, qui d\xE9finit parfaitement l\u2019essence de Tel Aviv, vous offre une occasion sans pareille d\u2019observer le genre humain. Vous pouvez aussi vous promener et admirer la magnifique architecture Bauhaus, le vieux kiosque et les mus\xE9es qui relatent la fascinante histoire de Tel Aviv et de son premier quartier, A\u2019huzat Bayit.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tVIE NOCTURNE :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tSi vous comptez rester quelques jours, vous pouvez choisir de louer une chambre dans l\u2019un des grands h\xF4tels de la plage, pr\xE8s de la promenade, ou dans l\u2019un des h\xF4tels-pensions. Et si vous avez encore de l\u2019\xE9nergie et d\xE9sirez marcher, c\u2019est le moment de vous rendre dans un bar ou un night-club, \xE0 l\u2019Op\xE9ra, ou d\u2019aller assister \xE0 un spectacle de dance ou \xE0 n\u2019importe quel autre festival ou \xE9v\xE8nement \xE0 Tel Aviv. Vous avez fini de go\xFBter aux plaisirs de Tel Aviv ? Maintenant profitez du meilleur des deux mondes en allant \xE0 J\xE9rusalem. Ce n\u2019est qu\u2019\xE0 40 minutes ! La cit\xE9 sacr\xE9e vous attend !\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\tJ\xC9RUSALEM - LA PLUS BELLE VILLE AU MONDE\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tD\xE9couvrez la ville sacr\xE9e pour trois religions \u2013 juda\xEFsme, chr\xE9tient\xE9 et islam. Visitez ses sites historiques, respirez ses odeurs enivrantes, go\xFBtez \xE0 ses plats sp\xE9ciaux, inhalez l'air pur de la montagne et amusez-vous dans les nombreux lieux de divertissement de la ville.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tEIN KAREM :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tAvant m\xEAme d'arriver, vous pourrez visiter le quartier pittoresque d'Ein Karem. A 20 minutes du centre-ville, il est connu pour son caract\xE8re idyllique: nich\xE9 dans la verdure, Ein Karem vous offre ses vues imprenables, ses charmantes maisons en pierre, ses all\xE9es enchanteresses, galeries et boutiques sp\xE9ciales, ses caf\xE9s et restaurants, ainsi que ses h\xF4tels exquis, anciens ou nouveaux.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tLE MUS\xC9E BLOOMFIELD DES SCIENCES :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tLe mus\xE9e des sciences de J\xE9rusalem est un royaume magique tant pour les enfants que pour les adultes, regorgeant d'objets mouvants, d\u2019illusions d\u2019optique, d\u2019exp\xE9riences \xE9lectriques et de tout ce qui fait de ce monde un lieu convivial.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tLA VIEILLE VILLE :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tV\xE9ritable must de toute visite de J\xE9rusalem ! La vieille ville de J\xE9rusalem est, pour dire les choses simplement, un v\xE9ritable tr\xE9sor combinant d\xE9couverte et plaisir. La v\xE9ritable essence de J\xE9rusalem se cache dans les all\xE9es \xE9troites et serpent\xE9es de la Vieille Ville: ambiance unique, histoire fascinante et secrets garantis au d\xE9tour de ses vieilles pierres. Visitez le Mur occidental, laissez l\u2019\xE9motion vous gagnez devant la saintet\xE9 des vestiges du Temple et glissez votre message entre les pierres avec une requ\xEAte adress\xE9e au Tr\xE8s Haut.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/1/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\tSuivez les traces de J\xE9sus le long de la Via Dolorosa, vers l'Eglise du Saint S\xE9pulcre l\u2019un des sites les plus saints de la Chr\xE9tient\xE9 : l\u2019endroit o\xF9 J\xE9sus a \xE9t\xE9 crucifi\xE9 et o\xF9 se trouve le tombeau vide duquel il est dit avoir ressuscit\xE9. Continuez vers le Mont Sion o\xF9 vous pourrez visiter le C\xE9nacle traditionnellement consid\xE9r\xE9 comme la salle de la Derni\xE8re C\xE8ne. Puis, comme le faisait J\xE9sus, rendez-vous au Mont des Oliviers pour un moment de m\xE9ditation au Geths\xE9mani, o\xF9 J\xE9sus a pri\xE9 et o\xF9 ses disciples se sont repos\xE9s la nuit pr\xE9c\xE9dant sa crucifixion. Puis, montez sur le toit de l'Hospice autrichien de la Sainte Famille pour une vue v\xE9ritablement magnifique de J\xE9rusalem et de la Vieille Ville. Pour vous plonger encore davantage dans les racines de la J\xE9rusalem antique, visitez les tunnels du Mur occidental, le D\xF4me du Rocher, le lieu saint o\xF9 Mahomet est suppos\xE9 \xEAtre mont\xE9 au Ciel, ainsi que l'Eglise luth\xE9rienne du R\xE9dempteur, qui abrite l'un des plus beaux orgues d'Isra\xEBl.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tLE MARCH\xC9 DE MA'HAN\xC9 Y\xC9HUDA :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tVous avez eu une journ\xE9e bien remplie. Vous commencez \xE0 avoir faim ? C\u2019est le moment o\xF9 jamais de visiter le March\xE9 de Ma'han\xE9 Y\xE9huda, ce march\xE9 hi\xE9rosolymitain \xE0 ciel ouvert, vibrant et dynamique. Aux c\xF4t\xE9s de ses \xE9tals, des caf\xE9s et restaurants ont \xAB fleuri \xBB ces derni\xE8res ann\xE9es.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tSHOPPING \xC0 J\xC9RUSALEM :\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tPr\xEAt pour un peu de shopping et des souvenirs ? Achetez de la c\xE9ramique arm\xE9nienne ou des pi\xE8ces d'art juif dans les belles boutiques de la Vieille Ville. Vous trouverez \xE9galement une pl\xE9thore de souvenirs d'Isra\xEBl au centre ville. De nombreuses boutiques de confection sont \xE0 votre disposition sur la rue pi\xE9tonne Ben Yehuda. Et n'oubliez pas les boutiques de fripes si vous souhaitez acheter quelque chose de plus authentique. De plus, ne ratez le centre commercial de Mamila, consid\xE9r\xE9 comme l'un des centres commerciaux les plus actifs de la ville.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tSi divers, si diff\xE9rents et pourtant si proches, J\xE9rusalem et Tel Aviv font la paire comme destination parfaite. Ensemble, elles vous apportent histoire et modernit\xE9, des art\xE9facts anciens et de l'art moderne, des moments au soleil tout et le voyage le plus spirituel de votre vie. Il n'y a pas mieux ! Alors qu'attendez-vous ? R\xE9servez vos vacances d\xE8s \xE0 pr\xE9sent !\n\t\t\t\t\t</p>\n\n\n           "};}},{id:"Jerusalem",bgImage:"/posts/bank/jerusalem-p/1.jpg",mobBgImage:"/posts/bank/jerusalem-p/M.jpg",title:"Jerusalem",smltitle:"",isVid:true,vidId:"FvAWuLQEOJw",ctg:"jerusalem",html:function html(){return{__html:"\n\n\t\t\t\t\t<h2>A CITY OF MAGIC AND RADIANCE BEYOND YOUR WILDEST DREAMS</h2>\n\t\t\t\t\t<p><strong>Jerusalem is The Capital of Israel and By Far One of The Most Famous and Fascinating Cities in the World, Where Thousands of Years of Glorious History Seamlessly Intertwine with Modern Day Life.</strong></p>\n                              \n                                <p>Discover the overwhelming power of this 3,000 year old city - its innumerable historic sites and archeological wonders, its magical walkways and magnificent views which are guaranteed to leave a lasting impression. At the same time, the city\u2019s strikingly modern attractions promise around the clock excitement and pleasure for all lovers of culture, arts, music, and culinary delights.</p>\n\n                                <h2>Walk through 3000 years of history</h2>\n\n                                <p>The Old City of Jerusalem is a favourite for all visitors from first timers, seasoned visitors as well as the locals. Surrounded by an ancient wall that has been rebuilt throughout history, there are 7 gates allowing access to historical and holy sites here. Make your way down the stone cobbled streets and find yourself walking through four thousand years of history, leaving you humbled and yet excited as you connect the modern day present with the simple beginnings of the past.</p>\n                              \n                                <h2>Meet the modern vibrant Jerusalem</h2>\n\n                                <p>Step outside of the Old City and find everything that a typical modern city offers including hotels, promenades, restaurants and shopping malls. Visit museums, like the Israel Museum which is the largest cultural institution in Israel and ranked among the world\u2019s leading art and archaeology museums housing the infamous Dead Sea Scrolls (oldest biblical manuscripts) among other treasures. Local farms, wineries and breweries are set up around Jerusalem offering a variety of options to foodies ranging from the traditional Israeli cuisine to the contemporary and fusion fare paired with delicious award-winning wines and beers attracting enthusiast from all over the world.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Jerusalem-p/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n                                <p>Visit Mahane Yehuda, a colourful and vibrant outdoor market with an attractive vibe filled with culture and delicious aromas of the delicacies sold here. Wait till sundown and see this \u2018shuk\u2019 transform into a trendy hangout with live music to suit every mood accompanied with energetic people, a growing \u2018street-art\u2019 gallery exceptional food and delightful drinks. Mahane Yehuda offers a special experience so walk down the streets, stop by a food joint, dance a little while enjoying a drink and make your way to the next spot.</p>\n\n                                <p>Drenched in art, history, culture and diversity the capital city of Israel loves to have a good time while allowing one to experience the contrast between old world historical charm and modern city living. As you drive in to Jerusalem you can\u2019t help but connect with the culture, archaeology and history of the many nations who have walked through here, where old meets new beyond the walls of the Old City in this unique world capital.</p>\n                                \n\t\t\t\t\n\n\n           "};}},{id:"Magical_Deadsea",bgImage:"/posts/bank/deadsea1/1.jpg",mobBgImage:"/posts/bank/deadsea1/M.jpg",title:"LA MER MORTE",smltitle:"",isVid:true,vidId:"8p4qfkneH1c",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t            <br/><h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Point Le Plus Bas Du Globe, Mais Source D'\xE9l\xE9vation Pour Le Corps Et L'esprit</h2>\n\t\t\t\t\t\t\t    <p><strong>D\xE9tendez-vous et vivez des vacances inoubliables gr\xE2ce aux vertus revitalisantes du sel de la mer Morte </strong></p>\n\t                            <p>Une beaut\xE9 naturelle \xE0 couper le souffle, des spas apaisants riches en min\xE9raux, des vertus reconnues pour la sant\xE9 et de nombreuses exp\xE9riences inoubliables&nbsp;: rien d'\xE9tonnant \xE0 ce que la mer Morte soit devenue l'une des destinations les plus pris\xE9es des touristes du monde entier. Ce myst\xE9rieux lac sal\xE9 est tout ce dont vous avez besoin pour mettre votre corps et votre esprit en vacances.</p>\n\t                            <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Magical-Deadsea/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t                            <p><strong>D\xE9tendez-vous</strong>. Sel, boue, soleil, et ce n'est pas tout. Baignez-vous dans les eaux (chaudes) sulfureuses naturelles et profitez des soins de thalassoth\xE9rapie. L'expression \"plaisir coupable\", vous connaissez&nbsp;? Oubliez-la. Oubliez tout sentiment de culpabilit\xE9 et profitez simplement de vacances saines, relaxantes et revitalisantes.</p>\n\t                            <p><strong>L\xE2chez-prise et profitez d'un des plus somptueux cadeaux de la nature </strong></p>\n\t                            <p><strong>Flottez. </strong>Gr\xE2ce \xE0 la salinit\xE9 exceptionnellement \xE9lev\xE9e de l'eau, vous pourrez faire un petit \"miracle\", non pas en marchant sur l'eau, mais en flottant naturellement. Allez dans l'eau, allongez-vous et laissez-faire la nature. Il vous faudra peut-\xEAtre une minute pour vous y habituer, mais vous pouvez nous croire, c'est magique.</p>\n\t                            <p><strong>Gu\xE9rissez. </strong>Aller dans la r\xE9gion de la mer Morte, c'est comme p\xE9n\xE9trer dans un autre monde. Tout y est diff\xE9rent&nbsp;: le paysage, l'espace, l'air, et m\xEAme le soleil.</p>\n\t                            <p>Du fait des caract\xE9ristiques g\xE9ologiques particuli\xE8res de la r\xE9gion, l'air et le soleil n'y ont pas les m\xEAmes propri\xE9t\xE9s et sont \xE0 l'origine de ses pouvoirs curatifs.</p>\n\t                            <p>L'atmosph\xE8re est sp\xE9ciale \xE0 cause du sel de la mer qui se dissout en riches particules min\xE9rales saines que vous absorbez en respirant.&nbsp; Le soleil est lui aussi diff\xE9rent du fait de la situation de la r\xE9gion, si basse par rapport au niveau de la mer. Les rayons du soleil sont plus faibles et ses rayons UV sont filtr\xE9s et moins nocifs. Sortez de l'eau et profitez des bienfaits de la nature.</p>\n\t                            <p><strong>D\xE9couvrez l'enfant qui sommeille en vous et laissez la nature vous gu\xE9rir </strong></p>\n\t                            <p><strong>Roulez-vous dans la boue </strong>\u2013 Les propri\xE9t\xE9s bienfaisantes de la boue de la mer Morte ne sont plus \xE0 d\xE9montrer. Cette boue assainit, revitalise et apaise la peau. Vous pouvez en acheter et l'utiliser chez vous, mais pourquoi rater l'occasion de r\xE9veiller l'enfant qui est en vous? Couvrez-vous de boue noire de la t\xEAte aux pieds et amusez-vous, tout simplement. Nous vous d\xE9fions de prendre un selfie.</p>\n\t\t\t\t\t\t\t\t\t\n           "};}},{id:"Next_Level_DS",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"TAKE RELAXATION TO THE NEXT LEVEL",smltitle:"",isVid:true,vidId:"8p4qfkneH1c",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n                     <p>\n\t\t\t\t\tThe Dead Sea, officially The Lowest Place On Earth (428m Below Sea Level) And A Shortlist Candidate For The World\u2019s 7 Natural Wonders, Is An Enthralling And Evocative Combination Of Natural Splendor, Compelling Ancient History And Modern Luxuries.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFrom the healing powers of the Dead Sea\u2019s cobalt blue waters, through the awesome beauty of the surrounding landscape to the myriad of fascinating sights this area has to offer, the Dead Sea is a place of tranquility, health and inspiration for body and soul alike.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFloat on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions. Along the main part of the 75 kilometer stretch dotted with beautiful beaches, you will also find world class hotels and spa facilities to guarantee a truly indulgent experience.\n\t\t\t\t</p>\n\t\t\t\t\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/next-level/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\t\tThe Magical Beaches of the Dead Sea\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe beaches of the Dead Sea are like nothing else the world has to offer. There are many kilometers of beautifully developed and well-maintained spots where you can soak up the sun while on your dream vacation. Choose your spot on the rocky sand and take in the breathtaking scenery with the incredible mountain ranges surrounding the sea. The warm waters of the Dead Sea are always calm and offer superior relaxation from the minute you get in.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tOn the southern shores at the lowest point on earth, you will find an array of hotels where you can enjoy a magical sunrise over the lake, leaving an array of colors on the small ponds with the salt formations scattered throughout. To complete the experience of being at the Dead Sea, take some of the silky dark mud and lather it on allowing your skin to absorb the helpful minerals. Dead Sea mud has been proven beneficial to the skin and body. You will feel refreshed with skin that looks and feels younger. Give yourself the pampering that you deserve and get dirty with the Dead Sea mud \u2013 it\u2019s healthy!\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tDiscover the desert area around the Dead Sea\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThere is more to do than just relaxing in the spas and floating in the Dead Sea. If you are travelling south from Jerusalem, complement your desert experience by stopping at kibbutz Ein Gedi, a natural oasis on the slopes of the Judean desert, and take a hike through a nature reserve where you will see wildlife like the ibex (a kind of mountain goat) and enjoy the waterfalls and pools cascading on the rock formation. Ein Gedi also offers hotel accommodations and spas which houses hot sulphur pools and have different types of healing and therapeutic massages too. Continue south from here to Masada, a national landmark with a strong historical connection, located at the top of a massive mountain that the adventure seeker can hike, or it can be reached comfortably by cable car.\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tMOUNT KARKOM\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tIn the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFeaturing a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai \u2013 mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tWalking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.\n\t\t\t\t</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/next-level/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\t\tAdding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tTo visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.\n\t\t\t\t</p>          \n\n\n           "};}},{id:"Natures_Glory",bgImage:"/posts/bank/natures-glory/1.jpg",mobBgImage:"/posts/bank/natures-glory/M.jpg",title:"NATURE'S GLORY",smltitle:"",isVid:true,vidId:"M627s8TdaB8",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n\t\t\t    <p>\n\t\t\t\t\tGet high on life in the lowest place on earth\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe Dead Sea, officially the lowest place on earth (428m below sea level) and one the world\u2019s natural wonders, is an enthralling and evocative combination of natural splendor, compelling ancient history, and modern luxuries.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tFloat on the waters, take a mud bath or go exploring - with 330 sunny days a year, the Dead Sea area is filled with superb attractions including natural healing spas, magnificent hiking trails, gourmet and fast food restaurants and adrenaline-charged attractions.\n\t\t\t\t</p>\n\t\t\t\t<h3>\n\t\t\t\t\tNEW BOARDWALK AT THE DEAD SEA\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tJust in time for the Passover and Easter holidays, a new, stone 4k boardwalk and free, accessible public beaches with full facilities have opened in the hotels area of the Dead Sea. The promenade will eventually extend another ten kilometers, to include a total of 16 public beaches, connecting Ein Bokek and Hamei Zohar, along the southern part of the Dead Sea. This is part of a major new leisure and hotel complex that is planned for the region.\n\t\t\t\t</p>\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/natures-glory/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<p>\n\t\t\t\t\tVisitors to the Dead Sea - the lowest place on earth and the world\u2019s largest natural spa known for its unique wellness properties since Biblical times \u2013 can now enjoy full access to wide, sandy beaches, walking, jogging, cycling or even taking a Segway along the entire length of the new boardwalk. The new beaches are all free to the public, with facilities that include beach chairs, showers, canopies, sports equipment, children\u2019s playgrounds and more.\n\t\t\t\t</p>\n\t\t\t\t<p>\n\t\t\t\t\tThe beaches are accessible for the disabled, with special wheelchairs and trails that can take visitors right into the waters of the Dead Sea. Special illumination allows tourists and visitors to walk the boardwalk at night, while at the same time enjoying the very special atmosphere at the Dead Sea.\n\t\t\t\t</p>\n                               \n\n\n           "};}},{id:"Natural_Spa",bgImage:"/posts/bank/deadsea1/1.jpg",mobBgImage:"/posts/bank/deadsea1/M.jpg",title:"MER MORTE",smltitle:"",isVid:true,vidId:"8p4qfkneH1c",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t<h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Avoir la sensation d'\xEAtre sur le toit du monde, au point le plus bas de la surface du globe</h2>\n\t\t\t\t    <p><strong>La relaxation \xE0 son summum</strong></p>\n\t\t\t\t\t<p><strong>La mer Morte, qui est officiellement le point le plus bas sur Terre (428 m\xE8tres sous le niveau de la mer), a figur\xE9 dans la s\xE9lection finale des 7 merveilles naturelles du monde. Elle offre une combinaison passionnante et fascinante de splendeur naturelle, d'histoire ancienne et de luxe moderne.</strong></p>\n\t\t\t\t\t<p>Des pouvoirs curatifs des eaux bleues cobalt de la mer Morte \xE0 la beaut\xE9 spectaculaire des paysages environnants, en passant par les innombrables sites int\xE9ressants que rec\xE8le cette r\xE9gion, la mer Morte est un havre de tranquillit\xE9, de sant\xE9 et d'inspiration pour le corps et l'esprit.</p>\n\t\t\t\t\t<p>Flottez sur l'eau, prenez un bain de boue ou partez en balade. Avec 330 jours d'ensoleillement par an, ce ne sont pas les divertissements qui manquent dans la r\xE9gion de la mer Morte, avec ses eaux thermales naturelles, ses magnifiques chemins de randonn\xE9e, ses \xE9tablissements gastronomiques ou de restauration rapide, et ses attractions qui font monter l'adr\xE9naline. Si vous voulez vous faire plaisir, vous trouverez aussi des h\xF4tels et centres de thalassoth\xE9rapie haut de gamme sur les 75 kilom\xE8tres de c\xF4tes bord\xE9es de splendides plages.</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/natural-spa/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t<p><strong>Les plages magiques de la mer Morte</strong></p>\n\t\t\t\t\t<p>Les plages de la mer Morte sont uniques au monde. Sur des kilom\xE8tres, vous trouverez des plages somptueuses et parfaitement entretenues o\xF9 vous pourrez prendre le soleil et passer des vacances de r\xEAve. Installez-vous sur le sable et embrassez du regard le splendide panorama des montagnes entourant la mer. Les eaux chaudes de la Mer morte sont toujours calmes et vous permettent de vous relaxer d\xE8s la premi\xE8re minute o\xF9 vous y p\xE9n\xE9trez.</p>\n\t\t\t\t\t<p>Sur les rives sud du point le plus bas de la Terre, plusieurs h\xF4tels permettent de voir le soleil se lever et couvrir de couleurs iris\xE9es les petites \xE9tendues d'eau parsem\xE9es de concr\xE9tions de sel.&nbsp; Pour ne rien oublier, enduisez-vous de boue noire et soyeuse et laissez votre peau absorber les min\xE9raux bienfaisants qu'elle contient. La boue de la mer Noire est connue pour ses vertus bienfaisantes pour la peau et le corps. Vous vous sentirez mieux gr\xE2ce \xE0 une peau plus jeune, tant \xE0 l'aspect qu'au toucher. Laissez-vous bichonner et l\xE2chez-vous en vous couvrant de boue de la mer Morte, c'est bon pour la sant\xE9&nbsp;!</p>\n\n\t\t\t\t\t<p><strong>D\xE9couvrez le d\xE9sert qui entoure la mer Morte</strong></p>\n\t\t\t\t\t<p>Se d\xE9tendre au spa et flotter sur la mer Morte ne sont pas les seules activit\xE9s offertes par la mer Morte.&nbsp; Si vous allez vers le sud en partant de J\xE9rusalem, arr\xEAtez-vous dans le d\xE9sert au kibboutz d'Ein Gedi, une oasis naturelle situ\xE9e sur les flancs du d\xE9sert de Jud\xE9e. Faites une randonn\xE9e dans la r\xE9serve naturelle et partez \xE0 la rencontre d'esp\xE8ces sauvages, notamment des bouquetins (ch\xE8vres des montagnes), et profitez des bassins et des cascades qui surgissent entre les formations rocheuses.&nbsp; \xC0 Ein Gedi, vous trouverez \xE9galement des h\xF4tels et centres de thalassoth\xE9rapie proposant des sources chaudes sulfureuses aux diverses propri\xE9t\xE9s gu\xE9rissantes, ainsi que des massages th\xE9rapeutiques.&nbsp; Partez encore plus au sud, \xE0 Massada, un site historique national situ\xE9 en haut d'une haute montagne que les amateurs de sensations fortes pourront escalader, tandis que les autres profiteront du confort d'un t\xE9l\xE9ph\xE9rique.</p>\n\n                               \n\n\n           "};}},{id:"Natural_Phenomena",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"NATURAL PHENOMENA",smltitle:"",isVid:true,vidId:"8p4qfkneH1c",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n                        <p>\n\t\t\t\t\t\t\tThe Dead Sea is one of the most unique natural phenomena on the planet. A crevice in the earth\u2019s crust that is part of the Great Rift Valley allows the waters of the River Jordan to flow south into a lozenge-shaped lake at the lowest point on our planet. With no outlet, the rays of the blazing sun evaporates the Jordan water to a point where its mineral content is highly concentrated; and it is this density of minerals and salt that makes it impossible to sink in the sea: bathers float effortlessly on the water\u2019s surface. Because the sun has to travel an additional 1,200 feet to reach the shore, ultra-violet rays are filtered out and oxygen is enriched to a point where even the fairest skins tan but do not burn.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/natural-phenomena/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t    </div>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tThis is why a visit to the Dead Sea enables sufferers of rheumatic diseases to breathe better, and why victims of psoriasis and other serious skin ailments receive temporary cures by bathing in the Dead Sea, slathering themselves with Dead Sea mud and baking in the non-burning sun.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\tThe Dead Sea is lined with spas, bathing beaches and spa hotels.\n\t\t\t\t\t\t</p>          \n\n\n           "};}},{id:"Masada",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"MASADA",smltitle:"",isVid:true,vidId:"XxWa_MNm5x8",ctg:"deadsea",html:function html(){return{__html:"\n\n\t\t\t\t\t\n\t\t\t\t\t\n                    <p>        \t\n\t\t\t\tNext to the Dead Sea is a site that, unlike the rest of the landscape, appears to be part of the Rift Valley cliff but is in fact an oval-shaped flat-topped mesa \u2013 a mountain completely surrounded by a virtually sheer drop. In the days before helicopters and drones, this was about as secure a site as could be found for King Herod to build himself a palace fortress to which he could retire in the case of emergency. (And, as it was adjacent to the Dead Sea it was convenient for a monarch who historians tell us had a \u201Cchronic skin ailment\u201D - possibly psoriasis.) The splendor of Masada was epic. It was also a marvel of engineering that used artificial water courses to channel the desert\u2019s rare rainfall into giant cisterns where, despite the 120\xB0-Fahrenheit heat, they could make and store ice.\n\t\t\t</p>\t\t\t\n\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/masada/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t\t\t<p>\n\t\t\t\tAfter Herod\u2019s death the site was all-but abandoned\u2026until the year 73. After the Romans destroyed Jerusalem in 70 and expelled Jews from their holy city, a group of Jewish refugees made their way to the summit of Masada and converted the once grand palace into their home. Having no interest in the palace\u2019s grandeur and considering themselves zealots, the refugees built a synagogue, created a mikveh, planted crops and tended goats. The Romans, however, could not tolerate their defiance and went on to besiege the mountain for three years, condemning thousands of legionnaires to camp in the extreme heat in a quest to starve the mountaintop inhabitants into surrender. (The outlines of the Roman encampments are clearly visible to this day.) Thousands of Jewish slaves were forced to build a giant ramp to the summit and after the months it took to complete the  construction, the mountaintop zealots -- realizing that the next day would bring Roman soldiers into their hideout -- determined to commit mass suicide rather than have their their wives, children and themselves murdered or enslaved. When the Romans finally battered their way onto the mountaintop they met no resistance and discovered 960 corpses. Two women who had hidden themselves from the mass suicide shared details of the events with the \u201Cconquerors\u201D and Jewish Roman historian, Josephus, told the story of Masada in his book \u201CThe Jewish Wars.\u201D The pledge by the zealots\u2019 leader, Elazar Ben Yair on the last night of freedom has entered immortality: \u201CSince we long ago resolved never to be servants to the Romans, nor to any other than to God Himself, Who alone is the true and just Lord of mankind, the time is now come that obliges us to make that resolution true in practice...We were the very first that revolted, and we are the last to fight against them; and I cannot but esteem it as a favor that God has granted us, that it is still in our power to die bravely, and in a state of freedom.\u201D The Byzantines built a church atop Masada in the 4th-century, but it and the mountain went on to be abandoned for centuries.\n\t\t\t</p>\n\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/masada/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t\t\t<p>\n\t\t\t\tIn 1964. Israel\u2019s Professor Yigal Yadin lead a two-year international excavation to discover Masada\u2019s secrets. Their hundreds of discoveries support Josephus\u2019 history, with the archeologists even finding the clay tokens on which the zealots had carved names and used as lots to decide who would \u201Ceuthanize\u201D their families and themselves first\u2026and last.\n\t\t\t</p>\n\t\t\t<p>\n\t\t\t\tThe story of what occurred two millennia ago atop Masada has become a symbol of Israelis\u2019 commitment never to allow \u201CMasada to fall again\u201D and, fifty years after the excavation, Masada is, after Jerusalem, the most visited site in Israel. Access to the summit on foot is possible up the traditional snake path used by Herod, and up the Roman ramp.  But the majority of the millions of tourists who visit Masada are whisked from the Masada Museum and Visitors Center to the summit in giant cable cars that operate daily with the exception of Yom Kippur. Every June, the base of Masada becomes the site of giant Opera Festival and spectacle that uses the floodlit mountain as a backdrop.\n\t\t\t</p>          \n\n\n           "};}},{id:"Tel_Aviv",bgImage:"/posts/bank/telaviv-p/1.jpg",mobBgImage:"/posts/bank/telaviv-p/M.jpg",title:"TEL-AVIV",smltitle:"",isVid:true,vidId:"I9a4BFWO_6w",ctg:"telaviv",html:function html(){return{__html:"\n\t\t\t                  <br/>\n\t\t\t                  <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">\u201CL'UNE DES 10 PREMI\xC8RES STATIONS BALN\xC9AIRES AU MONDE\u201D</h2>\n\n\t\t\t                   \n\n\t\t\t\t\t\t\t    <p>Salu\xE9e par le New York Times comme \xAB&nbsp;La capitale la plus cool de la M\xE9diterran\xE9e&nbsp;\xBB&nbsp; et comme l'une des \xAB&nbsp;dix villes les plus dynamiques au monde&nbsp;\xBB par Lonely Planet, Tel Aviv est sans aucun doute l'endroit \xE0 ne pas manquer en M\xE9diterran\xE9e.</p>\n\t\t\t\t\t\t\t\t<p>D\xE9sign\xE9e \xAB&nbsp;Capitale la plus cool de la M\xE9diterran\xE9e&nbsp;\xBB par le New York Times, <strong>Tel Aviv</strong> est une ville cosmopolite moderne et dynamique. Sa sc\xE8ne artistique anim\xE9e, son architecture Bauhaus distingu\xE9e par l'UNESCO, sa cuisine prim\xE9e, sa vie nocturne de classe mondiale, son atmosph\xE8re d\xE9contract\xE9e et ses magnifiques plages font de la ville l'une des plus belles destinations au monde.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p>Mais, m\xEAme dans cette ville qui a tout pour elle, votre visite doit forc\xE9ment commencer par <strong>la plage.</strong></p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/telaviv-p/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p><strong>D\xE9couvrez le c\u0153ur d'une ville bouillonnante </strong></p>\n\t\t\t\t\t\t\t\t<p><strong>Quoi. </strong>Le c\u0153ur de cette ville d\xE9sign\xE9e par <em>National Geographic</em> comme la \"Miami beach de la M\xE9diterran\xE9e\" et int\xE9gr\xE9e \xE0 sa liste des 10 premi\xE8res villes baln\xE9aires au monde, c'est son littoral.</p>\n\t\t\t\t\t\t\t\t<p><strong>Pourquoi.</strong> Des plages de sable fin, des eaux chaudes, de nombreuses possibilit\xE9s de pratiquer les sports aquatiques et un temps magnifique, faut-il en dire plus ? Le littoral de Tel Aviv comprend 13 plages uniques dont chacune apporte une exp\xE9rience et un panorama diff\xE9rent. Plage anim\xE9e et tendance ou plage retir\xE9e et reposante, elles forment une mosa\xEFque riche et color\xE9e dans une ville passionnante et diverse.</p>\n\t\t\t\t\t\t\t\t<p><strong>O\xF9.</strong> Les plages de Tel Aviv s'\xE9tendent \xE0 l'ouest de la ville et ne sont jamais tr\xE8s loin.&nbsp; Inutile de r\xE9sister \xE0 la tentation. Traversez la rue, enlevez vos chaussures et prenez du bon temps.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p><strong>Choisissez vos activit\xE9s de plage </strong></p>\n\t\t\t\t\t\t\t\t<p><strong>Bougez. </strong>La plage et les sports aquatiques sont tr\xE8s populaires \xE0 Tel Aviv. Le surf, la voile, l'aviron, la nage, le paddle, la plong\xE9e, le volley-ball \u2013 la liste des possibilit\xE9s n'en finit pas.</p>\n\t\t\t\t\t\t\t\t<p>Choisissez votre activit\xE9 pr\xE9f\xE9r\xE9e et amusez-vous. Ensuite, lorsque vous entendrez sur la plage le son du <em>Matkot</em>, joignez-vous \xE0 la foule pratiquant ce jeu de raquettes immens\xE9ment populaire en Isra\xEBl. Il n'y a ni gagnant ni perdant, mais ce n'en est pas moins amusant... et tr\xE8s addictif.</p>\n\t\t\t\t\t\t\t\t<p><strong>Engagez-vous</strong> pour la r\xE9gate SAIL TLV qui se d\xE9roule au printemps et \xE0 laquelle participent des bateaux \xE0 voile et \xE0 moteur et des yachts venus du monde entier. Profitez des activit\xE9s sportives et d'une communaut\xE9 particuli\xE8rement accueillante.</p>\n\t\t\t\t\t\t\t\t<p>Vous en voulez encore plus ? Joignez-vous aux habitants et faites du v\xE9lo, de la marche ou du jogging sur la promenade.</p>\n\t\t\t\t\t\t\t\t<p><strong>Faites des rencontres. </strong>Construisez des ch\xE2teaux de sable avec votre famille, partez vous promener avec votre chien et m\xEAlez-vous \xE0 la foule amicale et h\xE9t\xE9roclite.</p>\n\t\t\t\t\t\t\t\t<p><strong>Relaxez-vous. </strong>&nbsp;Vous voulez prendre votre temps et vous relaxer ? Pas de probl\xE8me ! D\xE9nichez-vous un coin tranquille sur l'une des plages les moins fr\xE9quent\xE9es, regardez (ou rejoignez) les groupes de percussions et installez-vous dans l'un des restaurants qui bordent la c\xF4te. L'apr\xE8s-midi, rapprochez-vous de l'eau, prenez une chaise, asseyez-vous et admirez le magnifique coucher de soleil de Tel Aviv. Il n'y a rien de plus beau.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\n\n           "};}},{id:"Simply_Delicious",bgImage:"/posts/bank/simply-delicious/1.jpg",mobBgImage:"/posts/bank/simply-delicious/M.jpg",ctg:"culinarytelaviv",isVid:true,// vidId: "n4kCnPXEX7g",
vidId:"JQD9JpMaw9g",title:"Tel Aviv – Tout simplement délicieux",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h2>Il n'est pas \xE9tonnant que Tel-Aviv figure parmi les \xAB destinations culinaires exceptionnelles \xBB recommand\xE9es par \xAB Saveur Magazine \xBB</h2>\n\n\t\t\t\t<p>Tel Aviv, connue pour ses plages de sable fin, sa vie tr\xE9pidante et ses nuits endiabl\xE9es regorge aussi de restaurants et bars uniques qui font de cette station baln\xE9aire une destination incontournable pour les gourmets. \xC0 Tel Aviv, la culture gastronomique constitue v\xE9ritablement le c\u0153ur et l'\xE2me de la ville, et m\xEAme si l\u2019on y trouve de nombreux restaurants haut de gamme, c\u2019est la cuisine de rue \xE0 base de produits frais locaux qui a v\xE9ritablement pris d'assaut la ville.</p>\n\t\t\t\t\n\t\t\t\t<h3>Quand la cuisine traditionnelle sur le pouce prend une nouvelle dimension</h3>\n\t\t\t\t\n\t\t\t\t<p>Oubliez l'\xE9poque o\xF9 la cuisine sur le pouce de Tel Aviv se limitait essentiellement \xE0 des fallafels frits et croustillants, fourr\xE9s dans un pain pita fra\xEEchement cuit au four. Aujourd'hui, la cuisine de rue de Tel Aviv est un vrai spectacle, des sp\xE9cialit\xE9s et plats raffin\xE9s \xE9tant servis aux promeneurs \xE0 tous les coins de rue. Fl\xE2nez le long des rues Ibn Gvirol, Ben Yehuda ou Carmel et faites votre choix parmi les innombrables mets haut de gamme constitu\xE9s de viande, poisson, l\xE9gumes pr\xE9par\xE9s et sauces, tous artistiquement pr\xE9sent\xE9s dans des pitas, entre des tranches de pain ou sous diverses autres formes. Grignotez les succulentes sp\xE9cialit\xE9s inspir\xE9es des quatre coins du monde, un sabich agr\xE9ment\xE9 de tahini servi dans un pain laffa, de succulents sandwichs de hareng, et bien plus encore. Vous poursuivrez votre balade en ville en initiant votre palais \xE0 la culture isra\xE9lienne avec un agr\xE9able sentiment de sati\xE9t\xE9.</p>\n\t\t\t\t\n\t\t\t\t<h3>La m\xEAme qualit\xE9 qu'au restaurant mais sur le pouce</h3>\n\t\t\t\t\n\t\t\t\t<p>Que demander de plus dans une ville anim\xE9e o\xF9 se pressent hommes d'affaires et touristes que de pouvoir d\xE9guster facilement en chemin des plats savoureux et \xE0 la derni\xE8re mode ? Les points de restauration rapide originaux, qui se multiplient aux coins des rues de la ville, servent des plats comme du pain ciabatta garni d'une entrec\xF4te et des arepas de ma\xEFs. Il n'est donc pas \xE9tonnant que Tel-Aviv figure parmi les \xAB destinations culinaires exceptionnelles \xBB recommand\xE9es par Saveur Magazine.</p>\n\t\t\t\t\n\t\t\t\t<p>Le paradis des gourmets: avec le spectacle offert par sa cuisine sur le pouce, qui propose un choix illimit\xE9 de mets d\xE9licieux \xE0 chaque coin de rue, Tel Aviv est la destination culinaire par excellence et un arr\xEAt incontournable lors de votre prochain voyage en Isra\xEBl.</p>\n\n\n                 <h3>\xC0 tel aviv, prenez le temps de go\xFBter \xE0 la cuisine le go\xFBt et la ville de tel aviv.</h3>\n\n                 <p><strong>Tel Aviv</strong>, la ville qui ne dort jamais, situ\xE9e sur les rives de la M\xE9diterran\xE9e, est une des destinations touristiques les plus pris\xE9es au monde. Anim\xE9e, dynamique et festive, la seconde ville d'Isra\xEBl a tout pour elle, y compris une sc\xE8ne culinaire cr\xE9ative, tendance, originale et plusieurs fois prim\xE9e, qui satisfait tous les go\xFBts et tous les budgets. Depuis les restaurants gastronomiques modernes et sophistiqu\xE9s jusqu'aux \xE9tablissements locaux simples et traditionnels, en passant par toutes les d\xE9clinaisons situ\xE9es entre les deux. La ville a m\xEAme \xE9t\xE9 nomm\xE9e parmi les principales destinations v\xE9ganes. Gourmands des quatre coins du monde, Tel Aviv est l'endroit qu'il vous faut.</p>\n\t\t\t\t\t<p><strong>En balade</strong>. Les Telaviviens adorent \xEAtre dehors. Il se passe toujours quelque chose de nouveau et de passionnant en ville, y compris en mati\xE8re de cuisine. Vous voulez explorer la sc\xE8ne culinaire de Tel Aviv&nbsp;? Commencez tout simplement par sortir dans la rue. Allez dans une des principales rues anim\xE9es de la ville, comme <strong>Dizengoff</strong> et <strong>Ibn Gabirol</strong> et allez de d\xE9couverte en d\xE9couverte. Les meilleurs caf\xE9s, restaurants, bars, traiteurs et vendeur de rue n'attendent que vous.</p>\n\t\t\t\t\t<p><strong>Go\xFBter les d\xE9lices des march\xE9s.</strong> Visitez le <strong>march\xE9 Carmel</strong>, le plus grand et le plus central des march\xE9s alimentaires de la ville, immens\xE9ment populaire. Ensuite, direction le <strong>march\xE9 Levinsky</strong>, au sud de la ville, le paradis des gourmets et des \xE9pices. Un conseil&nbsp;: prenez votre temps. Ces rues cachent certains des plus grands tr\xE9sors culinaires de la ville.</p>\n\n\t\t\t\t\t<p><strong>Une cuisine locale et internationale.</strong> Avec ses immigrants venus de plus de 120 pays, il n'est pas \xE9tonnant que Tel Aviv soit un v\xE9ritable creuset (litt\xE9ralement). Si pour vous nourriture ethnique signifie alimentation d'origine japonaise, tha\xEF ou indienne, ici le terme a une signification bien plus vaste. Cuisine turque, marocaine, perse, y\xE9m\xE9nite, \xE9thiopienne, g\xE9orgienne, et la liste ne fait que commencer...</p>\n\t\t\t\t\t<p>Tel Aviv est \xE9galement extr\xEAmement fi\xE8re de sa cuisine locale, qui s'inspire de ces nombreuses sp\xE9cialit\xE9s internationales qui apportent une touche originale aux mets traditionnels. Le r\xE9sultat est d\xE9licieux et extr\xEAmement original. Visitez le <strong>march\xE9 paysan du port de Tel Aviv</strong> ainsi que le <strong>march\xE9 international Sarona</strong>, pour go\xFBter \xE0 certains des meilleurs produits que la ville vous propose.</p>\n\t\t\t\t\t<p><strong>Une cuisine sophistiqu\xE9e, raffin\xE9e et innovante. </strong>Ce n'est un secret pour personne, un grand nombre des meilleurs restaurants isra\xE9liens se trouvent \xE0 Tel Aviv. Des chefs cr\xE9atifs et ayant le go\xFBt du risque, qui n'h\xE9sitent pas \xE0 se lancer dans des exp\xE9riences \xE0 partir de mets du Moyen-Orient, d'Asie de l'Est et d'Europe, ont transform\xE9 Tel Aviv en un p\xF4le gastronomique connu dans tout le pays et dans le monde entier. Intelligente et esth\xE9tique, cette cuisine est \xE9labor\xE9e \xE0 partir des produits locaux les plus frais - une exp\xE9rience culinaire que vous n'\xEAtes pas pr\xE8s d'oublier.</p>\n\t\t\t\t\t<p><strong>Une cuisine v\xE9g\xE9tarienne et v\xE9gane. </strong>Contrairement \xE0 de nombreuses villes du monde, \xE0 Tel Aviv on peut tr\xE8s facilement passer une semaine (ou plus) sans manger de viande ou de laitage. Vous trouverez facilement de la nourriture de qualit\xE9, ethnique, raffin\xE9e et pr\xE9par\xE9e rapidement. Nombreux sont les boulangeries, traiteurs, restaurants totalement v\xE9g\xE9tariens ou \xE9tablissements classiques \xE0 proposer de nombreux plats v\xE9gans et v\xE9g\xE9tariens. Vous pourrez d\xE9guster une cuisine savoureuse et originale, \xE9labor\xE9e \xE0 l'aide produits frais.</p>\n\t\t\t\t\t<p>Ce qui est apparu il y a quelques ann\xE9es comme une mode parmi tant d'autres s'est impos\xE9 comme l\u2019une des principales caract\xE9ristiques de la sc\xE8ne culinaire de Tel Aviv. Celle-ci fait bon usage de ses diverses influences gastronomiques, de l'impressionnante vari\xE9t\xE9 des l\xE9gumes propos\xE9s sur les march\xE9s et de l'int\xE9r\xEAt de la population pour la protection de l'environnement.</p>\n\t\t\t\t\t\t\t\t\t\n         "};}},{id:"Nonstop_Excitement",bgImage:"/posts/bank/35/1.jpg",mobBgImage:"/posts/bank/35/M.jpg",title:"EFFERVESCENCE NON-STOP",vidId:"88OV6xU0vPI",isVid:true,smltitle:"",ctg:"telaviv",html:function html(){return{__html:"\n                    <h2>Belle, pittoresque et palpitante \u2013 Incroyable Tel Aviv</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\tBienvenue \xE0 la ville qui irradie la vitalit\xE9 24 heures sur 24. Une cit\xE9 vibrante, joyeuse, qui vous accueille \xE0 bras ouverts. Qu'est-ce qui s\xE9duit autant les visiteurs dans cette ville et les fait revenir encore et encore ? Tel-Aviv est connue comme la ville isra\xE9lienne qui ne dort jamais, et cela la d\xE9crit parfaitement. Les caf\xE9s sont bond\xE9s 24 heures sur 24. Sa vie nocturne sans \xE9gale commence au coucher du soleil et finit \xE0 l'aube.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\t\t\t\t\tDe surcro\xEEt son climat, merveilleux tout au long de l'ann\xE9e, vous permet de profiter de la plage \xE0 n'importe quelle saison, de prendre un v\xE9lo et p\xE9daler \xE0 travers le Parc HaYarkon, visiter les deux ports de la ville ou tout simplement fl\xE2ner dans les rues de la premi\xE8re ville isra\xE9lienne qui combine les b\xE2timents historiques \xE0 des projets neufs et modernes. Et - cerise sur le g\xE2teau - la ville offre une vaste vari\xE9t\xE9 d'\xE9v\xE8nements culturels et de divertissements pour tous les \xE2ges.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\tD\xE9couvrez pourquoi le National Geographic a qualifi\xE9 Tel-Aviv de l'une des dix meilleures stations baln\xE9aires monde. Pourquoi elle a \xE9t\xE9 baptis\xE9e Destination Culinaire hors pair par le magazine Sauveur et class\xE9e comme exceptionnelle dans la cat\xE9gorie Meilleurs march\xE9s et Boutiques. De surcro\xEEt la Brasserie Pastel a \xE9t\xE9 d\xE9clar\xE9 Plus beau restaurant de 2014 par l\u2019International Space Design Awards. Etes-vous un amateur de caf\xE9 ? Le Huffington Post classe cette ville de bord de mer parmi les meilleures destinations pour les amateurs de caf\xE9. Impressionnant, n'est-il pas ? Mais ce n'est pas fini...\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\t\t\t\t\tTel-Aviv a eu le dessus sur 250 autres villes et obtenu le World Smart Cities Award pour 2004, gr\xE2ce \xE0 l'usage qu'elle fait des nouvelles technologies au b\xE9n\xE9fice de ses habitants. Selon le Lonely Planet, Tel-Aviv arrive en bonne place sur la liste des villes pour ses f\xEAtes.. And Tel-Aviv est \xE9galement fi\xE8re d'\xEAtre consid\xE9r\xE9e la meilleure ville pour gays par Gay Cities et la compagnie a\xE9rienne American Airlines.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\tVous projetez venir vous amuser \xE0 Tel-Aviv? Voici quelques recommandations qui vous aideront \xE0 r\xE9ussir vos vacances.\n\t\t\t\t\t</p>\n\t\t\t\t\t<br>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/5.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\tLES PLAGES\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tLa vie est une plage. Le littoral de Tel-Aviv, au bord de la M\xE9diterran\xE9e, compte 13 plages s'\xE9talant sur 14 km. Celles-ci, parfaites pour se baigner, faire la f\xEAte ou fl\xE2ner, attirent des milliers de visiteurs et vacanciers locaux et \xE9trangers. La saison des plages dure de mai \xE0 octobre mais m\xEAme en hiver vous pouvez profiter du soleil \xE0 Tel-Aviv. Les restaurants, clubs et nombreux lieux de divertissement de la promenade sont adapt\xE9s tous les visiteurs. Vous pouvez aussi participer \xE0 de nombreux sports nautiques.\n\t\t\t\t\t</P>\n\n\t\t\t\t\t<h3>LES PORTS</h3>\n\t\t\t\t\t<p>Tel-Aviv abrite deux vieux ports. Quand vous les visiterez vous serez \xE9tonn\xE9s de constater \xE0 quel point ils associent pass\xE9 et pr\xE9sent, en faisant la f\xEAte dans l'un des nombreux clubs, restaurants et caf\xE9s qui surplombent l'azur de la M\xE9diterran\xE9e.</p>\n\n\t\t\t\t\t<h3>LE PORT DE TEL-AVIV :</h3>\n\t\t\t\t\t<p>construit en 1938, ce port est devenu un lieu de divertissement ouvert \xE0 tout public. Ce site de 14 000 m\xB2 avec ses planches caract\xE9ristiques en teck, accueille des bars, night clubs, des boutiques, restaurants et caf\xE9s. C'est un must pour tous ceux qui souhaitent faire l'exp\xE9rience d'une cuisine vari\xE9e et d\xE9licieuse, tout en faisant du shopping et en se divertissant. Et si cela ne suffisait pas, le coucher du soleil y est absolument incroyable. Alors venez et profitez de la brise rafra\xEEchissante de la mer. Au coucher du soleil le port se transforme en l'un des lieux de divertissement les plus pris\xE9s de la ville et regorge de f\xEAtards.</p>\n\n\t\t\t\t\t<h3>LE PORT DE JAFFA:</h3>\n\t\t\t\t\t<p>Consid\xE9r\xE9 comme l'un des plus anciens au monde, le port de Jaffa a desservi p\xEAcheurs, marins, crois\xE9s, marchands, conqu\xE9rants et immigrants pendant des milliers d'ann\xE9es. De nos jours, le port continue \xE0 servir comme port de p\xEAche mais a aussi \xE9t\xE9 r\xE9nov\xE9 et offre aujourd'hui des activit\xE9s ludiques et culturelles, des possibilit\xE9s de shopping et des attractions touristiques, tout en pr\xE9servant son caract\xE8re culturel et historique unique.</p>\n\t\t\t\t\t\n\n\t\t\t\t\t<br>\n\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/6.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\n\t\t\t\t\t<h3>VIE NOCTURNE</h3>\n\t\t\t\t\t<p>Les noctambules pourront faire la f\xEAte dans les caf\xE9s et night clubs de la ville et exp\xE9rimenter la vie nocturne non-stop que la ville a \xE0 offrir. Une nuit typique \xE0 Tel-Aviv commence \xE0 11h du soir et dans certains cas se prolonge jusqu'\xE0 l'aube. Voici quelques endroits \xE0 la mode o\xF9 vous pouvez danser toute la nuit</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>HAOMAN 17</h3>\n\t\t\t\t\t<p>Haoman 17 - C'est le m\xE9ga-club le plus connu et le plus grand. Il accueille quelques uns des meilleurs DJs de la plan\xE8te. Adresse: 88 rue Abrabanel. T\xE9l: 03-6813636</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>DIZINGOFF CLUB</h3>\n\t\t\t\t\t<p>Trois bars, une piste de dance, salons, des salles VIP, etc. Ce club attire un public branch\xE9. On peut danser au son de la musique rock, disco, funk ou de tout ce que l'on joue d'autre. Adresse : 9 rue Dizengoff T\xE9l. : 052-3285103</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>DREAM EXHIBITION</h3>\n\t\t\t\t\t<p>l'un des endroits les plus populaires de Tel-Aviv. Son chic contemporain et son syst\xE8me son sans \xE9gal \xE0 360\xB0 vous fait r\xEAver. Adresse : 30 Bd Ibn Gvirol T\xE9l.: 054-9500001</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>KULEI ALMA</h3>\n\t\t\t\t\t<p>L'un des lieux alternatifs les plus chauds de la ville. Les murs sont couverts d'art de rue et art vid\xE9o. On y expose les \u0153uvres d'artistes locaux, et il dispose d'une cour agr\xE9able, o\xF9 on peut boire, grignoter et faire connaissance. Adresse : 30 rue Miqv\xE9 Isra\xEBl T\xE9l.: 03-6565155</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>THE CAT AND DOG</h3>\n\t\t\t\t\t<p>Club underground situ\xE9 dans la zone de Carlebach, On y \xE9coute de la musique \xE9clectique, les boissons coulent \xE0 flot gratuitement et la piste de dance ne d\xE9semplit pas. C'est sans doute l'un des plus chauds lieux de la vie nocturne de Tel-Aviv. Adresse : 23 rue Carlebach T\xE9l. : 072-32819233</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>THE BLOCK</h3>\n\t\t\t\t\t<p>Il a gagn\xE9 de nombreuses r\xE9compenses, y compris celle du meilleur night-club de l'ann\xE9e, o\xF9 sont organis\xE9es les meilleures f\xEAtes de l'ann\xE9e, et la meilleure f\xEAte locale de l'ann\xE9e, not\xE9 par la BBC comme ayant l'un de cinq meilleurs syst\xE8mes son du monde. Vaut vraiment le d\xE9tour. Adresse : 157 rue Salam\xE9 T\xE9l. : 03-5378002</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>KTOVET</h3>\n\t\t\t\t\t<p>Son nom signifie \xAB adresse \xBB en h\xE9breu, et il est consid\xE9r\xE9 par beaucoup comme L'ENDROIT o\xF9 il faut \xEAtre vu. Alors mettez vos chaussures et en piste. Des DJs internationaux vous y attendent. Adresse : 1 rue Miqv\xE9 Isra\xEBl T\xE9l.: 052-6779503</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>BIGGY Z BAR</h3>\n\t\t\t\t\t<p>Entrez dans ce bar. Vous vous retrouverez dans la Big Easy - New Orleans. Avec sa formule unique de boissons \xE0 volont\xE9, faites la f\xEAte! Alors buvez votre mint Julep et soyez heureux... Adresse : 18 rue Bograshov T\xE9l. : 03-5365982</p>\n\t\t\t\t\t\n\t\t\t\t\t<p>Et si vous cherchez un bar gay :</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>APOLO SEXY BAR</h3>\n\t\t\t\t\t<p>Seul bar gay de Tel-Aviv exclusivement r\xE9serv\xE9 aux hommes, l'Apollo s'inspire des meilleurs clubs d'Europe. Adresse : 46 rue Allenby T\xE9l.: 03-7741106</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>AMAZONA</h3>\n\t\t\t\t\t<p>Le top des bars gay de Tel-Aviv, excellente ambiance. Adresse : 23 rue Lilienblum T\xE9l.: 050-4810488</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>BARVAZ</h3>\n\t\t\t\t\t<p>Bar gay populaire avec de grands DJs chaque nuit. Adresse : 10 rue Hamehoga</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>MARCH\xC9S :</h3>\n\t\t\t\t\t<h3>MARCH\xC9 DU CARMEL :</h3>\n\t\t\t\t\t<p>Le plus c\xE9l\xE8bre des march\xE9s de la ville qui, en plus de son paysage humain haut en couleur, offre un nombre infini de mets fins, \xE9pices, aliments et autres options tentantes et enchanteresses. Ce march\xE9 est bond\xE9 en toute saison et en plus de ses clients fid\xE8les, il est fr\xE9quent\xE9 par les touristes qui profitent au maximum de cette exp\xE9rience de shopping moyen-oriental unique.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>MARCH\xC9 L\xC9VINSKY :</h3>\n\t\t\t\t\t<p>Un m\xE9lange de boulangeries, boutiques de sp\xE9cialit\xE9s, restaurants et \xE9choppes, qui proposent des \xE9pices, noix, fruit secs et aliments exotiques. Vous pouvez vous inscrire \xE0 une visite gastronomique du march\xE9 et \xE9couter les histoires, l\xE9gendes et secrets de l'ancien et du nouveau march\xE9. Le caract\xE8re unique de L\xE9vinsky en fait une attraction pour les touristes autant que pour les locaux.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>MARCH\xC9 AUX PUCES :</h3>\n\t\t\t\t\t<p>Situ\xE9 \xE0 Jaffa, le c\xE9l\xE8bre march\xE9 aux puces propose de la vaisselle, des fripes, et des chaussures ainsi que des objets de brocante, de d\xE9coration pour la maison et des meubles de collection. On y trouve aussi des caf\xE9s \xE0 la mode, des restaurants qui servent du houmous et des f\xE8ves (authentiques) et des plats du pass\xE9.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>FOIRES ALIMENTAIRES :</h3>\n\t\t\t\t\t<p>Au cours de ces derni\xE8res ann\xE9es, 3 foires aux aliments ont vu le jour \xE0 Tel-Aviv : Shuk Hanamal au port de Tel-Aviv, Sarona et le Shuk Tzafon \xE0 Ramat Hahayal et tous offrent aux visiteurs une exp\xE9rience gastronomique qui les fait saliver. Ces march\xE9s offrent des produits frais et des mati\xE8res premi\xE8res hors pair aux palais d\xE9licats.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>LE MARCH\xC9 ARTISANAL DU CENTRE COMMERCIAL PI\xC9TONNIER DE LA RUE NAHALAT BINYAMIN :</h3>\n\t\t\t\t\t<p>Ce march\xE9 haut en couleur, ouvert les mardis et vendredis donne un cachet sp\xE9cial \xE0 cette rue. N'h\xE9sitez pas \xE0 vous y promener, il constitue une source in\xE9puisable d'id\xE9es cr\xE9atives et originales de cadeaux qui ne se trouvent pas en magasin : des bijoux color\xE9s, du papier m\xE2ch\xE9, des peintures \xE0 l'huile, des jouets en bois, des horloges murales d\xE9coratives, des figurines de verre en miniature, des mains de Fatma, des poup\xE9es, de la vaisselle, etc.</p>\n\t\t\t\t\t<br>\n\n\t\t\t\t\t<h3>RESTAURANTS</h3>\n\t\t\t\t\t<p>Tel-Aviv est une v\xE9ritable Mecque de la gastronomie. Au-del\xE0 des fallafels et des shawarmas, elle regorge de bistros pour gourmets tenus par les meilleurs chefs du pays et de caf\xE9s enchanteurs o\xF9 vous pourrez prendre une l\xE9g\xE8re collation et d\xE9guster un excellent caf\xE9. Parall\xE8lement \xE0 ses restaurants o\xF9 l'on peut virtuellement commander tout ce que l'on peut imaginer, Tel-Aviv dispose \xE9galement de brasseries et de caf\xE9s et de restaurants v\xE9g\xE9tariens hors pair Voici quelques options pour vous r\xE9galer\u2026</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>MIZLALA :</h3>\n\t\t\t\t\t<p>Ce restaurant offre des plats issus de la cr\xE9ativit\xE9 et de la passion de son chef Meir Adoni. Situ\xE9e \xE0 Nahalat Binyamin, lieu \xE0 la mode s'il en fut, dans un b\xE2timent Bauhaus magnifiquement restaur\xE9, la Mizlala d\xE9borde d'\xE9nergie et offre une exp\xE9rience gastronomique inoubliable. Adresse : 57 rue Nahalat Binyamin T\xE9l. : 03-5665505</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>TOPOLPOMPO</h3>\n\t\t\t\t\t<p>Le restaurant du dragon de feu du chef Avi Conforti et son architecture hors norme vous font d\xE9couvrir des go\xFBts, senteurs et sensations n\xE9s d'un travail avec le feu et les \xE9pices. Une soir\xE9e dans cet \xE9tablissement, ainsi que le d\xE9crit son chef, ne peut \xEAtre que chaude, sexy et pleine d'\xE9motions \u2013 \xE0 ne pas rater. Adresse : 14 Hasolelim T\xE9l. : 03-6910691</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>TSFON ABRAXAS</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tLe c\xE9l\xE8bre chef local Eyal Shani, y sert des plats novateurs, intelligents et d\xE9licieux. Lieu \xE0 la mode par excellence o\xF9 la cuisine est ouverte, le restaurant Abraxas vous permet de savourer l'ambiance autant que la nourriture en observant les cuisiniers et leur \xE9nergie contagieuse. Adresse : 40 rue Lilienblum T\xE9l.: 03-5166660\n\t\t\t\t\t\tEt si vous pr\xE9f\xE9rez les plats v\xE9g\xE9tariens\u2026\n\t\t\t\t\t</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>HASHAWARMA HATIVONIT</h3>\n\t\t\t\t\t<p>Consid\xE9r\xE9 comme l'un des meilleurs restaurants v\xE9g\xE9tariens de rue de Tel-Aviv, ce restaurant sert des hamburgers et des hot dogs v\xE9g\xE9tariens et bien entendu une shawarma v\xE9g\xE9tarienne. Adresse : 81 rue King George T\xE9l. : 03-5248821</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>NANUCHKA</h3>\n\t\t\t\t\t<p>On y sert un excellent menu g\xE9orgien v\xE9g\xE9tarien dans un d\xE9cor hors normes avec un plancher antique et des \u0153uvres d'art des meilleurs artistes isra\xE9liens. Le menu est tellement original et savoureux que m\xEAme les carnivores les plus endurcis se passeront de viande avec plaisir. Adresse : 30 rue Lilienblum T\xE9l. : 03-5162254</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>BUDDHA BURGERS</h3>\n\t\t\t\t\t<p>Fast food populaire v\xE9g\xE9tarien, o\xF9 l'ambiance est agr\xE9able, les prix abordables et les plats vari\xE9s: burgers, hot dog, shawarmas et burritos. Adresse : 86 rue Ibn Gabirol T\xE9l. : 03-5101222</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>ZAKAIM</h3>\n\t\t\t\t\t<p>Se d\xE9finissent comme une boutique v\xE9g\xE9tarienne pratiquant les prix d'un march\xE9 fermier, tous les plats sont \xE0 base d'ingr\xE9dients locaux et de saison. Adresse : 20 Simtat Beit Hasho'eva (Alenby 98) T\xE9l. : 03-6135060</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>TENAT</h3>\n\t\t\t\t\t<p>Qualifi\xE9 de l'un des meilleurs restaurants v\xE9g\xE9tariens de Tel-Aviv par le guide Secret Tel-Aviv, Tenat sert un menu \xE9thiopien v\xE9g\xE9tarien et sans gluten. Adresse : 27 rue Chelnov T\xE9l. : 054-7499538</p>\n\n\t\t\t\t\t<h3>CULTURE</h3>\n\t\t\t\t\t<p>Si vous \xEAtes amateur d'art, visitez les nombreux mus\xE9es et galeries d'art de la ville.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>LE MUS\xC9E D'ART DE TEL-AVIV :</h3>\n\t\t\t\t\t<p>Ce mus\xE9e d'art isra\xE9lien et international de premier plan accueille des collections permanentes ainsi que des expositions itin\xE9rantes et affiche les meilleurs tableaux, sculptures, \u0153uvres de design et d'architecture, vid\xE9ographie, dessins et autres.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>BEIT HATFUTZOT, LE MUS\xC9E DE LA DIASPORA :</h3>\n\t\t\t\t\t<p>Il s'agit de l'une des principales institutions au monde impliqu\xE9es dans la recherche sur le juda\xEFsme et il est \xE9galement consid\xE9r\xE9 comme le premier mus\xE9e \xE0 afficher l'histoire et les r\xE9alisations du peuple juif. Sa visite est une exp\xE9rience \xE9mouvante pour les Juifs et permet d'avoir un aper\xE7u des expositions passionnantes retra\xE7ant les r\xE9cits et les \xE9v\xE8nements de la Diaspora juive tout au long de l'histoire.</p>\n\t\t\t\t\t\n\t\t\t\t\t<p>Tel-Aviv vous apporte tout ce qu'une grande ville de vill\xE9giature a \xE0 offrir \u2013 la mer, le soleil, la possibilit\xE9 de se relaxer ainsi qu'un monde culturel vibrant et une cuisine haut de gamme, des boutiques et une vitalit\xE9 in\xE9galable. Gr\xE2ce aux vols directs \xE0 partir des plus grandes villes des Etats-Unis et d'Europe, vous pourrez vous rendre compte par vous-m\xEAme de ce qui fait le charme unique de cette ville.</p>\n\n\t\t\t\t\t<h3>EV\xC8NEMENTS ANNUELS</h3>\n\t\t\t\t\t<p>Tel-Aviv ne s'arr\xEAte pas en si bon chemin, elle accueille de nombreux \xE9v\xE8nements sportifs, culturels et divertissements. Nous vous recommandons de chercher les dates de ces \xE9v\xE8nements sur Internet. En voici un \xE9chantillon :</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>LA NUIT BLANCHE DE TEL-AVIV :</h3>\n\t\t\t\t\t<p>Personne ne dort ne 30 juin 2016! Cette nuit sp\xE9ciale organis\xE9e une fois par an, vous propose ses concerts, f\xEAtes, spectacles de rue, pi\xE8ces de th\xE9\xE2tre etc. jusqu'au petit matin. Les sites artistiques et culturels de la ville restent ouverts ainsi que les magasins et certains clubs. La plupart des \xE9v\xE8nements de la Nuit Blanche sont ouverts au public, gratuitement ou pour un prix symbolique.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>LE FESTIVAL DES MAISONS OUVERTES :</h3>\n\t\t\t\t\t<p>Du 26 au 28 mai 2016. Ce festival pr\xE9voit des visites rares des maisons et b\xE2timents les plus fascinants de la ville, dont la plupart n'ont jamais \xE9t\xE9 ouverts au public.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>COURSE NOCTURNE DE TEL-AVIV :</h3>\n\t\t\t\t\t<p>Cette course de 10 km aura lieu le 16 novembre 2016. Cet \xE9v\xE8nement attire des milliers de coureurs ainsi que des dizaines de milliers de spectateurs venus les encourager et assister \xE0 cette incroyable c\xE9l\xE9bration unique. A la fin de la course, une grande f\xEAte de rythme et de musique est organis\xE9e \xE0 Ganei Yehoshua.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>LA GAY PRIDE :</h3>\n\t\t\t\t\t<p>\xE9v\xE8nement annuel qui a lieu chaque ann\xE9e en juin \xE0 Tel-Aviv, destination de plus en plus pris\xE9e par la communaut\xE9 gay internationale. La parade commence par un happening au Parc Meir avec des discours, des spectacles de drag queens et autres. Apr\xE8s cela, la parade se fraie un chemin au travers des rues principales, sur fond de bonne musique, en pr\xE9sence de groupes qui la suivent. Nombreux participants et de dizaines de milliers de spectateurs. Le point culminant de la parade est la m\xE9ga f\xEAte organis\xE9e \xE0 la plage Charles Chlore. Mais ce n'est pas tout\u2026 les \xE9v\xE8nements se poursuivent dans des soir\xE9es organis\xE9es dans toute la ville.</p>\n\t\t\t\t\t\n\t\t\t\t\t<h3>LE FESTIVAL DE L'INNOVATION DLD :</h3>\n\t\t\t\t\t<p>La conf\xE9rence num\xE9rique DLD de Tel-Aviv est le plus grand rassemblement international d'innovateurs et d'entrepreneurs, elle accueille des centaines de startups, VC, investisseurs et multinationales leaders. Gr\xE2ce \xE0 ses comp\xE9tences technologiques de pointe, \xE0 son taux d'investissement dans les entreprises \xE0 risque le plus \xE9lev\xE9 par capita et aux succursales de multinationales leaders de l'industrie telles que Intel, Google, Microsoft, Kimberly Clark, Amazon, GM, Amdocs, Facebook et autres qui y sont implant\xE9es, Tel-Aviv est l'endroit id\xE9al pour mieux conna\xEEtre le monde de la haute technologie. Le festival comprend de nombreuses conf\xE9rences, \xE9v\xE8nements, rencontres et rassemblements ax\xE9s sur diff\xE9rents aspects de l'innovation num\xE9rique, technologique, sociale et urbaine. Cette ann\xE9e le festival aura lieu du 24 au 29 septembre 2016.</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/2/7.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n         "};}},(_ref={id:"Vegan_Friendly_TelAviv",bgImage:"posts/bank/8/1.jpg",mobBgImage:"posts/bank/8/M.jpg",title:"SCENE VEGAN DE TEL AVIV",ctg:"culinarytelaviv",isVid:true,vidId:"S2NGYP3QQT8"},_defineProperty(_ref,"vidId","9l04RfZ95J0"),_defineProperty(_ref,"smlTitle",""),_defineProperty(_ref,"html",function html(){return{__html:"\n                     \n\t\t\t\t\t <br/>\n\t\t\t\t\t \n\n\t\t\t\t\t <h2>La visite de Tel Aviv n'a jamais \xE9t\xE9 aussi agr\xE9able ou savoureuse pour les v\xE9g\xE9taliens</h2>\n\n\t\t\t\t\t <p>La visite de villes \xE9trang\xE8res peut s'av\xE9rer difficile pour les v\xE9g\xE9taliens, qui ne consomment que des aliments n'ayant aucune origine animale. Tel n'est pas le cas de Tel Aviv, qui accueille une \xE9cole de cuisine int\xE9gralement v\xE9g\xE9talienne et de nombreux restaurants qui ouvrent leurs portes aux v\xE9g\xE9taliens. D\xE9j\xE0 un haut lieu du tourisme gastronomique et couronn\xE9e \xAB Premi\xE8re ville gastronomique au monde \xBB par Saveur Magazine, Tel Aviv a adopt\xE9 le v\xE9g\xE9talisme, ce qui a conduit la revue culinaire The Daily Meal \xE0 d\xE9clarer la ville \xAB Meilleure destination v\xE9g\xE9talienne au monde, \xBB devant huit autre \xAB villes ouvertes aux v\xE9g\xE9taliens \xBB.</p>\n\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/6/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t </div>\n\t\t\t\t\t \n\t\t\t\t\t \n\t\t\t\t\t <h3>Tout ce que d\xE9sirent les v\xE9g\xE9taliens</h3>\n\t\t\t\t\t \n\t\t\t\t\t <p>Si vous parcourez Tel Aviv, vous tomberez sur une quantit\xE9 de restaurants, brasseries et \xE9tablissements de restauration rapide v\xE9g\xE9taliens ou ouverts aux v\xE9g\xE9taliens. Appr\xE9ciez les aromes doux et savoureux flottant dans l'air de la ville en sachant que vous trouverez pr\xE8s de vous un mets d\xE9licieux que vous pourrez consommer. Suivant les go\xFBts et les demandes des habitants de Tel Aviv et des touristes, la plupart des \xE9tablissements de restauration de la ville, ou du moins ceux qui ont une once d'amour-propre, int\xE8grent \xE0 leurs menus des plats v\xE9g\xE9taliens. D'autres ont choisi d'embrasser compl\xE8tement la philosophie v\xE9gane, et proposent des d\xE9clinaisons des d\xE9lices locaux comme le fallafel sans \u0153uf, le shawarma au seitan et la pizza au fromage sans produits laitiers.</p>\n\t\t\t\t\t \n\t\t\t\t\t <h3>Go\xFBtez les saveurs de la M\xE9diterran\xE9e</h3>\n\t\t\t\t\t \n\t\t\t\t\t <p>Respirer l'air frais de la M\xE9diterran\xE9e vous a ouvert l'app\xE9tit et vous voulez go\xFBter les d\xE9lices locaux ? Si vous \xEAtes un v\xE9gan en visite \xE0 Tel Aviv, votre estomac saura vous guider vers les succulents plats \xE0 base de produits locaux frais, qui refl\xE8tant les diff\xE9rentes cultures, tendances et orientations gastronomiques de la ville.</p>\n\t\t\t\t\t \n\t\t\t\t\t <p>Isra\xEBl offre un grand nombre d'options culinaires aux v\xE9gans, mais, avec ses nombreux restaurants, Tel Aviv est vraiment le joyau gastronomique v\xE9g\xE9talien. Que vos aspiriez \xE0 un repas sur le pouce, \xE0 un menu gastronomique ou \xE0 un dessert, Tel Aviv a l'option v\xE9g\xE9talienne qui vous convient, ce qui fait de la station baln\xE9aire isra\xE9lienne une destination \xE0 ne pas manquer \xE0 l'occasion de votre prochain voyage en Isra\xEBl.</p>\n\n\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/6/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t </div>\n\n\t\t\t"};}),_ref),{id:"Jerusalem_Cuisine",bgImage:"/posts/bank/28/1.jpg",mobBgImage:"/posts/bank/28/M.jpg",title:"La cuisine de Jérusalem",ctg:"culinaryjerusalem",isVid:true,vidId:"2CSCe2WC7Ns",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Exaltante et diversifi\xE9e, et oops si d\xE9licieuse</h2>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\tJ\xE9rusalem regorge de restaurants anim\xE9s et branch\xE9s et de lieux o\xF9 passer du bon temps. La ville est remplie d\u2019endroits offrant d\u2019excellentes possibilit\xE9s de divertissements, de jour comme de nuit. Vous pouvez ainsi profiter d\u2019une agr\xE9able soir\xE9e autour d\u2019un bon repas accompagn\xE9 d\u2019une bi\xE8re fraiche ou aller danser sur de la musique entrainante.\n\t\t\t    </p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t\tIl est coutume de dire que l\u2019on se rend \xE0 J\xE9rusalem pour son houmous, et que l\u2019on y reste pour sa gastronomie incroyablement vari\xE9e. De la cuisine traditionnelle du Moyen-Orient et d\u2019Afrique du nord \xE0 la cuisine fusion d\u2019Am\xE9rique du sud et d\u2019Asie et aux mets d\u2019Europe continentale, des fastfood aux restaurants gastronomiques : J\xE9rusalem est sur tous les fronts culinaires. Un vaste choix d\u2019options de restauration est r\xE9ellement pr\xE9sent partout \xE0 J\xE9rusalem : sp\xE9cialit\xE9s locales dans les \xE9choppes, restaurants authentiques sur les march\xE9s, et si vous \xEAtes en qu\xEAte d\u2019une v\xE9ritable exp\xE9rience gastronomique, vous pouvez r\xE9server une table dans l\u2019une des nombreuses adresses prestigieuses de chefs.\n\t\t\t\t\t</p>\n\n         "};}},{id:"Coffee_In_TelAviv",bgImage:"posts/bank/42/1.jpg",mobBgImage:"posts/bank/42/M.jpg",title:"PAUSE-CAFÉ À TEL AVIV",ctg:"culinarytelaviv",isVid:true,vidId:"Q162n8iMTg8",smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t<p>Tel Aviv est une ville dynamique connue pour ses attractions touristiques, son effervescence et ses multiples activit\xE9s. Or, c'est dans les caf\xE9s que bat r\xE9ellement son c\u0153ur. Les caf\xE9s constituent un aspect fondamental de la culture de Tel Aviv. Alors faites une pause et impr\xE9gnez-vous de l'atmosph\xE8re de la ville devant un caf\xE9.</p>\n\n\t\t\t<h3>La culture du caf\xE9</h3>\n\t\t\t<p>Si vous voulez conna\xEEtre la \xAB v\xE9ritable Tel Aviv \xBB, il n'est pas de meilleur moyen que de vous soumettre \xE0 la tradition locale du caf\xE9. Vous pouvez en d\xE9guster un dans l\u2019un des nombreux coffee shops \xE0 la mode fr\xE9quent\xE9s par les touristes, mais pourquoi ne pas sortir des sentiers battus et vous rendre dans un petit \xE9tablissement authentique pour prendre le pouls de cette ville en regardant son quotidien se d\xE9rouler sous vos yeux ? Assistez au rush matinal ou faites comme les vrais Tel-aviviens qui, en fin de journ\xE9e, s'installent en terrasse pour profiter du frais, discuter, et bien s\xFBr, prendre un caf\xE9. Vous aurez l'irr\xE9sistible envie de vous attarder \xE0 votre table, alors profitez-en pour go\xFBter aux d\xE9licieux plats servis par ces \xE9tablissements. Certains vous raviront avec leurs riches p\xE2tisseries europ\xE9ennes tandis que d'autres vous serviront des repas complets s'inspirant de diff\xE9rentes tendances culinaires et cultures.</p>\n\t\t\t\n\t\t\t<p>Tel Aviv regorge d'\xE9tablissements de qualit\xE9 pour boire le caf\xE9, chacun offrant une atmosph\xE8re qui lui est propre. Sirotez un caf\xE9 glac\xE9 en bronzant sur la plage, m\xEAlez-vous aux autochtones dans un magnifique coffee shop situ\xE9 dans les fameux b\xE2timents de style Bauhaus du quartier \xE0 la mode N\xE9v\xE9 Tzedek, ou d\xE9tendez-vous en buvant un latte au port. Regardez passer les joggers, cyclistes et rollers pendant que vous savourez la vie - et un bon caf\xE9.</p>\n\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/coffe-in-tlv/1.jpg")+" class=\"img-responsive\" />\n\t\t\t</div>\n\t\t\t\n\t\t\t<h3>L'heure du caf\xE9</h3>\n\t\t\t<p>\xC0 Tel Aviv, vous ne boirez pas seulement diff\xE9rents types de caf\xE9s, vous go\xFBterez \xE0 plusieurs mondes et traditions. Le matin, vous pourrez essayer un \xAB caf\xE9 hafuch \xBB, moderne et tendance, la version isra\xE9lienne du cappuccino, constitu\xE9e d'un trait d'expresso vers\xE9 dans du lait chaud, que boivent les jeunes Telaviviens branch\xE9s. En milieu de matin\xE9e, laissez une tasse de caf\xE9 turc traditionnel, chaud, noir et fort, vous emporter dans un autre monde, \xE0 seulement quelques minutes de l\xE0, dans le vieux Jaffa. L'ar\xF4me et l'atmosph\xE8re vous transporteront dans le pass\xE9, parmi les odeurs et les parfums du Moyen-Orient ancien. Pour terminer, adoptez la tradition m\xE9diterran\xE9enne du caf\xE9 du soir, pris en terrasse, sur le boulevard Rothschild, avec les figues de barbarie.</p>\n\t\t\t\n\t\t\t<p>\xC0 Tel Aviv, il n'y a pas de mauvais moment pour boire un caf\xE9.</p>\n              \n\t\t\t"};}},{id:"Non_Stop_Markets",bgImage:"posts/bank/non-stop-markets/1.jpg",mobBgImage:"posts/bank/non-stop-markets/M.jpg",title:"Non Stop Markets",ctg:"telaviv",isVid:false,smlTitle:"",html:function html(){return{__html:"\n\t\t\t                 <p>A tour of the markets in Tel Aviv, with their unparalleled human tapestry and never-ending variety of delicacies is probably one of the best ways to get to know the true local spirit of Tel Aviv.<br>\n                             Here are some of the markets that are definitely a must, when visiting the sunny city:</p>\n\n                             <h3>Carmel Market:</h3>\n                             <p>The city\u2019s most famous market, renowned for its colorful spirit and food stalls, featuring fresh local delicacies and excellent restaurants serving fresh food straight from the market. You can also find hidden food placed behind the stalls and around the area. They are really worth finding. <br>\n                             <h3>The Flea Market:</h3>\n                             <p>Located in Jaffa, packed with fantastic authentic antiques from Tel Aviv and Jerusalem, a joy to bargain hunters. This market is also home to many fashionable and excellent caf\xE9s and restaurants of all varieties of cuisines: from Greek, to Italian, to Arabic.<br>\n                             <div class=\"img-wrapper\">\n\t\t\t\t\t\t         <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"posts/non-stop-markets/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t         </div>\n                             <h3>Nahalat Binyamin Arts & Crafts Market: </h3>\n                             <p>Open on Tuesdays and Fridays, this is a \u2018fair-like\u2019 artists\u2019 market, rich with creative and original ideas for gifts. It is just the place to pick up that perfect souvenir you won\u2019t find in any store.<br> \n                             <h3>Sarona Market</h3>\n                             <p>Offering a unique and fabulous culinary adventure, Sarona Market is located in the Trendy Sarona Complex, and is home to a modern and vibrant \u201Cfood court\u201D which offers a huge assortment of culinary options. Sarona is also extremely family friendly, filled with outdoor activities and fantastic playgrounds. <br>\n                             <h3>Tel Aviv Port Market</h3>\n                             <p>With more of a Farmers Market feel, this seaside Market is packed with tasty treats and specialty produce which you can enjoy, on the spot of take home as culinary souvenirs.<br>\n\n              \n\t\t\t"};}},{id:"Joys_Of_Jaffa",bgImage:"posts/bank/joys-of-jaffa/1.jpg",mobBgImage:"posts/bank/joys-of-jaffa/M.jpg",title:"JAFFA, VILLE MAGIQUE",ctg:"telaviv",isVid:true,// vidId:"a6QMndU0wx0",
vidId:"tgF0zMUYY2g",smlTitle:"",html:function html(){return{__html:"\n\t\t\t            \n\t\t\t            <br/>\n\t\t\t            <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Explorez tous les tr\xE9sors de la splendide ville antique de Jaffa</h2>\n\t\t\t            <p>Recently named among CNN Travel\u2019s must visit places for 2019, Jaffa is Tel Aviv\u2019s smaller sister, and even though it dates back thousands of years, a visit to Old Jaffa always feels like an exciting discovery. A tour of Jaffa reveals charming winding alleyways interspersed with art galleries, historic buildings, newly renovated hotels in extraordinary landmark areas and a multitude of quaint authentic restaurants.</p>\n\n                        <h3>Jaffa Flea Market</h3>\n                        <p>Located in Jaffa, the famous flea market is a pure delight for the bargain hunters among you, packed with great authentic antiques. The flea market has been experiencing a recent bloom, and is considered a nightlife hub, featuring trendy bars and cool outdoor eateries, packed with young party people until the (very) late.</p> \n\n                        <h3>Jaffa Port </h3>\n                        <p>Considered one of the world\u2019s most ancient ports, the Port of Jaffa served fishermen, sailors, merchants, crusaders, conquerors and immigrants for thousands of years. Today, the port continues to serve as a fishing port, and is also being renovated as an urban attraction that offers cultural and leisure activities, shopping and tourism, while preserving its unique historical and fascinating character.</p>\n\n                        <h3>Around Jaffa </h3>\n                        <p>A stone\u2019s throw away from Jaffa you can find the HaTachana complex, Tel Aviv\u2019s renovated Old Railway is now a now vibrant tourist hub and an attractive site in itself and also lovely Neve Tzaedek  neighborhood, perfect for a leisurely stroll. Jaffa also boasts stunning beaches and fantastic restaurants serving a variety of fantastic local cuisine at affordable prices.  </p>\n                        \n                        <h3>Colorful History and Irresistible Levantine Charm</h3>\n                        <p>The smells of the sea flavored with black coffee and spices from the markets, Levantine culture combined with European, ancient mixed with new \u2013 this is Jaffa. One of the oldest port cities in the world whose history dates back to the great flood, today's Jaffa is a vibrant city that never ceases to surprise and innovates. Picturesque alleys, art galleries, unique boutiques, ancient building, wonderful landmarks and an abundant of authentic middle-eastern restaurants \u2013 a trip to old Jaffa is a must-have multi-sensory stimulating experience for anyone visiting Israel. Prepare to fall in love.<br>&nbsp;</p>\n                        <h3>Discover the magic of a vibrant Port City</h3>\n                        <p>Situated on a hill overlooking the Mediterranean Sea, in the southern part of Tel-Aviv, Jaffa has been the center of historical events for thousands of years. Still an active port today the Jaffa Port is a great place to explore. Wander through the art galleries, shopping boutiques and gourmet food markets. Stroll by the old docks, listen to live music, drink, eat and absorb the special atmosphere.<br><br>To get a better view of the city, climb up the hill to Peak (Ha'Pisga) Park overlooking the bay and gaze at the beautiful city below. On your way down, make a wish at the Wishing Bridge. Who know, it may come true.</p>\n                        <h3>Go on A Romantic urban adventure</h3>\n                        <p>Jaffa streets are full of surprises. Stroll in the narrow stone-paved streets of old Jaffa, discover hidden courtyards and notice the small details \u2013 painted ceramic tiles, small sculptures and upper open terrace. See the people, enter the art galleries, artists' studios and unique boutique.<br><br>Keep exploring. From the Clock tower square at the heart of the city continue to the well-known Jaffa Flea Market and weave your way through daily basics and hidden treasures. It's time to test those bargaining skills. Enjoy the small quaint caf\xE9s, middle-eastern authentic restaurants, great bar and some of best hummus you ever tasted. Guaranteed.</p>\n\t\t\t\t\t\n                        <p><a href=\"https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1\" rel=\"nofollow\" target=\"_blank\">View attractions in Tel Aviv &amp; Center at Tourist Information site</a><br><a href=\"https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19\" rel=\"nofollow\" target=\"_blank\">View accommodations in </a><a href=\"https://info.goisrael.com/en/attractions#/specFilters=6m!#-!19&amp;pageSize=24&amp;viewMode=grid&amp;orderBy=0&amp;pageNumber=1\" rel=\"nofollow\" target=\"_blank\">Tel Aviv &amp; Center</a><a href=\"https://info.goisrael.com/en/accomodations#/specFilters=6m!#-!19\" rel=\"nofollow\" target=\"_blank\"> at Tourist Information site</a></p>\n\t\t\t\t\t\n              \n\t\t\t"};}},{id:"Gourmet_TelAviv",bgImage:"posts/bank/33/1.jpg",mobBgImage:"posts/bank/33/M.jpg",title:"SCÈNE GOURMANDE SUR TEL-AVIV",ctg:"culinarytelaviv",isVid:true,vidId:"jfyHxk8ZRrI",smlTitle:"",html:function html(){return{__html:"\n\n\t\t\t<h2>SC\xC8NE GOURMANDE SUR TEL-AVIV</h2>\n\t\t\t\n\t\t\t<p>\n\t\t\tL\u2019immense vari\xE9t\xE9 de restaurants fantastiques sur Tel-Aviv \u2013 L\u2019endroit parfait pour vous faire plaisir\n\t\t\t</p>\n\n\t\t\t<p>Tel Aviv, la ville qui ne dort jamais, situ\xE9e sur les rives de la M\xE9diterran\xE9e, est une des destinations touristiques les plus pris\xE9es au monde. Anim\xE9e, dynamique et festive, la seconde ville d'Isra\xEBl a tout pour elle, y compris une sc\xE8ne culinaire cr\xE9ative, tendance, originale et plusieurs fois prim\xE9e, qui satisfait tous les go\xFBts et tous les budgets. Depuis les restaurants gastronomiques modernes et sophistiqu\xE9s jusqu'aux \xE9tablissements locaux simples et traditionnels, en passant par toutes les d\xE9clinaisons situ\xE9es entre les deux. La ville a m\xEAme \xE9t\xE9 nomm\xE9e parmi les principales destinations v\xE9ganes. Gourmands des quatre coins du monde, Tel Aviv est l'endroit qu'il vous faut.</p>\n\n\t\t\t<p>En balade. Les Telaviviens adorent \xEAtre dehors. Il se passe toujours quelque chose de nouveau et de passionnant en ville, y compris en mati\xE8re de cuisine. Vous voulez explorer la sc\xE8ne culinaire de Tel Aviv ? Commencez tout simplement par sortir dans la rue. Allez dans une des principales rues anim\xE9es de la ville, comme Dizengoff et Ibn Gabirol et allez de d\xE9couverte en d\xE9couverte. Les meilleurs caf\xE9s, restaurants, bars, traiteurs et vendeur de rue n'attendent que vous.</p>\n\t\t\t\n\t\t\t<p>Go\xFBter les d\xE9lices des march\xE9s. Visitez le march\xE9 Carmel, le plus grand et le plus central des march\xE9s alimentaires de la ville, immens\xE9ment populaire. Ensuite, direction le march\xE9 Levinsky, au sud de la ville, le paradis des gourmets et des \xE9pices. Un conseil : prenez votre temps. Ces rues cachent certains des plus grands tr\xE9sors culinaires de la ville.</p>\n\t\t\t\n\t\t\t<p>Une cuisine locale et internationale. Avec ses immigrants venus de plus de 120 pays, il n'est pas \xE9tonnant que Tel Aviv soit un v\xE9ritable creuset (litt\xE9ralement). Si pour vous nourriture ethnique signifie alimentation d'origine japonaise, tha\xEF ou indienne, ici le terme a une signification bien plus vaste. Cuisine turque, marocaine, perse, y\xE9m\xE9nite, \xE9thiopienne, g\xE9orgienne, et la liste ne fait que commencer...</p>\n\t\t\t\n\t\t\t<p>Tel Aviv est \xE9galement extr\xEAmement fi\xE8re de sa cuisine locale, qui s'inspire de ces nombreuses sp\xE9cialit\xE9s internationales qui apportent une touche originale aux mets traditionnels. Le r\xE9sultat est d\xE9licieux et extr\xEAmement original. Visitez le march\xE9 paysan du port de Tel Aviv ainsi que le march\xE9 international Sarona, pour go\xFBter \xE0 certains des meilleurs produits que la ville vous propose.</p>\n\t\t\t\n\t\t\t<p>Une cuisine sophistiqu\xE9e, raffin\xE9e et innovante. Ce n'est un secret pour personne, un grand nombre des meilleurs restaurants isra\xE9liens se trouvent \xE0 Tel Aviv. Des chefs cr\xE9atifs et ayant le go\xFBt du risque, qui n'h\xE9sitent pas \xE0 se lancer dans des exp\xE9riences \xE0 partir de mets du Moyen-Orient, d'Asie de l'Est et d'Europe, ont transform\xE9 Tel Aviv en un p\xF4le gastronomique connu dans tout le pays et dans le monde entier. Intelligente et esth\xE9tique, cette cuisine est \xE9labor\xE9e \xE0 partir des produits locaux les plus frais - une exp\xE9rience culinaire que vous n'\xEAtes pas pr\xE8s d'oublier.</p>\n\t\t\t\n\t\t\t<p>Une cuisine v\xE9g\xE9tarienne et v\xE9gane. Contrairement \xE0 de nombreuses villes du monde, \xE0 Tel Aviv on peut tr\xE8s facilement passer une semaine (ou plus) sans manger de viande ou de laitage. Vous trouverez facilement de la nourriture de qualit\xE9, ethnique, raffin\xE9e et pr\xE9par\xE9e rapidement. Nombreux sont les boulangeries, traiteurs, restaurants totalement v\xE9g\xE9tariens ou \xE9tablissements classiques \xE0 proposer de nombreux plats v\xE9gans et v\xE9g\xE9tariens. Vous pourrez d\xE9guster une cuisine savoureuse et originale, \xE9labor\xE9e \xE0 l'aide produits frais.</p>\n\t\t\t\n\t\t\t<p>Ce qui est apparu il y a quelques ann\xE9es comme une mode parmi tant d'autres s'est impos\xE9 comme l\u2019une des principales caract\xE9ristiques de la sc\xE8ne culinaire de Tel Aviv. Celle-ci fait bon usage de ses diverses influences gastronomiques, de l'impressionnante vari\xE9t\xE9 des l\xE9gumes propos\xE9s sur les march\xE9s et de l'int\xE9r\xEAt de la population pour la protection de l'environnement.</p>\n\t\t\t\n\t\t\t<p>Cela vous a-t-il ouvert l'app\xE9tit ?</p>\n              \n\t\t\t"};}},{id:34,bgImage:"/posts/34/1.jpg",mobBgImage:"/posts/34/M/1.jpg",title:"the DEAD SEA",ctg:"deadsea",isVid:false,player_id_post:"",smltitle:"",html:function html(){return{__html:"\n            \n\t\t\t\t<p>\n               \t\tA geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction.\n\n                </p>\n\n                <p>\n               \t\tExperience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. While here, you can bathe in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.\n\t\t\t\t\t\n                </p>\n\n                <p>\n\n\t\t\t\t\tLuxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.\n\n                </p>\n\t\t\t\t\n            \t "};}},{id:"Shakshuka",bgImage:"/posts/bank/43/1.jpg",mobBgImage:"/posts/bank/43/M.jpg",title:"L’HEURE DE LA SHAKSHUKA",ctg:"culinary",isVid:true,vidId:"n4kCnPXEX7g",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<p>Quand vous demandez aux gens qui visitent Tel Aviv et J\xE9rusalem quel est leur plat pr\xE9f\xE9r\xE9 parmi ceux qu\u2019ils ont go\xFBt\xE9s durant leur s\xE9jour en Isra\xEBl, ils vous r\xE9pondront la plupart du temps que c\u2019est la Shakshuka. Ce mets m\xE9diterran\xE9en, qui est une sp\xE9cialit\xE9 r\xE9gionale incontournable, consiste essentiellement en un plat d\u2019oeufs poch\xE9s dans une sauce \xE0 base de tomates, de piments et d\u2019oignons, riche en saveurs et souvent servi avec du pain du tahini. Il existe \xE9videmment plusieurs variantes de ce plat, en fonction des styles et des go\xFBts locaux ; il est habituellement servi au petit-d\xE9jeuner ou pour un brunch, bien qu\u2019il puisse aussi faire un excellent d\xEEner.</p>\n\n\t\t\t\t<p>Le meilleur endroit pour savourer la Shakshuka est certainement \xE0 Tel Aviv ou \xE0 J\xE9rusalem, villes ensoleill\xE9es toute l\u2019ann\xE9e, ce qui permet de profiter d\u2019une escapade urbaine surprenante, pleine de saveurs et d\u2019exp\xE9riences inoubliables.</p>\n\n\t\t\t\t<p>Mais au cas o\xF9 vous souhaiteriez mettre la main \xE0 la p\xE2te et recr\xE9er le go\xFBt de la sensationnelle Shakshuka dans votre propre cuisine, voici comment proc\xE9der :</p>\n\n\t\t\t\t<h3>INGR\xC9DIENTS</h3>\n\t\t\t\t<ul>\n\t\t\t\t\t<li>2 cuiller\xE9es \xE0 soupe d\u2019huile d\u2019olive</li>\n\t\t\t\t\t<li>1 oignon, hach\xE9</li>\n\t\t\t\t\t<li>1 poivron rouge, \xE9p\xE9pin\xE9 et coup\xE9 en d\xE9s</li>\n\t\t\t\t\t<li>4 gousses d\u2019ail, \xE9minc\xE9es</li>\n\t\t\t\t\t<li>2 bo\xEEtes de tomates en d\xE9s</li>\n\t\t\t\t\t<li>6 oeufs</li>\n\t\t\t\t\t<li>2 cuiller\xE9es \xE0 soupe de coriandre frais, hach\xE9</li>\n\t\t\t\t\t<li>\xBE cuill\xE8re \xE0 caf\xE9 de sel</li>\n\t\t\t\t\t<li>1 cuill\xE8re \xE0 caf\xE9 de paprika</li>\n\t\t\t\t\t<li>\xBC cuill\xE8re \xE0 caf\xE9 de poivre noir</li>\n\t\t\t\t\t<li>1 jalapeno (facultatif)</li>\n\t\t\t\t</ul>\n\t\t\t\t<h3>PR\xC9PARATION</h3>\n\t\t\t\t<ul>\n\t\t\t\t\t<li>Commencez par pr\xE9chauffer le four \xE0 375 degr\xE9s.</li>\n\t\t\t\t\t<li>Faites chauffer \xE0 feu moyen l\u2019huile d\u2019olive dans une grande po\xEAle qui peut aller au four. Ajoutez-y l\u2019oignon, le poivron rouge et le jalapeno, et faites frire l\u2019oignon jusqu\u2019\xE0 ce qu\u2019il soit translucide.</li>\n\t\t\t\t\t<li>Ajoutez-y l\u2019ail et le paprika. Puis ajoutez les tomates, le sel et le poivre noir.</li>\n\t\t\t\t\t<li>Portez \xE0 \xE9bullition puis r\xE9duisez le feu. Laissez mijoter 10 \xE0 15 minutes.</li>\n\t\t\t\t\t<li>Cr\xE9ez 6 petits trous dans la sauce et cassez soigneusement les oeufs dans chacun des 6 espaces libres.</li>\n\t\t\t\t\t<li>Mettez la po\xEAle dans le four pr\xE9chauff\xE9 et faites revenir jusqu\u2019\xE0 ce que les blancs d\u2019oeuf soient cuits \u2013 10 minutes environ.</li>\n\t\t\t\t\t<li>Garnissez de coriandre avant de servir.</li>\n\t\t\t\t\t<li>Servez avec du pain et du tahini, et\u2026 D\xE9gustez !</li>\n\t\t\t\t</ul>\n\n         "};}},{id:"The_Gates_Of_Jerusalem",ctg:"jerusalem",isVid:true,// vidId:"MXtcTm_JXus",
vidId:"V0Acsw3Hf_M",bgImage:"/posts/bank/gates-of-jerusalem/1.jpg",mobBgImage:"/posts/bank/gates-of-jerusalem/M.jpg",title:"THE GATES OF JERUSALEM",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t  \n\t\t\t\t                <p>Jerusalem\u2019s Old City walls, built in the early 16th century by the Turkish Sultan Suleiman the Magnificent, have eight gates. All but one (the Gate of Mercy) still serve Jerusalemites and visitors streaming to its markets, and sacred and historic sites.</p>\n\n                                <p>Following  is a thumbnail description of the gates, counter-clockwise from south to west:</p>\n\n                                <h3>The Zion Gate:</h3>\n\n                                <p>Bearing Jerusalem\u2019s earliest biblical name in Hebrew and English, this gate\u2019s  Arabic name is the Gate of the Prophet David, as the Tomb of King David, on adjacent Mount Zion, is only a few steps away. Zion Gate leads directly to the Armenian and Jewish quarters.</p>\n\n                                <p><strong>The Dung Gate:</strong> This gate\u2019s unusual name derives from the refuse dumped here in antiquity, where the prevailing winds would carry odors away. Nehemiah 2:13 mentions a Dung Gate that was probably near this one. This gate leads directly to the Western Wall and the Southern Wall Archaeological Park.</p>\n\n                                <p><strong>Gate of Mercy:</strong> This gate, in the eastern Temple-Mount wall, may be the best-known of them all. Also called the Golden Gate or the Eastern Gate, it has been blocked for centuries, and is said to be awaiting a miraculous opening when the Messiah comes and the dead are resurrected.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/gates-of-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t            </div>\n\n\t\t\t\t\t\t\t    <h3>Lion\u2019s Gate:</h3>\n\n                                <p>This portal is named after a pair of ferocious-looking animal carvings that flank it. They are actually tigers, the heraldic symbol of the 13th-century Sultan Beybars. It is also called St. Stephen\u2019s Gate, after the first Christian martyr, who tradition says was stoned nearby. Lion\u2019s Gate, which leads to the Pools of Bethesda, the Via Dolorosa, and the markets, became famous during the Six Day War.</p>\n\n                                <h3>Herod\u2019s Gate:</h3>\n\n                                <p>  Despite its name, the notorious Judean king had nothing to do with this gate. In Arabic and Hebrew this north-facing gate, which leads to the Old City markets, is called the Flowers Gate. Some say the name derives from a rosette carved over it. However, in Arabic a similar word means \u201Cawakened,\u201D and may refer to a nearby cemetery and the hope of resurrection.</p>\n\n                                <h3> Damascus Gate:</h3>\n\n                                <p> This most imposing of Jerusalem\u2019s gateways also faces north and is named for the grand city from which Jerusalem\u2019s rulers once came. It is always a busy thoroughfare, thanks to the bustling markets within. Below the 16th-century gate, archaeologists have uncovered part of the entryway built by Emperor Hadrian in the second century CE.</p>\n\n                                <h3> The New Gate:</h3>\n\n                                <p>This is the only Old City entryway not part of the original design of the 16th-century walls. It was breached in the waning days of the Ottoman Empire to allow Christian pilgrims quicker access to their holy places within the ramparts.</p>\n\n                                <p>The Jaffa Gate: This was the destination of Jewish and Christian pilgrims disembarking at the Jaffa port, hence its name. It led (and still leads) directly to the Jewish and Christian quarters, as well as to the most popular parts of the market, and to the Tower of David Museum, once Jerusalem\u2019s citadel and now a showcase of its history.</p>\n\t\t\t\t\t\t\t    \n\n         "};}},{id:"Shopping_Delights",ctg:"jerusalem",isVid:true,// vidId:"MXtcTm_JXus",
vidId:"V0Acsw3Hf_M",bgImage:"/posts/bank/shopping-delights/1.jpg",mobBgImage:"/posts/bank/shopping-delights/M.jpg",title:"JOIES DU SHOPPING",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t  \n\t\t\t\t\t<p>\n\t\t\t\t\t    Des articles de mode aux souvenirs, J\xE9rusalem propose tout cela.<br/>\n\t\t\t\t\t\tFrom couture to souvenirs, Jerusalem has it all. <br/>\n\t\t\t\t\t\n\t\t\t\t\t\tThere are several areas in Jerusalem with outdoor shopping promenades and a few indoor malls as well. Rest assured, going shopping in Jerusalem, you can find what you\u2019re looking for budget.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   CITY CENTER: BEN YEHUDA AND SURROUNDING STREETS\n\t\t\t\t\t</h3>\n\n\n\t\t\t\t\t<p>\n                          Jerusalem\u2019s entire city center area is now one large pedestrian mall.&nbsp; The city is&nbsp;<a href=\"//www.itraveljerusalem.com/ben-yehuda-street\" target=\"_blank\"><strong>Ben Yehuda St.</strong></a>, a pedestrian street full of shops and restaurants<a href=\"//www.itraveljerusalem.com/ben-yehuda-street\"><strong>,</strong></a>&nbsp; with its repaved Jerusalem stone walkway,&nbsp; classy street lamp, elevated seating areas,&nbsp; and a small fountain to boot.&nbsp; The surrounding streets also enjoyed an upgrade with a sleek, grey-tiled sidewalk resurfacing and the same classy street lamp. This renovation was in preparation for the city\u2019s&nbsp;<a href=\"//www.itraveljerusalem.com/articles/jerusalem-light-rail/\" target=\"_blank\"><strong>lightrail on Jaffa St</strong></a>.\n                    </p>\n\n                    <p>\n                       Given the expanded revamped area, when you go shopping in Jerusalem, it\u2019s worth a stroll on all of the center city streets: Shatz St., King George St.,Hillel St., Ben Yehuda St., Jaffa St., Yoel Salomon St., and all of their offshoot streets. Tip: On Fridays during the day, check out the Artists Fair on Shatz and Betzalel Streets \u2013 an excellent place to purchase Jerusalem gifts by local artisans.\n                    </p>\n\n                    <p>\n                       Ben Yehuda St. itself is a hill, connecting with King George St. at the top, and Jaffa St. at the bottom, where it opens up into the Zion Square plaza (Kikar Tzion). Ben Yehuda highlights include branches of two famous Israeli companies: The Dead Sea spa products, Ahava, and the quality Teva-Naot leather shoes. Ben Yehuda St. is also a good place to peruse Judaica and Christian souvenirs at overall mid-tier prices \u2013 be sure to haggle! The area also offers practical day-to-day items, from hats and umbrellas to electronics.\n                    </p>\n\n                   <!-- <p>\n                          At the bottom of Ben Yehuda St., at Zion Square plaza, stands the newly-installed department store HaMashbir LaTzarchan (commonly referred to as simply \u201CHaMashbir\u201D), whose multiple floors offer everything you\u2019re used to in a department store. Near Zion Square, jewellery store&nbsp;<a href=\"//www.itraveljerusalem.com/baltinester-jewelry-judaica-jerusalem\" target=\"_blank\"><strong>Baltinester (Jaffa St.</strong></a>) is well known in particular for its name necklaces made to order.&nbsp;From Zion Square, you\u2019ll enter into Nachalat Shiva, centeredon Yoel Salomon St., home to several pottery and jewellery shops as well as boutique clothing stores.\n                    </p> -->\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/5/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t   MAMILLA MALL & THE OLD CITY\u2019S CARDO: UPSCALE SHOPPING\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n                          During your&nbsp;<a href=\"//www.itraveljerusalem.com/jerusalem-old-city\" target=\"_blank\"><strong>Old City tours</strong></a>, you\u2019ll find an exclusive shopping experience at&nbsp;<a href=\"//www.itraveljerusalem.com/cardo-jerusalem\" target=\"_blank\"><strong>the Cardo</strong></a>&nbsp;in the Jewish Quarter. The Cardo\u2019s row of luxury shops are particularly suited to purchasing Jerusalem souvenirs, all with the unique backdrop of the Cardo\u2019s ancient Roman columns and other archaeological remains.&nbsp; Thereby, the Cardo is a one-of-a-kind experience for any Jerusalem visitor, in that you can combine treading on history with shopping high-end.\n                    </p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\tTHE JERUSALEM MALCHA MALL\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    The Jerusalem Malcha Mall is a solid choice for anyone seeking the suburban indoor shopping mall experience, as well as families seeking an indoor outing.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    Now over twenty years old, when the Jerusalem Malcha Mall was established it was dubbed \u201CThe Biggest Mall in the Middle East\u201D. To date Malcha Mall certainly maintains its status as the biggest conglomerate of stores in Jerusalem, with over 250 to choose from.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t    The Jerusalem Malcha Mall houses both international and Israeli stores, ranging from somewhat low to mid-range budget to boutique, higher end. World-famous brand names such as H&M, Zara, Home Depot, and Toys R Us all maintain branches at this mall. Several Israeli clothing shops for all budgets have space here, as well as a branch of the department store HaMashbir LaTzarchan (the same department store as on Zion Square), and the Mega supermarket. In addition, Malcha Mall offers practical services such as a synagogue, a post office, and Bank Hapoalim. For eats, there\u2019s a vast selection of take out restaurants at the food court, all kosher.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/5/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n                          Activities include an indoor ice skating rink during winter, and entertainment and crafts workshops during holiday seasons \u2013 check our&nbsp;<a href=\"//www.itraveljerusalem.com/jerusalem-events\" target=\"_blank\"><strong>events schedule</strong></a>&nbsp;to plan your outing. In addition, the Shilav baby store has a gymboree area good for ages up to six. <br>\n                          Malcha Mall is an easy bus ride from center city or cab ride from anywhere.\n                    </p>\n\n                    <h3>\n                       THE OLD CITY\u2019S ARAB SHUK\n                    </h3>\n\n                    <p>\n                       If you\u2019re looking for authentic, local ware, the Old City\u2019s Arab Shuk is the place to be. Located in the Muslim and Christian quarters, enter via Jaffa Gate and go straight into the Muslim Quarter. Once you see dresses and frocks hanging high, you\u2019ll know you\u2019re in the right place. The Arab shuk in the Old City is a Middle Eastern market full of endemic artistry both in clothing and in foods. You can also find Christian, Jewish, and Muslim souvenirs here, often at a lower price than on Ben Yehuda St. \u2013 it\u2019s up to you to know, and use, your bargaining chips.(Hint: Start at half the offer price.)\n                    </p>\n\n                    <p>\n                      In the Arab shuk, you\u2019ll have a taste of the way things used to be. Merchants have been operating in the Old City for a couple of millenia, in these narrow alleyways, day in, day out; the sincerity of this centuries-old, Middle Eastern marketplace is something unmatched in Western culture in general.\n                    </p>\n\n                    <h3>\n                        MAHANE YEHUDA SHUK (MARKET)\n                    </h3>\n\n                    <p>\n                       The Mahane Yehuda market, or shuk, is renowned mostly for its Jerusalem flare with local food \u2013 fresh produce and nuts, bakeries (such as&nbsp;Marzipan), and shawarma/falafel  joints.&nbsp; In recent years&nbsp;<a href=\"//www.itraveljerusalem.com/mahane-yehuda-market\" target=\"_blank\"><strong>Mahane Yehuda</strong></a>&nbsp;has seen a slew of more upscale establishments \u2013 going from \u201Cshuk&nbsp; to chic\u201D \u2013 with specialized wine and cheese shops, health food stores, vegetarian restaurants, and even a branch of the Israeli international franchise, Caf\xE9 Aroma. In addition to food, you can find gifts to take home such as Judaica, jewelleryry, and pottery. &nbsp;You can also purchase electronics and low-cost clothing.\n                    </p>\n\n\n\n                    <p>\n                    Even with its upscale spin of late, the Mahane Yehuda shuk\u2019s salt of the earth, authentic Jerusalemite ambience remains entrenched, and for this reason it's a must.\n                    </p>\n\n                    <h3>\n                       IN SUMMARY\n                    </h3>\n\n                    <p>\n                          All in all, shopping in Jerusalem reflects the city itself, spanning the spectrum of ancient to modern, with options for those on a limited budget to those looking for upscale. You will see that shopping in Jerusalem is certainly an exciting, varied experience.\n                          <br>\u2013 See more at: http://www.itraveljerusalem.com/articles/popular-shopping-places/#sthash.HdOTQ81q.dpuf\n                    </p>\n\n         "};}},(_ref2={id:"Top_5_Things",ctg:"telaviv",isVid:false,bgImage:"/posts/bank/37/1.jpg",mobBgImage:"/posts/bank/37/M.jpg",title:"LES POINTS FORTS DE TEL AVIV",smltitle:""},_defineProperty(_ref2,"isVid",true),_defineProperty(_ref2,"vidId","LLOUxE-K_9Y"),_defineProperty(_ref2,"html",function html(){return{__html:"\n\t\t\t\t\t\n\t\t\t\t\t<h2>Le top 5 des choses \xE0 voir et \xE0 faire dans la ville:</h2>\n\t\t\t\t\t<h3>\n\t\t\t\t\tLE VIEUX JAFFA\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tM\xEAme si elle ram\xE8ne \xE0 des millions d\u2019ann\xE9es en arri\xE8re, une visite du Vieux Jaffa donne toujours l\u2019impression d\u2019une d\xE9couverte passionnante. De charmantes ruelles sinueuses parsem\xE9es de galleries d\u2019art, de b\xE2timents historiques, de sites extraordinaires et d\u2019une multitude de charmants restaurants pittoresques. Un tour du Vieux Jaffa est une exp\xE9rience impressionnante, un \u2018must\u2019 ind\xE9niable pour tout touriste visitant Isra\xEBl.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tLE PORT DE JAFFA\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tConsid\xE9r\xE9 comme l\u2019un des plus ancients ports du monde, celui de Jaffa a accueilli des p\xEAcheurs, des marins, des marchands, des crois\xE9s, des conqu\xE9rants et des immigrants pendant des milliers d\u2019ann\xE9es. De nos jours, le port continue d\u2019\xEAtre utilis\xE9 comme port de p\xEAche ; il est aussi en train d\u2019\xEAtre r\xE9nov\xE9 pour devenir une attraction urbaine offrant loisirs et activit\xE9s culturelles, shopping et activit\xE9s touristiques, tout en pr\xE9servant son caract\xE8re historique unique et fascinant.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tLE PORT DE TEL AVIV\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tR\xE9cemment restaur\xE9, le quartier branch\xE9 du port a vraiment tout pour lui. En journ\xE9e, vous pouvez vous retrouver en train de fl\xE2ner dans de remarquables espaces au style suspendu et y faire du shopping dans des magasins de marque, vous offrir un repas dans l\u2019un des restaurants avec vues magnifiques sur la mer, et participer \xE0 une multitude d\u2019activit\xE9s destin\xE9es \xE0 toute la famille. La nuit tomb\xE9e, une foule de jeunes clubbers descend alors sur la zone qui devient l\u2019un des quartiers nocturnes les plus appr\xE9ci\xE9s concentrant quelques-uns des clubs et bars les plus cools de Tel Aviv.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tLA VILLE BLANCHE\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tParticipez \xE0 une visite fascinante de la \u2018Ville Blanche\u2019 de Tel Aviv et d\xE9couvrez pourquoi elle a \xE9t\xE9 d\xE9clar\xE9e site class\xE9 au patrimoine mondial de l\u2019UNESCO. La \u2018Ville Blanche\u2019 abrite le plus vaste groupement de b\xE2timents de style international au monde, \xE9galement connu sous le nom de Bauhaus. Construite dans les ann\xE9es 1920 et 1930, et minutieusement restaur\xE9e \xE0 sa gloire d\u2019origine, le quartier de la \u2018Ville Blanche\u2019 est vraiment unique. C\u2019est un tr\xE9sor architectural m\xE9morable.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\tN\xC9V\xC9 TZEDEK\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\tOffrez-vous une pause avec le rythme tr\xE9pidant de Tel Aviv ; cette perle, dissimul\xE9e dans un quartier, poss\xE8de un magnifique style architectural oriental et de charmantes rues \xE9troites qui font de Neve Tzedek, qui signifie lit\xE9ralement une Oasis de Justice, une v\xE9ritable oasis au coeur de la ville effervescente.\n\t\t\t\t\t</p>\n\n         "};}),_ref2),// in fr.citiesbreak old this post wasn't translated
{id:"Amazing_Nightlife",bgImage:"/posts/bank/18/1.jpg",mobBgImage:"/posts/bank/18/M.jpg",title:"A LA RECHERCHE D'UNE VIE NOCTURNE",ctg:"telaviv",isVid:true,vidId:"ogEN7aRT0SM",// vidId:"WKfjMATNH8Q", - this is an old youtube video
smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t<div class=\"ac-cradit\">\n\t\t\t\t\t<span class=\"ac-cradit-text\">Credits:</span>\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<span class=\"ac-cradit-text-1\">Tel Aviv Jaffa municipality<br/></span<\n\t\t\t\t\t\t<span class=\"ac-cradit-text-2\">UDINI prodactions<br/></span>\n\t\t\t\t\t</div>\n\t\t\t\t\t<p></p>\n\t\t\t\t\t</div>\n\n                    <h2>\n                    It\u2019s a never-ending party in the nonstop city!</h2>\n\t\t\t\t\t<p>\n\t\t\t\t\t    Tel Aviv is rightly famous as one of the world\u2019s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that\u2019s pulsing with life.</p>\n\t\t\t\t\t\t<h3>Tel Aviv by Night</h3>\n\t\t\t\t\t\t<p>No matter what time it is, there\u2019s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv\u2019s pumping, pulsing clubs to dance the night away.</p>\n\t\t\t\t\t\t\n\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>Foodies will love the amazing cocktails mixed by Tel Aviv\u2019s expert baristas, Israel\u2019s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>\n                        <h3>Making the Most of Tel Aviv\u2019s Nightlife</h3>\n                        <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you\u2019ll be introduced to some of Israel\u2019s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv\u2019s new and exciting gallery bars that display pieces by up and coming artists.</p>\n                         \n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv\u2019s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn\u2019t reach full swing until 2am in most of Tel Aviv\u2019s wildly popular nightclubs, manned by top DJs. You\u2019ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>\n                         \n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/8/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n                      <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you\u2019ll find countless places to hang out at every hour of the day and night.</p>\n\n                        <p>photo credit: Dana Friedlander</p>\n\n         "};}},{id:"Boutique_Hospitality",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",title:"Boutique Hospitality",ctg:"telaviv",isVid:false,smltitle:"",html:function html(){return{__html:"\n\n                                <p>Tel Aviv has long been known as a young and vibrant seaside city, where life is fast-paced and non-stop. And with countless bars, restaurants, beaches, museums, shops and attractions lining every free inch of prime Tel Aviv real estate, the recent revolution in the city\u2019s boutique hotel offerings in the past two years has paved the way for luxury and leisure packed vacations, combining action with relaxation and increased visitor satisfaction.</p>\n\n                                <h3>A unique, personalized touch</h3>\n\n                                <p>If you are seeking a unique hospitality experience in a trendy neighborhood establishment that blends into the local infrastructure, a Tel Aviv boutique hotel stay is just what you need. Perfectly bringing together desired service and amenity features with an added increasingly personalized customer service, boutique hotels are known for their staff\u2019s exemplary accommodating attention to their visitors\u2019 every request and fancy.</p>\n\n                                <p>Built in converted heritage sites, restored old buildings or other contemporarily designed structures, each Tel Aviv neighborhood boutique hotel possesses unique themes, concepts and characteristics. Defined by their souls and coupled with uniquely designed guest rooms and a high level of customized service, the boutique hotels have great views of the \u201CCity that Never Sleeps\u201D from sprawling rooftop terraces, in-house spas, internet hubs and restaurants.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t            <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/boutique-hospitality/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t            Credit: Dana Friedlander\n\t\t\t\t\t            </div>\n\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t<h3>Live the big city</h3>\n\n                                <p>Looking to enjoy a romantic couple\u2019s getaway, find a quiet place to unwind during a weeklong business conference, gather your family for an intimate reunion or hang out with friends for a fun beach vacation? Don\u2019t want to travel far from your hotel room or sit in traffic to reach big city attractions, nightlife and events? The warm and inviting yet luxurious nature of boutique hotel stays in Tel Aviv provide the ideal hospitality experience that lets you \u201Clive\u201D Tel Aviv like a local, minus the onus of cleaning your own rooms and preparing your own meals.</p>\n\n                                <p>Think of boutique hotels as upscale and authentic guest houses in the heart of the big city. Somewhere you can go to escape the hustle and bustle when it\u2019s time to relax and be pampered, but still be able to pop out on a whim and casually enjoy the plethora of sites and services Tel Aviv offers the public, just like any one of  the city\u2019s locals. And with many of the city\u2019s boutique hotels situated in trendy areas, including in Neve Tzedek, along the coastline, in the diamond district and on Rothschild, Shenkin and Montefiore streets, a Tel Aviv boutique hotel stay is charming, authentic, pleasurable and exciting for all hospitality seekers.</p>\n            \n\n         "};}},{id:10,bgImage:"/posts/bank/12/1.jpg",mobBgImage:"/posts/bank/12/M.jpg",ctg:"telaviv",isVid:false,title:"Culture Time",smltitle:" ",html:function html(){return{__html:"\n\n\t\t\t\t\t<h2>A variety of fascinating museums and unique galleries</h2>\n\n\t\t\t\t    <h3>\n\t\t\t\t        Tel-Aviv Museum of Art\n\t\t\t\t    </h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe Tel Aviv Museum of Art presents a variety of permanent and temporal exhibits at its home in the Helena Rubenstein Pavilion, located on Shaul Hamelech Boulevard, next to the Mann Auditorium. The permanent exhibits include some of the best works of Israeli art, as well as sculptures from the 20\u2019s until today. It features European paintings \u2013 impressionism and post-impressionism \u2013 from the 16th to the 19th centuries, as well as European and American works of the 20th century. The museum\u2019s graphic collection includes more than 20,000 prints and sketches. Among the museum\u2019s outstanding works are a unique selection of early painted reliefs of Alexander Archipenko and works by Chagall, which he donated to the museum before its establishment. Helena Rubenstein\u2019s well-known collection of miniature rooms is on permanent display in the pavilion, which bears her name.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t        OPENING HOURS:\n\t\t\t\t    </h3>\n\n\t\t\t\t    <p>\n\n                          Sun Closed <br>\n                          Mon, Wed, Sat 10:00-18:00 <br>\n                          Tue, Thu 10:00-22:00 <br>\n                          Fri 10:00-14:00 <br>\n                          Sat 10:00-16:00 (July-August closed on Sat)<br>\n                    </p>\n\n                    <p>\n                       For more information, click to the&nbsp;<a href=\"//www.tamuseum.org.il/en/default.aspx\" target=\"_blank\">Tel-Aviv Museum of Art</a>\n                    </p>\n\n                    <h3>\n                        Beit Hatfutsot: The Diaspora Museum\n                    </h3>\n\n                    <p>\n                       Beit Hatefutsot-The Jewish Diaspora Museum, situated on the Tel Aviv University campus, has gained honorary distinction throughout the Jewish world as the first museum of the history of the Jewish people to showcase the Jewish contribution to human creativity and culture over a period of more than two millennia. The Museum\u2019s permanent exhibition brings the story of the Jewish People throughout the Diaspora to life through drawings, video clips, films, reconstructed models and other means. The exhibit focuses on various subjects \u2013 including \u201CThe Jewish Family life cycle\u201D, \u201Cthe community\u201D, \u201Cthe faith\u201D, and \u201Cthe return to Zion\u201D.\n                    </p>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/10/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<p>\n\n                          For more information, click to the&nbsp;<a href=\"//www.bh.org.il/\" target=\"_blank\">Beit Hatfutsot: The Diaspora Museum</a>\n\n                    </p>\n\n                    <h3>\n                         Eretz Israel Museum\n                    </h3>\n\n                    <p>\n\n                            The Eretz Israel Museum- Tel Aviv is a multi-disciplinary institution. It presents the history of the land and its culture through an extensive permanent exhibit, in addition to a variety of temporary exhibits on subjects such as archaeology, ethnography, folklore, Judaica, cultural history, local identity, traditional crafts and functional arts. The museum\u2019s pavilions are scattered throughout a spacious courtyard with the ancient archaeological mound of Tel Kassile, at which excavations revealed valuable findings, positioned at its center. The museum houses a variety of reconstructed ancient production devices, including wine presses, an olive oil press, and a flour mill, along with a \u201Ccraftsperson\u2019s marketplace\u201D which showcases traditional work instruments that were used in the Land of Israel and throughout the region. There is also a sophisticated Planetarium with its \u201CJourney to the Universe\u201D program, and a museum shop offering a unique selection of locally produced gifts and ornaments.<br>\n\n                            OPENING HOURS:<br>\n\n                          Sun-Wed 10:00-16:00 <br>\n\n\n\n                          Thu 10:00-20:00<br>\n\n\n\n                          Fri-Sat 10:00-14:00<br>\n\n                        </p>\n\n                    <p>\n                       For more information, click to the <strong>&nbsp;</strong><a href=\"//www.eretzmuseum.org.il/e/\" target=\"_blank\">Eretz Israel Museum&nbsp;</a>\n                    </p>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Beit Ha\u2019ir\n\t\t\t\t\t</h3>\n\n\n\t\t\t\t\t<p>\n\n                          Beit Ha\u2019ir, renovated by the city, was the old City Hall in Tel Aviv-Yafo on Bialik Street, and is now a living display of the city\u2019s history.  Beit Ha\u2019ir has a new exhibition, which sums up the extensive collection of photos and stories featuring events, sites, and experiences of residents throughout the years, a project that was part of the centenary celebrations of the city. The main hall has a virtual display, including hundreds of documentary films and thousands of rare photos and documents that showcase major events in the early years of city life.  At Beit Ha\u2019ir you can also visit the Dizengoff House, the restored residence of Meir Dizengoff, first mayor of Tel Aviv-Yafo, which includes a permanent exhibition.\n\n                          <br>\n                          OPENING HOURS:\n                          Sun Closed\n                          Mon-Thu 9:00-17:00 <br>\n                          Fri-Sat 10:00-14:00\n                    </p>\n\n                    <p>\n                      For more information, click to the <a href=\"//www.eretzmuseum.org.il/e/\" target=\"_blank\">Beit Ha\u2019ir</a>\n                    </p>\n\n                    <h3>\n                        The Olympic Experience Museum\n                    <h3>\n\n                    <p>\n\n                          A new museum in Tel Aviv-Yafo, The Olympic Experience Museum, presents a one-hour, five-ring trip through the greatest Olympic records, with a special focus on Israel\u2019s finest moments. The Olympic Experience boasts state-of-the art high tech imaging and illustrations, audio-visuals presentations, holograms, interactive screens, hands-on trials and much, much more.\n\n                          Guided tours for organized groups every 30 minutes. Advanced reservation is recommended.\n\n                          Opening Hours: Sunday-Thursday: 10:00-18:00, Friday:  10:00-14:00\n\n                          The Olympic Experience, 6 Shitrit Street, Hadar-Yosef. Tel: +972-3-6498385\n\n                    </p>\n\n                    <p>\n                       For more information, click to the&nbsp;<a href=\"//www.olympic.one.co.il/General/Page.aspx?id=86&amp;siteid=2\" target=\"_blank\">The Olympic Experience Museum</a>\n                    </p>\n\n                    <p>\n\n                          Ilana Goor Museum in Jaffa\n\n                          The private home of this world renowned artist has been turned into a museum. You can see her sculptures, furniture, jewelry and get a glimpse into this unique Jaffa home <br>\n                          OPENING HOURS: <br>\n                          Sun-Fri 10:00-16:00 <br>\n                          Sat 10:00-18:00<br>\n                          <a href=\"//www.ilanagoormuseum.org/eng/\">www.ilanagoormuseum.org</a>\n                    </p>\n\n                    <h3>\n                         Palmach Museum\n                    </h3>\n\n                    <p>\n                        Rated #1 Tel-Aviv museum on Trip Advisor, this museum examines the Palmach, the military wing of the Zionist Movement, which functioned until the establishment of the State of Israel.\n                    </p>\n\n                    <p>\n                        For more information, click to the&nbsp;<a href=\"//info.palmach.org.il/show_item.asp?itemId=8096&amp;levelId=42798&amp;itemType=0\" target=\"_blank\">Palmach Museum</a>\n                    </p>\n\n                    <h3>\n                        Other unique Museums\n                    </h3>\n\n                    <p>\n                        Tel Aviv-Yafo is home to a variety of smaller, specialized museums, such as Beit Ben Gurion (The home of David Ben Gurion, Israel\u2019s first prime minister), Beit Hatanach (The home of the Bible), The Haganah (defense) Museum, The I.Z.L. (the Irgun Zva\u2019I Leumi \u2013 National Military Organization) Museum, Beit Hasofer (author\u2019s house), Beit Reuven, The Jabotinsky Museum, and many others. Each of these smaller museums is a treasure house of artifacts. For example, Beit Bialik \u2013 the house of the national poet, displays the books, furniture and belongings of Israel\u2019s renowned national poet. Bialik\u2019s personal library of more than 3,000 books has been preserved, and the museum\u2019s archives contain thousands of manuscripts, including the most extensive collection of his writings.\n                    </p>\n\n                    <h3>\n                        OPENING HOURS OF TEL AVIV MUSEUMS:\n                    </h3>\n                    <h3>\n                        Etzel Museum:\n                    </h3>\n\n                    <p>\n\n                          King George 38: Sun-Thu 8:30-16:00 <br>\n\n                          For more information, click to the&nbsp;<a href=\"//www.goisrael.com/Tourism_Eng/Tourist%20Information/attractions/Pages/Etzel%20Museum.aspx\" target=\"_blank\">Etzel Museum</a>\n                    </p>\n\n                    <h3>\n                        Ben Gurion House:\n                    </h3>\n\n                    <p>\n                            Sun, Tue-Thu 8:00-15:00 <br>\n                            Mon 8:00-17:00<br>\n                            Fri 8:00-13:00<br>\n                            Sat 11:00-14:00\n                    </p>\n\n                    <p>\n                       For more information, click to the&nbsp;<a href=\"//www.bg-house.org/?categoryId=6575\" target=\"_blank\">Ben Gurion House</a>\n                    </p>\n\n                    <h3>\n                        Jabotinsky Institute in Israel:\n                    </h3>\n\n                    <p>\n\n                        Sun-Thu 8:00-16:00 <br>\n                        For more information, click to the&nbsp;<a href=\"//en.jabotinsky.org/\" target=\"_blank\">Jabotinsky Institute in Israel</a>\n\n                    </p>\n\n                    <h3>\n                           The Israeli Museum:\n                    </h3>\n\n                    <p>\n                            Sun, Mon, Wed 9:00-17:00 <br>\n                            Tue, Thu 9:00-19:00<br>\n                            Fri 9:00-14:00 <br>\n                            For more information, click to the\n                            <a href=\"//www.imj.org.il/en/\">www.imj.org.il</a>\n                    </p>\n\n                    <h3>\n                       Jaffa Visitors Center:\n                    </h3>\n\n                    <p>\n\n                            Summer Sun-Thu, Sat 9:00-20:00<br>\n\n                            Fri 9:00-17:00<br>\n\n                            Winter Sun-Thu, Sat 9:00-18:00<br>\n\n                            Fri 9:00-15:00<br>\n\n                            For more information, click to the  <br>\n\n                            <a href=\"//www.touristisrael.com/old-jaffa-visitors-center/3604/\" target=\"_blank\">Jaffa Visitors Center</a>\n\n                    </p>\n\n                    <h3>\n                         Hall of Independence:\n                    </h3>\n\n                   <p>\n\n                            Sun-Thu 9:00-17:00 <br>\n\n                            Fri 9:00-14:00<br>\n\n                            For more information, click to the&nbsp;<a href=\"//eng.ihi.org.il/\" target=\"_blank\">Hall of Independence</a>\n\n                    </p>\n\n                    <h3>\n                        The Bible Museum:\n                    </h3>\n\n                    <p>\n\n                            Sun-Fri 10:00-13:00 + 16:00-18:30 <br>\n\n                            For more information, click to the&nbsp;<a href=\"//www.blmj.org/en/\" target=\"_blank\">The Bible Museum</a>\n\n                    </p>\n\n                    <h3>\n                        Joseph Bau house:\n                    </h3>\n\n                    <p>\n\n                            By appointment only (including weekends) <br>\n\n                            For more information, click to the&nbsp;<a href=\"//www.josephbau.com/\" target=\"_blank\">Joseph Bau house</a>\n\n                    </p>\n\n                    <h3>\n                        Rubin Museum:\n                    </h3>\n\n                    <p>\n\n                            Sun Closed <br>\n\n                            Mon, Wed, Thu 10:00-15:00 <br>\n\n                            Tue 10:00-20:00<br>\n\n                            Sat 11:00-14:00<br>\n\n                            For more information, click to the &nbsp;<a href=\"//www.rubinmuseum.org.il/\" target=\"_blank\">Rubin Museum</a>\n\n                    </p>\n\n                    <h3>\n                        Art Galleries\n                    </h3>\n\n                    <p>\n                        Don\u2019t miss the dozens of fine galleries, primarily located along Gordon Street and in the Old City of Jaffa, featuring the very latest in contemporary Israeli art. We won\u2019t say another word- we\u2019ll let the art speak for itself.\n                    </p>\n\n         "};}},// {
// 	    id:99,
//         bgImage : "/posts/bank/20/1.jpg",
//         mobBgImage : "/posts/bank/20/M.jpg",
//         ctg:"jerusalem",
//         isVid:true,
//         vidId:'k4OwoEk5wMw',
//         title : "JERUSALEM MAIN SITES ",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 					<!--<div class="responisve-iframe">
// 						<iframe src="https://www.youtube.com/embed/k4OwoEk5wMw/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1" height="315" width="560" allowfullscreen="" frameborder="0"></iframe>
// 					</div>-->
// 					<h3>
// 				    	Discover the history that stretches back thousands of years
// 				    </h3>
// 					<p>
// 						Like any city, the charm and essence of Jerusalem is best absorbed by walking its streets. However, depending on your interests, you don’t want to miss out on exploring at least some of these major attractions.
// 					</p>
// 					<p>
//                          When visiting religious sites, it’s advised to dress modestly and wear clothing that covers your knees and elbows.
//                     </p>
// 					<p>
//                        A good place to start is Jerusalem’s Old City, which has a very special and distinct atmosphere and is where many of the major attractions of Jerusalem are found.
//                     </p>
//                     <h3>
//                         OLD CITY
//                     </h3>
//                     <h3>
//                         JERUSALEM WESTERN WALL
//                     </h3>
//                     <p>
//                       The Western Wall, also known as the Wailing Wall and Kotel, is the western retaining wall of the Second Temple. Considered Judaisms’s holiest site, the wall is divided into a men’s and women’s section where worshipers congregate throughout the day for morning, afternoon and evening services. Diverse crowds come to pray against the stones, to tuck small pieces of paper with prayers into the cracks and to simply marvel at the site.
//                     </p>
//                     <p>
//                           Address: Jewish Quarter, Old City <br>
//                           Phone: +972-2-627-3515<br>
//                           Hours: 24/7<br>
//                     </p>
//                     <h3>
//                         VIA DOLOROSA
//                     </h3>
//                     <p>
//                         TCrossing the Muslim Quarter from east to west is this street that traces the last steps of Jesus Christ as he was led to his crucifixion. Popular with both pilgrims and general tourists, the route marks 14 events on Christ’s last walk and is also lined with shops and stalls. It is worth visiting on a Friday afternoon (3:00opm in winter; 4:00pm in summer) when the Franciscans lead a procession along the route.
//                         <br>Address: Via Dolorosa, Muslim Quarter, Old City.
//                     </p>
//                     <h3>
//                         JERUSALEM CHURCH OF THE HOLY SEPULCHER
//                     </h3>
//                     <p>
//                         One of the holiest sites for Christians, this impressive building draws millions of pilgrims from around the world every year. The compound is believed to be the site of Golgotha (the Hill of Calvary), where, according to the New Testament, Jesus was crucified, buried and resurrected.
//                         <br>
//                         Address: Between Suq Khan e-Zeit and Christian Quarter Rd, Christian Quarter, Old City<br>
//                         Phone: +972-2-627-3314 <br>
//                         Hours: Sun – Sat: 5:00am – 8:00pm/9:00pm
//                     </p>
// 					<h3>
// 					    DAVID’S CITADEL
// 					</h3>
// 					<p>
// 					   David’s Citadel (also known as the Tower of David) was originally built in the second century BC to strategically strengthen a weak point in the city’s defences, and was subsequently destroyed and rebuilt many times over the ensuing centuries. Since 1989, the grounds are home to a fascinating museum, which sheds light on the history of Jerusalem. Don’t forget to take in the splendid view of Jerusalem from its ramparts.
// 					</p>
// 					<p>
//                           Address: Jaffa Gate, Christian Quarter, Old City <br>
//                           Phone: +972-2-626-5333<br>
//                           Hours: Sun-Thu: 10:00am -4:00pm, Fri: Closed, Sat: 10:00am – 2:00pm (September-June), Sun-Thu:<br> 10:00am – 5:00pm, Fri: 10:00am – 2:00pm, Sat: 10:00am – 5:00pm (July-August)
//                     </p>
//                     <h3>
//                         CITY OF DAVID
//                     </h3>
//                     <p>
//                         Situated deep below ground in the Arab village of Silwan is the remains of the once-grand citadel where a dynasty of Judean kings once ruled. A massive visitors’ center offers a tour that begins with an observation point overlooking the remains of ancient Jerusalem, then continues underground with a look at recent archaeological finds and ends at the Gihon Spring, where according to tradition Solomon was anointed king. Visitors can also wade through the waters of the 2,700-year-old Hezekiah’s Tunnel.
//                     </p>
//                     <p>
//                           Address: Silwan, East Jerusalem <br>
//                           Phone: +972-2-626-2341<br>
//                           Hours: Sun-Thu: 8:00am – 5:00pm (winter), 8:00am – 7:00pm (summer), Fri: 8:00am – 1:00pm (winter), 8:00am – 3:00pm (summer)
//                     </p>
//                     <div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/posts/9/3.jpg"} class="img-responsive" />
// 					</div>
// 					<h3>
//                        MOUNT OF OLIVES
//                     </h3>
//                     <p>
//                         The hill that rises to the east of the Old City, the Mount of Olives, is a great place to take in views of the Old City and the Dome of the Rock. Its slopes are filled with holy and burial sites and are home to several grand churches including the Church of all Nations. To take in all the sights, it’s best to start at the top, near to the Mosque of Ascension, and walk downhill to the Tomb of the Virgin. The Old City views are best in the morning. <br>
//                         Address: Mount of Olives, East Jerusalem
//                     </p>
//                     <h3>
//                         YEMIN MOSHE
//                     </h3>
//                     <p>
//                         This charming neighbourhood facing the Old City walls was originally built to escape overcrowding in the 19th Century. It is known for its windmill and communal housing block, known as Mishkenot Shaananim, which is now a venue for art and culture. The area is home to artists, writers and academics and is renowned for its Oriental-style houses, green parks, a music center, the YMCA, King David Hotel, Herod’s Family Tomb. <br>
//                         CITY CENTER
//                     </p>
//                     <h3>
//                         MAMILLA ALROV AVENUE
//                     </h3>
//                     <p>
//                           Situated between the city center and the Old City, Mamilla Alrov Avenue is a pedestrian mall that offers a selection of luxury shops, as well as upscale restaurants and cafes. Mamilla is known for its chic and tasteful European feel, and offers spectacular views of the Old City walls. <br>
//                           Address: 6 Yitzhak Kariv St, Jerusalem <br>
//                           Phone: +972-2-636-0000<br>
//                           Hours: Sun-Thu: 10:00am – 9:30pm (winter), 10:00am – 10:30pm (summer), Fri: 9:00am – 2:00pm (winter), 9:30am – 3:30pm (summer), Sat: One hour after Shabbat – 11:00pm
//                     </p>
//                     <h3>
//                         BEN YEHUDA STREET
//                     </h3>
//                     <p>
//                     One of Jerusalem’s prime hangout spots for locals and tourists alike, Ben Yehuda Street is a pedestrian mall extending between King George Street and Jaffa Road in downtown Jerusalem. The street is filled with gift shops, falafel and ice-cream stores, buskers, beggars, musicians and street performers.
//                     </p>
// 					<h3>
//                         NACHALAT SHIVA
//                     </h3>
//                     <p>
//                           This charming cobblestone neighbourhood just south of Ben Yehuda Street in the&nbsp;<a href="//www.itraveljerusalem.com/placecategory/food-nightlife?multi_hood=11" target="_blank"><strong>city center</strong></a>&nbsp;offers a great selection of shops, restaurants, bars and outdoor cafes. This is a great place to experience in summer and at night with many bustling until late.
//                     </p>
//                     <h3>
//                        MEAH SHEARIM
//                     </h3>
//                     <p>
//                           Though it is just a few minutes’ walk from modern Ben Yehuda Street, the ultra-orthodox enclave of Mea Shearim is an entirely different reality. You will feel as though you have stepped into 18th Century Europe with Jewish Orthodoxy dressed in full traditional attire such as long black coats, black fur hats and stockings. When touring, it’s recommended to dress extremely modestly, covering up your wrists and ankles, and to take photos with discretion. <br>
//                           Address: Meah Shearim Rd, Jerusalem
//                     </p>
//                     <h3>
//                         Mahane Yehuda Market
//                     </h3>
//                     <p>
//                           Often referred to as “the shuk”, Mahane Yehuda Market offers a huge assortment of fresh produce and food, as well as a variety of other shops like clothing stores, kitchenware shops, jewellery stores, ceramic stores and a variety of gentrified eateries. The shuk includes an open air and closed area, bounded by Jaffa Road on the one side and busy Agripas Street on the other. It’s worth taking public  to the shuk as there is not a huge abundance of parking, and a great deal of traffic. If you can handle crowds, go on a Friday to experience last minute Shabbat shopping.<br>
//                           Address: Agripas and Jaffa Street, Jerusalem
//                     </p>
//                     <h3>
//                         OTHER AREAS OF JERUSALEM
//                     </h3>
//                     <h3>
//                        YAD VASHEM
//                     </h3>
//                     <p>
//                           Yad Vashem, Israel’s national Holocaust memorial, commemorates the six million men, women and children murdered by the Nazis and their allies. Located at the foot of Mt. Herzl, Yad Vashem comprises several moving memorials, including the Hall of Remembrance and the haunting Children’s Memorial; the Holocaust History Museum; the Museum of Holocaust Art; sculptures and installations; a massive archive and a research institute. Dress appropriately, and make sure to reserve at least a few hours for a visit to the Museum.  Address: Har Hazikaron <br>
//                           Phone: +972-2-644-3400
//                     </p>
//                     <h3>
//                        ISRAEL MUSEUM
//                     </h3>
//                     <p>
//                           You’ll want to devote at least a day to Israel’s largest cultural institution, the Israel Museum, which was re-launched in the summer of 2010 after a major overhaul. The Museum is made up of many different wings and a huge collection of art, archaeological findings and Judaica. One of the major highlights is the distinctly shaped Shrine of the Book, which houses many ancient manuscripts including the Dead Sea Scrolls. Other highlights include the Youth Wing for children, the Billy Rose Art Garden, which showcases the development of western sculpture over the centuries, the Museum’s Fine Arts Wing and its in-depth Archaeology Wing.
//                     </p>
//          `
//     }
//   }
// },
{id:"Sensational_Beaches",ctg:"telaviv",isVid:true,vidId:"XDei1Zy_cu4",bgImage:"/posts/bank/17/1.jpg",mobBgImage:"/posts/bank/17/M.jpg",title:"PLAGES SENSATIONNELLES",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\n\t\t\t\t\t<p>\n\t\t\t\t\t\tCome chill by the sunny beaches of Tel Aviv \n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tRelax by the sunny beaches of Tel Aviv Pull out the sunscreen, grab your \u2018matkot\u2019 and lets go play\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tTel Aviv-Yafo boasts a long promenade, running alongside the seashore that makes up its western edge. People walk, jog, ride bikes, or sit on benches and fill their lungs with fresh air, all while being surrounded by a glorious 8.7 mile stretch of open views, blue horizons, and white sails bobbing on the waves.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDozens of restaurants, cafes, and ice cream parlors are busy all day long, while pubs, discos and jazz clubs blossom after dark. Regardless of the hour, human attractions abound \u2013 clowns, caricaturists, tattoo artists, hair-braiders, magicians and of course, the ever- changing parade of people strolling by the nearby beaches beckon. Right off the promenade you\u2019ll find clean sand, lounge chairs, ice-cream vendors, and die-hard beach-lovers that swim daily, winter and summer, no matter what. Each of Tel Aviv\u2019s 13 beautiful beaches enjoys unique characteristics and offers a variety of services, including lifeguard stations, kiosks, restaurants, children\u2019s playgrounds, outdoors gyms, and more.\n\t\t\t\t\t</p>\n\n                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/13/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tA Few Tips\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<ul>\n                      <li>On Friday afternoons at the Dolphinarium beach, you can join in on an improvised drumming festival and a Brazilian martial arts/dance/music combination called capoeira.</li>\n                      <li>Gordon beach is great for beach volleyball.</li>\n                      <li>The religiously observant will find gender-specific swimming at Hof Hadatiyim (Nordau Beach), just south of the Tel Aviv port. Women and girls bathe Sunday, Tuesday and Thursday while men and boys are allowed in on Monday, Wednesday and Friday. Members of both genders are allowed on Saturday.</li>\n                      <li>The gay-lesbian community tends to gravitate to the stretch near the Hilton, which has earned the unofficial title as the city\u2019s most gay-friendly beach.</li>\n                      <li>The narrow strip of sand near the Marina is less crowded and more peaceful than the other beaches, at the yacht basin, you can rent windsurfers, surfboards, sailboats, motorboats and diving equipment.</li>\n                      <li>Surfing is popular at Hilton Beach, where a special light system was recently installed to allow for night surfing.</li>\n                      <li>Kite Surfing is popular at Aviv Beach.</li>\n                      <li>To windsurf, go to Dolfinarium Beach.</li>\n                      <li>Volleyball can be found at both Aviv and Gordon beaches.</li>\n                      <li>The city\u2019s beaches are well equipped with changing rooms, showers and toilets. Lifeguard services are available during seasonal timing (May-October) and tourist police officers are present to provide security, assistance and information services.</li>\n                  \t</ul>\n\n                  \t<h3>\n\t\t\t\t\t\tFun Facts\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<ul>\n                      <li>8,500,000 bathers enjoy the beaches yearly.</li>\n                      <li>The official bathing season is May-October.</li>\n                      <li>There are 13 beaches along Tel Aviv-Yafo\u2019s coastline.</li>\n                      <li>Four beaches are accessible to people with disabilities: Tzuk, Northern Tzuk, Metzizim and Hilton (all in the northern part of the city).</li>\n                      <li>The Tel Aviv-Yafo beaches rank highly in tests run by the Israeli Ministry of the Environment and are considered to be very clean.</li>\n                      <li>An Israeli version of racquetball, called&nbsp;<a href=\"//www.gomatkot.com/the-game/\">Matkot</a>, is a favorite sport played along the shorelines (watch your head!).</li>\n                      <li>Watermelon with feta cheese is a very popular beach snack. Artikim, or popsicles, are also well liked, with the banana-chocolate flavor ranking at the top of most people\u2019s list.</li>\n                 \t</ul>\n\n                  \t<h3>\n\t\t\t\t\t\tBeach Guidelines\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<ul>\n                      <li>Bathers must comply with the lifeguard and rescue guards.</li>\n                      <li>Bathing is prohibited when there is no lifeguard on duty.</li>\n                      <li>Sea bathing is prohibited when the black flag is raised.</li>\n                      <li>NO motor sports (jet skis, boats) are allowed.</li>\n                      <li>Motorized vehicles are forbidden on beaches and boardwalk.</li>\n                      <li>Building a fire is prohibited on beaches.</li>\n                    </ul>\n\n                    <h3>\n                    \tBathing Season\n                    </h3>\n\n\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tThe 2016 Tel Aviv bathing season opens on May 9 2016 and will end on October 31 2016.\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tDuring the duration of the season, rescue services, supervision and first aid will be given to the following beaches: North Beach Cliff, South Beach Cliff, Tel Baruch Beach, Hilton Beach, Gordon Beach, Frishman Beach, Borgashov Beach (opening delayed due to renovations), Jerusalem Beach, Charles Clore Beach, Givat Aliyah Beach.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\tHours of activity:\n\t\t\t\t\t\t</strong>\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\tMay 9-31: 7am-5pm <br />\n\t\t\t\t\t\tJune: 7am-6pm<br />\n\t\t\t\t\t\tJuly-August: 7am-7pm<br />\n\t\t\t\t\t\tSeptember-October: 7am-5pm<br />\n\t\t\t\t\t\tInspection and clearing will be provided in all beaches mentioned above, from 7am until the evening hours.\n\t\t\t\t\t</p>\n\n\t\t\t\t\t<p>\n\t\t\t\t\t\t<strong>\n\t\t\t\t\t\t\tThe price list of the beaches is:\n\t\t\t\t\t\t</strong>\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tPita or bread with humus or salad \u2013 12 NIS <br />\n\t\t\t\t\t\tSmall bottle of mineral water \u2013 7 NIS<br />\n\t\t\t\t\t\tPopsicle \u2013 5 NIS<br />\n\t\t\t\t\t\tReclining Beach chair for the day \u2013 12 NIS<br />\n\t\t\t\t\t\tBeach chair for the day \u2013 6 NIS<br />\n\t\t\t\t\t\tUmbrella for the day \u2013 6 NIS<br />\n\t\t\t\t\t</p>-->\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tNational Geographic Magazine's \u201COne of the 10 best beach cities in the world\u201D\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t   With clear waters and action-packed beaches, each one of Tel Aviv\u2019s 16 beaches has its own style and attracts certain personalities - from hippie casual to Riviera chic. Day or night, hanging out on the beach is one of the best ways to spend time in Tel Aviv.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t    Beach activities\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t    Tel Aviv\u2019s shoreline offers a huge variety of fun beach and water activities, where you join in a game of paddle ball (a national favorite), join a friendly game of beach-volleyball or enjoy the many water sports on offer such as surfing, kayaking, boating and diving.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/13/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t    The 'Tayelet' (Promenade)\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t    A stunning newly renovated promenade, where you can walk, bike, rollerblade or even Segway and enjoy the lively atmosphere and colorful stream of people as you become taken by its infectious energy and the beautiful beachside views.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tFun Facts\n\t\t\t\t\t</h3>\n\n\t\t\t\t\t<ul>\n                      <li>8,500,000 bathers enjoy the beaches yearly.</li>\n                      <li>The official bathing season is May-October.</li>\n                      <li>There are 16 beaches along Tel Aviv-Yafo\u2019s coastline.</li>\n                      <li>Four beaches are accessible to people with disabilities: Tzuk, Northern Tzuk, Metzizim and Hilton (all in the northern part of the city).</li>\n                      <li>The Tel Aviv-Yaffo beaches rank highly in tests run by the Israeli Ministry of the Environment and are considered to be very clean.</li>\n                      <li>Watermelon with feta cheese is a very popular beach snack. Artikim, or popsicles, are also well liked, with the banana-chocolate flavor ranking at the top of most people\u2019s list.</li>\n\n                 \t</ul>\n\n         "};}},{id:"Modern_And_Vibrant_Video",bgImage:"/posts/bank/modern-and-vibrant-video/1.jpg",mobBgImage:"/posts/bank/modern-and-vibrant-video/M.jpg",ctg:"jerusalem",isVid:true,// vidId: "cUBBkziv_4c",
vidId:"V0Acsw3Hf_M",title:"MODERNE ET VIBRANTE",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<br/>\n\t\t\t\t<h2 class=\"ac-align-center ac-margin-top-20\">Tant \xE0 voir dans le centre-ville anim\xE9 de J\xE9rusalem</h2>\n\t\t\t\t<p class=\"ac-align-center ac-margin-bottom-20\"><b>Le nouveau & l\u2019ancien J\xE9rusalem</b></p>\n\t\t\t\t<p>\n\t\t\t\t\tBienvenue \xE0 J\xE9rusalem \u2013 o\xF9 son pass\xE9 glorieux est \xE9troitement li\xE9 \xE0 sa vie moderne et dynamique.<br/>\n\t\t\t\t\tJ\xE9rusalem abrite d\u2019innombrables sites historiques fascinants, des promenades magiques, des vues \xE0 couper le souffle au coucher du soleil, une grande vari\xE9t\xE9 de choix de divertissements, des restaurants qui procurent des \xE9motions culinaires, une vie nocturne anim\xE9e ainsi qu\u2019une offre consid\xE9rable de centres artistiques et culturels.\n\t\t\t\t</p>\n\n\t\t\t\t<p>Trouver l'inspiration \xE0 J\xE9rusalem</p>\n\n\t\t\t\t<p>Cela ne fait aucun doute, J\xE9rusalem est une des villes les plus fascinantes au monde. Depuis des si\xE8cles, elle offre un savant m\xE9lange de religions, traditions, histoire antique et modernit\xE9 urbaine qui intrigue les visiteurs. C'est \xE9galement cet aspect qui attire les artistes dans cette ville. La J\xE9rusalem d'aujourd'hui propose une multitude de mus\xE9es, galeries, march\xE9s et festivals culturels qui, combin\xE9s, constituent une sc\xE8ne artistique et culturelle vivante et unique. Pr\xE9parez-vous \xE0 y trouver l'inspiration.</p>\n\t\t\t\t\n\t\t\t\t<p>D\xE9couvrez. Sur une colline, \xE0 c\xF4t\xE9 de la Knesset et de la Cour supr\xEAme d'Isra\xEBl, se trouve la plus grande institution culturelle d'Isra\xEBl et un des plus importants mus\xE9es mondiaux d'art et d'arch\xE9ologie, le Mus\xE9e d'Isra\xEBl. Commencez par l'aile arch\xE9ologique. Organis\xE9es chronologiquement, les pi\xE8ces que vous y verrez constituent la collection la plus compl\xE8te au monde d'artefacts arch\xE9ologiques bibliques et de Terre sainte. Poursuivez votre visite en explorant la splendide aile consacr\xE9e \xE0 l'art et \xE0 l'ethnologie juive, l'impressionnante collection de beaux-arts et les expositions provisoires d'art contemporain. Ne manquez pas les \u0153uvres cl\xE9s du mus\xE9e : le sanctuaire du Livre, qui contient les manuscrits de la mer Morte, et le magnifique jardin de sculptures, qui fait face aux montagnes de J\xE9rusalem. Un conseil : prenez votre temps ; ce mus\xE9e est \xE0 la fois fascinant et accessible, et il donne tant \xE0 voir.</p>\n\t\t\t\t\n\t\t\t\t<p>\xC0 quelques pas du Mus\xE9e d'Isra\xEBl, vous trouverez le fascinant Mus\xE9e des Pays de la Bible. Qualifi\xE9 de \xAB capsule temporelle interactive \xBB, il est le seul mus\xE9e de son genre dans le monde. D\xE9ambulez dans les galeries et d\xE9couvrez les merveilles du quotidien des cultures anciennes du Proche-Orient, ainsi que leurs interactions depuis l'aube de la civilisation jusqu'au d\xE9but de l'\xE8re chr\xE9tienne.</p>\n\t\t\t\t\n\t\t\t\t<p>Multipliez les exp\xE9riences. Allez dans la Colonie des artistes de J\xE9rusalem (Hutzot Hayotzer) et \xE9veillez-vous \xE0 la cr\xE9ativit\xE9. Ce complexe d\xE9di\xE9 \xE0 l'art et \xE0 l'artisanat accueille l'atelier d'artistes et cr\xE9ateurs de diff\xE9rents corps de m\xE9tier. Fl\xE2nez dans cette rue pittoresque o\xF9 se c\xF4toient ateliers et galeries sous la muraille nord de la Vieille ville, et regardez les artistes \xE0 l'\u0153uvre. \xC9coutez leurs histoires, familiarisez-vous avec les techniques artistiques traditionnelles et contemporaines et achetez leurs \u0153uvres.</p>\n\t\t\t\t\n\t\t\t\t<p>Admirez le Spectacle son et lumi\xE8re de la Tour de David, \xE9galement appel\xE9 \u2018\u2019Jerusalem Night Spectacular\u2019\u2019. Ce splendide spectacle nocturne emploie une technologie moderne pour faire d\xE9couvrir l'histoire de la ville et sublimer la beaut\xE9 de la Tour. Les jeux de lumi\xE8re 3D et la musique donnent vie aux murailles et paysages sous les yeux des spectateurs qui ont vraiment le sentiment d'\xEAtre entra\xEEn\xE9s dans un r\xEAve.</p>\n\t\t\t\t\n\t\t\t\t<p>Participez aux festivit\xE9s. J\xE9rusalem poss\xE8de une histoire tr\xE8s riche ; c'est \xE9galement une ville moderne et anim\xE9e qui adore la f\xEAte. Consultez le riche programme de festivals et \xE9v\xE9nements culturels de la ville, et profitez du meilleur de ce que J\xE9rusalem a \xE0 vous offrir tout au long de l'ann\xE9e.</p>\n\t\t\t\t\n\t\t\t\t<p>Assistez au Festival d'Isra\xEBl, une importante manifestation multidisciplinaire internationale proposant des repr\xE9sentations th\xE9\xE2trales, de danse contemporaine, de musique classique ainsi que des spectacles du monde entier. Visitez la Foire des arts et artisanats Hutzot Hayotzer o\xF9 vous rencontrerez des artistes isra\xE9liens et internationaux\u2026 Allez au March\xE9 nocturne de J\xE9rusalem et promenez-vous entre les \xE9tals des artistes et cr\xE9ateurs en tous genres exposant et vendant leurs produits ; prenez-en plein les yeux au Festival des lumi\xE8res de J\xE9rusalem qui donne une dimension spectaculaire \xE0 la veille ville ; \xE9coutez de l'op\xE9ra au Festival d'op\xE9ra de J\xE9rusalem. Organis\xE9es \xE0 la Piscine du Sultan, les repr\xE9sentations permettent de profiter de la douceur des nuits d'\xE9t\xE9 de J\xE9rusalem avec un splendide panorama pour toile de fond.</p>\n\t\t\t\t\n\t\t\t\t<p>Ne manquez pas non plus le Festival de musique sacr\xE9e de J\xE9rusalem. Programm\xE9 dans le cadre de la Saison culturelle de J\xE9rusalem, ce festival extraordinaire r\xE9unit des artistes d'horizons, cultures et traditions tr\xE8s diverses qui interpr\xE8tent et explorent les musiques sacr\xE9es du monde entier.</p>                \n                            \n\n         "};}},{id:"Modern_And_Vibrant_Post",bgImage:"/posts/bank/39/1.jpg",mobBgImage:"/posts/bank/39/M.jpg",ctg:"jerusalem",isVid:true,vidId:"1Yx2Uht4rms",title:"Moderne et dynamique",smltitle:"",html:function html(){return{__html:"\n\n                \n                             \n                             <br/>\n                             <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Il y a tant \xE0 voir dans le centre-ville anim\xE9 de J\xE9rusalem</h2>\n                              <p>\n\t\t\t\t\t\t\t\tLe centre-ville de J\xE9rusalem constitue le coeur de cette m\xE9tropole moderne, regorgeant de vie nocturne, de restaurants et de curiosit\xE9s culturelles, rivalisant avec les plus grandes villes du monde.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tLa zone est compos\xE9e de plusieurs quartiers ainsi que de lieux attrayants comme le charmant Nahalat Shiva, la rue anim\xE9e Jaffa et la rue Ben Yehuda avec son caract\xE8re si singulier et son atmosphere \xE0 ne pas manquer.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tLe centre de J\xE9rusalem comprend certains quartiers les plus charmants de la ville ainsi que quelques-unes des attractions les plus fascinantes. Pour vivre une exp\xE9rience culturelle incomparable, partez \xE0 la d\xE9couverte des mus\xE9es passionnants de J\xE9rusalem, parmi lesquels le Mus\xE9e d\u2019Isra\xEBl de renomm\xE9e mondiale, le Mus\xE9e des pays de la Bible et le Mus\xE9e des sciences Bloomfield.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\tLe march\xE9 Mahane Yehuda\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tD\xE9couvrez l\u2019atmosph\xE8re et la diversit\xE9 incomparables de ce march\xE9 qui attire chaque jour des milliers de touristes. Une fois que la journ\xE9e de shopping est termin\xE9e et que les vendeurs de denr\xE9es ferment boutique, rejoignez la jeune foule branch\xE9e, m\xEAlant \xE9trangers et locaux, qui se rend sur le march\xE9 pour boire un verre et faire la f\xEAte jusqu\u2019au petit matin, dans les bars, les restaurants et les all\xE9es.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\tNahalat Shiva\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tCe charmant quartier pav\xE9 situ\xE9 au coeur de la ville offre une excellente s\xE9lection de boutiques, de restaurants, de bars et de caf\xE9s en terrasse. Nahalat Shiva abrite Kikar Hamusica (la place de la Musique) \u2013 un espace ext\xE9rieur anim\xE9 et tendance qui programme de la musique live tout au long de la semaine.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\tYemin Moshe\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tCe joli quartier qui fait face aux remparts de la Vieille Ville fut \xE0 l\u2019origine construit pour \xE9chapper \xE0 la surpopulation au 19e si\xE8cle. Terre d\u2019accueil pour les artistes, les \xE9crivains et les chercheurs, Yemin Moshe est r\xE9put\xE9 pour son magnifique moulin \xE0 vent et ses maisons au style oriental, ses parcs verdoyants, son centre de musique contemporaine ainsi que ses vues imprenables.\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t\tEin Kerem\n\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tNich\xE9 dans une paisible vall\xE9e entre les montagnes et les collines en terrasses au sud-ouest de J\xE9rusalem, Ein Kerem est l\u2019un des quartiers les plus pittoresques de J\xE9rusalem. Avec ses ruelles pav\xE9es et sineuses, ses charmantes maisons de pierres orn\xE9es d\u2019arcades, ses \xE9glises dont les cloches sonnent dans l\u2019air pur, Ein Kerem d\xE9borde de charme et de beaut\xE9 tel une \xEEle dans un oc\xE9an de for\xEAt verdoyante.\n\t\t\t\t\t\t</p>\n\n         "};}},// {
// 	    id:"Jerusalem_After_Dark_Fun",
//         bgImage : "/posts/bank/modern-and-vibrant/1.jpg",
//         mobBgImage : "/posts/bank/modern-and-vibrant/M.jpg",
//         ctg :"jerusalem",
//         isVid:true,
//         vidId:"nLKWDp5uA-U",
//         title : "After Dark Fun in the Holy City",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 					            <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem’s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>
//                               <p>To check it out, make your way to the City Center and explore the narrow streets just off Jaffa Street. There you’ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. Rivlin Street is a popular hangout for young people, while Shoshan Street and the surrounding area offers a more laid-back grown up vibe.</p>
//                               <div class="img-wrapper">
// 						          <img src=${getImgUrl() +  "/posts/modern-and-vibrant/1.jpg"} class="img-responsive" />
// 					          </div>
//                               <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing. </p>
//                               <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session. </p>
//                               <p>For a daytime change of pace head to the German Colony (Moshava) and, particularly, the neighborhood of Baka. Start at Beit Lechem Street where you’ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up Emek Refaim Street or through HaMesila (Railway) Park until you reach The First Station – once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>
//          `
//     }
//   }
// },
{id:"Jerusalem_Musts",bgImage:"/posts/bank/38/1.jpg",mobBgImage:"/posts/bank/38/M.jpg",ctg:"jerusalem",isVid:true,// vidId: "k4OwoEk5wMw",
vidId:"FvAWuLQEOJw",title:"Jerusalem ‘Musts’",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t    <h2>5 top things to do and see in the stunning city</2>\n\t\t\t\t\t\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tSegway Tours\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThis adrenaline-packed way of seeing the city will allow you to take in the\n\t\t\t\t\t\tbeauty of Jerusalem from an entirely unique perspective. The Segway\n\t\t\t\t\t\ttours leave from various central spots, including the Armon HaNatziv\n\t\t\t\t\t\tPromenade (East Talpiot), Yemin Moshe and the Old City, as well as near\n\t\t\t\t\t\tthe Knesset and the museum area.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tThe First Station (Hatachana)\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe First Station is right at the heart of Jerusalem, between the Old\n\t\t\t\t\t\tCity and the City Center, between the historic neighborhoods of the\n\t\t\t\t\t\tGerman Colony and Yemin Moshe. It is the site of the first train station\n\t\t\t\t\t\tin Jerusalem, which was built in 1892. After undergoing renovation and\n\t\t\t\t\t\tpreservation, the First Station was reopened as a lively entertainment\n\t\t\t\t\t\tspot, open seven days a week.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tThe Time Elevator\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tIf you are a fan of joy rides, you will love having your senses scintillated\n\t\t\t\t\t\tby the Time Elevator. It\u2019s an interactive experience that takes visitors on\n\t\t\t\t\t\tfabulous voyages to fascinating places, with motion-based seating in a\n\t\t\t\t\t\tunique hall, filled with special effects.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jerusalem-must/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tThe Biblical Zoo\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSpreading over 62 acres, this beautiful two-tiered zoo centers on a vast\n\t\t\t\t\t\tman-made lake complete with waterfalls and side pools, surrounded\n\t\t\t\t\t\tby spacious lawns and shaded resting spots. To the delight of children\n\t\t\t\t\t\tand adults alike, there are over 200 species on view, most of them\n\t\t\t\t\t\tmentioned in the Bible and some almost made extinct in the interim.\n\t\t\t\t\t\tThis does not mean that regular animals are not present they even have\n\t\t\t\t\t\tpenguins here. Near the Zoo there is a beautiful, huge and impressive\n\t\t\t\t\t\tAquarium, open for visitors during the day and evening, displaying marine\n\t\t\t\t\t\thabitat from the Mediterranean Sea, the Red Sea and more.\n\t\t\t\t\t</p>\n\t\t\t\t\t<h3>\n\t\t\t\t\t\tTeddy Park\n\t\t\t\t\t</h3>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tNamed after Teddy Kollek who was Mayor of Jerusalem between 1965-\n\t\t\t\t\t\t1995; Teddy park is fun, beautiful and historically significant.\n\t\t\t\t\t\tThe park constitutes a significant meeting point between the Old and\n\t\t\t\t\t\tNew Jerusalem and includes a wishing pond, an impressive sun clock\n\t\t\t\t\t\toriginal sculpture, restorations of historical properties and a fantastic\n\t\t\t\t\t\twater fountain attraction, featuring a spectacular light and sound\n\t\t\t\t\t\tevening show.\n\t\t\t\t\t</p>\n\n         "};}},{id:16,bgImage:"/posts/bank/34/1.jpg",ctg:"eilat",isVid:true,vidId:"yXzhH92kREg",mobBgImage:"/posts/bank/34/M.jpg",title:"NEGEV MAJESTIC DESERT",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h2>Action adventures in the desert sun. With so much to see and do, there is never a dull moment in the Negev</h2>\n\n\t\t\t\t\t<!--<div class=\"responisve-iframe\">\n\t\t\t\t\t\t<iframe src=\"https://www.youtube.com/embed/yXzhH92kREg/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t</div>-->\n\t\t\t\t\t<h3 class=\"negev-secondary-title\">\n\t\t\t\t\t\t\t\t The Negev Desert - Pure Magic Desert\n\t\t\t\t\t\t\t</h3>\n\n\n\t\t\t\t\t\t\t\n\n\n                            <!--negev text-->\n\n                            <p>\n\t\t\t\t\t\t\t\tThe Israeli desert with its breathtaking landscape and various attractions is offering the perfect place for a holiday. The Negev invites the visitors to an exciting journey that is rich in variety of opportunities.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tIsrael is a small country with 62% of the total area occupied by the Negev desert. The reddish gleaming desert terrain is characterized by many impressive geological rock formations. The visitors enjoy here a unique view of an untouched vastness - silent and majestic.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t\tThere are traces of past civilizations and their agriculture as well as archaeological sites. The Negev offers an unmistakable backdrop for encountering the Bedouin tribes - people of the desert.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<h2>\n                                The Israeli desert is special for the following reasons:\n                            </h2>\n\n\t\t\t\t\t\t\t<ul class=\"p-margin\">\n\t\t\t\t\t\t\t    <li>\n\t\t\t\t\t\t\t\t\t\t<b>The desert is very near:</b> just 4 hours of flying from Europe. Israel has two international airports - Ben Gurion and Ovda, which guarantee a short trip to the desert to all travellers (half an hour to an hour and a half).\n\t\t\t\t\t\t\t\t\t\tStarting from November, there will be direct flights from Europe and Russia to Ovda airport including Ryanair, Wizzair, and SAS.\n\t\t\t\t\t\t\t    </li>\n                                <li>\n                                        <b>Easy to Hike and Bike:</b> There are a lot of marked paths. Israel offers the most imposing hiking trails of the world and hundreds of safe paths lead through the Israeli desert. You can find a selection of trails on the following websites:<br>\n                                        <a href=\"//www.negevtour.co.il\" target=\"_blank\">www.negevtour.co.il</a>\n                                        <a href=\"//www.en.aravaway.co.il \" target=\"_blank\">www.en.aravaway.co.il</a>\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t    <li>\n                                        <b>Cordial local population:</b> The desert dwellers are friendly and hospitable and make the desert experience both pleasant and exciting for visitors.\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t    <li>\n                                        <b>Tourists Activities:</b> Along with the development of accommodation, the huge offer of tourist activities has converted the Negev in a popular, interesting, versatile and creative destination in recent years.\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t    <li>\n                                        <b>Magnificent landscapes:</b> Lots of tourists today, enjoy the charm of the Negev with its landscapes rich in variety<br>\n                                        <ul>\n                                        \t<li>\n                                        \t\tThere are spectacular sand dunes in the north.\n                                        \t</li>\n                                        \t<li>\n                                        \t\tThe Ramon Crater is present in the middle with its bold cliffs and seasonal water sources.\n                                        \t</li>\n                                        \t<li>\n                                        \t\tIn the east, one experiences the African desert with wide savannas and acacia trees.\n                                        \t</li>\n                                        \t<li>\n                                        \t\tTo the south, one finds red and black granite, contrasted by sandstone foothills having a powerfully pleasant colour.\n                                        \t</li>\n                                        </ul>\n                                        During a desert trip of approx. 3 hours, you can get to know the entire spectrum of the desert landscape and enjoy its variety, which one experiences in other deserts often only with a long trip of several kilometers.\n\t\t\t\t\t\t\t\t\t\tMany tourists decide for to stay for 2 or 3 days in each region of the Negev.\n\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t    <li>\n                                        <b>The Negev is very safe to travel.</b> In case of emergency, the rescue units working in the area are some of the best trained in the world and are always close by. Should anyone require medical assistance, Israel offers high quality, first class advanced western medical services.\n\t\t\t\t\t\t\t    </li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t<h2>\n\t\t\t\t\t\t\t    More information and tips for accommodation and recommendations:\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t   <a href=\"//www.negevtour.co.il/homepage/accommodation/?lang=en\" target=\"_blank\">www.negevtour.co.il</a><br>\n\t\t\t\t\t\t\t   <a href=\"https://en.aravaway.co.il/business/category/1/\" target=\"_blank\">www.en.aravaway.co.il</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t   <a href=\"//goisrael.de/taxonomy/term/85\" target=\"_blank\">Travel deals</a><br>\n\n\t\t\t\t\t\t\t</p>\n\n\n\n\n                            <!--Negev - s-->\n\n\t\t\t\t\t\t\t<h3>\n\t\t\t\t\t\t\t    NEGEV - LOCATION AND APPROACH\n\t\t\t\t\t\t\t</h3>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t   Landing at the airports of Ovda or Eilat with the  onward journey to Mitzpe Ramon or Sde Boker:\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<h2>\n\t\t\t\t\t\t\t   Public means of :\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tBus 392 from Eilat to Mitzpe Ramon and Be'erSheva, stops at the airport of Ovda on Sunday at 07:13, 08:41, 09:43, 14:12, 15:41, 17:43.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tArrival at the central bus station of Mitzpe Ramon after about an hour and a half.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tMondays - Thursdays at 07:13, 07:41, 09:43, 14:12, 15:41, 17:43.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t   <a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">Bus service </a><br>\n\t\t\t\t\t\t\t   <a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">Shuttle service from Ovda Airport </a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<h2>\n\t\t\t\t\t\t\t   Car rental in Eilat, Mitzpe Ramon and Be'erSheva:\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tThere a multiple option in renting a car in these cities.\n                                There is a choice of international and Israeli companies.\n\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t\tLanding at the Ben Gurion International Airport near Tel Aviv and onward journey for Negev to Mashabei Sadeh / Sde Boker / Mitzpe Ramon\n\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<h2>\n\t\t\t\t\t\t\t   Public means of :\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tBus routes 370/380 from Tel Aviv to Be'erSheva, routes 446/470 from Jerusalem to Be'erSheva.\n\t\t\t\t\t\t\t\t<a href=\"//www1.rail.co.il/EN/Pages/Homepage.aspx\" target=\"_blank\">Train from Ben Gurion or Tel Aviv to Be'erSheva.</a>\n                            </p>\n                            <p>\n\t\t\t\t\t\t\t\tFrom Be'erSheva bus routes 60, 64, 65, 660 Departure every morning 6 o'clock onward (approx. every 20 minutes).\n                                Arrival in Mashabei Sadeh in 35 minutes / SdeBoker area in 55 minutes / Mitzpe Ramon in 1 hour 20 minutes.\n                            </p>\n                            <p class=\"p-margin\">\n\t\t\t\t\t\t\t\tMore information about the public means of  is given <a href=\"https://www.bus.co.il/otobusimmvc?Language=en\" target=\"_blank\">here</a> or <a href=\"//www.egged.co.il/HomePage.aspx\">here</a>\n                            </p>\n\n\n                             <!--NEGEV DESERT-don't miss-->\n\n\n\n\n\n\n\n\n                            <h3 class=\"margin-h\">\n                                 NEGEV ROAD DISTANCES\n                            </h3>\n\t\t\t\t\t\t\t<table>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <th></th>\n\t\t\t\t\t\t\t    <th>Tel Aviv</th>\n\t\t\t\t\t\t\t    <th>Jerusalem</th>\n\t\t\t\t\t\t\t    <th>Bee'r Sheva</th>\n\t\t\t\t\t\t\t    <th>Eilat</th>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"> <strong>Old Town <br class=\"show-on-mobile\"> Beer Sheva</strong></td>\n\t\t\t\t\t\t\t    <td>113 Km</td>\n\t\t\t\t\t\t\t    <td>122 Km</td>\n\t\t\t\t\t\t\t    <td></td>\n\t\t\t\t\t\t\t    <td>232 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Tel Arad</strong></td>\n\t\t\t\t\t\t\t    <td>134 Km</td>\n\t\t\t\t\t\t\t    <td>144 Km</td>\n\t\t\t\t\t\t\t    <td>40 Km</td>\n\t\t\t\t\t\t\t    <td>229 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Ben-Gurion's House <br class=\"show-on-mobile\">in Sde Boker</strong></td>\n\t\t\t\t\t\t\t    <td>162 Km</td>\n\t\t\t\t\t\t\t    <td>171 Km</td>\n\t\t\t\t\t\t\t    <td>49 Km</td>\n\t\t\t\t\t\t\t    <td>185 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Ramon Crater</strong></td>\n\t\t\t\t\t\t\t    <td>210 Km</td>\n\t\t\t\t\t\t\t    <td>192 Km</td>\n\t\t\t\t\t\t\t    <td>97 Km</td>\n\t\t\t\t\t\t\t    <td>141 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Hai Bar Wildlife <br class=\"show-on-mobile\"> reserve Yotvata</strong></td>\n\t\t\t\t\t\t\t    <td>323 Km</td>\n\t\t\t\t\t\t\t    <td>288 Km</td>\n\t\t\t\t\t\t\t    <td>202 Km</td>\n\t\t\t\t\t\t\t    <td>35 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t  <tr>\n\t\t\t\t\t\t\t    <td class=\"place-table\"><strong>Timna Park</strong></td>\n\t\t\t\t\t\t\t    <td>330 Km</td>\n\t\t\t\t\t\t\t    <td>294 Km</td>\n\t\t\t\t\t\t\t    <td>208 Km</td>\n\t\t\t\t\t\t\t    <td>30 Km</td>\n\t\t\t\t\t\t\t  </tr>\n\t\t\t\t\t\t\t</table>\n\n                            <h3>\n\t\t\t\t\t\t\t\tNEGEV DESERT - DON'T MISS\n\t\t\t\t\t\t\t</h3>\n\n\t\t\t\t\t\t\t <h2>\n                                Ramon Crater\n                            </h2>\n\n                            <p>\n                                At the heart of Israel\u2019s vast Negev Desert, lies the Ramon Crater, the world\u2019s largest erosion crater,also known as Machtesh Ramon.\n\t\t\t\t\t\t\t\tEncompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an longated heart, and forms Israel\u2019s largest national park, the Ramon Nature Reserve.\n\t\t\t\t\t\t\t\tFar from the city lights and crowds, featuring multicolored sandstone, volcanic rock and fossils, the Ramon Crater is often described as Israel\u2019s very own Grand Canyon.\n\t\t\t\t\t\t\t\tThe truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/7.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h2>\n                                Timna Park\n                            </h2>\n\n                            <p>\n                               15,000 acres in a horseshoeshaped valley surrounded by steep cliffs, Timna Park is an extraordinarily stunning experience and an absolute treat for hiking enthusiasts. Here you'll witness the marvelous works of nature, as well as the amazing wildlife, plants and trees which make the desert their home, surviving in the harsh arid conditions.\n                               With its multitude of attractions, colorful sands and craggy mountains, Timna Park is an incomparable visitor magnet.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/9.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h2 class=\"title-to-play\">\n\t\t\t\t\t\t\t\tCLICK TO PLAY: Timna Park - An Exhilarating Desert Adventure\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t    <iframe src=\"https://www.youtube.com/embed/i_4QKtXIeto/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\n\n                            <h2>\n\t\t\t\t\t\t\t    Sandboarding in the desert\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tAn iconic desert experience. The plush sweeping sand dunes of the Negev desert allow you to glide down sitting down or standing up at an exhilarating pace. This is a fantastic and very special skill, which once you master (it\u2019s really very easy) you can call yourself a genuine sand surfer \u2013 how cool is that?\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<!--<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>-->\n\n\t\t\t\t\t\t\t<h2>\n\t\t\t\t\t\t\t    Negev at night\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tThe sky of the Negev at night is a mesmerizing sight. Simply look up once darkness sets and you will immediately be struck by the splendor of millions of twinkling stars, lighting up the blue-black darkness in a radiance that can only be seen in the dessert.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h2>\n\t\t\t\t\t\t\t    Sunrise at Masada\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tAvailable only to those brave enough to climb atop by foot - watching the Sunrise at Masada is undoubtedly one of the most unforgettable experiences to be had in Israel. The slow rise of the sun as it emerges over the Jordanian Moab Mountains and the Dead Sea, shedding its light on the surrounding desert landscapes, is a truly spectacular sight, one which you will not soon forget.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/6.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t\t<h3>\n                                NEGEV - ISRAEL\u2019S MAJESTIC DESERT\n                            </h3>\n                            <h2>\n                                Where Adventure and Inspiration Await\n                            </h2>\n                            <p>\n                              An ideal destination for travelers who love adventure in the great outdoors.\n\t\t\t\t\t\t\t  The south of Israel is sparsely populated, but packed with fascinating sites and activities.\n\n                            </p>\n                            <p class=\"p-margin\">\n                                With amazing natural wonders and beauty, the South boasts magnificent views that are guaranteed to take your breath away, from sunrise to sunset.\n\t\t\t\t\t\t\t\tA desert but definitely not deserted, there is so much to see and do here \u2013 there are many extraordinary geological marvels, significant historical landmarks and wonderful nature reserves, where you can go hiking, cycling and camel riding, or enjoy adrenaline-charged safari rides in the desert.\n\t\t\t\t\t\t\t\tSimply put, this majestic Southern region is one of the country\u2019s greatest assets and an absolute must on the itinerary.\n\n                            </p>\n\n\n\t\t\t\t\t\t\t<h2>\n                                Sde Boker\n                            </h2>\n\n                            <p class=\"p-margin\">\n                                A remarkable glance to the history of the State of Israel, Sde Boker is a Kibbutz originally established by pioneers, with the mission to settle the Negev in the early 50\u2019s.\n                                Sde Boker is renowned as the home of David Ben Gurion, Israel\u2019s first Prime Minister whose home is now a museum open to the public.\n\n\n                            </p>\n\n                            <h2>\n                                Vidor Center\n                            </h2>\n\n                            <p class=\"p-margin\">\n                                A truly unique attraction, offering a multi-sensory experience of the exceptional nature of the Arava region. Visitors to the center can discover advanced farming methods, the local flora and fauna, climate challenges, and special qualities of the soil and water of the desert.\n                            </p>\n\n\n\n                            <h2>\n                                Nevatim\n                            </h2>\n\n                            <p class=\"p-margin\">\n                               A visit to Nevatim, the home to Cochin Jews, is a fascinating experience. Cochin Jews, originally from India, immigrated to Israel after the establishment of the State. Cochin Jews consider themselves as one of the most ancient Jewish communities in the world.\n                               The Center for Cochin Heritage at Moshav Nevatim tells the story of this unique community.\n                            </p>\n\n                            <h2>\n\t\t\t\t\t\t\t   MidBurn Festival\n\t\t\t\t\t\t\t</h2>\n\n\t\t\t\t\t\t\t<p class=\"p-margin\">\n\t\t\t\t\t\t\t\tIsrael\u2019s own version of the famous \u201CBurning Man\u201D festival; where for 6 days, a temporary city is set up in the Negev desert, creating a platform which allows a communal life style, creativity, art and radical self-expression.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t    <iframe src=\"https://www.youtube.com/embed/QL3BGy2p77g/?autoplay=1&amp;mute=1&amp;rel=0&amp;loop=1\" height=\"315\" width=\"560\" allowfullscreen=\"\" frameborder=\"0\"></iframe>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<br>\n\n                            <h2>\n                                The Bedouin Experience\n                            </h2>\n\n                            <p>\n                               The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.\n                               A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality. From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a longforgotten way of life.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/8.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h2>\n                                The Culinary Queens of Yeruham\n                            </h2>\n\n                            <p class=\"p-margin\">\n                              For a truly memorable local experience, make sure to visit the Culinary Queens of Yeruham \u2013 a unique project, in which the wonderful women of Yeroham host tourists from far and wide for an excellent traditional meal in their homes, creating an unforgettable experience of smells, colors and flavors.\n                              Get to know the real life of locals through their fascinating stories, while tasting the ethnic delicacies and enjoying their amazing hospitality.\n\n                            </p>\n                            <h2>\n                                The Old City of Be'er Sheva\n                            </h2>\n\n                            <p class=\"p-margin\">\n                               Said to have been founded by biblical Abraham, Be'er Sheva is one of the oldest cities in the country, with evidence of a settlement dating back thousands of years. As charming as it is historic, the old city of Be'er Sheva offers a fascinating mosaic of urban spaces, and exploring the Old City will reveal a rare wealth of unique architecture, extensive history and stories as old as time.\n                            </p>\n                            <h2>\n                                Carasso Science Park\n                            </h2>\n\n                            <p>\n                               New in the Old City of Be\u2019er Sheva, the Carasso Science Park, spread over 4.25 acres, is the largest science park in Israel.\n                               Engaging and entertaining for all ages, Carasso Science Park features an interactive museum and a scientific garden with games and hands-on activities. The park also offers ten interactive exhibitions in various fields of science including: Genetics, Communication, Microelectronics, Nuclear Energy and more.\n\n                            </p>\n                            <h2>\n                                Arad\n                            </h2>\n\n                            <p class=\"p-margin\">\n                               Arad of the new millennium is a town with young spirit and rich experience. Arad and its surroundings have been blessed with beautiful landscapes, desert tranquility, and many walking trails nestled amongst untouched desert nooks, suitable for any age or style.\n                               With lots of attractions and plenty of tourism sites in and around the city, Arad is the perfect starting point and your natural gate to the perfect desert vacation.\n\n                            </p>\n\n\n\t\t\t\t\t\t\t<h2>\n                               Yotvata Hai-Bar\n                            </h2>\n\n                            <p>\n                               The Yotvata Hai-Bar Nature Reserve is the area\u2019s largest animal breeding and reclamation center for animals before they are reintroduced into the wild. The reserve boasts wonderful attractions that are an absolute delight for animal lovers, including the predators\u2019 center with its live predators and small desert animals, a Nocturnal animal\u2019s observatory in dark room conditions and 12 square kilometers of ground where herds of herbivores roam free.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/10.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\n\t\t\t\t\t\t\t<h2>\n                               Extreme Adventures\n                            </h2>\n\n                            <p>\n                               The south of Israel is a total dream destination for adventure-hungry travelers.  Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.\n\n                            </p>\n\n                            <div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/11.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<h2>\n\t\t\t\t\t\t\t    Camel rides\n\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\tA definite throwback, this is still most authentic way to explore the marvelous desert surrounding. Riding on the back of a Camel is an activity found in a number of camel farms across the Negev and one guaranteed to last in your memory.\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t<div class=\"img-wrapper img-page3\">\n\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/5.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\t</div>\n\n\n                            <!--NEGEV - \u05D5PDATED TEXT SITES-->\n\n                            <h3>\n                                EVENTS IN THE NEGEV: CALENDAR\n                            </h3>\n\t\t\t\t\t\t\n\n\n\t\t\t\t\t\t\t<div class=\"row-1 mounth-row\">\n\t\t\t\t\t             <div class=\"mounths active\">\n\t\t\t\t\t            <p id=\"myHeader1\" data-div=\"newboxes1\" onClick=\"toggleMounth(event)\" href=\"\">January <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\n\t\t\t\t\t         <div class=\"mounths month-mid\">\n\t\t\t\t\t            <p id=\"myHeader2\" data-div=\"newboxes2\" onClick=\"toggleMounth(event)\" href=\"\">February <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\n\t\t\t\t\t         <div class=\"mounths\" >\n\t\t\t\t\t            <p id=\"myHeader3\" data-div=\"newboxes3\" onClick=\"toggleMounth(event)\" href=\"\">May <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t         <div class=\"mounths month-mid\">\n\t\t\t\t\t            <p id=\"myHeader1\" data-div=\"newboxes4\"onClick=\"toggleMounth(event)\"  href=\"\">June <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t         <div class=\"mounths\">\n\t\t\t\t\t            <p id=\"myHeader2\" data-div=\"newboxes5\" onClick=\"toggleMounth(event)\" href=\"\">July <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\t\t\t\t\t        </div>\n\n\n\n\t\t\t\t\t        <div class=\"row-2 mounth-row\">\n\t\t\t\t\t          <div class=\"mounths\" >\n\t\t\t\t\t            <p id=\"myHeader3\" data-div=\"newboxes6\" onClick=\"toggleMounth(event)\" href=\"\">August <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t         <div class=\"mounths month-mid\">\n\t\t\t\t\t            <p id=\"myHeader1\" data-div=\"newboxes7\"onClick=\"toggleMounth(event)\"  href=\"\">October <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t         <div class=\"mounths\">\n\t\t\t\t\t            <p id=\"myHeader2\" data-div=\"newboxes8\" onClick=\"toggleMounth(event)\" href=\"\">November <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\n\t\t\t\t\t         <div class=\"mounths month-mid\" >\n\t\t\t\t\t            <p id=\"myHeader3\" data-div=\"newboxes9\" onClick=\"toggleMounth(event)\" href=\"\">December <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/Negev/icon/a-down.png")+" class=\"img-responsive icon-a-down\" /></p>\n\t\t\t\t\t         </div>\n\n\t\t\t\t\t        </div>\n\n\n\n\t\t\t\t\t         <div class=\"newboxes\" id=\"newboxes1\" style=\"    display: block;\"> <!--Jen-->\n\t\t\t\t\t                Round The Arava Race - The 63-kilometer bike race named after Yoni Friedman offers a breathtaking desert landscape, endless expanses of nature, the power of spirituality, serenity and serenity and a connection to an extraordinary sporting experience. The starting point and end of the race are in Moshav Hatzeva.<br>\n\t\t\t\t\t                <a href=\"https://www.arava-active.co.il/MenuDefault.aspx?id=4240\" target=\"_blank\">www.arava-active.co.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes2\"><!--Feb-->\n\t\t\t\t\t                Darom Adom is an annual festival held during the Anemone flower's blossoming season in the northern Negev region. The festival offers agricultural tours, farmers' markets, and countryside lodging, as well as sports activities such as marches, race, bike tours through the red fields of the northern Negev and other activities such as artistic performances. The local tourism association \"Shikma Besor\" is responsible for the festival and its yearly activities.<br>\n\t\t\t\t\t                <a href=\"//daromadom.habsor.co.il/\" target=\"_blank\">www.daromadom.habsor.co.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes3\"><!--May-->\n\t\t\t\t\t                The cherry festival takes place in the Yatir Forest, which is the largest forest in Israel where large orchards of orchards grow, and is a 5-minute drive from Be'er Sheva. The event includes a cherry harvest for the whole family, sweet and sour snacks, baking pita bread, sheep herding, cheese gibbon, local farmers' market, klezmer melodies, climbing wall, omega and many other activities for the whole family.<br>\n\t\t\t\t\t                <a href=\"//kinderland.co.il/events/%D7%A4%D7%A1%D7%98%D7%99%D7%91%D7%9C-%D7%93%D7%95%D7%91%D7%93%D7%91%D7%9F-%D7%91%D7%99%D7%A2%D7%A8-2017-%D7%A7%D7%98%D7%99%D7%A3-%D7%A2%D7%A6%D7%9E%D7%99-%D7%A9%D7%9C-%D7%93%D7%91%D7%93%D7%91%D7%A0/\" target=\"_blank\">www.kinderland.co.il</a>\n\t\t\t\t\t        </div>\n\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes4\"><!--June-->\n\t\t\t\t\t                Experience the magic of Ramadan nights in Rahat - when the night becomes a day and the streets are bustling with life. Join an unforgettable tour at the most special time of the year, giving a unique glimpse into Bedouin culture in Rahat. Meet the authentic dishes, absorb the fragrances of spices and roasted coffee, discover the secrets of Rahat from local guides and enjoy street performances, Debka music and more.<br>\n\t\t\t\t\t                <a href=\"//ramadan-nights.co.il/\" target=\"_blank\">www.ramadan-nights.co.il</a><br>\n\t\t\t\t\t                The Cinema South Festival, initiated by the School of Sound and Screen Arts at Sapir Academic College, started in 2002 with an emphasis on student films. Within a few years, however, became the festival an international film festival that provides a central stage for Israeli cinema, international quality and radical cinema. The festival takes place every year in June for five full days in various locations throughout the northern and western Negev. This is a festival that opens its doors to anyone, free of charge. The South Cinema Festival is produced from a unique cultural agenda relevant to the place where it was created.<br>\n\t\t\t\t\t                <a href=\"//csf.sapir.ac.il/csf2017/csf.sapir.ac.il/index.html\" target=\"_blank\">www.csf.sapir.ac.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes5\"><!--July-->\n\t\t\t\t\t               The International Fringe Festival Beer Sheva is a multi-disciplinary festival that crosses audiences and ages and constitutes a quality stage for the best Israeli and international artists from the fields of theater, dance, music, street art and the plastic arts. The festival is considered one of the major fringe events in Israel and the largest and leading cultural festivals in the south of the country. The festival was recently received by the EFFE (European Festivals Association) and is gaining a reputation as a prestigious event.<br>\n\t\t\t\t\t               <a href=\"https://www.iffb7.com/\" target=\"_blank\">www.iffb7.com</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes6\"> <!--Aug-->\n\t\t\t\t\t               Negev Of Stars - Like every summer, the Earth passes through the shrapnel left behind by the comet SWIFT-TATTLE. These fragments penetrate our atmosphere and create a spectacular view of \"shooting stars\". During this time in the Negev celebratethe people the amazing experience of the Perseid Meters, a number of astronomical events - a joint observation of the meteor shower, observation points with elaborate telescopes, lectures and many other activities.\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes7\"><!--Oct-->\n\t\t\t\t\t                The Tamar Festival is a combination of the ideal Israeli soundtrack and the spectacular vista of Masada and the Dead Sea region. The extraordinary experience takes place with concerts over 4 days at various locations and at different times over 24 hours, when the audience ventures out to the country's most extraordinary sites and landscapes.<br>\n\t\t\t\t\t                <a href=\"//www.tamarfestival.com/\" target=\"_blank\">www.tamarfestival.com</a><br>\n\t\t\t\t\t                Desert Magic Festival - The first Bedouin festival: A variety of experiential activities for the whole family that provide an authentic glimpse into the ancient Bedouin tradition.<br>\n\t\t\t\t\t                <a href=\"//www.kesem-hamidbar.co.il/\" target=\"_blank\">www.kesem-hamidbar.co.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes8\"><!--Nov-->\n\t\t\t\t\t                The Arava Film Festival is a unique event that has been going on for several years every November in the heart of the Arush Nature Reserve, adjacent to Tzukim. The films at the festival are screened in the evening and in the night, under the stars in the open air. They are the first line of international production that has been screened at world film festivals in the last year. Among the films of the festival are films for children and teenagers, as well as short films produced and filmed during the past year in the Arava. The films are screened on a giant screen and the audience can relax on a spacious and surprisingly comfortable platform, which was built especially for this purpose in the valley between the mountain cliffs of the eastern Negev.<br>\n\t\t\t\t\t                <a href=\"https://www.aravaff.co.il/\" target=\"_blank\">www.aravaff.co.il</a>\n\t\t\t\t\t        </div>\n\t\t\t\t\t        <div class=\"newboxes\" id=\"newboxes9\"><!--Dec-->\n\t\t\t\t\t                Ben-Gurion's march has been taking place for more than 20 years, at the initiative of the Ramat Negev Regional Council, following the daily sporting march of the first Prime Minister, David Ben-Gurion, during his stay in Kibbutz Sde-Boker. The march takes place on three tracks \u2013 a short track for families (7 km), a medium pathway (15 km) and a long one (22 km).<br>\n\t\t\t\t\t                <a href=\"//www.zaadatbg.org.il/\" target=\"_blank\">www.zaadatbg.org.il</a><br>\n\t\t\t\t\t                 Docaviv Negev - Docaviv, the Tel Aviv International Documentary Film Festival, is the largest film festival in the city of Tel Aviv, and the only festival in Israel dedicated in its entirety to documentary films. In order to expose as wide an audience as possible to documentary work, the NPO also organizes a regional festivals: Docaviv Negev, held in Yeruham, as well as dozens of documentary film screenings at cultural centers located throughout the country. Each year, Docaviv NPO awards Israel\u2019s largest prize for an original Israeli documentary production, and alongside it, prizes for the Best International Film Award, prizes for outstanding student filmmakers, and an additional prize within the Depth of Field framework, for innovative, inspiring documentary films from around the world.<br>\n\t\t\t\t\t                <a href=\"//www.docaviv.co.il/\" target=\"_blank\">www.docaviv.co.il</a>\n\t\t\t\t\t        </div>\n\n\n\n\n                            <a href=\"//graphics-lapam.org.il/clients/tayarut/negev/files/assets/basic-html/page-1.html#\" target=\"_blank\">FOR MORE IMFORMATION CLICK HERE </a>\n\n\n         "};}},{ctg:"telavivAndJerusalem",isVid:false,id:41,bgImage:"/posts/bank/46/1.jpg",mobBgImage:"/posts/bank/46/M/1.jpg",title:"Tel Aviv and Jerusalem",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t<h2>Nonstop fun for the whole family</h2>\n\n              \t\t<p>\n\t\t\tTravelling with kids to Tel Aviv and Jerusalem is a fantastic experience. Both cities, as is most of the country, are extremely family oriented, and from nature to culture, there is absolutely loads of amazing attractions and exciting activities for families to enjoy together. Wherever you turn, you\u2019re likely to find children out and about with parents, grandparents or groups.              \t\t\n\t\t</p>\n              \t\t<p>\n\t\t\tWith up to 300 sunny days a year, the beautiful beaches of Tel Aviv are a favorite destination for locals and tourists alike. The beaches themselves offer a fabulous combination of sun and fun the Tel Aviv boardwalk to is a great place for kids to walk, run or ride along on a bike or a mini scooter, and there are plenty of playgrounds and cafes.\n              \t\t</p>\n              \t\t<p>\n\t\t\tFor a fun day outdoors, take a picnic basket to the lovely Yarkon Park and enjoy bike riding, boating or running around. Tel Aviv also offers a multitude of hands-on museums and exhibitions, free performances, especially in the gorgeous Tel Aviv port area and outdoor entertainment guaranteed to keep visitors of all ages entertained.\n              \t\t</p>\n              \t\t<p>\n\t\t\tA visit to Jerusalem will ignite the imaginations of your little ones with its quaint alleyways, unique museums and fascinating history. with shady parks, water fountains and children-oriented exhibits and shows, there\u2019s definitely something for every age.\n              \t\t</p>\n              \t\t<p>\n\t\t\tAn incredible variety of food will keep all the kids, and adults, of your group happy. From outdoor food stalls to sit-down restaurants there is no shortage of places to eat and most restaurants and caf\xE9s offer children\u2019s\u2019 meals at considerably reduced rates. \n              \t\t</p>\n              \t\t<p>\n\t\t\tYour visit to Tel Aviv or Jerusalem with the young ones is guaranteed to be fun and rewarding.\n\t\t\tHere are just a few of the fabulous ways you can have a great family time in Jerusalem and Tel Aviv, all you and yours need to do is choose and go go go: \n              \t\t</p>\n\t\t<div class=\"img-wrapper\">\n\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/35/1.jpg")+" class=\"img-responsive\" />\n\t\t</div>\n              \t\t<h3>\n              \t\t\tTel Aviv\n              \t\t</h3>\n              \t\t<p>\n\t\t\t<strong>\"Luna Park\":</strong> A fantastic amusement park in the heart of the city offering a range of fun and exciting rides and attractions for the entire family. Right across from the beautiful Hayarkon Park, the green lung of Tel Aviv.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>HaYarkon Park:</strong> The tranquil Yarkon Park on the outskirts of the busy city offers beautiful green expanses, boating on the river, cycling along the bike paths, sports fields, and much more for the whole family. Enjoy a picnic with a view of the stunning Tel Aviv Skyline.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Hot Air Balloon:</strong> After relaxing in gorgeous HaYarkon Park, get high with a view of gorgeous Tel Aviv like you\u2019ve never seen it before, float above the Yarkon Park in an experience that is suitable for romantic trips or family fun.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Observatory:</strong> While in Azrieli, be sure to check out the amazing top floor observatory located on the top floor for an 360 view of Tel Aviv the little ones will not soon forget.  \n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Planetarium:</strong> Offering a fun introduction to astronomy, you\u2019ll be transported into space by interactive exhibits, revolving seats and informative presentations to suit the whole family.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Safari:</strong> With the largest collection of animals in the Middle East, you can spend a wonderful day in the wild, just 15 minutes from the heart of Tel Aviv, where you can check out the rest of the city\u2019s stunning attractions.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>HaTachana:</strong> Tel Aviv\u2019s Old Railway Station: A delight for the whole family, the Old Train Station complex offers something for everyone with restaurants, kids activities, art galleries, street performances, and even a train carriage ride.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Tel Aviv Port:</strong> Breath in the sea air and vies from the gorgeous marina, get some food in any of the  and check out the awesome street performances of music, magic theatre and more geared specifically for the joy of the little ones. \n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Nachlat Binyamin Street Fair:</strong> The biggest of its kind in Israel, the fair is a bright and bustling experience of crafts, live music, street performances, and cafes that will appeal to people of all ages.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Sarona:</strong> A trendy hub of restaurants, cafes, and bars, the covered market is a popular destination for couples, groups and families looking for one of the most happening places in the city.\n              \t\t</p>\n              \t\t<h3>\n              \t\t\tTel Aviv Museums\n              \t\t</h3>\n              \t\t<p>\n\t\t\t<strong>Tel Aviv Museum of Art:</strong> With a large number of collections, guides, creative and interactive activities, and games, the museum is a treasure for parents and children alike.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Museum of Natural History:</strong> Opened in 2018, the 5-floor museum with its 3,000 items, gives children the possibility to see the country\u2019s creatures right up close.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Olympic Experience Museum:</strong> Available via guided tours, offering an interactive glimpse into the history of sport in Israel through multimedia exhibits that are fun for the whole family.\n\t\t\tIndependence Hall- the birthplace of the State of Israel and the birthplace of the first Hebrew speaking city, Tel Aviv. A fascinating journey through history for the entire family. \n              \t\t</p>\n\t\t<div class=\"img-wrapper\">\n\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/35/2.jpg")+" class=\"img-responsive\" />\n\t\t</div>\n              \t\t<h3>\n              \t\t\tJerusalem \n              \t\t</h3>\n              \t\t<p>\n              \t\t\t<strong>City of David:</strong> An immersive archeological experience in the heart of Ancient Jerusalem including archeological digs, guided tours and a walk through an underground water tunnel.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Night Spectacular Sound & Light Show:</strong> A stunning first of its kind show where the walls of the Citadel become the stage for a nighttime show celebrating Jerusalem\u2019s 4,000-year-old history through sights and sounds.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Aquarium:</strong> One of the hottest attractions in Jerusalem, opened at the end of 2017, it offers a captivating adventure through the four seas of Israel that will thrill everyone, from young to old.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Time Elevator:</strong> Immerse yourself in virtual reality on a journey through the fascinating history of Jerusalem, with shaking seats and special effects that will amaze the youngsters among you.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Botanical Gardens:</strong> A stunning gem in the heart of the city featuring more than 6,000 species of plants from around the world, it is an interesting and tranquil location for anyone to enjoy.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Segway Tours:</strong> Suitable for older teens to adults, Segway tours offer an unforgettable experience through fascinating areas, allowing you to enjoy the modern to the ancient character of the city.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Mini Israel:</strong> Offering hundreds of mini replicas of Israeli landmarks, it offers a unique birds-eye view of historical, religious, and modern sites around the country.\n              \t\t</p>\n              \t\t<h3>\n              \t\t\tJerusalem Museums\n              \t\t</h3>\n              \t\t<p>\n              \t\t\t<strong>Israel Museum:</strong> A leading art and archeological museum absorbing you in the rich history and culture of the country and its people, with exhibits to interest visitors of all ages.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Tower of David Museum:</strong> The historic entrance to the Old City of Jerusalem, the medieval citadel features 3D models, hidden passageways, and family tours and activities.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>Ein Yael Active Museum:</strong> Providing an experiential journey through an old Roman street, creative workshops, pita baking, and one-on-one meetings with period actors, families will love this day out.\n              \t\t</p>\n              \t\t<p>\n\t\t\t<strong>The Bloomfield Science Museum:</strong> A fantastic children oriented cultural and educational museum, that presents exhibitions and interactive exhibits on subjects of science and Technology. \n              \t\t</p>\n\n            \t"};}},{ctg:"telaviv",isVid:true,vidId:"ogEN7aRT0SM",id:"Party_Capital",bgImage:"/posts/bank/party-capital/1.jpg",mobBgImage:"/posts/bank/party-capital/M.jpg",title:"Party Capital",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t<div class=\"ac-cradit\">\n\t\t\t\t\t\t\t<span class=\"ac-cradit-text\">Credits:</span>\n\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text-1\">Tel Aviv Jaffa municipality<br/></span<\n\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text-2\">UDINI prodactions<br/></span>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t</div>\n\n                            <h2>Epic Nights in the non stop city</h2>\n              \t\t        <p>Tel Aviv is rightly famous as one of the world\u2019s great nightlife cities, with her warm Mediterranean climate making it ideal to party outdoors for most of the year. As the sun goes down the city transforms into a welcoming nighttime experience that\u2019s pulsing with life.</p>\n\n                            <h3>Tel Aviv by Night</h3>\n                            <p>No matter what time it is, there\u2019s always something going on in Tel Aviv. Watch the sun go down at a casual beach bar, feet in the warm sand and a cold drink in your hand, before moving on to taste craft brews in a packed, friendly pub, enjoy an exotic cocktail in a relaxed bar or eat something delicious before heading off to one of Tel Aviv\u2019s pumping, pulsing clubs to dance the night away.</p>\n                            \n                            <p>Foodies will love the amazing cocktails mixed by Tel Aviv\u2019s expert baristas, Israel\u2019s lively pub scene serving craft beers and snacks, and the restaurants that range from elegant to casual to street pop-ups, offering every possible style and type of food. Eat your heart out!</p>\n                            <div class=\"img-wrapper\">\n\t\t\t                    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/party-capital/1.jpg")+" class=\"img-responsive\" />\n\t\t                    </div>\n                            <h3>Making the Most of Tel Aviv\u2019s Nightlife</h3>\n                            <p>Spend a relaxed evening in an upmarket wine bar in a trendy neighborhood like Neve Tzedek, where you\u2019ll be introduced to some of Israel\u2019s highly acclaimed wines. Move on to chill at one of the many bars that feature live bands, or enjoy some culture with your cocktails in one of Tel Aviv\u2019s new and exciting gallery bars that display pieces by up and coming artists.</p>\n\n                            <p>If you want a pumping party night on the town, Tel Aviv is the right place to find it. Tel Aviv\u2019s nightclubs are world-famous, often hosting international DJs. During the long summer season some of the beaches transform into nightclubs for all-night raves, with throbbing beats, lasers and pulsing music. The party doesn\u2019t reach full swing until 2am in most of Tel Aviv\u2019s wildly popular nightclubs, manned by top DJs. You\u2019ll find every time of club, from intimate to massive and from throwback dance to the newest electric indie beats.</p>\n\n                            <p>The LGBTQ scene is also hot in Tel Aviv, with some of the best parties and music nights hosted by gay-friendly clubs and bars. Whether you want chilled or full-on, cultural or flirty, you\u2019ll find countless places to hang out at every hour of the day and night.</p>\n                            <p>Tel Aviv\u2019s awesome nightlife scene has become famous worldwide. The city the doesn\u2019t stop is teaming up with endless possibilities designed for an epic night out! </p>\n                            <p>Start slow and easy in a bar at the chilled out Port of Tel Aviv, or grab yourself a shoreline table, perhaps at Jerusalem Beach. Order a beer, feel the sand between your toes, and watch the sunset.</p>\n                            <p>Now that you\u2019re in a mellow mood, it\u2019s time to get your groove on. you\u2019ll be spoiled for choice with upscale clubs, bracelet bars, and other hangouts around Tel Aviv\u2019s White City, Rothschild Boulevard and nearby streets (Levontin, Yehuda HaLevi, Lillenblum, and Allenby), with their trendy see and be seen vibe, filled with young party people all night long. </p>\n                            <div class=\"img-wrapper\">\n\t\t\t                    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/party-capital/2.jpg")+" class=\"img-responsive\" />\n\t\t                    </div>\n                            <p>A five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don\u2019t miss the up and coming hipster style Flea Market area in Jaffa.</p>\n                            <p>Want a more mainstream approach to a night on the town? Three streets \u2013 King George, Dizengoff, and Ibn Gabirol \u2013 will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.</p>\n                            <p>Wherever you go, you will always find where to have an awesome night in nonstop Tel Aviv! </p>\n\n            \t"};}},{id:"Mamilla_Avenue",bgImage:"/posts/bank/mamila-avenue/1.jpg",mobBgImage:"/posts/bank/mamila-avenue/M.jpg",title:"AVENUE MAMILLA UNE PROMENADE ARTISTIQUE",smltitle:"",ctg:"jerusalem",isVid:true,vidId:"V0Acsw3Hf_M",html:function html(){return{__html:"\n                               \n\n\t\t                            <br/><h2  class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Les magasins de luxe modernes se marient \xE0 la splendeur de l'ancienne J\xE9rusalem</h2>\n\t\t\t\t\t\t\t\t\t<p>L'Avenue Alrov Mamilla se trouve au carrefour de l'ancienne et de la nouvelle J\xE9rusalem, face aux magnifiques remparts de la ville ancienne et \xE0 seulement quelques pas de la Porte de Jaffa et du Mur occidental. Proche de la vieille ville, cette galerie marchande \xE0 ciel ouvert est aussi pris\xE9e des habitants que des touristes, parce qu'elle leur apporte le meilleur des deux mondes - une histoire riche, la culture locale et des commerces de luxe, dans un lieu privil\xE9gi\xE9 de renomm\xE9e internationale.</p>\n\n\t\t\t\t\t\t\t\t\t<p><strong>Un complexe moderne de divertissement au pied de la vieille ville de J\xE9rusalem </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Foulez les rues pav\xE9es de J\xE9rusalem et int\xE9ressez-vous aux plaques qui relatent l'histoire des structures historiques du quartier.&nbsp; Assistez aux repr\xE9sentations de th\xE9\xE2tre de rue, prenez place dans l'un (ou plus) des restaurants et caf\xE9s locaux et appr\xE9ciez la qualit\xE9 et la diversit\xE9 des boutiques proposant des marques locales et internationales.</p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t                             <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/mamila-avenue/1.jpg")+" class=\"img-responsive\" />\n\t\t                             </div>\n\t\t\t\t\t\t\t\t\t<p>Le soir, allez-vous relaxer dans l'un des excellents bars du quartier. En levant la t\xEAte, vous pourrez admirer la vue spectaculaire de la vieille ville qui s'\xE9tend juste devant vous. Il n'existe aucun lieu semblable au monde.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Visitez les rues qui font le lien entre la ville ancienne et la ville moderne&nbsp; </strong></p>\n\t\t\t\t\t\t\t\t\t<p>L'avenue Mamilla est un complexe contemporain de divertissement qui offre aux visiteurs un aper\xE7u de la culture riche, originale et toujours innovante de J\xE9rusalem.</p>\n\t\t\t\t\t\t\t\t\t<p>Pour profiter pleinement de ce que l'avenue Mamilla a \xE0 vous offrir, allez la visiter par temps ensoleill\xE9. En \xE9t\xE9, chaque nuit, des milliers de personnes d\xE9ambulent sur l'avenue et assistent \xE0 toutes sortes d'\xE9v\xE9nements culturels. Allez les rejoindre pour appr\xE9cier les foires d'art de rue et les expositions en plein air, le th\xE9\xE2tre de rue, les clowns, les acrobates, les percussionnistes et les spectacles musicaux quotidiens.&nbsp;Il y a tant de choses \xE0 voir et \xE0 faire que vous ne voudrez plus partir.</p>\n\n            \t"};}},{ctg:"jerusalem",isVid:true,vidId:"nLKWDp5uA-U",id:"First_Time_In_Jerusalem",bgImage:"/posts/bank/first-time-in-jerusalem/1.jpg",mobBgImage:"/posts/bank/first-time-in-jerusalem/M.jpg",title:"FIRST TIME IN JERUSALEM",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t<h2>The must list for the first-time visitor</h2>\n\n              \t\t<p>\n\t\t\t\t\t\tScour the globe it\u2019s hard to match Jerusalem for history, culture, and significance! So rich in sites and activities, it\u2019s difficult to know where to begin. Here are a few suggestions\u2026\n              \t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tJerusalem is the nexus of three of the world\u2019s great faiths. As such, you might want to consider religious, spiritual, or historical locations that will be meaningful to you.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAlmost any itinerary will include Old City. Famous as the home of the Western Wall, and the Church of the Holy Sepulcher, you could spend days exploring its four quarters \u2013 Jewish, Christian, Muslim, and Armenian \u2013 and only see but a small part of its many treasures. Make sure to download the free Audio Tours of Jerusalem app, which offers dozens of walking routes, GPS maps, and geo-location alerts as you approach each site.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/first-time-in-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tA five-minute cab ride southwest and you can visit the more mellow upscale bars in Neve Tzedek. Alternatively, a ten-minute ride south takes you to the underground scene in the newly-trendy hipster heaven of the Florentin neighborhood, and of course don\u2019t miss the up and coming hipster style Flea Market area in Jaffa.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWant a more mainstream approach to a night on the town? Three streets \u2013 King George, Dizengoff, and Ibn Gabirol \u2013 will be just right for you, allowing you a chance to interact with the locals and be part of the authentic nightlife scene of the city.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWherever you go, you will always find where to have an awesome night in nonstop Tel Aviv!\n\t\t\t\t\t</p>\n            \t"};}},{ctg:"telavivAndJerusalem",isVid:false,id:44,bgImage:"/posts/bank/travelling-on-budget/1.jpg",mobBgImage:"/posts/bank/travelling-on-budget/M.jpg",title:"TRAVELLING ON A BUDGET",smltitle:"",html:function html(){return{__html:"\n\n              \t\t <h2>Making It Count in Tel Aviv and Jerusalem!</h2>\n\n              \t\t<p>\n\t\t\t\t\t\tSo you\u2019ve heard of the stunning beaches, the amazing sights and the fabulous cuisine and you are looking to travel to Jerusalem and Tel Aviv, but affordability is a concern. Well, pack your bags and worry no more! Both cities offer low-cost accommodations, transportation, and meals, as well as countless sites to see and things to do, which require little or no expense.\n              \t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tFor affordable accommodation you can choose from the many hostels and smaller hotels, many of which are located only a few minutes\u2019 walk from Tel Aviv\u2019s Beaches and Jerusalem\u2019s main attractions.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tGetting around? In both cities it\u2019s a snap with a Rav Kav card. Purchase one for little more than a dollar at\u201DAl Hakav\u201D (on the line) Service centers at central stations and other locations around the city. Jerusalem also offers an affordable City Pass option, and in Tel Aviv, the Tel Ofan bicycle rental municipal service is a great and low cost way to get around in the city.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/80/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWhat to do? Jerusalem and Tel Aviv are packed with sites, marketplaces, parks, nearby nature reserves and hiking trails. There are endless ways to not spend a dime and fill your trip with unforgettable experiences.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tFinally, everyone\u2019s gotta eat, from hummus to gourmet, both cities are famous for great street food and low-price restaurants offering cheap lunch time dining.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tSo come visit Tel Aviv and Jerusalem where you are guaranteed a fantastic time without breaking the bank.\n\t\t\t\t\t</p>\n            \t"};}},{ctg:"jerusalem",isVid:false,id:45,bgImage:"/posts/bank/upscale-jerusalem/1.jpg",mobBgImage:"/posts/bank/upscale-jerusalem/M.jpg",title:"UPSCALE JERUSALEM",smltitle:"",html:function html(){return{__html:"\n                    <h2>Modern luxuries for the pampered traveler</h2>\n              \t\t<p>\n\t\t\t\t\t\tWhen it comes to luxury travel, high class accommodations, fine dining, and top-drawer shopping options Jerusalem is a city that\u2019s truly arrived.\n              \t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tThe city features numerous 5-star and boutique hotels ready to custom cater to your needs for comfort and relaxation, offering amazing rooftop views and inhouse spa treatments to boot.\n\t\t\t\t\t</p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/81/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t</div>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tLooking to delight your palette? Well, in 2018, several Jerusalem establishments were listed in the prestige French restaurant guide, Gault & Millau. Beyond that, the city features and is increasingly attracting some of the world\u2019s best chefs.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tWhen it comes to style, fashion, and swanky shopping, Jerusalem has any number of places you\u2019ll want to visit. Among these are Arlov Mamilla Avenue. This happening and trendy outdoor mall complex is a must for your go-to city destinations. Even better, it\u2019s situated just steps away from the Old City\u2019s Jaffa Gate.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAnother not-to-be-missed stop on your itinerary is the elegant The First Station. For over 100 years a railway depot, the site has been transformed into an urban shopping and culinary mecca that\u2019s chock-a-block with restaurants, shops, art galleries and an artists\u2019 marketplace three days a week, as well as live performances and more.\n\t\t\t\t\t</p>\n\t\t\t\t\t<p>\n\t\t\t\t\t\tAnd as long as you\u2019re in the neighborhood, treat yourself to a romantic afternoon or evening on Emek Refaim Street, the German Colony\u2019s main thoroughfare. Its beguiling architecture laid back mood, stylish boutiques, intimate restaurants, and 1920s-era cinema offer an absolute treat for all the senses.\n\t\t\t\t\t</p>\n            \t"};}},// End Posts
{id:5,ctg:"deadsea",isVid:false,bgImage:"posts/bank/100/1.jpg",mobBgImage:"posts/bank/100/M.jpg",title:"Dead Sea Joys",smlTitle:"",html:function html(){return{__html:"\n\t\t\t\t\t<h2>For a floating good time</h2>\n\n\t\t\t              <p>\n\t\t\t                              A geological wonder in a uniquely serene setting, the Dead Sea is an extremely popular tourist attraction. \n\t\t\t                              Experience the calm tranquility of the water with its distinct healing properties while enjoying the unparalleled beauty of the surrounding landscape. \n\t\t\t                              <strong>The Dead Sea, also known as the oldest natural spa in the world, is blessed with an extremely high salt concentration of 31.5%, \n\t\t\t                              allowing tourists from far and wide the amazing experience of effortlessly floating on the waters of the lowest place on Earth. \n\t\t\t                              While here, you can bathe</strong> in the healthy black mud of the area or explore the fascinating and historically rich nearby landscapes.\n\t\t\t              </p>\n\n\t\t\t              <p>\n\t\t\t                              Luxury hotels, varied cuisine from gourmet restaurants to fast food eateries, great souvenir shops, the extraordinary history of the nearby Masada, and many cultural activities throughout the year, make the Dead Sea a popular destination for local tourists as well as International visitors.\n\t\t\t              </p>\n\t\t\t              \n\t\t\t"};}},// {
// 	id:"Ultimate_Beach_Fun",
//                bgImage : "/posts/bank/17/1.jpg",
//         	mobBgImage : "/posts/bank/17/M.jpg",
//               title : "ULTIMATE BEACH FUN",
//               ctg:"telaviv",
//               isVid:true,
//               vidId:"I9a4BFWO_6w",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
//             		<p>Israel has a wide selection of beaches to choose from. The wide Mediterranean stretch along the west side of the country boasts wide golden sands and the gorgeous blue waves of the med.</p>
//         		 	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/24/1.jpg"} class="img-responsive" />
// 					</div>
//             		<p>Up North the Sea of Galilee have some lovely beaches where you can camp out, barbeque and really make a day of it. The Galilee offer boat hire and water sport equipment for some water fun!</p>
//             		<div class="videoWrapper">
// 						            <iframe width="100%" height="400px" src="https://www.youtube.com/embed/8p4qfkneH1c?autoplay=1&amp;controls=0&amp;loop=1&amp;rel=0&amp;playlist=8p4qfkneH1c&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0" frameborder="0" allowfullscreen=""></iframe>
// 						        </div>
//                                 <p>The Dead Sea’s desert beaches possess a unique atmosphere in the clear air and of course a sea which is not for swimming but for floating and taking care of your skin.</p>
//                                 <p>Last but not least the beaches in Eilat boast crystal clear blue waters of the Red Sea that are very seldom wavey. Eilat is known for its beautiful diving spots and swimming with dolphins. They have wonderful beach bars, restaurants, water sports and attractions a perfect destination for holiday makers.</p>
//             	 `
//     }
//   }
// },
{id:"Purchases_In_Israel",bgImage:"/posts/bank/purches-in-israel/1.jpg",mobBgImage:"/posts/bank/purches-in-israel/M.jpg",title:"DES ACHATS UNIQUES À ISRAËL",ctg:"jerusalem",isVid:false,smltitle:"",html:function html(){return{__html:"\n              \n              \n                                <p>En Isra\xEBl, le shopping va au-del\xE0 de la simple acquisition d'objets&nbsp;: c'est le meilleur moyen de penser \xE0 vos proches et \xE0 vos amis rest\xE9s au pays, car vous allez leur rapporter (ou vous offrir \xE0 vous-m\xEAme) un sac, une bouteille ou une bo\xEEte symbolisant les merveilles que vous avez v\xE9cues. En vous promenant sur les march\xE9s, dans les boutiques et les galeries, vous verrez une incroyable vari\xE9t\xE9 de produits. Cela signifie que vous trouverez quelque chose pour tout le monde et que vous aurez du plaisir \xE0 faire votre choix.</p>\n\t\t\t\t\t\t\t\t\n            \t\t            \n                                <p><strong>De magnifiques souvenirs du Moyen-Orient </strong></p>\n\t\t\t\t\t\t\t\t<p>Certains des souvenirs les plus charg\xE9s de sens vous attendent dans les lieux saints d'Isra\xEBl, en Galil\xE9e et \xE0 J\xE9rusalem. De superbes poteries arm\xE9niennes bleu et blanc orn\xE9es de th\xE8mes familiers relatifs aux lieux saints sont tr\xE8s appr\xE9ci\xE9es comme souvenirs, et utiles en tant que vaisselle. Le bois d'olivier et la nacre, des mat\xE9riaux artisanaux utilis\xE9s depuis des si\xE8cles, ornent aujourd'hui des bibles, des bo\xEEtes, des broches et de nombreux autres articles qui seront un souvenir vivant de votre visite.</p>\n\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t               <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/purches-in-israel/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\n\t\t\t\t\t               </div>\n\t\t\t\t\t\t\t\t<p><strong>La Jud\xE9e unique</strong></p>\n\t\t\t\t\t\t\t\t<p>Et quel meilleur moyen de se rappeler de Safed, J\xE9rusalem, Jaffa et d'autres centres juda\xEFques que de recouvrir votre table de Shabbat ou de jour saint avec une couverture de challah ou de matzah brod\xE9e \xE0 la main (l\xE9g\xE8re et facile \xE0 emballer !), ou avec des bougies, une coupe de kiddouch ou une m\xE9norah de Hannoucca de style contemporain ou traditionnel, en argent, \xE9tain, verre ou c\xE9ramique. Les mezouzahs sont le parfait cadeau pour une pendaison de cr\xE9maill\xE8re, et un ch\xE2le de pri\xE8re constituera un souvenir pour un Bar/Bat Mitzvah.</p>\n\t\t\t\t\t\t\t\t<p><strong>Les produits min\xE9raux de la mer Morte</strong></p>\n\t\t\t\t\t\t\t\t<p>Isra\xEBl abrite le plus grand spa en plein air du monde \u2013 la mer Morte \u2013 et apr\xE8s un bain dans son eau richement min\xE9ralis\xE9e, votre peau et vos cheveux seront aussi doux que de la soie. Et oui, ils la mettent en bouteille&nbsp;! Vous pouvez acheter une gamme compl\xE8te de produits min\xE9raux de la mer Morte, tous magnifiquement emball\xE9s, pour un cadeau parfait en provenance d'Isra\xEBl.</p>\n\t\t\t\t\t\t\t\t<p><strong>Shopping </strong></p>\n\t\t\t\t\t\t\t\t<p>Lors de votre s\xE9jour, vous voudrez certainement parcourir les magasins d'usine ou les boutiques de stylistes isra\xE9liens mondialement connus. D'adorables v\xEAtements de b\xE9b\xE9 100 % coton fabriqu\xE9s en Isra\xEBl rentreront sans probl\xE8me dans votre valise d\xE9j\xE0 bien remplie et feront un magnifique cadeau pour f\xEAter une naissance. Vos chaussures n'ont pas r\xE9sist\xE9 \xE0 votre p\xE9riple en Isra\xEBl ? Avant la fin de votre s\xE9jour, achetez une paire de sandales ou chaussures l\xE9g\xE8res fabriqu\xE9es en Isra\xEBl, \xE0 des prix que vous ne trouverez pas chez vous.</p>\n\t\t\t\t\t\t\t\t<p><strong>Joaillerie </strong></p>\n\t\t\t\t\t\t\t\t<p>Partout dans le monde, les bijouteries les plus r\xE9put\xE9es exposent les cr\xE9ations de joaillers isra\xE9liens. \xC9tant en Isra\xEBl, vous pouvez vous approvisionner directement \xE0 la source. Vous serez s\xE9duite par les bracelets tendance avec leurs cristaux et leurs perles multicolores offrant une infinit\xE9 de motifs, tout comme par les cr\xE9ations en malachite vert-bleu (pierre d'Eilat). Lorsque vous les porterez, tout le monde saura que vous \xEAtes all\xE9e en Isra\xEBl.</p>\n\t\t\t\t\t\t\t\t<p>Isra\xEBl est depuis longtemps c\xE9l\xE8bre pour ses diamants taill\xE9s et polis ainsi que pour l'exp\xE9rience, les connaissances et les comp\xE9tences de ses experts en diamant. Isra\xEBl est un pays exportateur de diamants, ce qui vous permettra de b\xE9n\xE9ficier de tarifs avantageux. Pour tout apprendre sur cette activit\xE9, vous pouvez \xE9galement visiter un atelier de taille et de polissage de diamant.</p>\n\t\t\t\t\t\t\t\t<p><strong>N'oubliez pas la nourriture </strong></p>\n\t\t\t\t\t\t\t\t<p>Isra\xEBl est c\xE9l\xE8bre dans le monde entier pour la qualit\xE9 de sa cuisine. Il ne faut donc pas h\xE9siter \xE0 rapporter chez vous des produits alimentaires emball\xE9s. Pour votre chef favori, vous pouvez ramener des \xE9pices comme l'hysope de la Bible, des dattes sucr\xE9es joliment emball\xE9es qui seront appr\xE9ci\xE9es par vos coll\xE8gues de travail, et un large \xE9ventail de tisanes, miels, vins prim\xE9s et d'autres produits.</p>\n\t\t\t\t\t\t\t\t<p>Et lorsque vous vous rendrez \xE0 l'a\xE9roport avec vos cadeaux, vous appr\xE9cierez de b\xE9n\xE9ficier d'un remboursement de la TVA pour les achats de plus de 100$ r\xE9alis\xE9s dans les magasins participants.</p>\n\t\t\t\t\t\t\t\t            \t\n\n            \t "};}},{id:"Jerusalem_Fun",bgImage:"/posts/bank/jerusalem-fun/1.jpg",mobBgImage:"/posts/bank/jerusalem-fun/M.jpg",title:"JERUSALEM FUN",ctg:"jerusalem",isVid:true,vidId:"nLKWDp5uA-U",smltitle:"",html:function html(){return{__html:"\n              \n                               <p>Planning a trip to Jerusalem usually involves its many sights of culture and historical significance. However, just as important to many, Jerusalem\u2019s has an amazingly cool after dark scene, filled with music, hipster hangouts, dance clubs, and much more.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t               <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jerusalem-fun/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t\t\t\n\t\t\t\t\t               </div>\n                                 <p>To check it out, make your way to the <b>City Center</b> and explore the narrow streets just off <b>Jaffa Street</b>. There you\u2019ll find bars and nightclubs that range from comfortably mainstream to eccentrically funky. <b>Rivlin Street</b> is a popular hangout for young people, while <b>Shoshan Street</b> and the surrounding area offers a more laid-back grown up vibe.</p>\n\n                                 <p>Machane Yehuda market offers a surprisingly awesome night out as in the evening it transforms into a trendy hotspot where vendor stalls and shops become the setting for bars, DJs, live music, and dancing.</p>\n                                 <p>Betzalel Street is famous for its student artsy vibe and the many little bars are a great place to befriend the locals who come for a drink and a jam session.</p>\n\n                                 <p>For a daytime change of pace head to the <b>German Colony (Moshava)</b> and, particularly, the neighborhood of <b>Baka</b>. Start at <b>Beit Lechem Street</b> where you\u2019ll have your choice of popular, contemporary restaurants and bars. Then stroll all the way up <b>Emek Refaim Street</b> or through <b>HaMesila (Railway) Park</b> until you reach The <b>First Station</b> \u2013 once a railroad depot in use for over a century, it transformed now into a trendy culinary, cultural, and retail delight.</p>\n                           \n            \t "};}},// {
// 	id:"Western_Wall_Wonders",
//               bgImage : "/posts/bank/30/1.jpg",
//               mobBgImage : "/posts/bank/30/M.jpg",
//               title : "WESTERN WALL WONDERS",
//               ctg :"jerusalem",
//               isVid:false,
//               player_id_post :"",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<p>
// 					The Western Wall (or Kotel, in Hebrew) was part of the most magnificent building Jerusalem had ever seen, which was the Second Temple, built by the great King Herod.
// 				</p>
// 				<p>
// 					The Second Temple was destroyed in the year 70 CE and despite the destruction that took place, all four of the Temple Mount support walls remained standing.  Throughout the generations since the Temple’s destruction, the Western Wall was the remnant closest to the site of the Temple’s ‘holies of holies - a place where only the Jewish High Priests were allowed, as it was there they believed God was present.  The actual remains of the Temple can be found the Western Wall Tunnels, which are an extraordinary journey through time.
// 				</p>
//              	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/1.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					For centuries Jewish People from around the world have been going there to mourn the loss of this grand temple. You will often find hundreds of people of different nationalities and religions’ pouring out their heart with prayers as the wall is believed to have enormous spiritual significance.
// 				</p>
// 				<p>
// 					It is tradition for the people that visit to write a note and place it in the cracks of the Western Wall, as it is believed the message will be taken to God. You will often find doves resting in the crevices of this impressive structure, which are a symbol of peace.
// 				</p>
// 				<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/27/2.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The Western Wall is a national symbol as the ancient bricks have seen Israel and the Jewish peoples  birth, exile and redemption. It’s a very popular location for national ceremonies and even Bar Mitzvah to take place
// 				</p>
// 				<p>
// 					For more information   <a  target="_blank" href="//www.thekotel.org">www.thekotel.org</a>
// 				</p>
//             	 `
//     }
//   }
// },
// {
// 	id:28,
//              bgImage : "/posts/bank/white-city-splendor/1.jpg",
//               mobBgImage : "/posts/bank/white-city-splendor/M.jpg",
//               title : "WHITE CITY SPLENDOR",
//               ctg:"telaviv",
//               isVid:false,
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<p>
// 					Tel Aviv’s “WHITE CITY” is a UNESCO World Heritage Site, because the city is home to more Bauhaus, modern and “International” architecture than any city on earth.
// 				</p>
//              	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/28/1.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					Tel Aviv was founded in 1909 as a garden suburb of the crowded port city of Jaffa. Very quickly it grew into a bustling metropolis so that by 1929, it was a flourishing city that was the apex of the Zionist dream. With the rise to power of Hitler in 1933, dozens of German Jewish architects escaped to Palestine – many of whom were students or graduates of the legendary Bauhaus school of design. The burgeoning of Tel Aviv required more and more buildings, and the arriving architects very quickly adapted their northern European Bauhaus design to the needs of the eastern Mediterranean heat. A walk through central Tel Aviv will bring you face to face with dozens of these extraordinary office buildings, apartment buildings and stores.
// 				</p>
// 				<p>
// 					<a  target="_blank" href="//www.bauhaus-center.com/">www.bauhaus-center.com/</a>
// 				</p>
//             	 `
//     }
//   }
// },
// {
// 	id:"Tower_Of_David_Museum",
//               bgImage : "/posts/bank/30/1.jpg",
//               mobBgImage : "/posts/bank/30/M.jpg",
//               title : "TOWER OF DAVID MUSEUM",
//               ctg:"jerusalem",
//               isVid:false,
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<p>
// 					Jerusalem’s Citadel, known as the “Tower of David”, is a historical and archaeological asset of international significance. The Tower is a medieval fortress that is located near the Jaffa Gate, the historical entrance to the Old City and has been the symbol for the city of Jerusalem for generations.
// 				</p>
//              	<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/1.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					At the Tower of David Museum you are presented with Jerusalem’s astounding story. While absorbing yourself in legends of the past and their dramatic chronicles it will not take you long to realise that the very stones of the museum are part of this city’s living history.
// 				</p>
// 				<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/2.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The 500-year-old walls are part of the Turkish citadel; its name derives from a tower so massive that early Jerusalemites ascribed it to their great King David and despite the name being ‘The Tower of David’ it was actually build by King Herod.
// 				</p>
// 				<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/3.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					Your visit can begin with a breath-taking view of old and new Jerusalem from the top of the tower. Each ancient room has been revamped to showcase a different period, allowing the tempestuous events of 4,000 years to fall perfectly into place in your mind.
// 				</p>
// 				<div class="img-wrapper">
// 						<img src=${getImgUrl() +  "/thingsToDo/posts/29/4.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The windows frame glimpses of modern Jerusalem, and with each doorway you exit, you look down into the citadel’s central courtyard, where archaeologists have unearthed remains dating from the Maccabees to the Middle Ages. This incredible site really is a maze of time!
// 				</p>
// 				<p>
// 					The museum also utilizes its unique space for multi-sensory exhibits by leading designers and artists from Israel and abroad. This One of a kind museum hosts the annual ‘Night Spectacular’ which is a unique sound and light show where the whole of the Citadel is lit up with stunning designs!
// 				</p>
// 				<p>
// 					For more information:   <a href="//www.tod.org.il/en/">www.tod.org.il/en/</a>
// 				</p>
//             	 `
//     }
//   }
// },
{id:"Must_Eat_In_Jerusalem",bgImage:"/posts/bank/must-in-jerusalem/1.jpg",mobBgImage:"/posts/bank/must-in-jerusalem/M.jpg",title:"MESMERIZING AND MAGICAL CITY",ctg:"jerusalem",isVid:true,vidId:"2CSCe2WC7Ns",smltitle:"",html:function html(){return{__html:"\n            \n                                <p>\n\t\t\t\t\t\t            Jerusalem is a mesmerizing and magical city. Many people who visit Jerusalem rave about the amazing atmosphere, the unforgettable sites, the breathtaking views and more. However, to truly understand what Jerusalem is all about, there are some things that you simply have to experience through your stomach. Here are just a few of the things you really should try while visiting Jerusalem:\n\t\t\t\t\t\t        </p>\n                               <div class=\"img-wrapper\">\n\t\t\t\t\t\t                 <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/must-in-jerusalem/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t                 </div>\n\n\t\t\t\t\t\t\t    <p><strong>Malabi:</strong> A unique a combination of beverage and dessert, made of a mixture of rosewater, milk, cornstarch and sugar. Malabi is a very popular Jerusalem dish, sold in many middle eastern restaurants and kiosks throughout the city. Guaranteed to be nothing like anything you have ever tasted.</p>\n\n                                <p><strong>Knafe:</strong> A very interesting and sensationally tasty dish when served and eaten fresh. Knafe is essentially an Arabic desert made of melted goats cheese and topped with hairs of orange pastry hairs, dipped in sweet rosewater syrup. Finding the perfect Knafe is a mission, once you find it, eating it becomes an addiction.</p>\n\n                                <p><strong>Jerusalem Pretzel:</strong> An absolute must when touring the fascinating sites of the old city is stopping by one of the small green carts and purchasing an authentic Jerusalem pretzel. Along with it, you will get a fragrant local green herb called Zaatar which goes great with the delicious warm doe.</p>\n\n                                <p><strong>\u201CMeorav Yerushalmi\u201D:</strong> Directly translates to \u201CMixed Jerusalem\u201D this delicious mix of different meats in a special local blend of spices is an absolute carnivores\u2019 heaven.</p>\n\n                                <p><strong>\u201CAshtanur\u201D:</strong> Short in Hebrew for \u201Cfire in the oven\u201D Ashtanur is an authentic local pitta bread which you can find in midtown or the markets during lunchtime. If you\u2019re especially hungry, try it wrapped around a portion of shawarma or falafel.</p>\n\n                                <p><strong>Sabich:</strong> an absolute original, the Sabich is a truly unique local dish comprised of a Pitta bread packed with fried eggplant, hard-boiled eggs, and pickles, usually topped by Amba, a local, flavorful condiment. Once you try it, you\u2019ll be hooked for life.</p>\n                                \n                \n            \t "};}},{id:"Jerusalem_Arts",bgImage:"/posts/bank/jerusalem-art/1.jpg",mobBgImage:"/posts/bank/jerusalem-art/M.jpg",title:"JERUSALEM’S ART",ctg:"jerusalem",isVid:false,smltitle:"",html:function html(){return{__html:"\n            \n                                <h3>Finding Inspiration in Jerusalem</h3>\n\n                                <p>There's no doubt Jerusalem is one of the most fascinating cities in the world. Its fusion of diverse religions, traditions, ancient history and modern city life intrigues visitors for centuries. It's also what attracts artists there. Today's Jerusalem is full of Museums, galleries, marketplaces and cultural festivals, which together form a vivid and unique Art and Culture scene. Prepare to be inspired.</p>\n\n                                <p>Discover. On a hill next to the Knesset and Israel's Supreme Court, situated Israel's largest cultural institution and one of the world's leading museums in art and archeology, The Israel Museum. Start with the archeological wing. Organized chronologically, the pieces there form the most extensive collection in the world for biblical and Holy Land archeology. Continue to the outstanding Jewish Art and Life wing, the impressive Fine Arts collection and the rotating contemporary art exhibitions. Don't miss few of the museum's highlights \u2013 The Shrine of The Book which holds the Dead Sea Scrolls and the stunning Art Garden looking over the Jerusalem Mountains. Tip: Give yourself time. It's an accessible, fascinating museum and there's so much to see.</p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t                <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/jerusalem-art/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t                </div>\n\t\t\t\t\t\t\t    <small style=\"color:#000; display:block;\">\n                      \t\t        Credit: Noam Chen\n                      \t        </small>\n\n\t\t\t\t\t\t\t\t<p>In close proximity to the Israel Museum you'll find the riveting <strong>Bible Lands Museum</strong>. Describes as \"an interactive time capsule\", it's the only museum of its kind in the world. Tour through the galleries and discover the wonders of the lives of ancient cultures in the Near East and their interrelations from the dawn on of civilization to the early Christian era.</p>\n\n                                <p><strong>Experience</strong>. Go to <strong>The Artists' Colony of Jerusalem</strong> (Hutzot Hayotzer) and experience creativity. This Art and Craft complex is a workplace for artists and designers from various fields. Stroll down this picturesque boulevard of shops and galleries underneath the northern walls of the Old City and see artists at work. Hear stories, learn about traditional and more contemporary art techniques and purchase works directly from the artists.</p>\n\n                                <p>See the <strong>Tower of David Light Show</strong>, known as the Jerusalem Night Spectacular. This truly stunning show combines modern technology with the city's history and the beauty of the Tower. You'll witness the walls and walkways comes alive with a 3D light show and vibrant music that pulls the viewer into an almost dreamlike experience.</p>\n\n                                <p><strong>Celebrate</strong>. Jerusalem has rich history but it's also a bustling modern city that loves to celebrate. Make sure to check the city's rich schedule of festival and cultural events and enjoy of the best Jerusalem has to offer throughout the year.</p>\n\n                                <p>Celebrate <strong>The Israel Festival</strong>, Israel's prominent multidisciplinary international festival that presents a large variety of outstanding theatre, contemporary dance, classical music and performance from all around the world. Join the Jerusalem Arts and Craft fair Hutzot Hayotzer where you'll meet Israeli and international artists and listen to great music; visit Jerusalem Night Market and stroll through the many stalls set by all types of artists and designers, showing off and selling their wares; Experience the Light in Jerusalem Festivalthat provides a dramatic unique and artistic dimension to the old city through use of light; listen to opera in the Jerusalem Opera Festival. Set in the Sultan pool, you'll watch great performance with the great Jerusalem night summer air and stunning view as a backdrop.</p>\n\n                                <p>Don't miss the Jerusalem Sacred Music Festival. As part of the Jerusalem Season of Culture, this extraordinary festival brings together diverse artists from huge array of fields, cultures and traditions that show and explore 'sacred' music from all around the world.</p>\n            \t\n                \n            \t "};}},{id:"All_Sensory_Markets",bgImage:"/posts/bank/1.jpg",mobBgImage:"/posts/bank/M.jpg",ctg:"jerusalem",isVid:false,title:"ALL SENSORY MARKETS",player_id_post:"",smltitle:"",html:function html(){return{__html:"\n            \n\n\t\t\t\t<p>\n\t\t\t\t\tFor a genuine Middle Eastern experience you can\u2019t beat a visit to one of Israel\u2019s many markets (Shuks).  The different colours, textures, smells, tastes and sounds of these hives of activity can be a highlight of any Israel visit.  \n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\tThese markets are a melting pot of cultures and a great place to give your bartering skills a go. Through the winding cobbled streets you will find, fresh produce, souvenirs, art and handmade jewellery\u2026the list is endless. Bring home a gift for your friends and family or just enjoy walking around and tasting different flavours.\n\t\t\t\t</p>\n\t\t\t\t\n\t\t\t\t\n             \t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/30/1.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<h3>\n\t\t\t\t\tTel Aviv\n\t\t\t\t</h3>\n\t\t\t\t<p>\n\t\t\t\t\tThe Carmel Market, or Shuk HaCarmel, is the most famous of all Tel Aviv\u2019s marketplaces. In recent years, it\u2019s even joined the ranks of Tel Aviv\u2019s trendy spots for bars, restaurants, coffee shops and chef-owned food stalls. It\u2019s no wonder Shuk HaCarmel is Tel Aviv\u2019s largest and most-centrally located shuk: From hand-made Jachnun, a traditional Yemenite dish, to boutique cheeses, and from one-off cotton clothes to designer threads, HaCarmel has it all. Plan your visit around your tastebuds and food preferences - salted fish, cured meats, Middle Eastern fare, fresh baked French pastries, and local-roasted coffee or fresh-pressed fruit or vegetable juice blends to wash it all down.\n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\t<a target=\"_blank\" href=\"//www.shuktlv.co.il/en/category/carmel-market\">\n\t\t\t\t\t\twww.shuktlv.co.il/en/category/carmel-market\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/30/2.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tNachlat Binyamin arts and crafts fair was established in 1988. It is the oldest and biggest of its kind in Israel, and one of the nicest in the world. The market is home to over two hundred artists who use materials such as wood, glass, fabric, plastic, paper\u2026even rocks (almost anything) to hand-make what they sell on their stall. \n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\t<a target=\"_blank\" href=\"//www.shuktlv.co.il/en/category/carmel-market\">\n\t\t\t\t\t\twww.shuktlv.co.il/en/category/carmel-market\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/30/3.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\t\t\t\t<h3>\n\t\t\t\t\tJerusalem\n\t\t\t\t</h3>\n\n\t\t\t\t<p>\n\t\t\t\t\tThe Machane Yehuda market is widely recognized as a symbol of the Jerusalem, and for a very good reason: Jerusalemites see it as a place that represents them, symbolizes them, and gives them a unique identity in a larger Israeli social context. Jerusalem today has many shopping and entertainment centres, but there is something about the Machane Yehuda market that attracts people, even without a shopping list.  From the heady scent of spices to the colourful displays of fruits and vegetables, a trip to this market is pleasing for all your senses.\n\t\t\t\t</p>\n\n\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/thingsToDo/posts/29/4.jpg")+" class=\"img-responsive\" />\n\t\t\t\t</div>\n\n\t\t\t\t<p>\n\t\t\t\t\tOne option of experiencing this market is by buying a \u2018Machane Yehuda Bites Card\u2019.  This card is comprised of vouchers curated in order to give you a chance to try a variety of products, flavours and the aromas of the market - without having to depend on an organized group or tour.  For more information please click here: \n\t\t\t\t</p>\n\n\t\t\t\t<p>\n\t\t\t\t\t<a target=\"_blank\" href=\"//www.machne.co.il/en/\">\n\t\t\t\t\t\thttp://www.machne.co.il/en/\n\t\t\t\t\t</a>\n\t\t\t\t</p>\n\t\t\t\t\n                \n            \t "};}},// {
// 	id:31,
//               bgImage : "/posts/bank/20/1.jpg",
//               mobBgImage : "/posts/bank/20/M.jpg",
//               title : "UNFORGETTABLE YAD VASHEM",
//               ctg :"jerusalem",
//               isVid:false,
//               player_id_post :"",
//               smltitle : "",
//               html: function(){
// 			return {
// 				__html: `
// 				<p>
// 					Yad Vashem, Israel’s main Holocaust remembrance and education centre is situated on the green slopes of Har HaZikaron, (the Mount of Remembrance) in Jerusalem.
// 				</p>
// 				<p>
// 					Israel’s Holocaust commemoration project began in 1953 with the task of perpetuating the memory of Holocaust victims and documenting the history of the Jewish people during the Holocaust so that it will be remembered by future generations. This project was an important step for the young nation of Israel at the time and was significant for the citizens of Israel, particularly for the survivors of the ghettos and concentration camps.
// 				</p>
//              	<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/1.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The new Yad Vashem museum was opened to the public in 2005. The museum is designed in the shape of a prism penetrating the mountain. Divided into nine galleries, the museum relates the stories of the Jewish communities before the Second World War and the series of events beginning from the rise of the Nazis to power, the pursuit of the Jews, their eviction to the ghettos and ending with “the Final Solution” and mass genocide
// 				</p>
// 				<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/2.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The personal experiences and feelings of the victims of the Holocaust constitute the groundwork for the museum’s exhibits. Photographs, films, documents, letters, works of art, and personal items found in the camps and ghettos are all an integral part of the exhibits. As you exit the Museum itself is the Hall of Names, an inspiring memorial containing over three million names of Holocaust victims that were submitted by their families and relatives. Names can still be submitted by visitors to the memorial and added to the computerized archive.
// 				</p>
// 				<p>
// 					In addition to the Holocaust History Museum Yad Vashem has other memorials and monuments including  the Hall of Remembrance, where the ashes of the dead are buried and an eternal flame burns in commemoration; Yad Layeled, the children’s memorial, commemorating the one and a half million Jewish children who were murdered in the Holocaust;
// 				</p>
// 				<div class="img-wrapper">
// 					<img src=${getImgUrl() +  "/thingsToDo/posts/31/3.jpg"} class="img-responsive" />
// 				</div>
// 				<p>
// 					The Memorial to the Deportees, an authentic railroad car hanging over the cliff on the road winding down from the mountain. The car was used to transport Jews who had been banished from their homes to the concentration camps.
// 				</p>
// 				<p>
// 					The Avenue of the Righteous Among the Nations has over 2,000 trees which were planted in honor of non-Jews who endangered their lives in order to rescue Jews from the Nazis; The archives and library of Yad Vashem House the world’s largest repository of material about the Holocaust;
// 				</p>
// 				<p>
// 					Visiting the Yad Vashem museum is an emotional and heartrending experience, but seeing the exhibits and remembering the Holocaust gives the more than one million individuals, world leaders and dignitaries who pass through its doors annually a meaningful way to commemorate the six million Jewish victims of the Holocaust.
// 				</p>
// 				<p>
// 					For more information   <a target="_blank" href="//www.yadvashem.org/">www.yadvashem.org</a>
// 				</p>
//             	 `
//     }
//   }
// },
{id:"What_To_Pack",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"CE QU'IL FAUT EMPORTER",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\n\n\t\t\t\t\t\t\t    <p>Isra\xEBl est un pays moderne et d\xE9velopp\xE9, et vous pouvez y acheter \xE0 peu pr\xE8s tout ce dont vous avez besoin pendant votre s\xE9jour, y compris des v\xEAtements, cosm\xE9tiques et produits d'hygi\xE8ne.</p>\n\t\t\t\t\t\t\t\t<p>Si vous visitez Isra\xEBl en \xE9t\xE9, vous aurez besoin de v\xEAtements l\xE9gers&nbsp;: chemises \xE0 manches courtes et sans manches, shorts, sandales, chaussures de plage et maillot de bain.&nbsp; Il est \xE9galement judicieux d'emporter un pull ou une veste, car les nuits dans les montagnes ou le d\xE9sert peuvent \xEAtre fra\xEEches.&nbsp;</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/what-to-pack/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p>Si vous visitez Isra\xEBl en hiver, emportez avec vous un manteau (et aussi un imperm\xE9able, si possible), de bonnes chaussures, un parapluie, des gants, une \xE9charpe et d'autres v\xEAtements chauds.&nbsp; Le climat en Isra\xEBl n'est pas aussi froid qu'en Europe, mais les journ\xE9es peuvent \xEAtre pluvieuses et froides.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p>Il est \xE9galement judicieux d'emporter un petit sac pour les excursions d'une journ\xE9e.&nbsp; Si vous allez \xE0 Eilat ou \xE0 la mer Morte, emportez un maillot de bain, car il y fait assez chaud pour vous baigner, m\xEAme en hiver.</p>\n\t\t\t\t\t\t\t\t<p>Une cr\xE8me solaire, un chapeau et des lunettes de soleil sont des accessoires indispensables tout au long de l'ann\xE9e.</p>\n\t\t\t\t\t\t\t\t<p>Si vous pr\xE9voyez de randonner, vous aurez besoin de bonnes chaussures et de beaucoup d'eau, que ce soit dans un bidon ou dans plusieurs bouteilles. Un sac de couchage, une tente, et un \xE9quipement de camping ne seront n\xE9cessaires que si vous pr\xE9voyez de dormir en plein air.&nbsp; La plupart des auberges de jeunesse fournissent draps et couvertures.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\n\t\t                        "};}},{id:"Electrical_Appliances",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"APPAREILS ÉLECTRIQUES",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t<p>&#8203;En Isra\xEBl, l\u2019alimentation \xE9lectrique est en 220 volts monophas\xE9 \xE0 50 Hz. La plupart des prises de courant sont dot\xE9es de trois trous, mais un grand nombre d'entre elles fonctionnent avec les fiches europ\xE9ennes \xE0 deux broches. Les personnes souhaitant utiliser un rasoir, un fer \xE0 repasser de voyage ou tout autre petit appareil \xE9lectrique, pourront avoir \xE0 utiliser un transformateur et un adaptateur.</p>\n<p><a href=\"https://info.goisrael.com/en/things-to-do\" target=\"_blank\">Consulter les choses \xE0 faire du site d'informations touristiques</a><br><a href=\"https://info.goisrael.com/en/organized-tourism\" target=\"_blank\">Consulter les services touristiques du site d'informations touristiques</a></p>\n                                <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/electrical-appliances/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n\n\t\t                        "};}},{id:"Weather",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"LE CLIMAT",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t<p>Avec une moyenne d'environ 40 jours de pluie par an, Isra\xEBl est connu pour son caract\xE8re ensoleill\xE9. Ne perdez tout de m\xEAme pas de vue que ce pays conna\xEEt 4 saisons. Les \xE9t\xE9s sont longs, ils durent d'avril \xE0 octobre, et les maximas de chaleur et d'humidit\xE9 se situent vers les mois de juillet et ao\xFBt. L'automne et l'hiver durent de novembre \xE0 mars.</p>\n<p>Eilat, la ville la plus au sud, jouit de pr\xE8s de 360 (!) jours de soleil par an, ce qui en fait la ville la plus chaude d'Isra\xEBl (sans jeu de mots !).</p>\n<p>Site Web du service m\xE9t\xE9orologique d'Isra\xEBl&nbsp;: <a href=\"//www.ims.gov.il\" rel=\"nofollow\" target=\"_blank\"><u>www.ims.gov.i</u></a></p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/weather-planyour-trip/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n\n\t\t                        "};}},{id:"Transportation",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"TRANSPORTS",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t<p>Isra\xEBl \xE9tant un petit pays, il peut \xEAtre parcouru rapidement et de fa\xE7on confortable. En Isra\xEBl, on utilise couramment les taxis pour les parcours urbains et interurbains. Ils peuvent \xEAtre h\xE9l\xE9s dans la rue ou r\xE9serv\xE9s par t\xE9l\xE9phone ou avec des applications internationales comme GetTexi.</p>\n\t\t\t\t\t\t\t\t<p>Les principaux moyens de transport public sont les cars et le service ferroviaire national qui constituent tous deux un moyen pratique et peu on\xE9reux de se rendre \xE0 quasiment n'importe quel endroit du pays.</p>\n\t\t\t\t\t\t\t\t<p>Services d'information sur les trains&nbsp;: <a href=\"//www.rail.co.il/en\" rel=\"nofollow\" target=\"_blank\"><u>www.rail.co.il</u></a> / T\xE9l\xE9phone : 08-6831222 or *5770.</p>\n\t\t\t\t\t\t\t\t<p>Services d'information sur les cars&nbsp;: <a href=\"//bus.gov.il/?language=en#/origindestination/1/0\" rel=\"nofollow\" target=\"_blank\"><u>www.bus.co.il</u></a> / T\xE9l\xE9phone : 1-900-72-1111</p>\n\t\t\t\t\t\t\t\t<p>Les billets peuvent \xEAtre achet\xE9s aux guichets de la gare routi\xE8re centrale de chaque ville ou village, ou directement au chauffeur.&nbsp;&nbsp;La plupart des lignes de cars ne fonctionnent pas pendant le Shabbat ou les jours f\xE9ri\xE9s juifs.&nbsp;&nbsp;Le service se termine le vendredi apr\xE8s-midi et reprend le samedi soir.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p>Les \xE9tudiants b\xE9n\xE9ficient de tarifs r\xE9duits sur les lignes de car interurbaines.&nbsp;&nbsp;Pour b\xE9n\xE9ficier du tarif r\xE9duit, ils doivent pr\xE9senter une carte internationale d'\xE9tudiant au moment d'acheter le billet.</p>\n\t\t\t\t\t\t\t\t<p><strong>La Rav Kav, la carte de transport intelligente</strong></p>\n\t\t\t\t\t\t\t\t<p>Les touristes peuvent acheter une carte Rav Kav anonyme.&nbsp;Cette carte peut \xEAtre achet\xE9e dans le car \xE0 un prix \xE9conomique, puis recharg\xE9e avec un ticket pour un ou plusieurs trajets, en g\xE9n\xE9ral dans la r\xE9gion m\xEAme et en b\xE9n\xE9ficiant d'une r\xE9duction de 20%.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts//1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p>Les touristes ne peuvent pas utiliser de carte Rav Kav personnelle, car celle-ci contient des informations personnelles sur le passager et est r\xE9serv\xE9e aux citoyens isra\xE9liens.</p>\n\t\t\t\t\t\t\t\t<p>&nbsp;Veuillez noter que&nbsp;:</p>\n\t\t\t\t\t\t\t\t<p>\xB7&nbsp;La carte Rav Kav peut \xEAtre utilis\xE9e pour r\xE9gler le transport de plusieurs passagers,</p>\n\t\t\t\t\t\t\t\t<p>\xB7&nbsp;Le tarif est le m\xEAme pour un enfant ou un adulte.</p>\n\t\t\t\t\t\t\t\t<p>\xB7&nbsp;La carte Rav Kav peut \xEAtre utilis\xE9e dans une r\xE9gion mais pas entre deux r\xE9gions, sauf si elle est express\xE9ment recharg\xE9e pour les itin\xE9raires d\xE9sir\xE9s.</p>\n\t\t\t\t\t\t\t\t<p>\xB7&nbsp;Dans certaines r\xE9gions, il est possible de b\xE9n\xE9ficier de trajets quotidiens illimit\xE9s, mais uniquement dans cette r\xE9gion.</p>\n\t\t\t\t\t\t\t\t<p><strong>Vols int\xE9rieurs </strong></p>\n\t\t\t\t\t\t\t\t<p>Isra\xEBl \xE9tant un petit pays, il n'est int\xE9ressant de prendre l'avion que pour circuler entre Eilat et Tel Aviv. Plusieurs compagnies assurent des vols entre Eilat et l'a\xE9roport David Ben Gourion, ou l'a\xE9roport Sd\xE9 Dov situ\xE9 au nord de Tel Aviv.&nbsp; Les tarifs a\xE9riens sont raisonnables, mais plus \xE9lev\xE9s que pour les cars.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p>Il existe \xE9galement des compagnies priv\xE9es qui assurent \xE0 la demande des vols sp\xE9ciaux depuis n'importe quelle partie du pays.</p>\n\t\t\t\t\t\t\t\t<p>Arkia&nbsp;:&nbsp; <a href=\"//www.arkia.com/flights-in-israel\" rel=\"nofollow\" target=\"_blank\"><u>www.arkia.com/flights-in-israel</u></a> T\xE9l\xE9phone&nbsp;: 00 972 3 690 2222,</p>\n\t\t\t\t\t\t\t\t<p>Israair&nbsp;: <a href=\"//int.israirairlines.com/cat_domestic.asp\" rel=\"nofollow\" target=\"_blank\"><u> int.israirairlines.com/cat_domestic.asp</u></a> T\xE9l\xE9phone&nbsp;: 00 972 3 795 5777</p>\n\t\t\t\t\t\t\t\t<p><b>Location de voitures</b></p>\n\t\t\t\t\t\t\t\t<p>La plupart des soci\xE9t\xE9s internationales et locales de location de voitures ont des bureaux dans les grandes villes et \xE0 l'A\xE9roport Ben Gourion.&nbsp; Il est recommand\xE9 de r\xE9server sa voiture \xE0 l'avance, depuis l'\xE9tranger.</p>\n\t\t\t\t\t\t\t\t<p>Pour louer une voiture en Isra\xEBl, le conducteur doit avoir plus de 24 ans et d\xE9tenir un permis de conduire international valide, ainsi qu'une carte de cr\xE9dit internationale.</p>\n\t\t\t\t\t\t\t\t<p>Isra\xEBl dispose d'un vaste r\xE9seau routier et d'une signalisation claire presque partout (en h\xE9breu, anglais et arabe).&nbsp;</p>\n\t\t\t\t\t\t\t\t<p><strong>Conduire en Isra\xEBl</strong></p>\n\t\t\t\t\t\t\t\t<p>L'<strong>\xE2ge minimum</strong> pour conduire en Isra\xEBl est de 17 ans et la conduite se fait sur la droite de la chauss\xE9e. Les limitations de vitesse sont de 30 \xE0 50 km/h dans les villes, 80-90 km/h sur les routes, 130 km/h sur les autoroutes et la Route n\xB0 6. Les ceintures de s\xE9curit\xE9 sont obligatoires et si vous voulez aller en ville faire la f\xEAte la nuit, gardez \xE0 l'esprit qu'il y a une tol\xE9rance z\xE9ro concernant l'alcool au volant. Avant de vous amuser, d\xE9signez donc un conducteur qui devra rester sobre.</p>\n\t\t\t\t\t\t\t\t<p><strong>Autoroute 6</strong></p>\n\t\t\t\t\t\t\t\t<p>L'Autoroute 6 est une route \xE0 p\xE9age \xE9lectronique sans barri\xE8res \xE0 l'entr\xE9e ou \xE0 la sortie et sans feux de signalisation, ce qui permet de se d\xE9placer sans interruption. Le syst\xE8me informatique de pointe install\xE9 le long de l'autoroute comprend des p\xE9ages \xE9lectroniques, identifie les v\xE9hicules, cat\xE9gorise les types de tarifs (abonnement ou non enregistr\xE9) et calcule le nombre de sections d'autoroute emprunt\xE9es par chaque v\xE9hicule. Chaque trajet est automatiquement compil\xE9 et factur\xE9. Les conducteurs b\xE9n\xE9ficient d'un trajet pratique et s\xFBr, \xE0 une vitesse limit\xE9e \xE0 130 kilom\xE8tres \xE0 l'heure.</p>\n\t\t\t\t\t\t\t\t<p>Les touristes ayant lou\xE9 une voiture seront d\xE9bit\xE9s sur leur carte de cr\xE9dit.&nbsp;&nbsp;Pour les conditions et les tarifs, veuillez vous informer aupr\xE8s de la soci\xE9t\xE9 de location.</p>\n\t\t\t\t\t\t\t\t<p>La plupart des soci\xE9t\xE9s de location de voitures ne proposent pas d'assurance pour les zones se trouvant en Cisjordanie, qui sont sous le contr\xF4le de l'Autorit\xE9 palestinienne.&nbsp; Les touristes d\xE9sirant se rendre avec une voiture de location dans les zones contr\xF4l\xE9es par l'Autorit\xE9 palestinienne sont encourag\xE9s \xE0 souscrire une assurance appropri\xE9e.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n            \t\n\n\t\t                        "};}},{id:"Israeli_Currency",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"MONNAIE ISRAÉLIENNE",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t\t\t<p><a href=\"//www.boi.org.il/en/Markets/ExchangeRates/Pages/Default.aspx\" rel=\"nofollow\" target=\"_blank\"><strong>Taux de change</strong></a></p>\n\t\t\t\t\t\t\t\t<p>La monnaie de l'\xC9tat d'Isra\xEBl est le nouveau shekel (NIS) ou shekel (dont le pluriel est shkalim en h\xE9breu et shekels en anglais et en fran\xE7ais). Un shekel est \xE9gal \xE0 100 agorot (agorah au singulier). On trouve des billets de 20, 50, 100 et 200 NIS et des pi\xE8ces de 10, 5, 2 et 1 NI et de 50 et 10&nbsp;agorot.</p>\n\t\t\t\t\t\t\t\t<p><strong>Changer de l'argent</strong></p>\n\t\t\t\t\t\t\t\t<p>Vous pouvez emporter en Isra\xEBl n'importe quelle somme en devise locale ou \xE9trang\xE8re, en esp\xE8ces, ch\xE8ques de voyage, cartes de cr\xE9dit ou obligations de l'\xC9tat d'Isra\xEBl. Vous pouvez \xE9changer n'importe quelle devise \xE9trang\xE8re dans les a\xE9roports, banques, bureaux de poste, la plupart des h\xF4tels ou dans les bureaux de change autoris\xE9s des grandes villes. Un passeport est demand\xE9 en cas d'\xE9change de ch\xE8ques de voyage. Le taux varie selon l'\xE9tablissement et les banques prennent une commission. Il est conseill\xE9, mais non obligatoire, de transporter une petite somme en dollars am\xE9ricains du fait que certains sites touristiques, en particulier&nbsp;la&nbsp; vieille ville &nbsp;de J\xE9rusalem, acceptent les paiements en dollars.&nbsp;&nbsp;<a href=\"https://www.boi.org.il/en/ConsumerInformation/Pages/Default.aspx\" rel=\"nofollow\" target=\"_blank\">ici</a>.</p>\n\t\t\t\t\t\t\t\t<p><strong>Retrait d'esp\xE8ces</strong></p>\n\t\t\t\t\t\t\t\t<p>Les titulaires d'une carte de cr\xE9dit internationale peuvent retirer des devises locales ou \xE9trang\xE8res dans les banques acceptant leur carte. Vous trouverez un distributeur automatique \xE0 l'ext\xE9rieur de la plupart des banques.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/israeli-currency/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n            \t\n\n\t\t                        "};}},{id:"Immigration_Customs",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"Immigration et douane",smltitle:"",html:function html(){return{__html:"\n                                <h2 class=\"ac-align-center ac-margin-top-20\">Proc\xE9dure aux postes fronti\xE8res</h2>\n                                <p class=\"ac-align-center ac-margin-bottom-20\"><b>Contr\xF4le des passeports</b></p>\n                               \n                                \n\t\t\t\t\t\t\t    <p>\xC0 leur arriv\xE9e en Isra\xEBl, les visiteurs doivent se soumettre \xE0 un contr\xF4le des passeports et pr\xE9senter un passeport valide pendant au moins six mois apr\xE8s la <strong>date de leur retour</strong>.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/immigration-customs/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p>Notez qu'Isra\xEBl a mis en place un nouveau syst\xE8me bas\xE9 sur une technologie moderne pour r\xE9pondre aux besoins des diff\xE9rentes autorit\xE9s d'immigration, de s\xE9curit\xE9, des a\xE9roports et de tourisme. Ce syst\xE8me permet \xE9galement aux touristes en r\xE8gle de prouver le statut de leur visa sans qu'aucun tampon ne soit appos\xE9 sur leur passeport.&nbsp; Par simple pression sur un bouton, le poste de contr\xF4le douanier imprime une carte r\xE9capitulant les principales informations concernant le voyageur, qui figurent en premi\xE8re page du passeport. La carte indique \xE9galement la date d'arriv\xE9e et les informations de visa. Cette carte est appel\xE9e \"Electronic Gate Pass\".</p>\n\t\t\t\t\t\t\t\t<p><strong>Le Gate Pass constitue une forme d'identification officielle valable pendant la dur\xE9e de votre s\xE9jour en Isra\xEBl.&nbsp; Tous les touristes sont invit\xE9s \xE0 garder cette carte sur eux en permanence afin de prouver leur statut.</strong></p>\n\t\t\t\t\t\t\t\t<p>Arriv\xE9e par avion et passage de la fronti\xE8re \u2013 Apr\xE8s l'atterrissage, les passeports des passagers sont contr\xF4l\xE9s puis ils sont dirig\xE9s vers la zone de r\xE9ception des bagages. Des chariots sont mis \xE0 leur disposition. Ils se soumettent alors au contr\xF4le douanier avant de se diriger vers la sortie.</p>\n\t\t\t\t\t\t\t\t<p><a href=\"//www.goisrael.com/Tourism_Eng/Tourist%20Information/Planning%20your%20trip/Documents/land%20gateways%202016%20ENGLISH.pdf\" rel=\"nofollow\" target=\"_blank\">Informations concernant les points d'acc\xE8s terrestres d'Isra\xEBl&#8203;</a></p>\n\t\t\t\t\t\t\t\t<p><strong>Douanes</strong><br>Vous pouvez t\xE9l\xE9charger les informations g\xE9n\xE9rales sur les lois et r\xE9glementations de l'Autorit\xE9 douani\xE8re :</p>\n\t\t\t\t\t\t\t\t<p><a href=\"https://taxes.gov.il/English/Pages/Guides.aspx\" rel=\"nofollow\" target=\"_blank\">https://taxes.gov.il/English/Pages/Guides.aspx</a></p>\n\t\t\t\t\t\t\t\t<p><strong>Notez que la travers\xE9e du pont Allenby est soumise \xE0 des limitations et r\xE9glementations.&nbsp; \xC0 titre d'exemple, les visiteurs empruntant le pont Allenby entre Isra\xEBl et la Jordanie ne sont pas autoris\xE9s \xE0 transporter plus de 2000 dinars jordaniens en esp\xE8ces.</strong></p>\n\t\t\t\t\t\t\t\t<p><strong>Douane et TVA pour les touristes :</strong></p>\n\t\t\t\t\t\t\t\t<p><a href=\"https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx\" rel=\"nofollow\" target=\"_blank\">https://taxes.gov.il/English/Vat/Pages/VatLobby.aspx</a></p>\n\t\t\t\t\t\t\t\t<p><strong>\xC0 l'exception de la travers\xE9e du pont Allenby, tous les autres points d'acc\xE8s, y compris les a\xE9roports</strong> sont soumis aux r\xE9glementations pr\xE9sent\xE9es dans le guide suivant, r\xE9dig\xE9 par l'Autorit\xE9 douani\xE8re et fiscale \xE0 l'intention des visiteurs :</p>\n\t\t\t\t\t\t\t\t<p><a href=\"https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx\" rel=\"nofollow\" target=\"_blank\">https://taxes.gov.il/English/Vat/pages/guides/vat-refund-for-tourists.aspx</a></p>\n\t\t\t\t\t\t\t\t<p><a href=\"https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx\" rel=\"nofollow\" target=\"_blank\">https://taxes.gov.il/English/customs/PersonalImport/Pages/CustomsTuristGuide.aspx</a></p>\n\t\t\t\t\t\t\t\t<p>Remarque : lors du passage en douane, deux voies (une verte, une rouge) sont propos\xE9es \xE0 l'A\xE9roport&nbsp; Ben Gurion et aux autres points de passage de la fronti\xE8re.&nbsp; Les visiteurs qui n'ont rien \xE0 d\xE9clarer doivent emprunter la voie verte \xE0 la sortie du hall d'arriv\xE9e des passagers.</p>\n\t\t\t\t\t\t\t\t\t\t         \n\n\t\t                        "};}},{id:"Frequently_Asked_Questions",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"FAQ",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t\t\t\t<h3>Frequently Asked Questions about the COVID-19 </h3>\n\n\t\t                                    <p>\n\t\t                                        <ol start=\"1\">\n\t\t                                              <li>\n\t\t\t\t\t\t\t\t\t\t\t          <strong>Je suis un touriste en Isra\xEBl et je crains d'avoir le COVID-19, o\xF9 dois-je aller ?</strong><br/>\n\t\t\t\t\t\t\t\t\t\t                Si vous avez une fi\xE8vre d\u2019au moins 38\xB0C ou plus, de la toux, des difficult\xE9s respiratoires ou d'autres sympt\xF4mes respiratoires, vous devez imm\xE9diatement vous auto-isoler et appeler le 101 (MDA Emergency Services Hotline) pour un avis m\xE9dical. Ne vous rendez pas dans une clinique ni dans une salle d'urgence.        \n\t\t\t\t\t\t\t\t\t\t              </li>\n\t\t\t\t\t\t\t\t\t\t              <li>\n\t\t\t\t\t\t\t\t\t\t                <strong>Quand Isra\xEBl sera-t-il \xE0 nouveau ouvert aux visiteurs \xE9trangers ?</strong><br/>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\u2019Il est \xE0 ce jour possible de se rendre en Isra\xEBl selon les conditions requises et avec un passeport en r\xE8gle. Il est demand\xE9 \xE0 chaque passager de remplir le formulaire d\u2019entr\xE9e (voir sur : www.israelsafe.com) et de disposer d\u2019une attestation d\u2019assurance personnelle sp\xE9cial COVID-19.\t\t\t\t\t\t\t\t\t\t              </li>\n\t\t\t\t\t\t\t\t\t\t\t       \n\t\t\t\t\t\t\t\t\t\t\t    </ol>\n\t\t                                    </p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Isra\xEBl c'est un peu loin, non&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Pas autant que vous le pensez : Isra\xEBl est \xE0 seulement 4h15 de vol de Paris et moins de 4h de Marseille. De plus, vous pouvez rejoindre Isra\xEBl via des douzaines de villes d'Europe.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>De quels documents ai-je besoin pour venir en Isra\xEBl&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Les citoyens fran\xE7ais et belges doivent se munir d'un passeport valide au moins six mois apr\xE8s leur date d'arriv\xE9e en Isra\xEBl. Il est inutile de se procurer un visa pour les s\xE9jours de moins de trois mois. Les m\xEAmes conditions s'appliquent aux citoyens de la plupart des pays occidentaux. Pour vous en assurer, consultez le document: <a href=\"//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf\" rel=\"nofollow\" target=\"_blank\">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Peut-on voyager sans danger en Isra\xEBl&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Si ce n'\xE9tait pas le cas, nous ne vous inviterions pas \xE0 venir. Chaque ann\xE9e, entre 3 et 4 millions de touristes viennent en vacances en Isra\xEBl, et \xE0 l'exception de ceux qui tombent amoureux d'un(e) isra\xE9lien(ne) - ou du pays lui-m\xEAme&nbsp;! - tous rentrent chez eux sains et saufs. S'il y avait un risque, le pays ne serait pas reli\xE9 par les avions de plus de 90 compagnies a\xE9riennes.&nbsp;</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Il para\xEEt qu'avant d'embarquer, il faut se soumettre \xE0 une enqu\xEAte de s\xE9curit\xE9...</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Si vous prenez un vol EL AL Israel Airlines (ou si vous venez d'Europe sur un vol Arkia Israel Airlines ou Israir), sachez que les pr\xE9cautions de s\xE9curit\xE9 appliqu\xE9es par les compagnies a\xE9riennes isra\xE9liennes sont l\xE9gendaires et envi\xE9es de toutes les compagnies a\xE9riennes au monde. Au moment de l'enregistrement, vous devrez r\xE9pondre \xE0 plusieurs questions dans le cadre d'un entretien de s\xE9curit\xE9. Certaines questions peuvent sembler non politiquement correctes, indiscr\xE8tes, non pertinentes ou r\xE9p\xE9titives. Contentez-vous de r\xE9pondre avec sinc\xE9rit\xE9, de prendre les choses comme elles viennent, sans perdre votre sang froid. Gardez \xE0 l'esprit que ces questions ont pour seul objectif de garantir votre s\xE9curit\xE9 ainsi que celle des autres passagers. Lorsque vous quittez Isra\xEBl, la proc\xE9dure d\xE9crite ci-dessus est appliqu\xE9e au d\xE9part par toutes les compagnies a\xE9riennes. &nbsp;</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Puis-je combiner mon voyage en Isra\xEBl avec une visite en Jordanie et/ou Egypte&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Absolument. Il existe des vols r\xE9guliers entre Tel Aviv et Le Caire et Tel Aviv et Amman. Vous pouvez vous y rendre par la terre, en traversant la fronti\xE8re entre Isra\xEBl et l'Egypte \xE0 Eilat/Taba, ou entre Isra\xEBl et la Jordanie \xE0 Eilat ou en empruntant le pont Sheikh Hussein au sud de la mer de Galil\xE9e. Vous aurez besoin d'un visa pour la Jordanie et l'Egypte. Les citoyens am\xE9ricains peuvent s'en procurer un \xE0 la fronti\xE8re. Les citoyens des autres pays sont invit\xE9s \xE0 s'adresser \xE0 leur consulat local en Egypte ou en Jordanie, afin de conna\xEEtre les formalit\xE9s d'obtention de visa.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Et si je veux visiter un autre pays arabe&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Pas de probl\xE8me. Comme de nombreux pays d'Europe, Isra\xEBl n'appose plus de tampon sur le passeport de ses visiteurs. Par cons\xE9quent, votre passeport n'indique pas que vous \xEAtes venu en Isra\xEBl.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Puis-je visiter l'Autorit\xE9 palestinienne&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Visiter Bethl\xE9em est extr\xEAmement simple, des milliers de touristes qui se rendent en Isra\xEBl le font chaque jour. Vous pouvez vous inscrire \xE0 une visite (voir \xE0 la r\xE9ception de votre h\xF4tel) ou prendre un taxi pour aller de J\xE9rusalem \xE0 Bethl\xE9em pour ensuite prendre un taxi palestinien \xE0 Bethl\xE9em.&nbsp;</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Que faut-il savoir en mati\xE8re de sant\xE9, m\xE9dicaments et vaccins&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Isra\xEBl est un pays ultra-moderne et celui au monde qui compte le plus de m\xE9decins par habitant. Le syst\xE8me de sant\xE9 et hospitalier du pays est envi\xE9 dans le monde entier. Pour visiter Isra\xEBl, aucun vaccin n'est exig\xE9 (\xE0 moins d'\xEAtre all\xE9 r\xE9cemment dans une r\xE9gion pr\xE9sentant un risque de fi\xE8vre jaune, chol\xE9ra ou fi\xE8vre Ebola). Vous trouverez dans le commerce des m\xE9dicaments \xE9quivalents \xE0 la plupart de ceux disponibles en Europe. Vous pouvez \xE9galement emporter avec vous vos propres m\xE9dicaments sur ordonnance. Si vous emportez des seringues ou flacons, n'oubliez pas de prendre avec vous la prescription de votre m\xE9decin attestant que vous en avez besoin, au cas o\xF9. Si vous avez besoin de consulter un m\xE9decin pendant votre s\xE9jour en Isra\xEBl, demandez conseil \xE0 la r\xE9ception de votre h\xF4tel. Une assurance voyage (comprenant une couverture m\xE9dicale) est toujours conseill\xE9e pour tous les voyages \xE0 l'\xE9tranger.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Comment s'habiller&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Comme presque partout dans le monde, vous pouvez porter des v\xEAtements d\xE9contract\xE9s pour faire du tourisme.&nbsp; Emportez de bonnes chaussures de marche ou des baskets ainsi que des v\xEAtements que vous pourrez superposer. Les Isra\xE9liens (en particuliers les femmes) adoptent un style \"casual chic\" le soir pour sortir \xE0 Tel Aviv et J\xE9rusalem. Certains quartiers religieux<b> </b>exigent une tenue pudique (bras et jambes couverts et parfois pas de pantalons pour les femmes). N'oubliez pas votre maillot de bain et, pour vous baigner dans la mer Morte, des chaussures en plastique ou chaussettes aquatiques.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Et pour l'argent&nbsp;?</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>La monnaie isra\xE9lienne est le shekel (officiellement le \"nouveau shekel\")&nbsp;; 1 Euro est \xE9gal \xE0 environ 4 Shekels.&nbsp;<a href=\"//www.boi.org.il/en/Markets/ExchangeRates/Pages/Default.aspx\" rel=\"nofollow\" target=\"_blank\">Cliquez ici pour conna\xEEtre le taux de change actuel</a>. Nous vous conseillons, \xE0 votre arriv\xE9e en Isra\xEBl, d'utiliser votre carte de cr\xE9dit pour retirer des devises \xE0 l'un des distributeurs automatiques disponibles dans les halls d'arriv\xE9e de l'a\xE9roport Ben Gurion, ou de changer de petites sommes ou ch\xE8ques de voyage \xE0 la banque de votre h\xF4tel. Vous trouverez des distributeurs de billets partout en Isra\xEBl et les cartes de cr\xE9dit sont largement accept\xE9es.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>\xC9lectricit\xE9</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>La plupart des chambres d'h\xF4tel sont \xE9quip\xE9es de s\xE8che-cheveux et de prises pour rasoir.&nbsp; En Isra\xEBl, l'\xE9lectricit\xE9 est en 220 V CA, monophas\xE9 50 cycles. Vous pouvez utiliser un transformateur 110&nbsp;V-220&nbsp;V pour brancher les appareils \xE9lectriques.&nbsp; Les prises isra\xE9liennes sont dot\xE9es de trois broches mais les raccords europ\xE9ens \xE0 deux broches fonctionnent g\xE9n\xE9ralement. En cas de probl\xE8me, demandez conseil \xE0 la r\xE9ception de votre h\xF4tel ou dans une quincaillerie.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Communications</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>La plupart des h\xF4tels proposent g\xE9n\xE9ralement une connexion wi-fi gratuite dans le hall, et parfois dans les chambres. De nombreux h\xF4tels poss\xE8dent un Centre d'affaires permettant d'acc\xE9der gratuitement \xE0 Internet et \xE0 la messagerie \xE9lectronique. Les t\xE9l\xE9phones portables am\xE9ricains qui fonctionnent \xE0 l'\xE9tranger fonctionneront \xE9galement en Isra\xEBl. Le d\xE9calage horaire est de + 1 heure: quand il est midi \xE0 Paris, il est 13 heures \xE0 J\xE9rusalem ou Tel-Aviv.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>Temp\xE9ratures</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Les temp\xE9ratures peuvent \xEAtre tr\xE8s variables : par cons\xE9quent, emportez des v\xEAtements adapt\xE9s \xE0 la saison et tout ira bien.&nbsp; La transition entre les saisons n'est bien entendu pas franche, mais les consignes g\xE9n\xE9rales sont les suivantes&nbsp;:<br>&nbsp;<br>\xC9T\xC9 (jun/jul/aou/d\xE9but sep)&nbsp;:&nbsp; temp\xE9ratures comprises entre 26 et 32\xBAC.&nbsp; Tel Aviv et Tib\xE9riade ont un climat chaud et humide (similaire \xE0 celui de New York ou Miami).&nbsp; J\xE9rusalem poss\xE8de un climat plus sec et plus frais, notamment la nuit.&nbsp; Massada et Eilat enregistrent des temp\xE9ratures extr\xEAmement \xE9lev\xE9es (+ de 43\xBAC&nbsp;!)... mais l'air y est sec.&nbsp; Vous n'aurez pas une goutte de pluie.<br>&nbsp;<br>PRINTEMPS/AUTOMNE (fin mar/avr/mai/fin sep/oct/nov)&nbsp;: temp\xE9ratures diurnes tr\xE8s plaisantes dans la plus grande partie du pays (autour de 24\xB0C) mais plus chaudes dans les r\xE9gions de la mer Rouge et de la mer Morte). \xC0 J\xE9rusalem, la temp\xE9rature sera d'environ 21\xB0C le jour et 10\xB0C la nuit.&nbsp; Vous aurez de la pluie, mais peu abondante.<br>&nbsp;<br>HIVER (d\xE9c/jan/f\xE9v/d\xE9but mar)&nbsp;: la m\xE9t\xE9o peut \xEAtre variable.&nbsp; Certains hivers sont doux et ensoleill\xE9s, d'autres rudes et nuageux. Les pluies fortes sont fr\xE9quentes, avec parfois de la neige en janvier et f\xE9vrier. La temp\xE9rature sera certainement comprise entre 10 et 15\xB0C dans la plupart des r\xE9gions, mais pourra descendre \xE0 4\xB0C \xE0 J\xE9rusalem et en Galil\xE9e, voire descendre encore la nuit.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>D\xE9placements</strong></p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>BUS:</strong>&nbsp;Isra\xEBl poss\xE8de l'un des r\xE9seaux de bus les plus performants et \xE9conomiques au monde puisqu'il relie la plupart des villes, villages et communes diverses.</p>\n\t\t\t\t\t\t\t\t\t\t\t<p><strong>TRAIN:&nbsp;</strong>des trains \xE0 grande vitesse relient l'A\xE9roport Ben Gurion \xE0 Tel Aviv, J\xE9rusalem et Ha\xEFfa, et des trains rapides et bon march\xE9 sillonnent la majeure partie du pays.&nbsp; Le train est un moyen de transport bon march\xE9 et extr\xEAmement simple \xE0 utiliser.&nbsp;<a href=\"//www.rail.co.il/EN/Pages/Homepage.aspx\">Cliquez ici</a>&nbsp;pour obtenir des informations compl\xE8tes.<br>&nbsp;<br><strong>AVION</strong>: Arkia, El Al et Israir proposent plusieurs liaisons quotidiennes pour Tel Aviv et Eilat, ainsi que des vols vers Ha\xEFfa et la Galil\xE9e.<br>&nbsp;<br><strong>TAXI:&nbsp;</strong>des taxis sont \xE0 votre disposition dans les villes et les chauffeurs vous transporteront avec plaisir d'une ville \xE0 l'autre. Consultez le tarif avant de convenir d'un trajet en taxi.<br>&nbsp;<br><strong>TAXI COLLECTIF:&nbsp;</strong>les taxis collectifs ou \"Sherut\" connaissent un vif succ\xE8s. Des stations \"Sherut\" sont propos\xE9es dans toute la ville. Pour conna\xEEtre la station la plus proche, adressez-vous \xE0 la r\xE9ception de votre h\xF4tel.<br>&nbsp;<br><strong>LOCATION DE VOITURE:&nbsp;</strong>La plupart des soci\xE9t\xE9s de location internationales poss\xE8dent des agences en Isra\xEBl. Il existe \xE9galement d'excellentes agences nationales. Votre permis de conduire europ\xE9en est valable en Isra\xEBl.</p>\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t                  \n\t\t                        "};}},{id:"Passports_Visa",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:false,title:"PASSEPORTS ET VISA",smltitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t   <p>Toutes les personnes venant visiter Isra\xEBl doivent avoir un passeport valide au moins six mois apr\xE8s la date de leur retour. Les personnes sans nationalit\xE9 doivent d\xE9tenir un laissez-passer valide, ainsi qu'un visa de retour vers le pays l'ayant \xE9mis.</p>\n\t\t\t\t\t\t\t\t<p>Les visiteurs sont autoris\xE9s \xE0 rester en Isra\xEBl jusqu'\xE0 trois mois \xE0 partir de la date de leur arriv\xE9e, conform\xE9ment aux conditions du visa qui leur a \xE9t\xE9 accord\xE9. Les visiteurs souhaitant travailler en Isra\xEBl doivent demander un visa sp\xE9cial au Minist\xE8re de l'int\xE9rieur.</p>\n\t\t\t\t\t\t\t\t<p>Isra\xEBl ne tamponne plus les passeports dans les a\xE9roports et dans la plupart des postes frontaliers.&nbsp; N\xE9anmoins, du fait que des difficult\xE9s techniques peuvent parfois se produire, et \xE0 certains moments, le contr\xF4le des fronti\xE8res doit revenir \xE0 la m\xE9thode consistant \xE0 tamponner les passeports. Nous recommandons donc aux touristes quittant Isra\xEBl pour aller dans les pays arabes de faire une <strong>demande officielle</strong> pour qu'aucun tampon isra\xE9lien n'apparaisse sur leur passeport. Le touriste doit informer le fonctionnaire de cette demande avant que les documents ne soient tamponn\xE9s.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/passports-visa/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div> <br>\n\t\t\t\t\t\t\t\t<p><strong>La carte \"Electronic Gate Pass\".</strong></p>\n\t\t\t\t\t\t\t\t<p>Conform\xE9ment \xE0 la section 13 de la loi de 1952 relative \xE0 l'entr\xE9e sur le territoire d'Isra\xEBl, un inspecteur officiel ou un officier de police peut exiger une identification et une preuve de la l\xE9galit\xE9 de la pr\xE9sence en Isra\xEBl. \xC0 cette fin, par simple pression sur un bouton, le poste de contr\xF4le douanier imprimera une carte r\xE9capitulant les principales informations concernant le voyageur, qui figurent en premi\xE8re page du passeport. La carte indique \xE9galement la date d'arriv\xE9e et les informations de visa. Appel\xE9e \xAB&nbsp;Electronic Gate Pass&nbsp;\xBB, cette carte est un nouveau syst\xE8me bas\xE9 sur une technologie moderne pour r\xE9pondre aux besoins des diff\xE9rentes autorit\xE9s d'immigration, de s\xE9curit\xE9, des a\xE9roports et de tourisme. Elle permet \xE9galement aux touristes en r\xE8gle de prouver la validit\xE9 de leur visa.&nbsp; <strong>La carte \xAB&nbsp;Electronic Gate Pass&nbsp;\xBB remplace le syst\xE8me consistant \xE0 tamponner les passeports</strong>&nbsp; \xC0 l'a\xE9roport, cette carte permet aux voyageurs de quitter le terminal d'arriv\xE9e sans attente suppl\xE9mentaire.</p>\n\t\t\t\t\t\t\t\t<p><strong>Le Gate Pass constitue une forme d'identification officielle valable pendant la dur\xE9e de votre s\xE9jour en Isra\xEBl.&nbsp; </strong>Tous les touristes sont invit\xE9s \xE0 garder cette carte sur eux en permanence afin de prouver la validit\xE9 de leur visa. \xC0 l'a\xE9roport et \xE0 certains postes fronti\xE8res, cette carte permet aux voyageurs de quitter le terminal d'arriv\xE9e pour se rendre \xE0 la zone de retrait des bagages.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p><strong>Il est demand\xE9 aux touristes de conserver \xE0 tout moment cette carte \xE0 port\xE9e de main.</strong></p>\n\t\t\t\t\t\t\t\t<p><strong>Visas touristiques</strong></p>\n\t\t\t\t\t\t\t\t<p>Isra\xEBl est heureux d'accueillir des visiteurs. De nombreux pays ont avec Isra\xEBl un programme d'exemption de visa, qui permet \xE0 leurs citoyens de visiter Isra\xEBl sans visa pr\xE9alable. Avant de s'embarquer, les visiteurs d\xE9sirant s'arr\xEAter en Isra\xEBl sur leur chemin vers d'autres destinations doivent v\xE9rifier s'ils ont besoin d'un visa touristique pr\xE9alable. Le lien qui suit donne la liste des pays en provenance desquels les touristes doivent pr\xE9senter un visa pr\xE9alable.</p>\n\t\t\t\t\t\t\t\t<p><a href=\"//mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf\" rel=\"nofollow\" target=\"_blank\">http://mfa.gov.il/MFA/ConsularServices/Documents/VisaRequirements-Tourists.pdf</a></p>\n\t\t\t\t\t\t\t\t<p>Pour p\xE9n\xE9trer en Isra\xEBl sans visa pr\xE9alable, tous les voyageurs b\xE9n\xE9ficiant d'un programme d'exemption de visa doivent pr\xE9senter au point d'entr\xE9e un passeport lisible par machine, sans quoi un visa sera exig\xE9. Cette disposition s'applique aux touristes arrivant avec une carte de passage depuis les pays ayant un programme d'exemption.</p>\n\t\t\t\t\t\t\t\t<p><strong>Prolongation de votre s\xE9jour </strong></p>\n\t\t\t\t\t\t\t\t<p>&#8203;Votre visa peut \xEAtre prolong\xE9 (redevance exig\xE9e) en vous adressant au bureau du Minist\xE8re de l'int\xE9rieur le plus proche. Pour cela, veuillez appeler le centre d'appel du Minist\xE8re au&nbsp;: *3450 ou composez le 12223450.</p>\n\t\t\t\t\t\t\t\t\t\t              \n\n\t\t                        "};}},{id:"Crazy_Night",ctg:"telaviv",bgImage:"/posts/bank/crazy-night/1.jpg",mobBgImage:"/posts/bank/crazy-night/M.jpg",isVid:true,vidId:"ogEN7aRT0SM",title:"À la recherche d'une vie nocturne de folie ?!",smltitle:"",html:function html(){return{__html:"<div class=\"ac-cradit\">\n\t\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text\">Credits:</span>\n\t\t\t\t\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text-1\">Tel Aviv Jaffa municipality<br/></span<\n\t\t\t\t\t\t\t\t\t\t<span class=\"ac-cradit-text-2\">UDINI prodactions<br/></span>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p></p>\n\t\t\t\t\t\t\t\t\t</div>\n                               <h2>\n                                   R\xE9servez votre s\xE9jour \xE0 Tel-Aviv d\xE8s maintenant !\n                               </h2>\n                               <p>\n                                 Amazing nightlife in Tel Aviv <a href=\"https://en.citiesbreak.com/Posts/telaviv/Amazing_Nightlife\" target=\"_blank\">Click here >> </a>\n                               </p>\n\t\t                        "};}},{id:"Heart_Of_The_World",ctg:"jerusalem",bgImage:"/posts/bank/heart-of-the-world/1.jpg",mobBgImage:"/posts/bank/heart-of-the-world/M.jpg",isVid:true,vidId:"nLKWDp5uA-U",title:"Jérusalem - le coeur du monde",smltitle:"",html:function html(){return{__html:"\n                               \n\t\t                        "};}},{id:"Neot_Semadar",ctg:"eilat-negev",bgImage:"/posts/bank/Neot_Semadar/1.jpg",mobBgImage:"/posts/bank/Neot_Semadar/M.jpg",isVid:false,title:"Neot Semadar",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t\t\t\n\n\t\t\t\t\t\t<p>Nich\xE9 au c\u0153ur du d\xE9sert de la Arava au sud d\u2019Isra\xEBl, Neot Semadar offre aux voyageurs une exp\xE9rience unique o\xF9 se rencontrent l'art, l'\xE9cologie et la communaut\xE9. Ce remarquable kibboutz est bien plus qu'une simple destination - c'est une v\xE9ritable toile vivante de cr\xE9ativit\xE9 humaine et d'harmonie environnementale.</p>\n\t\t\t\t\t\t<p>Imaginez un lieu o\xF9 l'exploit architectural c\xF4toie l'innovation \xE9cologique. Le centre artistique du kibboutz se dresse comme un t\xE9moignage de design collaboratif, avec un b\xE2timent extraordinaire aux audacieuses structures arrondies, surmont\xE9 d'une tour d'observation panoramique de 38 m\xE8tres. Chaque \xE9l\xE9ment raconte une histoire de vision collective et d'expression artistique.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Neot_Semadar/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p>Les visiteurs peuvent explorer les multiples facettes de cette communaut\xE9 du d\xE9sert. </p>\n\t\t\t\t\t\t<p>Les ateliers d'artistes mettent en valeur l'artisanat local, notamment la peinture sur soie, la sculpture sur bois et le tissage. Le paysage environnant offre des panoramas \xE0 360 degr\xE9s \xE0 couper le souffle, invitant les voyageurs \xE0 se connecter \xE0 la beaut\xE9 brute de l'environnement naturel.</p>\n\t\t\t\t\t\t<p>Au-del\xE0 de l'esth\xE9tique, Neot Semadar repr\xE9sente un engagement profond envers un mode de vie durable. La communaut\xE9 pratique l'agriculture biologique, propose des produits artisanaux et maintient une remarquable biodiversit\xE9 qui attire les chercheurs scientifiques. Avec plus de 196 esp\xE8ces de faune document\xE9es, le kibboutz se distingue comme un sanctuaire \xE9cologique unique.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Neot_Semadar/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p>Pour qui recherche une exp\xE9rience immersive, le site propose des opportunit\xE9s \xE0 s'engager dans la vie communautaire, \xE0 participer \xE0 des ateliers et \xE0 savourer des produits biologiques locaux. L'h\xE9bergement offre une retraite paisible au c\u0153ur du d\xE9sert, permettant aux visiteurs de se d\xE9connecter et de se reconnecter aux rythmes de la nature.</p>\n\t\t\t\t\t\t<p>Une visite \xE0 Neot Semadar d\xE9passe le simple tourisme - c'est un voyage au sein d'une communaut\xE9 inspir\xE9e et cr\xE9ative qui r\xE9invente le potentiel humain en parfaite harmonie avec le paysage d\xE9sertique.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/Neot_Semadar/3.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<p>Pour obtenir des informations compl\xE9mentaires sur le kibboutz et les options de visite, consultez notre site web: <a href=\"https://neot-semadar.com/en\" rel=\"noopener\" target=\"_blank\">https://neot-semadar.com/en</a></p>\n\t\t\t\t\t\t "};}},{id:"EILAT1",ctg:"eilat-negev",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",isVid:true,vidId:"ZdnNT-GDJv4",title:"EILAT",smltitle:"",html:function html(){return{__html:"\n                                \n\n                        \n                        <br/>\n                        <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">\n                        Un sentiment d'\xE9vasion pour un \xE9t\xE9 sans fin</h2>\n                         \n                      \n                                \n\n\t\t\t\t\t\t\t    <p>Capitale de la mer Rouge, Eilat est une cit\xE9 baln\xE9aire renomm\xE9e qui attire chaque ann\xE9e quelque 2,8 millions de visiteurs qui choisissent de passer leurs vacances sur les magnifiques rives de la mer Rouge.</p>\n\t\t\t\t\t\t\t\t<p>Eilat, la ville la plus au sud d'Isra\xEBl, est r\xE9put\xE9e pour la beaut\xE9 de ses paysages d\xE9sertiques, la splendeur de sa baie et un soleil qui brille toute l'ann\xE9e.&nbsp;<br><br>Que vous veniez \xE0 Eilat en famille, en couple ou seul, ce ne sont pas les lieux \xE0 visiter et les activit\xE9s qui manquent. De nombreux types d'h\xE9bergement vous attendent \xE9galement&nbsp;: luxueux h\xF4tels 5 \xE9toiles, logements de charme propos\xE9s par Airbnb ou auberges de jeunesse.&nbsp;&nbsp;</p>\n\t\t\t\t\t\t\t\t<p>Avec pas moins de 360 jours d'ensoleillement par an, Eilat est une destination extr\xEAmement pris\xE9e des touristes qui viennent de loin pour \xE9chapper \xE0 la rigueur hivernale.&nbsp;<br>Une visite \xE0 Eilat est une exp\xE9rience extr\xEAmement plaisante car vous pouvez \xE0 la fois vous d\xE9tendre, vous ressourcer et faire le plein d'\xE9nergie. Cette station baln\xE9aire anim\xE9e offre une multitude d'activit\xE9s et attractions tout au long de l'ann\xE9e, ainsi que d'excellents restaurants, caf\xE9s, centres commerciaux, bars branch\xE9s et bo\xEEtes de nuit.<br>Et le mieux dans tout cela&nbsp;? \xC0 Eilat, tout n'est qu'\xE0 quelques pas de la plage.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/eilat1/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p><strong>Plongez dans la mer Rouge</strong></p>\n\t\t\t\t\t\t\t\t<p>Une fantastique attraction touristique en elle-m\xEAme, la mer Rouge et les 10 kilom\xE8tres de c\xF4tes sublimes qui entourent Eilat constituent un des lieux les plus pris\xE9s de la r\xE9gion par les touristes de tous horizons.<br>Son eau propre, limpide et \xE9tonnamment fra\xEEche offre un r\xE9pit bienvenu \xE0 l'air chaud et sec de la ville. De plus, les nombreux centres d'int\xE9r\xEAt et installations des plages d'Eilat en font le lieu id\xE9al pour bronzer, se reposer et se d\xE9tendre.</p>\n\t\t\t\t\t\t\t\t<p>Les amateurs de sensations fortes ne manqueront pas de participer aux activit\xE9s propos\xE9es par les douzaines de clubs de sports aquatiques qui jalonnent les c\xF4tes nord et sud d'Eilat, telles que jet-ski, \xAB&nbsp;banana boat&nbsp;\xBB, bou\xE9e tract\xE9e, kayak, etc.</p>\n\t\t\t\t\t\t\t\t<p><strong>L'ambiance des nuits d'Eilat </strong></p>\n\t\t\t\t\t\t\t\t<p>Quand vient le soir et que le soleil ardent du d\xE9sert se couche sur Eilat, lorsque que les piscines et plages ferment, prenez une douche, changez-vous et participez \xE0 la vie nocturne anim\xE9e de la ville.&nbsp; Eilat d\xE9tient un record unique, celui du nombre de bo\xEEtes de nuit, bars et autres lieux de divertissement par habitant d'Isra\xEBl. Vous trouverez donc \xE0 coup s\xFBr l'endroit qui vous permettra de vous amuser jusqu'au bout de la nuit, tout comme vous l'avez fait pendant la journ\xE9e.</p>\n\t\t\t\t\t\t\t\t<p><strong>L'aventure dans le d\xE9sert</strong></p>\n\t\t\t\t\t\t\t\t<p>Au nord de la ville se trouve Arava, une r\xE9gion d\xE9sertique qui offre des panoramas \xE9poustouflants. Elle figure parmi les lieux du pays \xE0 ne pas manquer o\xF9 vous pourrez profiter de ses vastes \xE9tendues et admirer ses falaises abruptes, ses vall\xE9es et ses cours d'eau au gr\xE9 des randonn\xE9es.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t    <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/eilat1/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t<p>Outre le fait qu'elles contribuent \xE0 l'extraordinaire panorama de la ville, les montagnes color\xE9es et fascinantes de la r\xE9gion d'Eilat offriront une exp\xE9rience inoubliable aux amoureux de la nature. Vous pourrez parcourir les nombreux itin\xE9raires et sites \xE0 pied, \xE0 v\xE9lo, en voiture, \xE0 dos de chameau et m\xEAme en escalade ou en descente, si vous aimez les sports extr\xEAmes.&nbsp;</p>\n\t\t\t\t\t\t\t\t                        \n\n\n\t\t\t\t\t\t "};}},{id:"Ha_Arava",ctg:"eilat-negev",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",isVid:false,title:"ARAVA: ETONNEZ-VOUS !",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t      \n\n\t\t\t\t\t\t\t\t\t<p>Situ\xE9 entre le carrefour de Menucha au nord et le premier rond-point \xE0 l'entr\xE9e d\u2019Eilat, Arava est bord\xE9 par Har haNegev et les montagnes d'Eilat \xE0 l'ouest et les montagnes d'Edom \xE0 l'est. En d\xE9pit de son \xE9troitesse, cette bande de terre vous fera <em>ressentir</em> le d\xE9sert et tout ce qu'il a \xE0 offrir, que vous soyez en couple, en famille ou en groupe. Pour d\xE9couvrir Arava, les visiteurs ont le choix&nbsp;: \xE0 pied, en v\xE9lo, en voiture ou en car. En terme d'h\xE9bergement, le choix est aussi large puisque vous pourrez tout aussi bien dormir dans un h\xF4tel de luxe, que faire du \xAB&nbsp;glamping&nbsp;\xBB ou dormir \xE0 la belle \xE9toile. Voici quelques exemples de ce que vous pourrez voir et faire&nbsp;:</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Parc national de Timna</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Notre tout nouveau centre d\u2019accueil, situ\xE9 \xE0 l'entr\xE9e du parc, vous accueille avec une pr\xE9sentation des magnifiques paysages de Timna. Les gr\xE8s rouges sculpt\xE9s par la nature se juxtaposent \xE0 des rochers noirs et blancs pour cr\xE9er un cadre d'une beaut\xE9 \xE0 couper le souffle. En forme de fer \xE0 cheval, le parc de Timna rec\xE8le de tr\xE9sors des diff\xE9rentes p\xE9riodes et raconte l'histoire des mines de cuivre de l'\xC9gypte ancienne qui produisent encore aujourd'hui du minerai, en laissant admirer de v\xE9ritables vestiges ainsi que d'autres t\xE9moignages du pass\xE9.</p>\n\t\t\t\t\t\t\t\t\t<p>Timna propose plus de 25 pistes pour les randonneurs, les v\xE9los (y compris des monotraces), et les v\xE9hicules motoris\xE9s, dont les pistes du <strong>Champignon</strong>, des <strong>Arches</strong>, des <strong>Piliers de Salomon</strong>, du <strong>Canyon rose</strong>, de la C<strong>orkscrew</strong> et des <strong>Visages</strong>. Sans oublier&nbsp;: le Tabernacle, une r\xE9plique exacte du tabernacle biblique port\xE9 par les Isra\xE9lites durant leur p\xE9riple dans le Sina\xEF ; un lac que vous pourrez explorer en p\xE9dalo ; la fabrication de bouteilles remplies de sables color\xE9s et autres cr\xE9ations artisanales ; des locations de v\xE9los ; un camping r\xE9glement\xE9 ; et l'Auberge du Roi Salomon o\xF9 vous pourrez vous d\xE9salt\xE9rer et acheter des souvenirs.</p>\n                                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/ha-arava/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<p><strong>R\xE9serve naturelle Hai-Bar</strong></p>\n\t\t\t\t\t\t\t\t\t<p>La R\xE9serve naturelle de Hai-Bar a pour mission de r\xE9introduire dans la nature les animaux mentionn\xE9s dans la Bible. Les animaux sont prot\xE9g\xE9s et soign\xE9s dans leur habitat naturel qui est accessible aux visiteurs. Des circuits pour v\xE9hicules motoris\xE9s permettent aux visiteurs de partir en safari et de d\xE9couvrir des oryx, des addax et m\xEAme des autruches&nbsp;!... dans un cadre naturel o\xF9 s'\xE9panouit la flore du d\xE9sert, notamment l'acacia mentionn\xE9 dans la Bible. Des guides sur CD en diff\xE9rentes langues sont en vente dans notre boutique. Des visites guid\xE9es sont organis\xE9es le samedi \xE0 11h... l'heure de la \xAB&nbsp;collation&nbsp;\xBB des animaux&nbsp;! Un camping tout \xE9quip\xE9 est \xE0 votre disposition.</p>\n                                     <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/ha-arava/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Ferme de la Route des \xE9pices, \xE0 Eilat</strong></p>\n\t\t\t\t\t\t\t\t\t<p>La ferme, qui participe \xE0 des recherches en mariculture, se trouve au point d'intersection entre les anciennes Routes des \xE9pices et la Route de la mer, face aux montagnes d'Edom. On y \xE9l\xE8ve algues, palourdes, art\xE9mies et pseudochromis de la mer Rouge (\xAB&nbsp;poissons de Friedman&nbsp;\xBB en h\xE9breu, d'apr\xE8s le nom de l'\xE9leveur \xE0 l'origine de leur d\xE9couverte).</p>\n\t\t\t\t\t\t\t\t\t<p>Le centre d'accueil des visiteurs de la ferme est une v\xE9ritable f\xEAte pour les sens puisqu'en franchissant l'entr\xE9e vous \xEAtes accueillis par les parfums de douzaines d'\xE9pices, m\xE9langes et infusions utilis\xE9s pour la cuisine ou pour leurs propri\xE9t\xE9s th\xE9rapeutiques. Vous y trouverez \xE9galement des ustensiles de cuisine sp\xE9ciaux dont notre personnel se fera un plaisir d'expliquer le fonctionnement.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>L'agriculture biologique en vedette \xE0 Ne\xF3t Smad\xE1r</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Promenez-vous dans notre communaut\xE9 et admirez notre splendide centre d'art, dont la construction a demand\xE9 13 ann\xE9es de travail, nos terrains qui refl\xE8tent notre souci du d\xE9tail et notre c\xF4t\xE9 rustique, ainsi que nos vignobles et l'exploitation viticole la plus m\xE9ridionale d'Isra\xEBl&nbsp;!</p>\n\t\t\t\t\t\t\t\t\t<p>Notre centre d'art accueille les ateliers de nos artisans ainsi qu'une galerie o\xF9 leurs produits sont expos\xE9s et propos\xE9s \xE0 la vente. Le centre de la structure, reconnaissable par sa tour, est un puit de refroidissement qui joue le r\xF4le de climatiseur et rafra\xEEchit tout le b\xE2timent. L'ext\xE9rieur et l'int\xE9rieur du centre sont agr\xE9ment\xE9s de boiseries ornementales qui ont toutes \xE9t\xE9 fabriqu\xE9es par les membres de notre communaut\xE9.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Arava</strong><strong> de nuit</strong></p>\n\t\t\t\t\t\t\t\t\t<p>La nuit venue, le paysage change&nbsp;: les montagnes d'Edom se parent de nuances plus sombres de rouge et de violet sur fond de ciel parsem\xE9 d'\xE9toiles et baign\xE9 par le clair de lune. C'est l'heure de dormir et nous allons vous aider \xE0 trouver le logement le plus confortable et le mieux adapt\xE9 \xE0 vos besoins. Appelez notre ligne fixe au +972 (8) 661.6976&nbsp;!</p>\t\t\t\t\t\t\t                               \n\t\t\t\t\t\t\t\t\t\t\t                     \n\n\t\t                        "};}},{id:"Welcome_To_Eilat",ctg:"eilat-negev",bgImage:"/posts/bank/eilat2/1.jpg",mobBgImage:"/posts/bank/eilat2/M.jpg",isVid:true,vidId:"ZdnNT-GDJv4",title:"UN SENTIMENT D'ÉVASION POUR UN ÉTÉ SANS FIN",smltitle:"",html:function html(){return{__html:"\n                                    \n                                   \n                                   \n\t\t\t\t\t\t\t\t\t<p><strong>Capitale de la mer Rouge, Eilat est une cit\xE9 baln\xE9aire renomm\xE9e qui attire chaque ann\xE9e quelque 2,8 millions de visiteurs qui choisissent de passer leurs vacances sur les magnifiques rives de la mer Rouge.</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Eilat, la ville la plus au sud d'Isra\xEBl, est r\xE9put\xE9e pour la beaut\xE9 de ses paysages d\xE9sertiques, la splendeur de sa baie et un soleil qui brille toute l'ann\xE9e.&nbsp;<br><br>Que vous veniez \xE0 Eilat en famille, en couple ou seul, ce ne sont pas les lieux \xE0 visiter et les activit\xE9s qui manquent. De nombreux types d'h\xE9bergement vous attendent \xE9galement&nbsp;: luxueux h\xF4tels 5 \xE9toiles, logements de charme propos\xE9s par Airbnb ou auberges de jeunesse.&nbsp;&nbsp;</p>\n\t\t\t\t\t\t\t\t\t<p>Avec pas moins de 360 jours d'ensoleillement par an, Eilat est une destination extr\xEAmement pris\xE9e des touristes qui viennent de loin pour \xE9chapper \xE0 la rigueur hivernale.&nbsp;<br>Une visite \xE0 Eilat est une exp\xE9rience extr\xEAmement plaisante car vous pouvez \xE0 la fois vous d\xE9tendre, vous ressourcer et faire le plein d'\xE9nergie. Cette station baln\xE9aire anim\xE9e offre une multitude d'activit\xE9s et attractions tout au long de l'ann\xE9e, ainsi que d'excellents restaurants, caf\xE9s, centres commerciaux, bars branch\xE9s et bo\xEEtes de nuit.<br>Et le mieux dans tout cela&nbsp;? \xC0 Eilat, tout n'est qu'\xE0 quelques pas de la plage.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Plongez dans la mer Rouge</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Une fantastique attraction touristique en elle-m\xEAme, la mer Rouge et les 10 kilom\xE8tres de c\xF4tes sublimes qui entourent Eilat constituent un des lieux les plus pris\xE9s de la r\xE9gion par les touristes de tous horizons.<br>Son eau propre, limpide et \xE9tonnamment fra\xEEche offre un r\xE9pit bienvenu \xE0 l'air chaud et sec de la ville. De plus, les nombreux centres d'int\xE9r\xEAt et installations des plages d'Eilat en font le lieu id\xE9al pour bronzer, se reposer et se d\xE9tendre.</p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/welcome-to-eilat/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p>Les amateurs de sensations fortes ne manqueront pas de participer aux activit\xE9s propos\xE9es par les douzaines de clubs de sports aquatiques qui jalonnent les c\xF4tes nord et sud d'Eilat, telles que jet-ski, \xAB&nbsp;banana boat&nbsp;\xBB, bou\xE9e tract\xE9e, kayak, etc.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>L'ambiance des nuits d'Eilat </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Quand vient le soir et que le soleil ardent du d\xE9sert se couche sur Eilat, lorsque que les piscines et plages ferment, prenez une douche, changez-vous et participez \xE0 la vie nocturne anim\xE9e de la ville.&nbsp; Eilat d\xE9tient un record unique, celui du nombre de bo\xEEtes de nuit, bars et autres lieux de divertissement par habitant d'Isra\xEBl. Vous trouverez donc \xE0 coup s\xFBr l'endroit qui vous permettra de vous amuser jusqu'au bout de la nuit, tout comme vous l'avez fait pendant la journ\xE9e.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>L'aventure dans le d\xE9sert</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Au nord de la ville se trouve Arava, une r\xE9gion d\xE9sertique qui offre des panoramas \xE9poustouflants. Elle figure parmi les lieux du pays \xE0 ne pas manquer o\xF9 vous pourrez profiter de ses vastes \xE9tendues et admirer ses falaises abruptes, ses vall\xE9es et ses cours d'eau au gr\xE9 des randonn\xE9es.</p>\n\t\t\t\t\t\t\t\t\t<p>Outre le fait qu'elles contribuent \xE0 l'extraordinaire panorama de la ville, les montagnes color\xE9es et fascinantes de la r\xE9gion d'Eilat offriront une exp\xE9rience inoubliable aux amoureux de la nature. Vous pourrez parcourir les nombreux itin\xE9raires et sites \xE0 pied, \xE0 v\xE9lo, en voiture, \xE0 dos de chameau et m\xEAme en escalade ou en descente, si vous aimez les sports extr\xEAmes.&nbsp;</p>\n\t\t\t\t\t\t\t\t\t<p>N'attendez plus. Visitez Eilat. \xC9vadez-vous au soleil.</p>\n\t\t\t\t\t\t\t\t\t\n\n\n\t\t                        "};}},{id:"The_Ultimate_Holiday",ctg:"eilat-negev",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",isVid:false,title:"Pourquoi eilat est-elle la destination de vacances idéale ?",smltitle:"",html:function html(){return{__html:"\n                                 \n\n                               \n\t\t\t\t\t\t\t\t<p>D\xE9couvrez la ville au soleil \xE9ternel</p>\n\t\t\t\t\t\t\t\t<p><strong>Eilat, </strong>la ville la plus au sud d'Isra\xEBl, poss\xE8de tous les atouts n\xE9cessaires pour passer des vacances parfaites. Pour une escapade romantique, des vacances en famille, un s\xE9jour sous le signe de l'aventure et de l'action ou faire la f\xEAte entre amis, cette station baln\xE9aire situ\xE9e sur les rives de la mer Rouge est le lieu qu'il vous faut. Soleil m\xE9diterran\xE9en, eaux cristallines, spas apaisants, vie nocturne tr\xE9pidante, achats d\xE9tax\xE9s et attractions \xE0 profusion&nbsp;: c'est cela Eilat&nbsp;!</p>\n\t\t\t\t\t\t\t\t<p><strong>Profitez du soleil. </strong>Cette ville b\xE9n\xE9ficie d'un soleil estival \xE0 longueur d'ann\xE9e. Le meilleur moment pour la visiter est donc... celui que vous voulez&nbsp;! M\xEAme lorsque toute l'Europe grelotte, Eilat permet d'\xE9chapper au froid. Sautez dans un avion et au bout de quelques heures vous arr\xEAterez de frissonner, vous vous sentirez revigor\xE9.</p>\n\t\t\t\t\t\t\t\t<p><strong>Choisissez o\xF9 poser vos valises. </strong>Auberges, h\xF4tels \xE0 bas co\xFBt, h\xF4tels luxueux ou h\xF4tels de caract\xE8re\u2026 H\xE9bergement familial (ou de groupe) ou pied-\xE0-terre retir\xE9, calme et romantique&nbsp;; Eilat propose un vaste choix de lieux d'h\xE9bergement adapt\xE9s \xE0 tous les budgets et \xE0 tous les besoins.</p>\n\t\t\t\t\t\t\t\t<p><strong>Jetez-vous \xE0 l'eau.</strong> Avec plus de 7 kilom\xE8tres de superbes c\xF4tes bordant la mer Rouge, Eilat se pr\xEAte aux activit\xE9s aquatiques en tous genres. De la plong\xE9e avec tuba \xE0 la plong\xE9e sous-marine et \xE0 la planche \xE0 voile, en passant par le kite-surf ou la voile, etc. - tout est possible.</p>\n\t\t\t\t\t\t\t\t<p>D\xE9couvrez le <strong>R\xE9cif des dauphins</strong>, une plage familiale \xE9cologique dot\xE9e d'un magnifique jardin botanique, de bassins de d\xE9tente et, l'attraction principale, la possibilit\xE9 de regarder, toucher, nager et plonger avec les dauphins. (Soyez sans crainte<em>, toute interaction avec ces splendides cr\xE9atures n'a lieu que quand elles le d\xE9sirent</em>).</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-ultimate-holiday/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t<p>Visitez l'<strong>Observatoire sous-marin</strong>, une des attractions touristiques les plus populaires d'Eilat, o\xF9 votre famille et vous pourrez admirer et apprendre \xE0 conna\xEEtre la vie marine unique de la mer Rouge. \xC0 travers d'immenses baies vitr\xE9es, vous verrez \xE9voluer requins, tortues, raies et poissons multicolores de la mer Rouge. En embarquant sur un navire \xE0 la coque transparente, vous aurez l'impression de faire partie int\xE9grante de ce royaume sous-marin magique.</p>\n\t\t\t\t\t\t\t\t<p>Ne manquez pas la<strong> R\xE9serve naturelle de la Plage des Coraux </strong>de renomm\xE9e mondiale et sa splendide barri\xE8re de corail<strong>. </strong>Plongez avec masque et tuba ou avec bouteilles pour observer les poissons color\xE9s et les magnifiques plantes aquatiques de cet habitat naturel, rare et d\xE9licat.</p>\n\t\t\t\t\t\t\t\t<p><strong>Vivez une grande aventure dans le d\xE9sert. </strong>Le d\xE9sert du N\xE9guev offre certains des parcours sc\xE9niques les plus spectaculaires d'Isra\xEBl. En randonn\xE9e, \xE0 v\xE9lo ou en jeep, vous pourrez partir en exploration et vous \xE9merveiller devant la beaut\xE9 qui vous entoure.</p>\n\t\t\t\t\t\t\t\t<p>\xC0 seulement 25 kilom\xE8tres au nord d'Eilat, vous trouverez la <strong>vall\xE9e du parc de Timna</strong>. Partez en balade et explorez la splendide campagne environnante ainsi que le site antique de la premi\xE8re mine de cuivre au monde, et profitez des nombreuses attractions propos\xE9es aux familles et aux plus t\xE9m\xE9raires.</p>\n\n    \n\n\n<p>Vous voulez poursuivre votre aventure&nbsp;? Eilat permet d'acc\xE9der rapidement \xE0 tout le pays. Allez passer une journ\xE9e au bord de la mer Morte ou \xE0 J\xE9rusalem.</p>\n<p><strong>Prenez le temps de vous d\xE9tendre. </strong>Eilat est une ville calme qui permet vraiment de ralentir le rythme et de se reposer. Elle propose \xE9galement de superbes spas dispensant des soins tr\xE8s vari\xE9s allant des massages traditionnels \xE0 la baln\xE9oth\xE9rapie. <em>Faites-nous confiance, vous ne le regretterez pas&nbsp;!</em></p>\n<p><strong>Faites du shopping, mangez, buvez et faites la f\xEAte. </strong>Faites des achats au march\xE9 de la promenade de la ville, dans les boutiques de luxe et dans les nombreuses galeries marchandes<strong> - </strong>vous ne paierez pas les taxes&nbsp;<strong>!</strong></p>\n<p><strong>Passez une nuit en ville.</strong> Admirez le magnifique spectacle son et lumi\xE8re de la fontaine&nbsp;; pr\xE9parez-vous \xE0 avoir le souffle coup\xE9 par un spectacle digne de Broadway combinant danse, effets lumineux acrobatiques, bande sonore de haute qualit\xE9 et bien d'autres surprises.</p>\n<p>D\xEEnez dans un des nombreux restaurants et bars de la ville puis sortez en bo\xEEte de nuit.</p>\n<p>Que demander de plus&nbsp;?!</p>\n\n\t\t\t\t\t\t\t  \n\n\n\t\t                        "};}},// {
// 		id:"Eilat_Calling",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"ZdnNT-GDJv4",
//         title : "365 DAYS OF NONSTOP SUNNY JOY",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 							<p>Incredible adventure in Israel’s no. 1 vacation resort by the red sea.</p>
// 							<p>The capital of the red sea, Eilat is Israel's famous resort city drawing nearly 2.8 million visitors a year who come to vacation by the shores of the stunning red sea.</p>
// 							<p>The southernmost city in Israel, Eilat is renowned for its spectacular combination of the surrounding desert landscape, the beautiful bay and the summer sun that shines all year round.</p>
// 							<p>A visit to Eilat is a fun-filled experience where you get to relax, recharge and get energized all at the same time. Eilat boasts a whopping 360 sunny days a year, making it extremely popular with tourists from far and wide looking to get away from their cold winter climate.</p>
// 							<p>This lively resort city offers a multitude of year-round activities and attractions, excellent restaurants and cafés, shopping centers and trendy bars and clubs.</p>
// 									                        `
//     }
//   }
// },
{id:"Eilat_Doolphin_Reef",ctg:"eilat-negev",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",isVid:true,vidId:"3Cvz8GoxNzA",title:"LE RÉCIF DES DAUPHINS À EILAT",smltitle:"",html:function html(){return{__html:"\n                                 \n                                 <br/>\n                                 <h2 class=\"ac-align-center ac-margin-top-20\">Une Rencontre De R\xEAve Avec La Vie Sauvage la faune</h2>\n                                 <p class=\"ac-align-center ac-margin-bottom-20\"><strong>Nagez avec </strong><strong>les dauphins dans un lieu unique \xE0 Eilat</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Situ\xE9 sur les rives de la mer Rouge, \xE0 Eilat, le R\xE9cif des Dauphins est un v\xE9ritable \xE9crin pour la faune. Nature et d\xE9tente y c\xF4toient l'aventure. Les visiteurs du R\xE9cif p\xE9n\xE8trent dans un lieu magique o\xF9 ils peuvent interagir avec des dauphins dans leur milieu naturel, une superbe plage, o\xF9 la vie v\xE9g\xE9tale est en pleine floraison et \xE0 la beaut\xE9 saisissante.</p>\n\t\t\t\t\t\t\t\t\t<p>Un long ponton permet d'observer les dauphins locaux \xAB&nbsp;bottlenose&nbsp;\xBB dans leurs activit\xE9s quotidiennes, de les voir se nourrir, jouer, chasser, se reproduire et interagir. Il leur arrive m\xEAme de chercher le contact avec les visiteurs du site.&nbsp; Les visiteurs qui le souhaitent peuvent essayer d'entrer en contact avec les dauphins dans le cadre des diverses activit\xE9s propos\xE9es au public.</p>\n\t\t\t\t\t\t\t\t\t<p>Assister au repas des dauphins, \xE0 horaires fixes, est une exp\xE9rience captivante. Vous aimerez la joie enfantine et le caract\xE8re joueur des dauphins lorsqu'ils attendent impatiemment que leurs soigneurs les nourrissent.&nbsp; La joie pure qu'ils expriment lorsqu'ils prennent leurs repas d\xE9clenche presque instinctivement les applaudissements de tout le public. Les visiteurs sont aussi excit\xE9s et satisfaits que s'ils avaient \xE9t\xE9 nourris eux-m\xEAmes.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>Toute la beaut\xE9 du R\xE9cif des Dauphins r\xE9side dans le fait que les visiteurs ne sont pas contraints de se tenir \xE0 distance : ils peuvent plonger avec les dauphins pour les observer dans leur \xE9cosyst\xE8me unique, nager jusqu'\xE0 une profondeur de six m\xE8tres et d\xE9couvrir la vie magnifique et secr\xE8te qui se d\xE9roule naturellement sous l'eau. Ils peuvent aussi chausser masque et tuba et rester \xE0 la surface, flotter au milieu des dauphins et jouer avec eux.</p>\n\t\t\t\t\t\t\t\t\t<p>Dans les \"bassins de d\xE9tente\" du R\xE9cif des Dauphins, les visiteurs peuvent oublier tous leurs soucis et se laisser flotter au son d'une musique relaxante. Les diff\xE9rents restaurants sur site permettent de reprendre des forces et de se faire plaisir sans avoir \xE0 sortir de ce petit sanctuaire de beaut\xE9 naturelle.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  \n\t\t                        "};}},// {
// 		id:"Action_Packed_Eilat",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "ACTION PACKED EILAT",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                              <p>So, you’ve heard about the fabulous beaches, the awesome nightlife and fantastic atmosphere of year round sunny Eilat, but aren’t you wondering, amongst all the leisure, what to do with the excess energy? Well wonder no more. Here are just some of the amazing ways to have some action-packed fun in the sun:</p>
//                                  <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/action-packed-eilat/1.jpg"} class="img-responsive">
// 							</div>
// 						   <p>Eilat’s stunning red sea offers loads of fantastic adventures. For one, its gorgeous underwater environment is known as a world-famous <b>scuba diving destination</b>. Not a pro? No problem. There are short courses that run for 1-2 days.</p>
// 						   <p>Atop the waves, you’ll find, <b>windsurfing</b>, <b>kitesurfing</b>, and <b>stand-up paddle boarding</b> options for which it’s always an ideal time in Eilat, with its pristine beaches, calm waters, and perfect sunny weather almost year-round. By the way, don’t worry about equipment or experience, as there are plenty of options for rentals and individual or group lessons for all ages as well as all-inclusive packages. You’ll be flying across the sea in no time!</p>
// 						   <p>Looking to flex a few more muscles? Eilat’s nearby desert area offers <b>fantastic hikes</b> in stunning trails where you can <b>walk or bike</b> through breathtaking desert scenery.<span class="Apple-converted-space">&nbsp; </span>Feeling adventurous? Check out the huge array of unique action attractions from unforgettable camel rides to <b>adrenaline charged ATV rides</b> to thrilling off cliff <b>paragliding,</b> guaranteed to get the heart racing.</p>
// 						   <p>If your holidays are all about breathtaking adventures, Eilat is definitely the place for you!</p>
//                         `
//     }
//   }
// },
{id:"Eilat_Ultimate_Beachside",ctg:"eilat-negev",bgImage:"/posts/bank/eilat1/1.jpg",mobBgImage:"/posts/bank/eilat1/M.jpg",isVid:true,vidId:"ZdnNT-GDJv4",title:"FAITES LE GRAND PLONGEON",smltitle:"",html:function html(){return{__html:"\n                               \n\t\t\t\t\t\t\t\t   <br/>\n\t\t\t\t\t\t\t\t   <h2 class=\"ac-align-center ac-margin-top-20\">D\xE9couvrez Les Attractions Aquatiques D'Eilat</h2>\n\t\t\t\t\t\t\t\t   <p class=\"ac-align-center ac-margin-bottom-20\"><strong>Profitez des lieux aquatiques qui font d'Eilat une destination de bord de mer incontournable</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Entour\xE9e d'eau, Eilat, la ville la plus au sud d'Isra\xEBl, est un lieu propice \xE0 l'aventure en milieu naturel et aquatique, comme nulle part ailleurs. Gr\xE2ce \xE0 son climat chaud, Eilat permet de profiter de superbes plages, sports aquatiques, activit\xE9s et attractions tout au long de l'ann\xE9e.</p>\n\t\t\t\t\t\t\t\t\t<p>Trempez vos orteils dans les eaux bleues et cristallines des plages d'Eilat qui s'\xE9tendent sur plus de douze kilom\xE8tres de sable, promenades, h\xF4tels et attractions commerciales. D\xE9tendez-vous sur l'une des plages les plus au sud, parmi les plus tranquilles et retir\xE9es, et nagez au milieu des r\xE9cifs coralliens, ou optez pour une des plages du nord de la ville, plus anim\xE9es, o\xF9 h\xF4tels, restaurants et boutiques r\xE9pondront \xE0 tous vos besoins. Vous pouvez aussi visiter la r\xE9gion en yacht, naviguant \xE0 votre gr\xE9, pour profiter du soleil, vous d\xE9tendre et faire des rencontres.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/eilat-ultimate-beachside/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p>D\xE9couvrez le milieu unique de la R\xE9serve naturelle de la Plage des Coraux d'Eilat. Mettez masque et tuba pour observer et interagir avec les cr\xE9atures marines locales qui \xE9voluent autour de vous.</p>\n\t\t\t\t\t\t\t\t\t<p>Pour vivre des aventures aquatiques extr\xEAmes, c'est \xE0 Eilat qu'il vous faut aller. Sentez le vent dans vos cheveux et le soleil sur votre visage en vous laissant s\xE9duire par une sortie en ski nautique, jet-ski, \xAB&nbsp;banana boat&nbsp;\xBB, surf, ou bateau \xE0 fond transparent. Glissez sur les flots et laissez-vous griser par la vitesse. Vous pr\xE9f\xE9rez rester au-dessus de l'eau&nbsp;? En parachute ascensionnel, vous aurez une vue a\xE9rienne imprenable sur la baie d'Eilat.</p>\n\t\t\t\t\t\t\t\t\t<p>Vous aimez la vie sauvage&nbsp;? Nagez ou plongez avec les dauphins au R\xE9cif des Dauphins d'Eilat. Ce site \xE9cologique unique, nich\xE9 sur une plage paradisiaque, permet aux visiteurs de s'immerger dans la vie des dauphins et de vivre une aventure extr\xEAme passionnante. Envie d'une exp\xE9rience sous-marine sans vous mouiller&nbsp;? Visitez l'Observatoire sous-marin d'Eilat afin d'observer la vie sous la surface de la mer, participez aux activit\xE9s interactives et assistez \xE0 des animations sp\xE9ciales.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t   \n\n\t\t                        "};}},// {
// 		id:"One_Day_In_Eilat",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "ONE DAY IN EILAT",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 						   <p><b>Suggestions for an awesome day in the sun</b></p>
// 						   <p>Whether you’re staying in one of the city’s 5 star hotels, a hostel or have opted for the cool camping alternative, we recommend to start your day with a delicious breakfast and make your way to the <b>Dolphin Reef</b>. This is one of the most popular attractions in Eilat, where you can touch, swim and dive with these beautiful creatures. Watch the dolphins in their natural habitat, visit the underwater photo center, or take part in either scuba diving or snorkeling. Check out also <b>Coral Beach</b>, the natural underwater reserve that extends for 1,200 meters along the coast and gives you the opportunity to go snorkeling with an extraordinary variety of tropical fish in a beautiful coral reef.</p>
// 						   <div class="img-wrapper">
// 										<img src=${getImgUrl()+ "/posts/one-day-in-eilat/1.jpg"} class="img-responsive">
// 							</div>
// 						   <p>Once you’ve dried off, head to the stunning <b>Botanical Gardens</b> within Eilat. You’ll find there more than 1,000 types of trees and plants from all around the world, streams, waterfalls, a rainforest and bird sanctuaries.</p>
// 						   <p>To end of your day with something slightly different, head just outside of Eilat to the <b>Red Canyon,</b> where you can track through the riverbed and between the red Nubian sandstone walls that have been sculpted over the centuries by wind and water.</p>
// 						   <p>When evening comes, make your way to the buzzing Eilat promenade ,stroll by the shops and market stands which are open until late. You can treat yourself to a meal in any of the dozens of the excellent restaurants and cafés or a drink in any of the lively seaside pubs and bars.</p>
//                         `
//     }
//   }
// },
{id:"Majestic_Desert",ctg:"eilat-negev",bgImage:"/posts/bank/negev1/1.jpg",mobBgImage:"/posts/bank/negev1/M.jpg",isVid:false,title:"LE NÉGUEV - LE MAJESTUEUX DÉSERT D'ISRAËL",smltitle:"",html:function html(){return{__html:"\n                                   \n\t\t\t\t\t\t\t\t  \n                                    <div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t           <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/yXzhH92kREg\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t           </div>\n\t\t\t\t\t\t           <br/>\n\t\t\t\t\t\t           <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">L'aventure et l'inspiration vous y attendent</h2>\n\n\t\t\t\t\t\t\t\t\t<p>DESTINATION ID\xC9ALE POUR LES VOYAGEURS EN QU\xCATE D'AVENTURES DANS DES PAYSAGES SOMPTUEUX, LE SUD D'ISRA\xCBL EST PEU PEUPL\xC9, MAIS REGORGE DE SITES ET ACTIVIT\xC9S FASCINANTS.&nbsp;<br><br>Avec sa beaut\xE9 et ses merveilles naturelles, le sud offre des vues magnifiques \xE0 couper le souffle, de l'aube au cr\xE9puscule.&nbsp;<br><br>Paradoxalement, ce d\xE9sert regorge de choses \xE0 voir et \xE0 faire, \xE0 commencer par ses nombreuses merveilles g\xE9ologiques, ses monuments historiques embl\xE9matiques et ses superbes r\xE9serves naturelles o\xF9 vous pourrez marcher, faire du v\xE9lo, randonner \xE0 dos de chameau ou vivre en 4x4 des raids charg\xE9s d'adr\xE9naline.&nbsp;&nbsp;<br><br>Pour tout dire, cette majestueuse r\xE9gion m\xE9ridionale est l'un des principaux atouts du pays et un passage oblig\xE9 sur votre itin\xE9raire.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Le crat\xE8re Ramon</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Le crat\xE8re Ramon se trouve au c\u0153ur du vaste d\xE9sert isra\xE9lien du N\xE9guev. \xC9galement appel\xE9 Machtesh Ramon, il s'agit du plus grand crat\xE8re d'\xE9rosion au monde. Comportant une grande vari\xE9t\xE9 de roches aux formes et aux couleurs fantastiques, ce ph\xE9nom\xE8ne naturel envo\xFBtant mesure 40 km de long et entre 2 et 10 km de large. De la forme d'un c\u0153ur allong\xE9, il est le grand parc national d'Isra\xEBl&nbsp;: la R\xE9serve naturelle de Ramon.</p>\n\t\t\t\t\t\t\t\t\t<p>Loin de la foule et des lumi\xE8res de la ville, le crat\xE8re Ramon se caract\xE9rise par ses gr\xE8s multicolores, ses roches volcaniques et ses fossiles. On en parle souvent comme du Grand Canyon d'Isra\xEBl.</p>\n\t\t\t\t\t\t\t\t\t<p>Dominant le site du haut de ses 300 m\xE8tres, un belv\xE9d\xE8re vous offre une vue imprenable sur le Machtesh Ramon. Toute l'ann\xE9e, des touristes du monde entier s'y pressent pour admirer ce v\xE9ritable d\xE9cor hollywoodien.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Sde Boker</strong></p>\n\t\t\t\t\t\t\t\t\t<p>T\xE9moignage de l\u2019histoire de l\u2019\xC9tat d\u2019Isra\xEBl, Sde Boker est un kibboutz construit par des pionniers au d\xE9but des ann\xE9es 50 dans le but de coloniser le d\xE9sert du N\xE9guev.</p>\n\t\t\t\t\t\t\t\t\t<p>Sde Boker est connu pour avoir \xE9t\xE9 le lieu de r\xE9sidence de David Ben Gourion, ancien premier ministre d\u2019Isra\xEBl. Sa maison est aujourd\u2019hui un mus\xE9e ouvert au public.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"clear\"></div>\n\t\t\t\t\t\t\t\t\t<div class=\"responisve-iframe\">\n\t\t\t\t\t\t\t           <iframe width=\"560\" height=\"315\" src=\"https://www.youtube.com/embed/QL3BGy2p77g\" frameborder=\"0\" allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe>\n\t\t\t\t\t\t            </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Vidor Center</strong></p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>Un lieu r\xE9ellement unique qui permet aux visiteurs de mieux conna\xEEtre la nature exceptionnelle de la r\xE9gion d\u2019Arava \xE0 travers une exp\xE9rience multi sensorielle. Ils peuvent y d\xE9couvrir des m\xE9thodes agricoles avanc\xE9es, la flore et la faune locales, les probl\xE8mes climatiques et les propri\xE9t\xE9s particuli\xE8res du sol et de l\u2019eau du d\xE9sert.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Nevatim</strong></p>\n\t\t\t\t\t\t\t\t\t<p>La visite de Nevatim, o\xF9 s\u2019\xE9tablirent les Juifs du Cochin, est une exp\xE9rience fascinante. Originaires d\u2019Inde, les Juifs du Cochin ont immigr\xE9 en Isra\xEBl apr\xE8s la cr\xE9ation de l\u2019\xC9tat. Ils se consid\xE8rent comme l\u2019 une des communaut\xE9s juives les plus anciennes au monde.</p>\n\t\t\t\t\t\t\t\t\t<p>Le Centre du patrimoine des Juifs du Cochin du moshav Nevatim raconte l\u2019histoire de cette communaut\xE9 unique</p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p><strong>L'exp\xE9rience des B\xE9douins </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Vivre l'hospitalit\xE9 des B\xE9douins est une exp\xE9rience inoubliable et enrichissante qui n'a pas d'\xE9quivalent.</p>\n\t\t\t\t\t\t\t\t\t<p>Les B\xE9douins d'Isra\xEBl sont un groupe de tribus nomades indig\xE8nes dont l'origine remonte \xE0 de nombreux si\xE8cles. Continuant \xE0 vivre de fa\xE7on traditionnelle, ils ouvrent aux visiteurs leur c\u0153ur, leur foyer et leur mode de vie, pour partager leurs coutumes et leur hospitalit\xE9 r\xE9put\xE9es dans le monde entier.</p>\n\t\t\t\t\t\t\t\t\t<p>Vous pourrez faire une randonn\xE9e \xE0 dos de chameau, go\xFBter aux plats traditionnels b\xE9douins et m\xEAme passer une nuit dans une tente b\xE9douine. Ces attractions tr\xE8s appr\xE9ci\xE9es par les touristes vous permettront de d\xE9couvrir et d'appr\xE9cier un mode de vie oubli\xE9.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Les Reines de la gastronomie de Yeruham</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Pour une exp\xE9rience vraiment inoubliable, ne manquez pas l\u2019hospitalit\xE9 des Reines de la gastronomie de Yeruham. Gr\xE2ce \xE0 un projet unique, des habitantes de Yeruham accueillent des touristes \xE0 leur table et leur proposent un excellent repas traditionnel, au cours duquel ils d\xE9couvriront des odeurs, des couleurs et des saveurs uniques qui resteront grav\xE9es dans leur m\xE9moire.</p>\n\t\t\t\t\t\t\t\t\t<p>D\xE9couvrez le quotidien des habitants de la r\xE9gion \xE0 travers leurs histoires passionnantes tout en d\xE9gustant de d\xE9licieuses sp\xE9cialit\xE9s locales et en profitant de leur l\u2019hospitalit\xE9 exceptionnelle.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>La ville ancienne de Beer-Sheva</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Il est dit que Beer-Sheva a \xE9t\xE9 fond\xE9e par Abraham, figure centrale de la Bible. De fait, on y a d\xE9couvert un \xE9tablissement datant de plusieurs milliers d'ann\xE9es, et cette ville est l'une des plus anciennes du pays. Outre son caract\xE8re historique, la vieille ville de Beer-Sheva offre une mosa\xEFque fascinante d'espaces urbains. Son exploration vous r\xE9v\xE8lera son architecture unique, sa longue histoire et des r\xE9cits remontant \xE0 la nuit des temps.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Parc scientifique Carasso</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Nouveau lieu situ\xE9 dans la vieille ville de Beer-Sheva, le Parc scientifique Carasso, qui s\u2019\xE9tend sur 1,61 hectare, est le plus grand parc scientifique d\u2019Isra\xEBl.</p>\n\t\t\t\t\t\t\t\t\t<p>Divertissant et adapt\xE9 \xE0 tous les publics, il accueille un mus\xE9e interactif et un jardin scientifique proposant des jeux et des activit\xE9s pratiques. Le parc propose \xE9galement dix expositions interactives dans diff\xE9rents domaines&nbsp;: g\xE9n\xE9tique, communication, micro\xE9lectronique, \xE9nergie nucl\xE9aire, etc.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Arad </strong></p>\n\t\t\t\t\t\t\t\t\t<p>L'Arad du nouveau mill\xE9naire est une ville jeune mais particuli\xE8rement int\xE9ressante. Arad et ses environs b\xE9n\xE9ficient de paysages magnifiques, de la tranquillit\xE9 du d\xE9sert et de nombreux sentiers p\xE9destres parcourant des coins pr\xE9serv\xE9s du d\xE9sert, qui conviendront \xE0 tous les \xE2ges et tous les styles.</p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p>Avec grand nombre d'attractions et de sites touristiques au sein et \xE0 proximit\xE9 de la ville, Arad est un point de d\xE9part id\xE9al et une porte naturelle pour des vacances parfaites dans le d\xE9sert.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Parc de Timna</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Avec sa vall\xE9e de 60 kilom\xE8tres carr\xE9s en forme de fer-\xE0-cheval, le Parc de Timna offre un paysage \xE9poustouflant et ravira les passionn\xE9s de randonn\xE9e. Vous y d\xE9couvrirez l\u2019\u0153uvre de la nature ainsi que les animaux, plantes et arbres \xE9tonnants qui vivent dans le d\xE9sert malgr\xE9 son extr\xEAme aridit\xE9.</p>\n\t\t\t\t\t\t\t\t\t<p>Avec ses nombreux centres d\u2019int\xE9r\xEAt, ses sables color\xE9s et ses montagnes escarp\xE9es, le Parc de Timna n\u2019a pas son pareil pour attirer les touristes.</p>\n\t\t\t\t\t\t\t\t\t<p>The south of Israel is a total dream destination for adventure-hungry travelers. Its unique and challenging terrain make for an ideal setting for various extreme sports and activities including abseiling down steep ravens and canyons, dirt biking and off road cycling which are extremely popular in this area as are the 4x4 adventure drives which are all the rage for locals and tourists alike.</p>\n                                      <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/3.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t<p><strong>Nature </strong></p>\n\t\t\t\t\t\t\t\t\t<p><strong>Yotvata Hai-Bar </strong></p>\n\t\t\t\t\t\t\t\t\t<p>La r\xE9serve naturelle Yotvata Hai-Bar est le plus grand centre de reproduction et de r\xE9habilitation d'animaux de la r\xE9gion, avant leur r\xE9introduction dans la nature. La r\xE9serve offre des attractions passionnantes qui s\xE9duiront les amis des animaux, comme le centre des pr\xE9dateurs avec ses <strong>sp\xE9cimens</strong> vivants et ses petits animaux du d\xE9sert, une pi\xE8ce obscure permettant d'observer les animaux nocturnes et 12 kilom\xE8tres carr\xE9s de terres parcourus en toute libert\xE9 par des hardes d'herbivores.&nbsp;</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Des aventures extr\xEAmes </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Le sud d'Isra\xEBl est une destination de r\xEAve pour les voyageurs en qu\xEAte d'aventures.&nbsp; Son terrain unique et exigeant en fait un lieu id\xE9al pour un large \xE9ventail de sports et activit\xE9s extr\xEAmes. Citons la descente en rappel des ravins et canyons, le motocross et le v\xE9lo tout terrain qui sont extr\xEAmement populaires dans cette r\xE9gion, tout comme les raids aventure en 4x4 tr\xE8s en vogue, que ce soit chez les locaux ou les touristes.</p>\n                                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/majestic-desert/4.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\tCredit: Daphna Tal\n\t\t\t\t\t\t\t\t\t</div>\n\n\t\t                        "};}},{id:"Negev1",ctg:"eilat-negev",bgImage:"/posts/bank/negev2/1.jpg",mobBgImage:"/posts/bank/negev2/M.jpg",isVid:true,vidId:"yXzhH92kREg",title:"BOUGER ET PRENDRE DU BON TEMPS DANS LE DÉSERT ISRAÉLIEN",smltitle:"",html:function html(){return{__html:"\n                              \n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\n\n\n\t\t\t\t\t\t\t\t\t\t\t<p>Vous pensez que le d\xE9sert est vide&nbsp;? Avec ses panoramas somptueux, ses sites historiques et une multitude d\u2019activit\xE9s ludiques, le d\xE9sert isra\xE9lien ne correspond en rien \xE0 ce clich\xE9&nbsp;!</p>\n\t\t\t\t\t\t\t\t\t\t\t<h2>Le d\xE9sert, un cadre unique</h2>\n\t\t\t\t\t\t\t\t\t\t\t<p>Vous serez s\xE9duit par la beaut\xE9 naturelle des quatre principales r\xE9gions d\xE9sertiques d'Isra\xEBl&nbsp;: la mer Morte, la cha\xEEne de montagnes d'Eilat, le N\xE9guev et le d\xE9sert de Jud\xE9e. Vivez une exp\xE9rience hors du commun en partant randonner dans les paysages color\xE9s et les formations rocheuses uniques du crat\xE8re Ramon, et dans les roches iris\xE9es rougeoyantes du parc Timna, \xE0 proximit\xE9 d'Eilat. Quoi de mieux, apr\xE8s avoir d\xE9pass\xE9 vos limites en descendant en rappel des rochers multicolores ou en randonnant sur les sentiers poussi\xE9reux, que de plonger dans les eaux fra\xEEches d'une oasis telle que Ein Gedi, pr\xE8s de la mer Morte. Et si vous passez la nuit dans un des nombreux campings tout \xE9quip\xE9s, vous verrez plus d\u2019\xE9toiles que vous n\u2019en avez jamais vues. Vous aurez peut-\xEAtre m\xEAme la chance d'observer les animaux qui ne sortent qu'\xE0 la nuit tomb\xE9e&nbsp;!</p>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/negev/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<p>Le printemps, l'automne et l'hiver sont les saisons les plus propices pour affronter le climat aride et vivifiant du d\xE9sert isra\xE9lien. Sur le site de la forteresse de Massada, remontez le temps et red\xE9couvrez le destin funeste des derniers Juifs luttant contre les Romains, et admirez la grandeur du palais d'H\xE9rode. Explorez des ruines byzantines inattendues et d\xE9couvrez la culture stup\xE9fiante des cit\xE9s nabat\xE9ennes creus\xE9es dans la roche.</p>\n\t\t\t\t\t\t\t\t\t\t\t<h2>Bouger et prendre du bon temps dans le d\xE9sert</h2>\n\t\t\t\t\t\t\t\t\t\t\t<p>Le d\xE9sert isra\xE9lien offre de nombreuses activit\xE9s divertissantes. Faites-vous secouer en jeep lors d'une exp\xE9dition dans le N\xE9guev ou louez des VTT pour d\xE9passer vos limites sur les pistes du d\xE9sert ou entre les rochers color\xE9s qui conf\xE8rent une beaut\xE9 surnaturelle au parc Timna. Ralentissez le rythme en visitant le d\xE9sert de Jud\xE9e ou les montagnes d'Eilat \xE0 cheval, en famille ou avec des amis, ou d\xE9gustez un th\xE9 \xE0 la menthe accompagn\xE9 de dattes savoureuses en profitant de l'authentique hospitalit\xE9 b\xE9douine dans le d\xE9sert du N\xE9guev. Vous pouvez m\xEAme faire une balade en chameau pour vous mettre dans la peau des Isra\xE9lites de l'\xE9poque antique&nbsp;!</p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Pourquoi ne pas prendre un bain de boue aux propri\xE9t\xE9s th\xE9rapeutiques sur les rives de la mer Morte en admirant les magnifiques cha\xEEnes de montagne et l'eau bleue qui s'\xE9tendent devant vous. Les amoureux de sports extr\xEAmes ne manqueront pas de s'initier au sandsurfing. Quelle mont\xE9e d'adr\xE9naline en d\xE9valant \xE0 toute vitesse les dunes de sable du N\xE9guev&nbsp;!</p>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/negev/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<p>Jamais vous n'auriez imagin\xE9 vous amuser autant dans les d\xE9serts d'Isra\xEBl.</p>\n\n\t\t                        "};}},{id:"Location_And_Approach",ctg:"eilat-negev",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",isVid:true,vidId:"5AAqIhkq_tQ",title:"LE NÉGUEV - COMMENT S’Y RENDRE?",smltitle:"",html:function html(){return{__html:"\n                              \n\t\t\t\t\t\t\t\t    <br/>\n\t\t\t\t\t\t\t\t    <h2>Emplacement et acc\xE8s</h2>\n\t\t\t\t\t\t\t\t    <p>Arriv\xE9e \xE0 l'a\xE9roport d\u2019Ovda ou d'Eilat, puis transport vers Mitzp\xE9-Ramon ou Sd\xE9 Boker:</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Transports publics:</strong></p>\n\t\t\t\t\t\t\t\t\t<p><strong>Bus 392</strong> au d\xE9part d'Eilat pour Mitzp\xE9-Ramon et Beer-Sheva&nbsp;; arr\xEAt \xE0 l'a\xE9roport d\u2019<strong>Ovda</strong> le <strong>dimanche</strong> aux horaires suivants&nbsp;: 07h13, 08h41, 09h43, 14h12, 15h41, 17h43.</p>\n\t\t\t\t\t\t\t\t\t<p>Arriv\xE9e \xE0 la gare routi\xE8re centrale de Mitzp\xE9-Ramon environ une heure et demi apr\xE8s.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Lundi - jeudi&nbsp;:</strong> 07h13, 07h41, 09h43, 14h12, 15h41, 17h43.</p>\n\t\t\t\t\t\t\t\t\t<p><a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">Service de bus</a></p>\n\t\t\t\t\t\t\t\t\t<p><span dir=\"RTL\"><a href=\"https://eilatshuttle.com/\" target=\"_blank\"><span>Navettes depuis l'A\xE9roport Ovda</span></a></span></p>\n\t\t\t\t\t\t\t\t\t<p><strong>Location de voiture \xE0 Eilat, Mitzp\xE9-Ramon et Beer-Sheva:</strong></p>\n\t\t\t\t\t\t\t\t\t<p>De nombreuses options de location de voitures sont propos\xE9es dans ces villes.</p>\n\t\t\t\t\t\t\t\t\t<p>Vous trouverez des agences de location isra\xE9liennes et internationales.</p>\n\t\t\t\t\t\t\t\t\t<p>Arriv\xE9e \xE0 l'a\xE9roport International de Ben-Gourion (pr\xE8s de Tel-Aviv) et transport vers le N\xE9guev, \xE0 Mashabei Sadeh / Sd\xE9-Boker / Mitzp\xE9-Ramon</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Transports publics:</strong></p>\n\t\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t<li>Bus n\xB0370, 380 de Tel-Aviv vers Beer-Sheva,</li>\n\t\t\t\t\t\t\t\t\t<li>Bus n\xB0446, 470 de J\xE9rusalem vers Beer-Sheva.</li>\n\t\t\t\t\t\t\t\t\t<li>Train de l'A\xE9roport Ben-Gourion ou Tel-Aviv vers Beer-Sheva.</li>\n\t\t\t\t\t\t\t\t\t<li>De Beer-Sheva, bus n\xB0 60, 64, 65, 660. D\xE9parts tous les matins \xE0 partir de 6h (environ toutes les 20 minutes). Arriv\xE9e \xE0 Mashabei Sadeh en 35 minutes / Sd\xE9-Boker en 55 minutes / Mitzp\xE9-Ramon en 1 heure 20 minutes.</li>\n\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t<p>Des informations compl\xE9mentaires sur les moyens de transport publics sont propos\xE9es sur les liens suivants: <a href=\"https://www.bus.co.il/otobusimmvc?Language=en\" target=\"_blank\">www.bus.co.il</a>;&nbsp;<a href=\"//www.egged.co.il/HomePage.aspx\" target=\"_blank\">www.egged.co.il</a></p> \n\n\t\t                        "};}},{id:"Stay_In_The_Negev",ctg:"eilat-negev",bgImage:"/posts/bank/negev4/1.jpg",mobBgImage:"/posts/bank/negev4/M.jpg",isVid:false,title:"UN SÉJOUR DANS LE NÉGUEV",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t           \n\t\t\t\t\t\t\t\t   <p>Une visite du N\xE9guev a bien plus \xE0 offrir que les panoramas impressionnants et l'atmosph\xE8re de tranquillit\xE9 que l'on associe en g\xE9n\xE9ral au mot d\xE9sert. Si le N\xE9guev offre bien la beaut\xE9 naturelle, le calme et les sites \xE9poustouflants recherch\xE9s par les touristes qui se rendent dans le d\xE9sert, il est \xE9galement particuli\xE8rement int\xE9ressant, \xAB&nbsp;occidentalis\xE9&nbsp;\xBB et am\xE9nag\xE9 pour offrir d'innombrables activit\xE9s et aventures, proposant m\xEAme tout le confort d\u2019un s\xE9jour moderne.</p>\n\t\t\t\t\t\t\t\t\t<p>Le N\xE9guev offre des possibilit\xE9s d'h\xE9bergement extr\xEAmement vari\xE9es. Bien plus qu'un simple lieu o\xF9 poser vos valises, le type d'h\xE9bergement que vous choisirez vous offrira l'opportunit\xE9 de d\xE9couvrir le joyau incontest\xE9 du N\xE9guev&nbsp;: sa communaut\xE9 locale. Des r\xE9sidents des kibboutzim aux fermiers isol\xE9s en passant par les b\xE9douins locaux, vous constaterez que les habitants du N\xE9guev sont chaleureux, hospitaliers et toujours pr\xEAts \xE0 apporter leur aide. Voici quelques exemples d'h\xE9bergement que vous trouverez dans le N\xE9guev:</p>\n\t\t\t\t\t\t\t\t\t<p>H\xF4tels \u2013 le N\xE9guev propose un choix tr\xE8s large d'h\xE9bergements en h\xF4tel, des \xE9tablissements \xE9conomiques aux h\xF4tels internationaux de luxe 5 \xE9toiles et prim\xE9s dans lesquels vous pourrez vous d\xE9tendre dans un cadre raffin\xE9 durant votre p\xE9riple dans le d\xE9sert.</p>\n\t\t\t\t\t\t\t\t\t<p>Auberges \u2013 un type de logement \xE9conomique destin\xE9 \xE0 une client\xE8le de jeunes voyageurs. Les touristes qui y s\xE9journent ont l'occasion de faire connaissance avec d'autres voyageurs du monde entier partageant le m\xEAme \xE9tat d'esprit, et de passer leurs soir\xE9es \xE0 \xE9changer et parfois tisser des liens d'amiti\xE9 durables.</p>\n\t\t\t\t\t\t\t\t\t<p>Zimmers \u2013 version isra\xE9lienne des Bed and Breakfast, ces logements g\xE9n\xE9ralement ind\xE9pendants du domicile du propri\xE9taire offrent souvent l'intimit\xE9 et le confort recherch\xE9s pour une escapade paisible et romantique.&nbsp;</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/stay-in-the-negev/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t     </div>\n\t\t\t\t\t\t\t\t\t<p>Tentes b\xE9douines \u2013 indubitablement le must pour se loger dans le N\xE9guev, ce mode d'h\xE9bergement v\xE9ritablement unique et authentique vous accueille dans la tradition de la communaut\xE9 b\xE9douine et offre une occasion exceptionnelle de s'initier aux coutumes de ce peuple, au sein m\xEAme de son environnement naturel \u2013 hautement recommand\xE9.</p>\n\t\t\t\t\t\t\t\t\t<p>Khans \u2013 eux aussi uniques au N\xE9guev, ces vastes camps sont constitu\xE9s de huttes et de dortoirs et offrent toutes les commodit\xE9s de base. S'ils constituent souvent une forme d'h\xE9bergement plus rustique et basique, ils offrent un excellent moyen de go\xFBter \xE0 la tranquillit\xE9 du d\xE9sert, de faire connaissance avec d'autres voyageurs et avec la population locale, et d'avoir le sentiment de faire partie int\xE9grante du milieu naturel du d\xE9sert.</p>\n\t\t\t\t\t\t\t\t\t<p>Fermes isol\xE9es \u2013 apparues plus r\xE9cemment, ces fermes sont en fait des chambres d'h\xF4tes situ\xE9es dans des fermes familiales pittoresques et retir\xE9es, dans toute la r\xE9gion du N\xE9guev.&nbsp; Combinant tranquillit\xE9 et confort domestique, les fermes isol\xE9es permettent de b\xE9n\xE9ficier d'une grande intimit\xE9, de vues exceptionnelles et d'une fa\xE7on authentique d'appr\xE9cier l'atmosph\xE8re impressionnante du d\xE9sert du N\xE9guev.</p>\n\t\t\t\t\t\t\t\t\t<p>kibboutz -&nbsp;une forme d'h\xE9bergement communautaire typiquement isra\xE9lienne, le s\xE9jour en kibboutz permet de se loger \xE0 un prix \xE9conomique. Le v\xE9ritable attrait du kibboutz est toutefois son atmosph\xE8re singuli\xE8re et son esprit communautaire, ainsi que ses membres chaleureux, accueillants et hospitaliers, gr\xE2ce auxquels vous passerez immanquablement un s\xE9jour agr\xE9able et m\xE9morable.</p>\n\n\t\t\t\t\t\t\t\t  \n\t\t                        "};}},{id:"Pure_Desert_Magic",ctg:"eilat-negev",bgImage:"/posts/bank/negev1/1.jpg",mobBgImage:"/posts/bank/negev1/M.jpg",isVid:false,title:"LE DÉSERT DU NÉGUEV - TOUT SIMPLEMENT MAGIQUE!",smltitle:"",html:function html(){return{__html:"\n\t\t\t\t\t\t              \n\n\t\t\t\t\t\t\t\t\t   <p>Avec ses paysages \xE0 couper le souffle et ses attractions multiples, le d\xE9sert isra\xE9lien est le lieu id\xE9al pour passer ses vacances. Le N\xE9guev est une invitation au voyage offrant quantit\xE9 de possibilit\xE9s\u2026</p>\n\t\t\t\t\t\t\t\t\t<p>Isra\xEBl est un petit pays recouvert \xE0 62&nbsp;% par le d\xE9sert du N\xE9guev. Son paysage aux tons rouges se caract\xE9rise par d'impressionnantes formations rocheuses. Le visiteur dispose d\u2019un point de vue unique sur une immensit\xE9 intacte, silencieuse et majestueuse.</p>\n\t\t\t\t\t\t\t\t\t<p>On y trouve les traces des civilisations pass\xE9es et de leur agriculture, ainsi que des sites arch\xE9ologiques. Le N\xE9guev propose un cadre id\xE9al pour aller au contact des tribus b\xE9douines, les habitants du d\xE9sert.</p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/pure-desert-magic/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t       </div>\n\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t<strong>Le d\xE9sert isra\xE9lien est unique pour plusieurs raisons</strong>:\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Il est tr\xE8s proche</strong> - \xE0 seulement 4 heures de vol de l'Europe. Isra\xEBl \xE9tant dot\xE9 de deux a\xE9roports internationaux, Tel-Aviv/Ben-Gourion et Eilat/Ovda, tous les voyageurs n'ont qu'un court trajet \xE0 effectuer pour acc\xE9der au d\xE9sert (entre une demi-heure et une heure et demie de route).\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t<p>D\xE8s novembre, des vols directs relieront l'Europe et la Russie \xE0 l'a\xE9roport d\u2019Eilat-Ovda, notamment par\n\t\t\t\t\t\t\t\t\t\t\t<em>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Ryanair</strong>, \n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Wizzair</strong>\n\t\t\t\t\t\t\t\t\t\t\t</em>et\n\t\t\t\t\t\t\t\t\t\t\t<em>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>SAS</strong>\n\t\t\t\t\t\t\t\t\t\t\t</em>.\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t<p>Pour plus d'informations, consultez le lien suivant: \n\t\t\t\t\t\t\t\t\t\t\t<a href=\"//www.iaa.gov.il/en-US/airports/ovda/Pages/default.aspx\" target=\"_blank\">www.iaa.gov.il</a>\n\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Facile d'acc\xE8s \xE0 pied et \xE0 v\xE9lo:</strong> de nombreux sentiers balis\xE9s sont propos\xE9s. Isra\xEBl est \xE9quip\xE9 du r\xE9seau de chemins de randonn\xE9e le plus \xE9tendu au monde, et plusieurs centaines de chemins permettent de se rendre dans le d\xE9sert isra\xE9lien en toute s\xE9curit\xE9. Les sites suivants proposent une s\xE9lection de pistes&nbsp;: \n\t\t\t\t\t\t\t\t\t\t\t\t<a href=\"//www.negevtour.co.il\" target=\"_blank\">www.negevtour.co.il</a> ; \n\t\t\t\t\t\t\t\t\t\t\t\t<a href=\"//www.en.aravaway.co.il\" target=\"_blank\">www.en.aravaway.co.il</a>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Une population locale accueillante</strong>: l'amabilit\xE9 et l'hospitalit\xE9 des habitants font de l'exploration du d\xE9sert une exp\xE9rience agr\xE9able, chaleureuse et passionnante.\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Activit\xE9s touristiques:</strong> outre l'augmentation de la capacit\xE9 d'h\xE9bergement, la grande diversit\xE9 des activit\xE9s touristiques a permis au N\xE9guev de s'imposer ces derni\xE8res ann\xE9es comme une destination populaire, curieuse, diverse et originale.\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t\t<li>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Des paysages magnifiques:</strong> aujourd'hui, de tr\xE8s nombreux touristes viennent admirer l'immense vari\xE9t\xE9 de paysages du N\xE9guev\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<li>Les spectaculaires dunes de sable au nord.</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<li>Dans sa partie centrale, le crat\xE8re Ramon avec ses falaises et ses sources d'eau saisonni\xE8res.</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<li>Le d\xE9sert africain \xE0 l'est avec ses vastes \xE9tendues de savane et ses acacias.</li>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<li>Au sud, des paysages de granit rouge et noir, qui offrent un contraste saisissant avec les contreforts de gr\xE8s aux couleurs harmonieuses.</li>\n\t\t\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\t\t\t<p>Un voyage de 3 heures dans le d\xE9sert permet d'admirer tous les types de paysages d\xE9sertiques et de profiter d'une diversit\xE9 de panoramas que l'on ne peut rencontrer dans les autres d\xE9serts qu'au prix d'un long voyage.</p>\n\t\t\t\t\t\t\t\t\t\t<p>De nombreux touristes d\xE9cident de s\xE9journer 2 ou 3 jours dans chaque r\xE9gion du N\xE9guev.</p>\n\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Le N\xE9guev ne pr\xE9sente aucun danger.</strong> En cas d\u2019urgence, les services de secours de la r\xE9gion sont parmi les mieux form\xE9s au monde et sont toujours \xE0 proximit\xE9. Si vous avez besoin de voir un m\xE9decin, Isra\xEBl propose des services m\xE9dicaux de haute qualit\xE9 comparables \xE0 ceux des pays occidentaux.\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\t<strong>Informations compl\xE9mentaires et conseils pour l'h\xE9bergement:</strong>\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t\t\t\t\t\t<a href=\"//www.negevtour.co.il\" target=\"_blank\">www.negevtour.co.il</a><br/>\n\t\t\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t<a href=\"//www.en.aravaway.co.il\" target=\"_blank\">www.en.aravaway.co.il</a>\n\t\t\t\t\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\t\t\t\t<p>Bons plans voyage</p>                         \n\t\t\t\t\t\t "};}},{id:"Action_Fun_In_The_Desert",ctg:"eilat-negev",bgImage:"/posts/bank/negev2/1.jpg",mobBgImage:"/posts/bank/negev2/M.jpg",isVid:true,vidId:"yXzhH92kREg",title:"ACTION FUN IN THE ISRAELI DESERT",smltitle:"",html:function html(){return{__html:"\n\n\t\t\t\t\t\t          <p><strong>The Uniqueness of the Desert</strong></p>\n\t\t\t\t\t\t\t\t   <p>You\u2019ll be wowed by the natural beauty of Israel\u2019s four main desert areas: the Dead Sea, the Eilat mountain range, the Negev and the Judean desert. Tourists can step out-of-this-world on a hike through the unique colors and rock formations of the Ramon Crater and the deeply glowing hues of Timna Park outside Eilat. Rappelling down multicolored cliffs or challenging yourself on dusty, challenging hike is even better when you end it with a refreshing plunge into a desert oasis like Ein Gedi near the Dead Sea. You\u2019ll see more stars than you could have believed if you camp overnight at one of the many fully serviced campsites. You might even glimpse some of the desert\u2019s shy nocturnal wildlife!</p>\n\t\t\t\t\t\t\t\t   <p>Spring, Fall and Winter are the best times to visit the dry, bracing climate of Israel\u2019s desert. Step back in time at the famous Masada fortress to rediscover the bitter end of the last Jews fighting against the Romans and be awed by the grandeur of Herod\u2019s palace. Explore Unexpected Byzantine ruins and the astonishing culture of the Nabateans\u2019 ancient settlements carved out of the desert rock are waiting for you to explore them.</p>\n\t\t\t\t\t\t\t\t    <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/action-fun-in-the-desert/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t       </div> \n\t\t\t\t\t\t\t\t       <p><strong>Action Fun in the Desert</strong></p>\n\t\t\t\t\t\t\t\t   <p>Israel\u2019s desert is full of fun activities. An exciting jeep tour will bounce you through the unique terrain of the Negev, or you can hire mountain bikes to challenge yourself in the unearthly beauty of Timna Park\u2019s colorful rocks or across desert paths. Slow down to bond as a family or with friends on a calming horseback ride in the Judean desert or Eilat mountains, or sip mint tea and eat plump dates as you experience real Bedouin hospitality in the Negev. You can even ride on a camel to feel like a true ancient Israelite!</p>\n\t\t\t\t\t\t\t\t   <p>You could slather on the therapeutic mineral mud on the shores of the Dead Sea as you marvel at the towering mountains around you and the blue water beside you. Lovers of extreme sports can try their hand at sandsurfing down the Negev\u2019s sweeping sand dunes, feeling the thrill of racing across acres of sand.</p>\n\t\t\t\t\t\t\t\t   <p>Israel\u2019s deserts are full of more fun than you\u2019d believe.</p>\n\t\t\t\t\t\t\t\t   <p>photo credit:</p>\n\t\t\t\t\t\t\t\t   <p>Alon Ron,&nbsp;Dafna Tal.</p>                          \n\t\t                        "};}},{id:"The_Incense_Route",ctg:"eilat-negev",bgImage:"/posts/bank/negev3/1.jpg",mobBgImage:"/posts/bank/negev3/M.jpg",isVid:true,vidId:"5AAqIhkq_tQ",title:"LA ROUTE DE L'ENCENS",smltitle:"",html:function html(){return{__html:" \n\t\t\t\t\t\t           \n\t\t\t\t\t\t           <br/>\n\t\t\t\t\t\t           <h2 class=\"ac-align-center ac-margin-top-20\">L'histoire d'une r\xE9ussite commerciale datant de 2000 ans\u2026</h2>\n\t\t\t\t\t\t\t\t  \n\n\t\t\t\t\t\t\t\t    <p class=\"ac-align-center ac-margin-bottom-20\"><b>La l\xE9gendaire \u2018\u2019Route de l'encens\u2019\u2019 retrace l'histoire d'un succ\xE8s commercial n\xE9 il y a 2000 ans.</b></p>\n\t\t\t\t\t\t\t\t\t<p>En ce temps-l\xE0, o\xF9 n'existait aucun moyen de transport, route ou carte, de longues caravanes de chameaux empruntaient des pistes p\xE9rilleuses et affrontaient voleurs, pilleurs, emb\xFBches et monarques r\xE9gnant en ma\xEEtre. Des biens pr\xE9cieux \xE9taient transport\xE9s par cette route qui, partant du Y\xE9men \xE0 l'est, traversait l'Arabie saoudite et la Jordanie pour s'achever en Isra\xEBl, au port de Gaza. Les produits \xE9taient alors charg\xE9s \xE0 bord de navires marchands en partance pour l'Europe. Les femmes de l'Empire romain pouvaient ainsi jouir du parfum de l'encens et de la myrrhe, des saveurs des \xE9pices orientales, et des sels utilis\xE9s pour la cuisine et la conservation des aliments.</p>\n\t\t\t\t\t\t\t\t\t<p>Il fallait six mois pour parcourir les 2400 kilom\xE8tres de la route de l'encens. Les caravanes de chameaux - qui r\xE9unissaient plusieurs milliers de personnes - se d\xE9pla\xE7aient tr\xE8s lentement et faisaient 56 arr\xEAts durant lesquels les voyageurs se reposaient, prenaient soin des animaux et reprenaient des forces pour les jours suivants.</p>\n\t\t\t\t\t\t\t\t\t<p>La route de l'encens traversait Isra\xEBl sur 150 kilom\xE8tres. Dans le d\xE9sert du N\xE9guev, on trouve encore des ruines de la route et de nombreux visiteurs choisissent de s'arr\xEAter aux \xE9tapes successives pour d\xE9couvrir le d\xE9sert et se faire une id\xE9e du mode de vie des ma\xEEtres du d\xE9sert. Les vestiges de plusieurs lieux de halte sont encore visibles, comme l'oasis de Moa dans le d\xE9sert de la Arava, sur la fronti\xE8re jordanienne, o\xF9 l'on peut encore voir les ruines d'une auberge, d'un poste de garde, de caves, de celliers et d'un aqueduc.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/the-incense-route/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div> \n\t\t\t\t\t\t\t\t\t<p>De l\xE0, la route continue vers le nord-ouest jusqu'\xE0 Mamshit, une grande ville dont les ruines impressionnantes comprennent une auberge, des \xE9glises, des bains publics, des bassins de collecte d'eau de pluie et d'autres infrastructures.</p>\n\t\t\t\t\t\t\t\t\t<p>L'arr\xEAt suivant \xE9tait la ville d'Avdat, situ\xE9e en hauteur sur une colline. On y trouve ici aussi les vestiges d'une forteresse, d'\xE9glises, d'une presse \xE0 huile, d'un atelier de c\xE9ramique, de maisons, d'un bain public et m\xEAme de grottes fun\xE9raires.</p>\n\t\t\t\t\t\t\t\t\t<p>La caravane poursuivait sa route d'Avdat jusqu'\xE0 Shivta, une petite ville dot\xE9e d'un syst\xE8me sophistiqu\xE9 de r\xE9cup\xE9ration des eaux, de bassins, de presses \xE0 huile et de quelques \xE9glises. L'avant-dernier arr\xEAt, et le plus au nord, \xE9tait Halutsa, o\xF9 l\u2019on peut encore voir les ruines d'un th\xE9\xE2tre et d'une \xE9glise. Les caravanes partaient ensuite pour Gaza. Quelques postes mineurs jalonnaient aussi l'itin\xE9raire des caravanes, tels que Kasra, Nekarot, Makhmal et Grafon, ainsi qu'une autre auberge, Ein-Saharonim, dont il reste une cour entour\xE9e d'ateliers et un bain public.</p>\n\t\t\t\t\t\t\t\t\t<p>La route \xE9tait jalonn\xE9e de r\xE9servoirs, tours de guet, lieux de rituel, installations de bains publics et de rep\xE8res qui marquaient l'itin\xE9raire.</p>\n\t\t\t\t\t\t\t\t\t<p>Moa, Mamshit, Avdat, Shivta et Haluza, tout comme Ein-Saharonim, sont accessibles \xE0 tous les types de v\xE9hicules. La route elle-m\xEAme, qui traverse le d\xE9sert, n'est praticable qu'en jeep, bien que les cyclistes et pi\xE9tons puissent \xE9galement l'emprunter. En 2005, la route de l'encens a \xE9t\xE9 inscrite au Patrimoine mondial de l'UNESCO\u2026 Isra\xEBl vous invite \xE0 d\xE9couvrir les d\xE9serts du N\xE9guev et de la Arava pour marcher dans les pas des nomades et revivre une p\xE9riode tumultueuse de l\u2019histoire qui a laiss\xE9 derri\xE8re elle, ce t\xE9moin silencieux et impressionnant.</p> \n\t\t\t\t\t\t\t\t     \n\t\t\t\t\t\t\t\t\t\t                        "};}},// {
// 		id:"Mount_Karkom",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "MOUNT KARKOM",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                                 <p>In the heart of the western Negev lies a site considered one of the most significant landmarks in Christian history- the mysterious and beautiful Mount Karkom.</p>
// 						   <p>Featuring a wildly unspoiled landscape - an 847-meter-high limestone plateau scored by dramatic ravines, mount Karkom is believed by some scholars to be the site of the biblical Mount Sinai – mentioned often in the book of Exodus as the place where Moses received the Ten Commandments.</p>
// 						   <p>Walking down the eight-kilometer-long loop-trail, on the banks of the Karkom dry riverbed are two rows of standing stones and a rounded wall, reminiscent of nomadic shrine of the type built by the Israelites of the time. Looking closely, one can even spot 12 standing stones, believed by some to represent the 12 tribes of Israel.</p>
// 							<div class="img-wrapper">
// 										<img src=${getImgUrl()+ "/posts/mount-karkom/1.jpg"} class="img-responsive">
// 						       </div>
// 						       <p>Adding to the mystery and appeal, Mount Karkom features many famous rock drawings, depicting worshipping figures, animals and enigmatic symbols.</p>
//                                   <p>To visit the area Hikers must coordinate tour to the site in advance and use a Society for the Protection of Nature (SPNI) trail map (available in Hebrew only) to explore Mount Karkom.</p>
// 								                        `
//     }
//   }
// },
// {
// 		id:"Machtesh_Ramon",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "MACHTESH RAMON",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                               <p>At the heart of Israel’s vast Negev Desert, lies the Ramon Crater, the world’s largest erosion crater, also known as Machtesh Ramon. Encompassing a vast diversity of rocks of fantastic colors and forms, this mesmerizing natural phenomenon measures 40km in length and between 2 and 10km in width, shaped like an elongated heart, and forms Israel’s largest national park, the Ramon Nature Reserve.</p>
//                         <div class="img-wrapper">
// 							<img src=${getImgUrl()+ "/posts/machtes-ramon/1.jpg"} class="img-responsive">
// 						</div>
// 						<p>Far from the city lights and crowds, featuring multicolored sandstone, volcanic rock, and fossils, the Ramon Crater is often described as Israel’s very own Grand Canyon.</p>
// 						<p>The truly stunning views from the 300m edge lookout point of Machtesh Ramon, reminiscent of a Hollywood backdrop offer a powerful experience for tourists from all over the world, all year round.</p>
// 						<p>A visit to Machtesh Ramon offers a range of exciting experiences and attractions specifically geared towards tourists and world travelers:</p>
// 						<p><strong>Ramon Crater Visitor Center</strong>&nbsp;–&nbsp; Built on the crater’s edge, the visitor center overlooks the awesome views from the Machtesh and offers an opportunity to learn about its unique natural phenomena, and also about the life and work of Ilan Ramon, the first Israeli astronaut.</p>
// 						<p><strong>Hai Ramon</strong>&nbsp;- Raising awareness to the local animal population, The Hai Ramon animal park offers a fascinating encounter with the often obscure and unseen small animals of the desert, The site features about 40 species of animals: lizards, snakes, turtles, spurs, hedgehogs, falcons, pheasants and more.</p>
// 						<p><strong>Kahn Saharonim</strong>&nbsp;– a short walk from this once station on the Nabatean Spice Route, is Ein Saharonim, a beautiful spring (dry in the summer) which features rich vegetation and the footprints of the many animals that come to enjoy its waters.</p>
// 						<p><strong>The Carpentry</strong>&nbsp;– a fascinating geological phenomenon, The Carpentry is a concentration of elongated stones in the form of prisms formed when the sandstone was "baked" at the high temperature created by a hot lava flow from the depths of the earth. During its cooling, the rock formed into thousands of ribbed columns, and the fragments of the columns act as the prisms.</p>
// 						<p><strong>The Ammonite Wall</strong>&nbsp;- a rock wall featuring fossils of ammonites - marine animals that lived millions of years ago in the sea which then covered the entire Negev area.</p>
// 						<p>A trip to Machtesh Ramon is a fascinating experience, one guaranteed to create a strong impression and a lasting memory.</p>
//                         `
//     }
//   }
// },
{id:"Epic_Masada",ctg:"eilat-negev",bgImage:"/posts/bank/negev4/1.jpg",mobBgImage:"/posts/bank/negev4/M.jpg",isVid:true,vidId:"XxWa_MNm5x8",title:"AU CŒUR DU DÉSERT DE JUDÉE, EXPLOREZ MASSADA",smltitle:"",html:function html(){return{__html:"\n                                   <br/>\n                                   <h2 class=\"ac-align-center ac-margin-top-20\">Le Plus Haut Symbole Du Courage</h2>\n                                   \n\n\t\t\t\t\t\t\t\t    <p  class=\"ac-align-center ac-margin-bottom-20\"><strong>Au Sommet De Cette Fortification Embl\xE9matique, Revivez L'\xE9pop\xE9e Glorieuse Des Combattants De La Libert\xE9</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Prenez votre d\xE9part vers le parc national de Massada, l'ancienne fortification solitaire perch\xE9e au sommet d'une falaise du d\xE9sert de Jud\xE9e, qui surplombe la proche oasis de la mer Morte. Escaladez le sinueux chemin du Serpent ou l'escalier romain en partant de la base des fortifications. Vous pouvez \xE9galement emprunter le t\xE9l\xE9ph\xE9rique \xE0 partir du centre des visiteurs de Massada pour vous rendre au sommet du site et vous plonger dans un \xE9pisode glorieux de l'histoire ancienne, comme s'il \xE9tait en train de se d\xE9rouler sous vos yeux.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p><strong>Explorez ces ruines majestueuses et plongez-vous dans l'Histoire</strong></p>\n\t\t\t\t\t\t\t\t\t<p>D\xE9couvrez les vestiges d'anciens palais luxueux qui furent le dernier bastion des combattants de la libert\xE9. Suite \xE0 la destruction du Second Temple, ces hommes courageux men\xE8rent une guerre h\xE9ro\xEFque contre l'Empire romain. Sur ce site, l'histoire est encore si pr\xE9sente que les murs de pierres semblent litt\xE9ralement pleurer les \xE2mes des braves qui pr\xE9f\xE9r\xE8rent la mort \xE0 une vie d'esclave sous le joug de l'ennemi.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/epic-masada/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Une exp\xE9rience culturelle et spirituelle sans \xE9quivalent</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Baladez-vous dans les ruines du ch\xE2teau et d\xE9couvrez les pi\xE8ces et les constructions, les d\xE9couvertes arch\xE9ologiques qui permettent de reconstituer la vie \xE0 Massada pendant le si\xE8ge des Romains. P\xE9n\xE9trez dans le Ch\xE2teau Nord, les ruines du palais fortifi\xE9 priv\xE9 du roi H\xE9rode. Murmurez une pri\xE8re dans l'ancienne synagogue, o\xF9 les juifs se rassemblaient trois fois par jour afin de prier pour leur salut. Rendez hommage aux d\xE9funts combattants de la libert\xE9, qui se r\xE9unirent dans la \xAB&nbsp;Chambre du tirage au sort&nbsp;\xBB pour d\xE9terminer dans quel ordre mourraient les hommes, jusqu'\xE0 ce que le dernier d'entre eux mette lui-m\xEAme fin \xE0 ses jours.</p>\n\t\t\t\t\t\t\t\t\t<p>Admirez les vestiges d'une \xE9glise de l'\xE9poque byzantine et ses magnifiques mosa\xEFques, qui fut peut-\xEAtre utilis\xE9e d\xE8s le 1er si\xE8cle par des moines chr\xE9tiens en fuite, sur une p\xE9riode d'environ 600 ans.</p>\n\t\t\t\t\t\t\t\t\t<p>Explorez Massada, l'un des sites du patrimoine mondial de l'UNESCO, et assistez \xE0 son spectacle son et lumi\xE8re. Le soir, au pied de la fortification, ce spectacle reconstitue le mode de vie et les batailles que ce site a connus il y a des si\xE8cles.</p>\n\t\t\t\t\t\t\t\t  \n\t\t\t\t\t\t\t    "};}},// {
// 		id:"The_Bedouin_Experience",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "THE BEDOUIN EXPERIENCE",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 				           <p>The Bedouin hospitality is a truly unrivalled experience, one which is both highly enjoyable and culturally engaging.</p>
//                                  <p>A group of nomadic tribes indigenous to the area and dating back many hundreds of years, the Bedouins of Israel continue to live in traditional ways, opening their hearts, their homes and their way of life to the public, to share in their customs and their world-renowned hospitality.</p>
//                                  <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/the-bedouin-experience/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>From camel riding to traditional Bedouin meals and even overnight stays in traditional Bedouin tents - all these are immensely popular attractions with tourists in the region, and an opportunity to discover and connect with a long-forgotten way of life.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"The_Israel_National_Trail",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "THE ISRAEL NATIONAL TRAIL",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                                <p>The Israel National Trail (“Shvil Israel”) is a national project, paving a marked and safe hiking route across the country. Over 900km long, the route is one of the most rewarding ways to experience the nature and community in Israel.</p>
//                           <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/the-israel-national-trail/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>The Israel Bike Trail (Part of The Israel National Trail Project) is a national initiative to create mountain biking trail that crosses the country from north to south, connecting Mt. Hermon at one end with Eilat at the other. Perfectly suited for bicycle tourism, the trail passes through national sites and amazing landscapes, allowing riders to experience Israel's diversity of culture and types of communities along the way.The trail is one of the longest demarcated trails in the world suited to, and with appropriate signage for, mountain biking.</p>
//                         `
//     }
//   }
// },
{id:"Timna_Treasures",ctg:"eilat-negev",bgImage:"/posts/bank/negev4/1.jpg",mobBgImage:"/posts/bank/negev4/M.jpg",isVid:true,vidId:"i_4QKtXIeto",title:"LE PARC DE TIMNA",smltitle:"",html:function html(){return{__html:"\n                                   \n                                   <br/>\n                                   <h2 class=\"ac-align-center ac-margin-top-20\">Une aventure exaltante dans le d\xE9sert</h2>\n\n                                  \n\t\t\t\t\t\t\t\t   \n\n\t\t\t\t\t\t\t\t    <p  class=\"ac-align-center ac-margin-bottom-20\"><strong>Explorez la beaut\xE9 naturelle et les attractions captivantes du parc de Timna </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Situ\xE9 \xE0 20 minutes seulement d'Eilat, au c\u0153ur du d\xE9sert enchant\xE9 d'Isra\xEBl et nich\xE9 dans des paysages naturels \xE0 couper le souffle, le parc de Timna vous fera vivre une exp\xE9rience unique. Avec des attractions et des activit\xE9s qui combinent nature, antiquit\xE9s historiques et aventure, ce vaste site enchantera et suscitera l'engouement de tous les visiteurs, quels que soient leurs centres d'int\xE9r\xEAt ou leur \xE2ge.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Soyez t\xE9moin de ph\xE9nom\xE8nes naturels extraordinaires</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Parcourez le parc \xE0 pied et admirez les formations rocheuses uniques du site, aux formes rares et aux noms intrigants. Vous pourrez toucher de vos mains le \"Champignon\", le \"Champignon et demi\", le \"Canyon rose\", les \"Arches\", les \"Piliers de Salomon\" et la \"Vall\xE9e des dessins rupestres&nbsp;\xBB, qui illustrent une \xE9poque depuis longtemps r\xE9volue. Vous vous sentirez le t\xE9moin de quelque chose de r\xE9ellement spectaculaire.</p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/timna-treasures/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Partez en </strong><strong>randonn\xE9e dans les grands espaces</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Lancez-vous sur l'un des 20<strong> chemins de randonn\xE9e</strong> bien balis\xE9s, offrant des niveaux de difficult\xE9 vari\xE9s, et s\xE9lectionnez celui qui correspond le mieux aux exigences et aux capacit\xE9s de votre groupe. Randonnez sur ces fabuleux sentiers parsem\xE9s de curiosit\xE9s g\xE9ologiques et arch\xE9ologiques, ou optez pour la tranquillit\xE9 et le repos au bord du <strong>Lac Timna</strong>, ses terrains de camping et son restaurant King Solomon's Khan. Ici, vous pourrez remplir une bouteille de sables de diff\xE9rents coloris, ou louer un p\xE9dalo pour un tour sur le lac.</p>\n\t\t\t\t\t\t\t\t\t<p>Vous \xEAtes plut\xF4t attir\xE9 par les <strong>sports extr\xEAmes</strong> ? Testez la tyrolienne, les descentes en rappel et les circuits \xE0 v\xE9lo du parc. Soyez certain que chacune de ces activit\xE9s vous fortifiera et vous satisfera.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/timna-treasures/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Faites l'exp\xE9rience des temps anciens</strong></p>\n\t\t\t\t\t\t\t\t\t<p>D\xE9couvrez l'histoire biblique du d\xE9sert, \xE0 l'occasion d'une visite guid\xE9e du <strong>Tabernacle</strong> reconstruit, compl\xE9t\xE9 d'une r\xE9plique de l'Autel, du Saint des saints et de l'Arche. Observez comment les jeunes visiteurs s'\xE9merveillent de la reproduction de la structure sainte que Dieu ordonna aux Juifs de construire dans le d\xE9sert, et comment les visiteurs plus \xE2g\xE9s \xE9tudient l'authenticit\xE9 de la reconstruction, en apprenant une ou deux choses au passage.</p>\n\t\t\t\t\t\t\t\t\t<p>Le parc de Timna\u2026 L\xE0 o\xF9 l'Histoire rencontre l'aventure, au c\u0153ur du d\xE9sert isra\xE9lien.</p>\n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"Negev_Desert_Dont_Miss",ctg:"eilat-negev",bgImage:"/posts/bank/negev1/1.jpg",mobBgImage:"/posts/bank/negev1/M.jpg",isVid:false,title:"DÉSERT DU NÉGUEV – À NE PAS MANQUER",smltitle:"",html:function html(){return{__html:"\n                                   \n\t\t\t\t\t\t\t\t    <p><strong>Faire du sandboard dans le d\xE9sert</strong></p>\n\t\t\t\t\t\t\t\t\t <p>Une activit\xE9 embl\xE9matique du d\xE9sert. Laissez-vous griser par la vitesse en d\xE9valant assis ou debout les somptueuses dunes de sable du d\xE9sert du N\xE9guev. Lorsque vous ma\xEEtriserez cette technique tr\xE8s simple, vous pourrez vous consid\xE9rer comme un v\xE9ritable surfeur des sables. Quoi de plus g\xE9nial&nbsp;?</p>\n\n\t\t\t\t\t\t\t\t\t<p><strong>Le N\xE9guev de nuit</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Il n\u2019est rien de plus envo\xFBtant que le ciel du N\xE9guev de nuit. Levez la t\xEAte une fois la nuit tomb\xE9e, et vous serez frapp\xE9 par la splendeur des \xE9toiles scintillant dans le ciel bleu-noir et le parant d\u2019un \xE9clat que l\u2019on ne trouve que dans le d\xE9sert.</p>\n                                     <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/negev-desert-dont-miss/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Balade \xE0 dos de chameau</strong></p>\n\t\t\t\t\t\t\t\t\t<p>V\xE9ritable retour aux origines, il s\u2019agit toujours de la fa\xE7on la plus authentique d\u2019explorer le d\xE9sert. Plusieurs \xE9levages de chameaux du N\xE9guev proposent des promenades en chameau, et c\u2019est \xE0 coup s\xFBr une exp\xE9rience qui restera grav\xE9e dans votre m\xE9moire.</p>\n\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p><strong>Festival MidBurn</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Version isra\xE9lienne du fameux festival \xAB&nbsp;Burning Man&nbsp;\xBB, cette manifestation de 6 jours voit une ville \xE9ph\xE9m\xE8re s\u2019\xE9lever dans le d\xE9sert du N\xE9guev. Elle devient alors un lieu de vie communautaire, propice \xE0 la cr\xE9ativit\xE9, \xE0 l\u2019art et \xE0 une expression personnelle radicale.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Lever de soleil \xE0 Massada</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Seuls ceux qui seront suffisamment courageux pour gravir la montagne \xE0 pied pourront admirer le lever de soleil \xE0 Massada, une exp\xE9rience \xE0 ne manquer sous aucun pr\xE9texte lors de votre s\xE9jour en Isra\xEBl. Le soleil s\u2019\xE9levant lentement au-dessus des montagnes jordaniennes du Moab et de la mer Morte, dorant de ses rayons les paysages d\xE9sertiques environnants, est un spectacle que vous n\u2019\xEAtes pas pr\xE8s d\u2019oublier.</p>\n\t\t\t\t\t\t\t\t\t     \n\n\t\t                        "};}},// {
// 		id:"Negev_Charms",
//        	ctg : "eilat-negev",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"3UddwPEzDXo",
//         title : "ESCAPE TO THE NEVEG",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                                 <p>A desert holiday is unlike any other - the tranquility, the awe inspiring grand vistas, the clear star-studded night skies, all come together to create a truly mesmerizing and exotic experience most of us do not to partake in during our day to day lives.</p>
//                                 <p>The Negev is so much more than just a Desert. While it still offers all the natural beauty, calmness and wonderous sites which the desert tourist is looking for, it is also extremely westernized and packed with activities and adventures while offering all the comforts of a holiday. This is exactly what makes a trip to the Negev the perfect destination for travelers from all over the world. Another gem of the Negev is undoubtedly its local community, from the Kibbutz residents to the lone farm dwellers and the local Bedouin folk, the people of the Negev are warm, hospitable and always ready to lend a hand. The Negev is rich in geological and archeological treasures and offers loads of exciting activities for the more adventurous travelers.</p>
//                           <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/negev-charms/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>At the same time, visitors looking for relaxation are sure to find it in the tranquil surroundings, and for some urban excitement, the nearby cities provide a wide range of city fun from culinary treats to exciting nightlife.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"Galilee",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"5Ep3GgxELag",
//         title : "GALILEE",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 				          <p>Most of northern Israel is generically known as The Galilee (Galil in Hebrew). It stretches virtually from the Mediterranean to the harp-shaped Sea Of Galilee and River Jordan on whose shores vast history has been made. Here is Mount Gilboa where King Saul and his son, Jonathan, died in battle against the Phillistines. Here is Hazor, where Deborah killed Sisera. Here, at Mount Meron, is the grave of Rabbi Hillel. Here in Tzippori, Hamat Tveriya and Bet Alpha, gorgeous 1,800-year-old synagogue mosaics have been discovered. Here is Armageddon (Megiddo) where Solomon built giant stables. Here is the lakeshore city of Tiberias, one of the “Four Holy Cities of Judaism” (another is Galilee’s Safed), which reached fame 2,000 years ago as one of the chief locations in which the Talmud was written.</p>
//                                 <h3 >Galilee</h3>
//                                 <div class="responisve-iframe">
// 					           <iframe width="560" height="315" src="https://www.youtube.com/embed/lzYzxyvnfng" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
// 				           </div>
// 				           <p>The restoration of the Jewish homeland in the period beginning in the 1880’s was largely centered in the Galilee, and in the ensuing 130 years a much neglected landscape of not much more than olive trees has been transformed into one of the most fertile areas in the world. Here are dozens of kibbutzim and independently owned farms – whose produce feeds not only Israelis but is also flown daily to the grocery stores and flower markets of Europe. Here are some of Israel’s 300+ vineyards producing award winning wines. And here are pretty villages, towns and cities including Nazareth and Carmiel.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/galilee/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>In addition to hotels and very comfortable kibbutz guest houses, the Galilee is filled with dozens of country bed-and-breakfast accommodations, known as zimmerim. Many offer luxurious accommodations, including pools, and make a delightful base for relaxing and touring.</p>
//                         `
//     }
//   }
// },
{id:"Galilee_1",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:true,vidId:"5Ep3GgxELag",title:"DÉCOUVREZ LES JOYAUX CACHÉS DE GALILÉE",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t         \n\t\t\t\t\t\t          <br/>\n\t\t\t\t\t\t          <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Vos vacances de r\xEAve dans un Isra\xEBl insoup\xE7onn\xE9</h2>\n\t\t\t\t\t\t          <p>D\xE9couvrez la campagne luxuriante du nord d'Isra\xEBl, les villes pittoresques qui couronnent les collines de la Haute et Basse Galil\xE9e, des r\xE9gions o\xF9 caves \xE0 vin et restaurants c\xF4toient sites historiques antiques. S\xE9journez dans un h\xF4tel de luxe ou profitez de v\xE9ritables vacances \xE0 la campagne dans un des fameux \xAB&nbsp;<em>zimmers&nbsp;\xBB </em>de Galil\xE9e, des pavillons de vacances g\xE9r\xE9s en famille et nich\xE9s dans de petits villages\u2026 Et d\xE9couvrez Isra\xEBl sous un nouveau jour.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>O\xF9 l'</strong><strong>Histoire</strong><strong> prend vie</strong></p>\n\t\t\t\t\t\t\t\t\t<p>La Galil\xE9e regorge de sites historiques. Visitez les villages antiques de Kfar Nahum (Capharna\xFCm) et Migdal (Magdala) et p\xE9n\xE9trez dans la Maison de St Pierre, \xE0 Capharna\xFCm. Admirez les impressionnants monast\xE8res et \xE9glises qui entourent la mer de Galil\xE9e et qui marquent les d\xE9buts du christianisme. Respirez l'air de Safed, une des quatre villes saintes du juda\xEFsme, et explorez le plus important centre kabbalistique au monde. D\xE9couvrez les synagogues les plus anciennes au monde sur des sites tels que Baram et visitez les forteresses de Montfort et Nimrod, datant des croisades. Rendez hommage \xE0 Ma\xEFmonide dans la ville antique de Tib\xE9riade, et admirez les merveilles d'Acre (Akko), comme la ville souterraine des Crois\xE9s, la forteresse ou le tunnel des Templiers...</p>\n\t\t\t\t\t\t\t\t\t<p><strong>La Galil\xE9e&nbsp;: un paradis pour les gourmets</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Partout en Galil\xE9e vous trouverez des caves \xE0 vin et des fromageries artisanales. Vous pourrez ainsi vous r\xE9galer d'authentiques mets druzes et arabes cuits sur des feux ouverts. D\xE9gustez les produits directement chez les producteurs, dans les fermes biologiques, arr\xEAtez-vous dans un restaurant raffin\xE9 familial et consommez des fruits frais que vous aurez cueillis vous-m\xEAme dans les vergers. D\xE9couvrez Isra\xEBl, o\xF9 le lait et le miel ne sont pas les seuls produits disponibles en abondance. Vous y trouverez aussi une profusion de vins, huiles d'olive, fromages de ch\xE8vre et fruits savoureux.</p>\n\t\t\t\t\t\t\t\t\t <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/galilee/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Des activit\xE9s passionnantes dans des paysages \xE9poustouflants</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Le paysage vallonn\xE9 et verdoyant de Basse Galil\xE9e est sillonn\xE9 de rivi\xE8res et parfait pour se promener dans un cadre ombrag\xE9. Les amateurs d'adr\xE9naline pourront partir \xE0 l'assaut des hauteurs et descendre en rappel les sommets de Haute Galil\xE9e, ou d\xE9valer en rafting les eaux turbulentes du fleuve Jourdain. De superbes balades en jeep, \xE0 cheval ou \xE0 v\xE9lo, des parties de paint-ball et des activit\xE9s aquatiques vous attendent \xE9galement. Si vous pr\xE9f\xE9rez les activit\xE9s plus calmes, observez la vie sauvage dans les vastes r\xE9serves naturelles du pays ou partez en croisi\xE8re sur les eaux calmes du lac de Tib\xE9riade. Vous pouvez m\xEAme pratiquer les sports d'hiver sur les pentes enneig\xE9es du Mont Hermon, \xE0 l'extr\xEAme nord du pays.</p>\n\t\t\t\t\t\t\t\t\t<p>Pour passer les vacances de vos r\xEAves, visitez le nord d'Isra\xEBl.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t         \n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},// {
// 		id:"Caesarea",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"eLZ433_S6HI",
//         title : "CAESAREA",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `  <p>The Roman port city of Caesarea is one of Israel’s wonders, combining ancient structures, archeology and a picture-perfect harbor, and adapting them for modern use.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/caesarea/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>Built by Rome’s Judean Governor, Pontius Pilate, two millennia ago, Caesarea was one of the largest and most magnificent ports in the Mediterranean, with giant piers stretching out into the sea to accommodate dozens of ships. The city of Caesarea contained a giant hippodrome, aqueduct and theater; a thousand years later the Crusaders arrived and built a giant fortress, and then came the Ottomans, who turned it into a seaside town. Today, the Roman theatre is a venue for concerts, the Crusader fortress is thrilling to visit and the Ottoman harbor and beach are full of cafes, restaurants and a visitors’ center. Caesarea is 45 minutes’ drive from Tel Aviv, 20 from Haifa.</p>
//                         `
//     }
//   }
// },
{id:"Caesarea_1",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"eLZ433_S6HI",title:"CÉSARÉE : QUAND LITTORAL FLIRTE AVEC HISTOIRE…",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t\t\t   <p>Situ\xE9e au bord des eaux \xE9tincelantes de la M\xE9diterran\xE9e, C\xE9sar\xE9e est une ville de toute beaut\xE9 qui allie romantisme et sites de grande valeur historique et arch\xE9ologique, en d\xE9pit du souffle de modernit\xE9 et de luxe dont elle fait l'objet. \xC0 moins d'une heure de voiture de Tel Aviv, cette ville offre des plaisirs tr\xE8s vari\xE9s avec ses ruines antiques, son parcours de golf verdoyant et ses manifestations artistiques.</p>\n\n\t\t\t\t\t\t\t\t\t<p><strong>Un voyage dans le temps</strong></p>\n\t\t\t\t\t\t\t\t\t<p>La vieille ville et ses splendeurs arch\xE9ologiques t\xE9moignent du r\xF4le de C\xE9sar\xE9e \xE0 travers les \xE9poques. Une visite au parc national de C\xE9sar\xE9e, au vieux port, \xE0 l'hippodrome romain et \xE0 l'amphith\xE9\xE2tre r\xE9nov\xE9, ou une balade dans les ruines de l'impressionnant palais d'H\xE9rode vous feront faire un bond dans le temps et vous donneront l'illusion qu\u2019un navire romain s'appr\xEAte \xE0 accoster et \xE0 d\xE9charger sa riche cargaison.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/caesarea/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\n\t\t\t\t\t\t\t\t\t<p>\xC0 la \xAB&nbsp;Time Tower&nbsp;\xBB (Tour du temps), assistez \xE0 un spectacle son et lumi\xE8re magique retra\xE7ant l'histoire de la ville ou partez \xE0 la rencontre des h\xE9ros qui ont fait l'histoire avec \xAB&nbsp;Caesarea Stars&nbsp;\xBB (\xC9toiles de C\xE9sar\xE9e), une pr\xE9sentation technologique. Ces spectacles abordent l'histoire antique sous un angle moderne et sont \xE0 la fois divertissants et instructifs pour les visiteurs de tous \xE2ges, quels que soient leurs centres d'int\xE9r\xEAt.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>\xC0 la crois\xE9e des ruines antiques et du confort moderne</strong></p>\n\t\t\t\t\t\t\t\t\t<p>La beaut\xE9 \xE9blouissante du littoral de C\xE9sar\xE9e - les vagues qui viennent mourir sur les murailles du vieux port - combin\xE9e aux plaisirs modernes de la ville, comme les restaurants locaux pittoresques, les caf\xE9s, les boutiques, le mus\xE9e d'art Ralli et l'unique parcours de golf du pays, \xE9veillent un profond sentiment de d\xE9tente et de plaisir. Et lorsque vous assisterez aux diverses repr\xE9sentations donn\xE9es par les artistes locaux et internationaux dans l'amphith\xE9\xE2tre romain, vous vous laisserez envelopper dans l'atmosph\xE8re sp\xE9ciale d'un concert moderne donn\xE9 dans un cadre rest\xE9 inchang\xE9 depuis des si\xE8cles.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"Caesarea_2",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:true,vidId:"eLZ433_S6HI",title:"CÉSARÉE VOYAGEZ À TRAVERS LE TEMPS",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t\t\t<p><strong>Explorez les merveilles du pass\xE9, \xE9rig\xE9es </strong><b>par l\u2019un des&nbsp;</b><strong>plus grands b\xE2tisseurs de l'antiquit\xE9, H\xE9rode 1<sup>er</sup> Le Grand.</strong></p>\n\t\t\t\t\t\t\t\t<p>Au bord des eaux turquoises \xE9tincelantes de la M\xE9diterran\xE9e, \xE0 moins d'une heure de route de Tel Aviv, s'\xE9tend la magnifique cit\xE9 antique de C\xE9sar\xE9e.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p>La ville et ses splendeurs arch\xE9ologiques t\xE9moignent du r\xF4le de C\xE9sar\xE9e \xE0 travers les \xE9poques.&nbsp; Une promenade au parc national et au port antique, une visite de l'hippodrome et de l'amphith\xE9\xE2tre romains, une balade dans l'impressionnant palais vous permettront de d\xE9couvrir quelques uns des nombreux tr\xE9sors historiques de la cit\xE9 et de remonter le temps jusqu'\xE0 l'\xE9poque des grands empires.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/caesarea/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t<p>Surtout, ne manquez pas le mini-spectacle de sons et lumi\xE8res \"Voyage dans le temps\", une exp\xE9rience fascinante et \xE9mouvante qui vous restituera toute la magie de l'histoire de C\xE9sar\xE9e \xE0 travers les \xE2ges.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p>Pendant votre visite, vous serez \xE9galement s\xE9duit par la beaut\xE9 du bord de mer de C\xE9sar\xE9e et go\xFBterez aux plaisirs de la modernit\xE9, tels que ses restaurants et <em>caf\xE9s</em> d\xE9licieusement pittoresques et son parcours de golf, le seul du pays.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  \n\t\t                        "};}},{id:"Acre",ctg:"north",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",isVid:true,vidId:"KlXXyToCmCM",title:"LA VIEILLE VILLE D'ACRE - OU SAINT-JEAN D’ACRE",smltitle:"",html:function html(){return{__html:" \n\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<h2 class=\"ac-align-center ac-margin-top-20\">Suivez les traces des crois\xE9s</h2>\n\n\t\t\t\t\t\t<p  class=\"ac-align-center ac-margin-bottom-20\"><strong>Au nord d'Isra\xEBl, une ancienne cit\xE9 fortifi\xE9e devenue p\xF4le culturel</strong></p>\n\t\t\t\t\t\t<p>La vieille ville d'Acre est l'un des sites les plus exceptionnels d'Isra\xEBl. C'est une cit\xE9 c\xF4ti\xE8re entour\xE9e de vieux remparts en pierres qui abrite d'innombrables tr\xE9sors historiques et culinaires. La vieille ville d'Acre d\xE9gage une atmosph\xE8re unique et sublime, sans \xE9quivalent dans le pays.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p><strong>\xC0 la rencontre d'un patrimoine historique captivant</strong></p>\n\t\t\t\t\t\t<p>Pr\xE9parez-vous \xE0 visiter des sites et attractions fascinants \xE9voquant la vie et les pratiques des crois\xE9s qui contr\xF4l\xE8rent autrefois la vieille ville d'Acre. Contemplez <b>les anciens et magnifiques</b> <b>remparts</b> qui entourent la vieille ville et qui ont prot\xE9g\xE9 les habitants d'Acre pendant le si\xE8ge de la ville par Napol\xE9on. En visitant le <b>port d'Acre</b>, vous pourrez fermer les yeux, respirer l'air frais de la mer et imaginer le site tel qu'il \xE9tait autrefois. Ce port important \xE9tait l'aboutissement de liens maritimes avec l'Occident, et le principal point d'entr\xE9e des p\xE8lerins d\xE9couvrant la Terre Sainte.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/acre/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t<p>D\xE9couvrez un spectaculaire site souterrain, connu sous le nom de <strong>tunnel des Templiers</strong>. Dans le pass\xE9, ce passage en pierres aboutissait \xE0 une forteresse strat\xE9gique d\xE9fendant le port d'Acre pour permettre aux p\xE8lerins d'accomplir leur voyage en Isra\xEBl. Aujourd'hui consid\xE9r\xE9 comme un symbole de coop\xE9ration et de pers\xE9v\xE9rance, son franchissement est v\xE9ritablement une exp\xE9rience \xE0 couper le souffle. Continuez jusqu'\xE0 la <strong>Forteresse des Hospitaliers</strong> (salle des chevaliers), b\xE2tie par le roi Richard C\u0153ur de Lion durant la troisi\xE8me croisade. Les ruines de ce qui fut autrefois l'ancienne cour centrale du fort, entour\xE9e d'arches, constituent un v\xE9ritable t\xE9moignage des liens profonds forg\xE9s dans la ville en ces temps difficiles.</p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p><strong>Un mariage rare d'authenticit\xE9 et de cultures</strong></p>\n\t\t\t\t\t\t<p>Parmi les sites anciens et les attractions, c'est le <b>march\xE9</b> d'Acre qui illustre le mieux l'authentique r\xE9seau de cultures orientales et occidentales sur lequel la ville portuaire a \xE9t\xE9 fond\xE9e et continue de prosp\xE9rer. Le march\xE9 est un lieu riche en parfums et saveurs, o\xF9 des individus des quatre coins du monde proposent aux visiteurs des nourritures spirituelles et terrestres. Vous y trouverez une large vari\xE9t\xE9 de d\xE9lices culinaires, comme des p\xE2tisseries orientales, des \xE9pices pr\xE9par\xE9es sur place, des produits frais et du poisson encore vivant. En vous dirigeant vers le sud du march\xE9, vous pourrez visiter la Synagogue Ramchal et la maison de l'artiste Chaim Parchi, deux lieux qui apportent leur charme et leur vitalit\xE9 \xE0 un p\xF4le culturel d\xE9j\xE0 anim\xE9.</p>\n\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t   <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/acre/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\t\t\t\t\t\t   \n\t\t                        "};}},// No translation for this post in Frncias
// {
// 		id:"Haifa",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"3ahATaKkhBk",
//         title : "HAIFA",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `  <p>Haifa is Israel’s third-largest city, Israel’s chief port and home to 400,000.  Draped around the slopes of biblical Mount Carmel, it is a 100-year-old city whose importance burgeoned in the 1920’s and 1930’s as Britain followed its League of Nations mandate over Palestine to create a Jewish homeland. The bustling lower Carmel neighborhood is the port area and where much of Haifa’s daily business is conducted. The slopes of central Carmel are largely residential, and the mountaintop Upper Carmel is home to museums, many hotels and shops.  from the top to the bottom of Mount Carmel is achieved by the Carmelit subway, the Bat Ganim cable car and, of course, by road.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/haifa/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>Haifa’s iconic symbol is the golden-domed Baha’i Shrine of the Bab, completed in 1953, that abuts the international headquarters of the Baha’i Faith, a network of giant white Greco-Roman buildings whose beauty stuns the visitor. The Shrine of the Bab was further beautified with the completion in 2001 of the “hanging gardens” (a UNESCO World Heritage Site) magnificent terraced gardens that lead from the shrine to the bottom of Mount Carmel. Here is the restored Templer Colony – where the homes and workshops of 19th-century German Christian “Templer” immigrants are now a network of chic stores, bars and restaurants.</p>
// 						   <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/haifa/2.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>Haifa is home to a dozen museums – including a museum of Japanese Art, Israel’s Railway Museum and the Af-Al-Pi-Chen Museum of Illegal Immigration. It is also home to the Technion, Israel’s version of MIT. Haifa’s Wadi Nisnas neighborhood is the center of multi-holiday celebrations reflecting Haifa’s identity as city that is home to Jews, Christians, Muslims and Baha’is.</p>
// 						   <p><strong>MUST SEES:</strong></p>
// 						   <p><em>Baha’i Shrine of the Bab</em></p>
// 						   <p><em>Baha’i “Hanging Gardens”</em></p>
// 						   <p><em>Panorama of Haifa Bay from Upper Carmel</em></p>
// 						   <p><em>Templer Colony</em></p>
// 						   <p><strong>IF YOU HAVE MORE TIME:</strong></p>
// 						   <p><em>Af-Al-Pi-Chen Museum of Illegal Immigration</em></p>
// 						   <p><em>Israel Railway Museum</em></p>
// 						   <p><em>Museum of Japanese Art</em></p>
// 						   <p><em>Technion</em></p>
// 						   <p><em>Wadi Nisnas</em></p>
//                         `
//     }
//   }
// },
{id:"Haifa_1",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"3ahATaKkhBk",title:"HAÏFA LA PORTE VERS LE NORD D'ISRAËL",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t\t\t   \n\n\t\t\t\t\t\t\t\t    <p>Troisi\xE8me plus grande ville d'Isra\xEBl et de loin l'une des plus captivantes, Ha\xEFfa est parfois d\xE9sign\xE9e \"Capitale du Nord\".</p>\n\t\t\t\t\t\t\t\t\t<p>Au printemps ou en \xE9t\xE9, vous aurez le plaisir de vous baigner ou de prendre le soleil sur une de ses splendides plages. Tout au long de l\u2019ann\xE9e Ha\xEFfa regorge d\u2019activit\xE9s \xE0 ne pas manquer.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t<p>Sise sur les pentes de l'impressionnant Mont Carmel (\xE0 ne pas manquer), la ville est aussi surnomm\xE9e \"le San Francisco isra\xE9lien\" et se montre \xE0 la hauteur de cette comparaison avec ses plages magnifiques, ses panoramas inoubliables, ses nuits anim\xE9es et sa sc\xE8ne musicale avant-gardiste.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Jardins Baha\xEFs - Beaut\xE9, grandeur et inspiration</strong></p>\n\t\t\t\t\t\t\t\t\t<p>En juillet 2008, les jardins baha\xEFs ont \xE9t\xE9 inscrits au Patrimoine mondial de l'UNESCO pour leur \"valeur universelle exceptionnelle\" en tant que lieu saint de p\xE8lerinage de la foi baha\xEFe.</p>\n\t\t\t\t\t\t\t\t\t<p>Le mausol\xE9e et les jardins baha\xEFs sont des lieux inspir\xE9s qui allient beaut\xE9, grandeur et conception exquise dans une atmosph\xE8re paisible sans \xE9gal. Parmi les sites les plus visit\xE9s du pays, ces jardins attirent plus d'un million de visiteurs par an.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/haifa/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Mont Carmel - une montagne \xE0 la v\xE9g\xE9tation luxuriante pr\xE8s de la M\xE9diterran\xE9e</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Symbole de beaut\xE9 et de floraison le Mont Carmel est l \u2018un des principaux points d'int\xE9r\xEAt du pays, et la destination id\xE9ale pour une randonn\xE9e ou un pique-nique en famille. De plus, vous n'aurez nul besoin de vous fatiguer pour admirer les vues spectaculaires depuis le sommet puisque vous pourrez emprunter le Carmelit, un funiculaire.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Art et culture</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Ha\xEFfa est une ville cr\xE9ative et anim\xE9e qui propose de tr\xE8s belles galeries d'art et des \xE9v\xE9nements culturels au d\xE9tour de chaque rue. Ne manquez pas Madatech, le mus\xE9e national des sciences, de la technologie et de l'espace d'Isra\xEBl, le Mus\xE9e d'art de Ha\xEFfa, et le zoo, situ\xE9s sur le Mont Carmel<span dir=\"RTL\">.</span></p>\n\t\t\t\t\t\t\t\t\t<p>Ha\xEFfa propose \xE9galement un large \xE9ventail d'\xE9v\xE9nements culturels tels que le \xAB&nbsp;Holiday of Holidays Festival&nbsp;\xBB, qui c\xE9l\xE8bre les f\xEAtes juives, chr\xE9tiennes et musulmanes qui se d\xE9roulent toutes en d\xE9cembre. Ne manquez pas non plus le Festival international du film de Ha\xEFfa, tous les ans en septembre, qui pr\xE9sente une centaine de films de tous genres.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\n\t\t                        "};}},{id:"Haifa_Beauty",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:false,title:"HAÏFA LA BEAUTÉ SOURCE D'INSPIRATION",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t\t\t   \n\n\t\t\t\t\t\t\t\t   <p><strong>Tranquillit\xE9 urbaine et paysages enchanteurs </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Avec ses falaises escarp\xE9es qui viennent mourir sur les rives de la M\xE9diterran\xE9e et ses collines verdoyantes qui surplombent le port, la troisi\xE8me ville d'Isra\xEBl offre au regard des paysages parmi les plus spectaculaires du pays. Belle, tranquille et v\xE9ritable mod\xE8le de cohabitation entre les diff\xE9rentes communaut\xE9s religieuses, Ha\xEFfa est plus qu'un lieu, c'est un mode de vie. Marchez sous les pins et profitez de la diversit\xE9 culturelle de la ville, de son milieu intellectuel actif, de son atmosph\xE8re paisible et de sa beaut\xE9 indiscutable. Vous serez forc\xE9ment enthousiasm\xE9.&nbsp;&nbsp;&nbsp;&nbsp;</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Entourez-vous de s\xE9r\xE9nit\xE9 et de beaut\xE9 </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Les <strong>Jardins baha\xEFs</strong>, connus dans le monde entier, constituent l\u2019une des principales attractions touristiques de Ha\xEFfa. Inscrit depuis 2008 au Patrimoine mondial de l'UNESCO pour sa \"valeur universelle exceptionnelle\", ce lieu de toute beaut\xE9 accueille plus d'un million de visiteurs par an.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/haifa-beauty/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t     </div>\n\t\t\t\t\t\t\t\t\t<p>Commencez votre visite au sommet du Mont Carmel, sur l'agr\xE9able Promenade Louis. Admirez la vue exceptionnelle qui s'\xE9tend de la ville de Ha\xEFfa \xE0 l'ensemble de la c\xF4te et au-del\xE0 jusqu'aux Montagnes de Galil\xE9e.</p>\n\t\t\t\t\t\t\t\t\t<p>Explorez les jardins seul ou dans le cadre d'une visite gratuite. Descendez les terrasses en cascade et contemplez les haies et massifs de fleurs amoureusement entretenus. Visitez le Mausol\xE9e du Bab, orn\xE9 d'un d\xF4me dor\xE9, dans lequel repose le proph\xE8te HERALD de la religion baha\xEFe. \xC9merveillez-vous devant les couleurs et formes g\xE9om\xE9triques de ces jardins suspendus uniques et impr\xE9gnez-vous de leur s\xE9r\xE9nit\xE9.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>D\xE9couvrez le c\u0153ur de la sc\xE8ne culturelle de Ha\xEFfa </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Les Jardins baha\xEFs surplombent le quartier de la colonie allemande. B\xE2ti dans les ann\xE9es 1860 par les membres de la Soci\xE9t\xE9 du Temple allemande, ce quartier est aujourd'hui le c\u0153ur de la sc\xE8ne culturelle de la ville et un haut lieu touristique, avec ses restaurants, bars, galeries et h\xF4tels de charme. Fl\xE2nez dans les rues pav\xE9es, visitez les galeries et appr\xE9ciez l'architecture de qualit\xE9. Restaurez-vous dans les caf\xE9s et restaurants locaux, profitez de la vie nocturne et m\xEAlez-vous \xE0 la foule h\xE9t\xE9roclite. Lorsque la nuit s'ach\xE8ve, ne manquez pas de lever la t\xEAte pour regarder les splendides illuminations qui ornent les Jardins baha\xEFs de bas en haut.&nbsp;Vous serez combl\xE9.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  \n\t\t                        "};}},{id:"Safed",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:true,vidId:"i3_ihL51bHo",title:"SAFED – OÙ LE MYSTIQUE CÔTOIE LE TERRESTRE",smltitle:"",html:function html(){return{__html:"  \n\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Plongez-vous dans l'art et la spiritualit\xE9 pour une nouvelle interpr\xE9tation de la vie</h2>\n                        \n\n\t\t\t\t\t\t\t\t   <p>Avec ses paysages \xE0 perte de vue et son air pur, Safed saura vous captiver d\xE8s l'instant o\xF9 vous y poserez le pied. Connue comme la capitale du mysticisme juif, hier comme aujourd'hui, cette superbe ville antique perch\xE9e sur la colline est la ville la plus \xE9lev\xE9e de Galil\xE9e et d'Isra\xEBl, tant sur le plan g\xE9ologique que spirituel. Une des quatre villes sacr\xE9es du juda\xEFsme, Safed offre une exp\xE9rience v\xE9ritablement mystique dont l'\xE9nergie profonde \xE9veillera votre fascination.</p>\n\t\t\t\t\t\t\t\t\t<p>\xC0 une courte distance en voiture du lac de Tib\xE9riade, Safed vous accueille avec ses pittoresques all\xE9es pav\xE9es et son architecture numineuse. \xC9coutez les \xE2mes qui ont fait l'histoire, vous confier leurs secrets dans l'ancienne forteresse \xE9rig\xE9e par les Crois\xE9s, sous les influences mameloukes, ottomanes et britanniques, le Monument de la guerre d'ind\xE9pendance, ainsi que les synagogues et tombeaux anciens, v\xE9ritables t\xE9moins de l'histoire profond\xE9ment sacr\xE9e du lieu.</p>\n                                     <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/safed/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<p><strong>La capitale de la Kabbale \xE9ternelle</strong></p>\n\t\t\t\t\t\t\t\t\t<p>De Rabbi Shimon Bar-Yohai, auteur du livre essentiel de la Kabbale au 2<sup>\xE8me</sup> si\xE8cle connu sous le nom de Zohar, \xE0 Ari HaKadosh, le p\xE8re de la Kabbale contemporaine, Safed est la terre d'accueil de la plus haute mystique du juda\xEFsme et de ses \xE9l\xE8ves d\xE9vots. C'est au 16<sup>\xE8me</sup> si\xE8cle qu\u2019Ari HaKadosh a \xAB&nbsp;d\xE9mocratis\xE9&nbsp;\xBB les enseignements de la Kabbale en apportant une nouvelle compr\xE9hension qui la rendait accessible au profane.</p>\n\t\t\t\t\t\t\t\t\t<p>En cheminant \xE0 pied d'une synagogue \xE0 l'autre, vous comprendrez comment Safed est devenue le lieu d'accueil d'une si longue lign\xE9e d'aspirants spirituels, quels qu'aient \xE9t\xE9 les \xE9v\xE9nements plac\xE9s sur leur chemin au cours de l'histoire. La synagogue Abuhav dont l'architecture incarne le mysticisme num\xE9rique, la synagogue ashk\xE9naze Ari d\xE9di\xE9e \xE0 Ari HaKadosh et la synagogue Yosef Caro vous emporteront dans un voyage \xE0 travers le temps et dans les mondes les plus \xE9lev\xE9s du mysticisme.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Une vieille ville source d'inspiration</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Vivez d'autres moments inoubliables au cours de votre voyage en vous promenant dans les all\xE9es pav\xE9es sinueuses de la vieille ville, en contemplant d'incomparables \xE9difices en pierre et en poursuivant votre chemin jusqu'\xE0 la Colonie des artistes. D\xE9di\xE9e aux amoureux des arts, cette partie de la ville abrite des galeries de qualit\xE9 qui vous donneront l'occasion de d\xE9couvrir les \u0153uvres des artistes locaux, notamment un vaste choix de Juda\xEFca. Les amateurs de culture ne manqueront pas de visiter le Mus\xE9e de la poup\xE9e et le Mus\xE9e de l'art de l'impression.</p>\n\t\t\t\t\t\t\t\t\t<p>Safed nourrira votre corps comme votre esprit - les nombreux lieux de restauration de la vieille ville sauront satisfaire tous les palais et toutes les bourses. Des cr\xEApes y\xE9m\xE9nites et de la cuisine de rue aux mets inattendus propos\xE9s dans les restaurants, vous trouverez de quoi satisfaire vos envies, et bien plus encore, dans cette ville pleine de gr\xE2ce aux traditions profond\xE9ment ancr\xE9es.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t   \t\t\t\t\t\t\t   \n\t\t                        "};}},// {
// 		id:"The_Bahai_Gardens",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"JV_AmfRULOo",
//         title : "THE STUNNING BAHA’I GARDENS",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 				          <p><strong>Visit the Baha’i Gardens</strong></p>
//                                 <p>Picture yourself standing on the nineteenth terrace which is the very top of this breath taking monument where you can see the rolling hills of the Galilee, the city of Haifa, Akko and the Mediterranean Sea.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/bahai-gardens/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>Beauty, grandeur, and inspired design combined with the meticulous gardening by generations of dedicated gardeners and a variety of cultures create the unique atmosphere of the Baha’i shrine and gardens in Haifa. While each garden offers a different experience they all share the same theme of gravelling paths, unique hedges and flourishing flower beds. A picture so perfect you must see it with your own eyes to believe the precision and symmetry.</p>
// 						   <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/bahai-gardens/2.jpg"} class="img-responsive">
// 						   </div>
// 						     <p>This mystical iconic is site where members of the Baha’i faith have established their shrine and world centre because of its significance to their faith.</p>
//                                  <p>The Baha’i faith had its origins from Iran. Its founder Baha'u'llah, was exiled from his homeland at the end of the 19th century, and came to Akko (Acre) and Haifa after suffering persecution in neighbouring countries.&nbsp; He was impressed with the beauty of Mount Carmel and expressed the desire that the Bab (one of the central figures of the Baha’i faith) would be buried there. About 20 years later the bones of the Bab were laid to rest in Haifa on the site that then developed into the centre of The Baha’i faith which is visited by half a million people every year.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"The_Sea_Of_Galilee",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"haG-t3wwuMc",
//         title : "THE SEA OF GALILEE (KINNERET )",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
//                         `
//     }
//   }
// },
{id:"Rosh_Pina",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"_qKbHL5-qrQ",title:"ROSH PINA",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t           \n                                   <br/>\n                                   <h2 class=\"ac-align-center ac-margin-top-20\">La destination touristique pastorale secr\xE8te de la Galil\xE9e</h2>\n\t\t\t\t\t\t           \n\t\t\t\t\t\t\t\t    <p class=\"ac-align-center ac-margin-bottom-20\"><strong>Remontez le temps dans un village pittoresque et authentique de Galil\xE9e </strong></p>\n\t\t\t\t\t\t\t\t\t<p>Connu sous le nom de Princesse de la Galil\xE9e, Rosh Pina offre une combinaison parfaite de sites naturels, culturels, historiques et de divertissement. Rosh Pina est un village du nord, magnifiquement restaur\xE9, o\xF9 les vieux oliviers et les maisons pittoresques sont entour\xE9s de luxuriants champs dor\xE9s. C'est l'endroit parfait pour vivre des vacances tranquilles et d\xE9contract\xE9es, et retrouver la vie d'un village telle qu'elle se d\xE9roulait il y a plus d'un si\xE8cle.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Seul le chant des oiseaux vient briser la magie du silence</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Vous recherchez un lieu serein blotti dans la nature, qui rappelle la Toscane ou la Provence ? En vous dirigeant vers le nord jusqu'\xE0 Rosh Pina, o\xF9 les paysages ruraux \xE0 couper le souffle se marient harmonieusement aux attraits du village, vous vous sentirez transport\xE9 dans le pass\xE9. Posez vos bagages dans une des nombreuses maisons d'h\xF4tes \xE9quip\xE9es pour vous assurer un confort optimal, qui pars\xE8ment les ruelles romantiques du village. Ressourcez-vous au sein de cette communaut\xE9 accueillante au charme d\xE9suet, \xE9pargn\xE9e par l'agitation des grandes villes.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/rosh-pina/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<p>Profitez de la beaut\xE9 naturelle des lieux et baladez-vous dans la verdure, le long des superbes <strong>chemins de randonn\xE9e</strong> environnant la rivi\xE8re de Rosh Pina ou les <strong>Jardins du Baron de Rotschild</strong>, dont on dit qu'ils s'inspirent des grands jardins de Versailles. Au cours de votre promenade, respirez l'air frais et impr\xE9gnez-vous de la beaut\xE9 de la nature jusqu'\xE0 ne faire plus qu'un avec elle. Ressourcez-vous.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Un lieu de vill\xE9giature au charme artistique unique</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Le long des rues pav\xE9es du village, qui rappellent les vieux villages europ\xE9ens, vous pourrez jouir d'une agr\xE9able atmosph\xE8re culturelle et artistique, dans ce site qu'entourent les magnifiques montagnes de la Galil\xE9e. Le village abrite des caf\xE9s branch\xE9s, des restaurants gastronomiques, des galeries d'art, des mus\xE9es, des festivals, des sites historiques et un centre commercial. Il regorge d'antiquit\xE9s, de lieux culturels et naturels, de d\xE9lices culinaires qui \xE9voquent toute l'histoire de la premi\xE8re \xAB&nbsp;moshava de Galil\xE9e&nbsp;\xBB (ville) et de l'implantation des premi\xE8res communaut\xE9s juives en Isra\xEBl.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  \t\t\t\t\t\t   \n\t\t                        "};}},{id:"Nazareth",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"1M7N5BcmjFM",title:"NAZARETH LE BERCEAU DU CHRISTIANISME",smltitle:"",html:function html(){return{__html:" \n\n\t\t\t\t\t\t        \n\n\t\t\t\t\t\t\t\t   <p><b>Une ville ancienne, riche de sites arch\xE9ologiques fascinants, d'une culture moderne et du charme du Moyen-Orient</b><strong>&#8203;</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Nazareth, ou Natsrat tel que prononc\xE9 en h\xE9breu, est le berceau du christianisme. C'est la ville o\xF9, selon la tradition, l'ange Gabriel annon\xE7a \xE0 Marie qu'elle concevrait par la puissance du Saint-Esprit, et l'endroit o\xF9 J\xE9sus passa son enfance et sa jeunesse. Situ\xE9e en basse Galil\xE9e, Nazareth est blottie au c\u0153ur d'une vall\xE9e entour\xE9e de montagnes et abrite plusieurs lieux saints chr\xE9tiens parmi les plus importants. C'est une ville de religion et de foi, de spiritualit\xE9 et de saintet\xE9, mais \xE9galement une ville qui a une histoire riche, des vestiges arch\xE9ologiques fascinants, une culture moderne et un charme moyen-oriental.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Le berceau du christianisme</strong></p>\n\t\t\t\t\t\t\t\t\t<p>\xC0 sa naissance il y 2000 ans, Nazareth n\u2019\xE9tait qu'un petit village juif. Quelques centaines d'ann\xE9es plus tard, au cours de la p\xE9riode byzantine, elle devint une place forte du christianisme. Durant cette p\xE9riode, le nom de Nazareth se r\xE9pandit au loin, et le d\xE9sir de d\xE9couvrir le lieu o\xF9 v\xE9curent la Vierge Marie et J\xE9sus firent de la ville un site de p\xE8lerinage tr\xE8s fr\xE9quent\xE9. Ces visites conduisirent \xE0 la construction de la premi\xE8re \xE9glise de la ville, la basilique de l'Annonciation, \xE0 l'endroit o\xF9 la tradition situe la maison de Joseph et Marie. De nombreuses autres \xE9glises ont \xE9t\xE9 construites dans la ville, pour \xEAtre d\xE9truites et reconstruites au fil des si\xE8cles, sous la domination successive des musulmans et des chr\xE9tiens. Au 19\xE8me si\xE8cle, Nazareth suscita un nouvel engouement : des chr\xE9tiens revinrent y vivre et reb\xE2tirent des \xE9glises et des monast\xE8res. Aujourd'hui, Nazareth est la plus grande ville arabe d'Isra\xEBl. Elle compte environ 30 \xE9glises et monast\xE8res, ainsi que des mosqu\xE9es et d'anciennes synagogues.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Un avant-go\xFBt de la vieille ville </strong></p>\n\t\t\t\t\t\t\t\t\t<p>La visite de Nazareth nous fait revivre plusieurs \xE9poques. Chacune d'entre elles a laiss\xE9 derri\xE8re elle un symbole puissant qui, \xE0 l'\xE9poque moderne, est devenu un site touristique de premier ordre. La plupart des sites se trouvent dans la vieille ville, qui fut construite au milieu du 19<sup>\xE8me</sup> si\xE8cle dans un style architectural qui lui conf\xE8re un charme moyen-oriental. Rien ne vaut une balade dans ses ruelles \xE9troites bord\xE9es de maisons pittoresques. Ne vous pressez pas, il faut marcher lentement pour appr\xE9cier pleinement leur beaut\xE9.</p>\n\t\t\t\t\t\t\t\t\t<p>La vieille ville rec\xE8le un grand nombre d'\xE9glises anciennes, la basilique de l'Annonciation \xE9tant la premi\xE8re d'entre elles. L'\xE9glise reb\xE2tie a conserv\xE9 des \xE9l\xE9ments des \xE9glises pr\xE9c\xE9dentes, datant de la p\xE9riode byzantine et des croisades. Elle abrite \xE9galement une impressionnante collection de peintures.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/nazareth/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t\t<p>\xC0 deux pas de la basilique se trouve l'\xC9glise Saint-Joseph, b\xE2tie sur les ruines de b\xE2timents agricoles o\xF9, selon la tradition, Joseph, l'\xE9poux de Marie, avait son atelier de charpentier. Alors que la basilique de l'Annonciation a \xE9t\xE9 construite sur le site de la maison de Marie, l'\xC9glise grecque orthodoxe de l'Annonciation est construite \xE0 l'emplacement de la source du Puits de Marie, dont il est dit que la m\xE8re de J\xE9sus a bu l'eau. Cette construction datant des croisades abrite des fresques int\xE9ressantes. <strong>Tout pr\xE8s du Puits de Marie se trouve l'\xC9glise orthodoxe grecque de l'Annonciation</strong>, dans une construction datant des crois\xE9s. Selon la tradition, ici se trouvait la synagogue dans laquelle allait prier J\xE9sus.</p>\n\t\t\t\t\t\t\t\t\t<p>Parmi les nombreuses autres \xE9glises de Nazareth, on compte l'\xC9glise de la Mensa Christi, l'\xC9glise maronite, l'\xC9glise Saint-Gabriel et l'\xC9glise sal\xE9sienne. La vieille ville compte \xE9galement d'importants b\xE2timents de la p\xE9riode ottomane, dont le Saraya, ou palais du gouvernement, construit par Daher el Omar, gouverneur de la Galil\xE9e au 18\xE8me si\xE8cle, et la Mosqu\xE9e blanche, aujourd'hui utilis\xE9e comme maison de pri\xE8re et centre culturel. La Mosqu\xE9e blanche abrite \xE9galement un mus\xE9e dont les collections documentent l'histoire de Nazareth.</p>\n\t\t\t\t\t\t\t\t\t<p>Aucune visite de la vieille ville de Nazareth ne serait compl\xE8te sans une visite du march\xE9 local, qui est devenu une attraction appr\xE9ci\xE9e et bien connue gr\xE2ce \xE0 ses \xE9ventaires color\xE9s et \xE0 la vari\xE9t\xE9 de ses marchandises. Vous pourrez y admirer le festin visuel des \xE9toffes, go\xFBter aux \xE9pices et aliments locaux, et acqu\xE9rir des objets artisanaux et des souvenirs. Tous ces sons, spectacles, odeurs et saveurs vous feront vivre une exp\xE9rience authentiquement moyen-orientale.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Un aper\xE7u du charme du Moyen-Orient</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Nazareth regorge d'endroits fascinants et charmants qui ne pourront que vous s\xE9duire. La promenade qui longe la cha\xEEne de montagnes Nabi Sain est un autre lieu \xE0 ne pas manquer. Cette balade \xE0 pied vous fera d\xE9couvrir une vue magnifique sur la Galil\xE9e. Vous pouvez visiter les anciens bains turcs d\xE9couverts pendant la r\xE9novation de l'un des magasins de la ville, et d\xE9couvrir un \xE9l\xE9gant manoir qui vous d\xE9voilera la riche existence et les coutumes de la haute soci\xE9t\xE9 ottomane au 19<sup>\xE8me</sup> si\xE8cle, ainsi que ses fresques magnifiques. La maison de l'\xE9v\xEAque grec orthodoxe vaut \xE9galement le d\xE9tour. Vous pourrez y parcourir un r\xE9seau de passages souterrains qui ont \xE9t\xE9 d\xE9couverts dans la cour. Un autre site int\xE9ressant est le complexe construit par les Russes, destin\xE9 \xE0 servir d'auberge pour les p\xE8lerins.</p>\n\t\t\t\t\t\t\t\t\t<p>Nazareth accueille des p\xE8lerins depuis des si\xE8cles. Ses auberges chr\xE9tiennes et ses h\xF4tels de luxe assureront le confort des nombreux touristes visitant la ville, en particulier pendant la p\xE9riode de No\xEBl. La gastronomie n'est pas en reste, avec des dizaines de restaurants \xE9laborant une cuisine savoureuse dont les merveilleux ar\xF4mes attirent les visiteurs tout au long de l'ann\xE9e. C'est \xE0 No\xEBl que Nazareth appara\xEEt dans toute sa gloire, lorsque la ville est d\xE9cor\xE9e et que ses couleurs et sa ferveur s'unissent \xE0 l'atmosph\xE8re sainte et \xE0 l'\xE9cho des pri\xE8res provenant des \xE9glises de la ville.</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  \t\t\t\t\t\t\t   \n\t\t                        "};}},{id:"Nazareth_1",ctg:"north",bgImage:"/posts/bank/north3/1.jpg",mobBgImage:"/posts/bank/north3/M.jpg",isVid:true,vidId:"1M7N5BcmjFM",title:"NAZARETH : UN JOYAU AUX MULTIPLES FACETTES",smltitle:"",html:function html(){return{__html:" \n\n\t\t\t\t\t\t        \n                                    <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Un c\u0153ur sacr\xE9 antique aux fascinants accents de modernit\xE9</h2>\n\t\t\t\t\t\t\t\t    <p>Connue dans le monde entier comme la ville o\xF9 J\xE9sus a grandi, Nazareth est une destination cl\xE9 pour les p\xE8lerins chr\xE9tiens et constitue un v\xE9ritable joyau n'attendant qu'\xE0 \xEAtre d\xE9voil\xE9. Les papes Jean-Paul II et Beno\xEEt XVI n'ont pas manqu\xE9 de faire figurer la ville dans leur programme de visite dans la r\xE9gion, comme le font les dizaines de milliers de touristes qui se rendent \xE0 Nazareth chaque ann\xE9e.</p>\n\t\t\t\t\t\t\t\t\t<p>Une kyrielle de sites religieux sains, un riche pass\xE9, des march\xE9s color\xE9s, une sc\xE8ne gastronomique particuli\xE8rement active, une hospitalit\xE9 exceptionnelle, et d'innombrables attractions touristiques ne sont que quelques raisons pour lesquelles aucune visite en Isra\xEBl ne saurait \xEAtre compl\xE8te sans un d\xE9tour par Nazareth.</p>\n\t\t\t\t\t\t\t\t\t<p>Laissez-vous s\xE9duire par cette ville multiculturelle fascinante et passionnante, et d\xE9couvrez ses multiples visages. Vous ne pourrez qu'en tomber amoureux.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Marchez dans les pas de J\xE9sus de Nazareth</strong></p>\n\t\t\t\t\t\t\t\t\t<p>D\xE9couvrez le berceau du christianisme et impr\xE9gnez-vous de l'atmosph\xE8re spirituelle unique de la ville. Marchez sur les traces de J\xE9sus, qui y a pass\xE9 son enfance et sa jeunesse entour\xE9 de sa famille.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/nazareth/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<p>Visitez la superbe <strong>basilique de l'Annonciation</strong> qui, selon la croyance chr\xE9tienne, a \xE9t\xE9 construite \xE0 l'endroit m\xEAme o\xF9 l'ange Gabriel a annonc\xE9 \xE0 la Vierge Marie qu'elle \xE9tait enceinte de J\xE9sus. Contemplez la charmante <strong>\xE9glise Saint Gabriel</strong> et traversez le <strong>Puit de Marie</strong> dont les eaux, dit-on, poss\xE8dent des vertus curatives. Ne manquez pas l'<strong>\xE9glise de la synagogue, </strong>qui aurait \xE9t\xE9 b\xE2tie sur les ruines de l'ancienne synagogue de J\xE9sus.</p>\n\t\t\t\t\t\t\t\t\t<p>Poursuivez votre exploration et d\xE9couvrez les nombreux sites touristiques de la ville. Visitez le <strong>Village de Nazareth Village</strong> et le <strong>centre international \xAB&nbsp;Marie de Nazareth&nbsp;\xBB</strong>, o\xF9 vous verrez l'histoire prendre litt\xE9ralement vie. Gravissez le <strong>Mont du Pr\xE9cipice</strong> o\xF9, selon la tradition, le peuple de Nazareth a tent\xE9 de jeter J\xE9sus de la falaise. Impr\xE9gnez-vous del \u2018\xE9nergie spirituelle du lieu et profitez de la vue panoramique exceptionnelle.</p>\n\t\t\t\t\t\t\t\t\t<p>Un conseil&nbsp;: il y a tant \xE0 faire et \xE0 voir, pourquoi ne pas participer \xE0 une visite guid\xE9e&nbsp;? Rien de mieux pour d\xE9couvrir un lieu que de le voir \xE0 travers les yeux d'une personne qui y habite.</p>\n\n\t\t\t\t\t\t\t\t\t<p><strong>D\xE9couvrez les nombreux centres d'int\xE9r\xEAt de Nazareth ainsi que son hospitalit\xE9 renomm\xE9e</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Pas de doute, la plus grande ville arabe d'Isra\xEBl a fait son chemin depuis l'\xE9poque romaine o\xF9 elle n'\xE9tait encore qu'un petit village. Aujourd'hui, c'est une ville cosmopolite moderne et anim\xE9e qui jouit d'une vie culturelle riche, d'une sc\xE8ne gastronomique bouillonnante et d'une grande hospitalit\xE9.</p>\n\t\t\t\t\t\t\t\t\t<p>Embarquez-vous dans une aventure urbaine. D\xE9ambulez dans les all\xE9es pav\xE9es des march\xE9s anim\xE9s et impr\xE9gnez-vous des odeurs, des saveurs et des sons. Installez-vous dans un caf\xE9 et vivez une exp\xE9rience culturelle et culinaire authentique et de qualit\xE9. Musique et conversations passionnantes sont inscrites au menu. Attablez-vous dans les restaurants locaux et d\xE9gustez certains des plats les plus cr\xE9atifs et les plus savoureux que vous n\u2019ayez jamais mang\xE9s. Notre conseil&nbsp;: ne faites pas l'impasse sur le dessert.</p>\n\t\t\t\t\t\t\t\t\t<p>Explorez aussi l'architecture et les mus\xE9es de la ville, sans oublier la fabrique de \xAB&nbsp;halva&nbsp;\xBB. S\xE9journez dans un des nombreux h\xF4tels, pensions, auberges et lieux d'h\xE9bergement divers. Au loin, \xE9coutez les cloches retentir en parfaite harmonie chaque jour \xE0 midi en m\xE9moire de l'annonciation. \xC0 Nazareth, la vie prend tout son sens.</p>\n\t\t\t\t\t\t\t\t\t<p><span>photo credit: &nbsp;Dafna Tal, Mordagan</span></p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  \t\t\t\t\t\t\t   \n\t\t                        "};}},// {
// 		id:"Cheers_To_Israel",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"Cxii1yKqKwI",
//         title : "GREAT WITH WHITE OR RED",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `  <p>Over the past decade, Israeli wine-making has become a vital and thriving industry.</p>
//                                  <p>The fertile land of the area has been recognized worldwide as an excellent setting for burgeoning vineyards, and the local scene is trendy and opulent.</p>
//                                  <p>In the north, the general atmosphere reminiscent of French or Italian wine regions while the south&nbsp;has become renowned for its burgeoning&nbsp;wine scene, thanks to pioneering farmers and their use of computerized drip irrigation.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/cheers-to-israel/1.jpg"} class="img-responsive">
// 						   </div>
// 						    <p><span style="font-family: arial,sans-serif;">The Israeli wine scene allows visitors a fantastic experience combining delectable wine tastings with the stunning vistas and energy this has to offer.</span></p>
// 						   <p>So come get a taste of Israel’s wine country through its many fantastic tours of the vineyards and boutique wineries, the fantastic wine and music festivals and year-round wine-themed events.</p>
// 						   <p>FYI, a visit to Israel goes great with white or red.</p>
//                         `
//     }
//   }
// },
{id:"A_Galilean_Treat",ctg:"culinarynorth",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"kF808ENuuTQ",title:"DES VACANCES GASTRONOMIQUES EN GALILÉE",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t          <br/>\n\t\t\t\t\t\t          <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Un paradis pour les gourmets</h2>                          \n                                  \n\t\t\t\t\t\t\t\t   <p>Une visite en Galil\xE9e vous permettra de d\xE9couvrir des saveurs et parfums que vous n'avez encore jamais rencontr\xE9s. Fromages r\xE9gionaux fabriqu\xE9s dans des fromageries artisanales, vins de classe mondiales \xE0 d\xE9couvrir dans les domaines viticoles, restaurants familiaux raffin\xE9s servant des fruits et l\xE9gumes fra\xEEchement cueillis et riches en saveurs&nbsp;: la Galil\xE9e est vraiment le paradis des gourmets.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>Une r\xE9gion o\xF9 lait et vin coulent \xE0 flot</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Visitez une fromagerie artisanale, d\xE9couvrez la diversit\xE9 des fromages de Galil\xE9e et assistez \xE0 leur fabrication. Laissez-vous guider par un fromager exp\xE9riment\xE9 qui vous fera d\xE9guster un assortiment de fromages uniques de la r\xE9gion, \xE0 p\xE2te molle, ferme et semi-ferme. Vous go\xFBterez au <em>laban\xE9,</em> un fromage doux et cr\xE9meux \xE0 base de lait de brebis ou de ch\xE8vre, \xE0 la texture similaire \xE0 celle du yoghourt, et souvent vendu m\xE9lang\xE9 \xE0 des herbes locales, comme c'est le cas du za\u2019atar, ou du <em>zefatit</em>, un fromage sal\xE9 \xE0 base de lait caill\xE9 de brebis moul\xE9 dans un panier et portant le nom de la r\xE9gion de <em>Zefat</em>, ou Safed, d'o\xF9 il est originaire.</p>\n\t\t\t\t\t\t\t\t\t<p>Si vous aimez boire du vin pour accompagner votre fromage, vous ne serez pas d\xE9\xE7u. Chaque vin est meilleur que le pr\xE9c\xE9dent&nbsp;! La r\xE9volution qu'a connue r\xE9cemment la fabrication du vin a entra\xEEn\xE9 la multiplication des caves viticoles sur l'ensemble du terroir extr\xEAmement vari\xE9 de Galil\xE9e, chaque vignoble produisant un c\xE9page \xE0 la saveur unique due au sol sur lequel il a pouss\xE9. Caressez du regard les plaines tapiss\xE9es de vignes pendant que vous savourez un vin rouge fruit\xE9 et profond ou un vin blanc frais que vous auront conseill\xE9s de grands viticulteurs isra\xE9liens. D\xE9couvrez les combinaisons de c\xE9pages qui ont servi \xE0 produire des vins prim\xE9s lors de foires aux vins internationales - et commercialis\xE9s seulement en Isra\xEBl pour un grand nombre.</p>\n                                    <div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/galilean-treat/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<p><strong>Go\xFBtez la r\xE9colte</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Visitez des vergers dans lesquels vous pouvez ramasser vos propres fruits, et d\xE9gustez des baies, pommes, cerises, p\xEAches, prunes et m\xEAme des figues de barbarie charnues, juteuses et d\xE9bordantes de saveur. Faites halte dans les fermes d'\xE9pices pour humer et go\xFBter un choix sans cesse renouvel\xE9 d'herbes et d'\xE9pices. Vous en reconna\xEEtrez certaines, mais vous en d\xE9couvrirez que vous n'avez jamais rencontr\xE9es. D\xE9couvrez les parfums de la Galil\xE9e et cr\xE9ez vos propres infusions et m\xE9langes d'\xE9pices.</p>\n\t\t\t\t\t\t\t\t\t<p>Une autre r\xE9colte importante vous attend en Galil\xE9e&nbsp;: celle de l'olive. Si vous pensiez que toutes les huiles d'olive ont le m\xEAme go\xFBt, une visite dans une fabrique familiale d'huile d'olive de la r\xE9gion vous fera changer d'avis. Go\xFBtez diff\xE9rentes huiles d'olive pour d\xE9couvrir ce qui les diff\xE9rencie et passez un bon moment en participant \xE0 la r\xE9colte des olives et \xE0 leur pressage \xE0 l'ancienne. Vous fabriquerez ainsi votre propre huile d'olive extra-vierge.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>March\xE9s et restaurants</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Les villes anciennes de Galil\xE9e proposent de nombreux march\xE9s sur lesquels vous pourrez acheter les meilleurs produits locaux et artisanaux, souvent vendus par les personnes qui les ont fabriqu\xE9s. Fl\xE2nez sur les march\xE9s pour go\xFBter aux d\xE9lices qui vous attendent au d\xE9tour de chaque all\xE9e, ou suivez un guide sp\xE9cialis\xE9 qui vous conduira aux meilleurs \xE9tals et aux mets les plus fins.</p>\n\t\t\t\t\t\t\t\t\t<p>En vous laissant guider par vos papilles, vous d\xE9couvrirez en Galil\xE9e des restaurants de grande qualit\xE9 dans les lieux les plus improbables. La meilleure cuisine du pays est parfois servie dans des restaurants sans pr\xE9tention offrant un panorama magnifique. Un grand nombre d'entre eux sont g\xE9r\xE9s en famille et servent des plats \xE9labor\xE9s avec amour \xE0 partir d'ingr\xE9dients cultiv\xE9s ou produits \xE0 seulement quelques kilom\xE8tres de l\xE0. Mais pour apprendre \xE0 vraiment conna\xEEtre les produits fabriqu\xE9s en Galil\xE9e, vous devrez participer \xE0 un atelier cuisine. Ils sont anim\xE9s par des chefs locaux qui connaissent le terroir sur le bout des doigts et qui ne demandent qu'\xE0 partager leurs secrets concernant le choix, la pr\xE9paration et la d\xE9gustation des produits locaux les plus savoureux. Souvent, vous irez choisir vos ingr\xE9dients avant de les cuisiner puis vous confectionnerez les plats les plus d\xE9lectables que vous n\u2019aurez jamais pr\xE9par\xE9s.</p>\n\t\t\t\t\t\t\t\t\t<p><strong>L'exp\xE9rience unique de la Galil\xE9e</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Or, la Galil\xE9e ne se limite pas \xE0 ses d\xE9licieuses saveurs. Visitez des forteresses en ruine et des sites bibliques dans lesquels J\xE9sus a pr\xEAch\xE9 et o\xF9 des batailles ont \xE9t\xE9 livr\xE9es. Passez les vacances de vos r\xEAves en Galil\xE9e, en gravissant des montagnes, en vous lan\xE7ant dans des descentes en eaux vives ou en vous promenant le long de ruisseaux...</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t  \t\t   \n\t\t                        "};}},{id:"Galilee_Action",ctg:"north",bgImage:"/posts/bank/north2/1.jpg",mobBgImage:"/posts/bank/north2/M.jpg",isVid:true,vidId:"5Ep3GgxELag",title:"BOUGEZ EN GALILÉE",smltitle:"",html:function html(){return{__html:" \n\n\n\t\t\t\t\t\t           \n\n\t\t\t\t\t\t\t\t    <br/>\n\t\t\t\t\t\t\t\t    <h2 class=\"ac-align-center ac-margin-bottom-20 ac-margin-top-20\">Des activit\xE9s inattendues en Galil\xE9e</h2>\n\t\t\t\t\t\t\t\t    <p>En Galil\xE9e, les occasions de se divertir sont nombreuses pour les aventuriers de tous \xE2ges&nbsp;: sur les rivi\xE8res, sur les lacs ou en bord de mer. Les amateurs de frissons pourront sentir les embruns sur leurs visages lorsqu'ils d\xE9fieront leurs amis dans une course de kayak en eau vive, tandis que familles et couples pourront se d\xE9tendre en voyant d\xE9filer doucement les rivages verdoyants d'une des nombreuses rivi\xE8res de Galil\xE9e. Vous pouvez vous rafra\xEEchir en participant \xE0 une des nombreuses activit\xE9s nautiques propos\xE9es sur le lac de Tib\xE9riade, comme le ski nautique, la banane tract\xE9e ou le kite surf. Les touristes adorent se faire dorer sur les plages de sable qui longent la c\xF4te ou visiter les grottes de Rosh Hanikra, d'une beaut\xE9 presque surnaturelle.</p>\n\t\t\t\t\t\t\t\t\t<p>Vous pourrez pratiquer des sports extr\xEAmes aussi bien sur terre, que dans l'air ou dans l'eau. Les plus sportifs pourront faire monter l'adr\xE9naline en s'essayant \xE0 des activit\xE9s comme le parachutisme, la randonn\xE9e en jeep sur les pistes montagneuses abruptes ou la descente de falaises en rappel. En hiver, profitez de la neige sur le mont Hermon, en pratiquant le ski ou le snowboard sur des pistes de tous niveaux.</p>\n\n\t\t\t\t\t\t\t\t\t<h2>La Galil\xE9e&nbsp;: une nature g\xE9n\xE9reuse d'une beaut\xE9 saisissante</h2>\n\t\t\t\t\t\t\t\t\t<p>La Galil\xE9e regorge de splendides paysages naturels dans lesquels familles, amoureux et groupes d'amis peuvent se promener, observer la vie sauvage ou tout simplement pique-niquer dans un cadre paisible. Que vous partiez \xE0 cheval sur des sentiers retir\xE9s ou empruntiez des pistes soigneusement balis\xE9es \xE0 pied ou \xE0 v\xE9lo&nbsp;: beaut\xE9, plaisir et divertissement seront au rendez-vous. Si vous avez envie de calme, partez \xE0 la rencontre de la nature en observant les oiseaux et la vie sauvage dans la r\xE9serve naturelle de la vall\xE9e de la Houla, ou admirez la magie de la mosa\xEFque de for\xEAts, champs et rivi\xE8res qui s'\xE9tale sous vos yeux lorsque vous vous \xE9levez dans les airs en montgolfi\xE8re depuis le mont Guilboa. Pour ne rien oublier, laissez-vous gagner par la spiritualit\xE9 en visitant des sites saints chr\xE9tiens, juifs et baha\xEF.</p>\n\t\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/galilee-action/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t    </div>\n\t\t\t\t\t\t\t\t\t<p>Les nombreux chemins de randonn\xE9e de Galil\xE9e attirent les promeneurs de tous \xE2ges, tout au long de l'ann\xE9e. Si vous pr\xE9f\xE9rez les promenades ombrag\xE9es le long des ruisseaux, l'escalade et la descente en rappel, ou le plaisir simple d'un splendide panorama au terme d'une mont\xE9e difficile, vous trouverez la piste qui r\xE9pondra \xE0 vos attentes. En Galil\xE9e, tout est possible.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t   \n\t\t\t\t\t\t\t\t   \n\t\t                        "};}},// {
// 		id:"Bet_Shean",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "BET SHE’AN",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `  <p>South of the Sea of Galilee are the remains of one of the largest cities in the Roman-Byzantine Empire, Bet She’an. One of ten ancient cities (hence “Decapolis”) that included Philadelphia (present day Amman in Jordan) and Jerash, Scythopolis ((Bet She’an) was the only decapolis city west of the Jordan river.  It was very grand, with a giant theater, streets of tall columns, shops, bathhouses a hippodrome and hundreds of homes.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/bet-shean/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>However, the splendid city was toppled in 749 by a massive earthquake, and never rebuilt. Over the centuries the ruins were overgrown – and it was not until the mid-20th century that Israeli archeologists pulled Bet She’an out of the murk, discovering (and restoring) the theater, the Cardo, the columns and much more.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"Zichron_Yaakov",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "ZICHRON YA’AKOV",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: ` <p>Zichron Ya’akov is a wonderful town for tourists, both local and foreign. This picturesque moshava semi-cooperative farming community built at the tip of the Carmel mountain range is the first moshava ever built in Israel and is a main tourism and vacation site in this region.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/zichron-yaakov/1.jpg"} class="img-responsive">
// 						   </div>
// 						    <p>Anyone who visits&nbsp;<strong>Zichron&nbsp;Ya’akov&nbsp;</strong>goes straight to Ha-Nadiv Street, and Ha-Meyasdim Street in the town center, which has become a very popular pedestrian mall, thanks to the special atmosphere in this place. The streets are paved with stones and pass between the moshava’s original houses (some of which have been reconstructed), which are bustling with activity.</p>
// 						   <p>There are many quaint and charming restaurants and coffee shops, interspersed between beautifully designed stores that sell local art works and lovely souvenirs. There are art galleries, unique artists' studios and workshops. New, modern buildings stand alongside old ones, such as the synagogue and the administration building, an old courtyard with a display of antique agricultural implements.</p>
// 						   <p>From its early days,&nbsp;<strong>Zichron Ya’akov</strong>&nbsp;had two main characteristics: wine and tranquility. The moshava’s founding farmers cultivated vineyards and the large winery built here in 1889 became the area’s most important industry. During the British Mandate period (1917-1948), the moshava became a holiday resort and rural vacations site, and to this day has hotels, spas and guesthouses.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"Discover_The_Wine_Routes",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:true,
//        	vidId:"Cxii1yKqKwI",
//         title : "DISCOVER THE WINE ROUTES",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `  <p>Discover a different Israel through it's wineries and vineyards, through the passion of the people who are crafting award winning wines from home grown grapes.</p>
//                                  <p>Enjoy vintage wines, gourmet foods, and gorgeous scenery. Spend time experiencing Israel as you never have before, as a Wine Connoisseur! The beauty of these routes in Israel is of course the authentic wine but also the incredible landscapes that surround the wineries. Many of the wineries are situated near ‘Zimmers’ which are little spa complexes that are dotted around northern Israel. They have little cabins with Jacuzzis that face out to the magnificent views of the rolling green hills. You can relax in your personal cabin with a splendid glass of wine from the local winery.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/discover-the-wine-routes/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <div class="wpb_wrapper"><p>The Middle East &amp; Eastern Mediterranean was the cradle of wine production, and the ancient land of Canaan is in fact one of the earliest countries to cultivate wine over 2,000 years before the vine came to Europe.</p><p>There are currently over 25 commercial wineries and over 150 boutique wineries in Israel where wine making has become a personal obsession with wine makers striving to produce world class wines.</p><p>Israel like other 'long' countries such as Chile or Italy enjoys a variety of microclimates. While the northern region gets much rain and even snow in the winter, just a few hours away Israel's southern region is very arid with desert conditions. This range in microclimates supports many grape varieties, which can grow on several different types of soil, yielding excellent results.</p><p>As always in matters of taste, you must visit Israel’s wineries and vineyards and decide for yourself which is your favourite!</p><p></p></div>
//                         `
//     }
//   }
// },
{id:"Birdtastic_Hula_Lake",ctg:"north",bgImage:"/posts/bank/north1/1.jpg",mobBgImage:"/posts/bank/north1/M.jpg",isVid:true,vidId:"ImobrsxsKl8",title:"LAC DE LA HOULA",smltitle:"",html:function html(){return{__html:"  \n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t<h2 class=\"ac-align-center ac-margin-top-20\">La Nature Dans Toute Sa Splendeur</h2>\n\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t   \n\n\t\t\t\t\t\t\t\t   <p  class=\"ac-align-center ac-margin-bottom-20\"><strong>D\xE9couvrez l\u2019un des principaux sites ornithologiques au monde</strong></p>\n\t\t\t\t\t\t\t\t\t<p>Au c\u0153ur de la tr\xE8s pittoresque Vall\xE9e de la Houla, en Haute Galil\xE9e, \xE0 seulement deux heures de route du nord \xE0 Tel Aviv, se trouve le Lac de la Houla, un lieu d'une extraordinaire beaut\xE9 entre deux cha\xEEnes montagneuses. Cette r\xE9serve mar\xE9cageuse \xE9cologique de renomm\xE9e internationale est \xE9galement l\u2019un des plus importants sites ornithologiques au monde, v\xE9ritable oasis pour les oiseaux et les amoureux de la nature. Gr\xE2ce \xE0 l'opportunit\xE9 unique qui vous est offerte de profiter d'une nature sans barri\xE8res ni limites, vous vivrez une exp\xE9rience unique.</p>\n\t\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p><strong>Suivez les oiseaux et les merveilles de la nature&nbsp;&nbsp; </strong></p>\n\t\t\t\t\t\t\t\t<p>\xC0 chaque saison de migration (printemps et automne), plus de 500 millions d'oiseaux et pr\xE8s de 400 esp\xE8ces passent au-dessus du Lac de la Houla. Ce paradis mar\xE9cageux est la halte parfaite pour les sauvagines, cormorans, h\xE9rons, p\xE9licans, rapaces, cigognes et grues.</p>\n\t\t\t\t\t\t\t\t<p>Class\xE9 par la BBC Wildlife parmi les dix principaux sites ornithologiques mondiaux, le Lac de la Houla (Agamon Hula en h\xE9breu), attire des ornithologues de toutes nationalit\xE9s. Participez au festival international des oiseaux de Houla, organis\xE9 chaque ann\xE9e \xE0 l'automne, et vivez une exp\xE9rience inoubliable.&nbsp;</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/birdtastic-hula-lake/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t<p>Pour profiter pleinement du festival, plusieurs possibilit\xE9s s'offrent \xE0 vous. \xC0 vous de choisir l'aventure que vous souhaitez vivre.</p>\n\t\t\t\t\t\t\t\t<p><strong>Parcourez les chemins</strong>. Aventurez-vous sur les chemins du parc naturel. \xC0 pied, \xE0 v\xE9lo ou en voiturette \xE9lectrique, c'est vous qui choisissez. Entre les vergers, vous traverserez des canaux et aurez un aper\xE7u de la vie sauvage dans les mar\xE9cages.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p><strong>Partez en tracteur. </strong>Inscrivez-vous \xE0 une visite guid\xE9e \"Safari Wagon\", en tracteur, pour vous enfoncer encore plus dans le lac Agamon. Dissimul\xE9 dans la remorque du tracteur, vous pourrez approcher ces magnifiques oiseaux au plus pr\xE8s.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p><strong>Au lever du soleil ou de nuit.</strong> Pour les plus aventureux, deux visites sp\xE9ciales sont propos\xE9es. La premi\xE8re (\"Sunrise Tour\"), a lieu au lever du soleil, et permet d'observer et photographier les oiseaux dans les meilleures conditions. La seconde (\"Night Owl Tour\") offre une autre perspective de la r\xE9serve. Pr\xE8s d'un feu de camp et sous les \xE9toiles, vous observerez les chats sauvages, rapaces nocturnes et roussettes.&nbsp;</p>\n\t\t\t\t\t\t\t\t<p><strong>Vivez une exp\xE9rience enrichissante et observez les op\xE9rations men\xE9es pour pr\xE9server la nature&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </strong></p>\n\t\t\t\t\t\t\t\t<p><em>Agamon</em> Hula est reconnu dans le monde entier comme un syst\xE8me \xE9cologique durable qui trouve le juste \xE9quilibre entre nature, tourisme et agriculture.</p>\n\t\t\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/birdtastic-hula-lake/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t\t\t\t   </div>\n\t\t\t\t\t\t\t\t<p>Visitez le centre de baguage du parc et observez ce qui est fait pour prot\xE9ger la nature. Participez \xE0 la visite \"bird Island tour\" et vous aurez peut-\xEAtre la chance d'aider \xE0 rel\xE2cher un oiseau dans son milieu naturel. On ne fait pas mieux !</p>\n\t\t\t\t\t\t\t\t<p>Gr\xE2ce \xE0 ses innombrables esp\xE8ces animales et au travail accompli pour prot\xE9ger la nature de mani\xE8re originale, le Lac de Houla offre bien plus qu'une promenade sympathique dans cadre magnifique : c'est une exp\xE9rience dont vous sortirez enrichi, le c\u0153ur et l'esprit plus ouverts.&nbsp;</p>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t                        \n\t\t                        "};}},// {
// 		id:"The_Kibbutz_Experience",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "THE INCOMPARABLE KIBBUTZ EXPERIENCE",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 				           <p>Predominantly based amongst beautiful landscape settings dotted around the country the Kibbutz life is a modern day phenomenon and a totally unique way of living. The movement which started in 1905 is a collective community way of living traditionally based on agriculture. Each kibbutz would sell its own produce.  The people living on them would all collectively work together to preserve it and work the land.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/kibbutz-experience/1.jpg"} class="img-responsive">
// 						   </div>
// 						    <p>The word ‘Kibbutz’ in Hebrew means group.&nbsp;The point being it is a voluntary democratic community where people live and work together to generate economically. It is founded on the principles of communal ownership of property and social equality.</p>
//                                  <p>Some would describe the beautiful settings and a life of equality a utopia and why not experience it for yourself?&nbsp; Many of the Kibbutzim are open to visitors whether you would like to stay a few hours or a few months learning what this life is all about.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"National_Parks",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "NATIONAL PARKS",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 				          <p>Despite Israel being small its scenery varies immensely! You will find new cities and old, beaches and lakes, deserts and green mountains. Israel’s National parks and nature reserves make all this possible for you to experience the wondrous landscapes.</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/national-parks/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>In the south of the country you will find the expanse of the golden and orange plains of the desert. The Negev, Arava and Eilat are the fiery beautiful landscapes of the south that home the Dead Sea, Mitzpe Ramon and the beautiful desert oasis of En gedi not mention some wonderful hiking and cycling trails. When the sun sets the south turns in to a red illuminous sea of magic and when dark the sky turns in to a blanket of sparkles as the vast scenery makes it possible to see every star.</p>
//                                  <p>In the North of the country you are welcomed with Luscious green hills and mountains including the snow-capped Mount Hermon.&nbsp; The Golan Heights home to magnificent mountainous scenery and an array of cultures.&nbsp; There are endless forest trails and water fall hikes for all the family to enjoy. The view from the mountain tops is breath taking as your eyes take you all the way out to the Mediterranean. Below the mountains you will find the green slopes of the Galilee home to the famous Kinneret, wineries and some wonderful relaxation spa’s. It really is a wonderland.</p>
// 						   <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/national-parks/2.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>The national parks offer exciting cultural and natural adventures. You have the opportunity to visit magnificent historical sites and follow wonderful nature trails while searching for some of the countries species i.e. The desert ibex and leopards, Eagles in the Golan. The impressive diversity of natural wonders, encounters with unspoiled nature and with plants.</p>
//                         `
//     }
//   }
// },
// {
// 		id:"Tiberias",
//        	ctg : "north",
//         bgImage : "/HomeSlider/desktop/4.jpg",
//         mobBgImage : "/HomeSlider/M/3.jpg",
//        	isVid:false,
//         title : "TIBERIAS (TVERYA)",
//         smltitle : "",
//         html: function(){
// 			return {
// 				__html: `
// 				           <p>Located at the shores of the Sea of Galilee, Tiberias, the capital of the Galilee, was established in the early Roman period and has served as a religious, administrative and culture center of the Jewish people for many years.</p>
//                                 <p>In addition to its rich history and significance, modern day Tiberias is synonymous with holiday in Israel. Here one can enjoy a variety of activities the city has to offer, and experience a wonderful mix of relaxation, nature and history, along with contemporary attractions, active water sports, pilgrimage sites and unique tourist attractions</p>
//                                 <div class="img-wrapper">
// 							   <img src=${getImgUrl()+ "/posts/tiberias/1.jpg"} class="img-responsive">
// 						   </div>
// 						   <p>A visit to Tiberias is not complete without a visit to its surrounding area, which features many must-see sights, including The city Bet Shean, one of the oldest cities in the world, and one of the country’s largest archaeological sites; Magdala (Migdal) the ancient town on the Sea of Galilee which was home to many of Jesus’s disciples and is said to have been the home of Mary Magdalene; Megiddo, a beautiful and impressive national park and one of the most important archeological sites in Israel from the time of the Bible. Once an ancient city of critical strategic importance, Megiddo is a UNESCO World Heritage Site, and an inspiring location for lovers of history and archeology.</p>
//                         `
//     }
//   }
// },
{id:"Privacy_Policy",ctg:"telaviv",bgImage:"/HomeSlider/desktop/1.jpg",mobBgImage:"/HomeSlider/M/3.jpg",isVid:false,title:"PRIVACY POLICY",smltitle:"",html:function html(){return{__html:"\n\n\n\t\t\t\t\t\t\t<p><u><span>Last updated</span></u><span>: March 4, 2020</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3><span>OUR COMMITMENT TO YOU</span><span>&nbsp;</span></h3>\n\t\t\t\t\t\t\t<p>We, at&nbsp;The Israeli government, the Ministry of Tourism (\"<strong>us</strong>\", \"<strong>we</strong>\" or the<strong>&nbsp;\"Ministry</strong>\") respect the privacy of our users (each, a \"<strong>User</strong>\" or \"<strong>you</strong>\") and are committed to protect the privacy of Users who access, download, install, register, use or engage with our website, our mobile application(s), and any other service we provide (the<strong>&nbsp;</strong>\"<strong>Website</strong>\" and \"<strong>App</strong>\" respectively, and collectively the \"<strong>Service(s)</strong>\"). &nbsp;</p>\n\t\t\t\t\t\t\t<p>We've prepared this Privacy Policy to outline our practices with respect to collecting, using and disclosing your information when you use the Services. We encourage you to read this Privacy Policy carefully and use it to make informed decisions. By using the Services, you agree to the terms of this Privacy Policy and your continued use of the Services constitutes your ongoing agreement to the Privacy Policy.</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3><span>CONTENTS</span></h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t  <a href=\"#Grounds\" style=\"color:#000\"><span>1. </span>GROUNDS FOR DATA COLLECTION</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#WhatType\" style=\"color:#000\"><span>2. </span>WHAT TYPE OF DATA WE COLLECT?</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#HowDoWeUse\" style=\"color:#000\"><span>3. </span>HOW DO WE USE THE DATA WE COLLECT?</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#Tracking\" style=\"color:#000\"><span>4. </span>TRACKING TECHNOLOGIES</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#WitWhom\" style=\"color:#000\"><span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#HowWeProtect\" style=\"color:#000\"><span>6. </span>HOW WE PROTECT YOUR INFORMATION</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#Retention\" style=\"color:#000\"><span>7. </span>RETENTION</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#UserRigths\" style=\"color:#000\"><span>8. </span>USER RIGHTS</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#Transfer\" style=\"color:#000\"><span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#OurPolicy\" style=\"color:#000\"><span>10. </span>OUR POLICY TOWARD CHILDREN</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#HowToContactUs\" style=\"color:#000\"><span>11. </span>HOW TO CONTACT US?</a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"#Updates\" style=\"color:#000\"><span>12. </span>UPDATES TO THIS POLICY</a><br/>\n\t\t\t\t\t\t\t</p>\n\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Grounds\"><span>GROUNDS FOR DATA COLLECTION</span><span>&nbsp;</span></h3>\n\t\t\t\t\t\t\t<p><span>Processing of your \u201C<strong>Personal Data</strong>\u201D (meaning any information which may potentially allow your identification, either directly or by using reasonable means) is necessary for the performance of our contractual obligations towards you, for providing you with our Services and the operation of our Website, to protect our legitimate interests and for compliance with legal and regulatory obligations to which we are subject.</span></p>\n\t\t\t\t\t\t\t<p><span>When you use our Services, you consent to the collection, storage, use, disclosure and other uses of your Personal Information as described in this Privacy Policy.</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"WhatType\"><span>WHAT TYPE OF DATA WE COLLECT?</span></h3>\n\t\t\t\t\t\t\t<h3><span>Personal Data</span></h3>\n\t\t\t\t\t\t\t<p><span>In the course of using the Services, we may collect certain Personal Data to provide and improve the Services, to contact or identify you, to enable you to access certain parts of the Service</span><span>&nbsp;or as otherwise indicated in this Policy. We collect the following Personal Data about you</span><span>:</span></p>\n\t\t\t\t\t\t\t<ul style=\"list-style-type: disc;margin-left:0in;\">\n\t\t\t\t\t\t\t  <li><span>When you send us an email&nbsp;</span><span>or contact us through a contact form on the Website, we will collect your name and email address so we could respond to your inquiry. We may also collect any Personal Data that you choose to include in your inquiry to us.</span></li>\n\t\t\t\t\t\t\t  <li><span>Our webserver may also automatically collect your IP address, and unique online identifiers. These details are pseudonymized (cannot directly identify you) and are collected for the purpose of delivering relevant content and operating and improving our Service.</span></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t<h3><span>Non-Personal Data</span></h3>\n\t\t\t\t\t\t\t<p><span>We also collect data about the use of our Service and the characteristics and activities of users, in order to operate it and improve it. We may collect the following non-Personal Data:&nbsp;</span><span>Your operating system, device type, session start/stop time, time zone, network connection type (e.g., Wi-Fi, cellular), your general location (city and country), and general information regarding your browser and device.</span></p>\n\t\t\t\t\t\t\t<p><span>If we combine Personal Data with non-Personal Data, the combined data will be treated as Personal Data.&nbsp;</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"HowDoWeUse\"><span>HOW DO WE USE THE DATA WE COLLECT?</span></h3>\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t  <li><strong><span>Provision of the Service</span></strong><em><span>&nbsp;\u2013&nbsp;</span></em><span>we will use the Personal Data you provide us for the provision and improvement of our Service, providing customer support and to respond to your queries.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Service announcements</span></strong><span>&nbsp;- we will use your Personal Data to communicate with you and to keep you informed of our latest updates to our Service and offer you service offers.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Analytics, surveys and research</span></strong><span>&nbsp;- from time to time, we may conduct surveys or test features, and analyze the data we have to develop, evaluate and improve these features, all in order to improve our Services and offerings, and think of new and exciting features for our users.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Protecting our interests</span></strong><em><span>&nbsp;-&nbsp;</span></em><span>we may use your Personal Data when we believe it\u2019s necessary in order to take precautions against liabilities, investigate and defend ourselves against any third party claims or allegations, investigate and protect ourselves from fraud, protect the security or integrity of our services and protect the rights and property of the Ministry, its users and/or partners.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Enforcing of policies</span></strong><span>&nbsp;- we may use your Personal Data in order to enforce our policies, including but not limited to our <a href=\"https://goisrael.com/Posts/telaviv/Privacy_Policy\" style=\"text-decoration:underline;color:#000\" target=\"_blank\"> Terms </a></span><span style=\"line-height:115%;font-family:Calibri;font-size:8.0pt;color:windowtext;\">\n\t\t\t\t\t\t\t\t \n\t\t\t\t\t\t\t\t</span><span style=\"line-height:;font-family:Calibri;line-height:;color:windowtext;\">.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Compliance with legal and regulatory requirements</span></strong><span>&nbsp;- we may use your Personal Data to investigate violations, and as required by law, regulation or other governmental authority, or to comply with a subpoena or similar legal process.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Newsletter</span></strong><span>&nbsp;- we may use your Personal Data in order to send you our newsletter, if you subscribed to it. &nbsp;</span>\n\t\t\t\t\t\t\t\t<ol style=\"list-style-type: circle;\">\n\t\t\t\t\t\t\t\t  <li><u><span>Opt-out of receiving our newsletter</span></u><span>&nbsp;- You may choose not to receive our newsletter by clicking on the \u201Cunsubscribe\u201D link contained therein. Please note that even if you unsubscribe, we may continue to send you Service-related updates and notifications, or reply to your queries and feedback you provide us.&nbsp;</span></li>\n\t\t\t\t\t\t\t\t</ol>\n\t\t\t\t\t\t\t  </li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Tracking\"><span>TRACKING TECHNOLOGIES</span></h3>\n\t\t\t\t\t\t\t<p><span>When you visit or access our Services we use (and authorize 3<sup>rd</sup> parties to use) pixels, cookies, events and other technologies (collectively, \"<strong>Tracking Technologies</strong>\"). Those allow us to automatically collect information about you, your device and your online behavior, in order to enhance your navigation in our Services, improve our Services\u2019 performance, perform analytics and customize your experience. In addition, we may merge data we have with data collected through these tracking technologies and data we may obtain from other sources and, as a result, such data may become Personal Data.</span></p>\n\t\t\t\t\t\t\t<p>If you do not accept the use of cookies by us, please disable cookies by following the instructions below. However, please note that disabling cookies might seriously affect the function, User experience and other features of our Services.</p>\n\t\t\t\t\t\t\t<h3>Types of Tracking Technologies We Use</h3>\n\t\t\t\t\t\t\t<p>There are two broad categories of cookies: (a) <strong>First party cookies</strong>, served directly by us to your computer or mobile device, and (b) <strong>Third party cookies</strong>, served by a third party. We use third party cookies for functionality, performance and analytics, and social media purposes.</p>\n\t\t\t\t\t\t\t<p>Cookies can remain on your computer or mobile device for different periods of time. Some cookies are \"session cookies\" and expires upon closing of your browser. Other cookies are \"persistent cookies\", meaning that they survive after your browser is closed. They can be used by websites to recognize your computer when you open your browser and browse the Internet again.</p>\n\t\t\t\t\t\t\t<p>For example, we use a performance tracking technology tool called \u201C<strong>Google Analytics</strong>\u201D to collect information about the use of the Website. Google Analytics collects information such as how often users visit this site, what pages they visit when they do so, and what other sites they used prior to coming to this Site. We use the information we get from Google Analytics to maintain and improve the Site and our products. We do not combine the information collected through the use of Google Analytics with personally identifiable information. Google\u2019s ability to use and share information collected by Google Analytics about your visits to this Site is restricted by the Google Analytics Terms of Service, available at \n\t\t\t\t\t\t\t  <a href=\"//www.google.com/analytics/terms/us.html\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">www.google.com/analytics/</a>, and the Google Privacy Policy, available at \n\t\t\t\t\t\t\t  <a href=\"//www.google.com/policies/privacy/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">www.google.com/policies/</a>. You can opt-out of Google's collection of Personal Data through Google Analytics by downloading and installing the Google Analytics Opt-out Browser Add-on, available at \n\t\t\t\t\t\t\t  <a href=\"https://tools.google.com/dlpage/gaoptout\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">tools.google.com/dlpage/gaoptout</a>.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<h3><span>Interest-Based Advertising &amp; User Choice</span></h3>\n\t\t\t\t\t\t\t<p>Through our Services, we may display advertisements that are tailored to you, for example ads or partner services that are based on your recent browsing behavior. In order to tailor advertisements and services in which you might be interested, we as well as certain third parties may use Tracking Technologies to display advertisements based on your visits to the Websites, to target advertisements to you for products and services in which you might be interested, and to measure the effectiveness of the ads. You can turn off certain third party Tracking Technologies used for behavioral advertising purposes by visiting the Network Advertising Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU) using the links provided below. Please note that certain Tracking Technologies operate at the device and browser level, so to fully opt-out across devices, you will need to do so on each device and browser individually, as described below as well.</p>\n\t\t\t\t\t\t\t<h3><span>How to Manage Your Tracking Technologies Settings</span></h3>\n\t\t\t\t\t\t\t<p>There are various ways in which you can manage and control your Tracking Technologies settings. Please remember that, by deleting or blocking Tracking Technologies, some of the features of the Services may not work properly or as effectively.</p>\n\t\t\t\t\t\t\t<p style=\"margin-bottom:6.0pt;\"><strong>Turning off cookies via your web browser\n\t\t\t\t\t\t\t\t<br>&nbsp;\n\t\t\t\t\t\t\t  </strong>Most web browsers will provide you with some general information about cookies, enable you to see what cookies are stored on your device, allow you to delete them all or on an individual basis, and enable you to block or allow cookies for all websites or individually selected websites. You can also normally turn off third party cookies separately. Please note that the settings offered by a browser or device often only apply to that particular browser or device. Information about cookies is usually found in the \"Help\" section of the web browser. Below are some links to some commonly used web browsers:</p>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t  <a href=\"https://support.google.com/chrome/answer/95647?hl=en\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Google Chrome</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"https://support.microsoft.com/en-us/kb/260971\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Explorer</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Mozilla Firefox</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"https://support.apple.com/kb/PH5042?locale=en_US\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Safari (Desktop)</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"https://support.apple.com/en-us/HT201265\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Safari (Mobile)</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Android Browser</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//www.opera.com/help\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Opera</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//www.opera.com/help/mobile/android#privacy\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Opera Mobile</span></a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p>For other browsers, please consult the documentation that your browser manufacturer provides.</p>\n\t\t\t\t\t\t\t<p style=\"margin-bottom:6.0pt;\"><strong>Turning off third party cookies\n\t\t\t\t\t\t\t\t<br>&nbsp;\n\t\t\t\t\t\t\t  </strong>You can turn off certain third party targeting/advertising cookies by visiting the following link:&nbsp;\n\t\t\t\t\t\t\t  <a href=\"//www.networkadvertising.org/choices/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\">Network Advertising Initiative</a>.\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<h3><span>Other helpful resources</span><br/></h3>\n\t\t\t\t\t\t\t<p>\n\t\t\t\t\t\t\t<span>To learn more about advertisers\u2019 use of cookies the following links may be helpful:</span><br/>\n\t\t\t\t\t\t\t  <a href=\"//www.youronlinechoices.eu/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>European Interactive Digital Advertising Alliance (EU)</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//www.iab.net/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Advertising Bureau (US)</span></a><br/>\n\n\t\t\t\t\t\t\t  <a href=\"//www.iabeurope.eu/\" target=\"_blank\" style=\"text-decoration:underline;color:#000\"><span>Internet Advertising Bureau (EU)</span></a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t<p style=\"margin-top:6.0pt;margin-right:0in;margin-bottom:.0001pt;margin-left:0in;text-align:justify;\"><strong>Turning off cookies on a mobile device</strong></h3>\n\t\t\t\t\t\t\t<p>You can-opt out of certain types of interest-based advertising, by accessing the \u201Csettings\u201D on your device:</p>\n\t\t\t\t\t\t\t<ul style=\"list-style-type: disc;margin-left:undefined;\">\n\t\t\t\t\t\t\t  <li><strong><span>If you're using an Apple device</span></strong><span>&nbsp;you can configure your device to limit ad tracking to by clicking on \"settings\" &gt; \"privacy\" &gt; \"advertising\" and toggling \"limit ad tracking\" to \u2018on.\u2019</span></strong></li>\n\t\t\t\t\t\t\t  <li><strong><span>If you're using an Android device</span></strong><span>&nbsp;you can opt out of most app-based tracking for advertising by opening the \"Google Settings\" app on your device, selecting \"Ads\", and then selecting the option to opt-out of interest-based ads.</span></strong></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t<p>Please note that the above information may change when manufacturers update their systems. Also note, that your device may use another platform, not described above. In that case, please consult the manufacturer documentation for further instructions.</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"WitWhom\"><span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span></h3>\n\t\t\t\t\t\t\t<ul>\n\t\t\t\t\t\t\t  <li><strong><span>Internal concerned parties</span></strong><span>&nbsp;- we may share your information with other</span><span style=\"color:windowtext;\">&nbsp;</span><span>government ministries, as well as our employees, as needed to provide our Services.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Business partners</span></strong><span>&nbsp;- we may share your information with business partners such as storage and analytics providers who help us provide you with our Services. These third parties may have access to your Personal Data so that they may perform these tasks on our behalf, but they are obligated to comply with the highest security standards and applicable data protection legislation, and may not use your Personal Data for any other purpose.</span></li>\n\t\t\t\t\t\t\t  <li><strong><span>Compliance with laws and law enforcement entities</span></strong><span>&nbsp;- we cooperate with other governmental agencies and law enforcement officials to enforce and comply with the law. We will disclose Personal Data about you to government or law enforcement officials or private parties if we, in our sole discretion, believe necessary or appropriate to respond to claims and legal process (including but not limited to subpoenas), to protect our or a third party's property and rights, to protect the safety of the public or any person, or to prevent or stop any activity we may consider to be, or to pose a risk of being, illegal, unethical, inappropriate or legally actionable.&nbsp;</span></li>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"HowWeProtect\"><span>HOW WE PROTECT YOUR INFORMATION</span></h3>\n\t\t\t\t\t\t\t<p><span>We have implemented administrative, technical, and physical safeguards to help prevent unauthorized access, use, or disclosure of your Personal Data. Your data is stored on secure servers and isn\u2019t publicly available. We limit access of your information only to those employees or partners on a \u201Cneed to know\u201D basis, in order to enable the carrying out of the agreement between us.&nbsp;</span></p>\n\t\t\t\t\t\t\t<p><span>While we seek to protect your information to ensure that it is kept confidential, we cannot absolutely guarantee its security. You should be aware that there is always some risk involved in transmitting information over the internet. While we strive to protect your Personal Data, we cannot ensure or warrant the security and privacy of your Personal Data or other content you transmit using the Service, and you do so at your own risk.&nbsp;</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Retention\"><span>RETENTION</span></h3>\n\t\t\t\t\t\t\t<p><span>We will retain your Personal Data for as long as necessary to provide our Services, and as necessary to comply with our legal obligations, resolve disputes, and enforce our policies. Retention periods will be determined taking into account the type of information that is collected and the purpose for which it is collected, bearing in mind the requirements applicable to the situation and the need to destroy outdated, unused information at the earliest reasonable time. Under applicable regulations, we will keep records containing Personal Data, communications and anything else as required by applicable laws and regulations.&nbsp;</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3  id=\"UserRigths\"><span>USER RIGHTS</span></h3>\n\t\t\t\t\t\t\t<h4><strong><span style=\"font-family:&quot;Calibri&quot;,sans-serif;color:windowtext;font-style:normal;\">EU User Rights</span></strong></h4>\n\t\t\t\t\t\t\t<p><span>As an EU resident, you may request to:&nbsp;</span></p>\n\t\t\t\t\t\t\t<ol start=\"1\" style=\"list-style-type: lower-alpha;margin-left: 0px;\">\n\t\t\t\t\t\t\t  <li><span>Receive confirmation as to whether or not Personal Data concerning you is being processed, and access your stored Personal Data, together with supplementary information.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><span>Receive a copy of Personal Data you directly volunteer to us in a structured, commonly used and machine-readable format.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><span>Request rectification of your Personal Data that is in our control.</span></li>\n\t\t\t\t\t\t\t  <li><span>Request erasure of your Personal Data.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><span>Object to the processing of Personal Data by us.&nbsp;</span></li>\n\t\t\t\t\t\t\t  <li><span>Request to restrict processing of your Personal Data by us.</span></li>\n\t\t\t\t\t\t\t  <li><span>Lodge a complaint with a supervisory authority.</span></li>\n\t\t\t\t\t\t\t</ol>\n\t\t\t\t\t\t\t<p><span>Please note that these rights pertain to EU residents only, are not absolute, and may be subject to our own legitimate interests and regulatory requirements.&nbsp;</span></p>\n\t\t\t\t\t\t\t<p><span>Users Outside the EU -&nbsp;</span></strong><span>Some of the aforementioned rights are applicable in certain jurisdictions outside the EU as well. Users residing outside the EU are welcome to contact us for any questions or requests by using the details provided below.</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Transfer\"><span>TRANSFER OF DATA OUTSIDE THE EEA</span><span>&nbsp;</span></h3>\n\t\t\t\t\t\t\t<p><span>If you reside in the European Union (\"<strong>EU</strong>\"), please note that some data recipients may be located outside the EEA. In such cases we will transfer your data only to such countries as approved by the European Commission as providing adequate level of data protection, or enter into legal agreements ensuring an adequate level of data protection.</span></p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"OurPolicy\"><span>OUR POLICY TOWARD CHILDREN</span></h3>\n\t\t\t\t\t\t\t<p>We do not knowingly collect or solicit personal information from anyone under 18 years of age, (or the age of consent as determined under the applicable laws where the individual resides; \u201C<strong>Age of Consent</strong>\u201D). By accessing, using or interacting with our Services, you certify to us that you are not under the Age of Consent. In the event that we learn that we have collected personal information from an individual under the Age of Consent without verification of parental consent, we will delete that information upon discovery. If you believe that we might have any information from or about an individual under the Age of Consent, then please contact us through the contact details available below.</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"HowToContactUs\"><span>HOW TO CONTACT US?</span></h3>\n\t\t\t\t\t\t\t<p><span>If you wish to exercise any of the aforementioned rights, or receive more information, please contact us using the details below:</span><br/>Email:<a href=\"mailto:Dpo@tourism.gov.il\" style=\"text-decoration:underline;color:#000\"> Dpo@tourism.gov.il</a>\n\t\t\t\t\t\t\t</p>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t<h3 id=\"Updates\"><span>UPDATES TO THIS POLICY</span></h3>\n\t\t\t\t\t\t\t<p>This Privacy Policy is subject to changes from time to time, in our sole discretion. The most current version will always be posted on our Services (as reflected in the \"Last Updated\" heading). You are advised to check for updates regularly. By continuing to access or use our Services after any revisions become effective, you agree to be bound by the updated Privacy Policy.&nbsp;</p>\n\n\t\t\t\t\t\t   \n\t\t\t\t\t\t\t"};}},{id:"Destination_For_All",ctg:"TouristInfo",bgImage:"/posts/bank/plan-your-trip/1.jpg",mobBgImage:"/posts/bank/plan-your-trip/M.jpg",isVid:true,vidId:"QWA7qwsbbGY",title:"UNE DESTINATION POUR TOUS",smltitle:"",html:function html(){return{__html:"\n\t\t\n\t\t\n\t\t\t\t\t<p>Le nombre de visiteurs en Isra\xEBl conna\xEEt une croissance sans pr\xE9c\xE9dent. Les touristes du monde entier sont de plus en plus nombreux \xE0 r\xE9aliser leur r\xEAve : d\xE9couvrir Isra\xEBl. Le minist\xE8re du tourisme s'est engag\xE9 \xE0 permettre \xE0 tous ceux qui le souhaitent, de fouler le sol de la Terre promise, quelle que soit leur \xE9ventuelle d\xE9ficience.</p>\n<p>En mati\xE8re d'accessibilit\xE9, Isra\xEBl est un leader mondial en termes de l\xE9gislation. De l'infrastructure au service, le pays s'adapte pour permettre un s\xE9jour agr\xE9able et accueillant.</p>\n<p>Vous trouverez ci-dessous les liens vers les prestataires qui pourront vous aider et vous assurer un s\xE9jour harmonieux, sans le moindre obstacle.</p>\n<div class=\"img-wrapper\">\n\t\t\t\t\t   <img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/1.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t</div><br>\n\t\t\t\t\t<h2 class=\"ac-margin-bottom-20\">ONG et voyages</h2>\n\t\t\t\t\t<p><b>Keren Kayemeth LeIsrael (KKL, Fonds national juif)</b></p>\n\t\t\t\t\t<p><u>For\xEAt, parcs et sites accessibles en Isra\xEBl</u><br/>\n\t\t\t\t\tCes derni\xE8res ann\xE9es, le KKL s'est efforc\xE9 d\u2019installer des \xE9quipements adapt\xE9s aux personnes \xE0 mobilit\xE9 r\xE9duite dans ses for\xEAts et ses parcs. Notre objectif est d'ouvrir la nature \xE0 tous les secteurs de la population, en cr\xE9ant un environnement dans lequel les personnes \xE0 mobilit\xE9 r\xE9duite peuvent se d\xE9placer en tout confort et toute s\xE9curit\xE9. Nous avons \xE9galement fait un pas en avant et introduit la nature \xE0 l'\xE9cole avec la mise en place de projets uniques dans les \xE9tablissements d'\xE9ducation sp\xE9cialis\xE9e.\n\t\t\t\t\t<a href=\"//www.kkl-jnf.org/tourism-and-recreation/accessible-forests-parks-sites-israel/\" target=\"_blank\"> www.kkl-jnf.org</a>\n\t\t\t\t   </p>\n\t\t\n\t\t\t\t   <p><b>L\u2019Autorit\xE9 isra\xE9lienne de la nature et des parcs</b></p>\n\t\t\t\t   <p>Ces derni\xE8res ann\xE9es, l'Autorit\xE9 de la nature et des parcs a entrepris de rendre ses sites accessibles aux personnes handicap\xE9es. Dans tous les parcs nationaux, r\xE9serves naturelles, sites d'antiquit\xE9s et sites patrimoniaux, des travaux sont en cours pour am\xE9liorer l'accessibilit\xE9 et proposer des solutions d\u2019aide \xE0 l'acc\xE8s.<br/>\nL\u2019organisme met tout en \u0153uvre pour augmenter le nombre de visiteurs \xE0 mobilit\xE9 r\xE9duite qui peuvent profiter de ses sites et de leurs activit\xE9s.<br/>\n\n\n\t\t\t\t\tPour obtenir de plus amples informations et consulter nos cartes, rendez-vous sur notre site Internet :<a href=\"https://www.parks.org.il/en/accessibility/\" target=\"_blank\">www.parks.org.il</a></p>\n\t\t\t\t\t \n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/2.jpg")+" class=\"img-responsive\">\n\t\t\t\t </div><br>\n\t\t\t\t\t <p><b>Yad Sarah pour les Touristes</b></p>\n\t\t\t\t\t <p>Voyager \xE0 l'\xE9tranger pr\xE9sente des d\xE9fis particuliers pour les personnes \xE0 besoins sp\xE9cifiques. Yad Sarah pour les Touristes propose une assistance qui garantira des vacances agr\xE9ables et relaxantes \xE0 toute personne \xE0 besoins sp\xE9cifiques et \xE0 sa famille. Une fois les r\xE9servations finalis\xE9es avec l'office du tourisme, le visiteur pourra se d\xE9tendre, sachant que tous les arrangements seront alors entre les mains comp\xE9tentes d'un repr\xE9sentant de Yad Sarah.</p>\n\t\t\t\t   \n\t\t\t\t\t\t<p> <u>Parmi les services disponibles</u>:<br/>\n\t\t\t\t\t\t \n\t\t\t\t\t\t\u2022 Pr\xEAt de mat\xE9riel m\xE9dical. Possibilit\xE9 de livraison \xE0 l'h\xF4tel ou au lieu de r\xE9sidence pour une somme symbolique.<br/>\n\u2022 Equipement de votre chambre d'h\xF4tel pour rendre votre s\xE9jour plus confortable, y compris lits ou chaises adapt\xE9s, etc.<br/>\n\u2022 Pr\xEAt de bouteilles \xE0 oxyg\xE8ne / concentrateurs d'oxyg\xE8ne.<br/>\n\u2022 Transport dans des fourgonnettes avec syst\xE8me de retenue pour fauteuils roulants, y compris les transferts depuis et vers l'a\xE9roport et les visites touristiques.<br/>\n\u2022 Recommandation de guides touristiques sp\xE9cialis\xE9s dans l'accompagnement de touristes \xE0 mobilit\xE9 r\xE9duite et \xE0 besoins sp\xE9cifiques, et conseils sur les sites touristiques faciles d'acc\xE8s.<br/>\n\n\t\t\t\t\t\t<br/>\n\t\t\t\t\t\t Le service personnalis\xE9 de Yad Sarah est disponible, sur arrangement pr\xE9alable avec l\u2019office du tourisme, pour tout visiteur \xE0 besoins sp\xE9cifiques.<br/>\n\t\t\t\t\n\t\t\n\t\t\t\t <br/>\n\t\t\n\t\t\t\t\tLe service est disponible dans tout Isra\xEBl.<br/>\n                    Pour plus de d\xE9tails, ou pour organiser un transport ou une visite, veuillez contacter l\u2019office du tourisme au +972-2-6444382 ou par mail :  <a href=\"tel:+97226444382\">+972-2-6444382</a> or e-mail us: <a href=\"mailto:chaimvi@yadsarah.org.il\">chaimvi@yadsarah.org.il</a></p>\n\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/3.jpg")+" class=\"img-responsive\">\n\t\t\t\t </div><br>\n\t\t\t\t\t<p><b>Access Israel</b></p>\n\t\t\t\t\t<p>Access Israel est une organisation \xE0 but non lucratif qui encourage l'accessibilit\xE9 et l'inclusion des personnes handicap\xE9es et des personnes \xE2g\xE9es dans tous les secteurs de la vie. Access Israel a vu le jour en 1999 sous l\u2019impulsion de Youval Wagner, ancien pilote d'h\xE9licopt\xE8re qui s'est retrouv\xE9 en fauteuil roulant \xE0 la suite d'un accident d'h\xE9licopt\xE8re. L\u2019association m\xE8ne divers projets pour parvenir \xE0 une soci\xE9t\xE9 pleinement accessible et inclusive, y compris des efforts de sensibilisation dans les \xE9coles, conseils en accessibilit\xE9 pour les entreprises, cours d'accessibilit\xE9, cours de langue des signes, conf\xE9rences sur divers sujets et plus encore. De plus, Access Israel travaille \xE0 ancrer l'accessibilit\xE9 dans la loi isra\xE9lienne, g\xE8re un centre de plaintes en mati\xE8re d'accessibilit\xE9 et organise des \xE9v\xE9nements de sensibilisation pour le public. L\u2019organisme promeut l'accessibilit\xE9 et l'inclusion dans tous les domaines de la vie et en mati\xE8re d'\xE9ducation, de tourisme, de culture, de situations d'urgence et plus encore. \n\t\t\t\t\t\t<a href=\"https://www.aisrael.org/?CategoryID=3030\" target=\"_blank\">Le tourisme accessible sur le site Internet d'Access Israel</a></p>\n\t\t\n\t\t\t\t\t\t<p><u>LOTEM</u>est la plus grande organisation d\u2019Isra\xEBl en mati\xE8re d\u2019activit\xE9s d'apprentissage en ext\xE9rieur pour les enfants \xE0 besoins sp\xE9cifiques. Elle propose des activit\xE9s \xE9ducatives de plein air ainsi que des randonn\xE9es accessibles. Surin Hershko, un h\xE9ros de guerre gravement bless\xE9 lors de l'op\xE9ration Entebbe en 1976, est le fondateur et pr\xE9sident de LOTEM. Son inspiration vient du c\u0153ur : \xAB Accorder aux enfants le droit fondamental de vivre leur vie en plein air constitue mon objectif, et cela me remplit de joie \xBB. Le site principal, Emek HaShalom (La vall\xE9e de la Paix), est une ferme de 16 hectares situ\xE9e dans le nord d'Isra\xEBl, pr\xE8s de Yokneam. Nich\xE9e au c\u0153ur d'une magnifique vall\xE9e, elle a pour environnement imm\xE9diat une nature florissante et le ruissellement paisible de l'eau. Elle offre une exp\xE9rience d'apprentissage de terrain avec un jardin \xE9ducatif, des pressoirs \xE0 olive et \xE0 vin, ainsi qu\u2019une boulangerie et des sentiers de randonn\xE9es, le tout, accessible en fauteuil roulant.</p>\n\t\t\t\t\t\t<p><u>LOTEM</u> a bien conscience du r\xF4le vital que le plein air joue dans la vie des Isra\xE9liens, et l'impact incommensurable que peut avoir le fait de rendre la soci\xE9t\xE9 accessible, non seulement sur l'individu \xE0 besoins sp\xE9cifiques, mais aussi sur sa famille et l\u2019ensemble de la communaut\xE9. Dans le cadre de son travail pour s\u2019assurer qu'aucun membre de la soci\xE9t\xE9 ne soit laiss\xE9 pour compte, LOTEM donne la possibilit\xE9 aux enfants et adultes \xE0 besoins sp\xE9cifiques d'apprendre et de participer \xE0 des activit\xE9s de plein air dans tout le pays. \n\t\t\t\t\t\t<a href=\"https://www.lotem.net/?page_id=386\" target=\"_blank\">www.lotem.net</a></p>\n\t\t\n\t\t\t\t\t\t<h2 class=\"ac-margin-bottom-20 ac-margin-top-20\"> Transport</h2>\n\t\t\t\t\t\t<p><b>L\u2019Autorit\xE9 a\xE9roportuaire d'Isra\xEBl</b></p>\n\t\t\t\t\t\t<p>Selon la loi, l'Autorit\xE9 a\xE9roportuaire d'Isra\xEBl est charg\xE9e de fournir l'infrastructure physique pour l'activit\xE9 des entreprises de services aux passagers assist\xE9s. Cependant, selon la r\xE9glementation des transports, la responsabilit\xE9 de la prise en charge des passagers assist\xE9s et de leurs bagages, d\xE8s leur entr\xE9e dans l'a\xE9rogare ou leur d\xE9barquement de l'avion, incombe \xE0 la compagnie a\xE9rienne qui assure leur transport. Actuellement, \xE0 l'a\xE9roport Ben Gourion, le service aux passagers assist\xE9s est assur\xE9 par des soci\xE9t\xE9s d'assistance au sol. Le service comprend l'accompagnement et l\u2019aide des passagers handicap\xE9s lors des proc\xE9dures d\u2019embarquement et de d\xE9barquement. \n\t\t\t\t\t\t<a href=\"https://www.iaa.gov.il/en-us/airports/bengurion/pages/accessibility.aspx\" target=\"_blank\">www.iaa.gov.il</a></p>\n\t\t\t\t\t\t<p><b>Voici les soci\xE9t\xE9s d'assistance au sol: </b></p>\n\t\t\t\t\t\t<pAero Handling: <a href=\"//www.aerohandling.com/\" target=\"_blank\">www.aerohandling.com</a><br/>\n\t\t\t\t\t\tLaufer Aviation: GHI <a href=\"//lauferghi.com/\" target=\"_blank\">www.lauferghi.com</a><br/>\n\t\t\t\t\t\tQAS: <a href=\"//www.qasisrael.co.il\" target=\"_blank\">www.qasisrael.co.il</a><br/>\n\t\t\n\t\t\n\t\t\t\t\t\t</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/4.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t </div><br>\n\t\t\n\t\t\t\t\t\t<p>Ministry of Transportation help line (local call) <a href=\"tel:5678*\">5678*</a></p>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<p><b>PTransport public</b></p>\n\t\t\t\t\t\t<p>Trains - Si vous avez besoin de l'aide d'un membre du personnel de la gare pour embarquer ou descendre du train, veuillez coordonner votre trajet \xE0 l'avance avec \u2018Israel Railways\u2019, les chemins de fer isra\xE9liens, via leur site Internet ou leur hotline au <a href=\"tel:*5770\">*5770</a>.</p>\n\t\t\t\t\t\t \n\t\t\t\t\t\t<p><u>'Israel Railways'</u> fera de son mieux pour vous offrir le meilleur service possible, m\xEAme si vous n'avez pas planifi\xE9 votre voyage \xE0 l'avance.</p>\n\t\t\t\t\t\t<p>Dans tous les cas, veuillez coordonner \xE0 l\u2019avance tout trajet pr\xE9vu entre 20h et 6h, ou le samedi soir.</p>\n\t\t\t\t\t\t<p><u>Bus</u> - Toutes les lignes de bus interurbaines sont adapt\xE9es pour accueillir tous les voyageurs. Les bus intra-urbains sont partiellement accessibles. </p>\n\t\t\t\t\t\t<p><u>Taxis</u> - Il est rare de pouvoir h\xE9ler un taxi accessible dans la rue. Il est recommand\xE9 de le commander \xE0 l\u2019avance \xE0 partir de cette liste. <a href=\"https://www.aisrael.org/?CategoryID=2657&ArticleID=64179\" target=\"_blank\">https://www.aisrael.org/?CategoryID=2657&ArticleID=64179</a>.</p>\n\t\t\n\t\t\n\t\t\t\t\t\t<h2  class=\"ac-margin-bottom-20 ac-margin-top-20\">H\xE9bergement</h2>\n\t\t\t\t\t\t<p>A partir de 7 chambres ou plus, tous les types d'h\xE9bergement en Isra\xEBl sont tenus par la loi de proposer au moins 1 chambre accessible. A partir de 25 employ\xE9s, tous les prestataires de services doivent compter dans leurs \xE9quipes un superviseur en mati\xE8re d\u2019accessibilit\xE9. Gr\xE2ce \xE0 ces lois, il n'existe pas d\u2019endroit en Isra\xEBl sans une solution d'h\xE9bergement parfaitement adapt\xE9e. Une courte coordination de vos attentes par mail, avant votre d\xE9part, est toutefois toujours recommand\xE9e.</p>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/5.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t </div><br>\n\t\t\t\t\t\t\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div id=\"ac-left-nav\">\n\t\t\t\t\t\t<h2 class=\"ac-margin-bottom-20 pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Accessibility for those with special needs at the beaches:</span>\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t<ul id=\"chaptersList\" class=\"list-unstyled xs-mb-0\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<!-- ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<li data-show=\"1\" class=\"ac-active ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope light-gray-e7-background blue-border-right-5px\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt nounderline  ng-binding reforma-bold\">Northern District</span>\t\t\t\t\t\t                  \n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<li data-show=\"2\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<li data-show=\"3\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<div class=\"clear show-on-mobile\"></div>\n\t\t\t\t\t\t\t\t<li data-show=\"4\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</li>\n\t\t\t\t\t\t\t\t<!-- end ngRepeat: chapter in Guide.Chapters --><li data-show=\"5\" class=\"ac-district w-100 inline-flex light-gray-f7-background light-gray-e0-border xs-pt-15 xs-pb-10 xs-pl-10 focus-offset-2px ng-scope\" ng-repeat=\"chapter in Guide.Chapters\" ng-class=\"getDecorationForLi($index)\" ng-click=\"openChapterMenu(false,$index);updateChapterIndex($index);\" role=\"button\" tabindex=\"0\" >\n\t\t\t\t\t\t\t\t\t<span ng-class=\"CurrChapterindex == ($index) ? 'reforma-bold ': ''\" class=\"blue-txt description-txt reforma nounderline  ng-binding\">Southern District</span>\n\t\t\t\t\t\t\t\t\t<img src=\""+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/a-down.png")+"\" class=\"img-responsive a-arrow-img\" alt=\"\">\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t</li><!-- end ngRepeat: chapter in Guide.Chapters -->\n\t\t\t\t\t\t\t\t<div class=\"clear\"></div>\n\t\t\t\t\t\t\t</ul>\n\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t<div id=\"res\">\n\t\t\t\t\t\t\t<!-- ac part -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-1 ac-part-active\">\n\t\t\n\t\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Northern District</span>\n\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\n\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t\t\t\t\t\t\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\t\t\t\t<!--Image desc-->\n\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-1\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Kineret Municipal Unio</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking&nbsp;&nbsp; &nbsp;</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Tzinbari</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Berniki</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>At the nearby Shikmim beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Shikmim</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Hukok</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Amnon</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Kinar</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Doga</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Closed</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Tze\u2019elon</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Kursi</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Levanon</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Halukim</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>At the nearby Levanon beach</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Shizaf</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Dugit \u2013 Golan</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Gofra</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Tiberias</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Guy</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Galei Kineret - Rimonim</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Leonardo Pacific</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Closed for renovations</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Coco Hot / Holiday Inn</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Jordan Valley Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Ein Gev Vacation</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Ginnosar</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Migdal Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Restal Magdala</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Mateh Asher Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Banana Beach Achziv</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Nahariya</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Sokolov</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Galil Central</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Acco</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Argaman Central</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Hatmarim</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t</table></div></div>\n\t\t\n\t\t\t\t\t\t\t\t<p>&nbsp;</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- ac- part -->\n\t\t\n\t\t\t\t\t\t\t<!-- ac part 2 -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-2\">\n\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\n\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t<!--Image desc-->\n\t\t\t<div>\n\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t</div>\n\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t</div>\n\t\t</div>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\n\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-2\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table align=\"left\" cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t<tbody>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Kiryat Yam</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Zevulun</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Haifa</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Zamir 1</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Zamir 2</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Neot Kiryat Haim Central</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Bat Galim 1</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Bat Galim 2</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Hof Hacarmel Regional Council</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Dor Central 2</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Neve Yam</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Aqueduct</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Jisr a-Zarka Regional Council</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Jisr</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Hadera</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Kfar Yam&nbsp;</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Olga Central 2</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t\t</table></div></div>\n\t\t\n\t\t<p>&nbsp;</p>\n\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Northern District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- end ac part-2 -->\n\t\t\n\t\t\t\t\t\t\t<!-- ac-part-3 -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-3\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t\t\t\t\t\t\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t\t\t\t\t\t\t\t<!--Image desc-->\n\t\t\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-3\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t\t\t\t\t\t\t\t<tbody>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Emek Hefer Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Michmoret \u2013 Station number 1</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Michmoret \u2013 Station number 2</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Joint with number 1</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beit Yannai</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>NeUrim Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Netanya</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Kiryat Tzanz</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>HaOnot Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Parking</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Ampi Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Herzl</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Sironit Beach A</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Sironit Beach B</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Argaman Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Poleg Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Hof Hasharon Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Shefayim (Ga\u2019ash)</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Rishon Le-Zion</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 1 \u2013 Hakachol (Blue) Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 2 \u2013 Neve Hof Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 3 \u2013 Hofit Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 4 \u2013 Tel Yonah Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 5 \u2013 Hayeladim (Children\u2019s) Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Beach number 6 \u2013 separate beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Gan Raveh Regional Council</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t\t\t\t\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t\t\t\t\t\t\t\t<td>Palmahim Beach</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>Yes</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t\t<td>No</td>\n\t\t\t\t\t\t\t\t\t\t</tr>\n\t\t\t\t\t\t\t\t\t</tbody>\n\t\t\t\t\t\t\t\t</table></div></div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t<p>&nbsp;</p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Haifa District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- end ac-part-3 -->\n\t\t\n\t\t\t\t\t\t\t<!-- ac-part-4 -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-4\">\n\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t<span class=\"ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t</h2>\n\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t<!--- Image-->\n\t\t\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\n\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t<!--Image desc-->\n\t\t<div>\n\t\t<div class=\"position-absolute\">\n\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t</div>\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t</div>\n\t\t</div>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\n\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-4\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t<tbody>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Herzliya</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Nof Yam</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Hasharon&nbsp;&nbsp; &nbsp;Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Zevulun</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Acadia North Beach&nbsp;&nbsp; &nbsp;</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Acadia South Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Acadia South Beach \u2013 Disabled</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Separate beach</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Tel Aviv - Jaffa</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>HaTzuk Beach \u2013 Station number 1</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Tel Baruch Beach \u2013 Station number 1</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Nordau (Metzitzim) Beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Nordau separate beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Gordon</td>\n\t\t<td>No</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Bograshov</td>\n\t\t<td>No</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Allenby (Jerusalem)</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Charles Clore</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Jaffa \u2013 Givat HaAliyah</td>\n\t\t<td>Yes</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Hilton North</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>HaTzuk Beach \u2013 Station number 2</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Frishman</td>\n\t\t<td>No</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Aviv Beach</td>\n\t\t<td>No</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>Yes</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Bat Yam</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td><strong>Name of beach</strong></td>\n\t\t<td><strong>Parking</strong></td>\n\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t<td><strong>Access to shade</strong></td>\n\t\t<td><strong>Access to water</strong></td>\n\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>HaSela \u2013 Station number 1</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>HaSela \u2013 Station number 2</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>HaSela \u2013 Station number 3</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Sample Beach</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Riviera</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t<td>Separate beach</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t<td>Tayo</td>\n\t\t<td>Yes</td>\n\t\t<td>Bathrooms only</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t<td>No</td>\n\t\t</tr>\n\t\t</tbody>\n\t\t</table></div></div>\n\t\t\n\t\t<p>&nbsp;</p>\n\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\n\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\n\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\n\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-end\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Central District</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"false\">\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Southern District</span>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- end ac-part-4 -->\n\t\t\n\t\t\t\t\t\t\t<!-- ac-part-5 -->\n\t\t\t\t\t\t\t<div class=\"ac-part ac-part-5\">\n\t\t\t\t\t\t\t<div ng-include=\"chapterItem\" class=\"row row-gov ng-scope\">\n\t\t\t\t\t\t\t<!-- Sub Title -->\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 lg-mb-25 md-ps-40 pr-mr-0 ng-scope\">\n\t\t\t\t\t\t\t\t<h2 class=\"h2 gray-txt pr-fs-28 chapter-title inline-block\">\n\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.ShowChaptersIndex -->\n\t\t\t\t\t\t\t\t\t<span class=\"ng-binding\">Southern District</span>\n\t\t\t\t\t\t\t\t</h2>\n\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t<div class=\"col-lg-8 offset-lg-1 col-12 pr-mr-0 md-ps-40 ng-scope\">\n\t\t\t\t\t\t\t\t<!-- IMAGE TAG  ------->\n\t\t\t\t\t\t\t\t<!--- Image-->\n\t\t\n\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"row row-gov no-gutters ng-scope\">\n\t\t<div class=\"position-relative col-lg-10 lg-p-0\">\n\t\t\t<!-- ngIf: CurrChapter.Image.ClickURLRef -->\n\t\t\n\t\t\t<!-- ngIf: !CurrChapter.Image.ClickURLRef --><div ng-if=\"!CurrChapter.Image.ClickURLRef\" class=\"ng-scope\">\n\t\t\t</div><!-- end ngIf: !CurrChapter.Image.ClickURLRef -->\n\t\t\t<!--Image desc-->\n\t\t\t<div>\n\t\t\t\t<div class=\"position-absolute\">\n\t\t\t\t\t<!-- ngIf: CurrChapter.Image.PermittedUseImage || CurrChapter.Image.CopyrightDescription -->\n\t\t\t\t</div>\n\t\t\t\t<!-- ngIf: CurrChapter.Image --><div ng-if=\"CurrChapter.Image\" class=\"xs-mb-10 ng-scope\">\n\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t\t<span class=\"small-txt ng-binding\"></span>\n\t\t\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t</div>\n\t\t</div>\n\t\t</div><!-- end ngIf: CurrChapter.Image -->\n\t\t\t\t\t\t\t\t<!-- End IMAGE TAG  ------->\n\t\t\n\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters\">\n\t\t\t\t\t\t\t\t\t<!--Content Text-->\n\t\t\t\t\t\t\t\t\t<div id=\"GuidesChapterContent-5\" style=\"overflow: hidden;\" ng-bind-html=\"CurrChapter.Content | to_trusted\" fixed-tables=\"\" class=\"xs-mb-25  lg-mb-30 txt gray-txt margin-for-ul tbl-responsive tbl-accesabilty sub-links-permanent-underline pr-fs-15 ng-binding\"><div class=\"table-responsive\"><div><div class=\"changeWidth0\" style=\"width: auto;\"></div><table cellpadding=\"1\" cellspacing=\"1\" style=\"width: 100%;\" class=\"table ui-responsive\" data-mode=\"reflow\" data-role=\"table\">\n\t\t<tbody>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Ashdod</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Mei Ami Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Lido</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t<td>&nbsp;</td>\n\t\t\t\t<td>&nbsp;</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Oranim</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Hakshatot</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Separate beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Rova K</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Riviera</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td colspan=\"6\" style=\"text-align: center;\"><strong>Hof Ashkelon Regional Council</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Nitzanim</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Zikim</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Ashkelon</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Bar Kochva North</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Bar Kochva South</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Delila North</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Delila South</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Ashkelon National Park Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Separate beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>\u05DC\u05D0</td>\n\t\t\t\t<td>\u05DC\u05D0</td>\n\t\t\t\t<td>\u05DC\u05D0</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Tamar Regional Council</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Mazor Springs</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Meridian Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Hod Hotel Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Tzel Harim</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Crown Plaza Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Lot</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Lot\u2019s Wife</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Ein Bokek South</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Daniel Hotel Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Under construction&nbsp;&nbsp; &nbsp;</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Solarium Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Isrotel Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>International Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Leonardo Plaza Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Zohar Springs (North)</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td>Separate beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Leonardo Club Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td class=\"rtecenter\" colspan=\"6\"><strong>Municipality of Eilat&nbsp;&nbsp; &nbsp;</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td><strong>Name of beach</strong></td>\n\t\t\t\t<td><strong>Parking</strong></td>\n\t\t\t\t<td><strong>Bathrooms and showers</strong></td>\n\t\t\t\t<td><strong>Access to shade</strong></td>\n\t\t\t\t<td><strong>Access to water</strong></td>\n\t\t\t\t<td><strong>Bathing chairs for the disabled</strong></td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><br>\n\t\t\t\tSeparate beach</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(255, 255, 255);\">\n\t\t\t\t<td>Herod\u2019s beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t\t<tr style=\"background-color: rgb(244, 244, 244);\">\n\t\t\t\t<td><br>\n\t\t\t\tNorthwestern Beach</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t\t<td>Bathrooms only</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>No</td>\n\t\t\t\t<td>Yes</td>\n\t\t\t</tr>\n\t\t</tbody>\n\t\t</table></div></div>\n\t\t\n\t\t<p>&nbsp;</p>\n\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<!--Chapters/Collapse-->\n\t\t\t\t\t\t\t\t\t<div class=\"col-12\" id=\"accordion\" role=\"tablist\" aria-multiselectable=\"true\">\n\t\t\t\t\t\t\t\t\t\t<!-- ngRepeat: collapse in CurrChapter.Collapses -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\n\t\t\t\t\t\t\t\t\t<!-- ngRepeat: InnerImageItem in CurrChapter.ImagesAndContent -->\n\t\t\t\t\t\t\t\t\t<!--End of Chapters/Collapse-->\n\t\t\n\t\t\t\t\t\t\t\t\t<div class=\"col-12 xs-mb-25 lg-mb-30\">\n\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t\t\t\t\t\t\t\t\t<!-- Files for Download-->\n\t\t<!-- ngIf: ((CurrChapter.FilesGroup  &&  CurrChapter.FilesGroup.FilesGroupList.length > 0 && CurrChapter.FilesGroup.FilesGroupList[0].Files.length)||(Guide.FilesGroup  &&  Guide.FilesGroup.FilesGroupList.length > 0))   -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t<!-- ngIf: !isOnPrintMode --><div ng-if=\"!isOnPrintMode\" class=\"ng-scope\">\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: Guide.Chapters.length > 1 --><div ng-if=\"Guide.Chapters.length > 1\" class=\"ng-scope\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- horizontal line -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov xs-mb-25 lg-mb-30 xs-mb-25 \">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"horizontal-line\"></div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: Guide.Chapters.length > 1 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t<!--arrows subject nav  \u05D3\u05E4\u05D3\u05D5\u05E3-->\n\t\t\t\t\t\t\t\t\t\t\t<div class=\"row row-gov no-gutters xs-mb-25 lg-mb-30 display-flex-start\" ng-class=\"{true: 'display-flex-start', false: 'display-flex-end'}[CurrChapterindex == Guide.Chapters.length-1]\">\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05E7\u05D5\u05D3\u05DD -->\n\t\t\t\t\t\t\t\t\t\t\t\t<!-- ngIf: CurrChapterindex > 0 --><div ng-if=\"CurrChapterindex > 0\" class=\"col-6 list-unstyled xs-float-start ie-display-flex flex-start ie-flex-start hover-Pointer ng-scope\" ng-click=\"updateChapterIndex(CurrChapterindex - 1)\" role=\"button\" tabindex=\"0\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-right toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"xs-mr-20 lg-mr-10 guideBreakLine width-100 text-right height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\"> Previous page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\">Tel Aviv District</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: CurrChapterindex > 0 -->\n\t\t\n\t\t\t\t\t\t\t\t\t\t\t\t<!--  \u05DC\u05D3\u05E3 \u05D4\u05D1\u05D0 -->\n\t\t\t\t\t\t\t\t\t\t\t\t<div ng-show=\"CurrChapterindex < lastIndex\" class=\"col-6  list-unstyled xs-float-end ie-display-flex flex-end ie-flex-end hover-Pointer ng-hide\" ng-click=\"updateChapterIndex(CurrChapterindex + 1)\" role=\"button\" tabindex=\"0\" aria-hidden=\"true\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t<div class=\"guideBreakLine xs-ml-10 pull-left width-100 text-left height100\">\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"small-txt gray-txt width-100\">Next page:</span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t<span class=\"reforma description-txt blue-txt width-100 ng-binding\"></span>\n\t\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t\t\t<i class=\"icon-arrow-left toflipInEng h3 blue-txt\" aria-hidden=\"true\"></i>\n\t\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t\t\t</div><!-- end ngIf: !isOnPrintMode -->\n\t\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<!-- end ac-part-5 -->\n\t\t\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t<div class=\"img-wrapper\">\n\t\t\t\t\t\t<img src="+(Object(__WEBPACK_IMPORTED_MODULE_0__Utility_Utility__["e" /* getImgUrl */])()+"/posts/destination-for-all/6.jpg")+" class=\"img-responsive\">\n\t\t\t\t\t </div><br>\n\t\t\t\t\t\t\t\n\t\t\t\t\t\t\t"};}}];

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_css__ = __webpack_require__(293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Loader_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Loader_css__);
var Loader=function Loader(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"spinner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bounce3"}));};/* harmony default export */ __webpack_exports__["a"] = (Loader);

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(108);
module.exports = __webpack_require__(113);


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(109).enable();
  window.Promise = __webpack_require__(111);
}

// fetch() polyfill for making API calls.
__webpack_require__(112);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(35);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(60);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(60);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 112 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es_map__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es_set__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_polyfill__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ie_css__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ie_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ie_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fonts_fonts_css__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__fonts_fonts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__fonts_fonts_css__);
// import registerServiceWorker from './registerServiceWorker';
window.matchMedia=window.matchMedia||function(){return{matches:false,addListener:function addListener(){},removeListener:function removeListener(){}};};// const browserHistory = {};
// const basename = "/go-israel-new/";
var basename="/";__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_router_dom__["a" /* BrowserRouter */],{basename:basename,forceRefresh:true},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__App__["a" /* default */],null)),document.getElementById('root'));// registerServiceWorker();

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115);
__webpack_require__(84);
__webpack_require__(85);
__webpack_require__(86);
var path = __webpack_require__(43);

module.exports = path.Map;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(61);
var collectionStrong = __webpack_require__(81);

// `Map` constructor
// https://tc39.github.io/ecma262/#sec-map-objects
module.exports = collection('Map', function (init) {
  return function Map() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var nativePropertyIsEnumerable = {}.propertyIsEnumerable;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !nativePropertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : nativePropertyIsEnumerable;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);
var classof = __webpack_require__(64);

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(7);
var inspectSource = __webpack_require__(68);

var WeakMap = global.WeakMap;

module.exports = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(10);
var ownKeys = __webpack_require__(120);
var getOwnPropertyDescriptorModule = __webpack_require__(63);
var definePropertyModule = __webpack_require__(15);

module.exports = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(42);
var getOwnPropertyNamesModule = __webpack_require__(121);
var getOwnPropertySymbolsModule = __webpack_require__(124);
var anObject = __webpack_require__(19);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(71);
var enumBugKeys = __webpack_require__(45);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.github.io/ecma262/#sec-object.getownpropertynames
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var toIndexedObject = __webpack_require__(27);
var toLength = __webpack_require__(72);
var toAbsoluteIndex = __webpack_require__(123);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.github.io/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(44);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),
/* 124 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

module.exports = !fails(function () {
  return Object.isExtensible(Object.preventExtensions({}));
});


/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);
var Iterators = __webpack_require__(25);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var NATIVE_SYMBOL = __webpack_require__(76);

module.exports = NATIVE_SYMBOL
  // eslint-disable-next-line no-undef
  && !Symbol.sham
  // eslint-disable-next-line no-undef
  && typeof Symbol.iterator == 'symbol';


/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(78);
var Iterators = __webpack_require__(25);
var wellKnownSymbol = __webpack_require__(9);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(19);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (error) {
    var returnMethod = iterator['return'];
    if (returnMethod !== undefined) anObject(returnMethod.call(iterator));
    throw error;
  }
};


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line no-throw-literal
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
var setPrototypeOf = __webpack_require__(80);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);

module.exports = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};


/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(17);
var definePropertyModule = __webpack_require__(15);
var anObject = __webpack_require__(19);
var objectKeys = __webpack_require__(135);

// `Object.defineProperties` method
// https://tc39.github.io/ecma262/#sec-object.defineproperties
module.exports = DESCRIPTORS ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], Properties[key]);
  return O;
};


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var internalObjectKeys = __webpack_require__(71);
var enumBugKeys = __webpack_require__(45);

// `Object.keys` method
// https://tc39.github.io/ecma262/#sec-object.keys
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var getBuiltIn = __webpack_require__(42);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(24);

module.exports = function (target, src, options) {
  for (var key in src) redefine(target, key, src[key], options);
  return target;
};


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var IteratorPrototype = __webpack_require__(82).IteratorPrototype;
var create = __webpack_require__(48);
var createPropertyDescriptor = __webpack_require__(36);
var setToStringTag = __webpack_require__(47);
var Iterators = __webpack_require__(25);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var requireObjectCoercible = __webpack_require__(37);

// `ToObject` abstract operation
// https://tc39.github.io/ecma262/#sec-toobject
module.exports = function (argument) {
  return Object(requireObjectCoercible(argument));
};


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var fails = __webpack_require__(13);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(42);
var definePropertyModule = __webpack_require__(15);
var wellKnownSymbol = __webpack_require__(9);
var DESCRIPTORS = __webpack_require__(17);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);
  var defineProperty = definePropertyModule.f;

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineProperty(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(46);
var classof = __webpack_require__(78);

// `Object.prototype.toString` method implementation
// https://tc39.github.io/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(44);
var requireObjectCoercible = __webpack_require__(37);

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.github.io/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),
/* 144 */
/***/ (function(module, exports) {

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(27);
var addToUnscopables = __webpack_require__(146);
var Iterators = __webpack_require__(25);
var InternalStateModule = __webpack_require__(28);
var defineIterator = __webpack_require__(49);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.github.io/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.github.io/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.github.io/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.github.io/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.github.io/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.github.io/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return { value: undefined, done: true };
  }
  if (kind == 'keys') return { value: index, done: false };
  if (kind == 'values') return { value: target[index], done: false };
  return { value: [index, target[index]], done: false };
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.github.io/ecma262/#sec-createunmappedargumentsobject
// https://tc39.github.io/ecma262/#sec-createmappedargumentsobject
Iterators.Arguments = Iterators.Array;

// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var wellKnownSymbol = __webpack_require__(9);
var create = __webpack_require__(48);
var definePropertyModule = __webpack_require__(15);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.github.io/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  definePropertyModule.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(148);
__webpack_require__(84);
__webpack_require__(85);
__webpack_require__(86);
var path = __webpack_require__(43);

module.exports = path.Set;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var collection = __webpack_require__(61);
var collectionStrong = __webpack_require__(81);

// `Set` constructor
// https://tc39.github.io/ecma262/#sec-set-objects
module.exports = collection('Set', function (init) {
  return function Set() { return init(this, arguments.length ? arguments[0] : undefined); };
}, collectionStrong);


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(150).polyfill()


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(151)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(35),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(35),q=__webpack_require__(154);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(155);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 157 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Routes_Routes__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css__ = __webpack_require__(295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Loader_Loader__ = __webpack_require__(106);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this));_this.handleLoader=function(){_this.setState({isLoading:false});};_this.state={isLoading:true,currentBrowser:Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["d" /* getBrowser */])()// https://tc39.github.io/ecma262/#sec-array.prototype.find
};if(!Array.prototype.find){Object.defineProperty(Array.prototype,'find',{value:function value(predicate){// 1. Let O be ? ToObject(this value).
if(this==null){throw new TypeError('"this" is null or not defined');}var o=Object(this);// 2. Let len be ? ToLength(? Get(O, "length")).
var len=o.length>>>0;// 3. If IsCallable(predicate) is false, throw a TypeError exception.
if(typeof predicate!=='function'){throw new TypeError('predicate must be a function');}// 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
var thisArg=arguments[1];// 5. Let k be 0.
var k=0;// 6. Repeat, while k < len
while(k<len){// a. Let Pk be ! ToString(k).
// b. Let kValue be ? Get(O, Pk).
// c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
// d. If testResult is true, return kValue.
var kValue=o[k];if(predicate.call(thisArg,kValue,k,o)){return kValue;}// e. Increase k by 1.
k++;}// 7. Return undefined.
return undefined;}});}return _this;}_createClass(App,[{key:'render',value:function render(){var _this2=this;var cssClass='desktopVersion ';if(Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["g" /* isMobile */])()){cssClass=' MobileVersion ';}var version=this.state.currentBrowser.version;version=parseInt(version);// alert(this.state.currentBrowser)
var html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App '+this.state.currentBrowser.name+'  '+this.state.currentBrowser.name+'-'+version+' '+cssClass},void window.scrollTo(0,0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Routes_Routes__["a" /* Routes */],null));if(this.state.isLoading===true){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'App '+this.state.currentBrowser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Loader_Loader__["a" /* default */],null));window.setTimeout(function(){_this2.handleLoader();},500);}return html;}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (App);

/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Routes; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Pages_Home_Home__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Pages_SpacielDeals_SpacielDeals__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Pages_ExporeTelAvivAndJerusalem_ExporeTelAvivAndJerusalem__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Pages_TermsOfUse_TermsOfUse__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Pages_ThingsToDo_ThingsToDo__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Pages_WhereToGo_WhereToGo__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Pages_FAQ_FAQ__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Pages_TelAvivPage_TelAvivPage__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Pages_JerusalemPage_JerusalemPage__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Pages_CulinaryPage_CulinaryPage__ = __webpack_require__(276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Pages_DeadSeaPage_DeadSeaPage__ = __webpack_require__(278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Pages_TouristInfo_TouristInfoPage__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Pages_EilatNegevPage_EilatNegevPage__ = __webpack_require__(282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Pages_NorthPage_NorthPage__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Pages_CoronaVirusPage_CoronaVirus__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Posts_Videos_Videos__ = __webpack_require__(288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Posts_Posts_Posts__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Pages_Gallery_TA_GalleryTA__ = __webpack_require__(292);
/*
DEFINE CLIENT APP ROUTS 
*/// pages
// Posts
// import ConcertsPosts from '../Posts/Concerts/Concerts';
// Gallery
// import GalleryJA from '../Pages/Gallery/JA/GalleryJA';
var Routes=function Routes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TelAvivPage',component:__WEBPACK_IMPORTED_MODULE_9__Pages_TelAvivPage_TelAvivPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/EilatNegevPage',component:__WEBPACK_IMPORTED_MODULE_14__Pages_EilatNegevPage_EilatNegevPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/NorthPage',component:__WEBPACK_IMPORTED_MODULE_15__Pages_NorthPage_NorthPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/JerusalemPage',component:__WEBPACK_IMPORTED_MODULE_10__Pages_JerusalemPage_JerusalemPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/CulinaryPage',component:__WEBPACK_IMPORTED_MODULE_11__Pages_CulinaryPage_CulinaryPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/DeadSeaPage',component:__WEBPACK_IMPORTED_MODULE_12__Pages_DeadSeaPage_DeadSeaPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TouristInfoPage',component:__WEBPACK_IMPORTED_MODULE_13__Pages_TouristInfo_TouristInfoPage__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/CoronaVirusPage',component:__WEBPACK_IMPORTED_MODULE_16__Pages_CoronaVirusPage_CoronaVirus__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/FAQ',component:__WEBPACK_IMPORTED_MODULE_8__Pages_FAQ_FAQ__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/thingsToDo',component:__WEBPACK_IMPORTED_MODULE_6__Pages_ThingsToDo_ThingsToDo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/whereToGo',component:__WEBPACK_IMPORTED_MODULE_7__Pages_WhereToGo_WhereToGo__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/bestDeals',component:__WEBPACK_IMPORTED_MODULE_3__Pages_SpacielDeals_SpacielDeals__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Gallery/:galleryId',component:__WEBPACK_IMPORTED_MODULE_19__Pages_Gallery_TA_GalleryTA__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Gallery/',component:__WEBPACK_IMPORTED_MODULE_19__Pages_Gallery_TA_GalleryTA__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/TermsOfUse',component:__WEBPACK_IMPORTED_MODULE_5__Pages_TermsOfUse_TermsOfUse__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Pages/Videos',component:__WEBPACK_IMPORTED_MODULE_4__Pages_ExporeTelAvivAndJerusalem_ExporeTelAvivAndJerusalem__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Posts/Videos/:ctgId/:vidId',component:__WEBPACK_IMPORTED_MODULE_17__Posts_Videos_Videos__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/Posts/:ctgId/:id',component:__WEBPACK_IMPORTED_MODULE_18__Posts_Posts_Posts__["a" /* default */]}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:'/',component:__WEBPACK_IMPORTED_MODULE_2__Pages_Home_Home__["a" /* default */]}));};

/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(50);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(162);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["a"] = (invariant);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(50);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(170);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(51);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(87);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(174);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(176);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(91);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(178);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(51);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(180);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(52);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(91);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(52);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(184);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(89);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_reactjs_popup__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Home_css__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Home_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__Home_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import {  DealItem  } from '../../Components/Deals/DealItem'
// import AgreeCookies from '../../Components/AgreeCookies/AgreeCookies'
// private class data
var galleryObj1={img:"Home/7.jpg",link:"/Pages/Gallery/ta",text:"TEL AVIV"};var galleryObj2={img:"Home/8.jpg",link:"/Pages/Gallery/ja",text:"JÉRUSALEM"};var galleryObj3={img:"Home/9.jpg",link:"/Pages/Gallery/deadsea",text:"LA MER MORTE"};var galleryObj4={img:"Home/10.jpg",link:"/Pages/Gallery/yp",text:"VOS PHOTOS"};// function Shuffle(o) {
//   for(var j, x, i = o.length; i; j = parseInt(Math.random() * i), x = o[--i], o[i] = o[j], o[j] = x);
//   return o;
// };
var Home=function(_Component){_inherits(Home,_Component);function Home(props){_classCallCheck(this,Home);var _this=_possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).call(this,props));_this.updateDimensions=function(){var w=window,d=document,documentElement=d.documentElement,body=d.getElementsByTagName("body")[0],width=w.innerWidth||documentElement.clientWidth||body.clientWidth;// height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
_this.setState({width:width});};_this.openModal=function(id){var url=Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["f" /* getUrl */])()+"instagram-api.php?ID="+id;// var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
__WEBPACK_IMPORTED_MODULE_4_axios___default.a.get(url,{}).then(function(res){var obj=res.data;var userinfo=obj.graphql.shortcode_media;var likes=userinfo.edge_media_preview_like.count;var username=userinfo.owner.username;var caption=userinfo.edge_media_to_caption.edges[0].node.text;var userProfileImg=userinfo.owner.profile_pic_url;// console.log(username);
_this.setState({open:true,instagramId:id,instagramUserImg:userProfileImg,instagramCaption:caption,instagramUserName:username,instagramLikes:likes});});};_this.closeModal=function(){_this.setState({open:false});};_this.playVideo=function(event){// alert(this.state.imageState);
_this.setState({imageState:false});};_this.playVideo2=function(event){// alert(this.state.imageState);
_this.setState({imageState2:false});};_this.playVideo3=function(event){// alert(this.state.imageState);
_this.setState({imageState3:false});};_this.playVideo4=function(event){// alert(this.state.imageState);
_this.setState({imageState4:false});};_this.playVideo5=function(event){// alert(this.state.imageState);
_this.setState({imageState5:false});};_this.playVideo6=function(event){// alert(this.state.imageState);
_this.setState({imageState6:false});};_this.playVideo7=function(event){// alert(this.state.imageState);
_this.setState({imageState7:false});};_this.playVideo8=function(event){// alert(this.state.imageState);
_this.setState({imageState8:false});};_this.playVideo9=function(event){// alert(this.state.imageState);
_this.setState({imageState9:false});};_this.playVideo10=function(event){// alert(this.state.imageState);
_this.setState({imageState10:false});};_this.closeAlert=function(event){document.getElementById("travel-alert").style.display="none";};_this.setVideoMobile=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId1:vidId,MobileVidId1Elm:id});};_this.setVideoMobile2=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId2:vidId,MobileVidId2Elm:id});};_this.setVideoMobile3=function(vidId,id){// alert('setVideoMobile : ' +   vidId);
_this.setState({MobileVidId3:vidId,MobileVidId3Elm:id});};_this.setVideo=function(vidId,ctg){// alert("ss");
if(ctg==="culinary"||ctg==="culinarytelaviv"||ctg==="culinaryjerusalem"||ctg==="culinarynorth"){_this.setState({culinaryVid:vidId});var e=document.getElementById("CULINARY");__WEBPACK_IMPORTED_MODULE_2_react_scroll__["animateScroll"].scrollTo(e.offsetTop-100);if(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */]){_this.setState({imageState7:false});}}else{var elm=document.getElementById("expore-tel-aviv-and-jerusalem");__WEBPACK_IMPORTED_MODULE_2_react_scroll__["animateScroll"].scrollTo(elm.offsetTop-100);_this.setState({exporeTelAvivAndjerusalemMainVid:vidId});if(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */]){_this.setState({imageState8:false});}}};_this.setCurrentFaq=function(id){var faq=[].concat(_toConsumableArray(_this.state.faq));var current=faq.find(function(o){return o.id===id;});if(current.isOpen===true){current.isOpen=false;}else{current.isOpen=true;}_this.setState({faq:faq});};_this.handleisVidClick=function(){_this.setState({isVidClick:!_this.state.isVidClick});};_this.playVideo=_this.playVideo.bind(_this);_this.playVideo2=_this.playVideo2.bind(_this);_this.playVideo3=_this.playVideo3.bind(_this);_this.playVideo4=_this.playVideo4.bind(_this);_this.state={isVidClick:false,instagramData:[],instagramDataMobile:[],northArrMobile:[],// isLoading : true;
// exporeTelAvivAndjerusalemMainVid: "5nqL-oIC0GA", old video
// exporeTelAvivAndjerusalemMainVid: "nLKWDp5uA-U", changed at 17.05.2020
exporeTelAvivAndjerusalemMainVid:"FYtk8JMMZRE",eurovisionMainVid:"5PAjhoH0NWU",TelAvivAndjerusalemVideoState:0,culinaryVid:"jfyHxk8ZRrI",culinaryVidState:0,faq:__WEBPACK_IMPORTED_MODULE_8__Data_Data__["b" /* faqData */],telAvivWeather:20,waterTemp:20,jerusalemWeather:20,deadSeaWeather:15,shirCssClass:" btn-shir",supportCssClass:" new-support-btn",open:false,instagramId:null,instagramUserImg:null,instagramCaption:null,instagramUserName:null,instagramLikes:null,imageState:true,imageState2:true,imageState3:true,imageState4:true,imageState5:true,imageState6:true,imageState7:true,imageState8:true,imageState9:true,imageState10:true,width:0,MobileVidId1:"",MobileVidId1Elm:"",MobileVidId2:"",MobileVidId2Elm:"",MobileVidId3:"",MobileVidId3Elm:"",isInit:true};return _this;}_createClass(Home,[{key:"componentWillMount",value:function componentWillMount(){this.updateDimensions();}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("resize",this.updateDimensions);}// componentDidMount() {
//   Promise.all([asyncgetWeather(), geinstagramData()]).then((response) => {
//     const weather = response[0];
//     const instagramData = response[1];
//     // if ( weather.length > 0 ) {
//     this.setState({
//       instagramData: instagramData.posts,
//       deadSeaWeather: weather.deadsea.temperature,
//       jerusalemWeather: weather.jerusalem.temperature,
//       telAvivWeather: weather.telaviv.temperature,
//       waterTemp: weather.telaviv.water_temp,
//     });
//     // }
//   });
//   window.addEventListener("resize", this.updateDimensions);
// }
},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["a" /* asyncgetWeather */])(),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["c" /* geinstagramData */])()]).then(function(response){var weather=response[0];var instagramData=response[1];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({instagramData:instagramData.posts,jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({instagramData:instagramData.posts,jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({instagramData:instagramData.posts,jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}//This was added for mobile youtube butn play
},{key:"render",value:function render(){var _this3=this;var sliderSettings={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:"linear",slidesToShow:this.props.items!==undefined?this.props.items:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1}}]};var sliderSettings2={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:"linear",slidesToShow:this.props.items!==undefined?this.props.items:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:1}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1}}]};var culinaryArr=[];var postsArr=[];var videoArr=[];var eurovisionArr=[];var eilatNegevArr=[];var jerusalemArr=[];var telavivArr=[];var northArr=[];var deadseaArr=[];__WEBPACK_IMPORTED_MODULE_8__Data_Data__["c" /* newPosts */].map(function(o){// console.log('o' , o);
if(o.ctg==="culinary"||o.ctg==="culinarytelaviv"||o.ctg==="culinaryjerusalem"||o.ctg==="culinarynorth"){culinaryArr.push(o);}else if(o.ctg==="eurovision"){eurovisionArr.push(o);}else if(o.ctg==="eilat-negev"){eilatNegevArr.push(o);}else if(o.ctg==="north"){northArr.push(o);}else if(o.ctg==="jerusalem"){jerusalemArr.push(o);}else if(o.ctg==="telaviv"){telavivArr.push(o);}else if(o.ctg==="deadsea"){deadseaArr.push(o);}else{postsArr.push(o);}});// console.log("newVideos:", newVideos);
__WEBPACK_IMPORTED_MODULE_8__Data_Data__["d" /* newVideos */].map(function(o){// console.log('o' , o);
if(o.isVid===true||o.forVidPage===true){videoArr.push(o);}});// videoArr = Shuffle(videoArr);
// console.log('Shuffle vid' , videoArr);
var videoMobileArr=[];if(videoArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(videoArr.length){// console.log( 'easd' ,  postsArr.splice(0,4) );
videoMobileArr.push(videoArr.splice(0,size));}}var videosHtml=null;if(videoMobileArr.length>0){videosHtml=videoMobileArr.map(function(arr,i){return arr.map(function(o,i){// var title = o.title;
var url="Posts/"+o.ctg+"/"+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:o.desc,img:o.img,link:url,doBlank:true,mobileId:"",click:function click(){_this3.setVideo(o.vidId,o.ctg);}});});});videosHtml=videosHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var postsHtml=postsArr.map(function(o,i){// const url = "/Posts/" + o.id ;
var url="/Posts/"+o.ctg+"/"+o.id;if(o.hasOwnProperty("showOnHome")&&o.showOnHome===false){}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});}});var deadseamObileArr=[];if(deadseaArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(deadseaArr.length){// console.log( 'easd' ,  deadseaArr.splice(0,4) );
deadseamObileArr.push(deadseaArr.splice(0,size));}}var deadseaPostsHtml=null;if(deadseamObileArr.length>0){deadseaPostsHtml=deadseamObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});deadseaPostsHtml=deadseaPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var eilatNegevmObileArr=[];if(eilatNegevArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(eilatNegevArr.length){// console.log( 'easd' ,  eilatNegevArr.splice(0,4) );
eilatNegevmObileArr.push(eilatNegevArr.splice(0,size));}}var eilatNegevPostsHtml=null;if(eilatNegevmObileArr.length>0){eilatNegevPostsHtml=eilatNegevmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});eilatNegevPostsHtml=eilatNegevPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var jerusalemmObileArr=[];if(jerusalemArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(jerusalemArr.length){// console.log( 'easd' ,  jerusalemArr.splice(0,4) );
jerusalemmObileArr.push(jerusalemArr.splice(0,size));}}var jerusalemPostsHtml=null;if(jerusalemmObileArr.length>0){jerusalemPostsHtml=jerusalemmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});jerusalemPostsHtml=jerusalemPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var telavivmObileArr=[];if(telavivArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(telavivArr.length){// console.log( 'easd' ,  telavivArr.splice(0,4) );
telavivmObileArr.push(telavivArr.splice(0,size));}}var telavivPostsHtml=null;if(telavivmObileArr.length>0){telavivPostsHtml=telavivmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});telavivPostsHtml=telavivPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var northmObileArr=[];if(northArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(northArr.length){// console.log( 'easd' ,  northArr.splice(0,4) );
northmObileArr.push(northArr.splice(0,size));}}var northPostsHtml=null;if(northmObileArr.length>0){northPostsHtml=northmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});northPostsHtml=northPostsHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var culinaryMobileArr=[];if(culinaryArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(culinaryArr.length){// console.log( 'easd' ,  culinaryArr.splice(0,4) );
culinaryMobileArr.push(culinaryArr.splice(0,size));}}var culinaryHtml=null;if(culinaryMobileArr.length>0){culinaryHtml=culinaryMobileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;var url="Posts/"+o.ctg+"/"+o.id;// if ( this.state.width < 1000 ){
//     title = o.title + ' >';
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:o.desc,img:o.img,link:url,doBlank:true,mobileId:"",click:function click(){_this3.setVideo(o.vidId,o.ctg);}});});});culinaryHtml=culinaryHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var eurovisionHtml=eurovisionArr.map(function(o,i){// const url = "/Posts/" + o.id ;
var url="/Posts/"+o.ctg+"/"+o.id;if(o.hasOwnProperty("showOnHome")&&o.showOnHome===false){}else{return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});}});var date1=new Date();var hasBean=[];var notHasBean=[];__WEBPACK_IMPORTED_MODULE_8__Data_Data__["e" /* showsArr */].map(function(o,i){var isTodayBigger=Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["b" /* compareDates */])(date1,o.date);if(isTodayBigger===true||o.date==="30.12.2017"||o.date==="21.06.2018"){// o.cssClass +=" addOpacity ";
// hasBean.push(o);
}else{o.cssClass="";notHasBean.push(o);}});// marge two array into array
var newshowsArr=[].concat(notHasBean,hasBean);var concertsmObileArr=[];if(newshowsArr.length>0){var size=1;if(this.state.width<1000){size=2;}if(this.state.width<600){size=4;}while(newshowsArr.length){// console.log( 'easd' ,  newshowsArr.splice(0,4) );
concertsmObileArr.push(newshowsArr.splice(0,size));}}var concertSHtml=null;if(concertsmObileArr.length>0){concertSHtml=concertsmObileArr.map(function(arr,i){return arr.map(function(o,i){var title=o.title;if(_this3.state.width<1000){title=o.title;}var url="Posts/Concerts/"+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:title,desc:o.sml_desc,doBlank:true,img:o.img,link:url});});});concertSHtml=concertSHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var faqHtml=this.state.faq.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["d" /* FaqItem */],{q:o.q,key:o.id,answer:o.answer,isOpen:o.isOpen,click:function click(){_this3.setCurrentFaq(o.id);}});});var instagramHtml=null;var img1Url="Home/Mobile/1.jpg";var img2Url="Home/Mobile/2.jpg";var img3Url="Home/Mobile/3.jpg";var img4Url="Home/Mobile/4.jpg";var callToActionHtml="";var twoCitesOneBreakVid="";var euroVisionVid="";var culinaryVid="";var galleryHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:galleryObj1.img,cssClass:"col-100",link:galleryObj1.link,text:galleryObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:galleryObj3.img,cssClass:"col-100",link:galleryObj3.link,text:galleryObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:galleryObj2.img,cssClass:"col-100",link:galleryObj2.link,text:galleryObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:galleryObj4.img,cssClass:"col-100",link:galleryObj4.link,text:galleryObj4.text}));if(this.state.width>1000){callToActionHtml=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["b" /* AnimateCallToAction */],{src:"btn_shir.png",cssClass:this.state.shirCssClass,link:"/international/Pages/bestDeals"}));img1Url="Home/1.jpg";img2Url="Home/2.jpg";img3Url="Home/3.jpg";img4Url="Home/4.jpg";{/*euroVisionVid = <div className="hide-on-mobile">
                <ResponsiveYouTubeIframe vidId={this.state.eurovisionMainVid}  />
              </div>*/}{/*twoCitesOneBreakVid = <div className="hide-on-mobile">
                <ResponsiveYouTubeIframe vidId={this.state.exporeTelAvivAndjerusalemMainVid}  />
              </div>*/}{/*culinaryVid = <div className="hide-on-mobile">
        <ResponsiveYouTubeIframe vidId={this.state.culinaryVid} />
      </div>
      galleryHTML = <div className="row more-info-row">
                      <ImgAndText img={galleryObj1.img} cssClass={" col-33"} link={galleryObj1.link} text={galleryObj1.text} />
                      <ImgAndText img={galleryObj2.img} cssClass={" col-33"} link={galleryObj2.link} text={galleryObj2.text} />
                      <ImgAndText img={galleryObj3.img} cssClass={" col-33"} link={galleryObj3.link} text={galleryObj3.text} />

                  </div>*/}}else{galleryHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:galleryObj1.img,cssClass:" col-33",link:galleryObj1.link,text:galleryObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:galleryObj2.img,cssClass:" col-33",link:galleryObj2.link,text:galleryObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:galleryObj3.img,cssClass:" col-33",link:galleryObj3.link,text:galleryObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:galleryObj4.img,cssClass:" col-33",link:galleryObj4.link,text:galleryObj4.text}));}var instagramData=this.state.instagramData;// console.log('instagramData: ' , instagramData);
var insta_size=2;// if ( this.state.width < 1000 ) {
//     size = 4;
// }
if(this.state.width<600){insta_size=4;}if(instagramData.length>0){while(instagramData.length>0){this.state.instagramDataMobile.push(instagramData.splice(0,insta_size));}}if(this.state.instagramDataMobile.length>0){instagramHtml=this.state.instagramDataMobile.map(function(arr,i){return arr.map(function(o,i){var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:o.id,onClick:function onClick(){_this3.openModal(o.id);}}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["k" /* InstagremSliderItem */],{title:o.publishBy,cssClass:"InstagremSliderItem-"+i,img:imgLink}));});});// console.log('instagramHtml2' , instagramHtml2);
instagramHtml=instagramHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:i},o);});}var currentInstagramLikeUrl="https://www.instagram.com/p/"+this.state.instagramId+"/";var currentInstagramUrl="https://www.instagram.com/"+this.state.instagramUserName+"/";var currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";var a=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["g" /* HomeSlider */],{isHomeSlider:true,waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}));// if ( this.state.isVidClick === true ){
//   a = <section className="home-section caruasel-wrapper banners-caruasel-wrapper" id="part-1" >
//   <ResponsiveYouTubeIframe vidId={"5PAjhoH0NWU"} />
//   </section>
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page align-center page-home"},callToActionHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["o" /* TravelAlert */],{click:this.closeAlert}),a,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["f" /* HomeDeals */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section hide-on-mobile",id:"weather-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,"INFOS DIVERSES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"weather-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* WeatherIcon */],{label:"TEMPS DE VOL",temp:"4h 15m"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* WeatherIcon */],{label:"TEMPÉRATURE DE L'EAU",temp:this.state.waterTemp}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* WeatherIcon */],{label:"MÉTÉO DE TEL AVIV",temp:this.state.telAvivWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* WeatherIcon */],{label:"MÉTÉO DE JÉRUSALEM",temp:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["q" /* WeatherIcon */],{label:"MÉTÉO DE LA MER MORTE",temp:this.state.deadSeaWeather}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"eurovision"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),euroVisionVid,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},eurovisionHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"video"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,"PLANIFIEZ VOTRE VOYAGE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-explure-israel.jpg",click:this.playVideo}):// <ResponsiveYouTubeIframe vidId={"CV2TtpIHrrk"} />
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"NNvJf5CR_Q8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"more-info-wrapper add-margin-top"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:img1Url,cssClass:"first",link:"/Pages/whereToGo",text:"OÙ ALLER >"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:img2Url,cssClass:"last",link:"/Pages/thingsToDo",text:" À FAIRE >"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row more-info-row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:img4Url,cssClass:"first",link:"/Pages/TouristInfoPage",text:"INFO. TOURISTIQUES >"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["j" /* ImgAndText */],{img:img3Url,cssClass:"last",link:"/Pages/Videos",text:"VIDEOS >"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"expore-tel-aviv-and-jerusalem"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/thingsToDo",className:"ac-plan-your-trip"},"PLUS DE CHOSES \xC0 FAIRE !")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState8?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-more-things-todo.jpg",click:this.playVideo8}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:this.state.exporeTelAvivAndjerusalemMainVid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"jerusalem-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/JerusalemPage",className:"ac-jerusalem-posts"},"J\xC9RUSALEM")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState9?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-jerusalem.jpg",click:this.playVideo9}):// <ResponsiveYouTubeIframe vidId={"nLKWDp5uA-U"} />
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"9oZqdBNExTo"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},jerusalemPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"telaviv-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/TelavivPage",className:"ac-telaviv-posts"},"TEL AVIV")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState10?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-telaviv.jpg",click:this.playVideo10}):// <ResponsiveYouTubeIframe vidId={"jsTzRtTCvWg"} />
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"T9_kBElXdPI"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},telavivPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:100},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"CULINARY"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/CulinaryPage",className:"ac-coolinary-exp"},"LA MEILLEURE EXP\xC9RIENCE GASTRONOMIQUE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState7?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-culinary.jpg",click:this.playVideo7}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:this.state.culinaryVid}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},culinaryHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"deadsea-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/DeadSeaPage",className:"ac-dead-posts"},"LA MER MORTE")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState2?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-deadsea.jpg",click:this.playVideo2}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"8p4qfkneH1c"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},deadseaPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"eilat-negev-posts"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/EilatNegevPage",className:"ac-eilat-negev-posts"},"NEGEV ET EILAT")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState3?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-negev-eilat.jpg",click:this.playVideo3}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"ZdnNT-GDJv4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},eilatNegevPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"north"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/NorthPage",className:"ac-north-posts"},"NORD")),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState4?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-north.jpg",click:this.playVideo4}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"fZ_WdHpHRT8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings2},northPostsHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,"VOS PHOTOS D'I ISRA\xCBL"),Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["g" /* isMobile */])()&&this.state.imageState5?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["a" /* ActivaImg */],{src:"PostCarousel/video_mob/activa-img-insta.jpg",click:this.playVideo5}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"z0OoUqKkwwM"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-credit-home"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Credit:Fabio Wibmer")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},instagramHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"shows"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/liveShows",className:"ac-shows"}," ","SPECTACLES ET \xC9V\xC9NEMENTS ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",{className:"show-om-mobile"}),"INTERNATIONAUX - EN DIRECT")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"video-slider-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},concertSHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"gallery"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/Gallery/",className:"ac-gallery-home-page"},"GALERIE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),galleryHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding ",id:"faq"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:"/Pages/FAQ",className:"ac-faq"},"FOIRE AUX QUESTIONS")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faq-wrapper"},faqHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["f" /* HomeDeals */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_lazyload___default.a,{height:200,once:true,offset:400},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Components_Footer_Footer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"close",onClick:this.closeModal},"\xD7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userImgInstagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* Img */],{desktopImg:currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-info-instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userProfileImgWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.instagramUserImg})),"@",this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"instagramCaption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_6__Utility_Utility__["h" /* limitText */])(this.state.instagramCaption,130):""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"like-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_UI_UI__["i" /* Img */],{desktopImg:"like.png"}))))));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Home);

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(53);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(55);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(53);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'input',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(95);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(3);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` from props
      var newProps = _extends({}, this.props);
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(22);

var utils = __webpack_require__(32);
var scrollSpy = __webpack_require__(54);
var defaultScroller = __webpack_require__(31);
var PropTypes = __webpack_require__(3);
var scrollHash = __webpack_require__(94);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var bind = __webpack_require__(97);
var Axios = __webpack_require__(196);
var defaults = __webpack_require__(58);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(101);
axios.CancelToken = __webpack_require__(209);
axios.isCancel = __webpack_require__(100);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(210);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(58);
var utils = __webpack_require__(8);
var InterceptorManager = __webpack_require__(204);
var dispatchRequest = __webpack_require__(205);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(99);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);
var transformData = __webpack_require__(206);
var isCancel = __webpack_require__(100);
var defaults = __webpack_require__(58);
var isAbsoluteURL = __webpack_require__(207);
var combineURLs = __webpack_require__(208);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(8);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(101);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.on = on;
exports.off = off;
function on(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.addEventListener) {
    el.addEventListener(eventName, callback, opts);
  } else if (el.attachEvent) {
    el.attachEvent("on" + eventName, function (e) {
      callback.call(el, e || window.event);
    });
  }
}

function off(el, eventName, callback, opts) {
  opts = opts || false;
  if (el.removeEventListener) {
    el.removeEventListener(eventName, callback, opts);
  } else if (el.detachEvent) {
    el.detachEvent("on" + eventName, callback);
  }
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

/**
 * @fileOverview Find scroll parent
 */

exports.default = function (node) {
  if (!(node instanceof HTMLElement)) {
    return document.documentElement;
  }

  var excludeStaticParent = node.style.position === 'absolute';
  var overflowRegex = /(scroll|auto)/;
  var parent = node;

  while (parent) {
    if (!parent.parentNode) {
      return node.ownerDocument || document.documentElement;
    }

    var style = window.getComputedStyle(parent);
    var position = style.position;
    var overflow = style.overflow;
    var overflowX = style['overflow-x'];
    var overflowY = style['overflow-y'];

    if (position === 'static' && excludeStaticParent) {
      parent = parent.parentNode;
      continue;
    }

    if (overflowRegex.test(overflow) && overflowRegex.test(overflowX) && overflowRegex.test(overflowY)) {
      return parent;
    }

    parent = parent.parentNode;
  }

  return node.ownerDocument || node.documentElement || document.documentElement;
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = debounce;
function debounce(func, wait, immediate) {
  var timeout = void 0;
  var args = void 0;
  var context = void 0;
  var timestamp = void 0;
  var result = void 0;

  var later = function later() {
    var last = +new Date() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) {
          context = null;
          args = null;
        }
      }
    }
  };

  return function debounced() {
    context = this;
    args = arguments;
    timestamp = +new Date();

    var callNow = immediate && !timeout;
    if (!timeout) {
      timeout = setTimeout(later, wait);
    }

    if (callNow) {
      result = func.apply(context, args);
      context = null;
      args = null;
    }

    return result;
  };
}

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = throttle;
/*eslint-disable */
function throttle(fn, threshhold, scope) {
  threshhold || (threshhold = 250);
  var last, deferTimer;
  return function () {
    var context = scope || this;

    var now = +new Date(),
        args = arguments;
    if (last && now < last + threshhold) {
      // hold on to it
      clearTimeout(deferTimer);
      deferTimer = setTimeout(function () {
        last = now;
        fn.apply(context, args);
      }, threshhold);
    } else {
      last = now;
      fn.apply(context, args);
    }
  };
}

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(216);


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(217);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 217 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserInfo = /** @class */ (function () {
    function BrowserInfo(name, version, os) {
        this.name = name;
        this.version = version;
        this.os = os;
    }
    return BrowserInfo;
}());
exports.BrowserInfo = BrowserInfo;
var NodeInfo = /** @class */ (function () {
    function NodeInfo(version) {
        this.version = version;
        this.name = 'node';
        this.os = process.platform;
    }
    return NodeInfo;
}());
exports.NodeInfo = NodeInfo;
var BotInfo = /** @class */ (function () {
    function BotInfo() {
        this.bot = true; // NOTE: deprecated test name instead
        this.name = 'bot';
        this.version = null;
        this.os = null;
    }
    return BotInfo;
}());
exports.BotInfo = BotInfo;
// tslint:disable-next-line:max-line-length
var SEARCHBOX_UA_REGEX = /alexa|bot|crawl(er|ing)|facebookexternalhit|feedburner|google web preview|nagios|postrank|pingdom|slurp|spider|yahoo!|yandex/;
var SEARCHBOT_OS_REGEX = /(nuhk)|(Googlebot)|(Yammybot)|(Openbot)|(Slurp)|(MSNBot)|(Ask Jeeves\/Teoma)|(ia_archiver)/;
var REQUIRED_VERSION_PARTS = 3;
var userAgentRules = [
    ['aol', /AOLShield\/([0-9\._]+)/],
    ['edge', /Edge\/([0-9\._]+)/],
    ['edge-ios', /EdgiOS\/([0-9\._]+)/],
    ['yandexbrowser', /YaBrowser\/([0-9\._]+)/],
    ['vivaldi', /Vivaldi\/([0-9\.]+)/],
    ['kakaotalk', /KAKAOTALK\s([0-9\.]+)/],
    ['samsung', /SamsungBrowser\/([0-9\.]+)/],
    ['silk', /\bSilk\/([0-9._-]+)\b/],
    ['miui', /MiuiBrowser\/([0-9\.]+)$/],
    ['beaker', /BeakerBrowser\/([0-9\.]+)/],
    ['edge-chromium', /Edg\/([0-9\.]+)/],
    [
        'chromium-webview',
        /(?!Chrom.*OPR)wv\).*Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/,
    ],
    ['chrome', /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/],
    ['phantomjs', /PhantomJS\/([0-9\.]+)(:?\s|$)/],
    ['crios', /CriOS\/([0-9\.]+)(:?\s|$)/],
    ['firefox', /Firefox\/([0-9\.]+)(?:\s|$)/],
    ['fxios', /FxiOS\/([0-9\.]+)/],
    ['opera-mini', /Opera Mini.*Version\/([0-9\.]+)/],
    ['opera', /Opera\/([0-9\.]+)(?:\s|$)/],
    ['opera', /OPR\/([0-9\.]+)(:?\s|$)/],
    ['ie', /Trident\/7\.0.*rv\:([0-9\.]+).*\).*Gecko$/],
    ['ie', /MSIE\s([0-9\.]+);.*Trident\/[4-7].0/],
    ['ie', /MSIE\s(7\.0)/],
    ['bb10', /BB10;\sTouch.*Version\/([0-9\.]+)/],
    ['android', /Android\s([0-9\.]+)/],
    ['ios', /Version\/([0-9\._]+).*Mobile.*Safari.*/],
    ['safari', /Version\/([0-9\._]+).*Safari/],
    ['facebook', /FBAV\/([0-9\.]+)/],
    ['instagram', /Instagram\s([0-9\.]+)/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Mobile/],
    ['ios-webview', /AppleWebKit\/([0-9\.]+).*Gecko\)$/],
    ['searchbot', SEARCHBOX_UA_REGEX],
];
var operatingSystemRules = [
    ['iOS', /iP(hone|od|ad)/],
    ['Android OS', /Android/],
    ['BlackBerry OS', /BlackBerry|BB10/],
    ['Windows Mobile', /IEMobile/],
    ['Amazon OS', /Kindle/],
    ['Windows 3.11', /Win16/],
    ['Windows 95', /(Windows 95)|(Win95)|(Windows_95)/],
    ['Windows 98', /(Windows 98)|(Win98)/],
    ['Windows 2000', /(Windows NT 5.0)|(Windows 2000)/],
    ['Windows XP', /(Windows NT 5.1)|(Windows XP)/],
    ['Windows Server 2003', /(Windows NT 5.2)/],
    ['Windows Vista', /(Windows NT 6.0)/],
    ['Windows 7', /(Windows NT 6.1)/],
    ['Windows 8', /(Windows NT 6.2)/],
    ['Windows 8.1', /(Windows NT 6.3)/],
    ['Windows 10', /(Windows NT 10.0)/],
    ['Windows ME', /Windows ME/],
    ['Open BSD', /OpenBSD/],
    ['Sun OS', /SunOS/],
    ['Chrome OS', /CrOS/],
    ['Linux', /(Linux)|(X11)/],
    ['Mac OS', /(Mac_PowerPC)|(Macintosh)/],
    ['QNX', /QNX/],
    ['BeOS', /BeOS/],
    ['OS/2', /OS\/2/],
    ['Search Bot', SEARCHBOT_OS_REGEX],
];
function detect(userAgent) {
    if (!!userAgent) {
        return parseUserAgent(userAgent);
    }
    if (typeof navigator !== 'undefined') {
        return parseUserAgent(navigator.userAgent);
    }
    return getNodeVersion();
}
exports.detect = detect;
function parseUserAgent(ua) {
    // opted for using reduce here rather than Array#first with a regex.test call
    // this is primarily because using the reduce we only perform the regex
    // execution once rather than once for the test and for the exec again below
    // probably something that needs to be benchmarked though
    var matchedRule = ua !== '' &&
        userAgentRules.reduce(function (matched, _a) {
            var browser = _a[0], regex = _a[1];
            if (matched) {
                return matched;
            }
            var uaMatch = regex.exec(ua);
            return !!uaMatch && [browser, uaMatch];
        }, false);
    if (!matchedRule) {
        return null;
    }
    var name = matchedRule[0], match = matchedRule[1];
    if (name === 'searchbot') {
        return new BotInfo();
    }
    var versionParts = match[1] && match[1].split(/[._]/).slice(0, 3);
    if (versionParts) {
        if (versionParts.length < REQUIRED_VERSION_PARTS) {
            versionParts = __spreadArrays(versionParts, createVersionParts(REQUIRED_VERSION_PARTS - versionParts.length));
        }
    }
    else {
        versionParts = [];
    }
    return new BrowserInfo(name, versionParts.join('.'), detectOS(ua));
}
exports.parseUserAgent = parseUserAgent;
function detectOS(ua) {
    for (var ii = 0, count = operatingSystemRules.length; ii < count; ii++) {
        var _a = operatingSystemRules[ii], os = _a[0], regex = _a[1];
        var match = regex.test(ua);
        if (match) {
            return os;
        }
    }
    return null;
}
exports.detectOS = detectOS;
function getNodeVersion() {
    var isNode = typeof process !== 'undefined' && process.version;
    return isNode ? new NodeInfo(process.version.slice(1)) : null;
}
exports.getNodeVersion = getNodeVersion;
function createVersionParts(count) {
    var output = [];
    for (var ii = 0; ii < count; ii++) {
        output.push('0');
    }
    return output;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/*
 * Validator Class 
 * @DESC  simplae validation class
*/var Validator=function(){function Validator(){_classCallCheck(this,Validator);}_createClass(Validator,[{key:'simpleValidation',value:function simpleValidation(o){if(o.val===''){this.show_popup(o.err_1);return false;}else{return true;}}// email validation 
},{key:'email_validation',value:function email_validation(o){if(o.val===""){this.show_popup(o.err_1);return false;}else{if(o.expression.test(o.val)===false){this.show_popup(o.err_2);return false;}else{return true;}}}// regx validation 
},{key:'regx_validation',value:function regx_validation(obj){if(obj.val===''){this.show_popup(obj.err_1);return false;}else{if(obj.expression.test(obj.val)){return true;}else{this.show_popup(obj.err_2);return false;}}}// alert 
},{key:'show_popup',value:function show_popup(msg){alert(msg);}}]);return Validator;}();/* harmony default export */ __webpack_exports__["a"] = (Validator);

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
var Http=__WEBPACK_IMPORTED_MODULE_0_axios___default.a.create({// baseURL: 'https://en.citiesbreak.com',
});/* harmony default export */ __webpack_exports__["a"] = (Http);

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(222);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(223);

var _json2mq = __webpack_require__(230);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(232);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(233);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(22);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(224);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(225);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(33);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(34);

var _track = __webpack_require__(226);

var _dots = __webpack_require__(227);

var _arrows = __webpack_require__(228);

var _resizeObserverPolyfill = __webpack_require__(229);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(33);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(33);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(33);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(34);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(21)))

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(231);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 231 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(234);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(235);
var Util = __webpack_require__(103);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(236);
var each = __webpack_require__(103).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 236 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 237 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 238 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 239 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Deals_css__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Deals_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Deals_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__DealItem__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UI_UI_js_p1__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__UI_UI_js_p1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__UI_UI_js_p1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Deals=function(_Component){_inherits(Deals,_Component);function Deals(props){_classCallCheck(this,Deals);var _this=_possibleConstructorReturn(this,(Deals.__proto__||Object.getPrototypeOf(Deals)).call(this,props));_this.image_url=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["e" /* getImgUrl */])();_this.dealsSliderSettings={dots:true,infinite:true,cssEase:'linear',autoplay:false,lazyLoad:"ondemand",slidesToShow:_this.props.items!=undefined?_this.props.items:3,slidesToScroll:1,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:1,slidesToScroll:1}}]};_this.deals=[{price:"550 €",title:"Evaneos",desc:"City break Tel Aviv - 5J/4N",link:"https://www.evaneos.fr/israel/itineraire/14253-city-break-tel-aviv-5-jours-4-nuits/",logo:"/Deals/Evaneos.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"953 €",title:"Lidl voyages",desc:"AUTOKIBBOUTZ - 8J/7N LOC. DE VOITURE",link:"https://www.lidl-voyages.fr/product.html?s_pid=231508#ref_dd=11&ref_dmy=06/2022&ref_aj=0&ref_minMan=7,7&ref_mmd=8,8&ref_dpci=LYS&s_c.PRODUCT_TYPE=CIRCUIT&s_c.DEST=ISR&fromSerp=1",logo:"/Deals/Lidlvoyages.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"980 €",title:"Maison du Voyage",desc:"Jérusalem Autrement",link:"https://www.maisonsduvoyage.com/orient/israel",logo:"/Deals/MaisonduVoyage.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"1142 €",title:"Voyamar",desc:"L'ETOILE - ESCAPADE AUTOUR DE TEL AVIV - 8J/7N",link:"https://www.voyamar-vacances.com/product.cms?s_pid=39938&s_c.de=IL.TLV&s_dmy=05/2022&s_dd=19&s_aj=2&s_dpci=GVA&s_c.type=circuits_autotours",logo:"/Deals/Voyamar.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"1167 €",title:"Selectour",desc:"AUTOTOUR DES 4 MERS - 8J/7N",link:"https://www.selectour.com/israel/circuit",logo:"/Deals/Selectour.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"1500 €",title:"Voyageurs du Monde",desc:"Tel-Aviv solaire - Week-end énergique et (pluri) culturel",link:"https://www.voyageursdumonde.fr/voyage-sur-mesure/idees-voyage/week-end-en-ville/israel-94",logo:"/Deals/VoyageursduMonde.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"1590 €",title:"Salaün Holidays",desc:"Circuit découvertes en Israël - 8J/7N",link:"https://www.salaun-holidays.com/recherche-circuit,israel-2-92-0-0.html",logo:"/Deals/SalaünHolidays.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"1539 €",title:"VisitEurope",desc:"Circuit TRÉSOR HISTORIQUE ET CULTUREL",link:"https://www.visiteurope.fr/circuit-israel/circuit-israel-israel-tresor-historique-et-culturel-14764.html#ref_dd=07&ref_dmy=05/2022&ref_aj=0&ref_minMan=7,7&ref_mmd=8,8&ref_dpci=BRU",logo:"/Deals/VisitEurope.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"1869 €",title:"Nomade Aventure",desc:"Au cœur de l'Histoire et des Peuples",link:"https://www.nomade-aventure.com/voyage-aventure/israel/voyage-palestine/pal04",logo:"/Deals/NomadeAventure.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"2099 €",title:"Carrefour Voyages",desc:"Circuit Israël en liberté - 8J/7N",link:"https://voyages.carrefour.fr/circuits/jerusalem/tel-aviv/circuit-israel-en-liberte?pageType=product&s_pid=337335#ref_dd=14&ref_dmy=11/2022&ref_aj=0&ref_minMan=7,7&ref_mmd=8,8&ref_dpci=PAR",logo:"/Deals/CarrefourVoyages.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"2149 €",title:"Nouvelles Frontières",desc:"Circuit Terre d'Histoire - 8J/7N",link:"https://www.tui.fr/circuit-terre-dhistoire_ISRCT002/?duration=7&departuredate=18092022&departurecitycode=PAR",logo:"/Deals/NouvellesFrontières.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"2210 €",title:"Arts et Vie",desc:"Circuit de la Galilée à la mer Morte - 8J/7N",link:"https://www.artsetvie.com/circuit/israel/circuit-en-israel-de-la-galilee-a-la-mer-morte-188.html",logo:"/Deals/ArtsetVie.jpg",book_now:"RÉSERVEZ MAINTENANT"},{price:"3190 €",title:"Club Med",desc:"Carrefour du temps",link:"https://www.clubmed.fr/i/carrefour-du-temps/y",logo:"/Deals/ClubMed.jpg",book_now:"RÉSERVEZ MAINTENANT"}];return _this;}_createClass(Deals,[{key:'render',value:function render(){var dealsHtml=this.deals.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__DealItem__["a" /* DealItem */],{key:o.title,brand:o.title,price:o.price,brandImg:o.logo,desc:o.desc,bookNowLink:o.link,descFontSize:o.fontSize});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deals-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__SimpleSlider_SimpleSlider__["a" /* default */],{settings:this.dealsSliderSettings},dealsHtml));}}]);return Deals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Deals);

/***/ }),
/* 241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DealItem; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__UI_UI_js__ = __webpack_require__(2);
var DealItem=function DealItem(props){var callToActionText=props.callToActionText!==undefined?props.callToActionText:'RÉSERVEZ MAINTENANT';var cssClass=props.cssClass!==undefined?props.cssClass:'';var isReminder=props.isReminder!==undefined?props.isReminder:'';var job=props.job!==undefined?props.job:'';var new_day=new Date();// alert(new_day);
var corrent_month=new_day.getMonth();// alert(corrent_month);
var chinise_blackfriday=new_day.getDate();var world_blackfriday=new_day.getDate();var jobHTML=null;var blackfriday_friday_html='';if((chinise_blackfriday===11||world_blackfriday===29)&&corrent_month===10){blackfriday_friday_html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'ac-black-friday'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:'https://en.citiesbreak.com/twocities/assets/img/sale.png',className:'img-responsive',alt:'sale'}));}if(job!==''){jobHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'job-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('br',null),'(',job,')');}var html=null;if(isReminder){html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"deal-item "+cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank','data-agent':props.brand,href:props.bookNowLink,rel:'noopener'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.brand)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:props.descFontSize},Object(__WEBPACK_IMPORTED_MODULE_1__Utility_Utility__["h" /* limitText */])(props.desc,100))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI_js__["i" /* Img */],{desktopImg:props.brandImg}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.price,jobHTML)))));}else{html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:"deal-item "+cssClass},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{target:'_blank','data-agent':props.brand,href:props.bookNowLink,rel:'noopener'},blackfriday_friday_html,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'brand-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,props.brand)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'price-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('small',{className:'small'},'\xC0 partir de '),' ',props.price,jobHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-desc-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',{className:props.descFontSize},Object(__WEBPACK_IMPORTED_MODULE_1__Utility_Utility__["h" /* limitText */])(props.desc,100))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'deal-img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__UI_UI_js__["i" /* Img */],{desktopImg:props.brandImg}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'book-now-wrapper'},callToActionText,' ','>'))));}return html;};

/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_youtube_player___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_youtube_player__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * Check whether a `props` change should result in the video being updated.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdateVideo(prevProps, props) {
  // A changing video should always trigger an update
  if (prevProps.videoId !== props.videoId) {
    return true;
  }

  // Otherwise, a change in the start/end time playerVars also requires a player
  // update.
  var prevVars = prevProps.opts.playerVars || {};
  var vars = props.opts.playerVars || {};

  return prevVars.start !== vars.start || prevVars.end !== vars.end;
}

/**
 * Neutralise API options that only require a video update, leaving only options
 * that require a player reset. The results can then be compared to see if a
 * player reset is necessary.
 *
 * @param {Object} opts
 */
function filterResetOptions(opts) {
  return _extends({}, opts, {
    playerVars: _extends({}, opts.playerVars, {
      autoplay: 0,
      start: 0,
      end: 0
    })
  });
}

/**
 * Check whether a `props` change should result in the player being reset.
 * The player is reset when the `props.opts` change, except if the only change
 * is in the `start` and `end` playerVars, because a video update can deal with
 * those.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldResetPlayer(prevProps, props) {
  return !__WEBPACK_IMPORTED_MODULE_2_fast_deep_equal___default()(filterResetOptions(prevProps.opts), filterResetOptions(props.opts));
}

/**
 * Check whether a props change should result in an id or className update.
 *
 * @param {Object} prevProps
 * @param {Object} props
 */
function shouldUpdatePlayer(prevProps, props) {
  return prevProps.id !== props.id || prevProps.className !== props.className;
}

var YouTube = function (_React$Component) {
  _inherits(YouTube, _React$Component);

  function YouTube(props) {
    _classCallCheck(this, YouTube);

    var _this = _possibleConstructorReturn(this, (YouTube.__proto__ || Object.getPrototypeOf(YouTube)).call(this, props));

    _this.onPlayerReady = function (event) {
      return _this.props.onReady(event);
    };

    _this.onPlayerError = function (event) {
      return _this.props.onError(event);
    };

    _this.onPlayerStateChange = function (event) {
      _this.props.onStateChange(event);
      switch (event.data) {

        case YouTube.PlayerState.ENDED:
          _this.props.onEnd(event);
          break;

        case YouTube.PlayerState.PLAYING:
          _this.props.onPlay(event);
          break;

        case YouTube.PlayerState.PAUSED:
          _this.props.onPause(event);
          break;

        default:
      }
    };

    _this.onPlayerPlaybackRateChange = function (event) {
      return _this.props.onPlaybackRateChange(event);
    };

    _this.onPlayerPlaybackQualityChange = function (event) {
      return _this.props.onPlaybackQualityChange(event);
    };

    _this.createPlayer = function () {
      // do not attempt to create a player server-side, it won't work
      if (typeof document === 'undefined') return;
      // create player
      var playerOpts = _extends({}, _this.props.opts, {
        // preload the `videoId` video if one is already given
        videoId: _this.props.videoId
      });
      _this.internalPlayer = __WEBPACK_IMPORTED_MODULE_3_youtube_player___default()(_this.container, playerOpts);
      // attach event handlers
      _this.internalPlayer.on('ready', _this.onPlayerReady);
      _this.internalPlayer.on('error', _this.onPlayerError);
      _this.internalPlayer.on('stateChange', _this.onPlayerStateChange);
      _this.internalPlayer.on('playbackRateChange', _this.onPlayerPlaybackRateChange);
      _this.internalPlayer.on('playbackQualityChange', _this.onPlayerPlaybackQualityChange);
    };

    _this.resetPlayer = function () {
      return _this.internalPlayer.destroy().then(_this.createPlayer);
    };

    _this.updatePlayer = function () {
      _this.internalPlayer.getIframe().then(function (iframe) {
        if (_this.props.id) iframe.setAttribute('id', _this.props.id);else iframe.removeAttribute('id');
        if (_this.props.className) iframe.setAttribute('class', _this.props.className);else iframe.removeAttribute('class');
      });
    };

    _this.updateVideo = function () {
      if (typeof _this.props.videoId === 'undefined' || _this.props.videoId === null) {
        _this.internalPlayer.stopVideo();
        return;
      }

      // set queueing options
      var autoplay = false;
      var opts = {
        videoId: _this.props.videoId
      };
      if ('playerVars' in _this.props.opts) {
        autoplay = _this.props.opts.playerVars.autoplay === 1;
        if ('start' in _this.props.opts.playerVars) {
          opts.startSeconds = _this.props.opts.playerVars.start;
        }
        if ('end' in _this.props.opts.playerVars) {
          opts.endSeconds = _this.props.opts.playerVars.end;
        }
      }

      // if autoplay is enabled loadVideoById
      if (autoplay) {
        _this.internalPlayer.loadVideoById(opts);
        return;
      }
      // default behaviour just cues the video
      _this.internalPlayer.cueVideoById(opts);
    };

    _this.refContainer = function (container) {
      _this.container = container;
    };

    _this.container = null;
    _this.internalPlayer = null;
    return _this;
  }

  /**
    * Expose PlayerState constants for convenience. These constants can also be
    * accessed through the global YT object after the YouTube IFrame API is instantiated.
    * https://developers.google.com/youtube/iframe_api_reference#onStateChange
    */


  _createClass(YouTube, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.createPlayer();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      if (shouldUpdatePlayer(prevProps, this.props)) {
        this.updatePlayer();
      }

      if (shouldResetPlayer(prevProps, this.props)) {
        this.resetPlayer();
      }

      if (shouldUpdateVideo(prevProps, this.props)) {
        this.updateVideo();
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      /**
       * Note: The `youtube-player` package that is used promisifies all Youtube
       * Player API calls, which introduces a delay of a tick before it actually
       * gets destroyed. Since React attempts to remove the element instantly
       * this method isn't quick enough to reset the container element.
       */
      this.internalPlayer.destroy();
    }

    /**
     * https://developers.google.com/youtube/iframe_api_reference#onReady
     *
     * @param {Object} event
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onError
     *
     * @param {Object} event
     *   @param {Integer} data  - error type
     *   @param {Object} target - player object
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onStateChange
     *
     * @param {Object} event
     *   @param {Integer} data  - status change type
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackRateChange
     *
     * @param {Object} event
     *   @param {Float} data    - playback rate
     *   @param {Object} target - actual YT player
     */


    /**
     * https://developers.google.com/youtube/iframe_api_reference#onPlaybackQualityChange
     *
     * @param {Object} event
     *   @param {String} data   - playback quality
     *   @param {Object} target - actual YT player
     */


    /**
     * Initialize the Youtube Player API on the container and attach event handlers
     */


    /**
     * Shorthand for destroying and then re-creating the Youtube Player
     */


    /**
     * Method to update the id and class of the Youtube Player iframe.
     * React should update this automatically but since the Youtube Player API
     * replaced the DIV that is mounted by React we need to do this manually.
     */


    /**
     * Call Youtube Player API methods to update the currently playing video.
     * Depeding on the `opts.playerVars.autoplay` this function uses one of two
     * Youtube Player API methods to update the video.
     */

  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
        'div',
        { className: this.props.containerClassName },
        __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div', { id: this.props.id, className: this.props.className, ref: this.refContainer })
      );
    }
  }]);

  return YouTube;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

YouTube.propTypes = {
  videoId: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom ID for player element
  id: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // custom class name for player element
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
  // custom class name for player container element
  containerClassName: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  // https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
  opts: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.objectOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any),

  // event subscriptions
  onReady: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onError: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlay: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPause: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onEnd: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onStateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackRateChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
  onPlaybackQualityChange: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func
};
YouTube.defaultProps = {
  id: null,
  className: null,
  opts: {},
  containerClassName: '',
  onReady: function onReady() {},
  onError: function onError() {},
  onPlay: function onPlay() {},
  onPause: function onPause() {},
  onEnd: function onEnd() {},
  onStateChange: function onStateChange() {},
  onPlaybackRateChange: function onPlaybackRateChange() {},
  onPlaybackQualityChange: function onPlaybackQualityChange() {}
};
YouTube.PlayerState = {
  UNSTARTED: -1,
  ENDED: 0,
  PLAYING: 1,
  PAUSED: 2,
  BUFFERING: 3,
  CUED: 5
};


/* harmony default export */ __webpack_exports__["a"] = (YouTube);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;

module.exports = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  return a!==a && b!==b;
};


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _sister = __webpack_require__(246);

var _sister2 = _interopRequireDefault(_sister);

var _loadYouTubeIframeApi = __webpack_require__(247);

var _loadYouTubeIframeApi2 = _interopRequireDefault(_loadYouTubeIframeApi);

var _YouTubePlayer = __webpack_require__(249);

var _YouTubePlayer2 = _interopRequireDefault(_YouTubePlayer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @typedef YT.Player
 * @see https://developers.google.com/youtube/iframe_api_reference
 * */

/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Loading_a_Video_Player
 */
var youtubeIframeAPI = void 0;

/**
 * A factory function used to produce an instance of YT.Player and queue function calls and proxy events of the resulting object.
 *
 * @param maybeElementId Either An existing YT.Player instance,
 * the DOM element or the id of the HTML element where the API will insert an <iframe>.
 * @param options See `options` (Ignored when using an existing YT.Player instance).
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions. Default: `false`.
 * See `FunctionStateMap.js` for supported functions and acceptable states.
 */

exports.default = function (maybeElementId) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var strictState = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var emitter = (0, _sister2.default)();

  if (!youtubeIframeAPI) {
    youtubeIframeAPI = (0, _loadYouTubeIframeApi2.default)(emitter);
  }

  if (options.events) {
    throw new Error('Event handlers cannot be overwritten.');
  }

  if (typeof maybeElementId === 'string' && !document.getElementById(maybeElementId)) {
    throw new Error('Element "' + maybeElementId + '" does not exist.');
  }

  options.events = _YouTubePlayer2.default.proxyEvents(emitter);

  var playerAPIReady = new Promise(function (resolve) {
    if ((typeof maybeElementId === 'undefined' ? 'undefined' : _typeof(maybeElementId)) === 'object' && maybeElementId.playVideo instanceof Function) {
      var player = maybeElementId;

      resolve(player);
    } else {
      // asume maybeElementId can be rendered inside
      // eslint-disable-next-line promise/catch-or-return
      youtubeIframeAPI.then(function (YT) {
        // eslint-disable-line promise/prefer-await-to-then
        var player = new YT.Player(maybeElementId, options);

        emitter.on('ready', function () {
          resolve(player);
        });

        return null;
      });
    }
  });

  var playerApi = _YouTubePlayer2.default.promisifyPlayer(playerAPIReady, strictState);

  playerApi.on = emitter.on;
  playerApi.off = emitter.off;

  return playerApi;
};

module.exports = exports['default'];

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Sister;

/**
* @link https://github.com/gajus/sister for the canonical source repository
* @license https://github.com/gajus/sister/blob/master/LICENSE BSD 3-Clause
*/
Sister = function () {
    var sister = {},
        events = {};

    /**
     * @name handler
     * @function
     * @param {Object} data Event data.
     */

    /**
     * @param {String} name Event name.
     * @param {handler} handler
     * @return {listener}
     */
    sister.on = function (name, handler) {
        var listener = {name: name, handler: handler};
        events[name] = events[name] || [];
        events[name].unshift(listener);
        return listener;
    };

    /**
     * @param {listener}
     */
    sister.off = function (listener) {
        var index = events[listener.name].indexOf(listener);

        if (index !== -1) {
            events[listener.name].splice(index, 1);
        }
    };

    /**
     * @param {String} name Event name.
     * @param {Object} data Event data.
     */
    sister.trigger = function (name, data) {
        var listeners = events[name],
            i;

        if (listeners) {
            i = listeners.length;
            while (i--) {
                listeners[i].handler(data);
            }
        }
    };

    return sister;
};

module.exports = Sister;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _loadScript = __webpack_require__(248);

var _loadScript2 = _interopRequireDefault(_loadScript);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (emitter) {
  /**
   * A promise that is resolved when window.onYouTubeIframeAPIReady is called.
   * The promise is resolved with a reference to window.YT object.
   */
  var iframeAPIReady = new Promise(function (resolve) {
    if (window.YT && window.YT.Player && window.YT.Player instanceof Function) {
      resolve(window.YT);

      return;
    } else {
      var protocol = window.location.protocol === 'http:' ? 'http:' : 'https:';

      (0, _loadScript2.default)(protocol + '//www.youtube.com/iframe_api', function (error) {
        if (error) {
          emitter.trigger('error', error);
        }
      });
    }

    var previous = window.onYouTubeIframeAPIReady;

    // The API will call this function when page has finished downloading
    // the JavaScript for the player API.
    window.onYouTubeIframeAPIReady = function () {
      if (previous) {
        previous();
      }

      resolve(window.YT);
    };
  });

  return iframeAPIReady;
};

module.exports = exports['default'];

/***/ }),
/* 248 */
/***/ (function(module, exports) {


module.exports = function load (src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0]
  var script = document.createElement('script')

  if (typeof opts === 'function') {
    cb = opts
    opts = {}
  }

  opts = opts || {}
  cb = cb || function() {}

  script.type = opts.type || 'text/javascript'
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true
  script.src = src

  if (opts.attrs) {
    setAttributes(script, opts.attrs)
  }

  if (opts.text) {
    script.text = '' + opts.text
  }

  var onend = 'onload' in script ? stdOnEnd : ieOnEnd
  onend(script, cb)

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }

  head.appendChild(script)
}

function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}

function stdOnEnd (script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null
    cb(null, script)
  }
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null
    cb(new Error('Failed to load ' + this.src), script)
  }
}

function ieOnEnd (script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return
    this.onreadystatechange = null
    cb(null, script) // there is no way to catch loading errors in IE8
  }
}


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _debug = __webpack_require__(250);

var _debug2 = _interopRequireDefault(_debug);

var _functionNames = __webpack_require__(253);

var _functionNames2 = _interopRequireDefault(_functionNames);

var _eventNames = __webpack_require__(254);

var _eventNames2 = _interopRequireDefault(_eventNames);

var _FunctionStateMap = __webpack_require__(255);

var _FunctionStateMap2 = _interopRequireDefault(_FunctionStateMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable promise/prefer-await-to-then */

var debug = (0, _debug2.default)('youtube-player');

var YouTubePlayer = {};

/**
 * Construct an object that defines an event handler for all of the YouTube
 * player events. Proxy captured events through an event emitter.
 *
 * @todo Capture event parameters.
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 */
YouTubePlayer.proxyEvents = function (emitter) {
  var events = {};

  var _loop = function _loop(eventName) {
    var onEventName = 'on' + eventName.slice(0, 1).toUpperCase() + eventName.slice(1);

    events[onEventName] = function (event) {
      debug('event "%s"', onEventName, event);

      emitter.trigger(eventName, event);
    };
  };

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = _eventNames2.default[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var eventName = _step.value;

      _loop(eventName);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return events;
};

/**
 * Delays player API method execution until player state is ready.
 *
 * @todo Proxy all of the methods using Object.keys.
 * @todo See TRICKY below.
 * @param playerAPIReady Promise that resolves when player is ready.
 * @param strictState A flag designating whether or not to wait for
 * an acceptable state when calling supported functions.
 * @returns {Object}
 */
YouTubePlayer.promisifyPlayer = function (playerAPIReady) {
  var strictState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var functions = {};

  var _loop2 = function _loop2(functionName) {
    if (strictState && _FunctionStateMap2.default[functionName]) {
      functions[functionName] = function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return playerAPIReady.then(function (player) {
          var stateInfo = _FunctionStateMap2.default[functionName];
          var playerState = player.getPlayerState();

          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          var value = player[functionName].apply(player, args);

          // TRICKY: For functions like `seekTo`, a change in state must be
          // triggered given that the resulting state could match the initial
          // state.
          if (stateInfo.stateChangeRequired ||

          // eslint-disable-next-line no-extra-parens
          Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerState) === -1) {
            return new Promise(function (resolve) {
              var onPlayerStateChange = function onPlayerStateChange() {
                var playerStateAfterChange = player.getPlayerState();

                var timeout = void 0;

                if (typeof stateInfo.timeout === 'number') {
                  timeout = setTimeout(function () {
                    player.removeEventListener('onStateChange', onPlayerStateChange);

                    resolve();
                  }, stateInfo.timeout);
                }

                if (Array.isArray(stateInfo.acceptableStates) && stateInfo.acceptableStates.indexOf(playerStateAfterChange) !== -1) {
                  player.removeEventListener('onStateChange', onPlayerStateChange);

                  clearTimeout(timeout);

                  resolve();
                }
              };

              player.addEventListener('onStateChange', onPlayerStateChange);
            }).then(function () {
              return value;
            });
          }

          return value;
        });
      };
    } else {
      functions[functionName] = function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        return playerAPIReady.then(function (player) {
          // eslint-disable-next-line no-warning-comments
          // TODO: Just spread the args into the function once Babel is fixed:
          // https://github.com/babel/babel/issues/4270
          //
          // eslint-disable-next-line prefer-spread
          return player[functionName].apply(player, args);
        });
      };
    }
  };

  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = _functionNames2.default[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var functionName = _step2.value;

      _loop2(functionName);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return functions;
};

exports.default = YouTubePlayer;
module.exports = exports['default'];

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = __webpack_require__(251);
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome
               && 'undefined' != typeof chrome.storage
                  ? chrome.storage.local
                  : localstorage();

/**
 * Colors.
 */

exports.colors = [
  'lightseagreen',
  'forestgreen',
  'goldenrod',
  'dodgerblue',
  'darkorchid',
  'crimson'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

function useColors() {
  // NB: In an Electron preload script, document will be defined but not fully
  // initialized. Since we know we're in Chrome, we'll just detect this case
  // explicitly
  if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') {
    return true;
  }

  // is webkit? http://stackoverflow.com/a/16459606/376773
  // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
  return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
    // is firebug? http://stackoverflow.com/a/398120/376773
    (typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
    // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
    // double check webkit in userAgent just in case we are in a worker
    (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

exports.formatters.j = function(v) {
  try {
    return JSON.stringify(v);
  } catch (err) {
    return '[UnexpectedJSONParseError]: ' + err.message;
  }
};


/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
  var useColors = this.useColors;

  args[0] = (useColors ? '%c' : '')
    + this.namespace
    + (useColors ? ' %c' : ' ')
    + args[0]
    + (useColors ? '%c ' : ' ')
    + '+' + exports.humanize(this.diff);

  if (!useColors) return;

  var c = 'color: ' + this.color;
  args.splice(1, 0, c, 'color: inherit')

  // the final "%c" is somewhat tricky, because there could be other
  // arguments passed either before or after the %c, so we need to
  // figure out the correct index to insert the CSS into
  var index = 0;
  var lastC = 0;
  args[0].replace(/%[a-zA-Z%]/g, function(match) {
    if ('%%' === match) return;
    index++;
    if ('%c' === match) {
      // we only are interested in the *last* %c
      // (the user may have provided their own)
      lastC = index;
    }
  });

  args.splice(lastC, 0, c);
}

/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */

function log() {
  // this hackery is required for IE8/9, where
  // the `console.log` function doesn't have 'apply'
  return 'object' === typeof console
    && console.log
    && Function.prototype.apply.call(console.log, console, arguments);
}

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */

function save(namespaces) {
  try {
    if (null == namespaces) {
      exports.storage.removeItem('debug');
    } else {
      exports.storage.debug = namespaces;
    }
  } catch(e) {}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */

function load() {
  var r;
  try {
    r = exports.storage.debug;
  } catch(e) {}

  // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
  if (!r && typeof process !== 'undefined' && 'env' in process) {
    r = Object({"NODE_ENV":"production","PUBLIC_URL":""}).DEBUG;
  }

  return r;
}

/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */

exports.enable(load());

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
  try {
    return window.localStorage;
  } catch (e) {}
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(30)))

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */

exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;
exports.humanize = __webpack_require__(252);

/**
 * The currently active debug mode names, and names to skip.
 */

exports.names = [];
exports.skips = [];

/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */

exports.formatters = {};

/**
 * Previous log timestamp.
 */

var prevTime;

/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */

function selectColor(namespace) {
  var hash = 0, i;

  for (i in namespace) {
    hash  = ((hash << 5) - hash) + namespace.charCodeAt(i);
    hash |= 0; // Convert to 32bit integer
  }

  return exports.colors[Math.abs(hash) % exports.colors.length];
}

/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */

function createDebug(namespace) {

  function debug() {
    // disabled?
    if (!debug.enabled) return;

    var self = debug;

    // set `diff` timestamp
    var curr = +new Date();
    var ms = curr - (prevTime || curr);
    self.diff = ms;
    self.prev = prevTime;
    self.curr = curr;
    prevTime = curr;

    // turn the `arguments` into a proper Array
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }

    args[0] = exports.coerce(args[0]);

    if ('string' !== typeof args[0]) {
      // anything else let's inspect with %O
      args.unshift('%O');
    }

    // apply any `formatters` transformations
    var index = 0;
    args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
      // if we encounter an escaped % then don't increase the array index
      if (match === '%%') return match;
      index++;
      var formatter = exports.formatters[format];
      if ('function' === typeof formatter) {
        var val = args[index];
        match = formatter.call(self, val);

        // now we need to remove `args[index]` since it's inlined in the `format`
        args.splice(index, 1);
        index--;
      }
      return match;
    });

    // apply env-specific formatting (colors, etc.)
    exports.formatArgs.call(self, args);

    var logFn = debug.log || exports.log || console.log.bind(console);
    logFn.apply(self, args);
  }

  debug.namespace = namespace;
  debug.enabled = exports.enabled(namespace);
  debug.useColors = exports.useColors();
  debug.color = selectColor(namespace);

  // env-specific initialization logic for debug instances
  if ('function' === typeof exports.init) {
    exports.init(debug);
  }

  return debug;
}

/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */

function enable(namespaces) {
  exports.save(namespaces);

  exports.names = [];
  exports.skips = [];

  var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
  var len = split.length;

  for (var i = 0; i < len; i++) {
    if (!split[i]) continue; // ignore empty strings
    namespaces = split[i].replace(/\*/g, '.*?');
    if (namespaces[0] === '-') {
      exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
    } else {
      exports.names.push(new RegExp('^' + namespaces + '$'));
    }
  }
}

/**
 * Disable debug output.
 *
 * @api public
 */

function disable() {
  exports.enable('');
}

/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */

function enabled(name) {
  var i, len;
  for (i = 0, len = exports.skips.length; i < len; i++) {
    if (exports.skips[i].test(name)) {
      return false;
    }
  }
  for (i = 0, len = exports.names.length; i < len; i++) {
    if (exports.names[i].test(name)) {
      return true;
    }
  }
  return false;
}

/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */

function coerce(val) {
  if (val instanceof Error) return val.stack || val.message;
  return val;
}


/***/ }),
/* 252 */
/***/ (function(module, exports) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isNaN(val) === false) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  if (ms >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (ms >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (ms >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (ms >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  return plural(ms, d, 'day') ||
    plural(ms, h, 'hour') ||
    plural(ms, m, 'minute') ||
    plural(ms, s, 'second') ||
    ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, n, name) {
  if (ms < n) {
    return;
  }
  if (ms < n * 1.5) {
    return Math.floor(ms / n) + ' ' + name;
  }
  return Math.ceil(ms / n) + ' ' + name + 's';
}


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Functions
 */
exports.default = ['cueVideoById', 'loadVideoById', 'cueVideoByUrl', 'loadVideoByUrl', 'playVideo', 'pauseVideo', 'stopVideo', 'getVideoLoadedFraction', 'cuePlaylist', 'loadPlaylist', 'nextVideo', 'previousVideo', 'playVideoAt', 'setShuffle', 'setLoop', 'getPlaylist', 'getPlaylistIndex', 'setOption', 'mute', 'unMute', 'isMuted', 'setVolume', 'getVolume', 'seekTo', 'getPlayerState', 'getPlaybackRate', 'setPlaybackRate', 'getAvailablePlaybackRates', 'getPlaybackQuality', 'setPlaybackQuality', 'getAvailableQualityLevels', 'getCurrentTime', 'getDuration', 'removeEventListener', 'getVideoUrl', 'getVideoEmbedCode', 'getOptions', 'getOption', 'addEventListener', 'destroy', 'setSize', 'getIframe'];
module.exports = exports['default'];

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * @see https://developers.google.com/youtube/iframe_api_reference#Events
 * `volumeChange` is not officially supported but seems to work
 * it emits an object: `{volume: 82.6923076923077, muted: false}`
 */
exports.default = ['ready', 'stateChange', 'playbackQualityChange', 'playbackRateChange', 'error', 'apiChange', 'volumeChange'];
module.exports = exports['default'];

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PlayerStates = __webpack_require__(256);

var _PlayerStates2 = _interopRequireDefault(_PlayerStates);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  pauseVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PAUSED],
    stateChangeRequired: false
  },
  playVideo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING],
    stateChangeRequired: false
  },
  seekTo: {
    acceptableStates: [_PlayerStates2.default.ENDED, _PlayerStates2.default.PLAYING, _PlayerStates2.default.PAUSED],
    stateChangeRequired: true,

    // TRICKY: `seekTo` may not cause a state change if no buffering is
    // required.
    timeout: 3000
  }
};
module.exports = exports['default'];

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  BUFFERING: 3,
  ENDED: 0,
  PAUSED: 2,
  PLAYING: 1,
  UNSTARTED: -1,
  VIDEO_CUED: 5
};
module.exports = exports["default"];

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GDPRWrapper; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var GDPRWrapper=function GDPRWrapper(_ref){var children=_ref.children,group=_ref.group;var _useState=Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),_useState2=_slicedToArray(_useState,2),isConsentGiven=_useState2[0],setIsConsentGiven=_useState2[1];Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function(){var checkConsent=function checkConsent(){// Method 1: Check via ultimateGdpr API
if(window.ultimateGdpr&&typeof window.ultimateGdpr.getConsentGroups==="function"){var consentGroups=window.ultimateGdpr.getConsentGroups();console.log('GDPR consent groups:',consentGroups,'Looking for:',group);setIsConsentGiven(consentGroups.includes(group));return;}// Method 2: Check cookie directly
var getCookie=function getCookie(name){var value="; "+document.cookie;var parts=value.split("; "+name+"=");if(parts.length===2)return parts.pop().split(';').shift();return null;};var groupCookie=getCookie(group);console.log("Cookie "+group+":",groupCookie);if(groupCookie==='true'){setIsConsentGiven(true);return;}// Default: no consent
console.warn("GDPR plugin is not loaded or getConsentGroups is undefined.");setIsConsentGiven(false);};// Listen for consent updates
document.addEventListener("ct-ultimate-gdpr-cookie-update",checkConsent);// Also check every 2 seconds (fallback)
var intervalId=setInterval(checkConsent,2000);// Initial check
checkConsent();return function(){document.removeEventListener("ct-ultimate-gdpr-cookie-update",checkConsent);clearInterval(intervalId);};},[group]);return isConsentGiven?children:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{textAlign:'center',padding:'40px 20px',background:'#f5f5f5',borderRadius:'8px',margin:'20px 0'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{fontSize:'16px',color:'#333',marginBottom:'15px'}},"Pour visionner cette vid\xE9o, veuillez accepter les cookies de fonctionnalit\xE9 dans vos param\xE8tres de confidentialit\xE9."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:function onClick(){console.log('Cookie Settings button clicked');// Use jQuery (loaded in index.html)
var $=window.jQuery||window.$||window.ct$;if(!$){console.error('jQuery not found!');return;}console.log('jQuery found, trying to open modal...');// Method 1: Try to trigger the gear icon click
var gearIcon=$('#ct-ultimate-gdpr-cookie-open');console.log('Gear icon found:',gearIcon.length);if(gearIcon.length>0){gearIcon.click();return;}// Method 2: Try the change settings button
var settingsBtn=$('#ct-ultimate-gdpr-cookie-change-settings');console.log('Settings button found:',settingsBtn.length);if(settingsBtn.length>0){settingsBtn.click();return;}// Method 3: Show modal directly
var modal=$('#ct-ultimate-gdpr-cookie-modal');console.log('Modal found:',modal.length);if(modal.length>0){modal.show();$('body').addClass('cookie-modal-open');$('html').addClass('cookie-modal-open');$('#ct-ultimate-gdpr-cookie-open').hide();}else{console.error('Could not find GDPR modal!');}},style:{background:'#6a8ee7',color:'white',border:'none',padding:'12px 24px',borderRadius:'4px',cursor:'pointer',fontSize:'14px',fontWeight:'bold',width:'max-content'}},"Param\xE8tres des cookies"));};

/***/ }),
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(5);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SpacielDeals=function(_Component){_inherits(SpacielDeals,_Component);function SpacielDeals(){var _ref;var _temp,_this,_ret;_classCallCheck(this,SpacielDeals);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=SpacielDeals.__proto__||Object.getPrototypeOf(SpacielDeals)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(SpacielDeals,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page align-center page-SpacielDeals"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeSlider */],{isHomeSlider:true,waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return SpacielDeals;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (SpacielDeals);

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ExporeTelAvivAndJerusalem_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ExporeTelAvivAndJerusalem=function(_Component){_inherits(ExporeTelAvivAndJerusalem,_Component);function ExporeTelAvivAndJerusalem(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ExporeTelAvivAndJerusalem);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ExporeTelAvivAndJerusalem.__proto__||Object.getPrototypeOf(ExporeTelAvivAndJerusalem)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ExporeTelAvivAndJerusalem,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["c" /* newPosts */]));// get video posts
var nonVidPosts=posts.filter(function(o,i){return(o.isVid===true||o.forVidPage===true)&&o.isDouble!==true;});var concertSHtml=nonVidPosts.map(function(o,i){var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url="/Posts/Videos/"+o.ctg+"/"+o.id;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-ExporeTelAvivAndJerusalem"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/posts/bank/page-videos/1.jpg",mobileImg:"/posts/bank/page-videos/M.jpg",cssClass:"telaviv",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"VID\xC9OS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"FYtk8JMMZRE"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},concertSHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return ExporeTelAvivAndJerusalem;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ExporeTelAvivAndJerusalem);

/***/ }),
/* 264 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TermsOfUse_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TermsOfUse=function(_Component){_inherits(TermsOfUse,_Component);function TermsOfUse(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TermsOfUse);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TermsOfUse.__proto__||Object.getPrototypeOf(TermsOfUse)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TermsOfUse,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page align-left page-TermsOfUse"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"Terms of Use"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"General"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The Israeli Ministry of Tourism (hereinafter- the Ministry) offers the information on this website (hereinafter- the service) subject to your acceptance, with no amendments whatsoever, of the terms, conditions and notifications contained herein. By using the Service you signify your agreement to all such terms, conditions and notifications. Please read these Terms of Use carefully before using the Service. If you do not agree to all these terms, you may not use the Service. The term \u201CUser\u201D as follows shall mean each person who establishes or accesses a connection to the service."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Liability"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The information provided to User is provided for his convenience only. Information that concerns third parties should be verified with the service providers themselves before making a decision based on the information shown."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"It is emphasized that the businesses whose details are provided in the Service are not supervised or reviewed by the Ministry and are not under its responsibility, and the Ministry therefore is not responsible in any way for the service provided to any visitor, including the quality and nature of the physical facilities or the service, the prices charged, the visitor\u2019s satisfaction, etc. The Ministry shall not be held liable for any damage caused to User and/or to any visitor in the course of any visit or use made based on the information provided to him/her by the Service. The information provided to User informs of the existence per se of the businesses (attractions, accommodation, events, etc.) and is not in any way a specific recommendation to use a particular business. Full responsibility for the service is imposed on the service provider. The information provided on the Service may not be construed as endorsement, approval, recommendation or favoring of the use of a particular service or of a visit to a particular site and/or business. The Ministry shall not be held liable for the suitability of the Service to User\u2019s needs. Furthermore, the Ministry shall not be held liable for errors or mistakes in the information provided to User which was not produced by the Ministry but is received from third parties.. User alone is responsible for the way in which he/she uses the Service. The Ministry shall not be held liable for any damage caused to User or to any third party as a direct or indirect result of using the Service, including damage caused due to the use of software applications downloaded directly through the Service or activated as a result of the use of the Service, including Java, JavaScript and ActiveX. For purposes of this section, \u201CThe Ministry\u201D includes its employees and representatives."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Links"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"As part of the Service, the Service may provide links to other websites. The following conditions apply to the use of those links, without derogating from the other conditions in these Terms of Use. The links are provided solely for the convenience of User. Regarding links to external sites which are not owned by the State of Israel (third party sites), unless otherwise stipulated on this Site, no legal or commercial relationship exists between the Ministry and the owners of third party sites, and the Ministry has no control over or right to material found on those sites. The Ministry is not responsible for the content of third party sites and/or for information on commercial or noncommercial products or services offered on them, including the nature or quality thereof. It is recommended to check the information with the service providers or with another relevant party. Links to third party sites may not be construed as endorsement, approval, recommendation or favoring by the State of Israel of those linked-to sites, including documents and other material found on them, of the operators of said sites and of the products or services presented and/or offered on them. At the time each link was included in this Service, the information contained on the linked-to site was found to be compatible with the purposes of the Service and the link itself was functional. However, it is possible that with the passage of time changes have occurred in the linked-to site. If User feels that the linked-to site or material is inappropriate, or if User finds that the link is no longer operational, he/she is requested to inform the Ministry via email at: NitsanI@tourism.gov.il"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Deals/packages"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The Ministry serves as an information channel and is not responsible whatsoever for the packages advertised herein by third commercial parties. Any and all purchases of packages appearing on this page shall not take place on the Ministry\u2019s platform and the purchase shall be performed on the platform of the entity who is advertising the package. Full responsibility for the service is imposed on the service provider and not the Ministry of Tourism. The packages are neither supervised nor reviewed by the Ministry and are not under its responsibility, therefore it is recommended to verify the information with the service providers themselves before making a decision based on the information shown."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Copyright"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The copyrights of the website and its content belong to the Ministry. Subject to copyright law, User may not copy, redistribute, retransmit or publish protected material, without the prior written consent of the Ministry."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Contacting the Ministry"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Any question regarding this Service and other questions relating to the Ministry\u2019s sphere of activity may be addressed directly to the Ministry by email at: NitsanI@tourism.gov.il"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Official Publications of the State of Israel"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In the event of a conflict or inconsistency between material published in the Service and material appearing in official written publications of the State of Israel, only the material contained in such official publications shall be deemed correct."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Copyright Infringement Notification"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you believe your copyright-protected work was posted on this page without authorization, you may submit a copyright infringement notification by e-mail to nitsani@tourism.gov.il. Notification and requests should be submitted by the copyright owner or an agent authorized to act on the owner\u2019s behalf."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"Defamation"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"If you believe that any content uploaded, posted or published on this website is defamatory, please submit your notification by e-mail to NitsanI@tourism.gov.il.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return TermsOfUse;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TermsOfUse);

/***/ }),
/* 266 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css__ = __webpack_require__(268);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ThingsToDo_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ThingsToDo=function(_Component){_inherits(ThingsToDo,_Component);function ThingsToDo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ThingsToDo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ThingsToDo.__proto__||Object.getPrototypeOf(ThingsToDo)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ThingsToDo,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["c" /* newPosts */]));// get non video posts and culinary posts
var nonVidPosts=posts.filter(function(o,i){// return  o.isVid === false  || o.ctg === 'culinary' || o.isDouble === true;
return o.isVid===false||o.ctg==="culinary";});// const thingsToDoPosts = [ ...posts ];
var thingsToDoPosts=posts.filter(function(o,i){return o.isDouble!==true;});var postsHtml=thingsToDoPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-ExporeTelAvivAndJerusalem page-thingsToDo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/posts/bank/page-thingstodo/1.jpg",mobileImg:"/posts/bank/page-thingstodo/M.jpg",cssClass:"jerusalim",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"\xC0 FAIRE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return ThingsToDo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ThingsToDo);

/***/ }),
/* 268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhereToGo_css__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__WhereToGo_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__WhereToGo_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// private class data
var PageObj1={img:"wtg1.jpg",img_mob:"wtg1-mob.jpg",link:"/Pages/TelAvivPage",text:"TEL AVIV"};var PageObj2={img:"wtg2.jpg",img_mob:"wtg2-mob.jpg",link:"/Pages/JerusalemPage",text:"JÉRUSALEM"};var PageObj3={img:"wtg3.jpg",img_mob:"wtg3.jpg",link:"/Pages/DeadSeaPage",text:"MER MORTE"};var PageObj4={img:"wtg5.jpg",img_mob:"wtg5.jpg",link:"/Pages/NorthPage",text:"NORD"};var PageObj5={img:"wtg4.jpg",img_mob:"wtg4.jpg",link:"/Pages/EilatNegevPage",text:"NEGEV ET EILAT"};var PageObj6={img_mob:"wtg6-mob.jpg",link:"/Pages/thingsToDo",text:"À FAIRE"};var WhereToGo=function(_Component){_inherits(WhereToGo,_Component);function WhereToGo(){var _ref;var _temp,_this,_ret;_classCallCheck(this,WhereToGo);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=WhereToGo.__proto__||Object.getPrototypeOf(WhereToGo)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0,telAvivVideo:"XDei1Zy_cu4",telAvivVideoState:0,jerusalemVideo:"k4OwoEk5wMw",jerusalemVideoState:0,deadSeaVideo:"DzEJxjnC_UQ",deadSeaVideoState:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(WhereToGo,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){var _React$createElement;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-whereToGo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"relative"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/posts/bank/page-wheretogo/1.jpg",mobileImg:"/posts/bank/page-wheretogo/M.jpg",cssClass:"jerusalim",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"home-section home-section-padding weather-section",id:"expore-tel-aviv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container ac-flex ac-flex-column"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["h" /* HomeTitle */],null,"O\xD9 ALLER?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-row ac-flex ac-flex-row ac-flex-row-mob"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-50 ac-margin-right"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* ImgAndText */],{img:PageObj1.img,img_mob:PageObj1.img_mob,cssClass:" col-100",link:PageObj1.link,text:PageObj1.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"show_more button",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/TelAvivPage"},"LIRE LA SUITE >>")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-50"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* ImgAndText */],{img:PageObj2.img,img_mob:PageObj2.img_mob,cssClass:" col-100",link:PageObj2.link,text:PageObj2.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"show_more button",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/JerusalemPage"},"LIRE LA SUITE >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-row ac-flex ac-flex-row ac-flex-row-mob"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-33"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* ImgAndText */],{img:PageObj3.img,img_mob:PageObj3.img_mob,cssClass:" col-100",link:PageObj3.link,text:PageObj3.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"show_more button",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/DeadSeaPage"},"LIRE LA SUITE >>")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-33  ac-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* ImgAndText */],(_React$createElement={img:PageObj4.img,img_mob:PageObj6.img_mob},_defineProperty(_React$createElement,"img_mob",PageObj4.img_mob),_defineProperty(_React$createElement,"cssClass"," col-100"),_defineProperty(_React$createElement,"link",PageObj4.link),_defineProperty(_React$createElement,"text",PageObj4.text),_React$createElement)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"show_more button",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/NorthPage"},"LIRE LA SUITE >>")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-33"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* ImgAndText */],{img:PageObj5.img,img_mob:PageObj5.img_mob,cssClass:" col-100",link:PageObj5.link,text:PageObj5.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"show_more button",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/EilatNegevPage"},"LIRE LA SUITE >>")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-33 show-on-mobile ac-margin"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_UI_UI__["j" /* ImgAndText */],{img_mob:PageObj6.img_mob,cssClass:" col-100",link:PageObj6.link,text:PageObj6.text}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"show_more button",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/thingsToDo"},"LIRE LA SUITE >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Components_Footer_Footer__["a" /* default */],null));}}]);return WhereToGo;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (WhereToGo);

/***/ }),
/* 270 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FAQ=function(_Component){_inherits(FAQ,_Component);function FAQ(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FAQ);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FAQ.__proto__||Object.getPrototypeOf(FAQ)).call.apply(_ref,[this].concat(args))),_this),_this.state={faq:__WEBPACK_IMPORTED_MODULE_3__Data_Data__["b" /* faqData */],telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_this.setCurrentFaq=function(id){var faq=[].concat(_toConsumableArray(_this.state.faq));var current=faq.find(function(o){return o.id===id;});if(current.isOpen===true){current.isOpen=false;}else{current.isOpen=true;}_this.setState({faq:faq});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FAQ,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){var _this3=this;var faqHtml=this.state.faq.map(function(o){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["d" /* FaqItem */],{q:o.q,answer:o.answer,isOpen:o.isOpen,click:function click(){_this3.setCurrentFaq(o.id);}});});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page align-center page-FAQ inner-page"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"FAQ"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"faq-wrapper"},faqHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return FAQ;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (FAQ);

/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css__ = __webpack_require__(273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TelAvivPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TelAvivPage=function(_Component){_inherits(TelAvivPage,_Component);function TelAvivPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TelAvivPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TelAvivPage.__proto__||Object.getPrototypeOf(TelAvivPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TelAvivPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["c" /* newPosts */]));// get non video posts and culinary posts
var telAvivPosts=posts.filter(function(o,i){return(o.ctg==="telaviv"||o.ctg==="telavivAndJerusalem"||o.ctg==="culinarytelaviv")&&o.isDouble!==true;// return o.ctg === 'telaviv' || o.ctg === 'telavivAndJerusalem'|| o.ctg === 'culinarytelaviv';
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=telAvivPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-telaviv"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/posts/bank/page-telaviv/1.jpg",mobileImg:"/posts/bank/page-telaviv/M.jpg",cssClass:"telaviv",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"TEL AVIV"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"T9_kBElXdPI"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return TelAvivPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TelAvivPage);

/***/ }),
/* 273 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css__ = __webpack_require__(275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__JerusalemPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var JerusalemPage=function(_Component){_inherits(JerusalemPage,_Component);function JerusalemPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,JerusalemPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=JerusalemPage.__proto__||Object.getPrototypeOf(JerusalemPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(JerusalemPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["c" /* newPosts */]));// get non video posts and culinary posts
var jerusalemPosts=posts.filter(function(o,i){return(o.ctg==="jerusalem"||o.ctg==="culinaryjerusalem")&&o.isDouble!==true;// return o.ctg === 'jerusalem'  ||  o.ctg === 'culinaryjerusalem' ;
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=jerusalemPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-jerusalem"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/posts/bank/page-jerusalem/1.jpg",mobileImg:"/posts/bank/page-jerusalem/M.jpg",cssClass:"jerusalim",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"J\xC9RUSALEM"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"9oZqdBNExTo"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return JerusalemPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (JerusalemPage);

/***/ }),
/* 275 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__CulinaryPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CulinaryPage=function(_Component){_inherits(CulinaryPage,_Component);function CulinaryPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CulinaryPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CulinaryPage.__proto__||Object.getPrototypeOf(CulinaryPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CulinaryPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["c" /* newPosts */]));// get non video posts and culinary posts
var culinaryPosts=posts.filter(function(o,i){return(o.ctg==="culinary"||o.ctg==="culinaryjerusalem"||o.ctg==="culinarytelaviv"||o.ctg==="culinarynorth")&&o.isDouble!==true;// return o.ctg === 'culinary' || o.ctg === 'culinaryjerusalem' || o.ctg === 'culinarytelaviv';
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=culinaryPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-culinary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/posts/bank/page-culinary/1.jpg",mobileImg:"/posts/bank/page-culinary/M.jpg",cssClass:"telaviv",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"CULINAIRE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"jfyHxk8ZRrI"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return CulinaryPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CulinaryPage);

/***/ }),
/* 277 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css__ = __webpack_require__(279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__DeadSeaPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var DeadSeaPage=function(_Component){_inherits(DeadSeaPage,_Component);function DeadSeaPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,DeadSeaPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=DeadSeaPage.__proto__||Object.getPrototypeOf(DeadSeaPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(DeadSeaPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["c" /* newPosts */]));// get non video posts and culinary posts
var deadseaPosts=posts.filter(function(o,i){return o.ctg==="deadsea"&&o.isDouble!==true;// return o.ctg === 'deadsea' || o.ctg === 'deadsea2';
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=deadseaPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-deadsea"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"LA MER MORTE"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"8p4qfkneH1c"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return DeadSeaPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (DeadSeaPage);

/***/ }),
/* 279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__TouristInfoPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TouristInfoPage=function(_Component){_inherits(TouristInfoPage,_Component);function TouristInfoPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TouristInfoPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TouristInfoPage.__proto__||Object.getPrototypeOf(TouristInfoPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(TouristInfoPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["a" /* TouristInfoPosts */]));// get non video posts and culinary posts
var telAvivPosts=posts.filter(function(o,i){return o.ctg==="TouristInfo";});// const thingsToDoPosts = [ ...posts ];
var postsHtml=telAvivPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-touristinfo"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/posts/bank/page-tourist/1.jpg",mobileImg:"/posts/bank/page-tourist/M.jpg",cssClass:"telaviv",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"INFORMATIONS TOURISTIQUES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"XDei1Zy_cu4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return TouristInfoPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (TouristInfoPage);

/***/ }),
/* 281 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EilatNegevPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var EilatNegevPage=function(_Component){_inherits(EilatNegevPage,_Component);function EilatNegevPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,EilatNegevPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=EilatNegevPage.__proto__||Object.getPrototypeOf(EilatNegevPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(EilatNegevPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["c" /* newPosts */]));// get non video posts and culinary posts
var eilatnegevPosts=posts.filter(function(o,i){return o.ctg==="eilat-negev"&&o.isDouble!==true;// return o.ctg === 'eilat-negev' ;
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=eilatnegevPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-eilatnegev"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"NEGEV ET EILAT"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"ZdnNT-GDJv4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return EilatNegevPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (EilatNegevPage);

/***/ }),
/* 283 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__innerPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__innerPage_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NorthPage_css__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NorthPage_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NorthPage_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NorthPage=function(_Component){_inherits(NorthPage,_Component);function NorthPage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NorthPage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NorthPage.__proto__||Object.getPrototypeOf(NorthPage)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NorthPage,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_3__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){// get all posts
var posts=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_2__Data_Data__["c" /* newPosts */]));// get non video posts and culinary posts
var northPosts=posts.filter(function(o,i){return(o.ctg==="north"||o.ctg==="culinarynorth")&&o.isDouble!==true;// return o.ctg === 'north' ;
});// const thingsToDoPosts = [ ...posts ];
var postsHtml=northPosts.map(function(o,i){// console.log('o' , o);
var cssClass="";var html="";if(i%4===0){cssClass=" first";}var url=null;var component=null;if(o.isVid===true){url="/Posts/Videos/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}else{// url = "/Posts/" + o.id ;
url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:o.title,desc:"",img:o.img,link:url,cssClass:cssClass});}return component;});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner-page align-center page-north"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["g" /* HomeSlider */],{waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"live-shows-section"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["h" /* HomeTitle */],null,"Nord"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"fZ_WdHpHRT8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"live-shows-wrapper"},postsHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Components_Footer_Footer__["a" /* default */],null));}}]);return NorthPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NorthPage);

/***/ }),
/* 285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css__ = __webpack_require__(287);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__CoronaVirus_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var CoronaVirus=function(_Component){_inherits(CoronaVirus,_Component);function CoronaVirus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,CoronaVirus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=CoronaVirus.__proto__||Object.getPrototypeOf(CoronaVirus)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,waterTemp:0,jerusalemWeather:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(CoronaVirus,[{key:"componentDidMount",value:function componentDidMount(){var _this2=this;Promise.all([Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["a" /* asyncgetWeather */])()]).then(function(response){var weather=response[0];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});window.addEventListener("scroll",this.handleScroll);window.addEventListener("resize",this.updateDimensions);}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page align-left page-Corona-virus"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Menu_Menu__["a" /* default */],null),!Object(__WEBPACK_IMPORTED_MODULE_2__Utility_Utility__["g" /* isMobile */])()?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/HomeSlider/corona.jpg",mobileImg:"/HomeSlider/M/uk/4.jpg",cssClass:"north",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-corona-mobile-video"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"yE5MV_10cZw"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-new-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-new-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"ac-pink"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"ac-pink ac-pink ac-margin-top-1 ac-bigger"},"Heureux de vous revoir!"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Voyage en Isra\xEBl pour les ressortissants \xE9trangers vaccin\xE9s (vaccination compl\xE8te)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Depuis le 1er novembre 2021, les ressortissants \xE9trangers qui sont vaccin\xE9s (vaccination compl\xE8te) seront autoris\xE9s \xE0 entrer en Isra\xEBl sous r\xE9serve des conditions suivantes:",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1. Vous n\u2019\xE9tiez pas dans un pays de la zone rouge au cours des 14 jours pr\xE9c\xE9dant votre arriv\xE9e en Isra\xEBl."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"2. Vous \xEAtes vaccin\xE9 avec un vaccin reconnu par l\u2019OMS sous r\xE9serve des conditions d\xE9finies ci-dessous."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"3. L\u2019entr\xE9e en Isra\xEBl se fait uniquement par l\u2019a\xE9roport Tel-Aviv/Ben Gourion."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"4. Il n\u2019existe aucun autre obstacle \xE0 votre entr\xE9e en Isra\xEBl."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"5. Les ressortissants \xE9trangers qui ne remplissent pas les conditions ci-dessus peuvent encore demander d\u2019entrer en Isra\xEBl en passant par le"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://survey.gov.il/he/PCR2",target:"_blank",rel:"noopener"},"Comit\xE9 des exceptions"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"ac-pink"},"Vaccins homologu\xE9s"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-left-15"},"Les vaccins suivants sont approuv\xE9s par Isra\xEBl: Moderna, Pfizer, Johnson & Johnson \u2013 Janssen, AstraZeneca, Covishield, Sinopharm, Sinovac, SputniK-V (sous r\xE9serve des conditions ci-dessous)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-left-15"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Quelles personnes sont reconnues par Isra\xEBl comme \xE9tant compl\xE8tement vaccin\xE9es?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-left-15"},"Les ressortissants \xE9trangers ayant effectu\xE9 une vaccination avec Pfizer/Moderna/AstraZeneca/Sinovac ou Sinopharm:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Si vous avez effectu\xE9 une vaccination compl\xE8te de deux injections de vaccin, au moins 14 jours doivent s\u2019\xEAtre \xE9coul\xE9s entre la deuxi\xE8me dose et votre entr\xE9e en Isra\xEBl (mais pas plus de 180 jours \xE0 votre sortie d\u2019Isra\xEBl)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Si vous avez re\xE7u la troisi\xE8me dose, au moins 14 jours doivent s\u2019\xEAtre \xE9coul\xE9s entre la troisi\xE8me dose et votre entr\xE9e en Isra\xEBl.")),"\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-left-15"},"Les ressortissants \xE9trangers ayant re\xE7u les vaccins Johnson & Johnson \u2013 Janssen:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF au moins 14 jours doivent s\u2019\xEAtre \xE9coul\xE9s depuis la date de vaccination (mais pas plus de 180 jours \xE0 votre sortie d\u2019Isra\xEBl)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Si vous avez re\xE7u la troisi\xE8me dose, au moins 14 jours doivent s\u2019\xEAtre \xE9coul\xE9s entre la troisi\xE8me dose et votre entr\xE9e en Isra\xEBl.")),"\xA0",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-left-15"},"Les ressortissants \xE9trangers ayant re\xE7u le vaccin Sputnik:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Les ressortissants \xE9trangers qui ont re\xE7u le vaccin Sputnik \xE0 compter du 15/11/21 et dont le test s\xE9rologique antig\xE9nique COVID effectu\xE9 en Isra\xEBl est n\xE9gatif par manque d\u2019anti-corps (vous devez rester en quarantaine jusqu\u2019\xE0 l\u2019obtention d\u2019un r\xE9sultat positif)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Vous devez avoir effectu\xE9 une vaccination compl\xE8te de deux injections, au moins 14 jours doivent s\u2019\xEAtre \xE9coul\xE9s entre la deuxi\xE8me dose et votre entr\xE9e en Isra\xEBl (mais pas plus de 180 jours \xE0 votre sortie d\u2019Isra\xEBl)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Si vous avez re\xE7u la troisi\xE8me dose, au moins 14 jours doivent s\u2019\xEAtre \xE9coul\xE9s entre la troisi\xE8me dose et votre entr\xE9e en Isra\xEBl.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Entr\xE9e en Isra\xEBl pour les personnes compl\xE8tement gu\xE9ries de la COVID-19")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-left-15"},"Les ressortissants \xE9trangers qui sont gu\xE9ris de la COVID seront autoris\xE9s \xE0 entrer en Isra\xEBl s'ils poss\xE8dent un certificat num\xE9rique qui peut \xEAtre authentifi\xE9 par les syst\xE8mes du minist\xE8re isra\xE9lien de la Sant\xE9 et sur la base d'un r\xE9sultat positif \xE0 un test NAAT (test mol\xE9culaire similaire au PCR)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Au moins 11 jours doivent s\u2019\xEAtre \xE9coul\xE9s entre la date du r\xE9sultat de test positif et votre entr\xE9e en Isra\xEBl (mais pas plus de 190 jours \xE0 votre sortie d\u2019Isra\xEBl)"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Vous devez avoir re\xE7u au moins une dose d\u2019un vaccin reconnu par l\u2019OMS (l\u2019ordre des \xE9v\xE8nements n\u2019a pas d\u2019importance).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"#_ednref1",name:"_edn1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("b",null,"* Entry for recoverees is only applicable for those coming from countries that issue certificates that the Israeli MOH systems can digitally authenticate, which is not available for people traveling from the USA or Canada"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Proc\xE9dure d\u2019entr\xE9e en Isra\xEBl")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"ac-wrpr-num"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"ac-num-li"},"1. Vous devez effectuer un test PCR au plus 72 heures avant votre vol"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"ac-num-li"},"2. Vous devez remplir une d\xE9claration de passager avant d\u2019entrer en Isra\xEBl.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Les passagers en possession d'un certificat num\xE9rique v\xE9rifiable devront scanner ou t\xE9l\xE9charger leur certificat de vaccination ou de gu\xE9rison sur le formulaire du passager entrant et ils recevront un pass-sanitaire avant d\u2019embarquer sur le vol."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Les passagers qui n'ont pas de certificat num\xE9rique v\xE9rifiable d\xE9clareront leur statut vaccinal dans le formulaire du passager entrant et rempliront une demande pour raccourcir la p\xE9riode de quarantaine. Ils joindront ensuite les documents ad\xE9quats pour recevoir le pass-sanitaire avant d\u2019embarquer sur le vol."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"ac-num-li"},"3. Les documents suivants devront \xEAtre pr\xE9sent\xE9s \xE0 l\u2019embarquement",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Test PCR n\xE9gatif r\xE9alis\xE9 au plus 72 heures avant le vol."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Confirmation d\u2019accord d\u2019une d\xE9claration de passager entrant."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Certificat de vaccination attestant de la vaccination conform\xE9ment aux dispositions ci-dessus."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Certificat de gu\xE9rison qui peut \xEAtre authentifi\xE9 par les syst\xE8mes du minist\xE8re isra\xE9lien de la Sant\xE9, indiquant la gu\xE9rison conform\xE9ment aux dispositions d\xE9finies ci-dessus."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Certificat num\xE9rique attestant de la gu\xE9rison de la COVID conform\xE9ment aux dispositions ci-dessus."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u25CF Permis d\u2019entr\xE9e exceptionnelle d\xE9livr\xE9 par le minist\xE8re isra\xE9lien de l\u2019Int\xE9rieur (exceptions, grandes lignes, groupes)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"ac-num-li"},"4. Des tests al\xE9atoires de conformit\xE9 de documents seront effectu\xE9s par l'Autorit\xE9 de l'a\xE9roport Ben Gourion."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"ac-num-li"},"5. Un test PCR doit \xEAtre effectu\xE9 \xE0 l'atterrissage \xE0 l'a\xE9roport Ben Gourion. Vous devrez entrer en quarantaine jusqu'\xE0 l\u2019obtention d\u2019un r\xE9sultat n\xE9gatif, (ou pendant 24 heures maximum)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"ac-num-li"},"6. Les voyageurs ayant re\xE7u les vaccins Spoutnik doivent effectuer un test s\xE9rologique \xE0 l'a\xE9roport Ben Gourion et entrer en quarantaine jusqu'\xE0 l'obtention d'un r\xE9sultat de test positif (en plus de l'isolement impos\xE9 jusqu'\xE0 l'obtention d'un r\xE9sultat n\xE9gatif du test PCR effectu\xE9 \xE0 l'atterrissage).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-center"},"Pour consulter la liste des pays qui d\xE9livrent des certificats que les syst\xE8mes du minist\xE8re isra\xE9lien de la Sant\xE9 peuvent authentifier num\xE9riquement:",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en",target:"_blank",rel:"noopener",className:"ac-align-center"},"https://ec.europa.eu/info/live-work-travel-eu/coronavirus-response/safe-covid-19-vaccines-europeans/eu-digital-covid-certificate_en")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-center"},"Pour obtenir les d\xE9tails complet du protocole d\u2019entr\xE9e, cliquez ici:",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air",className:"ac-align-left-15",target:"_blank",rel:"noopener"},"https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"ac-align-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",null,"Les directives susmentionn\xE9es sont d\xE9taill\xE9es ici pour votre information et votre b\xE9n\xE9fice. En cas de doute, veuillez-vous reporter aux directives publi\xE9es sur le site du minist\xE8re isra\xE9lien de la Sant\xE9 qui contient les informations les plus r\xE9centes et les plus pr\xE9cises.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air",className:"ac-align-center",target:"_blank",rel:"noopener"},"https://corona.health.gov.il/en/directives/air-travel-covid19-green/?tab=by-air")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{className:"ac-pink"},"Nous esp\xE9rons vous voir bient\xF4t")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-inner-video"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:"LSb4Lmuw_Kw"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_Footer_Footer__["a" /* default */],null));}}]);return CoronaVirus;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (CoronaVirus);

/***/ }),
/* 287 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Videos_css__ = __webpack_require__(289);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Videos_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Videos_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostsData__ = __webpack_require__(105);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var VideoPosts=function(_Component){_inherits(VideoPosts,_Component);function VideoPosts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,VideoPosts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=VideoPosts.__proto__||Object.getPrototypeOf(VideoPosts)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:_this.props.match.params.vidId,ctgId:_this.props.match.params.ctgId},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(VideoPosts,[{key:'componentWillMount',value:function componentWillMount(){}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var _this2=this;console.log('ctgId:',this.state.ctgId);var counter=0;var videosHtml=null;var mixVideos=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__PostsData__["a" /* newPostdata */]));var shuffleData=Object(__WEBPACK_IMPORTED_MODULE_4__Utility_Utility__["i" /* shuffle */])(mixVideos);console.log('shuffleData:',typeof shuffleData==='undefined'?'undefined':_typeof(shuffleData));var current=__WEBPACK_IMPORTED_MODULE_9__PostsData__["a" /* newPostdata */].find(function(o){if(_this2.props.match.params.ctgId!=undefined){if(o.hasOwnProperty("ctg")){return o.id===_this2.state.id&&o.ctg===_this2.state.ctgId;}}});if(this.props.match.params.ctgId!=undefined){videosHtml=shuffleData.map(function(o,i){if(o.hasOwnProperty("ctg")){if(o.ctg===_this2.props.match.params.ctgId){var postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["c" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',postFromPostData);if(postFromPostData!=undefined&&postFromPostData.id!==current.id){counter++;if(counter<=3){var component=null;var url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.side_img,link:url});}else{url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.side_img,link:url});}return component;}}}else if(o.ctg==='culinary'||o.ctg==='culinaryjerusalem'||o.ctg==='culinarytelaviv'||o.ctg==='culinarynorth'){var _postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["c" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',_postFromPostData);if(_postFromPostData!=undefined&&_postFromPostData.id!==current.id){counter++;if(counter<=3){var _component=null;var _url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:_postFromPostData.title,desc:_postFromPostData.sml_desc,img:_postFromPostData.side_img,link:_url});}else{_url="/Posts/"+o.ctg+"/"+o.id;_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:_postFromPostData.title,desc:_postFromPostData.sml_desc,img:_postFromPostData.side_img,link:_url});}return _component;}}}}});}var html=null;if(current!=undefined){console.log("current",current);var vidHTML=null;var smlTitle=null;var title=null;if(current.isVid===true){vidHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:current.vidId});}title=current.title;var smltitle=current.hasOwnProperty("smltitle")?current.smltitle:current.smlTitle;var titleHTML=null;var smlTitleHTML=null;if(smltitle!==''){titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'},title);smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["h" /* HomeTitle */],null,smltitle);}else{titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'});smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["h" /* HomeTitle */],null,title);}html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-post post post-type-videos inner-post-'+current.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-post-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* Img */],{desktopImg:current.bgImage,mobileImg:current.mobBgImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container align-center white'},titleHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},smlTitleHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),vidHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-wrapper',dangerouslySetInnerHTML:current.html()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["h" /* HomeTitle */],null,'VID\xC9OS LI\xC9ES:'),videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__["a" /* default */],null));}return html;}}]);return VideoPosts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(VideoPosts));

/***/ }),
/* 289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Data_Data__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Posts_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__Posts_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostsData__ = __webpack_require__(105);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Posts=function(_Component){_inherits(Posts,_Component);function Posts(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Posts);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Posts.__proto__||Object.getPrototypeOf(Posts)).call.apply(_ref,[this].concat(args))),_this),_this.state={id:_this.props.match.params.vidId,ctgId:_this.props.match.params.ctgId},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Posts,[{key:'componentWillMount',value:function componentWillMount(){// console.log(this.props.match.params)
}},{key:'componentDidMount',value:function componentDidMount(){}},{key:'componentWillReceiveProps',value:function componentWillReceiveProps(nextProps){}},{key:'render',value:function render(){var _this2=this;var counter=0;var videosHtml=null;var mixVideos=[].concat(_toConsumableArray(__WEBPACK_IMPORTED_MODULE_9__PostsData__["a" /* newPostdata */]));var limitRelatedPost=3;// alert(this.props.match.params.id);
if(this.props.match.params.id==="34"){limitRelatedPost=2;}var shuffleData=Object(__WEBPACK_IMPORTED_MODULE_4__Utility_Utility__["i" /* shuffle */])(mixVideos);var current=__WEBPACK_IMPORTED_MODULE_9__PostsData__["a" /* newPostdata */].find(function(o){if(_this2.props.match.params.ctgId!=undefined){if(o.hasOwnProperty("ctg")){// console.log('o' , o);
return o.id==_this2.props.match.params.id&&o.ctg==_this2.props.match.params.ctgId;}}else{return o.id===_this2.props.match.params.id;}});console.log("current",current);if(this.props.match.params.ctgId!=undefined){videosHtml=shuffleData.map(function(o,i){if(o.hasOwnProperty("ctg")){// if (  o.ctg === this.props.match.params.ctgId  && parseInt(o.id) !== parseInt(this.props.match.params.id) ) {
if(o.ctg===_this2.props.match.params.ctgId){var postFromPostData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["c" /* newPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromPostData',postFromPostData);if(postFromPostData!=undefined&&postFromPostData.id!==current.id){counter++;if(counter<=limitRelatedPost){var component=null;var url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.img,link:url});}else{url="/Posts/"+o.ctg+"/"+o.id;component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:postFromPostData.title,desc:postFromPostData.sml_desc,img:postFromPostData.img,link:url});}return component;}}}if(o.ctg===_this2.props.match.params.ctgId){var postFromTouristData=__WEBPACK_IMPORTED_MODULE_5__Data_Data__["a" /* TouristInfoPosts */].find(function(obj,index){return obj.id===o.id&&obj.ctg===o.ctg;});console.log('postFromTouristData',postFromTouristData);if(postFromTouristData!=undefined){counter++;if(counter<=limitRelatedPost){var _component=null;var _url="/Posts/Videos/"+o.ctg+"/"+o.id;if(o.isVid===true){_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["p" /* VideoSliderItem */],{key:i,title:postFromTouristData.title,desc:postFromTouristData.sml_desc,img:postFromTouristData.img,link:_url});}else{_url="/Posts/"+o.ctg+"/"+o.id;_component=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["m" /* PostSliderItem */],{key:i,title:postFromTouristData.title,desc:postFromTouristData.sml_desc,img:postFromTouristData.img,link:_url});}return _component;}}}}});}var html=null;var smlTitle=null;var title=null;if(current!=undefined){console.log('success');var vidHTML=null;if(current.isVid===true){vidHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:current.vidId});}var _title=current.title;var smltitle=current.hasOwnProperty("smltitle")?current.smltitle:current.smlTitle;var titleHTML=null;var smlTitleHTML=null;if(smltitle!==''){titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'},_title);smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["h" /* HomeTitle */],null,smltitle);}else{titleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h1',{className:'page-section-big-title'});smlTitleHTML=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["h" /* HomeTitle */],null,_title);}// client custom req
console.log('this.state',this.state);// if ( current.id === 5 ) {
//   titleHTML = '';
// }
html=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner-post post post-type-videos post-type-posts inner-post-'+current.id},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Components_Menu_Menu__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('section',{className:'post-data'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'main-post-banner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["i" /* Img */],{desktopImg:current.bgImage,mobileImg:current.mobBgImage}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container align-center white'},titleHTML)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container content-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-75'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},smlTitleHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),vidHTML,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'html-wrapper',dangerouslySetInnerHTML:current.html()}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["f" /* HomeDeals */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col col-25 sidebar'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'inner'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_UI_UI__["h" /* HomeTitle */],null,'ARTICLES SIMILAIRES'),videosHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'clear'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Components_Footer_Footer__["a" /* default */],null));}return html;}}]);return Posts;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Posts));

/***/ }),
/* 291 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lazyload__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lazyload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_lazyload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Utility_Utility__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_reactjs_popup__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Components_Menu_Menu__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Components_Footer_Footer__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Components_Loader_Loader__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery_css__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__Gallery_css__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GalleryTA=function(_Component){_inherits(GalleryTA,_Component);function GalleryTA(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryTA);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryTA.__proto__||Object.getPrototypeOf(GalleryTA)).call.apply(_ref,[this].concat(args))),_this),_this.state={telAvivWeather:0,instagramData:[],instagramDataMobile:[],instagramId:null,instagramUserImg:null,instagramCaption:null,instagramUserName:null,instagramLikes:null,waterTemp:0,jerusalemWeather:0,open:false,isInstaOpen:false,openInstagram:false,id:null,isLoader:false,ctg:"",videoId:"",cityName:"",stopLoopAt:"",galleryId:"",relatedGalery:[{title:"TEL AVIV",cityId:"ta"},{title:"MER MORTE",cityId:"deadsea"},{title:"JÉRUSALEM",cityId:"ja"},{title:"EILAT",cityId:"eilat"},{title:"NEGEV",cityId:"negev"},{title:"CAESAREA",cityId:"caesarea"},{title:"HAIFA",cityId:"haifa"},{title:"CULINAIRE",cityId:"culinary"},{title:"GALILEE",cityId:"galilee"},{title:"VOS PHOTOS D'I ISRAËL",cityId:"yp"}]},_this.OpenLoader=function(){_this.setState({isLoader:true});console.log("LOADERLOADERLOADER:",_this.state.isLoader);},_this.openModel2=function(id){_this.setState({isLoader:true});// var url ='https://view.activated.co.il/twocities/de/instagram-api.php?ID=' + id;
// var url = 'https://www.instagram.com/p/' + id;
// window.open(url);
setTimeout(function(){var url=Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"instagram-api.php?ID="+id;var url="https://en.citiesbreak.com/instagram-api.php?ID="+id;// var url = 'https://new.goisrael.com/eu/instagram-api.php?ID=' + id;
console.log("id:",id);// alert(url);
// var url = 'https://www.instagram.com/p/'+id+'/?tagged=takeme2telaviv&__a=1';
__WEBPACK_IMPORTED_MODULE_2_axios___default.a.get(url,{}).then(function(res){var obj=res.data;_this.setState({isLoader:false});if(obj==null){var url="https://www.instagram.com/p/"+id;window.open(url);}else{var userinfo=obj.graphql.shortcode_media;var likes=userinfo.edge_media_preview_like.count;var username=userinfo.owner.username;var caption=userinfo.edge_media_to_caption.edges[0].node.text;var userProfileImg=userinfo.owner.profile_pic_url;console.log(username);_this.setState({isInstaOpen:true,instagramId:id,instagramUserImg:userProfileImg,instagramCaption:caption,instagramUserName:username,instagramLikes:likes});}});},2000);},_this.openModal=function(id,ctg){_this.setState({open:true,ctg:ctg,id:id});},_this.closeModal=function(){_this.setState({open:false});},_this.closeModal2=function(){_this.setState({isInstaOpen:false});},_this.updateDimensions=function(){var w=window,d=document,documentElement=d.documentElement,body=d.getElementsByTagName("body")[0],width=w.innerWidth||documentElement.clientWidth||body.clientWidth;// height = w.innerHeight|| documentElement.clientHeight|| body.clientHeight;
_this.setState({width:width});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryTA,[{key:"componentWillMount",value:function componentWillMount(){this.updateDimensions();}},{key:"componentWillUnmount",value:function componentWillUnmount(){window.removeEventListener("scroll",this.handleScroll);window.removeEventListener("resize",this.updateDimensions);}},{key:"componentDidMount",value:function componentDidMount(){var _this2=this;var galleryId="noGalleryId";var videoId="";var cityName="";var stopLoopAt=32;console.log(this.props);if(this.props.match.params.galleryId!==undefined){galleryId=this.props.match.params.galleryId;if(galleryId==="ja"){this.state.videoId="V0Acsw3Hf_M";this.state.stopLoopAt=32;this.state.cityName="JÉRUSALEM";}else if(galleryId==="ta"){this.state.videoId="5nqL-oIC0GA";this.state.stopLoopAt=28;this.state.cityName="TEL AVIV";}else if(galleryId==="deadsea"){this.state.videoId="M627s8TdaB8";this.state.stopLoopAt=13;this.state.cityName="MER MORTE";}else if(galleryId==="eilat"){this.state.videoId="ZdnNT-GDJv4";this.state.stopLoopAt=17;this.state.cityName="EILAT";}else if(galleryId==="caesarea"){this.state.videoId="eLZ433_S6HI";this.state.stopLoopAt=4;this.state.cityName="CAESAREA";}else if(galleryId==="negev"){this.state.videoId="XxWa_MNm5x8";this.state.stopLoopAt=17;this.state.cityName="NEGEV";}else if(galleryId==="haifa"){this.state.videoId="3ahATaKkhBk";this.state.stopLoopAt=17;this.state.cityName="HAIFA";}else if(galleryId==="culinary"){this.state.videoId="JQD9JpMaw9g";this.state.stopLoopAt=13;this.state.cityName="CULINAIRE";}else if(galleryId==="galilee"){this.state.videoId="ImobrsxsKl8";this.state.stopLoopAt=17;this.state.cityName="GALILEE";}else if(galleryId==="markets"){this.state.videoId="2CSCe2WC7Ns";this.state.stopLoopAt=13;this.state.cityName="MARCHÉS";}else if(galleryId==="yp"){this.state.videoId="M627s8TdaB8";this.state.stopLoopAt=102;this.state.cityName="VOS PHOTOS D'I ISRAËL";}}Promise.all([Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["a" /* asyncgetWeather */])(),Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["c" /* geinstagramData */])()]).then(function(response){var weather=response[0];var instagramData=response[1];// console.log(typeof weather);
// console.log( weather);
var jerusalemTemperature='20';var deadSeaTemperature='20';var telAvivTemperature='20';var telAvivWaterTemp='20';if((typeof weather==="undefined"?"undefined":_typeof(weather))!=='object'){// console.log('The weather variable is a string.');
// Find the starting index of the JSON object
var jsonStartIndex=weather.indexOf('{"jerusalem"');if(jsonStartIndex!==-1){// Extract the JSON substring
var jsonString=weather.substring(jsonStartIndex);// Log the extracted JSON string to verify
// console.log('Extracted JSON String:', jsonString);
try{var weatherData=JSON.parse(jsonString);// console.log('Parsed Weather Data:', weatherData);
// Accessing the required temperature values
var _jerusalemTemperature=weatherData.jerusalem.temperature;var _deadSeaTemperature=weatherData.deadsea.temperature;var _telAvivTemperature=weatherData.telaviv.temperature;var _telAvivWaterTemp=weatherData.telaviv.water_temp;// console.log('Jerusalem Temperature:', jerusalemTemperature);
// console.log('Dead Sea Temperature:', deadSeaTemperature);
// console.log('Tel Aviv Temperature:', telAvivTemperature);
// console.log('Tel Aviv Water Temp:', telAvivWaterTemp);
// Set the state with the extracted values
_this2.setState({instagramData:instagramData.posts,jerusalemWeather:_jerusalemTemperature,deadSeaWeather:_deadSeaTemperature,telAvivWeather:_telAvivTemperature,waterTemp:_telAvivWaterTemp});}catch(error){console.error('Error parsing JSON:',error);}}else{console.error('No JSON found in the weather response');_this2.setState({instagramData:instagramData.posts,jerusalemWeather:jerusalemTemperature,deadSeaWeather:deadSeaTemperature,telAvivWeather:telAvivTemperature,waterTemp:telAvivWaterTemp});}}else{// console.log('The weather variable is an object.');
_this2.setState({instagramData:instagramData.posts,jerusalemWeather:weather.jerusalem.temperature,deadSeaWeather:weather.deadsea.temperature,telAvivWeather:weather.telaviv.temperature,waterTemp:weather.jerusalem.water_temp});}});}},{key:"render",value:function render(){var _this3=this;// let count  = 30;
var gallery=[];for(var i=1;i<=32;i++){gallery.push({id:i});}var sliderSettings={dots:false,autoplay:true,// lazyLoad: 'ondemand',
infinite:true,lazyLoad:"ondemand",cssEase:"linear",slidesToShow:3,slidesToScroll:3,responsive:[{breakpoint:1000,settings:{slidesToShow:2,slidesToScroll:2}},{breakpoint:600,settings:{slidesToShow:2,slidesToScroll:1}}]};var singleGalleryImg="";var singleGalleryImgMob="";var galleryHtml="";var galleryHtml2="";var galleryHtml3="";var galleryHtml4="";var galleryHtml5="";var galleryHtml6="";var galleryHtml7="";var galleryHtml8="";var galleryHtml9="";var galleryHtml10="";var stopLoopAt="";var finatlHtmlToRender="";var videoId="";var relatedGaleryHtml=null;{/*let cover = <HomeSlider waterTemp={this.state.waterTemp} telAvivWeather={this.state.telAvivWeather} jerusalemWeather={this.state.jerusalemWeather} />;*/}var cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["c" /* CoverSection */],{desktopImg:"/posts/bank/page-gallery/1.jpg",mobileImg:"/posts/bank/page-gallery/M.jpg",cssClass:"telaviv",waterTemp:this.state.waterTemp,telAvivWeather:this.state.telAvivWeather,jerusalemWeather:this.state.jerusalemWeather});var cityName="";var cssClass="";var instagramHtml=null;var bigImgPath="gallery/ta/big/"+this.state.id+".jpg";if(this.state.ctg==="ja"){bigImgPath="gallery/ja/big/"+this.state.id+".jpg";}else if(this.state.ctg==="deadsea"){bigImgPath="gallery/deadsea/big/"+this.state.id+".jpg";}else if(this.state.ctg==="eilat"){bigImgPath="gallery/eilat/big/"+this.state.id+".jpg";}else if(this.state.ctg==="caesarea"){bigImgPath="gallery/caesarea/big/"+this.state.id+".jpg";}else if(this.state.ctg==="negev"){bigImgPath="gallery/negev/big/"+this.state.id+".jpg";}else if(this.state.ctg==="haifa"){bigImgPath="gallery/haifa/big/"+this.state.id+".jpg";}else if(this.state.ctg==="culinary"){bigImgPath="gallery/culinary/big/"+this.state.id+".jpg";}else if(this.state.ctg==="galilee"){bigImgPath="gallery/galilee/big/"+this.state.id+".jpg";}else if(this.state.ctg==="markets"){bigImgPath="gallery/markets/big/"+this.state.id+".jpg";}if(this.props.match.params.galleryId===undefined){var instagramData=this.state.instagramData;var size=1;// if ( this.state.width < 600 ) {
//     size = 4;
// }
if(instagramData.length>0){while(instagramData.length>0){this.state.instagramDataMobile.push(instagramData.splice(0,size));}}if(this.state.instagramDataMobile.length>0){instagramHtml=this.state.instagramDataMobile.map(function(arr,i){return arr.map(function(o,i){var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{onClick:function onClick(){_this3.openModel2(o.id);}}," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["k" /* InstagremSliderItem */],{title:o.publishBy,cssClass:"InstagremSliderItem-"+i,img:"instagram/"+o.id+".jpg"}));});});// console.log('instagramHtml2' , instagramHtml2);
instagramHtml=instagramHtml.map(function(o,i){// console.log(o);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,o);});}var _currentInstagramLikeUrl="https://www.instagram.com/p/"+this.state.instagramId+"/";var _currentInstagramUrl="https://www.instagram.com/"+this.state.instagramUserName+"/";var _currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";// alert('currentInstagramImgUrl : ' +currentInstagramImgUrl);
// alert('currentInstagramUrl : ' +currentInstagramUrl);
// alert('currentInstagramLikeUrl : ' +currentInstagramLikeUrl);
galleryHtml=gallery.map(function(o,i){console.log(o);var cssClass="col";if(i%3===0){cssClass+=" first ";}if(i<=28){var imgPath="gallery/ta/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"ta");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml2=gallery.map(function(o,i){var cssClass="col";if(i<=32){var imgPath="gallery/ja/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"ja");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml3=gallery.map(function(o,i){var cssClass="col";if(i<=13){var imgPath="gallery/deadsea/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"deadsea");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml4=gallery.map(function(o,i){var cssClass="col";if(i<=17){var imgPath="gallery/eilat/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"eilat");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml5=gallery.map(function(o,i){var cssClass="col";if(i<=4){var imgPath="gallery/caesarea/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"caesarea");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml6=gallery.map(function(o,i){var cssClass="col";if(i<=17){var imgPath="gallery/negev/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"negev");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml7=gallery.map(function(o,i){var cssClass="col";if(i<=5){var imgPath="gallery/haifa/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"haifa");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml8=gallery.map(function(o,i){var cssClass="col";if(i<=13){var imgPath="gallery/culinary/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"culinary");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml9=gallery.map(function(o,i){var cssClass="col";if(i<=17){var imgPath="gallery/galilee/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"galilee");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});galleryHtml10=gallery.map(function(o,i){var cssClass="col";if(i<=13){var imgPath="gallery/markets/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,"markets");}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});finatlHtmlToRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"post-data"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container content-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner",id:"instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,"VOS PHOTOS D'I ISRA\xCBL"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},instagramHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/yp"},"Toutes les photos >>")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner",id:"tel-aviv-gallery"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/ta"},"TEL AVIV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/ta"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/ja"},"J\xC9RUSALEM")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml2),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/ja"},"Toutes les photos >>")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/deadsea"},"MER MORTE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml3)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/deadsea"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/eilat"},"EILAT")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml4)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/eilat"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/caesarea"},"CAESAREA")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml5)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/caesarea"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/negev"},"NEGEV")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml6)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/negev"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/haifa"},"HAIFA")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml7)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/haifa"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/culinary"},"CULINAIRE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml8)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/culinary"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/galilee"},"GALILEE")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml9)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/galilee"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_lazyload___default.a,{height:200,once:true,offset:50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/markets"},"MARCH\xC9S")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Components_SimpleSlider_SimpleSlider__["a" /* default */],{settings:sliderSettings},galleryHtml10)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"button show_more",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"/Pages/Gallery/markets"},"Toutes les photos >>")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.isInstaOpen,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"close",onClick:this.closeModal2},"\xD7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userImgInstagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:_currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-info-instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:_currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userProfileImgWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.instagramUserImg})),"@",this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"instagramCaption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["h" /* limitText */])(this.state.instagramCaption,130):""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:_currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"like-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:"like.png"}))))));__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"close",onClick:this.closeModal2},"\xD7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userImgInstagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:_currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-info-instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:_currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userProfileImgWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.instagramUserImg})),"@",this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"instagramCaption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["h" /* limitText */])(this.state.instagramCaption,130):""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:_currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"like-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:"like.png"})))));}else{// const galleryId = this.state.galleryId;
var galleryId=this.props.match.params.galleryId;var imgToShow="";if(galleryId==="ta"){imgToShow="1.jpg";}else if(galleryId==="ja"){imgToShow="4.jpg";}else if(galleryId==="deadsea"){imgToShow="6.jpg";}else if(galleryId==="eilat"){imgToShow="1.jpg";}if(galleryId==="ta"||galleryId==="deadsea"||galleryId==="ja"||galleryId==="eilat"||galleryId==="negev"||galleryId==="caesarea"||galleryId==="haifa"||galleryId==="galilee"||galleryId==="culinary"||galleryId==="markets"){cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:"gallery/"+"/ctg/Main/"+galleryId+".jpg",mobileImg:"gallery/"+"/ctg/Mobile/"+galleryId+".jpg"});bigImgPath="gallery/"+galleryId+"/big/"+this.state.id+".jpg";galleryHtml=gallery.map(function(o,i){var cssClass="col";if(_this3.state.stopLoopAt%3!=0&&i===_this3.state.stopLoopAt-1){// cssClass += ' last';
cssClass+=" ";}if(i<=_this3.state.stopLoopAt){var imgPath="gallery/"+galleryId+"/small/"+o.id+".jpg";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:cssClass,onClick:function onClick(){_this3.openModal(o.id,galleryId);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgPath}));}});}else if(galleryId==="yp"){// console.log("this.props.match.params.galleryId 10_10 :", this.props.match.params.galleryId);
cover=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:"gallery/ctg/Main/"+galleryId+".jpg",mobileImg:"gallery/"+"ctg/Mobile/"+galleryId+".jpg"});galleryHtml=this.state.instagramData.map(function(o,i){var obj_id=o.id;var obj_publishBy=o.publishBy;// console.log('OOOOO:', o);
// return arr.map((o , i) =>  {
var imgLink="instagram/"+o.id+".jpg";if(_this3.state.width<600){imgLink="instagram/Mobile/"+o.id+".jpg";}// console.log('imgLink' , imgLink);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-wrapper-img-instagram",onClick:function onClick(){console.log("obj_id:",obj_id);_this3.openModel2(obj_id);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:imgLink}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-wrapper-publish-by"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",{className:"ac-publish-by"},"@",obj_publishBy)));// });
});// console.log('instagramHtml2' , instagramHtml2);
galleryHtml=galleryHtml.map(function(o,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,o);});}relatedGaleryHtml=this.state.relatedGalery.map(function(o,i){var link="/Pages/Gallery/"+o.cityId;if(o.cityId!==galleryId){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["e" /* GallerSideBarItem */],{title:o.title,link:link,img:"gallery/"+"/ctg/"+o.cityId+".jpg"});}});finatlHtmlToRender=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("section",{className:"post-data"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container content-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-75"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container content-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,this.state.cityName),this.state.galleryId==="yp"?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["n" /* ResponsiveYouTubeIframe */],{vidId:this.state.videoId}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"gallery-html-wrapper"},galleryHtml),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col col-25 sidebar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"inner"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["h" /* HomeTitle */],null,"GALERIE"),relatedGaleryHtml,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"show_more button",href:Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["f" /* getUrl */])()+"Pages/Gallery"},"Toutes les photos >>"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"})));}var currentInstagramUrl="https://www.instagram.com/"+this.state.instagramUserName+"/";var currentInstagramImgUrl="instagram/"+this.state.instagramId+".jpg";var currentInstagramLikeUrl="https://www.instagram.com/p/"+this.state.instagramId+"/";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"page align-center page-Gallery inner-post gallery-"+this.state.galleryId},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Components_Menu_Menu__["a" /* default */],null),cover,finatlHtmlToRender,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.open,closeOnDocumentClick:true,onClose:this.closeModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"close",onClick:this.closeModal},"\xD7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:bigImgPath}))),this.state.isLoader===true?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ac-wrapper-loading"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Components_Loader_Loader__["a" /* default */],null)):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7_reactjs_popup__["a" /* default */],{open:this.state.isInstaOpen,closeOnDocumentClick:true,onClose:this.closeModal2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"modal"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"close",onClick:this.closeModal2},"\xD7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userImgInstagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:currentInstagramImgUrl})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"user-info-instagram"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:currentInstagramUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"userProfileImgWrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:this.state.instagramUserImg})),"@",this.state.instagramUserName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"instagramCaption"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,this.state.instagramCaption!=null?Object(__WEBPACK_IMPORTED_MODULE_5__Utility_Utility__["h" /* limitText */])(this.state.instagramCaption,130):""))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"clear"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{target:"_blank",href:currentInstagramLikeUrl},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"like-wrapper"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Components_UI_UI__["i" /* Img */],{desktopImg:"like.png"}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Components_Footer_Footer__["a" /* default */],null));}}]);return GalleryTA;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(GalleryTA));

/***/ }),
/* 293 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 294 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 295 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 296 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.2e563d29.js